var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/components/ActionCard.tsx
import React761 from "react";
import styled5 from "@emotion/styled";
import { isString } from "lodash";

// src/components/Box.tsx
import React4, { forwardRef as forwardRef2 } from "react";
import styled2 from "@emotion/styled";

// src/components/Base.tsx
import React3, { forwardRef } from "react";
import styled from "@emotion/styled";

// src/components/utils.ts
import "react";
import isPropValid from "@emotion/is-prop-valid";

// src/styles/StyleClosetThemeProvider.tsx
import * as React from "react";
import { ThemeProvider, useTheme as useEmotionTheme } from "emotion-theming";

// src/styles/theme.ts
import Color from "color";
var colors = {
  bmtNavy: "#000B50",
  bmtNavy60: "#4B5581",
  bmtBlue: "#1D6AE5",
  bmtBlue10: "#E3F8FF",
  bmtTeal: "#66C2CC",
  bmtTeal10: "#DAFCF5",
  bmtTeal90: "#377982",
  bmtOrange: "#FA7D29",
  bmtOrange10: "#FFF1F0",
  bmtOrange90: "#C74106",
  bmtGold: "#FFC729",
  bmtGold10: "#FCFCD0",
  bmtGold50: "#FEE27D",
  bmtPurple: "#703dea",
  bmtWhite: "#FFFFFF",
  bmtGrey10: "#F5F5F5",
  bmtGrey20: "#E6E6E6",
  bmtGrey30: "#C7C7C7",
  bmtGrey40: "#A3A3A3",
  bmtGrey50: "#6D6D6D",
  bmtGrey60: "#363636",
  bmtGrey90: "#212121",
  bmtVizGrey50: "#6D6D6D",
  bmtVizGrey60: "#363636",
  bmtVizGrey90: "#212121",
  bmtVizNavy: "#000B50",
  bmtVizNavy50: "#8085A7",
  bmtVizNavy60: "#40487C",
  bmtVizPurple: "#703DEA",
  bmtVizPurple50: "#946DEF",
  bmtVizBlue: "#1D6AE5",
  bmtVizBlue50: "#558FEB",
  bmtVizTeal20: "#BDEDEB",
  bmtVizTeal90: "#377982",
  bmtVizTeal: "#00A3B5",
  bmtVizOrange: "#F26D13",
  transparent: "transparent"
};
var secondaryColors = {
  grey60Accent: Color(colors.bmtGrey60).darken(0.2).hex(),
  whiteAccent: Color(colors.bmtWhite).darken(0.1).hex(),
  blueAccent: Color(colors.bmtBlue).darken(0.2).hex(),
  blue10: "#ade7ff",
  blue20: "#61bcff",
  blue30: "#1d6ae5",
  blue40: "#1f4ab4",
  blue50: "#1d2064",
  green10: "#b5ffcb",
  green20: "#5dffa3",
  green30: "#00cc9a",
  green40: "#219a8a",
  green50: "#183f51",
  purple10: "#dec7ff",
  purple20: "#a673ff",
  purple30: "#703dea",
  purple40: "#4e23b6",
  purple50: "#2d1b64",
  coral10: "#ffc6b3",
  coral20: "#ff8e75",
  coral30: "#ff6759",
  coral40: "#eb312a",
  coral50: "#7b1e30",
  gold10: "#ffedc2",
  gold20: "#ffda8b",
  gold30: "#f0b95b",
  gold40: "#e5a229",
  gold50: "#6a4a24"
};
var breakpoints = [
  "500px",
  // 0
  "700px",
  // 1
  "964px",
  // 2
  "1224px"
  // 3
];
var fontSizes = [
  "1.2rem",
  // 0
  "1.4rem",
  // 1
  "1.6rem",
  // 2
  "1.8rem",
  // 3
  "2.4rem",
  // 4
  "2.8rem",
  // 5
  "3.2rem",
  // 6
  "4.0rem",
  // 7
  "4.8rem",
  // 8
  "6.4rem"
  // 9
];
var lineHeights = [
  "1.6rem",
  // 0
  "2rem",
  // 1
  "2.4rem",
  // 2
  "3.2rem",
  // 3
  "3.6rem",
  // 4
  "4rem",
  // 5
  "4.8rem",
  // 6
  "5.6rem",
  // 7
  "6.4rem"
  // 8
];
var space = [
  // TODO Determine spaces and if we should use the same set for everything or separate by intent a la Tailwind CSS
  // TODO Add 1.0 rem?
  // Index Old
  "0",
  // 0     0
  ".4rem",
  // 1     xxs
  ".6rem",
  // 2     --- Remove?
  ".8rem",
  // 3     xs
  "1.2rem",
  // 4     12
  "1.4rem",
  // 5     --- Remove?
  "1.6rem",
  // 6     s
  "2.0rem",
  // 7     20
  "2.4rem",
  // 8     m
  "3.2rem",
  // 9     l
  "4.8rem",
  // 10     48
  "6.4rem",
  // 11    xl
  "9.6rem"
  // 12    xxl
];
var fonts = {
  sans: "GT America",
  rich: "GT America Compressed"
};
var fontWeights = {
  light: 300,
  regular: 500,
  medium: 600,
  bold: 700
};
var shadows = {
  default: `0 0 15px rgba(0, 0, 0, 0.25)`,
  s: `1px 2px 4px rgba(0, 0, 0, 0.09)`,
  xs: `0 1px rgba(0, 0, 0, 0.06)`
};
var zIndexes = {
  visualization: 25e8,
  modal: 200,
  overlay: 100,
  loader: 5,
  tooltip: 4,
  dropdown: 3,
  default: 1,
  below: -1
};
var theme = {
  breakpoints,
  fonts,
  fontSizes,
  fontWeights,
  shadows,
  lineHeights,
  space,
  colors,
  secondaryColors,
  zIndexes
};

// src/styles/StyleClosetThemeProvider.tsx
var SCThemeContext = React.createContext("default");
var StyleClosetThemeProvider = ({
  children,
  theme: theme2 = "default"
}) => {
  return /* @__PURE__ */ React.createElement(ThemeProvider, { theme }, /* @__PURE__ */ React.createElement(SCThemeContext.Provider, { value: theme2 }, children));
};
var useTheme = () => {
  const name = React.useContext(SCThemeContext);
  const theme2 = useEmotionTheme();
  if (theme2 && Object.keys(theme2).length) return { name, theme: theme2 };
  return { name, theme };
};

// src/components/utils.ts
function useIconProps({
  title,
  titleId,
  componentNameString: componentNameString752,
  ...props
}) {
  const { theme: theme2 } = useTheme();
  const allColors2 = {
    ...theme2.secondaryColors,
    ...theme2.colors
  };
  if (props.color) {
    props.fill = allColors2[props.color];
  }
  if (props.size) {
    const size2 = theme2.space[Number(props.size)] || props.size;
    props.width = size2;
    props.height = size2;
  } else if (componentNameString752 && ["24", "48", "72"].some((suffix) => componentNameString752.endsWith(suffix))) {
    props.width = `${componentNameString752.slice(-2)}px`;
    props.height = `${componentNameString752.slice(-2)}px`;
  } else {
    props.width = "1em";
    props.height = "1em";
  }
  if (title) {
    titleId = titleId || `${title}-icon-title`;
  }
  return [titleId, props];
}
var shouldForwardProp = (prop) => isPropValid(prop) && prop !== "color";

// src/components/Base.tsx
var Base = styled(({ as = "div", ...rest }) => React3.createElement(as, rest), {
  shouldForwardProp
})``;
var ReffableBase = forwardRef(
  ({ as = "div", ...rest }, ref) => React3.createElement(as, { ref, ...rest })
);

// src/components/constants.ts
import { themeGet } from "@styled-system/theme-get";
import * as styles from "styled-system";
import {
  compose,
  get as getKey,
  style
} from "styled-system";
var get = (key) => themeGet(key, getKey(theme, key));
var COMMON = compose(styles.color, styles.space);
var BORDER = compose(styles.borders, styles.borderColor, styles.boxShadow, styles.borderRadius);
var TYPOGRAPHY = compose(
  styles.fontFamily,
  styles.fontSize,
  styles.fontStyle,
  styles.fontWeight,
  styles.lineHeight,
  styles.textAlign,
  style({ prop: "textDecoration" }),
  style({ prop: "textTransform" })
);
var LAYOUT = compose(
  styles.display,
  styles.size,
  styles.width,
  styles.height,
  styles.minWidth,
  styles.minHeight,
  styles.maxWidth,
  styles.maxHeight,
  styles.overflow,
  styles.verticalAlign
);
var POSITION = compose(styles.position, styles.zIndex, styles.top, styles.right, styles.bottom, styles.left);
var FLEX_CONTAINER = compose(
  styles.flexBasis,
  styles.flexDirection,
  styles.flexWrap,
  styles.alignContent,
  styles.alignItems,
  styles.justifyContent,
  styles.justifyItems
);
var FLEX_ITEM = compose(styles.flex, styles.justifySelf, styles.alignSelf, styles.order);
var CONTENT_GRID_ITEM_PX = [".6rem", ".6rem", "1rem", 6];
var CONTENT_GRID_CONTAINER_MX = ["-.6rem", "-.6rem", "-1rem", `-${theme.space[6]}`];
var BORDER_COLOR = "bmtGrey20";
var BORDER_RADIUS = "3px";
var INPUT_MAX_WIDTH = "40rem";
var CONTENT_MIN_WIDTH = "320px";
var CONTENT_MAX_WIDTH = "1200px";
var VERTICAL_RHYTHM = [8, 8, 9];
var TOOLTIP_MAX_WIDTH = "28.2rem";

// src/components/Box.tsx
var StyledBox = styled2(Base)`
  ${POSITION}
  ${BORDER}
  ${LAYOUT}
  ${COMMON}
`;
var Box = ({
  children,
  ...rest
}) => {
  return /* @__PURE__ */ React4.createElement(StyledBox, { ...rest }, children);
};
var StyledReffableBox = styled2(ReffableBase, { shouldForwardProp })`
  ${POSITION}
  ${BORDER}
  ${LAYOUT}
  ${COMMON}
`;
var ReffableBox = forwardRef2(({ children, ...rest }, ref) => /* @__PURE__ */ React4.createElement(StyledReffableBox, { ...rest, ref }, children));

// src/components/Flex.tsx
import React5, { forwardRef as forwardRef3 } from "react";
import styled3 from "@emotion/styled";
import { display as display2 } from "styled-system";
var StyledBaseItem = styled3(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${BORDER}
  ${LAYOUT}
`;
var Item = ({
  children,
  ...rest
}) => {
  return /* @__PURE__ */ React5.createElement(StyledBaseItem, { ...rest }, children);
};
var StyledBaseFlex = styled3(Base)`
  ${FLEX_CONTAINER}
  ${COMMON}
  ${BORDER}
  ${LAYOUT}
  ${display2}
`;
var Flex = ({
  children,
  ...rest
}) => {
  return /* @__PURE__ */ React5.createElement(StyledBaseFlex, { ...rest }, children);
};
Flex.defaultProps = {
  display: "flex"
};
Flex.Item = Item;
var StyledReffableFlex = styled3(ReffableBase, { shouldForwardProp })`
  ${FLEX_CONTAINER}
  ${COMMON}
  ${BORDER}
  ${LAYOUT}
  ${display2}
`;
var ReffableFlex = forwardRef3(({ children, ...rest }, ref) => /* @__PURE__ */ React5.createElement(StyledReffableFlex, { ...rest, ref }, children));
ReffableFlex.defaultProps = {
  display: "flex"
};

// src/components/icons/FeatureAgingParentsSunset24.tsx
import * as React6 from "react";
var componentNameString = "FeatureAgingParentsSunset24";
function FeatureAgingParentsSunset24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString,
    ...props
  });
  return /* @__PURE__ */ React6.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React6.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React6.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.3 4.3L12 1L8.7 4.3H4.3V8.7L1 12L4.3 15.3V19.7H8.7L12 23L15.3 19.7H19.7V15.3L23 12L19.7 8.7V4.3H15.3ZM17.7 6.3H14.4716L12 3.82843L9.52843 6.3H6.3V9.52843L3.82843 12L6.3 14.4716V17.7H9.52842L12 20.1716L14.4716 17.7H17.7V14.4716L20.1716 12L17.7 9.52843V6.3Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React6.createElement("path", { d: "M17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12L17 12Z" }));
}

// src/components/icons/FeatureAgingParentsSunset48.tsx
import * as React7 from "react";
var componentNameString2 = "FeatureAgingParentsSunset48";
function FeatureAgingParentsSunset48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString2,
    ...props
  });
  return /* @__PURE__ */ React7.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React7.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React7.createElement("path", { d: "M33 24.5a9 9 0 10-18 0h18z" }), /* @__PURE__ */ React7.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M30.6 8.6L24 2l-6.6 6.6H8.6v8.8L2 24l6.6 6.6v8.8h8.8L24 46l6.6-6.6h8.8v-8.8L46 24l-6.6-6.6V8.6h-8.8zm5.3 3.5h-6.7L24 6.9l-5.2 5.2h-6.7v6.8L6.9 24l5.2 5.1V36h6.8l5.1 5.2 5.1-5.2H36v-6.7l5.2-5.2-5.2-5.2v-6.7z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureAgingParentsSunset72.tsx
import * as React8 from "react";
var componentNameString3 = "FeatureAgingParentsSunset72";
function FeatureAgingParentsSunset72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString3,
    ...props
  });
  return /* @__PURE__ */ React8.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React8.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React8.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M45.9 12.9L36 3l-9.9 9.9H12.9v13.2L3 36l9.9 9.9v13.2h13.2L36 69l9.9-9.9h13.2V45.9L69 36l-9.9-9.9V12.9H45.9zm8.2 5H43.8L36 10.1l-7.8 7.8H17.9v10.3L10.1 36l7.8 7.8v10.3h10.3l7.8 7.8 7.8-7.8h10.3V43.8l7.8-7.8-7.8-7.8V17.9z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React8.createElement("path", { d: "M51 36a15 15 0 10-30 0h30z" }));
}

// src/components/icons/FeatureArrowCircle24.tsx
import * as React9 from "react";
var componentNameString4 = "FeatureArrowCircle24";
function FeatureArrowCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString4,
    ...props
  });
  return /* @__PURE__ */ React9.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React9.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React9.createElement("path", { d: "M21.0001 16.5859L22.293 15.293L23.7072 16.7072L20.0001 20.4143L16.293 16.7072L17.7072 15.293L19.0001 16.5859V12C19.0001 8.13401 15.8661 5 12.0001 5V3C16.9706 3 21.0001 7.02944 21.0001 12V16.5859Z" }), /* @__PURE__ */ React9.createElement("path", { d: "M5.00006 12V7.41411L6.29297 8.70701L7.70718 7.2928L4.00008 3.58569L0.292969 7.2928L1.70718 8.70701L3.00006 7.41413V12C3.00006 16.9706 7.0295 21 12.0001 21V19C8.13407 19 5.00006 15.866 5.00006 12Z" }));
}

// src/components/icons/FeatureArrowCircle48.tsx
import * as React10 from "react";
var componentNameString5 = "FeatureArrowCircle48";
function FeatureArrowCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString5,
    ...props
  });
  return /* @__PURE__ */ React10.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React10.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React10.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.8 10v14c0 7.9 6.3 14.3 14.2 14.3v3.5c-9.8 0-17.8-8-17.8-17.8V10h3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React10.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.3 38V24c0-7.9-6.4-14.3-14.3-14.3V6.3c9.8 0 17.8 7.9 17.8 17.7v14h-3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React10.createElement("path", { fillRule: "evenodd", d: "M8 7.5l7.2 7.3-2.4 2.4L8 12.5l-4.8 4.7-2.4-2.4L8 7.5z", clipRule: "evenodd" }), /* @__PURE__ */ React10.createElement("path", { fillRule: "evenodd", d: "M40 40.5l-7.2-7.3 2.4-2.4 4.8 4.7 4.8-4.7 2.4 2.4-7.2 7.3z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowCircle72.tsx
import * as React11 from "react";
var componentNameString6 = "FeatureArrowCircle72";
function FeatureArrowCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString6,
    ...props
  });
  return /* @__PURE__ */ React11.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React11.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React11.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.5 15v21c0 11.9 9.6 21.5 21.5 21.5v5A26.5 26.5 0 019.5 36V15h5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React11.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57.5 57V36c0-11.9-9.6-21.5-21.5-21.5v-5A26.5 26.5 0 0162.5 36v21h-5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React11.createElement("path", { fillRule: "evenodd", d: "M12 11.5l10.8 10.7-3.6 3.6-7.2-7.3-7.2 7.3-3.6-3.6L12 11.5z", clipRule: "evenodd" }), /* @__PURE__ */ React11.createElement("path", { fillRule: "evenodd", d: "M60 60.5L49.2 49.8l3.6-3.6 7.2 7.3 7.2-7.3 3.6 3.6L60 60.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowCircleCheckmark24.tsx
import * as React12 from "react";
var componentNameString7 = "FeatureArrowCircleCheckmark24";
function FeatureArrowCircleCheckmark24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString7,
    ...props
  });
  return /* @__PURE__ */ React12.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React12.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React12.createElement("path", { d: "M22.293 15.293L21.0001 16.5859V12C21.0001 7.02944 16.9706 3 12.0001 3V5C15.8661 5 19.0001 8.13401 19.0001 12V16.5859L17.7072 15.293L16.293 16.7072L20.0001 20.4143L23.7072 16.7072L22.293 15.293Z" }), /* @__PURE__ */ React12.createElement("path", { d: "M5.00006 7.41411V12C5.00006 15.866 8.13407 19 12.0001 19V21C7.0295 21 3.00006 16.9706 3.00006 12V7.41414L1.70718 8.70701L0.292969 7.2928L4.00008 3.58569L7.70718 7.2928L6.29297 8.70701L5.00006 7.41411Z" }), /* @__PURE__ */ React12.createElement("path", { d: "M10.0001 16.4143L16.7072 9.70718L15.293 8.29297L10.0001 13.5859L8.20718 11.793L6.79297 13.2072L10.0001 16.4143Z" }));
}

// src/components/icons/FeatureArrowCircleCheckmark48.tsx
import * as React13 from "react";
var componentNameString8 = "FeatureArrowCircleCheckmark48";
function FeatureArrowCircleCheckmark48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString8,
    ...props
  });
  return /* @__PURE__ */ React13.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React13.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React13.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.8 10v14c0 7.9 6.3 14.3 14.2 14.3v3.5c-9.8 0-17.8-8-17.8-17.8V10h3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React13.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.3 38V24c0-7.9-6.4-14.3-14.3-14.3V6.3c9.8 0 17.8 7.9 17.8 17.7v14h-3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React13.createElement("path", { fillRule: "evenodd", d: "M8 7.5l7.2 7.3-2.4 2.4L8 12.5l-4.8 4.7-2.4-2.4L8 7.5z", clipRule: "evenodd" }), /* @__PURE__ */ React13.createElement("path", { fillRule: "evenodd", d: "M40 40.5l-7.2-7.3 2.4-2.4 4.8 4.7 4.8-4.7 2.4 2.4-7.2 7.3z", clipRule: "evenodd" }), /* @__PURE__ */ React13.createElement("path", { fillRule: "evenodd", d: "M33.2 19.2L20 32.5l-6.2-6.3 2.4-2.4 3.8 3.7 10.8-10.7 2.4 2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowCircleCheckmark72.tsx
import * as React14 from "react";
var componentNameString9 = "FeatureArrowCircleCheckmark72";
function FeatureArrowCircleCheckmark72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString9,
    ...props
  });
  return /* @__PURE__ */ React14.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React14.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React14.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.5 15v21c0 11.9 9.6 21.5 21.5 21.5v5A26.5 26.5 0 019.5 36V15h5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React14.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57.5 57V36c0-11.9-9.6-21.5-21.5-21.5v-5A26.5 26.5 0 0162.5 36v21h-5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React14.createElement("path", { fillRule: "evenodd", d: "M12 11.5l10.8 10.7-3.6 3.6-7.2-7.3-7.2 7.3-3.6-3.6L12 11.5z", clipRule: "evenodd" }), /* @__PURE__ */ React14.createElement("path", { fillRule: "evenodd", d: "M60 60.5L49.2 49.8l3.6-3.6 7.2 7.3 7.2-7.3 3.6 3.6L60 60.5z", clipRule: "evenodd" }), /* @__PURE__ */ React14.createElement("path", { fillRule: "evenodd", d: "M49.8 28.8L30 48.5l-9.3-9.2 3.6-3.6 5.7 5.8 16.2-16.3 3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowCircleMinus24.tsx
import * as React15 from "react";
var componentNameString10 = "FeatureArrowCircleMinus24";
function FeatureArrowCircleMinus24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString10,
    ...props
  });
  return /* @__PURE__ */ React15.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React15.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React15.createElement("path", { d: "M22.293 15.293L21.0001 16.5859V12C21.0001 7.02944 16.9706 3 12.0001 3V5C15.8661 5 19.0001 8.13401 19.0001 12V16.5859L17.7072 15.293L16.293 16.7072L20.0001 20.4143L23.7072 16.7072L22.293 15.293Z" }), /* @__PURE__ */ React15.createElement("path", { d: "M5.00006 7.41411V12C5.00006 15.866 8.13407 19 12.0001 19V21C7.0295 21 3.00006 16.9706 3.00006 12V7.41414L1.70718 8.70701L0.292969 7.2928L4.00008 3.58569L7.70718 7.2928L6.29297 8.70701L5.00006 7.41411Z" }), /* @__PURE__ */ React15.createElement("path", { d: "M16.0001 11H8.00006V13H16.0001V11Z" }));
}

// src/components/icons/FeatureArrowCircleMinus48.tsx
import * as React16 from "react";
var componentNameString11 = "FeatureArrowCircleMinus48";
function FeatureArrowCircleMinus48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString11,
    ...props
  });
  return /* @__PURE__ */ React16.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React16.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React16.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.8 10v14c0 7.9 6.3 14.3 14.2 14.3v3.5c-9.8 0-17.8-8-17.8-17.8V10h3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React16.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.3 38V24c0-7.9-6.4-14.3-14.3-14.3V6.3c9.8 0 17.8 7.9 17.8 17.7v14h-3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React16.createElement("path", { fillRule: "evenodd", d: "M8 7.5l7.2 7.3-2.4 2.4L8 12.5l-4.8 4.7-2.4-2.4L8 7.5z", clipRule: "evenodd" }), /* @__PURE__ */ React16.createElement("path", { fillRule: "evenodd", d: "M40 40.5l-7.2-7.3 2.4-2.4 4.8 4.7 4.8-4.7 2.4 2.4-7.2 7.3z", clipRule: "evenodd" }), /* @__PURE__ */ React16.createElement("path", { fillRule: "evenodd", d: "M16 22.3h16v3.4H16v-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowCircleMinus72.tsx
import * as React17 from "react";
var componentNameString12 = "FeatureArrowCircleMinus72";
function FeatureArrowCircleMinus72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString12,
    ...props
  });
  return /* @__PURE__ */ React17.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React17.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React17.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.5 15v21c0 11.9 9.6 21.5 21.5 21.5v5A26.5 26.5 0 019.5 36V15h5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React17.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57.5 57V36c0-11.9-9.6-21.5-21.5-21.5v-5A26.5 26.5 0 0162.5 36v21h-5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React17.createElement("path", { fillRule: "evenodd", d: "M12 11.5l10.8 10.7-3.6 3.6-7.2-7.3-7.2 7.3-3.6-3.6L12 11.5z", clipRule: "evenodd" }), /* @__PURE__ */ React17.createElement("path", { fillRule: "evenodd", d: "M60 60.5L49.2 49.8l3.6-3.6 7.2 7.3 7.2-7.3 3.6 3.6L60 60.5z", clipRule: "evenodd" }), /* @__PURE__ */ React17.createElement("path", { fillRule: "evenodd", d: "M24 33.5h24v5H24v-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowCirclePlus24.tsx
import * as React18 from "react";
var componentNameString13 = "FeatureArrowCirclePlus24";
function FeatureArrowCirclePlus24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString13,
    ...props
  });
  return /* @__PURE__ */ React18.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React18.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React18.createElement("path", { d: "M21.0001 16.5858L22.293 15.2929L23.7072 16.7071L20.0001 20.4142L16.293 16.7071L17.7072 15.2929L19.0001 16.5858V12C19.0001 8.13401 15.8661 5 12.0001 5L12.0001 3C16.9706 3 21.0001 7.02944 21.0001 12V16.5858Z" }), /* @__PURE__ */ React18.createElement("path", { d: "M5.00008 12V7.41421L6.29297 8.70711L7.70718 7.29289L4.00008 3.58579L0.292969 7.29289L1.70718 8.70711L3.00008 7.41421V12C3.00008 16.9706 7.02951 21 12.0001 21V19C8.13408 19 5.00008 15.866 5.00008 12Z" }), /* @__PURE__ */ React18.createElement("path", { d: "M11.0001 11V8H13.0001V11H16.0001V13H13.0001V16H11.0001V13H8.00008V11H11.0001Z" }));
}

// src/components/icons/FeatureArrowCirclePlus48.tsx
import * as React19 from "react";
var componentNameString14 = "FeatureArrowCirclePlus48";
function FeatureArrowCirclePlus48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString14,
    ...props
  });
  return /* @__PURE__ */ React19.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React19.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React19.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.8 10v14c0 7.9 6.3 14.3 14.2 14.3v3.5c-9.8 0-17.8-8-17.8-17.8V10h3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React19.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.3 38V24c0-7.9-6.4-14.3-14.3-14.3V6.3c9.8 0 17.8 7.9 17.8 17.7v14h-3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React19.createElement("path", { fillRule: "evenodd", d: "M8 7.5l7.2 7.3-2.4 2.4L8 12.5l-4.8 4.7-2.4-2.4L8 7.5z", clipRule: "evenodd" }), /* @__PURE__ */ React19.createElement("path", { fillRule: "evenodd", d: "M40 40.5l-7.2-7.3 2.4-2.4 4.8 4.7 4.8-4.7 2.4 2.4-7.2 7.3z", clipRule: "evenodd" }), /* @__PURE__ */ React19.createElement("path", { fillRule: "evenodd", d: "M22.3 32V16h3.4v16h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React19.createElement("path", { fillRule: "evenodd", d: "M16 22.3h16v3.4H16v-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowCirclePlus72.tsx
import * as React20 from "react";
var componentNameString15 = "FeatureArrowCirclePlus72";
function FeatureArrowCirclePlus72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString15,
    ...props
  });
  return /* @__PURE__ */ React20.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React20.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React20.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.5 15v21c0 11.9 9.6 21.5 21.5 21.5v5A26.5 26.5 0 019.5 36V15h5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React20.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57.5 57V36c0-11.9-9.6-21.5-21.5-21.5v-5A26.5 26.5 0 0162.5 36v21h-5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React20.createElement("path", { fillRule: "evenodd", d: "M12 11.5l10.8 10.7-3.6 3.6-7.2-7.3-7.2 7.3-3.6-3.6L12 11.5z", clipRule: "evenodd" }), /* @__PURE__ */ React20.createElement("path", { fillRule: "evenodd", d: "M60 60.5L49.2 49.8l3.6-3.6 7.2 7.3 7.2-7.3 3.6 3.6L60 60.5z", clipRule: "evenodd" }), /* @__PURE__ */ React20.createElement("path", { fillRule: "evenodd", d: "M33.5 48V24h5v24h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React20.createElement("path", { fillRule: "evenodd", d: "M24 33.5h24v5H24v-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureArrowDown.tsx
import * as React21 from "react";
var componentNameString16 = "FeatureArrowDown";
function FeatureArrowDown({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString16,
    ...props
  });
  return /* @__PURE__ */ React21.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React21.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React21.createElement(
    "polygon",
    {
      points: "37.029 12 28.343 20.686 28.343 0 20.343 0 20.343 20.686 11.656 12 6 17.657 24.343 36 42.686 17.657",
      className: "sc-Icon--secondary-color"
    }
  ), /* @__PURE__ */ React21.createElement("polygon", { points: "8.343 48 40.343 48 40.343 40 8.343 40", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureAtmCard24.tsx
import * as React22 from "react";
var componentNameString17 = "FeatureAtmCard24";
function FeatureAtmCard24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString17,
    ...props
  });
  return /* @__PURE__ */ React22.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React22.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React22.createElement("path", { fillRule: "evenodd", d: "M2 2H22V10H19.3333V8H20V4H4V8H4.66667V10H2V2Z", clipRule: "evenodd" }), /* @__PURE__ */ React22.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.8332 7.3335L5.1665 7.3335L5.1665 5.3335L18.8332 5.3335L18.8332 7.3335Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React22.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 15.6665C18 17.3234 16.6569 18.6665 15 18.6665L9 18.6665C7.34315 18.6665 6 17.3234 6 15.6665L6 6.99984L8 6.99984L8 15.6665C8 16.2188 8.44772 16.6665 9 16.6665L15 16.6665C15.5523 16.6665 16 16.2188 16 15.6665L16 6.99984L18 6.99984L18 15.6665Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React22.createElement("path", { d: "M14.6665 17L12.6665 17L12.6665 7L14.6665 7L14.6665 17Z" }), /* @__PURE__ */ React22.createElement("path", { d: "M11 15.3335L9.33333 15.3335L9.33333 13.3335L11 13.3335L11 15.3335Z" }));
}

// src/components/icons/FeatureAtmCard48.tsx
import * as React23 from "react";
var componentNameString18 = "FeatureAtmCard48";
function FeatureAtmCard48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString18,
    ...props
  });
  return /* @__PURE__ */ React23.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React23.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React23.createElement("path", { fillRule: "evenodd", d: "M4.3 4.3h39.5v15.4h-5.1v-3.4h1.5V7.7H7.8v8.6h1.6v3.4h-5V4.3z", clipRule: "evenodd" }), /* @__PURE__ */ React23.createElement("path", { fillRule: "evenodd", d: "M37.7 14.4H10.3V11h27.4v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React23.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M35.8 32.3c0 2.7-2.2 4.8-4.8 4.8H17a4.8 4.8 0 01-4.8-4.8V14h3.6v18.3c0 .7.5 1.3 1.2 1.3h14c.7 0 1.3-.6 1.3-1.3V14h3.5v18.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React23.createElement("path", { d: "M29.3 34h-4V14h4v20z" }), /* @__PURE__ */ React23.createElement("path", { d: "M22 30.7h-3.3v-4H22v4z" }));
}

// src/components/icons/FeatureAtmCard72.tsx
import * as React24 from "react";
var componentNameString19 = "FeatureAtmCard72";
function FeatureAtmCard72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString19,
    ...props
  });
  return /* @__PURE__ */ React24.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React24.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React24.createElement("path", { fillRule: "evenodd", d: "M6.5 6.5h59v23H58v-5h2.5v-13h-49v13H14v5H6.5v-23z", clipRule: "evenodd" }), /* @__PURE__ */ React24.createElement("path", { fillRule: "evenodd", d: "M56.5 21.5h-41v-5h41v5z", clipRule: "evenodd" }), /* @__PURE__ */ React24.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M53.5 48c0 4.1-3.4 7.5-7.5 7.5H26a7.5 7.5 0 01-7.5-7.5V21h5v27c0 1.4 1.1 2.5 2.5 2.5h20c1.4 0 2.5-1.1 2.5-2.5V21h5v27z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React24.createElement("path", { d: "M44 51h-6V21h6v30z" }), /* @__PURE__ */ React24.createElement("path", { d: "M33 46h-5v-6h5v6z" }));
}

// src/components/icons/FeatureAtmCash24.tsx
import * as React25 from "react";
var componentNameString20 = "FeatureAtmCash24";
function FeatureAtmCash24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString20,
    ...props
  });
  return /* @__PURE__ */ React25.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React25.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React25.createElement("path", { fillRule: "evenodd", d: "M2 2H22V10H19.3333V8H20V4H4V8H4.66667V10H2V2Z", clipRule: "evenodd" }), /* @__PURE__ */ React25.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.8334 7.3335L5.16675 7.3335L5.16675 5.3335L18.8334 5.3335L18.8334 7.3335Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React25.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 19.3335L8 6.3335L6 6.3335L6 21.3335L18 21.3335L18 6.3335L16 6.3335L16 19.3335L8 19.3335Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React25.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11 11.3335C11 10.7812 11.4477 10.3335 12 10.3335C12.5523 10.3335 13 10.7812 13 11.3335C13 11.8858 12.5523 12.3335 12 12.3335C11.4477 12.3335 11 11.8858 11 11.3335ZM12 8.3335C10.3431 8.3335 9 9.67664 9 11.3335C9 12.9904 10.3431 14.3335 12 14.3335C13.6569 14.3335 15 12.9903 15 11.3335C15 9.67664 13.6569 8.3335 12 8.3335Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureAtmCash48.tsx
import * as React26 from "react";
var componentNameString21 = "FeatureAtmCash48";
function FeatureAtmCash48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString21,
    ...props
  });
  return /* @__PURE__ */ React26.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React26.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React26.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.25 4.25H43.75V19.75H38.6667V16.25H40.25V7.75H7.75V16.25H9.33333V19.75H4.25V4.25Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React26.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M37.6666 14.4166L10.3333 14.4166L10.3333 10.9166L37.6666 10.9166L37.6666 14.4166Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React26.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.75 38.9166L15.75 12.6666L12.25 12.6666L12.25 42.4166L35.75 42.4166L35.75 12.6666L32.25 12.6666L32.25 38.9166L15.75 38.9166Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React26.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21.75 22.6666C21.75 21.424 22.7574 20.4166 24 20.4166C25.2426 20.4166 26.25 21.424 26.25 22.6666C26.25 23.9093 25.2426 24.9166 24 24.9166C22.7574 24.9166 21.75 23.9093 21.75 22.6666ZM24 16.9166C20.8244 16.9166 18.25 19.491 18.25 22.6666C18.25 25.8423 20.8244 28.4166 24 28.4166C27.1756 28.4166 29.75 25.8423 29.75 22.6666C29.75 19.491 27.1756 16.9166 24 16.9166Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureAtmCash72.tsx
import * as React27 from "react";
var componentNameString22 = "FeatureAtmCash72";
function FeatureAtmCash72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString22,
    ...props
  });
  return /* @__PURE__ */ React27.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React27.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React27.createElement("path", { fillRule: "evenodd", d: "M6.5 6.5h59v23H58v-5h2.5v-13h-49v13H14v5H6.5v-23z", clipRule: "evenodd" }), /* @__PURE__ */ React27.createElement("path", { fillRule: "evenodd", d: "M56.5 21.5h-41v-5h41v5z", clipRule: "evenodd" }), /* @__PURE__ */ React27.createElement("path", { fillRule: "evenodd", d: "M23.5 58.5V19h-5v44.5h35V19h-5v39.5h-25z", clipRule: "evenodd" }), /* @__PURE__ */ React27.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32.5 34a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm3.5-8.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureAward.tsx
import * as React28 from "react";
var componentNameString23 = "FeatureAward";
function FeatureAward({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString23,
    ...props
  });
  return /* @__PURE__ */ React28.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React28.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React28.createElement("path", { d: "M38.9 26.6l8.9 13.1-7.8-.1-2.5 7.3-9-13.1A19 19 0 0039 26.6zm-30.1 0a19 19 0 0010.3 7.2l-8.9 13.1-2.5-7.3-7.8.1 8.9-13.1z" }), /* @__PURE__ */ React28.createElement("circle", { cx: 24, cy: 16, r: 15, className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureBag.tsx
import * as React29 from "react";
var componentNameString24 = "FeatureBag";
function FeatureBag({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString24,
    ...props
  });
  return /* @__PURE__ */ React29.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React29.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React29.createElement("path", { d: "M30.3 13.1L24 24l-6.3-10.9a18 18 0 1012.6 0" }), /* @__PURE__ */ React29.createElement("path", { d: "M30.3 13.1L37.9 0H10l7.6 13.1a18 18 0 0112.6 0" }));
}

// src/components/icons/FeatureBalance24.tsx
import * as React30 from "react";
var componentNameString25 = "FeatureBalance24";
function FeatureBalance24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString25,
    ...props
  });
  return /* @__PURE__ */ React30.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React30.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React30.createElement("path", { fillRule: "evenodd", d: "M22 15H2V13H22V15Z", clipRule: "evenodd" }), /* @__PURE__ */ React30.createElement("circle", { cx: 12, cy: 7, r: 3 }), /* @__PURE__ */ React30.createElement("path", { d: "M13.5858 20H10.4142L12 18.4142L13.5858 20Z" }));
}

// src/components/icons/FeatureBalance48.tsx
import * as React31 from "react";
var componentNameString26 = "FeatureBalance48";
function FeatureBalance48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString26,
    ...props
  });
  return /* @__PURE__ */ React31.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React31.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React31.createElement("path", { fillRule: "evenodd", d: "M44 29.8H4v-3.6h40v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React31.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 18.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React31.createElement("path", { fillRule: "evenodd", d: "M16 42h16l-8-8-8 8z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBalance72.tsx
import * as React32 from "react";
var componentNameString27 = "FeatureBalance72";
function FeatureBalance72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString27,
    ...props
  });
  return /* @__PURE__ */ React32.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React32.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React32.createElement("path", { fillRule: "evenodd", d: "M66 44.5H6v-5h60v5z", clipRule: "evenodd" }), /* @__PURE__ */ React32.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 28a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React32.createElement("path", { fillRule: "evenodd", d: "M24 63h24L36 51 24 63z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBank24.tsx
import * as React33 from "react";
var componentNameString28 = "FeatureBank24";
function FeatureBank24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString28,
    ...props
  });
  return /* @__PURE__ */ React33.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React33.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React33.createElement("path", { fillRule: "evenodd", d: "M17.3944 8L12 4.4037L6.60555 8H17.3944ZM3 8L12 2L21 8V10H3V8Z", clipRule: "evenodd" }), /* @__PURE__ */ React33.createElement("path", { fillRule: "evenodd", d: "M21 21L3 21L3 19L21 19V21Z", clipRule: "evenodd" }), /* @__PURE__ */ React33.createElement("path", { fillRule: "evenodd", d: "M13 17V12H15V17H13Z", clipRule: "evenodd" }), /* @__PURE__ */ React33.createElement("path", { fillRule: "evenodd", d: "M17 17V12H19V17H17Z", clipRule: "evenodd" }), /* @__PURE__ */ React33.createElement("path", { fillRule: "evenodd", d: "M9 17V12H11V17H9Z", clipRule: "evenodd" }), /* @__PURE__ */ React33.createElement("path", { fillRule: "evenodd", d: "M5 17V12H7V17H5Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBank48.tsx
import * as React34 from "react";
var componentNameString29 = "FeatureBank48";
function FeatureBank48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString29,
    ...props
  });
  return /* @__PURE__ */ React34.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React34.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React34.createElement("path", { fillRule: "evenodd", d: "M42 20H6v-4L24 4l18 12v4zM24 8.2l-12.4 8.3h24.8L24 8.2z", clipRule: "evenodd" }), /* @__PURE__ */ React34.createElement("path", { fillRule: "evenodd", d: "M42 41.8H6v-3.5h36v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React34.createElement("path", { fillRule: "evenodd", d: "M26.3 34V24h3.4v10h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React34.createElement("path", { fillRule: "evenodd", d: "M34.3 34V24h3.5v10h-3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React34.createElement("path", { fillRule: "evenodd", d: "M18.3 34V24h3.4v10h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React34.createElement("path", { fillRule: "evenodd", d: "M10.3 34V24h3.4v10h-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBank72.tsx
import * as React35 from "react";
var componentNameString30 = "FeatureBank72";
function FeatureBank72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString30,
    ...props
  });
  return /* @__PURE__ */ React35.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React35.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React35.createElement("path", { fillRule: "evenodd", d: "M63 30H9v-6L36 6l27 18v6zM36 12L16.5 25h39L36 12z", clipRule: "evenodd" }), /* @__PURE__ */ React35.createElement("path", { fillRule: "evenodd", d: "M63 62.5H9v-5h54v5z", clipRule: "evenodd" }), /* @__PURE__ */ React35.createElement("path", { fillRule: "evenodd", d: "M39.5 51V36h5v15h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React35.createElement("path", { fillRule: "evenodd", d: "M51.5 51V36h5v15h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React35.createElement("path", { fillRule: "evenodd", d: "M27.5 51V36h5v15h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React35.createElement("path", { fillRule: "evenodd", d: "M15.5 51V36h5v15h-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBank.tsx
import * as React36 from "react";
var componentNameString31 = "FeatureBank";
function FeatureBank({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString31,
    ...props
  });
  return /* @__PURE__ */ React36.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React36.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React36.createElement("path", { d: "M16 48V16h6v32h-6zM6 48V16h6v32H6zm20 0V16h6v32h-6zm10 0V16h6v32h-6z" }), /* @__PURE__ */ React36.createElement("polygon", { points: "24 0 0 8 0 12 47.999 12 47.999 8", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureBar24.tsx
import * as React37 from "react";
var componentNameString32 = "FeatureBar24";
function FeatureBar24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString32,
    ...props
  });
  return /* @__PURE__ */ React37.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React37.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React37.createElement("path", { fillRule: "evenodd", d: "M10 20V4H14V20H10Z", clipRule: "evenodd" }), /* @__PURE__ */ React37.createElement("path", { fillRule: "evenodd", d: "M4 20V12H8V20H4Z", clipRule: "evenodd" }), /* @__PURE__ */ React37.createElement("path", { fillRule: "evenodd", d: "M16 20V8H20V20H16Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBar48.tsx
import * as React38 from "react";
var componentNameString33 = "FeatureBar48";
function FeatureBar48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString33,
    ...props
  });
  return /* @__PURE__ */ React38.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React38.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React38.createElement("path", { fillRule: "evenodd", d: "M22.5 36.5h3v-25h-3v25zM19 40V8h10v32H19z", clipRule: "evenodd" }), /* @__PURE__ */ React38.createElement("path", { fillRule: "evenodd", d: "M9.5 36.5h3v-9h-3v9zM6 40V24h10v16H6z", clipRule: "evenodd" }), /* @__PURE__ */ React38.createElement("path", { fillRule: "evenodd", d: "M35.5 36.5h3v-17h-3v17zM32 40V16h10v24H32z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBar72.tsx
import * as React39 from "react";
var componentNameString34 = "FeatureBar72";
function FeatureBar72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString34,
    ...props
  });
  return /* @__PURE__ */ React39.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React39.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React39.createElement("path", { fillRule: "evenodd", d: "M34 55h5V17h-5v38zm-5 5V12h15v48H29z", clipRule: "evenodd" }), /* @__PURE__ */ React39.createElement("path", { fillRule: "evenodd", d: "M14 55h5V41h-5v14zm-5 5V36h15v24H9z", clipRule: "evenodd" }), /* @__PURE__ */ React39.createElement("path", { fillRule: "evenodd", d: "M54 55h5V29h-5v26zm-5 5V24h15v36H49z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBeachUmbrella24.tsx
import * as React40 from "react";
var componentNameString35 = "FeatureBeachUmbrella24";
function FeatureBeachUmbrella24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString35,
    ...props
  });
  return /* @__PURE__ */ React40.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React40.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React40.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6.34319 6.34315C3.70732 8.97901 3.29532 12.9966 5.10719 16.0644L16.0645 5.10715C12.9967 3.29528 8.97906 3.70728 6.34319 6.34315ZM17.5155 3.65617C13.6327 1.08375 8.3499 1.50801 4.92898 4.92893C1.50805 8.34986 1.0838 13.6327 3.65621 17.5154C4.0204 18.0651 4.44466 18.5867 4.92898 19.0711L19.0711 4.92893C18.5868 4.44461 18.0652 4.02036 17.5155 3.65617Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React40.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.707 21.1211L12.707 14.1211L14.1212 12.7069L21.1212 19.7069L19.707 21.1211Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBeachUmbrella48.tsx
import * as React41 from "react";
var componentNameString36 = "FeatureBeachUmbrella48";
function FeatureBeachUmbrella48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString36,
    ...props
  });
  return /* @__PURE__ */ React41.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React41.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React41.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.3 12.3A16.5 16.5 0 0010.1 33L33 10.1C26.5 6 18 6.7 12.3 12.3zm23.2-4.7A20 20 0 009.9 38.1L38 10c-.8-.9-1.7-1.6-2.6-2.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React41.createElement("path", { fillRule: "evenodd", d: "M39.6 42l-14-14 2.5-2.4 14 14-2.5 2.5z", clipRule: "evenodd" }), /* @__PURE__ */ React41.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10.1 33C7 28 6.7 21.7 9.2 16.6a21 21 0 005.9 11.2l-5 5zm15.4-15.4l-8 7.9a16 16 0 01-5-13 16 16 0 0113 5zm2.4-2.5l5-5a16.7 16.7 0 00-16.2-.9 21 21 0 0111.2 6zm7.6-7.5A20 20 0 009.9 38.1L38 10c-.8-.9-1.7-1.6-2.6-2.3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBeachUmbrella72.tsx
import * as React42 from "react";
var componentNameString37 = "FeatureBeachUmbrella72";
function FeatureBeachUmbrella72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString37,
    ...props
  });
  return /* @__PURE__ */ React42.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React42.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React42.createElement("path", { fillRule: "evenodd", d: "M59.5 63l-21-21 3.5-3.5 21 21-3.5 3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React42.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.1 49.8a25 25 0 01-1.3-25.4C14.5 29.6 17 36 23 42l-7.8 7.8zm23.4-23.3l-12 12a24.3 24.3 0 01-7.8-19.8c4.4-.5 12.1.3 19.8 7.8zm3.5-3.6a30 30 0 00-17.6-9A25 25 0 0149.8 15L42 23zm11.4-11.4a30 30 0 00-38.6 45.7l3.5-3.5 35.4-35.4 3.5-3.5a30.2 30.2 0 00-3.8-3.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React42.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.3 18.3a25 25 0 00-3.2 31.5L49.8 15a25 25 0 00-31.5 3.2zm35-6.8a30 30 0 00-38.5 45.7l42.4-42.4a30.2 30.2 0 00-3.8-3.3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBills24.tsx
import * as React43 from "react";
var componentNameString38 = "FeatureBills24";
function FeatureBills24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString38,
    ...props
  });
  return /* @__PURE__ */ React43.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React43.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React43.createElement("path", { d: "M8 8H16V6H8V8Z" }), /* @__PURE__ */ React43.createElement("path", { d: "M16 12H8V10H16V12Z" }), /* @__PURE__ */ React43.createElement("path", { d: "M8 16H16V14H8V16Z" }), /* @__PURE__ */ React43.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 20L20 22V2H4V22L6 20L8 22L10 20L12 22L14 20L16 22L18 20ZM18 4V17.1716L16 19.1716L14 17.1716L12 19.1716L10 17.1716L8 19.1716L6 17.1716V4H18Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBills48.tsx
import * as React44 from "react";
var componentNameString39 = "FeatureBills48";
function FeatureBills48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString39,
    ...props
  });
  return /* @__PURE__ */ React44.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React44.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React44.createElement("path", { d: "M17 14.75H31V11.25H17V14.75Z" }), /* @__PURE__ */ React44.createElement("path", { d: "M31 22.75H17V19.25H31V22.75Z" }), /* @__PURE__ */ React44.createElement("path", { d: "M17 30.75H31V27.25H17V30.75Z" }), /* @__PURE__ */ React44.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34.5 40L38 44V4H10V44L13.5 40L17 44L20.5 40L24 44L27.5 40L31 44L34.5 40ZM34.5 7.5V34.6849L31 38.6849L27.5 34.6849L24 38.6849L20.5 34.6849L17 38.6849L13.5 34.6849V7.5H34.5Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBills72.tsx
import * as React45 from "react";
var componentNameString40 = "FeatureBills72";
function FeatureBills72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString40,
    ...props
  });
  return /* @__PURE__ */ React45.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React45.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React45.createElement("path", { d: "M26 21.5H46V16.5H26V21.5Z" }), /* @__PURE__ */ React45.createElement("path", { d: "M46 33.5H26V28.5H46V33.5Z" }), /* @__PURE__ */ React45.createElement("path", { d: "M26 45.5H46V40.5H26V45.5Z" }), /* @__PURE__ */ React45.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M51 60L56 66V6H16V66L21 60L26 66L31 60L36 66L41 60L46 66L51 60ZM51 11V52.1898L46 58.1898L41 52.1898L36 58.1898L31 52.1898L26 58.1898L21 52.1898V11H51Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBoat24.tsx
import * as React46 from "react";
var componentNameString41 = "FeatureBoat24";
function FeatureBoat24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString41,
    ...props
  });
  return /* @__PURE__ */ React46.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React46.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React46.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6 17V19H15C16.4806 19 17.7733 18.1956 18.4649 17H6ZM4 19C4 20.1046 4.89543 21 6 21H15C17.6124 21 19.8349 19.3304 20.6586 17C20.8797 16.3744 21 15.7013 21 15H4V19Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React46.createElement("path", { fillRule: "evenodd", d: "M13 2L4 13H13V2ZM11 7.60282L8.22049 11H11V7.60282Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBoat48.tsx
import * as React47 from "react";
var componentNameString42 = "FeatureBoat48";
function FeatureBoat48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString42,
    ...props
  });
  return /* @__PURE__ */ React47.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React47.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React47.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.5 38.5H34c2.5 0 4.5-2 4.5-4.5v-.5h-27v5zM8 40c0 1.1.9 2 2 2h24a8 8 0 008-8v-4H8v10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React47.createElement("path", { fillRule: "evenodd", d: "M26 4L8 26h18V4zm-3.5 9.8l-7.1 8.7h7.1v-8.7z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBoat72.tsx
import * as React48 from "react";
var componentNameString43 = "FeatureBoat72";
function FeatureBoat72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString43,
    ...props
  });
  return /* @__PURE__ */ React48.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React48.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React48.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17 58h38a3 3 0 003-3v-5H17v8zm-5 3c0 1.1.9 2 2 2h41a8 8 0 008-8V45H12v16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React48.createElement("path", { fillRule: "evenodd", d: "M39 6L12 39h27V6zm-5 14L22.6 34H34V20z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBook.tsx
import * as React49 from "react";
var componentNameString44 = "FeatureBook";
function FeatureBook({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString44,
    ...props
  });
  return /* @__PURE__ */ React49.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React49.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React49.createElement("path", { d: "M11 2h35.2v44H11V2zm5.8 14.8H40V9H16.8v8z" }), /* @__PURE__ */ React49.createElement("polygon", { points: "2 45.914 9 45.914 9 2.001 2 2.001", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureBriefcase24.tsx
import * as React50 from "react";
var componentNameString45 = "FeatureBriefcase24";
function FeatureBriefcase24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString45,
    ...props
  });
  return /* @__PURE__ */ React50.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React50.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React50.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 8H5L5 18H19V8ZM5 6C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React50.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 4C10.8954 4 10 4.89543 10 6V7H8V6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V7H14V6C14 4.89543 13.1046 4 12 4Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React50.createElement("path", { fillRule: "evenodd", d: "M20 14H4V12H20V14Z", clipRule: "evenodd" }), /* @__PURE__ */ React50.createElement("path", { d: "M13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10Z" }));
}

// src/components/icons/FeatureBriefcase48.tsx
import * as React51 from "react";
var componentNameString46 = "FeatureBriefcase48";
function FeatureBriefcase48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString46,
    ...props
  });
  return /* @__PURE__ */ React51.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React51.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React51.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 15.5H10c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5V16c0-.3-.2-.5-.5-.5zM10 12a4 4 0 00-4 4v20a4 4 0 004 4h28a4 4 0 004-4V16a4 4 0 00-4-4H10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React51.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 7.8a4.3 4.3 0 00-4.3 4.2v2h-3.4v-2a7.8 7.8 0 0115.4 0v2h-3.4v-2c0-2.3-2-4.3-4.3-4.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React51.createElement("path", { fillRule: "evenodd", d: "M40 27.8H8v-3.6h32v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React51.createElement("path", { d: "M26 20a2 2 0 11-4 0 2 2 0 014 0z" }));
}

// src/components/icons/FeatureBriefcase72.tsx
import * as React52 from "react";
var componentNameString47 = "FeatureBriefcase72";
function FeatureBriefcase72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString47,
    ...props
  });
  return /* @__PURE__ */ React52.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React52.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React52.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57 23H15a1 1 0 00-1 1v30c0 .6.4 1 1 1h42c.6 0 1-.4 1-1V24c0-.6-.4-1-1-1zm-42-5a6 6 0 00-6 6v30a6 6 0 006 6h42a6 6 0 006-6V24a6 6 0 00-6-6H15z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React52.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.5c-3.6 0-6.5 3-6.5 6.5v3h-5v-3a11.5 11.5 0 1123 0v3h-5v-3c0-3.6-3-6.5-6.5-6.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React52.createElement("path", { fillRule: "evenodd", d: "M60 41.5H12v-5h48v5z", clipRule: "evenodd" }), /* @__PURE__ */ React52.createElement("path", { d: "M39 30a3 3 0 11-6 0 3 3 0 016 0z" }));
}

// src/components/icons/FeatureBriefcaseAlt24.tsx
import * as React53 from "react";
var componentNameString48 = "FeatureBriefcaseAlt24";
function FeatureBriefcaseAlt24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString48,
    ...props
  });
  return /* @__PURE__ */ React53.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React53.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React53.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 8H5L5 18H19V8ZM5 6C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React53.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 4C10.8954 4 10 4.89543 10 6V7H8V6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V7H14V6C14 4.89543 13.1046 4 12 4Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React53.createElement("path", { fillRule: "evenodd", d: "M20 14H4V12H20V14Z", clipRule: "evenodd" }), /* @__PURE__ */ React53.createElement("path", { fillRule: "evenodd", d: "M11 16L11 12L13 12L13 16L11 16Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBriefcaseAlt48.tsx
import * as React54 from "react";
var componentNameString49 = "FeatureBriefcaseAlt48";
function FeatureBriefcaseAlt48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString49,
    ...props
  });
  return /* @__PURE__ */ React54.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React54.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React54.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 15.5H10c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5V16c0-.3-.2-.5-.5-.5zM10 12a4 4 0 00-4 4v20a4 4 0 004 4h28a4 4 0 004-4V16a4 4 0 00-4-4H10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React54.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 7.8a4.3 4.3 0 00-4.3 4.2v2h-3.4v-2a7.8 7.8 0 0115.4 0v2h-3.4v-2c0-2.3-2-4.3-4.3-4.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React54.createElement("path", { fillRule: "evenodd", d: "M40 27.8H8v-3.6h32v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React54.createElement("path", { fillRule: "evenodd", d: "M22.3 32.3v-7.6h3.4v7.6h-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBriefcaseAlt72.tsx
import * as React55 from "react";
var componentNameString50 = "FeatureBriefcaseAlt72";
function FeatureBriefcaseAlt72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString50,
    ...props
  });
  return /* @__PURE__ */ React55.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React55.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React55.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57 23H15a1 1 0 00-1 1v30c0 .6.4 1 1 1h42c.6 0 1-.4 1-1V24c0-.6-.4-1-1-1zm-42-5a6 6 0 00-6 6v30a6 6 0 006 6h42a6 6 0 006-6V24a6 6 0 00-6-6H15z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React55.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.5c-3.6 0-6.5 3-6.5 6.5v3h-5v-3a11.5 11.5 0 1123 0v3h-5v-3c0-3.6-3-6.5-6.5-6.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React55.createElement("path", { fillRule: "evenodd", d: "M60 41.5H12v-5h48v5z", clipRule: "evenodd" }), /* @__PURE__ */ React55.createElement("path", { fillRule: "evenodd", d: "M33.5 48.5V37h5v11.5h-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBrowser24.tsx
import * as React56 from "react";
var componentNameString51 = "FeatureBrowser24";
function FeatureBrowser24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString51,
    ...props
  });
  return /* @__PURE__ */ React56.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React56.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React56.createElement("path", { d: "M5 16V11H10L8.20711 12.7929L10.7071 15.2929L9.29291 16.7071L6.79289 14.2071L5 16Z" }), /* @__PURE__ */ React56.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM3 5H21V7H3V5ZM3 9L3 19H21V9H3Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBrowser48.tsx
import * as React57 from "react";
var componentNameString52 = "FeatureBrowser48";
function FeatureBrowser48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString52,
    ...props
  });
  return /* @__PURE__ */ React57.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React57.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React57.createElement("path", { fillRule: "evenodd", d: "M43.7 17.8h-39v-3.6h39v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React57.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M42 9.5H6c-.3 0-.5.2-.5.5v28c0 .3.2.5.5.5h36c.3 0 .5-.2.5-.5V10c0-.3-.2-.5-.5-.5zM6 6a4 4 0 00-4 4v28a4 4 0 004 4h36a4 4 0 004-4V10a4 4 0 00-4-4H6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React57.createElement("path", { d: "M10 32V22h10L10 32z" }), /* @__PURE__ */ React57.createElement("path", { fillRule: "evenodd", d: "M18.8 33.2l-8-8 2.4-2.4 8 8-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React57.createElement("path", { fillRule: "evenodd", d: "M24 25h16v-3.4H24V25z", clipRule: "evenodd" }), /* @__PURE__ */ React57.createElement("path", { fillRule: "evenodd", d: "M24 33h12v-3.4H24V33z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBrowser72.tsx
import * as React58 from "react";
var componentNameString53 = "FeatureBrowser72";
function FeatureBrowser72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString53,
    ...props
  });
  return /* @__PURE__ */ React58.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React58.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React58.createElement("path", { fillRule: "evenodd", d: "M65.5 26.5H7v-5h58.5v5z", clipRule: "evenodd" }), /* @__PURE__ */ React58.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M63 14H9a1 1 0 00-1 1v42c0 .6.4 1 1 1h54c.6 0 1-.4 1-1V15c0-.6-.4-1-1-1zM9 9a6 6 0 00-6 6v42a6 6 0 006 6h54a6 6 0 006-6V15a6 6 0 00-6-6H9z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React58.createElement("path", { d: "M15 48V33h15L15 48z" }), /* @__PURE__ */ React58.createElement("path", { fillRule: "evenodd", d: "M28.2 49.8l-12-12 3.6-3.6 12 12-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React58.createElement("path", { fillRule: "evenodd", d: "M36 37.5h24v-5H36v5z", clipRule: "evenodd" }), /* @__PURE__ */ React58.createElement("path", { fillRule: "evenodd", d: "M36 49.5h18v-5H36v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBrowser.tsx
import * as React59 from "react";
var componentNameString54 = "FeatureBrowser";
function FeatureBrowser({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString54,
    ...props
  });
  return /* @__PURE__ */ React59.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React59.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React59.createElement("polygon", { points: "2 12 46 12 46 5 2 5", className: "sc-Icon--primary-color" }), /* @__PURE__ */ React59.createElement("path", { d: "M11.3 31.3l-3.5 4V22.8l8.8 8.8-5.3-.3zM2 43h44V16H2v27z" }));
}

// src/components/icons/FeatureBuildWealth.tsx
import * as React60 from "react";
var componentNameString55 = "FeatureBuildWealth";
function FeatureBuildWealth({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString55,
    ...props
  });
  return /* @__PURE__ */ React60.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React60.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React60.createElement("path", { d: "M0 22v-9h22v9H0zm0 13v-9h22v9H0zm0 13v-9h22v9H0zm26-13v-9h22v9H26zm0 13v-9h22v9H26z" }), /* @__PURE__ */ React60.createElement("polygon", { points: "0 9 22 9 22 0 0 0", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureBuilding24.tsx
import * as React61 from "react";
var componentNameString56 = "FeatureBuilding24";
function FeatureBuilding24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString56,
    ...props
  });
  return /* @__PURE__ */ React61.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React61.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React61.createElement("path", { fillRule: "evenodd", d: "M8 14H16V20H19V4H5V20H8V14ZM10 22H3V2H21V22H14V16H10V22Z", clipRule: "evenodd" }), /* @__PURE__ */ React61.createElement("path", { d: "M11 6H13V8H11V6Z" }), /* @__PURE__ */ React61.createElement("path", { d: "M7 6H9V8H7V6Z" }), /* @__PURE__ */ React61.createElement("path", { d: "M15 6H17V8H15V6Z" }), /* @__PURE__ */ React61.createElement("path", { d: "M11 10H13V12H11V10Z" }), /* @__PURE__ */ React61.createElement("path", { d: "M7 10H9V12H7V10Z" }), /* @__PURE__ */ React61.createElement("path", { d: "M15 10H17V12H15V10Z" }));
}

// src/components/icons/FeatureBuilding48.tsx
import * as React62 from "react";
var componentNameString57 = "FeatureBuilding48";
function FeatureBuilding48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString57,
    ...props
  });
  return /* @__PURE__ */ React62.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React62.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React62.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.5 28.5h15v12h7v-33h-29v33h7v-12zM20 44H6V4h36v40H28V32h-8v12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React62.createElement("path", { d: "M22 12h4v4h-4v-4z" }), /* @__PURE__ */ React62.createElement("path", { d: "M14 12h4v4h-4v-4z" }), /* @__PURE__ */ React62.createElement("path", { d: "M30 12h4v4h-4v-4z" }), /* @__PURE__ */ React62.createElement("path", { d: "M22 20h4v4h-4v-4z" }), /* @__PURE__ */ React62.createElement("path", { d: "M14 20h4v4h-4v-4z" }), /* @__PURE__ */ React62.createElement("path", { d: "M30 20h4v4h-4v-4z" }));
}

// src/components/icons/FeatureBuilding72.tsx
import * as React63 from "react";
var componentNameString58 = "FeatureBuilding72";
function FeatureBuilding72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString58,
    ...props
  });
  return /* @__PURE__ */ React63.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React63.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React63.createElement("path", { fillRule: "evenodd", d: "M25 43h22v18h11V11H14v50h11V43zm5 23H9V6h54v60H42V48H30v18z", clipRule: "evenodd" }), /* @__PURE__ */ React63.createElement("path", { d: "M33 18h6v6h-6v-6z" }), /* @__PURE__ */ React63.createElement("path", { d: "M21 18h6v6h-6v-6z" }), /* @__PURE__ */ React63.createElement("path", { d: "M45 18h6v6h-6v-6z" }), /* @__PURE__ */ React63.createElement("path", { d: "M33 30h6v6h-6v-6z" }), /* @__PURE__ */ React63.createElement("path", { d: "M21 30h6v6h-6v-6z" }), /* @__PURE__ */ React63.createElement("path", { d: "M45 30h6v6h-6v-6z" }));
}

// src/components/icons/FeatureBuildings24.tsx
import * as React64 from "react";
var componentNameString59 = "FeatureBuildings24";
function FeatureBuildings24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString59,
    ...props
  });
  return /* @__PURE__ */ React64.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React64.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React64.createElement("path", { fillRule: "evenodd", d: "M6 15H12V20H14V5H4V20H6V15ZM2 22V3H16V22H10V17H8V22H2Z", clipRule: "evenodd" }), /* @__PURE__ */ React64.createElement("path", { d: "M10 7H12V9H10V7Z" }), /* @__PURE__ */ React64.createElement("path", { d: "M6 7H8V9H6V7Z" }), /* @__PURE__ */ React64.createElement("path", { d: "M16 12H18V14H16V12Z" }), /* @__PURE__ */ React64.createElement("path", { d: "M10 11H12V13H10V11Z" }), /* @__PURE__ */ React64.createElement("path", { d: "M6 11H8V13H6V11Z" }), /* @__PURE__ */ React64.createElement("path", { d: "M16 16H18V18H16V16Z" }), /* @__PURE__ */ React64.createElement("path", { fillRule: "evenodd", d: "M20 10H16V20H20V10ZM22 8V22H14V8H22Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBuildings48.tsx
import * as React65 from "react";
var componentNameString60 = "FeatureBuildings48";
function FeatureBuildings48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString60,
    ...props
  });
  return /* @__PURE__ */ React65.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React65.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React65.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.5 30.5h11v10h5v-31h-21v31h5v-10zM16 44H4V6h28v38H20V34h-4v10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React65.createElement("path", { d: "M20 14h4v4h-4v-4z" }), /* @__PURE__ */ React65.createElement("path", { d: "M12 14h4v4h-4v-4z" }), /* @__PURE__ */ React65.createElement("path", { d: "M32 24h4v4h-4v-4z" }), /* @__PURE__ */ React65.createElement("path", { d: "M20 22h4v4h-4v-4z" }), /* @__PURE__ */ React65.createElement("path", { d: "M12 22h4v4h-4v-4z" }), /* @__PURE__ */ React65.createElement("path", { d: "M32 32h4v4h-4v-4z" }), /* @__PURE__ */ React65.createElement("path", { fillRule: "evenodd", d: "M40.5 19.5h-8.3v21h8.3v-21zM44 16v28H28.7V16H44z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBuildings72.tsx
import * as React66 from "react";
var componentNameString61 = "FeatureBuildings72";
function FeatureBuildings72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString61,
    ...props
  });
  return /* @__PURE__ */ React66.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React66.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React66.createElement("path", { fillRule: "evenodd", d: "M19 46h16v15h8V14H11v47h8V46zm5 20H6V9h42v57H30V51h-6v15z", clipRule: "evenodd" }), /* @__PURE__ */ React66.createElement("path", { d: "M30 21h6v6h-6v-6z" }), /* @__PURE__ */ React66.createElement("path", { d: "M18 21h6v6h-6v-6z" }), /* @__PURE__ */ React66.createElement("path", { d: "M48 36h6v6h-6v-6z" }), /* @__PURE__ */ React66.createElement("path", { d: "M30 33h6v6h-6v-6z" }), /* @__PURE__ */ React66.createElement("path", { d: "M18 33h6v6h-6v-6z" }), /* @__PURE__ */ React66.createElement("path", { d: "M48 48h6v6h-6v-6z" }), /* @__PURE__ */ React66.createElement("path", { fillRule: "evenodd", d: "M61 29H48v32h13V29zm5-5v42H43V24h23z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureBullet24.tsx
import * as React67 from "react";
var componentNameString62 = "FeatureBullet24";
function FeatureBullet24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString62,
    ...props
  });
  return /* @__PURE__ */ React67.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React67.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React67.createElement("circle", { cx: 12, cy: 12, r: 5 }));
}

// src/components/icons/FeatureBullet48.tsx
import * as React68 from "react";
var componentNameString63 = "FeatureBullet48";
function FeatureBullet48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString63,
    ...props
  });
  return /* @__PURE__ */ React68.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React68.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React68.createElement("path", { d: "M34 24a10 10 0 11-20 0 10 10 0 0120 0z" }));
}

// src/components/icons/FeatureBullet72.tsx
import * as React69 from "react";
var componentNameString64 = "FeatureBullet72";
function FeatureBullet72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString64,
    ...props
  });
  return /* @__PURE__ */ React69.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React69.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React69.createElement("path", { d: "M51 36a15 15 0 11-30 0 15 15 0 0130 0z" }));
}

// src/components/icons/FeatureBulletOutline24.tsx
import * as React70 from "react";
var componentNameString65 = "FeatureBulletOutline24";
function FeatureBulletOutline24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString65,
    ...props
  });
  return /* @__PURE__ */ React70.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React70.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React70.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBulletOutline48.tsx
import * as React71 from "react";
var componentNameString66 = "FeatureBulletOutline48";
function FeatureBulletOutline48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString66,
    ...props
  });
  return /* @__PURE__ */ React71.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React71.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React71.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 30.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 3.5a10 10 0 100-20 10 10 0 000 20z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureBulletOutline72.tsx
import * as React72 from "react";
var componentNameString67 = "FeatureBulletOutline72";
function FeatureBulletOutline72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString67,
    ...props
  });
  return /* @__PURE__ */ React72.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React72.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React72.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 46a10 10 0 100-20 10 10 0 000 20zm0 5a15 15 0 100-30 15 15 0 000 30z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCalculator24.tsx
import * as React73 from "react";
var componentNameString68 = "FeatureCalculator24";
function FeatureCalculator24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString68,
    ...props
  });
  return /* @__PURE__ */ React73.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React73.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React73.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 4H6V20H18V4ZM6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2H6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React73.createElement("path", { fillRule: "evenodd", d: "M18.5001 9H5.16675V7H18.5001V9Z", clipRule: "evenodd" }), /* @__PURE__ */ React73.createElement("path", { d: "M11 10.3335H13V12.3335H11V10.3335Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M8 10.3335H10V12.3335H8V10.3335Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M14 10.3335H16V12.3335H14V10.3335Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M11 13.6665H13V15.6665H11V13.6665Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M8 13.6665H10V15.6665H8V13.6665Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M14 13.6665H16V15.6665H14V13.6665Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M14 17H16V19H14V17Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M8 17H11.3333V19H8V17Z" }), /* @__PURE__ */ React73.createElement("path", { d: "M11.3333 17H12.9999V19H11.3333V17Z" }));
}

// src/components/icons/FeatureCalculator48.tsx
import * as React74 from "react";
var componentNameString69 = "FeatureCalculator48";
function FeatureCalculator48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString69,
    ...props
  });
  return /* @__PURE__ */ React74.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React74.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React74.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 7.5H12c-.3 0-.5.2-.5.5v32c0 .3.2.5.5.5h24c.3 0 .5-.2.5-.5V8c0-.3-.2-.5-.5-.5zM12 4a4 4 0 00-4 4v32a4 4 0 004 4h24a4 4 0 004-4V8a4 4 0 00-4-4H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React74.createElement("path", { fillRule: "evenodd", d: "M37 17.8H10.3v-3.6H37v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React74.createElement("path", { d: "M22 20.7h4v4h-4v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M16 20.7h4v4h-4v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M28 20.7h4v4h-4v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M22 27.3h4v4h-4v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M16 27.3h4v4h-4v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M28 27.3h4v4h-4v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M28 34h4v4h-4v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M16 34h6.7v4H16v-4z" }), /* @__PURE__ */ React74.createElement("path", { d: "M22.7 34H26v4h-3.3v-4z" }));
}

// src/components/icons/FeatureCalculator72.tsx
import * as React75 from "react";
var componentNameString70 = "FeatureCalculator72";
function FeatureCalculator72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString70,
    ...props
  });
  return /* @__PURE__ */ React75.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React75.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React75.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54 11H18a1 1 0 00-1 1v48c0 .6.4 1 1 1h36c.6 0 1-.4 1-1V12c0-.6-.4-1-1-1zM18 6a6 6 0 00-6 6v48a6 6 0 006 6h36a6 6 0 006-6V12a6 6 0 00-6-6H18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React75.createElement("path", { fillRule: "evenodd", d: "M55.5 26.5h-40v-5h40v5z", clipRule: "evenodd" }), /* @__PURE__ */ React75.createElement("path", { d: "M33 31h6v6h-6v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M24 31h6v6h-6v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M42 31h6v6h-6v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M33 41h6v6h-6v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M24 41h6v6h-6v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M42 41h6v6h-6v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M42 51h6v6h-6v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M24 51h10v6H24v-6z" }), /* @__PURE__ */ React75.createElement("path", { d: "M34 51h5v6h-5v-6z" }));
}

// src/components/icons/FeatureCalendar24.tsx
import * as React76 from "react";
var componentNameString71 = "FeatureCalendar24";
function FeatureCalendar24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString71,
    ...props
  });
  return /* @__PURE__ */ React76.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React76.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React76.createElement("path", { d: "M14 16V12H18V16H14Z" }), /* @__PURE__ */ React76.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9 2V4H15V2H17V4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H7V2H9ZM20 6H4V8H20V6ZM4 18V10H20V18H4Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCalendar48.tsx
import * as React77 from "react";
var componentNameString72 = "FeatureCalendar48";
function FeatureCalendar48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString72,
    ...props
  });
  return /* @__PURE__ */ React77.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React77.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React77.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 11.5H10A2.5 2.5 0 007.5 14v20c0 1.4 1.1 2.5 2.5 2.5h28c1.4 0 2.5-1.1 2.5-2.5V14c0-1.4-1.1-2.5-2.5-2.5zM10 8a6 6 0 00-6 6v20a6 6 0 006 6h28a6 6 0 006-6V14a6 6 0 00-6-6H10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React77.createElement("path", { fillRule: "evenodd", d: "M17.8 4v6h-3.6V4h3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React77.createElement("path", { fillRule: "evenodd", d: "M33.8 4v6h-3.5V4h3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React77.createElement("path", { fillRule: "evenodd", d: "M41 19.8H7v-3.6h34v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React77.createElement("path", { d: "M28 24h8v8h-8v-8z" }), /* @__PURE__ */ React77.createElement("path", { fillRule: "evenodd", d: "M28 24v8h8v-8h-8z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCalendar72.tsx
import * as React78 from "react";
var componentNameString73 = "FeatureCalendar72";
function FeatureCalendar72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString73,
    ...props
  });
  return /* @__PURE__ */ React78.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React78.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React78.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M60 17H12a1 1 0 00-1 1v36c0 .6.4 1 1 1h48c.6 0 1-.4 1-1V18c0-.6-.4-1-1-1zm-48-5a6 6 0 00-6 6v36a6 6 0 006 6h48a6 6 0 006-6V18a6 6 0 00-6-6H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React78.createElement("path", { fillRule: "evenodd", d: "M26.5 6v9h-5V6h5z", clipRule: "evenodd" }), /* @__PURE__ */ React78.createElement("path", { fillRule: "evenodd", d: "M50.5 6v9h-5V6h5z", clipRule: "evenodd" }), /* @__PURE__ */ React78.createElement("path", { fillRule: "evenodd", d: "M61.5 29.5h-51v-5h51v5z", clipRule: "evenodd" }), /* @__PURE__ */ React78.createElement("path", { d: "M42 36h12v12H42V36z" }), /* @__PURE__ */ React78.createElement("path", { fillRule: "evenodd", d: "M49 41h-2v2h2v-2zm-7-5v12h12V36H42z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCalendar.tsx
import * as React79 from "react";
var componentNameString74 = "FeatureCalendar";
function FeatureCalendar({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString74,
    ...props
  });
  return /* @__PURE__ */ React79.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React79.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React79.createElement("path", { d: "M0 48V0h48v48H0zm4-4h40V8H4v36zm8-42a2 2 0 100 4 2 2 0 000-4zm24 0a2 2 0 100 4 2 2 0 000-4zm5 20h-9v8h9v3h-9v8h-3v-8H19v8h-3v-8H7v-3h9v-8H7v-3h9v-8h3v8h10v-8h3v8h9v3zm-22 8h10v-8H19v8z" }), /* @__PURE__ */ React79.createElement("polygon", { points: "35 16 41 16 41 11 35 11", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureCamera24.tsx
import * as React80 from "react";
var componentNameString75 = "FeatureCamera24";
function FeatureCamera24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString75,
    ...props
  });
  return /* @__PURE__ */ React80.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React80.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React80.createElement("path", { fillRule: "evenodd", d: "M9 13H2V11H9V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React80.createElement("path", { fillRule: "evenodd", d: "M22 13H15V11H22V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React80.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React80.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.82843 7H4V17H20V7H16.1716L14.1716 5H9.82843L7.82843 7ZM9 3L7 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5H17L15 3H9Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCamera48.tsx
import * as React81 from "react";
var componentNameString76 = "FeatureCamera48";
function FeatureCamera48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString76,
    ...props
  });
  return /* @__PURE__ */ React81.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React81.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React81.createElement("path", { fillRule: "evenodd", d: "M18 25.8H4v-3.6h14v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React81.createElement("path", { fillRule: "evenodd", d: "M44 25.8H30v-3.6h14v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React81.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React81.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.4 13.5H8c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h32c.3 0 .5-.2.5-.5V14c0-.3-.2-.5-.5-.5h-7.4l-4-4h-9.2l-4 4zM18 6l-4 4H8a4 4 0 00-4 4v20a4 4 0 004 4h32a4 4 0 004-4V14a4 4 0 00-4-4h-6l-4-4H18z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCamera72.tsx
import * as React82 from "react";
var componentNameString77 = "FeatureCamera72";
function FeatureCamera72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString77,
    ...props
  });
  return /* @__PURE__ */ React82.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React82.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React82.createElement("path", { fillRule: "evenodd", d: "M27 38.5H6v-5h21v5z", clipRule: "evenodd" }), /* @__PURE__ */ React82.createElement("path", { fillRule: "evenodd", d: "M66 38.5H45v-5h21v5z", clipRule: "evenodd" }), /* @__PURE__ */ React82.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 43a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React82.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M23 20H12a1 1 0 00-1 1v30c0 .6.4 1 1 1h48c.6 0 1-.4 1-1V21c0-.6-.4-1-1-1H49l-6-6H29l-6 6zm4-11l-6 6h-9a6 6 0 00-6 6v30a6 6 0 006 6h48a6 6 0 006-6V21a6 6 0 00-6-6h-9l-6-6H27z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCancel24.tsx
import * as React83 from "react";
var componentNameString78 = "FeatureCancel24";
function FeatureCancel24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString78,
    ...props
  });
  return /* @__PURE__ */ React83.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React83.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React83.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C10.1513 20 8.44906 19.3729 7.09437 18.3199L18.3199 7.09437C19.3729 8.44905 20 10.1513 20 12ZM5.68016 16.9057L16.9057 5.68016C15.551 4.62709 13.8487 4 12 4C7.58172 4 4 7.58172 4 12C4 13.8487 4.62709 15.551 5.68016 16.9057Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCancel48.tsx
import * as React84 from "react";
var componentNameString79 = "FeatureCancel48";
function FeatureCancel48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString79,
    ...props
  });
  return /* @__PURE__ */ React84.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React84.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React84.createElement("path", { fillRule: "evenodd", d: "M9.8 35.8l26-26 2.4 2.4-26 26-2.4-2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React84.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCancel72.tsx
import * as React85 from "react";
var componentNameString80 = "FeatureCancel72";
function FeatureCancel72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString80,
    ...props
  });
  return /* @__PURE__ */ React85.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React85.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React85.createElement("path", { fillRule: "evenodd", d: "M16.2 52.2l36-36 3.6 3.6-36 36-3.6-3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React85.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCar24.tsx
import * as React86 from "react";
var componentNameString81 = "FeatureCar24";
function FeatureCar24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString81,
    ...props
  });
  return /* @__PURE__ */ React86.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React86.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React86.createElement("circle", { cx: 16.5, cy: 13.5, r: 1.5 }), /* @__PURE__ */ React86.createElement("circle", { cx: 7.5, cy: 13.5, r: 1.5 }), /* @__PURE__ */ React86.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.86667 6C7.49735 6 7.15811 6.20355 6.98431 6.52941L5 10.25V16H19V10.25L17.0157 6.52941C16.8419 6.20355 16.5026 6 16.1333 6H7.86667ZM5.21961 5.58823C5.74099 4.61064 6.75873 4 7.86667 4H16.1333C17.2413 4 18.259 4.61064 18.7804 5.58824L21 9.75V18H3V9.75L5.21961 5.58823Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React86.createElement("path", { fillRule: "evenodd", d: "M20 11H4V9H20V11Z", clipRule: "evenodd" }), /* @__PURE__ */ React86.createElement("path", { d: "M18 17H21V18.5C21 19.3284 20.3284 20 19.5 20C18.6716 20 18 19.3284 18 18.5V17Z" }), /* @__PURE__ */ React86.createElement("path", { d: "M3 17H6V18.5C6 19.3284 5.32843 20 4.5 20C3.67157 20 3 19.3284 3 18.5V17Z" }), /* @__PURE__ */ React86.createElement("circle", { cx: 2.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ React86.createElement("circle", { cx: 21.5, cy: 9.5, r: 1.5 }));
}

// src/components/icons/FeatureCar48.tsx
import * as React87 from "react";
var componentNameString82 = "FeatureCar48";
function FeatureCar48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString82,
    ...props
  });
  return /* @__PURE__ */ React87.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React87.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React87.createElement("path", { d: "M36 27a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React87.createElement("path", { d: "M18 27a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React87.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.7 11.8c-.8 0-1.6.4-2 1.1l-4 7.5v11.9h28.6V20.4l-4-7.5a2.3 2.3 0 00-2-1.2H15.7zm-5-.5c1-1.9 3-3 5-3h16.6c2 0 4 1.1 5 3l4.5 8.3v16.1H6.3V19.6l4.4-8.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React87.createElement("path", { fillRule: "evenodd", d: "M40 21.8H8v-3.6h32v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React87.createElement("path", { d: "M36 34h5.8v3.1a2.9 2.9 0 01-5.8 0V34z" }), /* @__PURE__ */ React87.createElement("path", { d: "M12 34H6.2v3.1a2.9 2.9 0 005.8 0V34z" }), /* @__PURE__ */ React87.createElement("path", { d: "M8 19a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React87.createElement("path", { d: "M46 19a3 3 0 11-6 0 3 3 0 016 0z" }));
}

// src/components/icons/FeatureCar72.tsx
import * as React88 from "react";
var componentNameString83 = "FeatureCar72";
function FeatureCar72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString83,
    ...props
  });
  return /* @__PURE__ */ React88.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React88.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React88.createElement("path", { d: "M54 40.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React88.createElement("path", { d: "M27 40.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React88.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M23.6 17.5c-1.3 0-2.5.7-3 1.9l-6.1 11.2v17.9h43V30.6l-6-11.2a3.5 3.5 0 00-3.1-1.9H23.6zm-7.5-.5a8.5 8.5 0 017.5-4.5h24.8c3.1 0 6 1.7 7.5 4.5l6.6 12.4v24.1h-53V29.4L16.1 17z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React88.createElement("path", { fillRule: "evenodd", d: "M60 32.5H12v-5h48v5z", clipRule: "evenodd" }), /* @__PURE__ */ React88.createElement("path", { d: "M54 51h8.5v4.8a4.3 4.3 0 01-8.5 0V51z" }), /* @__PURE__ */ React88.createElement("path", { d: "M18 51H9.5v4.8a4.3 4.3 0 008.5 0V51z" }), /* @__PURE__ */ React88.createElement("path", { d: "M12 28.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React88.createElement("path", { d: "M69 28.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }));
}

// src/components/icons/FeatureCarAlt24.tsx
import * as React89 from "react";
var componentNameString84 = "FeatureCarAlt24";
function FeatureCarAlt24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString84,
    ...props
  });
  return /* @__PURE__ */ React89.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React89.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React89.createElement("path", { d: "M18 13.5C18 14.3284 17.3284 15 16.5 15C15.6716 15 15 14.3284 15 13.5C15 12.6716 15.6716 12 16.5 12C17.3284 12 18 12.6716 18 13.5Z" }), /* @__PURE__ */ React89.createElement("path", { d: "M9 13.5C9 14.3284 8.32843 15 7.5 15C6.67157 15 6 14.3284 6 13.5C6 12.6716 6.67157 12 7.5 12C8.32843 12 9 12.6716 9 13.5Z" }), /* @__PURE__ */ React89.createElement("path", { d: "M18 17H21V18.5C21 19.3284 20.3284 20 19.5 20C18.6716 20 18 19.3284 18 18.5V17Z" }), /* @__PURE__ */ React89.createElement("path", { d: "M3 17H6V18.5C6 19.3284 5.32843 20 4.5 20C3.67157 20 3 19.3284 3 18.5V17Z" }), /* @__PURE__ */ React89.createElement("path", { d: "M4 9.5C4 10.3284 3.32843 11 2.5 11C1.67157 11 1 10.3284 1 9.5C1 8.67157 1.67157 8 2.5 8C3.32843 8 4 8.67157 4 9.5Z" }), /* @__PURE__ */ React89.createElement("path", { d: "M23 9.5C23 10.3284 22.3284 11 21.5 11C20.6716 11 20 10.3284 20 9.5C20 8.67157 20.6716 8 21.5 8C22.3284 8 23 8.67157 23 9.5Z" }), /* @__PURE__ */ React89.createElement("path", { fillRule: "evenodd", d: "M3 9H21V18H3V9ZM5 11V16H19V11H5Z", clipRule: "evenodd" }), /* @__PURE__ */ React89.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.10002 9H16.9C16.4367 6.71776 14.419 5 12 5C9.58104 5 7.56329 6.71776 7.10002 9ZM5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V11H5V10Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCarAlt48.tsx
import * as React90 from "react";
var componentNameString85 = "FeatureCarAlt48";
function FeatureCarAlt48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString85,
    ...props
  });
  return /* @__PURE__ */ React90.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React90.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React90.createElement("path", { d: "M36 27a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React90.createElement("path", { d: "M18 27a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React90.createElement("path", { d: "M36 34h5.8v3.1a2.9 2.9 0 01-5.8 0V34z" }), /* @__PURE__ */ React90.createElement("path", { d: "M12 34H6.2v3.1a2.9 2.9 0 005.8 0V34z" }), /* @__PURE__ */ React90.createElement("path", { d: "M8 19a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React90.createElement("path", { d: "M46 19a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React90.createElement("path", { fillRule: "evenodd", d: "M6.3 18.3h35.5v17.4H6.3V18.3zm3.5 3.4v10.6h28.4V21.8H9.8z", clipRule: "evenodd" }), /* @__PURE__ */ React90.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.9 18.3h20.2a10.3 10.3 0 00-20.2 0zM10.2 20a13.8 13.8 0 0127.6 0v1.8H10.3V20z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCarAlt72.tsx
import * as React91 from "react";
var componentNameString86 = "FeatureCarAlt72";
function FeatureCarAlt72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString86,
    ...props
  });
  return /* @__PURE__ */ React91.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React91.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React91.createElement("path", { d: "M54 40.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React91.createElement("path", { d: "M27 40.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React91.createElement("path", { d: "M54 51h8.5v7a2 2 0 01-2 2H56a2 2 0 01-2-2v-7z" }), /* @__PURE__ */ React91.createElement("path", { d: "M18 51H9.5v7c0 1.1.9 2 2 2H16a2 2 0 002-2v-7z" }), /* @__PURE__ */ React91.createElement("path", { d: "M12 28.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React91.createElement("path", { d: "M69 28.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React91.createElement("path", { fillRule: "evenodd", d: "M9.5 27.5h53v26h-53v-26zm5 5v16h43v-16h-43z", clipRule: "evenodd" }), /* @__PURE__ */ React91.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.7 27.5h30.6a15.5 15.5 0 00-30.6 0zM15.5 30a20.5 20.5 0 0141 0v2.5h-41V30z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCard24.tsx
import * as React92 from "react";
var componentNameString87 = "FeatureCard24";
function FeatureCard24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString87,
    ...props
  });
  return /* @__PURE__ */ React92.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React92.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React92.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4 4C4 2.89543 4.89543 2 6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4ZM11 4H18V20H11V4ZM8 4H6V20H8V4Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCard48.tsx
import * as React93 from "react";
var componentNameString88 = "FeatureCard48";
function FeatureCard48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString88,
    ...props
  });
  return /* @__PURE__ */ React93.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React93.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React93.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 7.5H12c-.3 0-.5.2-.5.5v32c0 .3.2.5.5.5h24c.3 0 .5-.2.5-.5V8c0-.3-.2-.5-.5-.5zM12 4a4 4 0 00-4 4v32a4 4 0 004 4h24a4 4 0 004-4V8a4 4 0 00-4-4H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React93.createElement("path", { d: "M16 6h6v35.3h-6V6z" }), /* @__PURE__ */ React93.createElement("path", { d: "M28.7 10.7h4.6V16h-4.6v-5.3z" }));
}

// src/components/icons/FeatureCard72.tsx
import * as React94 from "react";
var componentNameString89 = "FeatureCard72";
function FeatureCard72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString89,
    ...props
  });
  return /* @__PURE__ */ React94.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React94.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React94.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54 11H18a1 1 0 00-1 1v48c0 .6.4 1 1 1h36c.6 0 1-.4 1-1V12c0-.6-.4-1-1-1zM18 6a6 6 0 00-6 6v48a6 6 0 006 6h36a6 6 0 006-6V12a6 6 0 00-6-6H18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React94.createElement("path", { d: "M24 9h9v53h-9V9z" }), /* @__PURE__ */ React94.createElement("path", { d: "M43 16h7v8h-7v-8z" }));
}

// src/components/icons/FeatureCaretDown24.tsx
import * as React95 from "react";
var componentNameString90 = "FeatureCaretDown24";
function FeatureCaretDown24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString90,
    ...props
  });
  return /* @__PURE__ */ React95.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React95.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React95.createElement("path", { d: "M18.3536 9.70709L12 16.0606L5.64648 9.70708L6.70714 8.64642L12 13.9393L17.2929 8.64643L18.3536 9.70709Z" }));
}

// src/components/icons/FeatureCaretDown48.tsx
import * as React96 from "react";
var componentNameString91 = "FeatureCaretDown48";
function FeatureCaretDown48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString91,
    ...props
  });
  return /* @__PURE__ */ React96.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React96.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React96.createElement("path", { fillRule: "evenodd", d: "M24 32.5L10.8 19.2l2.4-2.4L24 27.5l10.8-10.7 2.4 2.4L24 32.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCaretDown72.tsx
import * as React97 from "react";
var componentNameString92 = "FeatureCaretDown72";
function FeatureCaretDown72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString92,
    ...props
  });
  return /* @__PURE__ */ React97.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React97.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React97.createElement("path", { fillRule: "evenodd", d: "M36 48.5L16.2 28.8l3.6-3.6L36 41.5l16.2-16.3 3.6 3.6L36 48.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCaretLeft24.tsx
import * as React98 from "react";
var componentNameString93 = "FeatureCaretLeft24";
function FeatureCaretLeft24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString93,
    ...props
  });
  return /* @__PURE__ */ React98.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React98.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React98.createElement("path", { d: "M14.2928 18.3536L7.93921 12L14.2928 5.64645L15.3534 6.70711L10.0605 12L15.3534 17.2929L14.2928 18.3536Z" }));
}

// src/components/icons/FeatureCaretLeft48.tsx
import * as React99 from "react";
var componentNameString94 = "FeatureCaretLeft48";
function FeatureCaretLeft48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString94,
    ...props
  });
  return /* @__PURE__ */ React99.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React99.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React99.createElement("path", { fillRule: "evenodd", d: "M15.5 24l13.3-13.2 2.4 2.4L20.5 24l10.7 10.8-2.4 2.4L15.5 24z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCaretLeft72.tsx
import * as React100 from "react";
var componentNameString95 = "FeatureCaretLeft72";
function FeatureCaretLeft72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString95,
    ...props
  });
  return /* @__PURE__ */ React100.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React100.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React100.createElement("path", { fillRule: "evenodd", d: "M23.5 36l19.7-19.8 3.6 3.6L30.5 36l16.3 16.2-3.6 3.6L23.5 36z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCaretRight24.tsx
import * as React101 from "react";
var componentNameString96 = "FeatureCaretRight24";
function FeatureCaretRight24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString96,
    ...props
  });
  return /* @__PURE__ */ React101.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React101.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React101.createElement("path", { d: "M13.9394 12L8.64649 6.70708L9.70715 5.64642L16.0607 12L9.70714 18.3535L8.64648 17.2929L13.9394 12Z" }));
}

// src/components/icons/FeatureCaretRight48.tsx
import * as React102 from "react";
var componentNameString97 = "FeatureCaretRight48";
function FeatureCaretRight48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString97,
    ...props
  });
  return /* @__PURE__ */ React102.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React102.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React102.createElement("path", { fillRule: "evenodd", d: "M32.5 24L19.2 37.2l-2.4-2.4L27.5 24 16.8 13.2l2.4-2.4L32.5 24z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCaretRight72.tsx
import * as React103 from "react";
var componentNameString98 = "FeatureCaretRight72";
function FeatureCaretRight72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString98,
    ...props
  });
  return /* @__PURE__ */ React103.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React103.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React103.createElement("path", { fillRule: "evenodd", d: "M48.5 36L28.8 55.8l-3.6-3.6L41.5 36 25.2 19.8l3.6-3.6L48.5 36z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCaretUp24.tsx
import * as React104 from "react";
var componentNameString99 = "FeatureCaretUp24";
function FeatureCaretUp24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString99,
    ...props
  });
  return /* @__PURE__ */ React104.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React104.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React104.createElement("path", { d: "M5.64648 14.2929L12 7.93936L18.3536 14.2929L17.2929 15.3536L12 10.0607L6.70714 15.3536L5.64648 14.2929Z" }));
}

// src/components/icons/FeatureCaretUp48.tsx
import * as React105 from "react";
var componentNameString100 = "FeatureCaretUp48";
function FeatureCaretUp48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString100,
    ...props
  });
  return /* @__PURE__ */ React105.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React105.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React105.createElement("path", { fillRule: "evenodd", d: "M24 15.5l13.2 13.3-2.4 2.4L24 20.5 13.2 31.2l-2.4-2.4L24 15.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCaretUp72.tsx
import * as React106 from "react";
var componentNameString101 = "FeatureCaretUp72";
function FeatureCaretUp72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString101,
    ...props
  });
  return /* @__PURE__ */ React106.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React106.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React106.createElement("path", { fillRule: "evenodd", d: "M36 23.5l19.8 19.7-3.6 3.6L36 30.5 19.8 46.8l-3.6-3.6L36 23.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCash24.tsx
import * as React107 from "react";
var componentNameString102 = "FeatureCash24";
function FeatureCash24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString102,
    ...props
  });
  return /* @__PURE__ */ React107.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React107.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React107.createElement("path", { fillRule: "evenodd", d: "M22 7H2V17H22V7ZM0 5V19H24V5H0Z", clipRule: "evenodd" }), /* @__PURE__ */ React107.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCash48.tsx
import * as React108 from "react";
var componentNameString103 = "FeatureCash48";
function FeatureCash48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString103,
    ...props
  });
  return /* @__PURE__ */ React108.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React108.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React108.createElement("path", { fillRule: "evenodd", d: "M44.5 13.5h-41v21h41v-21zM0 10v28h48V10H0z", clipRule: "evenodd" }), /* @__PURE__ */ React108.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCash72.tsx
import * as React109 from "react";
var componentNameString104 = "FeatureCash72";
function FeatureCash72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString104,
    ...props
  });
  return /* @__PURE__ */ React109.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React109.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React109.createElement("path", { fillRule: "evenodd", d: "M67 20H5v32h62V20zM0 15v42h72V15H0z", clipRule: "evenodd" }), /* @__PURE__ */ React109.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 43a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCharity24.tsx
import * as React110 from "react";
var componentNameString105 = "FeatureCharity24";
function FeatureCharity24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString105,
    ...props
  });
  return /* @__PURE__ */ React110.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React110.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React110.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.0001 9.88809L9.50419 7.2882C8.24717 5.9788 6.15301 5.9788 4.89599 7.2882C3.70947 8.52415 3.70947 10.4761 4.89599 11.7121L12.0001 19.1122L19.1042 11.7121C20.2907 10.4761 20.2907 8.52415 19.1042 7.2882C17.8472 5.9788 15.753 5.9788 14.496 7.2882L12.0001 9.88809ZM10.5987 5.57194C8.5333 3.78023 5.38522 3.89063 3.45321 5.90314C1.52373 7.91302 1.52373 11.0873 3.45322 13.0971L10.5573 20.4973C11.3444 21.3172 12.6557 21.3172 13.4429 20.4972L20.547 13.0971C22.4764 11.0873 22.4765 7.91302 20.547 5.90314C18.615 3.89063 15.4669 3.78023 13.4015 5.57194C13.2816 5.67593 13.1653 5.78633 13.0532 5.90314L12.0001 7.00014L10.947 5.90314C10.8348 5.78633 10.7186 5.67593 10.5987 5.57194Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React110.createElement("path", { d: "M15.8307 12.914L12.0001 17L8.16955 12.914C7.51184 12.2125 7.51184 11.1208 8.16955 10.4192C8.8901 9.65063 10.1101 9.65063 10.8307 10.4192L12.0001 11.6666L13.1696 10.4192C13.8901 9.65063 15.1101 9.65063 15.8307 10.4192C16.4884 11.1208 16.4884 12.2125 15.8307 12.914Z" }));
}

// src/components/icons/FeatureCharity48.tsx
import * as React111 from "react";
var componentNameString106 = "FeatureCharity48";
function FeatureCharity48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString106,
    ...props
  });
  return /* @__PURE__ */ React111.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React111.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React111.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 19l-4.6-4.8a6.9 6.9 0 10-10 9.6L24 38.9l14.6-15.1a6.9 6.9 0 10-10-9.6L24 19.1zm-1 21zm1-26l2.1-2.2.3-.3a10.4 10.4 0 0114.7 14.7L25.4 42.5a2 2 0 01-2.8 0L6.9 26.2a10.4 10.4 0 0115-14.4L24 14z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React111.createElement("path", { d: "M31.7 25.8L24 34l-7.7-8.2a3.6 3.6 0 015.4-5l2.3 2.5 2.3-2.5a3.6 3.6 0 015.4 5z" }));
}

// src/components/icons/FeatureCharity72.tsx
import * as React112 from "react";
var componentNameString107 = "FeatureCharity72";
function FeatureCharity72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString107,
    ...props
  });
  return /* @__PURE__ */ React112.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React112.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React112.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 28.2l-7.2-7.5a10 10 0 00-14.4 0l-.8.9a10 10 0 000 13.8L36 58.8l22.4-23.4a10 10 0 000-13.8l-.8-.9a10 10 0 00-14.4 0L36 28.2zm-3.6-11a15 15 0 00-21.6 0l-.8 1a15 15 0 000 20.7l24.6 25.6a2 2 0 002.8 0L62 38.9A15 15 0 0062 18l-.8-.8a15 15 0 00-21.6 0L36 21l-3.6-3.7z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React112.createElement("path", { d: "M47.5 38.7L36 51 24.5 38.7a5.5 5.5 0 118-7.4L36 35l3.5-3.7a5.5 5.5 0 018 7.4z" }));
}

// src/components/icons/FeatureCharityHand24.tsx
import * as React113 from "react";
var componentNameString108 = "FeatureCharityHand24";
function FeatureCharityHand24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString108,
    ...props
  });
  return /* @__PURE__ */ React113.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React113.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React113.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.5 3C11.2239 3 11 3.22386 11 3.5V12H11H9H8.99996V5.5C8.99996 5.22386 8.77611 5 8.49996 5C8.22382 5 7.99996 5.22386 7.99996 5.5V18.4142L4.70707 15.1213C4.32096 14.7352 3.69765 14.7308 3.30618 15.1082L6.61723 19.7437C7.18037 20.5321 8.08958 21 9.05844 21H15C16.6568 21 18 19.6569 18 18V6.5C18 6.22386 17.7761 6 17.5 6C17.2259 6 17.0033 6.22058 17 6.49392V12H17H15H15V6.5L15 6.48639V4.5C15 4.22386 14.7761 4 14.5 4C14.2239 4 14 4.22386 14 4.5V12H12V4.5V3.5C12 3.22386 11.7761 3 11.5 3ZM13.6123 2.16218C13.169 1.46363 12.3886 1 11.5 1C10.27 1 9.24751 1.88823 9.03891 3.05824C8.86533 3.0201 8.685 3 8.49996 3C7.11925 3 5.99996 4.11929 5.99996 5.5V13.5922C4.82205 12.5369 3.01059 12.5752 1.87864 13.7071L0.693848 14.8919L4.98977 20.9062C5.92833 22.2202 7.44368 23 9.05844 23H15C17.7614 23 20 20.7614 20 18V6.5C20 5.11929 18.8807 4 17.5 4C17.315 4 17.1346 4.0201 16.9611 4.05822C16.7525 2.88822 15.73 2 14.5 2C14.1874 2 13.8882 2.05738 13.6123 2.16218ZM15.9999 16.0002L12.9999 19.0002L9.99991 16.0002C9.44762 15.4479 9.44762 14.5524 9.99991 14.0002C10.5522 13.4479 11.4476 13.4479 11.9999 14.0002L12.9999 15.0002L13.9999 14.0002C14.5522 13.4479 15.4476 13.4479 15.9999 14.0002C16.5522 14.5524 16.5522 15.4479 15.9999 16.0002Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCharityHand48.tsx
import * as React114 from "react";
var componentNameString109 = "FeatureCharityHand48";
function FeatureCharityHand48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString109,
    ...props
  });
  return /* @__PURE__ */ React114.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React114.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React114.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17 9.8c-.7 0-1.3.5-1.3 1.2v25.2l-5-5a4 4 0 00-4.3-.8l7.2 10a4.2 4.2 0 003.5 1.9H32c2.3 0 4.2-2 4.2-4.3V13a1.2 1.2 0 10-2.5 0v11h-3.5V13a4.8 4.8 0 019.5 0v25c0 4.3-3.4 7.8-7.7 7.8H17a7.7 7.7 0 01-6.2-3.3L2.6 31c-.5-.7-.4-1.6.2-2.2a7.4 7.4 0 019.4-.9V11a4.8 4.8 0 019.5 0v13h-3.5V11c0-.7-.5-1.3-1.2-1.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React114.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M23 5.8c-.7 0-1.3.5-1.3 1.2v17h-3.4V7a4.7 4.7 0 119.4 0v17h-3.4V7c0-.7-.6-1.3-1.3-1.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React114.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M29 7.8c-.7 0-1.3.5-1.3 1.2v15h-3.4V9a4.8 4.8 0 019.5 0v15h-3.5V9c0-.7-.6-1.3-1.3-1.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React114.createElement("path", { d: "M32 32l-6 6-6-6a2.8 2.8 0 014-4l2 2 2-2a2.8 2.8 0 114 4z" }), /* @__PURE__ */ React114.createElement("path", { fillRule: "evenodd", d: "M26 38l6-6a2.8 2.8 0 10-4-4l-2 2-2-2a2.8 2.8 0 00-4 4l6 6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCharityHand72.tsx
import * as React115 from "react";
var componentNameString110 = "FeatureCharityHand72";
function FeatureCharityHand72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString110,
    ...props
  });
  return /* @__PURE__ */ React115.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React115.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React115.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M25.5 14.5a2 2 0 00-2 2V54l-9-9a3.5 3.5 0 00-5 0l-.2.3 11.3 15.9c1 1.4 2.7 2.3 4.5 2.3H49c3 0 5.5-2.5 5.5-5.5V19.5a2 2 0 00-4 0V36h-5V19.5a7 7 0 1114 0V58c0 5.8-4.7 10.5-10.5 10.5H25.1c-3.4 0-6.6-1.6-8.5-4.4L2.7 44.7 6 41.5a8.5 8.5 0 0112 0l.5.5V16.5a7 7 0 1114 0V36h-5V16.5a2 2 0 00-2-2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React115.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34.5 8.5a2 2 0 00-2 2V36h-5V10.5a7 7 0 1114 0V36h-5V10.5a2 2 0 00-2-2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React115.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M43.5 11.5a2 2 0 00-2 2V36h-5V13.5a7 7 0 1114 0V36h-5V13.5a2 2 0 00-2-2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React115.createElement("path", { d: "M48 48l-9 9-9-9a4.2 4.2 0 116-6l3 3 3-3a4.2 4.2 0 116 6z" }), /* @__PURE__ */ React115.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M39 45l3-3a4.2 4.2 0 116 6l-9 9-9-9a4.2 4.2 0 116-6l3 3zm0 10.6l8.3-8.3a3.2 3.2 0 10-4.6-4.6L39 46.4l-3.7-3.7a3.2 3.2 0 10-4.6 4.6l8.3 8.3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureChat24.tsx
import * as React116 from "react";
var componentNameString111 = "FeatureChat24";
function FeatureChat24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString111,
    ...props
  });
  return /* @__PURE__ */ React116.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React116.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React116.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.8284 16L20 17.1716V6L4 6L4 16H18.8284ZM22 22L18 18H4C2.89543 18 2 17.1046 2 16L2 6C2 4.89543 2.89543 4 4 4L20 4C21.1046 4 22 4.89543 22 6V22Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React116.createElement("path", { fillRule: "evenodd", d: "M13 12H11V10H13V12Z", clipRule: "evenodd" }), /* @__PURE__ */ React116.createElement("path", { fillRule: "evenodd", d: "M17 12H15V10H17V12Z", clipRule: "evenodd" }), /* @__PURE__ */ React116.createElement("path", { fillRule: "evenodd", d: "M9 12H7V10H9V12Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureChat48.tsx
import * as React117 from "react";
var componentNameString112 = "FeatureChat48";
function FeatureChat48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString112,
    ...props
  });
  return /* @__PURE__ */ React117.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React117.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React117.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M37.4 32.5l3.1 3V12c0-.3-.2-.5-.5-.5H8c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h29.4zM44 44l-8-8H8a4 4 0 01-4-4V12a4 4 0 014-4h32a4 4 0 014 4v32z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React117.createElement("path", { d: "M14 24h4v-4h-4v4z" }), /* @__PURE__ */ React117.createElement("path", { d: "M22 24h4v-4h-4v4z" }), /* @__PURE__ */ React117.createElement("path", { d: "M30 24h4v-4h-4v4z" }));
}

// src/components/icons/FeatureChat72.tsx
import * as React118 from "react";
var componentNameString113 = "FeatureChat72";
function FeatureChat72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString113,
    ...props
  });
  return /* @__PURE__ */ React118.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React118.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React118.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M56 49l5 5V18c0-.6-.4-1-1-1H12a1 1 0 00-1 1v30c0 .6.4 1 1 1h44zm10 17L54 54H12a6 6 0 01-6-6V18a6 6 0 016-6h48a6 6 0 016 6v48z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React118.createElement("path", { d: "M21 36h6v-6h-6v6z" }), /* @__PURE__ */ React118.createElement("path", { d: "M33 36h6v-6h-6v6z" }), /* @__PURE__ */ React118.createElement("path", { d: "M45 36h6v-6h-6v6z" }));
}

// src/components/icons/FeatureChatTwo.tsx
import * as React119 from "react";
var componentNameString114 = "FeatureChatTwo";
function FeatureChatTwo({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString114,
    ...props
  });
  return /* @__PURE__ */ React119.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React119.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React119.createElement("polygon", { points: "0 2 0 32.001 6 26 18 26 18 14.001 30 14.001 30 2", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React119.createElement("polygon", { points: "30 14 30 26 18 26 18 37.999 42.001 37.999 48 44 48 14", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureChat.tsx
import * as React120 from "react";
var componentNameString115 = "FeatureChat";
function FeatureChat({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString115,
    ...props
  });
  return /* @__PURE__ */ React120.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React120.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React120.createElement(
    "polygon",
    {
      points: "9 7 9 13 30 13 30 18 9 18 9 23 20 23 20 28 9 28 9 34 37 34 48 41 48 7",
      className: "sc-Icon--secondary-color"
    }
  ), /* @__PURE__ */ React120.createElement("path", { d: "M0 18v-5h9v5H0zm0 10v-5h9v5H0z" }));
}

// src/components/icons/FeatureCheckBack24.tsx
import * as React121 from "react";
var componentNameString116 = "FeatureCheckBack24";
function FeatureCheckBack24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString116,
    ...props
  });
  return /* @__PURE__ */ React121.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React121.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React121.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17.0211 11.1221C17.5646 10.8257 17.3541 10 16.735 10H16V8L16.735 8C19.4261 8 20.3413 11.5893 17.9789 12.8779C17.4354 13.1743 17.6459 14 18.265 14H19V16H18.265C15.5739 16 14.6587 12.4107 17.0211 11.1221Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React121.createElement("path", { fillRule: "evenodd", d: "M3 17L21 17L21 7L3 7L3 17ZM23 19L23 5L1 5L1 19L23 19Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckBack48.tsx
import * as React122 from "react";
var componentNameString117 = "FeatureCheckBack48";
function FeatureCheckBack48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString117,
    ...props
  });
  return /* @__PURE__ */ React122.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React122.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React122.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34.2 22.5c1.3-.8.8-2.8-.7-2.8H32v-3.4h1.5c5 0 6.8 6.8 2.3 9.2-1.3.8-.8 2.8.7 2.8H38v3.4h-1.5c-5 0-6.8-6.8-2.3-9.2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React122.createElement("path", { fillRule: "evenodd", d: "M5.5 34.5h37v-21h-37v21zM46 38V10H2v28h44z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckBack72.tsx
import * as React123 from "react";
var componentNameString118 = "FeatureCheckBack72";
function FeatureCheckBack72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString118,
    ...props
  });
  return /* @__PURE__ */ React123.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React123.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React123.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M51.3 33.8c2-1.1 1.3-4.3-1-4.3H48v-5h2.2c7.6 0 10.1 10 3.5 13.7-2 1.1-1.3 4.3 1.1 4.3H57v5h-2.2c-7.6 0-10.1-10-3.5-13.7z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React123.createElement("path", { fillRule: "evenodd", d: "M8 52h56V20H8v32zm61 5V15H3v42h66z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckFront24.tsx
import * as React124 from "react";
var componentNameString119 = "FeatureCheckFront24";
function FeatureCheckFront24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString119,
    ...props
  });
  return /* @__PURE__ */ React124.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React124.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React124.createElement("path", { d: "M12 11H5V9H12V11Z" }), /* @__PURE__ */ React124.createElement("path", { d: "M5 15H19V13H5V15Z" }), /* @__PURE__ */ React124.createElement("path", { fillRule: "evenodd", d: "M23 19L23 5L1 5L1 19L23 19ZM3 17L21 17L21 7L3 7L3 17Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckFront48.tsx
import * as React125 from "react";
var componentNameString120 = "FeatureCheckFront48";
function FeatureCheckFront48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString120,
    ...props
  });
  return /* @__PURE__ */ React125.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React125.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React125.createElement("path", { fillRule: "evenodd", d: "M4.8 34.5h38.4v-21H4.8v21zM46.7 38V10H1.3v28h45.4z", clipRule: "evenodd" }), /* @__PURE__ */ React125.createElement("path", { fillRule: "evenodd", d: "M24 21.8H10v-3.6h14v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React125.createElement("path", { fillRule: "evenodd", d: "M38 29.8H10v-3.6h28v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckFront72.tsx
import * as React126 from "react";
var componentNameString121 = "FeatureCheckFront72";
function FeatureCheckFront72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString121,
    ...props
  });
  return /* @__PURE__ */ React126.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React126.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React126.createElement("path", { fillRule: "evenodd", d: "M7 52h58V20H7v32zm63 5V15H2v42h68z", clipRule: "evenodd" }), /* @__PURE__ */ React126.createElement("path", { fillRule: "evenodd", d: "M36 32.5H15v-5h21v5z", clipRule: "evenodd" }), /* @__PURE__ */ React126.createElement("path", { fillRule: "evenodd", d: "M57 44.5H15v-5h42v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckFrontWithSignature24.tsx
import * as React127 from "react";
var componentNameString122 = "FeatureCheckFrontWithSignature24";
function FeatureCheckFrontWithSignature24({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString122,
    ...props
  });
  return /* @__PURE__ */ React127.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React127.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React127.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.2 14.6C14.8156 14.0874 14 14.3593 14 15H12C12 12.4373 15.2624 11.3498 16.8 13.4C17.1844 13.9125 18 13.6406 18 13H20C20 15.5627 16.7376 16.6501 15.2 14.6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React127.createElement("path", { fillRule: "evenodd", d: "M3 17L21 17L21 7L3 7L3 17ZM23 19L23 5L1 5L1 19L23 19Z", clipRule: "evenodd" }), /* @__PURE__ */ React127.createElement("path", { fillRule: "evenodd", d: "M12 11L5 11L5 9L12 9V11Z", clipRule: "evenodd" }), /* @__PURE__ */ React127.createElement("path", { fillRule: "evenodd", d: "M10 15L5 15L5 13L10 13V15Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckFrontWithSignature48.tsx
import * as React128 from "react";
var componentNameString123 = "FeatureCheckFrontWithSignature48";
function FeatureCheckFrontWithSignature48({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString123,
    ...props
  });
  return /* @__PURE__ */ React128.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React128.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React128.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M30.6 29c-1-1.2-2.9-.5-2.9 1h-3.4a5 5 0 019.1-3c1 1.2 2.9.5 2.9-1h3.5a5 5 0 01-9.2 3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React128.createElement("path", { fillRule: "evenodd", d: "M4.8 34.5h38.4v-21H4.8v21zM46.7 38V10H1.3v28h45.4z", clipRule: "evenodd" }), /* @__PURE__ */ React128.createElement("path", { fillRule: "evenodd", d: "M24 21.8H10v-3.6h14v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React128.createElement("path", { fillRule: "evenodd", d: "M20 29.8H10v-3.6h10v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckFrontWithSignature72.tsx
import * as React129 from "react";
var componentNameString124 = "FeatureCheckFrontWithSignature72";
function FeatureCheckFrontWithSignature72({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString124,
    ...props
  });
  return /* @__PURE__ */ React129.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React129.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React129.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M46 43.5c-1.4-2-4.5-.9-4.5 1.5h-5A7.5 7.5 0 0150 40.5c1.4 2 4.5.9 4.5-1.5h5A7.5 7.5 0 0146 43.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React129.createElement("path", { fillRule: "evenodd", d: "M7 52h58V20H7v32zm63 5V15H2v42h68z", clipRule: "evenodd" }), /* @__PURE__ */ React129.createElement("path", { fillRule: "evenodd", d: "M36 32.5H15v-5h21v5z", clipRule: "evenodd" }), /* @__PURE__ */ React129.createElement("path", { fillRule: "evenodd", d: "M30 44.5H15v-5h15v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckmark24.tsx
import * as React130 from "react";
var componentNameString125 = "FeatureCheckmark24";
function FeatureCheckmark24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString125,
    ...props
  });
  return /* @__PURE__ */ React130.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React130.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React130.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.7072 6.70718L9.00008 18.4143L3.29297 12.7072L4.70718 11.293L9.00008 15.5859L19.293 5.29297L20.7072 6.70718Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCheckmark48.tsx
import * as React131 from "react";
var componentNameString126 = "FeatureCheckmark48";
function FeatureCheckmark48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString126,
    ...props
  });
  return /* @__PURE__ */ React131.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React131.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React131.createElement("path", { fillRule: "evenodd", d: "M41.2 13.2L18 36.5 6.8 25.2l2.4-2.4 8.8 8.7 20.8-20.7 2.4 2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckmark72.tsx
import * as React132 from "react";
var componentNameString127 = "FeatureCheckmark72";
function FeatureCheckmark72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString127,
    ...props
  });
  return /* @__PURE__ */ React132.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React132.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React132.createElement("path", { fillRule: "evenodd", d: "M61.8 19.8L27 54.5 10.2 37.8l3.6-3.6L27 47.5l31.2-31.3 3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCheckmarkFilledCircle48.tsx
import * as React133 from "react";
var componentNameString128 = "FeatureCheckmarkFilledCircle48";
function FeatureCheckmarkFilledCircle48({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString128,
    ...props
  });
  return /* @__PURE__ */ React133.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React133.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React133.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44ZM20.0002 32.8286L33.4144 19.4144L30.5859 16.5859L20.0002 27.1717L16.4144 23.5859L13.5859 26.4144L20.0002 32.8286Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCheckmarkFilledCircle72.tsx
import * as React134 from "react";
var componentNameString129 = "FeatureCheckmarkFilledCircle72";
function FeatureCheckmarkFilledCircle72({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString129,
    ...props
  });
  return /* @__PURE__ */ React134.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React134.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React134.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 66C52.5685 66 66 52.5685 66 36C66 19.4315 52.5685 6 36 6C19.4315 6 6 19.4315 6 36C6 52.5685 19.4315 66 36 66ZM30.0002 49.2429L50.1215 29.1215L45.8789 24.8789L30.0002 40.7576L24.6215 35.3789L20.3789 39.6215L30.0002 49.2429Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCheckmarkInCircle24.tsx
import * as React135 from "react";
var componentNameString130 = "FeatureCheckmarkInCircle24";
function FeatureCheckmarkInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString130,
    ...props
  });
  return /* @__PURE__ */ React135.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React135.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React135.createElement("path", { d: "M10 16.4143L16.7071 9.70718L15.2929 8.29297L10 13.5859L8.20712 11.793L6.79291 13.2072L10 16.4143Z" }), /* @__PURE__ */ React135.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCheckmarkInCircle48.tsx
import * as React136 from "react";
var componentNameString131 = "FeatureCheckmarkInCircle48";
function FeatureCheckmarkInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString131,
    ...props
  });
  return /* @__PURE__ */ React136.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React136.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React136.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React136.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M33.6 19.2L20.3 32.5l-6.2-6.3 2.5-2.4 3.7 3.7 10.8-10.7 2.5 2.4z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCheckmarkInCircle72.tsx
import * as React137 from "react";
var componentNameString132 = "FeatureCheckmarkInCircle72";
function FeatureCheckmarkInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString132,
    ...props
  });
  return /* @__PURE__ */ React137.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React137.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React137.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React137.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M50.3 28.8L30.5 48.5l-9.3-9.2 3.6-3.6 5.7 5.8 16.2-16.3 3.6 3.6z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCheckmarkInFilledCircle24.tsx
import * as React138 from "react";
var componentNameString133 = "FeatureCheckmarkInFilledCircle24";
function FeatureCheckmarkInFilledCircle24({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString133,
    ...props
  });
  return /* @__PURE__ */ React138.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React138.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React138.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.0001 16.4143L16.7072 9.70718L15.293 8.29297L10.0001 13.5859L8.20718 11.793L6.79297 13.2072L10.0001 16.4143Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCheckmark.tsx
import * as React139 from "react";
var componentNameString134 = "FeatureCheckmark";
function FeatureCheckmark({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString134,
    ...props
  });
  return /* @__PURE__ */ React139.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React139.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React139.createElement(
    "polygon",
    {
      points: "39.811 2 19.212 31.417 5.736 21.982 0 30.173 21.668 45.345 48.002 7.736",
      className: "sc-Icon--secondary-color"
    }
  ), /* @__PURE__ */ React139.createElement("path", { d: "M48 40.3a5 5 0 11-10 0 5 5 0 0110 0" }));
}

// src/components/icons/FeatureChildren24.tsx
import * as React140 from "react";
var componentNameString135 = "FeatureChildren24";
function FeatureChildren24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString135,
    ...props
  });
  return /* @__PURE__ */ React140.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React140.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React140.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13ZM9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React140.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5C16 18.3284 16.6716 19 17.5 19ZM17.5 21C19.433 21 21 19.433 21 17.5C21 15.567 19.433 14 17.5 14C15.567 14 14 15.567 14 17.5C14 19.433 15.567 21 17.5 21Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React140.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.2928 16.7072L12.2928 13.7072L13.7071 12.293L16.7071 15.293L15.2928 16.7072Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React140.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.7071 5.70703L5.70706 13.707L4.29285 12.2928L12.2928 4.29282L13.7071 5.70703Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureChildren48.tsx
import * as React141 from "react";
var componentNameString136 = "FeatureChildren48";
function FeatureChildren48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString136,
    ...props
  });
  return /* @__PURE__ */ React141.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React141.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React141.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 26.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0 3.5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React141.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M35 38.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 3.5a7 7 0 100-14 7 7 0 000 14z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React141.createElement("path", { fillRule: "evenodd", d: "M30.8 33.2l-6-6 2.4-2.4 6 6-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React141.createElement("path", { fillRule: "evenodd", d: "M27.2 11.2l-16 16-2.4-2.4 16-16 2.4 2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureChildren72.tsx
import * as React142 from "react";
var componentNameString137 = "FeatureChildren72";
function FeatureChildren72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString137,
    ...props
  });
  return /* @__PURE__ */ React142.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React142.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React142.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M27 40a13 13 0 100-26 13 13 0 000 26zm0 5a18 18 0 100-36 18 18 0 000 36z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React142.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M52.5 58a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0 5a10.5 10.5 0 100-21 10.5 10.5 0 000 21z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React142.createElement("path", { fillRule: "evenodd", d: "M46.2 49.8l-9-9 3.6-3.6 9 9-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React142.createElement("path", { fillRule: "evenodd", d: "M40.8 16.8l-24 24-3.6-3.6 24-24 3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCircle24.tsx
import * as React143 from "react";
var componentNameString138 = "FeatureCircle24";
function FeatureCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString138,
    ...props
  });
  return /* @__PURE__ */ React143.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React143.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React143.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCircle48.tsx
import * as React144 from "react";
var componentNameString139 = "FeatureCircle48";
function FeatureCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString139,
    ...props
  });
  return /* @__PURE__ */ React144.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React144.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React144.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCircle72.tsx
import * as React145 from "react";
var componentNameString140 = "FeatureCircle72";
function FeatureCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString140,
    ...props
  });
  return /* @__PURE__ */ React145.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React145.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React145.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCircleArrowsPlus.tsx
import * as React146 from "react";
var componentNameString141 = "FeatureCircleArrowsPlus";
function FeatureCircleArrowsPlus({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString141,
    ...props
  });
  return /* @__PURE__ */ React146.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React146.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React146.createElement("path", { d: "M0 24A24 24 0 0110.2 4.2L7.8 0H24l-8.3 14-3-5.5C8.3 11.8 6 18.1 6 24a18 18 0 0014.8 17.7L17.6 47A24 24 0 010 24z" }), /* @__PURE__ */ React146.createElement("path", { d: "M48 24a24 24 0 01-10.2 19.7l2.4 4.3H24l8.3-14 3 5.5C39.7 36.2 42 29.9 42 24A18 18 0 0027.2 6.4L30.4 1A24 24 0 0148 24zm-21-9v6h6v6h-6v6h-6v-6h-6v-6h6v-6h6z" }));
}

// src/components/icons/FeatureCircleArrows.tsx
import * as React147 from "react";
var componentNameString142 = "FeatureCircleArrows";
function FeatureCircleArrows({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString142,
    ...props
  });
  return /* @__PURE__ */ React147.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React147.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React147.createElement("path", { d: "M10.2 4.3L7.8 0H24l-8.3 14-3-5.4C8.3 11.9 6 18 6 24a18 18 0 0014.8 17.7l-3.1 5.4a24 24 0 01-7.5-42.8z" }), /* @__PURE__ */ React147.createElement("path", { d: "M48 24a24 24 0 01-10.2 19.7l2.4 4.3H24l8.3-14 3 5.4C39.7 36.1 42 30 42 24A18 18 0 0027.2 6.3L30.3.9A24 24 0 0148 24" }));
}

// src/components/icons/FeatureClock.tsx
import * as React148 from "react";
var componentNameString143 = "FeatureClock";
function FeatureClock({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString143,
    ...props
  });
  return /* @__PURE__ */ React148.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React148.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React148.createElement("path", { d: "M27 42a18 18 0 010-36V0a24 24 0 1017 41l-4.3-4.3A18 18 0 0127 42" }), /* @__PURE__ */ React148.createElement("path", { d: "M27 6v18l12.7 12.7A18 18 0 0027 6z" }));
}

// src/components/icons/FeatureCompass24.tsx
import * as React149 from "react";
var componentNameString144 = "FeatureCompass24";
function FeatureCompass24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString144,
    ...props
  });
  return /* @__PURE__ */ React149.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React149.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React149.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.655 5.39803C14.8753 4.98056 15 4.50484 15 4C15 2.34315 13.6569 1 12 1C10.3431 1 9 2.34315 9 4C9 4.50484 9.1247 4.98056 9.34498 5.39803C5.67037 6.53089 3 9.9536 3 14C3 18.9706 7.02944 23 12 23C16.9706 23 21 18.9706 21 14C21 9.9536 18.3296 6.53089 14.655 5.39803ZM13 4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4ZM12 7C8.13401 7 5 10.134 5 14C5 15.9228 5.77523 17.6645 7.03018 18.9296L10 12L16.9296 9.03018C15.6645 7.77523 13.9228 7 12 7ZM12 21C15.866 21 19 17.866 19 14C19 12.0772 18.2248 10.3355 16.9698 9.07041L14 16L7.07041 18.9698C8.33554 20.2248 10.0772 21 12 21ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCompass48.tsx
import * as React150 from "react";
var componentNameString145 = "FeatureCompass48";
function FeatureCompass48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString145,
    ...props
  });
  return /* @__PURE__ */ React150.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React150.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React150.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M27.9991 12.473C29.2271 11.3744 30 9.77744 30 8C30 4.68629 27.3137 2 24 2C20.6863 2 18 4.68629 18 8C18 9.77744 18.7729 11.3744 20.0009 12.473C12.5417 14.2715 7 20.9886 7 29C7 38.3888 14.6112 46 24 46C33.3888 46 41 38.3888 41 29C41 20.9886 35.4583 14.2715 27.9991 12.473ZM24 10.5C25.3807 10.5 26.5 9.38071 26.5 8C26.5 6.61929 25.3807 5.5 24 5.5C22.6193 5.5 21.5 6.61929 21.5 8C21.5 9.38071 22.6193 10.5 24 10.5ZM33.4216 19.3313L27.7779 32.5001L14.5557 38.1667L20.2223 24.9445L33.3904 19.301C30.9607 16.9481 27.6495 15.5 24 15.5C16.5442 15.5 10.5 21.5442 10.5 29C10.5 36.4558 16.5442 42.5 24 42.5C31.4558 42.5 37.5 36.4558 37.5 29C37.5 25.2092 35.9376 21.7834 33.4216 19.3313ZM24.0001 30.6112C25.0433 30.6112 25.889 29.7655 25.889 28.7223C25.889 27.6791 25.0433 26.8334 24.0001 26.8334C22.9569 26.8334 22.1112 27.6791 22.1112 28.7223C22.1112 29.7655 22.9569 30.6112 24.0001 30.6112Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCompass72.tsx
import * as React151 from "react";
var componentNameString146 = "FeatureCompass72";
function FeatureCompass72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString146,
    ...props
  });
  return /* @__PURE__ */ React151.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React151.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React151.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.1113 56.8336L41.5559 48.5001L49.8892 29.0557L30.4448 37.389L22.1113 56.8336ZM33.2226 42.9447C33.2226 42.1777 33.5336 41.4831 34.0363 40.9805C34.5389 40.4778 35.2333 40.1669 36.0004 40.1669C37.5345 40.1669 38.7782 41.4106 38.7782 42.9447C38.7782 43.7117 38.4673 44.4062 37.9646 44.9088C37.4619 45.4115 36.7674 45.7225 36.0004 45.7225C34.4663 45.7225 33.2226 44.4788 33.2226 42.9447Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React151.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M42.772 18.9281C44.1592 17.3446 45 15.2705 45 13C45 8.02944 40.9706 4 36 4C31.0294 4 27 8.02944 27 13C27 15.2705 27.8408 17.3446 29.228 18.9281C18.7112 21.8806 11 31.5398 11 43C11 56.8071 22.1929 68 36 68C49.8071 68 61 56.8071 61 43C61 31.5398 53.2888 21.8806 42.772 18.9281ZM36 17C38.2091 17 40 15.2091 40 13C40 10.7909 38.2091 9 36 9C33.7909 9 32 10.7909 32 13C32 15.2091 33.7909 17 36 17ZM56 43C56 54.0457 47.0457 63 36 63C24.9543 63 16 54.0457 16 43C16 31.9543 24.9543 23 36 23C47.0457 23 56 31.9543 56 43Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCopy24.tsx
import * as React152 from "react";
var componentNameString147 = "FeatureCopy24";
function FeatureCopy24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString147,
    ...props
  });
  return /* @__PURE__ */ React152.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React152.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React152.createElement("path", { d: "M15 4H5V16H3V2H15V4Z" }), /* @__PURE__ */ React152.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7 22V6.00005H15.1716C15.702 6.00005 16.2107 6.21076 16.5858 6.58583L20.4142 10.4143C20.7893 10.7893 21 11.298 21 11.8285V22H7ZM15 8.00005V12H19L19 20H9V8.00005L15 8.00005Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureCopy48.tsx
import * as React153 from "react";
var componentNameString148 = "FeatureCopy48";
function FeatureCopy48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString148,
    ...props
  });
  return /* @__PURE__ */ React153.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React153.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React153.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32.6 12.6a2 2 0 00-1.4-.6H14v32h28V22.8c0-.5-.2-1-.6-1.4l-8.8-8.8zm5.9 27.9v-17l-8-8h-13v25h21z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React153.createElement("path", { d: "M30 24V14l10 10H30z" }), /* @__PURE__ */ React153.createElement("path", { fillRule: "evenodd", d: "M6.3 4.3H30v3.5H9.7V32H6.3V4.2z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureCopy72.tsx
import * as React154 from "react";
var componentNameString149 = "FeatureCopy72";
function FeatureCopy72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString149,
    ...props
  });
  return /* @__PURE__ */ React154.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React154.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React154.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21 66V18h26.2c.5 0 1 .2 1.4.6l13.8 13.8c.4.4.6.9.6 1.4V66H21zm37-5V35L46 23H26v38h32z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React154.createElement("path", { d: "M45 36V21l15 15H45z" }), /* @__PURE__ */ React154.createElement("path", { fillRule: "evenodd", d: "M9.5 6.5H45v5H14.5V48h-5V6.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDeposit24.tsx
import * as React155 from "react";
var componentNameString150 = "FeatureDeposit24";
function FeatureDeposit24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString150,
    ...props
  });
  return /* @__PURE__ */ React155.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React155.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React155.createElement("path", { fillRule: "evenodd", d: "M20 20L20 4L22 4L22 20L20 20Z", clipRule: "evenodd" }), /* @__PURE__ */ React155.createElement("path", { fillRule: "evenodd", d: "M16 13L2 13L2 11L16 11L16 13Z", clipRule: "evenodd" }), /* @__PURE__ */ React155.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.4141 12L11.707 18.7071L10.2927 17.2929L15.5856 12L10.2927 6.70711L11.707 5.29289L18.4141 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDeposit48.tsx
import * as React156 from "react";
var componentNameString151 = "FeatureDeposit48";
function FeatureDeposit48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString151,
    ...props
  });
  return /* @__PURE__ */ React156.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React156.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React156.createElement("path", { fillRule: "evenodd", d: "M40.25 40L40.25 8L43.75 8L43.75 40L40.25 40Z", clipRule: "evenodd" }), /* @__PURE__ */ React156.createElement("path", { fillRule: "evenodd", d: "M32 25.75L4 25.75L4 22.25L32 22.25L32 25.75Z", clipRule: "evenodd" }), /* @__PURE__ */ React156.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36.4746 24L23.2372 37.2374L20.7623 34.7626L31.5249 24L20.7623 13.2374L23.2372 10.7626L36.4746 24Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDeposit72.tsx
import * as React157 from "react";
var componentNameString152 = "FeatureDeposit72";
function FeatureDeposit72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString152,
    ...props
  });
  return /* @__PURE__ */ React157.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React157.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React157.createElement("path", { fillRule: "evenodd", d: "M60.5 60L60.5 12L65.5 12L65.5 60L60.5 60Z", clipRule: "evenodd" }), /* @__PURE__ */ React157.createElement("path", { fillRule: "evenodd", d: "M48 38.5L6 38.5L6 33.5L48 33.5L48 38.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React157.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54.5356 36L34.7679 55.7678L31.2323 52.2322L47.4646 36L31.2323 19.7678L34.7679 16.2322L54.5356 36Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDepositCheck24.tsx
import * as React158 from "react";
var componentNameString153 = "FeatureDepositCheck24";
function FeatureDepositCheck24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString153,
    ...props
  });
  return /* @__PURE__ */ React158.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React158.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React158.createElement("path", { d: "M23 1L23 15H15V13H21L21 3L3 3L3 13L9 13V15L1 15L1 1L23 1Z" }), /* @__PURE__ */ React158.createElement("path", { d: "M12 7H5V5H12V7Z" }), /* @__PURE__ */ React158.createElement("path", { d: "M5 11H19V9H5V11Z" }), /* @__PURE__ */ React158.createElement("path", { d: "M11 19.5859V13H13V19.6269L15.2866 17.2994L16.7133 18.701L12.0418 23.4561L7.29289 18.7072L8.70711 17.293L11 19.5859Z" }));
}

// src/components/icons/FeatureDepositCheck48.tsx
import * as React159 from "react";
var componentNameString154 = "FeatureDepositCheck48";
function FeatureDepositCheck48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString154,
    ...props
  });
  return /* @__PURE__ */ React159.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React159.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React159.createElement("path", { fillRule: "evenodd", d: "M45.8 29.8H30v-3.6h12.3V5.8H5.8v20.6H18v3.4H2.3V2.4h43.4v27.4z", clipRule: "evenodd" }), /* @__PURE__ */ React159.createElement("path", { fillRule: "evenodd", d: "M24 13.8H10v-3.6h14v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React159.createElement("path", { fillRule: "evenodd", d: "M38 21.8H10v-3.6h28v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React159.createElement("path", { fillRule: "evenodd", d: "M22.3 42V26h3.4v16h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React159.createElement("path", { fillRule: "evenodd", d: "M24 46.6l-9.2-9.4 2.4-2.4 6.9 6.8 6.7-6.8 2.4 2.4-9.1 9.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDepositCheck72.tsx
import * as React160 from "react";
var componentNameString155 = "FeatureDepositCheck72";
function FeatureDepositCheck72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString155,
    ...props
  });
  return /* @__PURE__ */ React160.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React160.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React160.createElement("path", { fillRule: "evenodd", d: "M68.5 44.5H45v-5h18.5v-31h-55v31H27v5H3.5v-41h65v41z", clipRule: "evenodd" }), /* @__PURE__ */ React160.createElement("path", { fillRule: "evenodd", d: "M36 20.5H15v-5h21v5z", clipRule: "evenodd" }), /* @__PURE__ */ React160.createElement("path", { fillRule: "evenodd", d: "M57 32.5H15v-5h42v5z", clipRule: "evenodd" }), /* @__PURE__ */ React160.createElement("path", { fillRule: "evenodd", d: "M33.5 63V39h5v24h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React160.createElement("path", { fillRule: "evenodd", d: "M36.1 69.7l-13.9-14 3.6-3.5L36 62.6l10.1-10.4 3.6 3.6L36 69.7z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDining24.tsx
import * as React161 from "react";
var componentNameString156 = "FeatureDining24";
function FeatureDining24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString156,
    ...props
  });
  return /* @__PURE__ */ React161.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React161.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React161.createElement("path", { d: "M6 2H4V8C4 9.10457 4.89543 10 6 10H7V22H9V10H10C11.1046 10 12 9.10457 12 8V2H10V8H9V2H7V8H6V2Z" }), /* @__PURE__ */ React161.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 2.10002C18.3231 2.03443 18.6575 2 19 2H20V22H18V16H14V7C14 4.58104 15.7178 2.56329 18 2.10002ZM18 4.17071V14H16V7C16 5.69378 16.8348 4.58254 18 4.17071Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDining48.tsx
import * as React162 from "react";
var componentNameString157 = "FeatureDining48";
function FeatureDining48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString157,
    ...props
  });
  return /* @__PURE__ */ React162.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React162.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React162.createElement("path", { d: "M8.25 16V4H11.75V16C11.75 16.6904 12.3096 17.25 13 17.25H14V4H18V17.25H19C19.6904 17.25 20.25 16.6904 20.25 16V4H23.75V16C23.75 18.6234 21.6234 20.75 19 20.75H18L18 44H14L14 20.75H13C10.3766 20.75 8.25 18.6234 8.25 16Z" }), /* @__PURE__ */ React162.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34.5 4.1404C34.9859 4.04823 35.4873 4 36 4H38V44H34V30H28V12C28 8.09442 30.7987 4.84251 34.5 4.1404ZM31.5 26.5V12C31.5 10.0407 32.7522 8.37381 34.5 7.75606V26.5H31.5Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDining72.tsx
import * as React163 from "react";
var componentNameString158 = "FeatureDining72";
function FeatureDining72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString158,
    ...props
  });
  return /* @__PURE__ */ React163.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React163.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React163.createElement("path", { d: "M12 25V6H17V25C17 25.2761 17.2239 25.5 17.5 25.5H21V6H26V25.5H30.5C30.7761 25.5 31 25.2761 31 25V6H36V25C36 28.0376 33.5376 30.5 30.5 30.5H26L26 66H21L21 30.5H17.5C14.4624 30.5 12 28.0376 12 25Z" }), /* @__PURE__ */ React163.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M52 6.85353C53.5639 6.30077 55.2468 6 57 6V66H52V45H42V21C42 14.4689 46.174 8.91271 52 6.85353ZM52 12.3378C49.011 14.0669 47 17.2986 47 21V40H52V12.3378Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDirectDeposit24.tsx
import * as React164 from "react";
var componentNameString159 = "FeatureDirectDeposit24";
function FeatureDirectDeposit24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString159,
    ...props
  });
  return /* @__PURE__ */ React164.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React164.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React164.createElement("path", { fillRule: "evenodd", d: "M20 20L20 4L22 4L22 20L20 20Z", clipRule: "evenodd" }), /* @__PURE__ */ React164.createElement("path", { fillRule: "evenodd", d: "M12 13L2 13L2 11L12 11L12 13Z", clipRule: "evenodd" }), /* @__PURE__ */ React164.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.4141 12L11.707 18.7071L10.2927 17.2929L15.5856 12L10.2927 6.70711L11.707 5.29289L18.4141 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React164.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.4141 12L6.70695 18.7071L5.29274 17.2929L10.5856 12L5.29274 6.70711L6.70696 5.29289L13.4141 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDirectDeposit48.tsx
import * as React165 from "react";
var componentNameString160 = "FeatureDirectDeposit48";
function FeatureDirectDeposit48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString160,
    ...props
  });
  return /* @__PURE__ */ React165.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React165.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React165.createElement("path", { fillRule: "evenodd", d: "M40.25 40L40.25 8L43.75 8L43.75 40L40.25 40Z", clipRule: "evenodd" }), /* @__PURE__ */ React165.createElement("path", { fillRule: "evenodd", d: "M24 25.75L4 25.75L4 22.25L24 22.25L24 25.75Z", clipRule: "evenodd" }), /* @__PURE__ */ React165.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36.4746 24L23.2372 37.2374L20.7623 34.7626L31.5249 24L20.7623 13.2374L23.2372 10.7626L36.4746 24Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React165.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M26.4746 24L13.2372 37.2374L10.7623 34.7626L21.5249 24L10.7623 13.2374L13.2372 10.7626L26.4746 24Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDirectDeposit72.tsx
import * as React166 from "react";
var componentNameString161 = "FeatureDirectDeposit72";
function FeatureDirectDeposit72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString161,
    ...props
  });
  return /* @__PURE__ */ React166.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React166.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React166.createElement("path", { fillRule: "evenodd", d: "M60.5 60L60.5 12L65.5 12L65.5 60L60.5 60Z", clipRule: "evenodd" }), /* @__PURE__ */ React166.createElement("path", { fillRule: "evenodd", d: "M36 38.5L6 38.5L6 33.5L36 33.5L36 38.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React166.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54.5356 36L34.7679 55.7678L31.2323 52.2322L47.4646 36L31.2323 19.7678L34.7679 16.2322L54.5356 36Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React166.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M39.5356 36L19.7679 55.7678L16.2323 52.2322L32.4646 36L16.2323 19.7678L19.7679 16.2322L39.5356 36Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocument24.tsx
import * as React167 from "react";
var componentNameString162 = "FeatureDocument24";
function FeatureDocument24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString162,
    ...props
  });
  return /* @__PURE__ */ React167.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React167.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React167.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.1716 2C13.702 2 14.2107 2.21071 14.5858 2.58579L19.4142 7.41421C19.7893 7.78929 20 8.29799 20 8.82843V22H4V2H13.1716ZM18 9L18 20H6V4H13V9H18Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocument48.tsx
import * as React168 from "react";
var componentNameString163 = "FeatureDocument48";
function FeatureDocument48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString163,
    ...props
  });
  return /* @__PURE__ */ React168.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React168.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React168.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 44V4h19.2c.5 0 1 .2 1.4.6l10.8 10.8c.4.4.6.9.6 1.4V44H8zm28.5-3.5v-23l-10-10h-15v33h25z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React168.createElement("path", { d: "M26 18V6l12 12H26z" }));
}

// src/components/icons/FeatureDocument72.tsx
import * as React169 from "react";
var componentNameString164 = "FeatureDocument72";
function FeatureDocument72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString164,
    ...props
  });
  return /* @__PURE__ */ React169.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React169.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React169.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 66V6h29.2c.5 0 1 .2 1.4.6l16.8 16.8c.4.4.6.9.6 1.4V66H12zm43-5V26L40 11H17v50h38z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React169.createElement("path", { d: "M39 27V9l18 18H39z" }));
}

// src/components/icons/FeatureDocumentComplete24.tsx
import * as React170 from "react";
var componentNameString165 = "FeatureDocumentComplete24";
function FeatureDocumentComplete24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString165,
    ...props
  });
  return /* @__PURE__ */ React170.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React170.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React170.createElement("path", { d: "M11 18.4142L16.7071 12.7071L15.2929 11.2929L11 15.5858L9.20712 13.7929L7.79291 15.2071L11 18.4142Z" }), /* @__PURE__ */ React170.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2H4V22H20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579ZM18 20L18 9H13V4H6V20H18Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocumentComplete48.tsx
import * as React171 from "react";
var componentNameString166 = "FeatureDocumentComplete48";
function FeatureDocumentComplete48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString166,
    ...props
  });
  return /* @__PURE__ */ React171.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React171.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React171.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 44V4h19.2c.5 0 1 .2 1.4.6l10.8 10.8c.4.4.6.9.6 1.4V44H8zm28.5-3.5v-23l-10-10h-15v33h25z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React171.createElement("path", { d: "M26 18V6l12 12H26z" }), /* @__PURE__ */ React171.createElement("path", { fillRule: "evenodd", d: "M30.8 22.8l2.4 2.4L22 36.5l-6.2-6.3 2.4-2.4 3.8 3.7 8.8-8.7z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDocumentComplete72.tsx
import * as React172 from "react";
var componentNameString167 = "FeatureDocumentComplete72";
function FeatureDocumentComplete72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString167,
    ...props
  });
  return /* @__PURE__ */ React172.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React172.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React172.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 66V6h29.2c.5 0 1 .2 1.4.6l16.8 16.8c.4.4.6.9.6 1.4V66H12zm43-5V26L40 11H17v50h38z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React172.createElement("path", { d: "M39 27V9l18 18H39z" }), /* @__PURE__ */ React172.createElement("path", { fillRule: "evenodd", d: "M49.8 37.8L33 54.5l-9.3-9.2 3.6-3.6 5.7 5.8 13.2-13.3 3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDocumentFilled24.tsx
import * as React173 from "react";
var componentNameString168 = "FeatureDocumentFilled24";
function FeatureDocumentFilled24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString168,
    ...props
  });
  return /* @__PURE__ */ React173.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React173.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React173.createElement("path", { d: "M16 14H8V12H16V14Z" }), /* @__PURE__ */ React173.createElement("path", { d: "M8 18H16V16H8V18Z" }), /* @__PURE__ */ React173.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.1716 2C13.702 2 14.2107 2.21071 14.5858 2.58579L19.4142 7.41421C19.7893 7.78929 20 8.29799 20 8.82843V22H4V2H13.1716ZM18 9L18 20H6V4H13V9H18Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocumentFilled48.tsx
import * as React174 from "react";
var componentNameString169 = "FeatureDocumentFilled48";
function FeatureDocumentFilled48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString169,
    ...props
  });
  return /* @__PURE__ */ React174.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React174.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React174.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 44V4h19.2c.5 0 1 .2 1.4.6l10.8 10.8c.4.4.6.9.6 1.4V44H8zm28.5-3.5v-23l-10-10h-15v33h25z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React174.createElement("path", { d: "M26 18V6l12 12H26z" }), /* @__PURE__ */ React174.createElement("path", { fillRule: "evenodd", d: "M32 27.8H16v-3.6h16v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React174.createElement("path", { fillRule: "evenodd", d: "M32 35.8H16v-3.5h16v3.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDocumentFilled72.tsx
import * as React175 from "react";
var componentNameString170 = "FeatureDocumentFilled72";
function FeatureDocumentFilled72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString170,
    ...props
  });
  return /* @__PURE__ */ React175.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React175.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React175.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 66V6h29.2c.5 0 1 .2 1.4.6l16.8 16.8c.4.4.6.9.6 1.4V66H12zm43-5V26L40 11H17v50h38z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React175.createElement("path", { d: "M39 27V9l18 18H39z" }), /* @__PURE__ */ React175.createElement("path", { fillRule: "evenodd", d: "M48 41.5H24v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React175.createElement("path", { fillRule: "evenodd", d: "M48 53.5H24v-5h24v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDocumentPlus24.tsx
import * as React176 from "react";
var componentNameString171 = "FeatureDocumentPlus24";
function FeatureDocumentPlus24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString171,
    ...props
  });
  return /* @__PURE__ */ React176.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React176.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React176.createElement("path", { d: "M13 16V19H11V16H8V14H11V11H13V14H16V16H13Z" }), /* @__PURE__ */ React176.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.1716 2C13.702 2 14.2107 2.21071 14.5858 2.58579L19.4142 7.41421C19.7893 7.78929 20 8.29799 20 8.82843V22H4V2H13.1716ZM18 9L18 20H6V4H13V9H18Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocumentPlus48.tsx
import * as React177 from "react";
var componentNameString172 = "FeatureDocumentPlus48";
function FeatureDocumentPlus48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString172,
    ...props
  });
  return /* @__PURE__ */ React177.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React177.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React177.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 44V4h19.2c.5 0 1 .2 1.4.6l10.8 10.8c.4.4.6.9.6 1.4V44H8zm28.5-3.5v-23l-10-10h-15v33h25z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React177.createElement("path", { d: "M26 18V6l12 12H26z" }), /* @__PURE__ */ React177.createElement("path", { fillRule: "evenodd", d: "M25.8 22v16h-3.6V22h3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React177.createElement("path", { fillRule: "evenodd", d: "M32 31.8H16v-3.6h16v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDocumentPlus72.tsx
import * as React178 from "react";
var componentNameString173 = "FeatureDocumentPlus72";
function FeatureDocumentPlus72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString173,
    ...props
  });
  return /* @__PURE__ */ React178.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React178.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React178.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 66V6h29.2c.5 0 1 .2 1.4.6l16.8 16.8c.4.4.6.9.6 1.4V66H12zm43-5V26L40 11H17v50h38z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React178.createElement("path", { d: "M39 27V9l18 18H39z" }), /* @__PURE__ */ React178.createElement("path", { fillRule: "evenodd", d: "M38.5 33v24h-5V33h5z", clipRule: "evenodd" }), /* @__PURE__ */ React178.createElement("path", { fillRule: "evenodd", d: "M48 47.5H24v-5h24v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDocumentReview24.tsx
import * as React179 from "react";
var componentNameString174 = "FeatureDocumentReview24";
function FeatureDocumentReview24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString174,
    ...props
  });
  return /* @__PURE__ */ React179.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React179.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React179.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2H4V22H20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579ZM18 20L18 8.82843L13.1716 4H6V20H18Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React179.createElement("path", { d: "M13 9V3L19 9H13Z" }), /* @__PURE__ */ React179.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.2929 21.7072L13.2929 16.7072L14.7072 15.293L19.7072 20.293L18.2929 21.7072Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React179.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 16C13.1046 16 14 15.1046 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16ZM12 18C14.2091 18 16 16.2091 16 14C16 11.7909 14.2091 10 12 10C9.79086 10 8 11.7909 8 14C8 16.2091 9.79086 18 12 18Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocumentReview48.tsx
import * as React180 from "react";
var componentNameString175 = "FeatureDocumentReview48";
function FeatureDocumentReview48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString175,
    ...props
  });
  return /* @__PURE__ */ React180.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React180.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React180.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 44V4h19.2c.5 0 1 .2 1.4.6l10.8 10.8c.4.4.6.9.6 1.4V44H8zm28.5-3.5v-23l-10-10h-15v33h25z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React180.createElement("path", { d: "M26 18V6l12 12H26z" }), /* @__PURE__ */ React180.createElement("path", { fillRule: "evenodd", d: "M36.8 43.2l-10-10 2.4-2.4 10 10-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React180.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 32.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocumentReview72.tsx
import * as React181 from "react";
var componentNameString176 = "FeatureDocumentReview72";
function FeatureDocumentReview72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString176,
    ...props
  });
  return /* @__PURE__ */ React181.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React181.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React181.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 66V6h29.2c.5 0 1 .2 1.4.6l16.8 16.8c.4.4.6.9.6 1.4V66H12zm43-5V26L40 11H17v50h38z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React181.createElement("path", { d: "M39 27V9l18 18H39z" }), /* @__PURE__ */ React181.createElement("path", { fillRule: "evenodd", d: "M55.2 64.8l-15-15 3.6-3.6 15 15-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React181.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 49a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocuments24.tsx
import * as React182 from "react";
var componentNameString177 = "FeatureDocuments24";
function FeatureDocuments24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString177,
    ...props
  });
  return /* @__PURE__ */ React182.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React182.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React182.createElement("path", { d: "M9 20H19V8H21V22H9V20Z" }), /* @__PURE__ */ React182.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 2V18H17V7.82843C17 7.29799 16.7893 6.78929 16.4142 6.41421L12.5858 2.58579C12.2107 2.21071 11.702 2 11.1716 2H3ZM15 8L15 16H5V4L11 4V8H15Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDocuments48.tsx
import * as React183 from "react";
var componentNameString178 = "FeatureDocuments48";
function FeatureDocuments48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString178,
    ...props
  });
  return /* @__PURE__ */ React183.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React183.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React183.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24.6 4.6a2 2 0 00-1.4-.6H6v32h28V14.8c0-.5-.2-1-.6-1.4l-8.8-8.8zm5.9 27.9v-17l-8-8h-13v25h21z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React183.createElement("path", { fillRule: "evenodd", d: "M38.3 40.3V16h3.5v27.8H18v-3.5h20.3z", clipRule: "evenodd" }), /* @__PURE__ */ React183.createElement("path", { d: "M22 16V6l10 10H22z" }));
}

// src/components/icons/FeatureDocuments72.tsx
import * as React184 from "react";
var componentNameString179 = "FeatureDocuments72";
function FeatureDocuments72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString179,
    ...props
  });
  return /* @__PURE__ */ React184.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React184.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React184.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9 54V6h26.2c.5 0 1 .2 1.4.6l13.8 13.8c.4.4.6.9.6 1.4V54H9zm37-5V23L34 11H14v38h32z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React184.createElement("path", { fillRule: "evenodd", d: "M57.5 60.5V24h5v41.5H27v-5h30.5z", clipRule: "evenodd" }), /* @__PURE__ */ React184.createElement("path", { d: "M33 24V9l15 15H33z" }));
}

// src/components/icons/FeatureDollar24.tsx
import * as React185 from "react";
var componentNameString180 = "FeatureDollar24";
function FeatureDollar24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString180,
    ...props
  });
  return /* @__PURE__ */ React185.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React185.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React185.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11 20V22H13V20H13.5C15.9853 20 18 17.9853 18 15.5C18 13.0147 15.9853 11 13.5 11H13V6H13.5C14.8807 6 16 7.11929 16 8.5H18C18 6.01472 15.9853 4 13.5 4H13V2H11V4H10.5C8.01472 4 6 6.01472 6 8.5C6 10.9853 8.01472 13 10.5 13H11V18H10.5C9.11929 18 8 16.8807 8 15.5H6C6 17.9853 8.01472 20 10.5 20H11ZM13 18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H13V18ZM11 11V6H10.5C9.11929 6 8 7.11929 8 8.5C8 9.88071 9.11929 11 10.5 11H11Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDollar48.tsx
import * as React186 from "react";
var componentNameString181 = "FeatureDollar48";
function FeatureDollar48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString181,
    ...props
  });
  return /* @__PURE__ */ React186.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React186.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React186.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.3 17c0-4.8 3.9-8.8 8.7-8.8h6c4.8 0 8.8 4 8.8 8.8h-3.5c0-2.9-2.4-5.3-5.3-5.3h-6a5.2 5.2 0 100 10.6h6a8.7 8.7 0 110 17.4h-6a8.8 8.8 0 01-8.8-8.7h3.6c0 2.9 2.3 5.3 5.2 5.3h6a5.2 5.2 0 100-10.5h-6c-4.8 0-8.8-4-8.8-8.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React186.createElement("path", { fillRule: "evenodd", d: "M22.3 44V4h3.4v40h-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDollar72.tsx
import * as React187 from "react";
var componentNameString182 = "FeatureDollar72";
function FeatureDollar72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString182,
    ...props
  });
  return /* @__PURE__ */ React187.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React187.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React187.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.5 25.5a13 13 0 0113-13h9a13 13 0 0113 13h-5a8 8 0 00-8-8h-9a8 8 0 100 16h9a13 13 0 010 26h-9a13 13 0 01-13-13h5a8 8 0 008 8h9a8 8 0 100-16h-9a13 13 0 01-13-13z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React187.createElement("path", { fillRule: "evenodd", d: "M33.5 66V6h5v60h-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDollarInCircle24.tsx
import * as React188 from "react";
var componentNameString183 = "FeatureDollarInCircle24";
function FeatureDollarInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString183,
    ...props
  });
  return /* @__PURE__ */ React188.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React188.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React188.createElement("path", { d: "M11 17C9.34315 17 8 15.6569 8 14H10C10 14.5523 10.4477 15 11 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H11C9.34315 13 8 11.6569 8 10C8 8.34315 9.34315 7 11 7V5H13V7C14.6569 7 16 8.34315 16 10H14C14 9.44772 13.5523 9 13 9H11C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11H13C14.6569 11 16 12.3431 16 14C16 15.6569 14.6569 17 13 17V19H11V17Z" }), /* @__PURE__ */ React188.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDollarInCircle48.tsx
import * as React189 from "react";
var componentNameString184 = "FeatureDollarInCircle48";
function FeatureDollarInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString184,
    ...props
  });
  return /* @__PURE__ */ React189.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React189.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React189.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React189.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.3 19.5c0-3.5 2.7-6.3 6.2-6.3h5c3.5 0 6.3 2.8 6.3 6.3h-3.5c0-1.5-1.3-2.8-2.8-2.8h-5a2.7 2.7 0 100 5.6h5a6.2 6.2 0 110 12.4h-5a6.2 6.2 0 01-6.3-6.2h3.6c0 1.5 1.2 2.8 2.7 2.8h5a2.7 2.7 0 100-5.6h-5a6.2 6.2 0 01-6.3-6.2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React189.createElement("path", { fillRule: "evenodd", d: "M22.3 14v-4h3.4v4h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React189.createElement("path", { fillRule: "evenodd", d: "M22.3 38v-4h3.4v4h-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDollarInCircle72.tsx
import * as React190 from "react";
var componentNameString185 = "FeatureDollarInCircle72";
function FeatureDollarInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString185,
    ...props
  });
  return /* @__PURE__ */ React190.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React190.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React190.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React190.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M23.5 29.5c0-5 4-9 9-9h7c5 0 9 4 9 9h-5a4 4 0 00-4-4h-7a4 4 0 000 8h7a9 9 0 110 18h-7c-5 0-9-4-9-9h5a4 4 0 004 4h7a4 4 0 000-8h-7c-5 0-9-4-9-9z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React190.createElement("path", { fillRule: "evenodd", d: "M33.5 21v-5h5v5h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React190.createElement("path", { fillRule: "evenodd", d: "M33.5 56v-5h5v5h-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDollar.tsx
import * as React191 from "react";
var componentNameString186 = "FeatureDollar";
function FeatureDollar({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString186,
    ...props
  });
  return /* @__PURE__ */ React191.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React191.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React191.createElement("path", { d: "M0 38V10h48v28H0zm42-6V16h-9a12 12 0 00-18 0H6v16h9a12 12 0 0018 0h9z" }), /* @__PURE__ */ React191.createElement("path", { d: "M33 24a9 9 0 11-18 0 9 9 0 0118 0" }));
}

// src/components/icons/FeatureDonut24.tsx
import * as React192 from "react";
var componentNameString187 = "FeatureDonut24";
function FeatureDonut24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString187,
    ...props
  });
  return /* @__PURE__ */ React192.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React192.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React192.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 17.917V19.9381C7.05369 19.446 4 16.0796 4 12C4 7.92038 7.05369 4.55399 11 4.06189V6.08296C8.16229 6.55904 6 9.027 6 12C6 14.973 8.16229 17.441 11 17.917ZM19.9381 13H17.917C17.4955 15.5125 15.5125 17.4955 13 17.917V19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13ZM19.9381 11H17.917C17.4955 8.48749 15.5125 6.50448 13 6.08296V4.06189C16.6187 4.51314 19.4869 7.38128 19.9381 11ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDonut48.tsx
import * as React193 from "react";
var componentNameString188 = "FeatureDonut48";
function FeatureDonut48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString188,
    ...props
  });
  return /* @__PURE__ */ React193.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React193.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React193.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React193.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 32.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0 3.5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React193.createElement("path", { fillRule: "evenodd", d: "M22.3 14V6h3.4v8h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React193.createElement("path", { fillRule: "evenodd", d: "M22.3 42v-8h3.4v8h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React193.createElement("path", { fillRule: "evenodd", d: "M34 22.3h8v3.4h-8v-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDonut72.tsx
import * as React194 from "react";
var componentNameString189 = "FeatureDonut72";
function FeatureDonut72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString189,
    ...props
  });
  return /* @__PURE__ */ React194.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React194.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React194.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React194.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 49a13 13 0 100-26 13 13 0 000 26zm0 5a18 18 0 100-36 18 18 0 000 36z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React194.createElement("path", { fillRule: "evenodd", d: "M33.5 21V9h5v12h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React194.createElement("path", { fillRule: "evenodd", d: "M33.5 63V51h5v12h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React194.createElement("path", { fillRule: "evenodd", d: "M51 33.5h12v5H51v-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureDonut.tsx
import * as React195 from "react";
var componentNameString190 = "FeatureDonut";
function FeatureDonut({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString190,
    ...props
  });
  return /* @__PURE__ */ React195.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React195.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React195.createElement("path", { d: "M24 40a16 16 0 01-2-32V0a24 24 0 1017.5 42.2l-5.7-5.7A16 16 0 0124 40" }), /* @__PURE__ */ React195.createElement("path", { d: "M39.9 22A16 16 0 0026 8V0a24 24 0 0121.9 22h-8zm0 4h8c-.4 5-2.4 9.7-5.6 13.4l-5.7-5.7A16 16 0 0040 26z" }));
}

// src/components/icons/FeatureDown24.tsx
import * as React196 from "react";
var componentNameString191 = "FeatureDown24";
function FeatureDown24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString191,
    ...props
  });
  return /* @__PURE__ */ React196.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React196.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React196.createElement("path", { fillRule: "evenodd", d: "M11 18L11 4L13 4L13 18L11 18Z", clipRule: "evenodd" }), /* @__PURE__ */ React196.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 20.4143L5.29289 13.7072L6.7071 12.293L12 17.5859L17.2929 12.293L18.7071 13.7072L12 20.4143Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDown48.tsx
import * as React197 from "react";
var componentNameString192 = "FeatureDown48";
function FeatureDown48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString192,
    ...props
  });
  return /* @__PURE__ */ React197.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React197.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React197.createElement("path", { fillRule: "evenodd", d: "M22.25 36L22.25 8L25.75 8L25.75 36L22.25 36Z", clipRule: "evenodd" }), /* @__PURE__ */ React197.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.4748L10.7626 27.2374L13.2374 24.7625L24 35.5251L34.7626 24.7625L37.2374 27.2374L24 40.4748Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDown72.tsx
import * as React198 from "react";
var componentNameString193 = "FeatureDown72";
function FeatureDown72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString193,
    ...props
  });
  return /* @__PURE__ */ React198.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React198.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React198.createElement("path", { fillRule: "evenodd", d: "M33.5 54L33.5 12L38.5 12L38.5 54L33.5 54Z", clipRule: "evenodd" }), /* @__PURE__ */ React198.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 60.5356L16.2322 40.7679L19.7678 37.2323L36 53.4646L52.2322 37.2323L55.7678 40.7679L36 60.5356Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDownArrowSmall24.tsx
import * as React199 from "react";
var componentNameString194 = "FeatureDownArrowSmall24";
function FeatureDownArrowSmall24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString194,
    ...props
  });
  return /* @__PURE__ */ React199.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React199.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React199.createElement("path", { d: "M13 13.5858L15.2928 11.2929L16.7071 12.7071L12 17.4142L7.29285 12.7071L8.70706 11.2929L11 13.5858L11 7H13L13 13.5858Z" }));
}

// src/components/icons/FeatureDownload24.tsx
import * as React200 from "react";
var componentNameString195 = "FeatureDownload24";
function FeatureDownload24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString195,
    ...props
  });
  return /* @__PURE__ */ React200.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React200.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React200.createElement("path", { fillRule: "evenodd", d: "M4 20L20 20L20 22L4 22L4 20Z", clipRule: "evenodd" }), /* @__PURE__ */ React200.createElement("path", { fillRule: "evenodd", d: "M11 16L11 2L13 2L13 16L11 16Z", clipRule: "evenodd" }), /* @__PURE__ */ React200.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18.4143L5.29289 11.7072L6.7071 10.293L12 15.5859L17.2929 10.293L18.7071 11.7072L12 18.4143Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDownload48.tsx
import * as React201 from "react";
var componentNameString196 = "FeatureDownload48";
function FeatureDownload48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString196,
    ...props
  });
  return /* @__PURE__ */ React201.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React201.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React201.createElement("path", { fillRule: "evenodd", d: "M8 40.25L40 40.25L40 43.75L8 43.75L8 40.25Z", clipRule: "evenodd" }), /* @__PURE__ */ React201.createElement("path", { fillRule: "evenodd", d: "M22.25 32L22.25 4L25.75 4L25.75 32L22.25 32Z", clipRule: "evenodd" }), /* @__PURE__ */ React201.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 36.4748L10.7626 23.2374L13.2374 20.7625L24 31.5251L34.7626 20.7625L37.2374 23.2374L24 36.4748Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureDownload72.tsx
import * as React202 from "react";
var componentNameString197 = "FeatureDownload72";
function FeatureDownload72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString197,
    ...props
  });
  return /* @__PURE__ */ React202.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React202.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React202.createElement("path", { fillRule: "evenodd", d: "M12 60.5L60 60.5L60 65.5L12 65.5L12 60.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React202.createElement("path", { fillRule: "evenodd", d: "M33.5 48L33.5 6L38.5 6L38.5 48L33.5 48Z", clipRule: "evenodd" }), /* @__PURE__ */ React202.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 54.5356L16.2322 34.7679L19.7678 31.2323L36 47.4646L52.2322 31.2323L55.7678 34.7679L36 54.5356Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureEdit24.tsx
import * as React203 from "react";
var componentNameString198 = "FeatureEdit24";
function FeatureEdit24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString198,
    ...props
  });
  return /* @__PURE__ */ React203.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React203.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React203.createElement("path", { d: "M17.7953 9.20988L14.7929 6.2075L5.2071 15.7933L8.21661 18.8028L17.7953 9.20988Z" }), /* @__PURE__ */ React203.createElement("path", { d: "M16.2071 4.79328L16.4994 4.50095C17.3282 3.67221 18.6718 3.67221 19.5006 4.50095C20.3289 5.32925 20.3294 6.67203 19.5017 7.50095L19.2084 7.79461L16.2071 4.79328Z" }), /* @__PURE__ */ React203.createElement("path", { d: "M3 21.0212L3.9175 17.3321L6.68528 20.0999L3 21.0212Z" }));
}

// src/components/icons/FeatureEdit48.tsx
import * as React204 from "react";
var componentNameString199 = "FeatureEdit48";
function FeatureEdit48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString199,
    ...props
  });
  return /* @__PURE__ */ React204.createElement("svg", { viewBox: "0 0 37 38", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React204.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React204.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28.4868 10.5468L26.4795 8.55498L9.25847 25.9099L11.2658 27.9017L28.4868 10.5468ZM26.4604 3.60527L4.30876 25.929L11.2849 32.8514L33.4365 10.5276L26.4604 3.60527Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React204.createElement("path", { d: "M28.5636 1.48788C30.4752 -0.438532 33.5865 -0.450576 35.5129 1.46099C37.4393 3.37255 37.4514 6.48384 35.5398 8.41026L34.8476 9.10788L27.8714 2.1855L28.5636 1.48788Z" }), /* @__PURE__ */ React204.createElement("path", { d: "M0.09375 37.2493L2.64166 27.591L9.73207 34.6267L0.09375 37.2493Z" }));
}

// src/components/icons/FeatureEdit72.tsx
import * as React205 from "react";
var componentNameString200 = "FeatureEdit72";
function FeatureEdit72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString200,
    ...props
  });
  return /* @__PURE__ */ React205.createElement("svg", { viewBox: "0 0 56 57", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React205.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React205.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M43.0837 16.3208L39.7178 12.9809L13.5341 39.3681L16.8999 42.708L43.0837 16.3208ZM39.6905 5.90985L6.46304 39.3955L16.9273 49.7791L50.1547 16.2934L39.6905 5.90985Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React205.createElement("path", { d: "M42.8453 2.73378C45.7127 -0.155845 50.3796 -0.173912 53.2693 2.69343C56.1589 5.56078 56.177 10.2277 53.3096 13.1173L52.2713 14.1638L41.807 3.78021L42.8453 2.73378Z" }), /* @__PURE__ */ React205.createElement("path", { d: "M0.140625 56.3757L3.9625 41.8882L14.5981 52.4418L0.140625 56.3757Z" }));
}

// src/components/icons/FeatureEducation24.tsx
import * as React206 from "react";
var componentNameString201 = "FeatureEducation24";
function FeatureEducation24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString201,
    ...props
  });
  return /* @__PURE__ */ React206.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React206.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React206.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4 4C4 2.89543 4.89543 2 6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4ZM12 4H18V20H6V4H8V12L10 10L12 12V4Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureEducation48.tsx
import * as React207 from "react";
var componentNameString202 = "FeatureEducation48";
function FeatureEducation48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString202,
    ...props
  });
  return /* @__PURE__ */ React207.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React207.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React207.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 7.5H12c-.3 0-.5.2-.5.5v32c0 .3.2.5.5.5h24c.3 0 .5-.2.5-.5V8c0-.3-.2-.5-.5-.5zM12 4a4 4 0 00-4 4v32a4 4 0 004 4h24a4 4 0 004-4V8a4 4 0 00-4-4H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React207.createElement("path", { d: "M16 24V6h8v18l-4-4-4 4z" }), /* @__PURE__ */ React207.createElement("path", { fillRule: "evenodd", d: "M24 24V6h-8v18l4-4 4 4zm-6-4.8l2-2 2 2V8h-4v11.2z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureEducation72.tsx
import * as React208 from "react";
var componentNameString203 = "FeatureEducation72";
function FeatureEducation72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString203,
    ...props
  });
  return /* @__PURE__ */ React208.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React208.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React208.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54 11H18a1 1 0 00-1 1v48c0 .6.4 1 1 1h36c.6 0 1-.4 1-1V12c0-.6-.4-1-1-1zM18 6a6 6 0 00-6 6v48a6 6 0 006 6h36a6 6 0 006-6V12a6 6 0 00-6-6H18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React208.createElement("path", { d: "M24 36V9h12v27l-6-6-6 6z" }), /* @__PURE__ */ React208.createElement("path", { fillRule: "evenodd", d: "M36 36V9H24v27l6-6 6 6zm-10-4.8l4-4 4 4V11h-8v20.2z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureEllipses24.tsx
import * as React209 from "react";
var componentNameString204 = "FeatureEllipses24";
function FeatureEllipses24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString204,
    ...props
  });
  return /* @__PURE__ */ React209.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React209.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React209.createElement("rect", { width: 4, height: 4, x: 3, y: 10 }), /* @__PURE__ */ React209.createElement("rect", { width: 4, height: 4, x: 10, y: 10 }), /* @__PURE__ */ React209.createElement("rect", { width: 4, height: 4, x: 17, y: 10 }));
}

// src/components/icons/FeatureEllipses48.tsx
import * as React210 from "react";
var componentNameString205 = "FeatureEllipses48";
function FeatureEllipses48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString205,
    ...props
  });
  return /* @__PURE__ */ React210.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React210.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React210.createElement("path", { d: "M6 20h8v8H6v-8z" }), /* @__PURE__ */ React210.createElement("path", { d: "M20 20h8v8h-8v-8z" }), /* @__PURE__ */ React210.createElement("path", { d: "M34 20h8v8h-8v-8z" }));
}

// src/components/icons/FeatureEllipses72.tsx
import * as React211 from "react";
var componentNameString206 = "FeatureEllipses72";
function FeatureEllipses72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString206,
    ...props
  });
  return /* @__PURE__ */ React211.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React211.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React211.createElement("path", { d: "M9 30h12v12H9V30z" }), /* @__PURE__ */ React211.createElement("path", { d: "M30 30h12v12H30V30z" }), /* @__PURE__ */ React211.createElement("path", { d: "M51 30h12v12H51V30z" }));
}

// src/components/icons/FeatureEnvelope.tsx
import * as React212 from "react";
var componentNameString207 = "FeatureEnvelope";
function FeatureEnvelope({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString207,
    ...props
  });
  return /* @__PURE__ */ React212.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React212.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React212.createElement("polygon", { points: "24 36 0 18 0 48 47.999 48 47.999 18", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React212.createElement("polygon", { points: "24 0 0 18 47.999 18", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureExclamationInCircle24.tsx
import * as React213 from "react";
var componentNameString208 = "FeatureExclamationInCircle24";
function FeatureExclamationInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString208,
    ...props
  });
  return /* @__PURE__ */ React213.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React213.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React213.createElement("path", { d: "M13 6V14H11V6H13Z" }), /* @__PURE__ */ React213.createElement("path", { d: "M11 18V16H13V18H11Z" }), /* @__PURE__ */ React213.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureExclamationInCircle48.tsx
import * as React214 from "react";
var componentNameString209 = "FeatureExclamationInCircle48";
function FeatureExclamationInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString209,
    ...props
  });
  return /* @__PURE__ */ React214.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React214.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React214.createElement("path", { fillRule: "evenodd", d: "M25.8 12v17h-3.6V12h3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React214.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React214.createElement("path", { fillRule: "evenodd", d: "M25.8 32v3.5h-3.6V32h3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureExclamationInCircle72.tsx
import * as React215 from "react";
var componentNameString210 = "FeatureExclamationInCircle72";
function FeatureExclamationInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString210,
    ...props
  });
  return /* @__PURE__ */ React215.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React215.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React215.createElement("path", { fillRule: "evenodd", d: "M38.5 17v28h-5V17h5z", clipRule: "evenodd" }), /* @__PURE__ */ React215.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React215.createElement("path", { fillRule: "evenodd", d: "M38.5 50v5h-5v-5h5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureExclamationPoint24.tsx
import * as React216 from "react";
var componentNameString211 = "FeatureExclamationPoint24";
function FeatureExclamationPoint24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString211,
    ...props
  });
  return /* @__PURE__ */ React216.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React216.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React216.createElement("path", { d: "M13 17V3H11V17H13Z" }), /* @__PURE__ */ React216.createElement("path", { d: "M13 19H11V21H13V19Z" }));
}

// src/components/icons/FeatureExclamationPoint48.tsx
import * as React217 from "react";
var componentNameString212 = "FeatureExclamationPoint48";
function FeatureExclamationPoint48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString212,
    ...props
  });
  return /* @__PURE__ */ React217.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React217.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React217.createElement("path", { fillRule: "evenodd", d: "M25.8 6v29h-3.6V6h3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React217.createElement("path", { fillRule: "evenodd", d: "M25.8 38.5V42h-3.6v-3.5h3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureExclamationPoint72.tsx
import * as React218 from "react";
var componentNameString213 = "FeatureExclamationPoint72";
function FeatureExclamationPoint72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString213,
    ...props
  });
  return /* @__PURE__ */ React218.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React218.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React218.createElement("path", { fillRule: "evenodd", d: "M38.5 9v44h-5V9h5z", clipRule: "evenodd" }), /* @__PURE__ */ React218.createElement("path", { fillRule: "evenodd", d: "M38.5 58v5h-5v-5h5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureExit24.tsx
import * as React219 from "react";
var componentNameString214 = "FeatureExit24";
function FeatureExit24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString214,
    ...props
  });
  return /* @__PURE__ */ React219.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React219.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React219.createElement("path", { fillRule: "evenodd", d: "M20 13L6 13L6 11L20 11L20 13Z", clipRule: "evenodd" }), /* @__PURE__ */ React219.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.4141 12L15.707 18.7071L14.2927 17.2929L19.5856 12L14.2927 6.70711L15.707 5.29289L22.4141 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React219.createElement("path", { fillRule: "evenodd", d: "M2 20L2 4L4 4L4 20L2 20Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureExit48.tsx
import * as React220 from "react";
var componentNameString215 = "FeatureExit48";
function FeatureExit48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString215,
    ...props
  });
  return /* @__PURE__ */ React220.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React220.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React220.createElement("path", { fillRule: "evenodd", d: "M40 25.75L12 25.75L12 22.25L40 22.25L40 25.75Z", clipRule: "evenodd" }), /* @__PURE__ */ React220.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M44.4746 24L31.2372 37.2374L28.7623 34.7626L39.5249 24L28.7623 13.2374L31.2372 10.7626L44.4746 24Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React220.createElement("path", { fillRule: "evenodd", d: "M4.25 40L4.25 8L7.75 8L7.75 40L4.25 40Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureExit72.tsx
import * as React221 from "react";
var componentNameString216 = "FeatureExit72";
function FeatureExit72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString216,
    ...props
  });
  return /* @__PURE__ */ React221.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React221.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React221.createElement("path", { fillRule: "evenodd", d: "M60 38.5L18 38.5L18 33.5L60 33.5L60 38.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React221.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M66.5356 36L46.7679 55.7678L43.2323 52.2322L59.4646 36L43.2323 19.7678L46.7679 16.2322L66.5356 36Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React221.createElement("path", { fillRule: "evenodd", d: "M6.5 60L6.5 12L11.5 12L11.5 60L6.5 60Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureExit.tsx
import * as React222 from "react";
var componentNameString217 = "FeatureExit";
function FeatureExit({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString217,
    ...props
  });
  return /* @__PURE__ */ React222.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React222.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React222.createElement("polygon", { points: "0 40.343 8 40.343 8 8.343 0 8.343", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React222.createElement(
    "polygon",
    {
      points: "24 11.657 32.686 20.343 12 20.343 12 28.343 32.686 28.343 24 37.03 29.657 42.686 48 24.343 29.657 6",
      className: "sc-Icon--primary-color"
    }
  ));
}

// src/components/icons/FeatureEye24.tsx
import * as React223 from "react";
var componentNameString218 = "FeatureEye24";
function FeatureEye24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString218,
    ...props
  });
  return /* @__PURE__ */ React223.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React223.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React223.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3.93508 12C5.40907 14.966 8.46917 17 12.0001 17C15.5311 17 18.5912 14.966 20.0652 12C18.5912 9.03403 15.5311 7 12.0001 7C8.46917 7 5.40907 9.03403 3.93508 12ZM22.2502 12C20.6501 7.90265 16.6641 5 12.0001 5C7.33615 5 3.35014 7.90264 1.75 12C3.35014 16.0974 7.33615 19 12.0001 19C16.6641 19 20.6501 16.0974 22.2502 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React223.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureEye48.tsx
import * as React224 from "react";
var componentNameString219 = "FeatureEye48";
function FeatureEye48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString219,
    ...props
  });
  return /* @__PURE__ */ React224.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React224.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React224.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.3 24a18.5 18.5 0 0033.4 0 18.5 18.5 0 00-33.4 0zm37.2 0a22 22 0 00-41 0 22 22 0 0041 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React224.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureEye72.tsx
import * as React225 from "react";
var componentNameString220 = "FeatureEye72";
function FeatureEye72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString220,
    ...props
  });
  return /* @__PURE__ */ React225.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React225.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React225.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10.7 36a28 28 0 0050.6 0 28 28 0 00-50.6 0zm56 0a33 33 0 00-61.5 0 33 33 0 0061.6 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React225.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 43a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureEyeCrossout24.tsx
import * as React226 from "react";
var componentNameString221 = "FeatureEyeCrossout24";
function FeatureEyeCrossout24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString221,
    ...props
  });
  return /* @__PURE__ */ React226.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React226.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React226.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17.518 17.518L22 22L20.5 23.5L15.4486 18.4486C14.3639 18.8064 13.2046 19 12.0001 19C7.33615 19 3.35014 16.0974 1.75 12C2.39529 10.3477 3.42858 8.88961 4.73787 7.73787L0.5 3.5L2 2L6.48207 6.48207C6.48209 6.48205 6.48212 6.48204 6.48215 6.48202L7.9571 7.95697C7.95707 7.95699 7.95704 7.957 7.95701 7.95701L9.17163 9.17163C9.17165 9.17161 9.17168 9.17159 9.1717 9.17157L10.5859 10.5858C10.5859 10.5858 10.5859 10.5858 10.5858 10.5858L13.4143 13.4143C13.4143 13.4143 13.4143 13.4142 13.4143 13.4142L14.8285 14.8284C14.8285 14.8284 14.8285 14.8285 14.8285 14.8285L16.0431 16.0431C16.0431 16.0431 16.0431 16.043 16.0431 16.043L17.5181 17.518C17.5181 17.518 17.518 17.518 17.518 17.518ZM13.8166 16.8166L12.8987 15.8987C12.6098 15.965 12.3091 16 12.0001 16C9.79098 16 8.00012 14.2091 8.00012 12C8.00012 11.691 8.03515 11.3903 8.10145 11.1014L6.15546 9.15546C5.23709 9.94025 4.47835 10.9068 3.93508 12C5.40907 14.966 8.46917 17 12.0001 17C12.6223 17 13.2298 16.9369 13.8166 16.8166ZM22.2502 12C21.6049 13.6524 20.5716 15.1104 19.2623 16.2622L17.8447 14.8446C18.7631 14.0598 19.5219 13.0932 20.0652 12C18.5912 9.03403 15.5311 7 12.0001 7C11.3779 7 10.7704 7.06315 10.1836 7.18343L8.55154 5.55142C9.63623 5.19361 10.7956 5 12.0001 5C16.6641 5 20.6501 7.90265 22.2502 12ZM16.0001 12C16.0001 12.309 15.9651 12.6098 15.8988 12.8987L11.1015 8.10135C11.3903 8.03503 11.6911 8 12.0001 8C14.2093 8 16.0001 9.79086 16.0001 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureEyeCrossout48.tsx
import * as React227 from "react";
var componentNameString222 = "FeatureEyeCrossout48";
function FeatureEyeCrossout48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString222,
    ...props
  });
  return /* @__PURE__ */ React227.createElement("svg", { viewBox: "0 0 48 49", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React227.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React227.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.3 24a18.5 18.5 0 0033.4 0 18.5 18.5 0 00-33.4 0zm37.2 0a22 22 0 00-41 0 22 22 0 0041 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React227.createElement("path", { fillRule: "evenodd", d: "M44 48.4L0 4.4 2.5 2l44 44-2.6 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React227.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M31.7 26.2a8 8 0 00-10-9.9l10 10zm-13.1-8A8 8 0 0024 32a8 8 0 005.9-2.6L18.6 18.1z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React227.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M29.4 29.9l.5-.5-11.3-11.3A8 8 0 0016 24a8 8 0 0013.4 5.9zM23.6 16a8 8 0 00-1.8.3l9.9 10A8 8 0 0023.6 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureEyeCrossout72.tsx
import * as React228 from "react";
var componentNameString223 = "FeatureEyeCrossout72";
function FeatureEyeCrossout72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString223,
    ...props
  });
  return /* @__PURE__ */ React228.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React228.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React228.createElement("path", { fillRule: "evenodd", d: "M64.2 71.8l-64-64 3.6-3.6 64 64-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React228.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M56.4 50a33 33 0 0010.4-14 33 33 0 00-43-18.7l4 4A28 28 0 0161.3 36a29 29 0 01-8.4 10.3l3.5 3.6zm-9.3-9.4A12 12 0 0036 24a12 12 0 00-4.6.9l15.7 15.7zM27.3 27.8l17 17A12 12 0 0124 36c0-3.2 1.2-6 3.3-8.2zm-4.5-4.5A28.1 28.1 0 0010.7 36a28 28 0 0037.8 13l3.7 3.7A32.8 32.8 0 015.2 36a33.1 33.1 0 0114-16.4l3.6 3.7z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureFilter24.tsx
import * as React229 from "react";
var componentNameString224 = "FeatureFilter24";
function FeatureFilter24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString224,
    ...props
  });
  return /* @__PURE__ */ React229.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React229.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React229.createElement("path", { fillRule: "evenodd", d: "M18 13H6V11H18V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React229.createElement("path", { fillRule: "evenodd", d: "M14 17H10V15H14V17Z", clipRule: "evenodd" }), /* @__PURE__ */ React229.createElement("path", { fillRule: "evenodd", d: "M22 9H2V7H22V9Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureFilter48.tsx
import * as React230 from "react";
var componentNameString225 = "FeatureFilter48";
function FeatureFilter48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString225,
    ...props
  });
  return /* @__PURE__ */ React230.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React230.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React230.createElement("path", { fillRule: "evenodd", d: "M36 25.8H12v-3.6h24v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React230.createElement("path", { fillRule: "evenodd", d: "M28 33.8h-8v-3.5h8v3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React230.createElement("path", { fillRule: "evenodd", d: "M44 17.8H4v-3.6h40v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureFilter72.tsx
import * as React231 from "react";
var componentNameString226 = "FeatureFilter72";
function FeatureFilter72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString226,
    ...props
  });
  return /* @__PURE__ */ React231.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React231.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React231.createElement("path", { fillRule: "evenodd", d: "M54 38.5H18v-5h36v5z", clipRule: "evenodd" }), /* @__PURE__ */ React231.createElement("path", { fillRule: "evenodd", d: "M42 50.5H30v-5h12v5z", clipRule: "evenodd" }), /* @__PURE__ */ React231.createElement("path", { fillRule: "evenodd", d: "M66 26.5H6v-5h60v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureFitness24.tsx
import * as React232 from "react";
var componentNameString227 = "FeatureFitness24";
function FeatureFitness24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString227,
    ...props
  });
  return /* @__PURE__ */ React232.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React232.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React232.createElement("path", { d: "M20.2929 9.70698L14.2928 3.70694L15.7071 2.29272L17.9999 4.58561L19.5428 3.04276L20.957 4.45698L19.4142 5.99982L21.7071 8.29276L20.2929 9.70698Z" }), /* @__PURE__ */ React232.createElement("path", { d: "M4.58567 17.9999L2.29285 15.7071L3.70706 14.2928L9.7071 20.2929L8.29289 21.7071L5.99989 19.4141L4.45689 20.9571L3.04267 19.5429L4.58567 17.9999Z" }), /* @__PURE__ */ React232.createElement("path", { d: "M4.54285 13.4571L10.5429 19.4571L11.9571 18.0429L9.66416 15.7499L15.75 9.6641L18.043 11.9571L19.4572 10.5429L13.4572 4.54285L12.043 5.95706L14.3358 8.24989L8.24995 14.3357L5.95706 12.0428L4.54285 13.4571Z" }));
}

// src/components/icons/FeatureFitness48.tsx
import * as React233 from "react";
var componentNameString228 = "FeatureFitness48";
function FeatureFitness48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString228,
    ...props
  });
  return /* @__PURE__ */ React233.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React233.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React233.createElement("path", { d: "M40.7625 19.2375L28.7625 7.23745L31.2373 4.76257L35.9999 9.52518L39.2625 6.26262L41.7374 8.7375L38.4748 12.0001L43.2374 16.7626L40.7625 19.2375Z" }), /* @__PURE__ */ React233.createElement("path", { d: "M9.52519 36.0001L4.7627 31.2376L7.23757 28.7627L19.2376 40.7627L16.7627 43.2376L12.0001 38.4749L8.73739 41.7376L6.26251 39.2627L9.52519 36.0001Z" }), /* @__PURE__ */ React233.createElement("path", { d: "M9.26245 26.7376L21.2625 38.7376L23.7374 36.2627L18.9748 31.5001L31.5001 18.9748L36.2627 23.7375L38.7376 21.2626L26.7376 9.26257L24.2627 11.7374L29.0252 16.4999L16.4999 29.0252L11.7373 24.2627L9.26245 26.7376Z" }));
}

// src/components/icons/FeatureFitness72.tsx
import * as React234 from "react";
var componentNameString229 = "FeatureFitness72";
function FeatureFitness72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString229,
    ...props
  });
  return /* @__PURE__ */ React234.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React234.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React234.createElement("path", { d: "M61.2321 28.7676L43.2319 10.7675L46.7675 7.23193L53.9998 14.4642L58.982 9.48205L62.5175 13.0176L57.5353 17.9998L64.7676 25.2321L61.2321 28.7676Z" }), /* @__PURE__ */ React234.createElement("path", { d: "M14.464 54L7.23193 46.768L10.7675 43.2324L28.7676 61.2325L25.2321 64.7681L17.9995 57.5355L13.017 62.5181L9.48147 58.9825L14.464 54Z" }), /* @__PURE__ */ React234.createElement("path", { d: "M13.9819 40.018L31.9821 58.0181L35.5176 54.4825L28.2852 47.2501L47.25 28.2853L54.4826 35.5178L58.0181 31.9823L40.018 13.9822L36.4824 17.5177L43.7145 24.7498L24.7497 43.7146L17.5175 36.4824L13.9819 40.018Z" }));
}

// src/components/icons/FeatureFolder24.tsx
import * as React235 from "react";
var componentNameString230 = "FeatureFolder24";
function FeatureFolder24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString230,
    ...props
  });
  return /* @__PURE__ */ React235.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React235.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React235.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10.1716 8L8.17157 6H4V18H20V8H10.1716ZM9 4L11 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H9Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureFolder48.tsx
import * as React236 from "react";
var componentNameString231 = "FeatureFolder48";
function FeatureFolder48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString231,
    ...props
  });
  return /* @__PURE__ */ React236.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React236.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React236.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.6 15.5l-4-4H8c-.3 0-.5.2-.5.5v24c0 .3.2.5.5.5h32c.3 0 .5-.2.5-.5V16c0-.3-.2-.5-.5-.5H20.6zM18 8l4 4h18a4 4 0 014 4v20a4 4 0 01-4 4H8a4 4 0 01-4-4V12a4 4 0 014-4h10z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureFolder72.tsx
import * as React237 from "react";
var componentNameString232 = "FeatureFolder72";
function FeatureFolder72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString232,
    ...props
  });
  return /* @__PURE__ */ React237.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React237.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React237.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M31 23l-6-6H12a1 1 0 00-1 1v36c0 .6.4 1 1 1h48c.6 0 1-.4 1-1V24c0-.6-.4-1-1-1H31zm-4-11l6 6h27a6 6 0 016 6v30a6 6 0 01-6 6H12a6 6 0 01-6-6V18a6 6 0 016-6h15z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureFolderComplete24.tsx
import * as React238 from "react";
var componentNameString233 = "FeatureFolderComplete24";
function FeatureFolderComplete24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString233,
    ...props
  });
  return /* @__PURE__ */ React238.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React238.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React238.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10.1716 8L8.17157 6H4V18H20V8H10.1716ZM9 4L11 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H9Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React238.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.7071 10.7071L11 16.4142L7.79289 13.2071L9.20711 11.7929L11 13.5858L15.2929 9.29289L16.7071 10.7071Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureFolderComplete48.tsx
import * as React239 from "react";
var componentNameString234 = "FeatureFolderComplete48";
function FeatureFolderComplete48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString234,
    ...props
  });
  return /* @__PURE__ */ React239.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React239.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React239.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.6 15.5l-4-4H8c-.3 0-.5.2-.5.5v24c0 .3.2.5.5.5h32c.3 0 .5-.2.5-.5V16c0-.3-.2-.5-.5-.5H20.6zM18 8l4 4h18a4 4 0 014 4v20a4 4 0 01-4 4H8a4 4 0 01-4-4V12a4 4 0 014-4h10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React239.createElement("path", { fillRule: "evenodd", d: "M30.8 18.8l2.4 2.4L22 32.5l-6.2-6.3 2.4-2.4 3.8 3.7 8.8-8.7z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureFolderComplete72.tsx
import * as React240 from "react";
var componentNameString235 = "FeatureFolderComplete72";
function FeatureFolderComplete72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString235,
    ...props
  });
  return /* @__PURE__ */ React240.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React240.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React240.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M31 23l-6-6H12a1 1 0 00-1 1v36c0 .6.4 1 1 1h48c.6 0 1-.4 1-1V24c0-.6-.4-1-1-1H31zm-4-11l6 6h27a6 6 0 016 6v30a6 6 0 01-6 6H12a6 6 0 01-6-6V18a6 6 0 016-6h15z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React240.createElement("path", { fillRule: "evenodd", d: "M49.8 31.8L33 48.5l-9.3-9.2 3.6-3.6 5.7 5.8 13.2-13.3 3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureFpo24.tsx
import * as React241 from "react";
var componentNameString236 = "FeatureFpo24";
function FeatureFpo24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString236,
    ...props
  });
  return /* @__PURE__ */ React241.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React241.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React241.createElement("path", { d: "M15.8589 12C15.8589 13.2016 16.3775 13.9355 17.2497 13.9355C18.122 13.9355 18.6327 13.2097 18.6327 12C18.6327 10.7903 18.122 10.0645 17.2497 10.0645C16.3775 10.0645 15.8589 10.7903 15.8589 12Z" }), /* @__PURE__ */ React241.createElement("path", { d: "M11.765 11.8306H10.9399V10.121H11.765C12.3622 10.121 12.7001 10.4355 12.7001 10.9758C12.7001 11.5161 12.3543 11.8306 11.765 11.8306Z" }), /* @__PURE__ */ React241.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM20 12C20 13.8468 18.9235 15 17.2497 15C15.576 15 14.4995 13.8387 14.4995 12C14.4995 10.1532 15.576 9 17.2497 9C18.9235 9 20 10.1532 20 12ZM8.81894 10.1694V9.1371H5V14.8629H6.32799V12.5081H8.6775V11.4919H6.32799V10.1694H8.81894ZM12.0872 9.1371H9.61191V14.8629H10.9399V12.7823H12.0557C13.313 12.7823 14.0909 12.0726 14.0909 10.9355C14.0909 9.84677 13.2973 9.1371 12.0872 9.1371Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureFpo48.tsx
import * as React242 from "react";
var componentNameString237 = "FeatureFpo48";
function FeatureFpo48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString237,
    ...props
  });
  return /* @__PURE__ */ React242.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React242.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React242.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React242.createElement("path", { d: "M19.5 21.8v-1.6H14v7.6h2.2v-3h3.1v-1.6h-3v-1.4h3.2z" }), /* @__PURE__ */ React242.createElement("path", { d: "M24.1 20.2h-3.7v7.6h2.2v-2.6h1.5c1.7 0 2.8-1 2.8-2.5s-1-2.5-2.8-2.5zm-.6 3.5h-.9v-2h.9c.7 0 1 .4 1 1 0 .7-.3 1-1 1z" }), /* @__PURE__ */ React242.createElement("path", { d: "M31.3 28c2.4 0 3.9-1.5 3.9-4s-1.5-4-4-4c-2.3 0-3.8 1.5-3.8 4s1.5 4 3.9 4zm0-1.7c-1 0-1.6-.9-1.6-2.3s.6-2.3 1.6-2.3 1.6.9 1.6 2.3-.6 2.3-1.6 2.3z" }));
}

// src/components/icons/FeatureFpo72.tsx
import * as React243 from "react";
var componentNameString238 = "FeatureFpo72";
function FeatureFpo72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString238,
    ...props
  });
  return /* @__PURE__ */ React243.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React243.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React243.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React243.createElement("path", { d: "M28.2 32.1v-2.8H19v12.8h3.8v-5h5v-2.7h-5v-2.3h5.4z" }), /* @__PURE__ */ React243.createElement("path", { d: "M36 29.3h-6.4v12.8h3.8v-4.3h2.4c3 0 4.9-1.7 4.9-4.4 0-2.5-2-4-4.8-4zm-1.1 6h-1.5v-3.4h1.5c1.2 0 1.8.6 1.8 1.7 0 1-.6 1.6-1.8 1.6z" }), /* @__PURE__ */ React243.createElement("path", { d: "M48 42.4c4 0 6.5-2.6 6.5-6.7S51.9 29 47.9 29c-4 0-6.5 2.6-6.5 6.7s2.5 6.7 6.5 6.7zm0-3c-1.8 0-2.8-1.3-2.8-3.7 0-2.4 1-3.8 2.7-3.8 1.7 0 2.7 1.4 2.7 3.8s-1 3.8-2.7 3.8z" }));
}

// src/components/icons/FeatureFpo.tsx
import * as React244 from "react";
var componentNameString239 = "FeatureFpo";
function FeatureFpo({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString239,
    ...props
  });
  return /* @__PURE__ */ React244.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React244.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React244.createElement("path", { d: "M24 2a22 22 0 100 44 22 22 0 000-44z" }), /* @__PURE__ */ React244.createElement("path", { d: "M17.3 21.5v-2.4h-8v11.2h3.3v-4.4H17v-2.3h-4.5v-2h4.7zm6.8-2.4c2.5 0 4.1 1.4 4.1 3.6 0 2.4-1.6 3.8-4.2 3.8h-2v3.8h-3.3V19h5.5zm-1 5.2c1.1 0 1.7-.5 1.7-1.5s-.6-1.4-1.6-1.4h-1.3v2.9h1.3zm11.5 6.2c-3.5 0-5.8-2.2-5.8-5.8 0-3.6 2.3-5.9 5.8-5.9s5.7 2.3 5.7 5.9c0 3.6-2.2 5.8-5.7 5.8zm0-2.5c1.4 0 2.3-1.2 2.3-3.3 0-2.1-.9-3.3-2.3-3.3-1.5 0-2.4 1.2-2.4 3.3 0 2 .9 3.3 2.4 3.3z" }));
}

// src/components/icons/FeatureFullscreen24.tsx
import * as React245 from "react";
var componentNameString240 = "FeatureFullscreen24";
function FeatureFullscreen24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString240,
    ...props
  });
  return /* @__PURE__ */ React245.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React245.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React245.createElement("path", { fillRule: "evenodd", d: "M3 3H9V5H5V9H3V3Z", clipRule: "evenodd" }), /* @__PURE__ */ React245.createElement("path", { fillRule: "evenodd", d: "M21 21L15 21L15 19L19 19L19 15L21 15L21 21Z", clipRule: "evenodd" }), /* @__PURE__ */ React245.createElement("path", { fillRule: "evenodd", d: "M21 3L21 9L19 9L19 5L15 5L15 3L21 3Z", clipRule: "evenodd" }), /* @__PURE__ */ React245.createElement("path", { fillRule: "evenodd", d: "M3 21L3 15L5 15L5 19L9 19L9 21L3 21Z", clipRule: "evenodd" }), /* @__PURE__ */ React245.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.29297 10.7072L3.29297 4.70718L4.70718 3.29297L10.7072 9.29297L9.29297 10.7072Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React245.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.2928 9.29297L19.2928 3.29297L20.707 4.70718L14.707 10.7072L13.2928 9.29297Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React245.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.293 20.7072L13.293 14.7072L14.7072 13.293L20.7072 19.293L19.293 20.7072Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React245.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3.29282 19.293L9.29282 13.293L10.707 14.7072L4.70703 20.7072L3.29282 19.293Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureFullscreen48.tsx
import * as React246 from "react";
var componentNameString241 = "FeatureFullscreen48";
function FeatureFullscreen48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString241,
    ...props
  });
  return /* @__PURE__ */ React246.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React246.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M6.3 6.3H18v3.5H9.7V18H6.3V6.2z", clipRule: "evenodd" }), /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M41.8 41.8H30v-3.5h8.3V30h3.5v11.8z", clipRule: "evenodd" }), /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M41.8 6.3V18h-3.5V9.7H30V6.3h11.8z", clipRule: "evenodd" }), /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M6.3 41.8V30h3.5v8.3H18v3.5H6.2z", clipRule: "evenodd" }), /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M18.8 21.2l-12-12 2.4-2.4 12 12-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M26.8 18.8l12-12 2.4 2.4-12 12-2.4-2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M38.8 41.2l-12-12 2.4-2.4 12 12-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React246.createElement("path", { fillRule: "evenodd", d: "M6.8 38.8l12-12 2.4 2.4-12 12-2.4-2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureFullscreen72.tsx
import * as React247 from "react";
var componentNameString242 = "FeatureFullscreen72";
function FeatureFullscreen72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString242,
    ...props
  });
  return /* @__PURE__ */ React247.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React247.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M9.5 9.5H27v5H14.5V27h-5V9.5z", clipRule: "evenodd" }), /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M62.5 62.5H45v-5h12.5V45h5v17.5z", clipRule: "evenodd" }), /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M62.5 9.5V27h-5V14.5H45v-5h17.5z", clipRule: "evenodd" }), /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M9.5 62.5V45h5v12.5H27v5H9.5z", clipRule: "evenodd" }), /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M28.2 31.8l-18-18 3.6-3.6 18 18-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M40.2 28.2l18-18 3.6 3.6-18 18-3.6-3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M58.2 61.8l-18-18 3.6-3.6 18 18-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React247.createElement("path", { fillRule: "evenodd", d: "M10.2 58.2l18-18 3.6 3.6-18 18-3.6-3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureGearInCircle24.tsx
import * as React248 from "react";
var componentNameString243 = "FeatureGearInCircle24";
function FeatureGearInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString243,
    ...props
  });
  return /* @__PURE__ */ React248.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React248.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React248.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13 8.12602C13.7149 8.31003 14.3525 8.68672 14.8541 9.19744L16.6961 8.13392L17.6961 9.86597L15.855 10.929C15.9495 11.2698 16 11.629 16 12C16 12.3709 15.9495 12.7301 15.855 13.0709L17.6961 14.1339L16.6961 15.866L14.8541 14.8025C14.3526 15.3132 13.715 15.69 13 15.874V18H11V15.874C10.285 15.69 9.64743 15.3132 9.14586 14.8025L7.30383 15.866L6.30383 14.1339L8.14498 13.0709C8.05049 12.7301 8 12.3709 8 12C8 11.629 8.0505 11.2698 8.145 10.929L6.30383 9.86597L7.30383 8.13392L9.14593 9.19745C9.64749 8.68673 10.2851 8.31003 11 8.12602V6H13V8.12602ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React248.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureGearInCircle48.tsx
import * as React249 from "react";
var componentNameString244 = "FeatureGearInCircle48";
function FeatureGearInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString244,
    ...props
  });
  return /* @__PURE__ */ React249.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React249.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React249.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React249.createElement("path", { fillRule: "evenodd", d: "M22.3 18v-6h3.4v6h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React249.createElement("path", { fillRule: "evenodd", d: "M22.3 36v-6h3.4v6h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React249.createElement("path", { fillRule: "evenodd", d: "M19.7 28.5l-5.2 3-1.8-3 5.2-3 1.8 3z", clipRule: "evenodd" }), /* @__PURE__ */ React249.createElement("path", { fillRule: "evenodd", d: "M35.3 19.5l-5.2 3-1.8-3 5.2-3 1.8 3z", clipRule: "evenodd" }), /* @__PURE__ */ React249.createElement("path", { fillRule: "evenodd", d: "M18 22.5l-5.3-3 1.8-3 5.2 3-1.8 3z", clipRule: "evenodd" }), /* @__PURE__ */ React249.createElement("path", { fillRule: "evenodd", d: "M33.5 31.5l-5.2-3 1.8-3 5.2 3-1.8 3z", clipRule: "evenodd" }), /* @__PURE__ */ React249.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureGearInCircle72.tsx
import * as React250 from "react";
var componentNameString245 = "FeatureGearInCircle72";
function FeatureGearInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString245,
    ...props
  });
  return /* @__PURE__ */ React250.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React250.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React250.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React250.createElement("path", { fillRule: "evenodd", d: "M33.5 27v-9h5v9h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React250.createElement("path", { fillRule: "evenodd", d: "M33.5 54v-9h5v9h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React250.createElement("path", { fillRule: "evenodd", d: "M29.5 42.7l-7.8 4.5-2.5-4.4 7.8-4.5 2.5 4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React250.createElement("path", { fillRule: "evenodd", d: "M52.8 29.2L45 33.7l-2.5-4.4 7.8-4.5 2.5 4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React250.createElement("path", { fillRule: "evenodd", d: "M27 33.7l-7.8-4.5 2.5-4.4 7.8 4.5-2.5 4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React250.createElement("path", { fillRule: "evenodd", d: "M50.3 47.2l-7.8-4.5 2.5-4.4 7.8 4.5-2.5 4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React250.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 43a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureGears24.tsx
import * as React251 from "react";
var componentNameString246 = "FeatureGears24";
function FeatureGears24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString246,
    ...props
  });
  return /* @__PURE__ */ React251.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React251.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React251.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.00002 1V3.10002C5.9179 3.31968 4.96268 3.88881 4.2573 4.68449L2.43787 3.63403L1.43787 5.36608L3.25617 6.41588C3.09001 6.91368 3.00002 7.44633 3.00002 8C3.00002 8.55371 3.09003 9.0864 3.2562 9.58423L1.43789 10.634L2.43789 12.3661L4.25738 11.3156C4.96275 12.1112 5.91794 12.6803 7.00002 12.9V15H9.00002V12.9C10.0821 12.6803 11.0373 12.1112 11.7427 11.3156L13.5622 12.3661L14.5622 10.634L12.7438 9.5842C12.91 9.08637 13 8.5537 13 8C13 7.44634 12.91 6.9137 12.7439 6.41591L14.5622 5.36608L13.5622 3.63403L11.7428 4.68451C11.0374 3.88882 10.0822 3.31968 9.00002 3.10002V1H7.00002ZM5.42931 6.4527L5.37187 6.55219C5.13489 6.98146 5.00002 7.47498 5.00002 8C5.00002 9.65685 6.34317 11 8.00002 11C9.65687 11 11 9.65685 11 8C11 7.47396 10.8646 6.97955 10.6268 6.5497L10.5722 6.45514C10.0474 5.58323 9.09182 5 8.00002 5C6.90924 5 5.95442 5.58215 5.42931 6.4527Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React251.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 13.126V11H18V13.126C18.715 13.31 19.3525 13.6867 19.8541 14.1975L21.6962 13.1339L22.6962 14.866L20.855 15.929C20.9495 16.2698 21 16.629 21 17C21 17.3709 20.9495 17.7301 20.855 18.071L22.6961 19.1339L21.6961 20.866L19.8542 19.8025C19.3526 20.3132 18.715 20.69 18 20.874V23H16V20.874C15.2851 20.69 14.6475 20.3132 14.1459 19.8025L12.3039 20.866L11.3039 19.1339L13.145 18.071C13.0505 17.7301 13 17.3709 13 17C13 16.629 13.0505 16.2698 13.145 15.929L11.3039 14.866L12.3039 13.1339L14.1459 14.1975C14.6475 13.6867 15.2851 13.31 16 13.126ZM15.2867 18.0323L15.2475 17.9644C15.0898 17.6784 15 17.3497 15 17C15 15.8954 15.8955 15 17 15C18.1046 15 19 15.8954 19 17C19 17.3497 18.9103 17.6784 18.7526 17.9644L18.7133 18.0323C18.3632 18.6123 17.7269 19 17 19C16.2732 19 15.6369 18.6123 15.2867 18.0323Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureGears48.tsx
import * as React252 from "react";
var componentNameString247 = "FeatureGears48";
function FeatureGears48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString247,
    ...props
  });
  return /* @__PURE__ */ React252.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React252.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M14.3 8.8V2h3.4v6.8h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M14.3 30v-7h3.4v7h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M32.3 28.8V22h3.5v6.8h-3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M32.3 46v-7.3h3.5V46h-3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M28.6 32.9l-5.9-3.4 1.8-3 5.8 3.4-1.7 3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M43.5 41.5l-6-3.7 1.7-3 6.1 3.7-1.8 3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M39.4 32.9l5.9-3.4-1.8-3-5.8 3.4 1.7 3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M24.5 41.5l6.4-3.6-1.8-3-6.4 3.6 1.8 3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M23.2 18.1l5.8 3.4-1.8 3-5.8-3.4 1.8-3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M4.7 7.5l5.8 3.3-1.7 3L3 10.6l1.7-3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M8.8 18.1L3 21.5l1.8 3 5.8-3.4-1.8-3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement("path", { fillRule: "evenodd", d: "M27.3 7.5l-6.1 3.3 1.6 3 6.2-3.3-1.7-3z", clipRule: "evenodd" }), /* @__PURE__ */ React252.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 22.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 3.5a10 10 0 100-20 10 10 0 000 20z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React252.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34 38.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureGears72.tsx
import * as React253 from "react";
var componentNameString248 = "FeatureGears72";
function FeatureGears72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString248,
    ...props
  });
  return /* @__PURE__ */ React253.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React253.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M21.5 13.1V3h5v10.1h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M21.5 45V34.5h5V45h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M48.5 43.1V33h5v10.1h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M48.5 69V58h5v11h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M43 49.2l-8.8-5 2.5-4.4 8.7 5.1-2.5 4.3z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M65.3 62.1l-9-5.5 2.5-4.2 9 5.5-2.5 4.2z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M59 49.2l8.8-5-2.5-4.4-8.7 5.1 2.5 4.3z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M36.7 62.2l9.5-5.5-2.4-4.4-9.6 5.5 2.5 4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M34.7 27.3l8.7 5-2.5 4.4-8.7-5.1 2.5-4.3z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M7 11.3l8.7 5-2.4 4.4-8.7-5L7 11.3z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M13.3 27.3l-8.7 5L7 36.7l8.7-5.1-2.5-4.3z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement("path", { fillRule: "evenodd", d: "M41 11.3l-9.2 5 2.4 4.4 9.2-5-2.4-4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React253.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 34a10 10 0 100-20 10 10 0 000 20zm0 5a15 15 0 100-30 15 15 0 000 30z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React253.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M51 58a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureGears.tsx
import * as React254 from "react";
var componentNameString249 = "FeatureGears";
function FeatureGears({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString249,
    ...props
  });
  return /* @__PURE__ */ React254.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React254.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React254.createElement("path", { d: "M13.2 48l-.8-2.1a9 9 0 01-3 0l-1 2-3.6-1.6.9-2A9 9 0 013.6 42l-2.1.9L0 39.3l2-.9a9 9 0 01.1-3l-2-.9L1.5 31l2 .8a9 9 0 012.2-2L5 27.5 8.7 26l.8 2h3l1-2 3.6 1.6-.9 2a9 9 0 012.1 2.2l2.1-.9 1.5 3.7-2 .9-.1 3 2 .9-1.5 3.6-2-.8a9 9 0 01-2.2 2l.8 2.1-3.7 1.5zm-6-9.5a4 4 0 107.5-3 4 4 0 00-7.5 3z" }), /* @__PURE__ */ React254.createElement("path", { d: "M48 19h-3.4c-.3 1.4-.9 2.6-1.6 3.8l2.4 2.4-4.3 4.2-2.3-2.3c-1.2.7-2.5 1.2-3.9 1.5V32h-6v-3.4c-1.3-.3-2.6-.8-3.8-1.5l-2.3 2.3-4.3-4.2 2.4-2.4c-.7-1.2-1.3-2.4-1.6-3.8H16v-6h3.4c.3-1.4.9-2.7 1.6-3.8l-2.4-2.4 4.3-4.2L25 4.9c1.2-.7 2.5-1.2 3.8-1.5V0h6v3.4c1.4.3 2.7.8 3.9 1.5L41 2.6l4.3 4.2L43 9.2c.7 1.2 1.3 2.4 1.6 3.8h3.3v6zm-16 4a7 7 0 100-14 7 7 0 000 14z" }));
}

// src/components/icons/FeatureGiftbox.tsx
import * as React255 from "react";
var componentNameString250 = "FeatureGiftbox";
function FeatureGiftbox({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString250,
    ...props
  });
  return /* @__PURE__ */ React255.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React255.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React255.createElement("path", { d: "M0 48h48V24H0v24zm6-6h36V30H6v12z" }), /* @__PURE__ */ React255.createElement(
    "polygon",
    {
      points: "36.003 0 24.007 11.998 11.995 0 7.753 4.242 15.505 11.998 .001 11.998 .001 17.999 48 17.999 48 11.998 32.49 11.998 40.245 4.242",
      className: "sc-Icon--primary-color"
    }
  ));
}

// src/components/icons/FeatureGlitter24.tsx
import * as React256 from "react";
var componentNameString251 = "FeatureGlitter24";
function FeatureGlitter24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString251,
    ...props
  });
  return /* @__PURE__ */ React256.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React256.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React256.createElement("path", { d: "M17.5 3L16.5547 5.55468L14 6.5L16.5547 7.44532L17.5 10L18.4453 7.44532L21 6.5L18.4453 5.55468L17.5 3Z" }), /* @__PURE__ */ React256.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.1607 9.83927L10 4L7.83927 9.83927L2 12L7.83927 14.1607L10 20L12.1607 14.1607L18 12L12.1607 9.83927ZM12.2369 12L10.6042 11.3958L10 9.76308L9.39583 11.3958L7.76308 12L9.39583 12.6042L10 14.2369L10.6042 12.6042L12.2369 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React256.createElement("path", { d: "M16.5547 16.5547L17.5 14L18.4453 16.5547L21 17.5L18.4453 18.4453L17.5 21L16.5547 18.4453L14 17.5L16.5547 16.5547Z" }));
}

// src/components/icons/FeatureGlitter48.tsx
import * as React257 from "react";
var componentNameString252 = "FeatureGlitter48";
function FeatureGlitter48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString252,
    ...props
  });
  return /* @__PURE__ */ React257.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React257.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React257.createElement("path", { d: "M36.8906 11.1094L35 6L33.1094 11.1094L28 13L33.1094 14.8906L35 20L36.8906 14.8906L42 13L36.8906 11.1094Z" }), /* @__PURE__ */ React257.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24.3215 19.6785L20 8L15.6785 19.6785L4 24L15.6785 28.3215L20 40L24.3215 28.3215L36 24L24.3215 19.6785ZM25.9146 24L21.5975 22.4025L20 18.0854L18.4025 22.4025L14.0854 24L18.4025 25.5975L20 29.9146L21.5975 25.5975L25.9146 24Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React257.createElement("path", { d: "M35 28L36.8906 33.1094L42 35L36.8906 36.8906L35 42L33.1094 36.8906L28 35L33.1094 33.1094L35 28Z" }));
}

// src/components/icons/FeatureGlitter72.tsx
import * as React258 from "react";
var componentNameString253 = "FeatureGlitter72";
function FeatureGlitter72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString253,
    ...props
  });
  return /* @__PURE__ */ React258.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React258.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React258.createElement("path", { d: "M55.7009 16.2991L53 9L50.2991 16.2991L43 19L50.2991 21.7009L53 29L55.7009 21.7009L63 19L55.7009 16.2991Z" }), /* @__PURE__ */ React258.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.2121 29.7879L32 13L25.7879 29.7879L9 36L25.7879 42.2121L32 59L38.2121 42.2121L55 36L38.2121 29.7879ZM40.5923 36L34.3207 33.6793L32 27.4077L29.6793 33.6793L23.4077 36L29.6793 38.3207L32 44.5923L34.3207 38.3207L40.5923 36Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React258.createElement("path", { d: "M53 43L55.7009 50.2991L63 53L55.7009 55.7009L53 63L50.2991 55.7009L43 53L50.2991 50.2991L53 43Z" }));
}

// src/components/icons/FeatureGlobe24.tsx
import * as React259 from "react";
var componentNameString254 = "FeatureGlobe24";
function FeatureGlobe24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString254,
    ...props
  });
  return /* @__PURE__ */ React259.createElement("svg", { viewBox: "0 0 27 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React259.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React259.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.0874 12.0808C19.7908 10.3774 19.7908 7.61573 18.0874 5.91236C16.3841 4.20899 13.6224 4.20899 11.919 5.91236C10.2156 7.61573 10.2156 10.3774 11.919 12.0808C13.6224 13.7842 16.3841 13.7842 18.0874 12.0808ZM19.5017 13.495C21.9861 11.0106 21.9861 6.98256 19.5017 4.49815C17.0172 2.01373 12.9892 2.01373 10.5048 4.49815C8.02037 6.98256 8.02037 11.0106 10.5048 13.495C12.9892 15.9794 17.0172 15.9794 19.5017 13.495Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React259.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8.71224 4.11947C6.28569 7.24159 6.50673 11.7552 9.37535 14.6238C12.244 17.4924 16.7576 17.7135 19.8797 15.2869L19.4294 14.8366L20.8436 13.4224L22.7521 15.3309L22.045 16.038C18.1559 19.9272 11.8503 19.9272 7.96113 16.038C4.07197 12.1489 4.07197 5.84331 7.96113 1.95415L8.66824 1.24704L10.5768 3.15558L9.16257 4.5698L8.71224 4.11947Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React259.createElement("path", { fillRule: "evenodd", d: "M14 20.9998L14 17.6665L16 17.6665L16 20.9998L14 20.9998Z", clipRule: "evenodd" }), /* @__PURE__ */ React259.createElement("path", { fillRule: "evenodd", d: "M20 22H10V20H20V22Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureGlobe48.tsx
import * as React260 from "react";
var componentNameString255 = "FeatureGlobe48";
function FeatureGlobe48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString255,
    ...props
  });
  return /* @__PURE__ */ React260.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React260.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React260.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M30.5 24.5a9.2 9.2 0 10-13-13 9.2 9.2 0 0013 13zM33 27A12.7 12.7 0 1015 9a12.7 12.7 0 0018 18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React260.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.4 7.9a16.2 16.2 0 0022.7 22.7l-1-1.1 2.4-2.5 3.7 3.7-1.3 1.2A19.7 19.7 0 1110.1 4.1l1.2-1.3L15 6.5 12.5 9l-1.1-1.1z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React260.createElement("path", { fillRule: "evenodd", d: "M22.3 42v-6.7h3.4V42h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React260.createElement("path", { fillRule: "evenodd", d: "M34 43.8H14v-3.5h20v3.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureGlobe72.tsx
import * as React261 from "react";
var componentNameString256 = "FeatureGlobe72";
function FeatureGlobe72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString256,
    ...props
  });
  return /* @__PURE__ */ React261.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React261.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React261.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M46 37a14 14 0 10-20-20 14 14 0 0020 20zm3.5 3.5a19 19 0 10-27-27 19 19 0 0027 27z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React261.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17 11.6A24.4 24.4 0 0051.5 46l-1.8-1.7 3.6-3.6 5.3 5.4-1.7 1.8A29.4 29.4 0 0115.2 6.2L17 4.4l5.4 5.4-3.6 3.6-1.7-1.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React261.createElement("path", { fillRule: "evenodd", d: "M33.5 63V53h5v10h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React261.createElement("path", { fillRule: "evenodd", d: "M51 65.5H21v-5h30v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureGlobe.tsx
import * as React262 from "react";
var componentNameString257 = "FeatureGlobe";
function FeatureGlobe({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString257,
    ...props
  });
  return /* @__PURE__ */ React262.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React262.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React262.createElement("path", { d: "M0 24a24 24 0 1148 0 24 24 0 01-48 0zm4 0a20 20 0 1040 0 20 20 0 00-40 0zm4 0a16 16 0 1132 0 16 16 0 01-32 0zm4 0a12 12 0 1024 0 12 12 0 00-24 0z" }), /* @__PURE__ */ React262.createElement("path", { d: "M24 16a8 8 0 110 16 8 8 0 010-16zm0 12a4 4 0 100-8 4 4 0 000 8z" }));
}

// src/components/icons/FeatureGraphBar.tsx
import * as React263 from "react";
var componentNameString258 = "FeatureGraphBar";
function FeatureGraphBar({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString258,
    ...props
  });
  return /* @__PURE__ */ React263.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React263.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React263.createElement("path", { d: "M0 48V24h10v24H0zm19 0V12h10v36H19z" }), /* @__PURE__ */ React263.createElement("polygon", { points: "38 48 48 48 48 0 38 0", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureGraphDots.tsx
import * as React264 from "react";
var componentNameString259 = "FeatureGraphDots";
function FeatureGraphDots({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString259,
    ...props
  });
  return /* @__PURE__ */ React264.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React264.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React264.createElement("path", { d: "M13 8A5 5 0 113 8a5 5 0 0110 0zm16 0a5 5 0 11-10 0 5 5 0 0110 0zM13 24a5 5 0 11-10 0 5 5 0 0110 0z" }), /* @__PURE__ */ React264.createElement("path", { d: "M45 8a5 5 0 11-10 0 5 5 0 0110 0zM29 24a5 5 0 11-10 0 5 5 0 0110 0zm16 0a5 5 0 11-10 0 5 5 0 0110 0zM13 40a5 5 0 11-10 0 5 5 0 0110 0zm16 0a5 5 0 11-10 0 5 5 0 0110 0zm16 0a5 5 0 11-10 0 5 5 0 0110 0z" }));
}

// src/components/icons/FeatureGraphLineAngles.tsx
import * as React265 from "react";
var componentNameString260 = "FeatureGraphLineAngles";
function FeatureGraphLineAngles({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString260,
    ...props
  });
  return /* @__PURE__ */ React265.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React265.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React265.createElement("polygon", { points: "26.416 25.012 46 5 2 5 2 38.515 15.496 22.177", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React265.createElement("polygon", { points: "29.775 31.238 18.688 29.161 2 43 46 43 46 20.853", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureGraphLineCurves.tsx
import * as React266 from "react";
var componentNameString261 = "FeatureGraphLineCurves";
function FeatureGraphLineCurves({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString261,
    ...props
  });
  return /* @__PURE__ */ React266.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React266.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React266.createElement("path", { d: "M46 5H2v33.5s8.4-14 13.7-15.8c4.7-1.5 7.4 5 13 2.5C36.5 21.6 46 5 46 5z" }), /* @__PURE__ */ React266.createElement("path", { d: "M46 43H2s9.1-12 14.4-13c5.3-1.2 8.3 6.4 15.2 3.2 7-3.3 14.4-11.3 14.4-11.3V43z" }));
}

// src/components/icons/FeatureGraphPie.tsx
import * as React267 from "react";
var componentNameString262 = "FeatureGraphPie";
function FeatureGraphPie({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString262,
    ...props
  });
  return /* @__PURE__ */ React267.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React267.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React267.createElement("path", { d: "M42 27A21 21 0 1121 6v21h21z" }), /* @__PURE__ */ React267.createElement("path", { d: "M48 21A21 21 0 0027 0v21h21z" }));
}

// src/components/icons/FeatureGuidance24.tsx
import * as React268 from "react";
var COMPONENT_NAME = "FeatureGuidance24";
function FeatureGuidance24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: COMPONENT_NAME,
    ...props
  });
  return /* @__PURE__ */ React268.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title && /* @__PURE__ */ React268.createElement("title", { id: titleId }, title), /* @__PURE__ */ React268.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9 20L12 23L15 20H19C19.55 20 20.0208 19.8042 20.4125 19.4125C20.8042 19.0208 21 18.55 21 18V4C21 3.45 20.8042 2.97917 20.4125 2.5875C20.0208 2.19583 19.55 2 19 2H5C4.45 2 3.97917 2.19583 3.5875 2.5875C3.19583 2.97917 3 3.45 3 4V18C3 18.55 3.19583 19.0208 3.5875 19.4125C3.97917 19.8042 4.45 20 5 20H9ZM17.0289 11L13.5789 12.55L12.0289 16L10.4789 12.55L7.02893 11L10.4789 9.45001L12.0289 6.00001L13.5789 9.45001L17.0289 11Z"
    }
  ));
}

// src/components/icons/FeatureHamburger24.tsx
import * as React269 from "react";
var componentNameString263 = "FeatureHamburger24";
function FeatureHamburger24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString263,
    ...props
  });
  return /* @__PURE__ */ React269.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React269.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React269.createElement("path", { fillRule: "evenodd", d: "M21 13H3V11H21V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React269.createElement("path", { fillRule: "evenodd", d: "M21 18H3V16H21V18Z", clipRule: "evenodd" }), /* @__PURE__ */ React269.createElement("path", { fillRule: "evenodd", d: "M21 8H3V6H21V8Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureHamburger48.tsx
import * as React270 from "react";
var componentNameString264 = "FeatureHamburger48";
function FeatureHamburger48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString264,
    ...props
  });
  return /* @__PURE__ */ React270.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React270.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React270.createElement("path", { fillRule: "evenodd", d: "M42 25.8H6v-3.6h36v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React270.createElement("path", { fillRule: "evenodd", d: "M42 35.8H6v-3.5h36v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React270.createElement("path", { fillRule: "evenodd", d: "M42 15.8H6v-3.6h36v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureHamburger72.tsx
import * as React271 from "react";
var componentNameString265 = "FeatureHamburger72";
function FeatureHamburger72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString265,
    ...props
  });
  return /* @__PURE__ */ React271.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React271.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React271.createElement("path", { fillRule: "evenodd", d: "M63 38.5H9v-5h54v5z", clipRule: "evenodd" }), /* @__PURE__ */ React271.createElement("path", { fillRule: "evenodd", d: "M63 53.5H9v-5h54v5z", clipRule: "evenodd" }), /* @__PURE__ */ React271.createElement("path", { fillRule: "evenodd", d: "M63 23.5H9v-5h54v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureHearts.tsx
import * as React272 from "react";
var componentNameString266 = "FeatureHearts";
function FeatureHearts({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString266,
    ...props
  });
  return /* @__PURE__ */ React272.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React272.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React272.createElement("path", { d: "M15.8 25.3a10.3 10.3 0 01-3-6.6A7.5 7.5 0 102.2 29.3L12.8 40l8.8-8.8-5.8-5.8z" }), /* @__PURE__ */ React272.createElement("path", { d: "M45 10.7a10.3 10.3 0 00-14.6 0 10.3 10.3 0 00-17.6 8 7.5 7.5 0 0110.5 0c3 3 3 7.7 0 10.6l-1.7 1.8 8.8 8.8L45 25.3c4-4 4-10.6 0-14.6" }));
}

// src/components/icons/FeatureHouse24.tsx
import * as React273 from "react";
var componentNameString267 = "FeatureHouse24";
function FeatureHouse24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString267,
    ...props
  });
  return /* @__PURE__ */ React273.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React273.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React273.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5 10.8981V19H8V16C8 13.7909 9.79086 12 12 12C14.2091 12 16 13.7909 16 16V19H19V10.8981L12 4.67591L5 10.8981ZM12 2L3 10V21H10V16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16V21H21V10L12 2Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureHouse48.tsx
import * as React274 from "react";
var componentNameString268 = "FeatureHouse48";
function FeatureHouse48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString268,
    ...props
  });
  return /* @__PURE__ */ React274.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React274.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React274.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.5 21.6v16.9h7V32a7.5 7.5 0 0115 0v6.5h7v-17L24 8.8 9.5 21.6zM24 4L6 20v22h14V32a4 4 0 018 0v10h14V20L24 4z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React274.createElement("path", { fillRule: "evenodd", d: "M38.5 10.8h-3v2.6l3 2.7v-5.3zM42 24l-10-9V7.3h10V24z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureHouse72.tsx
import * as React275 from "react";
var componentNameString269 = "FeatureHouse72";
function FeatureHouse72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString269,
    ...props
  });
  return /* @__PURE__ */ React275.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React275.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React275.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14 32.2V58h11V48a11 11 0 0122 0v10h11V32.2L36 12.7 14 32.2zM36 6L9 30v33h21V48a6 6 0 0112 0v15h21V30L36 6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React275.createElement("path", { fillRule: "evenodd", d: "M58 16h-5v4.3l5 4.5V16zm5 20L48 22.5V11h15v25z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureHouse.tsx
import * as React276 from "react";
var componentNameString270 = "FeatureHouse";
function FeatureHouse({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString270,
    ...props
  });
  return /* @__PURE__ */ React276.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React276.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React276.createElement("polygon", { points: "38 27 24 16.3 10 27 10 44 20 44 20 32 28 32 28 44 38 44", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React276.createElement(
    "polygon",
    {
      points: "23.998 11.769 3.675 27.204 .046 22.425 24.002 4.231 34.817 12.464 30 14.851 30 4 36 4 36 20.89 31.185 17.24 30 16.338 30 4 36 4 36 14.851 34.812 12.46 47.953 22.422 44.328 27.203 36 20.89 36 20.905 31.185 17.24 30 16.342",
      className: "sc-Icon--primary-color"
    }
  ));
}

// src/components/icons/FeatureHsa24.tsx
import * as React277 from "react";
var componentNameString271 = "FeatureHsa24";
function FeatureHsa24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString271,
    ...props
  });
  return /* @__PURE__ */ React277.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React277.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React277.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 1.6665H6V3.6665H5V7.99984C5 9.65669 6.34315 10.9998 8 10.9998C9.65685 10.9998 11 9.65669 11 7.99984V3.6665H10V1.6665H13V7.99984C13 10.7613 10.7614 12.9998 8 12.9998C5.23858 12.9998 3 10.7613 3 7.99984V1.6665Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React277.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.75 10C16.0596 10 15.5 10.5596 15.5 11.25V16.9167C15.5 19.2639 13.5972 21.1667 11.25 21.1667C8.90279 21.1667 7 19.2639 7 16.9167V12.3333H9V16.9167C9 18.1593 10.0074 19.1667 11.25 19.1667C12.4926 19.1667 13.5 18.1593 13.5 16.9167V11.25C13.5 9.45508 14.9551 8 16.75 8C18.5449 8 20 9.45507 20 11.25V17.3333H18V11.25C18 10.5596 17.4404 10 16.75 10Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React277.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 21C20.1046 21 21 20.1046 21 19C21 17.8954 20.1046 17 19 17C17.8954 17 17 17.8954 17 19C17 20.1046 17.8954 21 19 21ZM19 19.6668C19.3682 19.6668 19.6667 19.3684 19.6667 19.0002C19.6667 18.632 19.3682 18.3335 19 18.3335C18.6319 18.3335 18.3334 18.632 18.3334 19.0002C18.3334 19.3684 18.6319 19.6668 19 19.6668Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureHsa48.tsx
import * as React278 from "react";
var componentNameString272 = "FeatureHsa48";
function FeatureHsa48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString272,
    ...props
  });
  return /* @__PURE__ */ React278.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React278.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React278.createElement("path", { d: "M42 38a4 4 0 11-8 0 4 4 0 018 0z" }), /* @__PURE__ */ React278.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6.3 3.6H12V7H9.7v9a6.3 6.3 0 0012.6 0V7H20V3.7h5.8V16a9.8 9.8 0 01-19.6 0V3.6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React278.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M33.5 19.8a2.7 2.7 0 00-2.8 2.7v11.3a8.2 8.2 0 11-16.4 0v-9.1h3.4v9.1a4.7 4.7 0 109.6 0V22.5a6.2 6.2 0 1112.4 0v12.2h-3.5V22.5c0-1.5-1.2-2.8-2.7-2.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React278.createElement("path", { d: "M39.3 38a1.3 1.3 0 11-2.6 0 1.3 1.3 0 012.6 0z" }));
}

// src/components/icons/FeatureHsa72.tsx
import * as React279 from "react";
var componentNameString273 = "FeatureHsa72";
function FeatureHsa72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString273,
    ...props
  });
  return /* @__PURE__ */ React279.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React279.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React279.createElement("path", { d: "M63 57a6 6 0 11-12 0 6 6 0 0112 0z" }), /* @__PURE__ */ React279.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.5 5.5H18v5h-3.5V24a9.5 9.5 0 0019 0V10.5H30v-5h8.5V24a14.5 14.5 0 01-29 0V5.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React279.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M50.3 29.5a4.3 4.3 0 00-4.3 4.3v17a12.2 12.2 0 11-24.5 0V37h5v13.8a7.2 7.2 0 1014.5 0v-17a9.3 9.3 0 0118.5 0V52h-5V33.7c0-2.3-1.9-4.2-4.3-4.2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React279.createElement("path", { d: "M59 57a2 2 0 11-4 0 2 2 0 014 0z" }));
}

// src/components/icons/FeatureImage24.tsx
import * as React280 from "react";
var componentNameString274 = "FeatureImage24";
function FeatureImage24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString274,
    ...props
  });
  return /* @__PURE__ */ React280.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React280.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React280.createElement("circle", { cx: 7.5, cy: 9.5, r: 1.5 }), /* @__PURE__ */ React280.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20 6H4V18H20V6ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React280.createElement("path", { d: "M8.41421 15L12 11.4142L15.5858 15H8.41421Z" }));
}

// src/components/icons/FeatureImage48.tsx
import * as React281 from "react";
var componentNameString275 = "FeatureImage48";
function FeatureImage48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString275,
    ...props
  });
  return /* @__PURE__ */ React281.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React281.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React281.createElement("path", { d: "M18 19a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React281.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40 11.5H8c-.3 0-.5.2-.5.5v24c0 .3.2.5.5.5h32c.3 0 .5-.2.5-.5V12c0-.3-.2-.5-.5-.5zM8 8a4 4 0 00-4 4v24a4 4 0 004 4h32a4 4 0 004-4V12a4 4 0 00-4-4H8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React281.createElement("path", { d: "M24 20l12 12H12l12-12z" }), /* @__PURE__ */ React281.createElement("path", { fillRule: "evenodd", d: "M24 20l12 12H12l12-12zm0 2.8L16.8 30h14.4L24 22.8z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureImage72.tsx
import * as React282 from "react";
var componentNameString276 = "FeatureImage72";
function FeatureImage72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString276,
    ...props
  });
  return /* @__PURE__ */ React282.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React282.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React282.createElement("path", { d: "M27 28.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" }), /* @__PURE__ */ React282.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M60 17H12a1 1 0 00-1 1v36c0 .6.4 1 1 1h48c.6 0 1-.4 1-1V18c0-.6-.4-1-1-1zm-48-5a6 6 0 00-6 6v36a6 6 0 006 6h48a6 6 0 006-6V18a6 6 0 00-6-6H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React282.createElement("path", { d: "M36 30l18 18H18l18-18z" }), /* @__PURE__ */ React282.createElement("path", { fillRule: "evenodd", d: "M36 30l18 18H18l18-18zm0 2.8L22.8 46h26.4L36 32.8z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInfo24.tsx
import * as React283 from "react";
var componentNameString277 = "FeatureInfo24";
function FeatureInfo24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString277,
    ...props
  });
  return /* @__PURE__ */ React283.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React283.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React283.createElement("path", { fillRule: "evenodd", d: "M21 13H7V11H21V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React283.createElement("path", { fillRule: "evenodd", d: "M5 13H3V11H5V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React283.createElement("path", { fillRule: "evenodd", d: "M21 17H7V15H21V17Z", clipRule: "evenodd" }), /* @__PURE__ */ React283.createElement("path", { fillRule: "evenodd", d: "M5 17H3V15H5V17Z", clipRule: "evenodd" }), /* @__PURE__ */ React283.createElement("path", { fillRule: "evenodd", d: "M21 9H7V7H21V9Z", clipRule: "evenodd" }), /* @__PURE__ */ React283.createElement("path", { fillRule: "evenodd", d: "M5 9H3V7H5V9Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInfo48.tsx
import * as React284 from "react";
var componentNameString278 = "FeatureInfo48";
function FeatureInfo48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString278,
    ...props
  });
  return /* @__PURE__ */ React284.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React284.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React284.createElement("path", { fillRule: "evenodd", d: "M42 25.8H13.3v-3.6H42v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React284.createElement("path", { fillRule: "evenodd", d: "M9.8 25.8H6v-3.6h3.8v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React284.createElement("path", { fillRule: "evenodd", d: "M42 33.8H13.3v-3.5H42v3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React284.createElement("path", { fillRule: "evenodd", d: "M9.8 33.8H6v-3.5h3.8v3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React284.createElement("path", { fillRule: "evenodd", d: "M42 17.8H13.3v-3.6H42v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React284.createElement("path", { fillRule: "evenodd", d: "M9.8 17.8H6v-3.6h3.8v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInfo72.tsx
import * as React285 from "react";
var componentNameString279 = "FeatureInfo72";
function FeatureInfo72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString279,
    ...props
  });
  return /* @__PURE__ */ React285.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React285.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React285.createElement("path", { fillRule: "evenodd", d: "M63 38.5H20v-5h43v5z", clipRule: "evenodd" }), /* @__PURE__ */ React285.createElement("path", { fillRule: "evenodd", d: "M14 38.5H9v-5h5v5z", clipRule: "evenodd" }), /* @__PURE__ */ React285.createElement("path", { fillRule: "evenodd", d: "M63 50.5H20v-5h43v5z", clipRule: "evenodd" }), /* @__PURE__ */ React285.createElement("path", { fillRule: "evenodd", d: "M14 50.5H9v-5h5v5z", clipRule: "evenodd" }), /* @__PURE__ */ React285.createElement("path", { fillRule: "evenodd", d: "M63 26.5H20v-5h43v5z", clipRule: "evenodd" }), /* @__PURE__ */ React285.createElement("path", { fillRule: "evenodd", d: "M14 26.5H9v-5h5v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInfoBox24.tsx
import * as React286 from "react";
var componentNameString280 = "FeatureInfoBox24";
function FeatureInfoBox24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString280,
    ...props
  });
  return /* @__PURE__ */ React286.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React286.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React286.createElement("path", { fillRule: "evenodd", d: "M17 13H11V11H17V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React286.createElement("path", { fillRule: "evenodd", d: "M9 13H7V11H9V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React286.createElement("path", { fillRule: "evenodd", d: "M17 17H11V15H17V17Z", clipRule: "evenodd" }), /* @__PURE__ */ React286.createElement("path", { fillRule: "evenodd", d: "M9 17H7V15H9V17Z", clipRule: "evenodd" }), /* @__PURE__ */ React286.createElement("path", { fillRule: "evenodd", d: "M17 9H11V7H17V9Z", clipRule: "evenodd" }), /* @__PURE__ */ React286.createElement("path", { fillRule: "evenodd", d: "M9 9H7V7H9V9Z", clipRule: "evenodd" }), /* @__PURE__ */ React286.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 5H5L5 19H19V5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureInfoBox48.tsx
import * as React287 from "react";
var componentNameString281 = "FeatureInfoBox48";
function FeatureInfoBox48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString281,
    ...props
  });
  return /* @__PURE__ */ React287.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React287.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React287.createElement("path", { fillRule: "evenodd", d: "M34 25.8H22v-3.6h12v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React287.createElement("path", { fillRule: "evenodd", d: "M17.7 25.8H14v-3.6h3.7v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React287.createElement("path", { fillRule: "evenodd", d: "M34 33.8H22v-3.5h12v3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React287.createElement("path", { fillRule: "evenodd", d: "M17.7 33.8H14v-3.5h3.7v3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React287.createElement("path", { fillRule: "evenodd", d: "M34 17.8H22v-3.6h12v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React287.createElement("path", { fillRule: "evenodd", d: "M17.7 17.8H14v-3.6h3.7v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React287.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 9.5H10c-.3 0-.5.2-.5.5v28c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5V10c0-.3-.2-.5-.5-.5zM10 6a4 4 0 00-4 4v28a4 4 0 004 4h28a4 4 0 004-4V10a4 4 0 00-4-4H10z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureInfoBox72.tsx
import * as React288 from "react";
var componentNameString282 = "FeatureInfoBox72";
function FeatureInfoBox72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString282,
    ...props
  });
  return /* @__PURE__ */ React288.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React288.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React288.createElement("path", { fillRule: "evenodd", d: "M51 38.5H33v-5h18v5z", clipRule: "evenodd" }), /* @__PURE__ */ React288.createElement("path", { fillRule: "evenodd", d: "M26.5 38.5H21v-5h5.5v5z", clipRule: "evenodd" }), /* @__PURE__ */ React288.createElement("path", { fillRule: "evenodd", d: "M51 50.5H33v-5h18v5z", clipRule: "evenodd" }), /* @__PURE__ */ React288.createElement("path", { fillRule: "evenodd", d: "M26.5 50.5H21v-5h5.5v5z", clipRule: "evenodd" }), /* @__PURE__ */ React288.createElement("path", { fillRule: "evenodd", d: "M51 26.5H33v-5h18v5z", clipRule: "evenodd" }), /* @__PURE__ */ React288.createElement("path", { fillRule: "evenodd", d: "M26.5 26.5H21v-5h5.5v5z", clipRule: "evenodd" }), /* @__PURE__ */ React288.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14 14v44h44V14H14zm-3-5a2 2 0 00-2 2v50c0 1.1.9 2 2 2h50a2 2 0 002-2V11a2 2 0 00-2-2H11z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureInfoInCircle24.tsx
import * as React289 from "react";
var componentNameString283 = "FeatureInfoInCircle24";
function FeatureInfoInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString283,
    ...props
  });
  return /* @__PURE__ */ React289.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React289.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React289.createElement("path", { d: "M13 7V9H11V7H13Z" }), /* @__PURE__ */ React289.createElement("path", { d: "M11 17V11H13V17H11Z" }), /* @__PURE__ */ React289.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureInfoInCircle48.tsx
import * as React290 from "react";
var componentNameString284 = "FeatureInfoInCircle48";
function FeatureInfoInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString284,
    ...props
  });
  return /* @__PURE__ */ React290.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React290.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React290.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React290.createElement("path", { fillRule: "evenodd", d: "M25.8 20.5v13h-3.6v-13h3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React290.createElement("path", { fillRule: "evenodd", d: "M25.8 14v3.5h-3.6V14h3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInfoInCircle72.tsx
import * as React291 from "react";
var componentNameString285 = "FeatureInfoInCircle72";
function FeatureInfoInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString285,
    ...props
  });
  return /* @__PURE__ */ React291.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React291.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React291.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React291.createElement("path", { fillRule: "evenodd", d: "M38.5 32v18h-5V32h5z", clipRule: "evenodd" }), /* @__PURE__ */ React291.createElement("path", { fillRule: "evenodd", d: "M38.5 22v5h-5v-5h5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInfo.tsx
import * as React292 from "react";
var componentNameString286 = "FeatureInfo";
function FeatureInfo({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString286,
    ...props
  });
  return /* @__PURE__ */ React292.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React292.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React292.createElement("path", { d: "M0 28v-8h8v8H0zm16 0v-8h32v8H16zM0 44v-8h8v8H0zm16 0v-8h32v8H16z" }), /* @__PURE__ */ React292.createElement("path", { d: "M0 12V4h8v8H0zm16 0V4h32v8H16z" }));
}

// src/components/icons/FeatureInheritance24.tsx
import * as React293 from "react";
var componentNameString287 = "FeatureInheritance24";
function FeatureInheritance24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString287,
    ...props
  });
  return /* @__PURE__ */ React293.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React293.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React293.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14ZM12 16C15.866 16 19 12.866 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.866 8.13401 16 12 16Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React293.createElement("path", { fillRule: "evenodd", d: "M11 21L11 15L13 15L13 21L11 21Z", clipRule: "evenodd" }), /* @__PURE__ */ React293.createElement("path", { fillRule: "evenodd", d: "M17 22H7V20H17V22Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritance48.tsx
import * as React294 from "react";
var componentNameString288 = "FeatureInheritance48";
function FeatureInheritance48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString288,
    ...props
  });
  return /* @__PURE__ */ React294.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React294.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React294.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 28.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21zm0 3.5a14 14 0 100-28 14 14 0 000 28z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React294.createElement("path", { fillRule: "evenodd", d: "M22.3 42V30h3.4v12h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React294.createElement("path", { fillRule: "evenodd", d: "M34 43.8H14v-3.5h20v3.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritance72.tsx
import * as React295 from "react";
var componentNameString289 = "FeatureInheritance72";
function FeatureInheritance72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString289,
    ...props
  });
  return /* @__PURE__ */ React295.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React295.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React295.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 43a16 16 0 100-32 16 16 0 000 32zm0 5a21 21 0 100-42 21 21 0 000 42z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React295.createElement("path", { fillRule: "evenodd", d: "M33.5 63V45h5v18h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React295.createElement("path", { fillRule: "evenodd", d: "M51 65.5H21v-5h30v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritanceTree24.tsx
import * as React296 from "react";
var componentNameString290 = "FeatureInheritanceTree24";
function FeatureInheritanceTree24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString290,
    ...props
  });
  return /* @__PURE__ */ React296.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React296.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React296.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13ZM16 15C18.2091 15 20 13.2091 20 11C20 8.79086 18.2091 7 16 7C13.7909 7 12 8.79086 12 11C12 13.2091 13.7909 15 16 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React296.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 13C9.10457 13 10 12.1046 10 11C10 9.89543 9.10457 9 8 9C6.89543 9 6 9.89543 6 11C6 12.1046 6.89543 13 8 13ZM8 15C10.2091 15 12 13.2091 12 11C12 8.79086 10.2091 7 8 7C5.79086 7 4 8.79086 4 11C4 13.2091 5.79086 15 8 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React296.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7ZM12 9C14.2091 9 16 7.20914 16 5C16 2.79086 14.2091 1 12 1C9.79086 1 8 2.79086 8 5C8 7.20914 9.79086 9 12 9Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React296.createElement("path", { fillRule: "evenodd", d: "M11 21L11 8L13 8L13 21L11 21Z", clipRule: "evenodd" }), /* @__PURE__ */ React296.createElement("path", { fillRule: "evenodd", d: "M17 22H7V20H17V22Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritanceTree48.tsx
import * as React297 from "react";
var componentNameString291 = "FeatureInheritanceTree48";
function FeatureInheritanceTree48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString291,
    ...props
  });
  return /* @__PURE__ */ React297.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React297.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React297.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32 26.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React297.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 26.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React297.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 14.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React297.createElement("path", { fillRule: "evenodd", d: "M22.3 42V16h3.4v26h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React297.createElement("path", { fillRule: "evenodd", d: "M34 43.8H14v-3.5h20v3.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritanceTree72.tsx
import * as React298 from "react";
var componentNameString292 = "FeatureInheritanceTree72";
function FeatureInheritanceTree72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString292,
    ...props
  });
  return /* @__PURE__ */ React298.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React298.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React298.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 40a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React298.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 21a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React298.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M23.5 27a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 5a8.5 8.5 0 100-17 8.5 8.5 0 000 17z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React298.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M48.5 27a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 5a8.5 8.5 0 100-17 8.5 8.5 0 000 17z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React298.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.5 40a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 5a8.5 8.5 0 100-17 8.5 8.5 0 000 17z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React298.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M51.5 40a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 5a8.5 8.5 0 100-17 8.5 8.5 0 000 17z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React298.createElement("path", { fillRule: "evenodd", d: "M33.5 63V48h5v15h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React298.createElement("path", { fillRule: "evenodd", d: "M51 65.5H21v-5h30v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritanceTreeAlt24.tsx
import * as React299 from "react";
var componentNameString293 = "FeatureInheritanceTreeAlt24";
function FeatureInheritanceTreeAlt24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString293,
    ...props
  });
  return /* @__PURE__ */ React299.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React299.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React299.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React299.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7ZM12 9C14.2091 9 16 7.20914 16 5C16 2.79086 14.2091 1 12 1C9.79086 1 8 2.79086 8 5C8 7.20914 9.79086 9 12 9Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React299.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9ZM8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React299.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9ZM16 11C17.6569 11 19 9.65685 19 8C19 6.34315 17.6569 5 16 5C14.3431 5 13 6.34315 13 8C13 9.65685 14.3431 11 16 11Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React299.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13ZM7 15C8.65685 15 10 13.6569 10 12C10 10.3431 8.65685 9 7 9C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React299.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11C16.4477 11 16 11.4477 16 12C16 12.5523 16.4477 13 17 13ZM17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React299.createElement("path", { fillRule: "evenodd", d: "M11 21L11 16L13 16L13 21L11 21Z", clipRule: "evenodd" }), /* @__PURE__ */ React299.createElement("path", { fillRule: "evenodd", d: "M17 22H7V20H17V22Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritanceTreeAlt48.tsx
import * as React300 from "react";
var componentNameString294 = "FeatureInheritanceTreeAlt48";
function FeatureInheritanceTreeAlt48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString294,
    ...props
  });
  return /* @__PURE__ */ React300.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React300.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React300.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 26.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React300.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 13.8a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React300.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.7 17.8a2.2 2.2 0 100-4.3 2.2 2.2 0 000 4.3zm0 3.5a5.7 5.7 0 100-11.3 5.7 5.7 0 000 11.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React300.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32.3 17.8a2.2 2.2 0 100-4.3 2.2 2.2 0 000 4.3zm0 3.5a5.7 5.7 0 100-11.3 5.7 5.7 0 000 11.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React300.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.7 26.5a2.2 2.2 0 100-4.3 2.2 2.2 0 000 4.3zm0 3.5a5.7 5.7 0 100-11.3 5.7 5.7 0 000 11.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React300.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34.3 26.5a2.2 2.2 0 100-4.3 2.2 2.2 0 000 4.3zm0 3.5a5.7 5.7 0 100-11.3 5.7 5.7 0 000 11.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React300.createElement("path", { fillRule: "evenodd", d: "M22.3 42V32h3.4v10h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React300.createElement("path", { fillRule: "evenodd", d: "M34 43.8H14v-3.5h20v3.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInheritanceTreeAlt72.tsx
import * as React301 from "react";
var componentNameString295 = "FeatureInheritanceTreeAlt72";
function FeatureInheritanceTreeAlt72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString295,
    ...props
  });
  return /* @__PURE__ */ React301.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React301.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React301.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M48 40a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React301.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React301.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 22a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React301.createElement("path", { fillRule: "evenodd", d: "M33.5 63V24h5v39h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React301.createElement("path", { fillRule: "evenodd", d: "M51 65.5H21v-5h30v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureInvesting24.tsx
import * as React302 from "react";
var componentNameString296 = "FeatureInvesting24";
function FeatureInvesting24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString296,
    ...props
  });
  return /* @__PURE__ */ React302.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React302.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React302.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.00246 12.2005C3.35548 12.069 2.6858 12 2 12C2 12.6858 2.06904 13.3555 2.20054 14.0025C2.99653 17.9187 6.08127 21.0035 9.99754 21.7995C10.6445 21.931 11.3142 22 12 22C12 21.3142 11.931 20.6445 11.7995 19.9975C11.0035 16.0813 7.91873 12.9965 4.00246 12.2005ZM9.64896 19.649C7.12139 18.873 5.127 16.8786 4.35104 14.351C6.87861 15.127 8.873 17.1214 9.64896 19.649Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React302.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.9975 12.2005C20.6445 12.069 21.3142 12 22 12C22 12.6858 21.931 13.3555 21.7995 14.0025C21.0035 17.9187 17.9187 21.0035 14.0025 21.7995C13.3555 21.931 12.6858 22 12 22C12 21.3142 12.069 20.6445 12.2005 19.9975C12.9965 16.0813 16.0813 12.9965 19.9975 12.2005ZM14.351 19.649C16.8786 18.873 18.873 16.8786 19.649 14.351C17.1214 15.127 15.127 17.1214 14.351 19.649Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React302.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14 12C14 11.6494 13.9098 11.3198 13.7512 11.0332C13.9201 11.3138 14.1604 11.5567 14.4641 11.7321C15.4207 12.2843 16.6439 11.9566 17.1962 11C17.7484 10.0434 17.4207 8.82024 16.4641 8.26795C16.1603 8.09257 15.8297 8.00594 15.5022 8C15.8297 7.99406 16.1603 7.90743 16.4641 7.73205C17.4207 7.17976 17.7484 5.95658 17.1962 5C16.6439 4.04341 15.4207 3.71566 14.4641 4.26794C14.1604 4.44327 13.9201 4.6862 13.7513 4.96674C13.9098 4.68021 14 4.35064 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 4.35066 10.0903 4.68025 10.2488 4.9668C10.0799 4.68623 9.83959 4.44329 9.5359 4.26795C8.57932 3.71567 7.35614 4.04342 6.80385 5C6.25157 5.95659 6.57932 7.17977 7.5359 7.73206C7.83951 7.90734 8.16997 7.99398 8.49731 8C8.16997 8.00602 7.83951 8.09266 7.5359 8.26794C6.57932 8.82023 6.25157 10.0434 6.80385 11C7.35614 11.9566 8.57932 12.2843 9.5359 11.732C9.83961 11.5567 10.0799 11.3137 10.2488 11.0331C10.0903 11.3197 10 11.6493 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureInvesting48.tsx
import * as React303 from "react";
var componentNameString297 = "FeatureInvesting48";
function FeatureInvesting48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString297,
    ...props
  });
  return /* @__PURE__ */ React303.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React303.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React303.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.5 24.3C6.4 24.1 5.2 24 4 24a20 20 0 0020 20A20 20 0 007.5 24.3zM20 40c-5.9-1.5-10.5-6-12-12a16.6 16.6 0 0112 12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React303.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40.5 24.3c1.1-.2 2.3-.3 3.5-.3a20 20 0 01-20 20 20 20 0 0116.5-19.7zM28 40a16.6 16.6 0 0012-12 16.6 16.6 0 00-12 12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React303.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28 24a4 4 0 00-.6-2 4 4 0 103.5-6 4 4 0 10-3.5-6 4 4 0 10-7 0 4 4 0 10-3.5 6 4 4 0 103.5 6 4 4 0 107.5 2zm-4-4a4 4 0 100-8 4 4 0 000 8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureInvesting72.tsx
import * as React304 from "react";
var componentNameString298 = "FeatureInvesting72";
function FeatureInvesting72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString298,
    ...props
  });
  return /* @__PURE__ */ React304.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React304.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React304.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11 36.4c-1.6-.3-3.3-.4-5-.4a30 30 0 0030 30 30 30 0 00-25-29.6zm19.4 24a25 25 0 01-18.8-18.8 25 25 0 0118.8 18.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React304.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M61 36.4c1.6-.3 3.3-.4 5-.4a30 30 0 01-30 30 30 30 0 0125-29.6zm-19.4 24a25 25 0 0018.8-18.8 25 25 0 00-18.8 18.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React304.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M43 34.5c0-1.1-.3-2.2-.8-3.1.5.9 1.3 1.7 2.3 2.2a6.5 6.5 0 103.3-12.1 6.5 6.5 0 10-5.7-9.9c.6-.9.9-2 .9-3.1a6.5 6.5 0 10-12.2 3.1 6.5 6.5 0 10-5.7 9.9c-1 0-2.2.3-3.1.9a6.5 6.5 0 108.8 9A6.5 6.5 0 1043 34.5zM36.5 28a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureJointCash24.tsx
import * as React305 from "react";
var componentNameString299 = "FeatureJointCash24";
function FeatureJointCash24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString299,
    ...props
  });
  return /* @__PURE__ */ React305.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React305.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React305.createElement("path", { fillRule: "evenodd", d: "M17 7H3V13H17V7ZM1 5V15H19V5H1Z", clipRule: "evenodd" }), /* @__PURE__ */ React305.createElement("circle", { cx: 10, cy: 10, r: 1 }), /* @__PURE__ */ React305.createElement("path", { fillRule: "evenodd", d: "M23 9V19H5V17H21V9H23Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureJointCash48.tsx
import * as React306 from "react";
var componentNameString300 = "FeatureJointCash48";
function FeatureJointCash48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString300,
    ...props
  });
  return /* @__PURE__ */ React306.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React306.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React306.createElement("path", { fillRule: "evenodd", d: "M34.5 13.5h-29v13h29v-13zM2 10v20h36V10H2z", clipRule: "evenodd" }), /* @__PURE__ */ React306.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20 17.8a2.3 2.3 0 100 4.5 2.3 2.3 0 000-4.6zM14.2 20a5.8 5.8 0 1111.6 0 5.8 5.8 0 01-11.6 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React306.createElement("path", { fillRule: "evenodd", d: "M45.8 18v19.8H10v-3.5h32.3V18h3.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureJointCash72.tsx
import * as React307 from "react";
var componentNameString301 = "FeatureJointCash72";
function FeatureJointCash72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString301,
    ...props
  });
  return /* @__PURE__ */ React307.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React307.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React307.createElement("path", { fillRule: "evenodd", d: "M52 20H8v20h44V20zM3 15v30h54V15H3z", clipRule: "evenodd" }), /* @__PURE__ */ React307.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M30 26.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM21.5 30a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React307.createElement("path", { fillRule: "evenodd", d: "M68.5 27v29.5H15v-5h48.5V27h5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureJointChecking24.tsx
import * as React308 from "react";
var componentNameString302 = "FeatureJointChecking24";
function FeatureJointChecking24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString302,
    ...props
  });
  return /* @__PURE__ */ React308.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React308.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React308.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15 4H6L6 16H15V4ZM6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H15C16.1046 18 17 17.1046 17 16V4C17 2.89543 16.1046 2 15 2H6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React308.createElement("path", { d: "M8 3H10V17H8V3Z" }), /* @__PURE__ */ React308.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 20C8 21.1046 8.89543 22 10 22H19C20.1046 22 21 21.1046 21 20V8C21 6.89543 20.1046 6 19 6V8V20H10H8Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureJointChecking48.tsx
import * as React309 from "react";
var componentNameString303 = "FeatureJointChecking48";
function FeatureJointChecking48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString303,
    ...props
  });
  return /* @__PURE__ */ React309.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React309.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React309.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M30 7.5H12c-.3 0-.5.2-.5.5v24c0 .3.2.5.5.5h18c.3 0 .5-.2.5-.5V8c0-.3-.2-.5-.5-.5zM12 4a4 4 0 00-4 4v24a4 4 0 004 4h18a4 4 0 004-4V8a4 4 0 00-4-4H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React309.createElement("path", { d: "M16 6h4v28h-4V6z" }), /* @__PURE__ */ React309.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 40.5a4 4 0 004 3.5h16a6 6 0 006-6V16a4 4 0 00-3.5-4v26c0 1.4-1.1 2.5-2.5 2.5H16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React309.createElement("path", { d: "M24.7 10H28v4h-3.3v-4z" }));
}

// src/components/icons/FeatureJointChecking72.tsx
import * as React310 from "react";
var componentNameString304 = "FeatureJointChecking72";
function FeatureJointChecking72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString304,
    ...props
  });
  return /* @__PURE__ */ React310.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React310.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React310.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M45 11H18a1 1 0 00-1 1v36c0 .6.4 1 1 1h27c.6 0 1-.4 1-1V12c0-.6-.4-1-1-1zM18 6a6 6 0 00-6 6v36a6 6 0 006 6h27a6 6 0 006-6V12a6 6 0 00-6-6H18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React310.createElement("path", { d: "M24 9h6v42h-6V9z" }), /* @__PURE__ */ React310.createElement("path", { fillRule: "evenodd", d: "M24 61a6 6 0 006 5h27a6 6 0 006-6V24a6 6 0 00-5-6v43H24z", clipRule: "evenodd" }), /* @__PURE__ */ React310.createElement("path", { d: "M37 15h5v6h-5v-6z" }));
}

// src/components/icons/FeatureLaptop24.tsx
import * as React311 from "react";
var componentNameString305 = "FeatureLaptop24";
function FeatureLaptop24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString305,
    ...props
  });
  return /* @__PURE__ */ React311.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React311.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React311.createElement("path", { fillRule: "evenodd", d: "M23 20H1V18H23V20Z", clipRule: "evenodd" }), /* @__PURE__ */ React311.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 6H5V15H19V6ZM5 4C3.89543 4 3 4.89543 3 6V15C3 16.1046 3.89543 17 5 17H19C20.1046 17 21 16.1046 21 15V6C21 4.89543 20.1046 4 19 4H5Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLaptop48.tsx
import * as React312 from "react";
var componentNameString306 = "FeatureLaptop48";
function FeatureLaptop48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString306,
    ...props
  });
  return /* @__PURE__ */ React312.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React312.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React312.createElement("path", { fillRule: "evenodd", d: "M46 39.8H2v-3.5h44v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React312.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 11.5H10c-.3 0-.5.2-.5.5v18c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5V12c0-.3-.2-.5-.5-.5zM10 8a4 4 0 00-4 4v18a4 4 0 004 4h28a4 4 0 004-4V12a4 4 0 00-4-4H10z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLaptop72.tsx
import * as React313 from "react";
var componentNameString307 = "FeatureLaptop72";
function FeatureLaptop72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString307,
    ...props
  });
  return /* @__PURE__ */ React313.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React313.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React313.createElement("path", { fillRule: "evenodd", d: "M69 59.5H3v-5h66v5z", clipRule: "evenodd" }), /* @__PURE__ */ React313.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57 17H15a1 1 0 00-1 1v27c0 .6.4 1 1 1h42c.6 0 1-.4 1-1V18c0-.6-.4-1-1-1zm-42-5a6 6 0 00-6 6v27a6 6 0 006 6h42a6 6 0 006-6V18a6 6 0 00-6-6H15z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLaptopCloud.tsx
import * as React314 from "react";
var componentNameString308 = "FeatureLaptopCloud";
function FeatureLaptopCloud({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString308,
    ...props
  });
  return /* @__PURE__ */ React314.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React314.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React314.createElement("path", { d: "M6 29V6h36v23H6zm24.6-5c4.5 0 4.5-6.9 0-6.9.2-5.9-7.3-6.7-9-2.3a3 3 0 00-3.6 2.4c-4.4.5-3.8 6.8.5 6.8h12.1z" }), /* @__PURE__ */ React314.createElement("polygon", { points: "42.384 32 5.615 32 0 41.912 48 41.912", className: "sc-Icon--secondary-color" }));
}

// src/components/icons/FeatureLaptopDownload.tsx
import * as React315 from "react";
var componentNameString309 = "FeatureLaptopDownload";
function FeatureLaptopDownload({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString309,
    ...props
  });
  return /* @__PURE__ */ React315.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React315.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React315.createElement("path", { d: "M6 29V6h36v23H6zm16-18v7.2L19 15l-2 2.2 6.5 6.8 6.5-6.8-2-2.2-3 3.2V11h-3z" }), /* @__PURE__ */ React315.createElement("polygon", { points: "42.384 32.088 5.615 32.088 0 42 48 42", className: "sc-Icon--secondary-color" }));
}

// src/components/icons/FeatureLaptopSecurity.tsx
import * as React316 from "react";
var componentNameString310 = "FeatureLaptopSecurity";
function FeatureLaptopSecurity({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString310,
    ...props
  });
  return /* @__PURE__ */ React316.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React316.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React316.createElement("path", { d: "M6 29V6h36v23H6zm24-9.3v-7.5L24 10l-6 2.2v7.5c0 1.2.7 2.2 2 3.3 1 1 2.5 2 4 3 1.5-1 3-2 4-3 1.3-1 2-2.1 2-3.3z" }), /* @__PURE__ */ React316.createElement("polygon", { points: "42.384 32.088 5.615 32.088 0 42 48 42", className: "sc-Icon--secondary-color" }));
}

// src/components/icons/FeatureLaptop.tsx
import * as React317 from "react";
var componentNameString311 = "FeatureLaptop";
function FeatureLaptop({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString311,
    ...props
  });
  return /* @__PURE__ */ React317.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React317.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React317.createElement("polygon", { points: "0 46 48 46 48 40 0 40", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React317.createElement("path", { d: "M4 36V2h40v34H4zm6-6h28V8H10v22z" }));
}

// src/components/icons/FeatureLeft24.tsx
import * as React318 from "react";
var componentNameString312 = "FeatureLeft24";
function FeatureLeft24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString312,
    ...props
  });
  return /* @__PURE__ */ React318.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React318.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React318.createElement("path", { fillRule: "evenodd", d: "M6 11L20 11L20 13L6 13L6 11Z", clipRule: "evenodd" }), /* @__PURE__ */ React318.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3.58594 12L10.293 5.29289L11.7073 6.7071L6.41437 12L11.7073 17.2929L10.293 18.7071L3.58594 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLeft48.tsx
import * as React319 from "react";
var componentNameString313 = "FeatureLeft48";
function FeatureLeft48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString313,
    ...props
  });
  return /* @__PURE__ */ React319.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React319.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React319.createElement("path", { fillRule: "evenodd", d: "M12 22.25L40 22.25L40 25.75L12 25.75L12 22.25Z", clipRule: "evenodd" }), /* @__PURE__ */ React319.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.5254 24L20.7628 10.7626L23.2377 13.2374L12.4751 24L23.2377 34.7626L20.7628 37.2374L7.5254 24Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLeft72.tsx
import * as React320 from "react";
var componentNameString314 = "FeatureLeft72";
function FeatureLeft72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString314,
    ...props
  });
  return /* @__PURE__ */ React320.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React320.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React320.createElement("path", { fillRule: "evenodd", d: "M18 33.5L60 33.5L60 38.5L18 38.5L18 33.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React320.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.4644 36L31.2321 16.2322L34.7677 19.7678L18.5354 36L34.7677 52.2322L31.2321 55.7678L11.4644 36Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLeftArrowSmall24.tsx
import * as React321 from "react";
var componentNameString315 = "FeatureLeftArrowSmall24";
function FeatureLeftArrowSmall24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString315,
    ...props
  });
  return /* @__PURE__ */ React321.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React321.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React321.createElement("path", { d: "M11.2929 7.29285L6.58582 12L11.2929 16.7071L12.7071 15.2928L10.4142 13H17V11L10.4142 11L12.7071 8.70706L11.2929 7.29285Z" }));
}

// src/components/icons/FeatureLifePreserver.tsx
import * as React322 from "react";
var componentNameString316 = "FeatureLifePreserver";
function FeatureLifePreserver({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString316,
    ...props
  });
  return /* @__PURE__ */ React322.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React322.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React322.createElement("path", { d: "M33.8 36.6l5.7 5.7a23.9 23.9 0 01-31 0l5.7-5.7a16 16 0 0019.6 0zM14.2 11.4L8.5 5.7a23.9 23.9 0 0131 0l-5.7 5.7a16 16 0 00-19.6 0z" }), /* @__PURE__ */ React322.createElement("path", { d: "M36.6 33.8a16 16 0 000-19.6l5.7-5.7a23.9 23.9 0 010 31l-5.7-5.7zM11.4 14.2a16 16 0 000 19.6l-5.7 5.7a23.9 23.9 0 010-31l5.7 5.7z" }));
}

// src/components/icons/FeatureLightbulb24.tsx
import * as React323 from "react";
var componentNameString317 = "FeatureLightbulb24";
function FeatureLightbulb24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString317,
    ...props
  });
  return /* @__PURE__ */ React323.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React323.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React323.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 8C19 10.7924 17.3649 13.2029 15 14.3264V18H9V14.3264C6.63505 13.2029 5 10.7924 5 8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8ZM14.1418 12.5198L13 13.0623V16H11V13.0623L9.85818 12.5198C8.16429 11.7152 7 9.99156 7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 9.99156 15.8357 11.7152 14.1418 12.5198Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React323.createElement("path", { d: "M14.2361 22C14.7111 21.4692 15 20.7684 15 20H9C9 20.7684 9.28885 21.4692 9.76389 22C10.3132 22.6137 11.1115 23 12 23C12.8885 23 13.6868 22.6137 14.2361 22Z" }));
}

// src/components/icons/FeatureLightbulb48.tsx
import * as React324 from "react";
var componentNameString318 = "FeatureLightbulb48";
function FeatureLightbulb48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString318,
    ...props
  });
  return /* @__PURE__ */ React324.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React324.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React324.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M26.5 26.4406L28.4982 25.4913C32.0537 23.8023 34.5 20.1833 34.5 16C34.5 10.201 29.799 5.5 24 5.5C18.201 5.5 13.5 10.201 13.5 16C13.5 20.1833 15.9463 23.8023 19.5018 25.4913L21.5 26.4406V32.5H26.5V26.4406ZM30 28.6527C34.7299 26.4058 38 21.5848 38 16C38 8.26801 31.732 2 24 2C16.268 2 10 8.26801 10 16C10 21.5848 13.2701 26.4058 18 28.6527V36H30V28.6527Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React324.createElement("path", { d: "M24 46C27.3137 46 30 43.3137 30 40H18C18 43.3137 20.6863 46 24 46Z" }), /* @__PURE__ */ React324.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 40H30C30 41.5367 29.4223 42.9385 28.4722 44C27.3736 45.2275 25.777 46 24 46C22.223 46 20.6264 45.2275 19.5278 44C18.5777 42.9385 18 41.5367 18 40Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React324.createElement("path", { d: "M31.7728 16C31.7761 15.9076 31.7778 15.8149 31.7778 15.7217C31.7778 11.5795 28.42 8.22168 24.2778 8.22168C24.1848 8.22168 24.0922 8.22337 24 8.22673V11.7312C24.0918 11.7249 24.1844 11.7217 24.2778 11.7217C26.487 11.7217 28.2778 13.5125 28.2778 15.7217C28.2778 15.8152 28.2746 15.908 28.2683 16H31.7728Z" }));
}

// src/components/icons/FeatureLightbulb72.tsx
import * as React325 from "react";
var componentNameString319 = "FeatureLightbulb72";
function FeatureLightbulb72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString319,
    ...props
  });
  return /* @__PURE__ */ React325.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React325.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React325.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40 39.8188L42.8545 38.4628C48.2717 35.8894 52 30.3751 52 24C52 15.1634 44.8366 8 36 8C27.1634 8 20 15.1634 20 24C20 30.3751 23.7283 35.8894 29.1455 38.4628L32 39.8188V49H40V39.8188ZM45 42.9791C52.0948 39.6087 57 32.3772 57 24C57 12.402 47.598 3 36 3C24.402 3 15 12.402 15 24C15 32.3772 19.9052 39.6087 27 42.9791V54H45V42.9791Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React325.createElement("path", { d: "M36 69C40.9706 69 45 64.9706 45 60H27C27 64.9706 31.0294 69 36 69Z" }), /* @__PURE__ */ React325.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 65C37.1258 65 38.1647 64.6279 39.0005 64H32.9995C33.8353 64.6279 34.8742 65 36 65ZM27.9355 64C27.3367 62.795 27 61.4368 27 60H45C45 61.4368 44.6633 62.795 44.0645 64C42.5918 66.9634 39.5337 69 36 69C32.4663 69 29.4082 66.9634 27.9355 64Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React325.createElement("path", { d: "M48.4362 25C48.4416 24.8524 48.4443 24.7041 48.4443 24.5551C48.4443 17.9277 43.0718 12.5551 36.4443 12.5551C36.2956 12.5551 36.1474 12.5579 36 12.5632V17.569C36.1469 17.5598 36.2951 17.5551 36.4443 17.5551C40.3103 17.5551 43.4443 20.6892 43.4443 24.5551C43.4443 24.7046 43.4397 24.8529 43.4304 25H48.4362Z" }));
}

// src/components/icons/FeatureLightbulbInCircle24.tsx
import * as React326 from "react";
var componentNameString320 = "FeatureLightbulbInCircle24";
function FeatureLightbulbInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString320,
    ...props
  });
  return /* @__PURE__ */ React326.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React326.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React326.createElement("path", { d: "M14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16H14Z" }), /* @__PURE__ */ React326.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React326.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightbulbInCircle48.tsx
import * as React327 from "react";
var componentNameString321 = "FeatureLightbulbInCircle48";
function FeatureLightbulbInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString321,
    ...props
  });
  return /* @__PURE__ */ React327.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React327.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React327.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React327.createElement("path", { d: "M24 36a4 4 0 004-4h-8a4 4 0 004 4z" }), /* @__PURE__ */ React327.createElement("path", { fillRule: "evenodd", d: "M20 32a4 4 0 004 4 4 4 0 004-4h-8z", clipRule: "evenodd" }), /* @__PURE__ */ React327.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 25.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightbulbInCircle72.tsx
import * as React328 from "react";
var componentNameString322 = "FeatureLightbulbInCircle72";
function FeatureLightbulbInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString322,
    ...props
  });
  return /* @__PURE__ */ React328.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React328.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React328.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React328.createElement("path", { d: "M36 54a6 6 0 006-6H30a6 6 0 006 6z" }), /* @__PURE__ */ React328.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 52a4 4 0 003.5-2h-7a4 4 0 003.5 2zm-5.7-2a6 6 0 01-.3-2h12a6 6 0 01-11.7 2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React328.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 37a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightbulb.tsx
import * as React329 from "react";
var componentNameString323 = "FeatureLightbulb";
function FeatureLightbulb({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString323,
    ...props
  });
  return /* @__PURE__ */ React329.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React329.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React329.createElement("path", { d: "M17 30.4a16 16 0 1114 0z" }), /* @__PURE__ */ React329.createElement("rect", { width: 14, height: 8, x: 17, y: 40, className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureLightning24.tsx
import * as React330 from "react";
var componentNameString324 = "FeatureLightning24";
function FeatureLightning24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString324,
    ...props
  });
  return /* @__PURE__ */ React330.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React330.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React330.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11 11V7.80963L7.66333 13H13V16.1904L16.3367 11H11ZM20 9L11 23V15H4L13 1V9H20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightning48.tsx
import * as React331 from "react";
var componentNameString325 = "FeatureLightning48";
function FeatureLightning48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString325,
    ...props
  });
  return /* @__PURE__ */ React331.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React331.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React331.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.5 21.5v-7.6l-8 12.6h11v7.6l8-12.6h-11zM40 18L22 46V30H8L26 2v16h14z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightning72.tsx
import * as React332 from "react";
var componentNameString326 = "FeatureLightning72";
function FeatureLightning72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString326,
    ...props
  });
  return /* @__PURE__ */ React332.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React332.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React332.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34 32V20L21.2 40H38v12l12.8-20H34zm26-5L33 69V45H12L39 3v24h21z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningCrossout24.tsx
import * as React333 from "react";
var componentNameString327 = "FeatureLightningCrossout24";
function FeatureLightningCrossout24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString327,
    ...props
  });
  return /* @__PURE__ */ React333.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React333.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React333.createElement("path", { d: "M22 22L2 2L0.5 3.5L20.5 23.5L22 22Z" }), /* @__PURE__ */ React333.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.8696 13.8696L20 9H13V1L9.47826 6.47826L16.8696 13.8696ZM15.6957 15.6957L8.30435 8.30435L4 15H11V23L15.6957 15.6957Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningCrossout48.tsx
import * as React334 from "react";
var componentNameString328 = "FeatureLightningCrossout48";
function FeatureLightningCrossout48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString328,
    ...props
  });
  return /* @__PURE__ */ React334.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React334.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React334.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M39.2 17.3l-6 9.3-14-14.1L25.7 2v15.3h13.4zM16.9 16l14 14L43 42.2 40.1 45 28.7 33.6 22 44V28.8H8.7l6-9.4L2 6.8l2.9-2.9 12 12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningCrossout72.tsx
import * as React335 from "react";
var componentNameString329 = "FeatureLightningCrossout72";
function FeatureLightningCrossout72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString329,
    ...props
  });
  return /* @__PURE__ */ React335.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React335.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React335.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M60 25.8l-9.3 14.5-22-22L39.2 2v23.8H60zm-34.8-2l22 22L66 64.5 61.5 69 43.7 51.2 33.3 67.5V43.7H12.4l9.3-14.5L2 9.4 6.5 5l18.7 18.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningInCircle24.tsx
import * as React336 from "react";
var componentNameString330 = "FeatureLightningInCircle24";
function FeatureLightningInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString330,
    ...props
  });
  return /* @__PURE__ */ React336.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React336.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React336.createElement("path", { fillRule: "evenodd", d: "M7 13.875H11.375V18.875L17 10.125H12.625V5.125L7 13.875Z", clipRule: "evenodd" }), /* @__PURE__ */ React336.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningInCircle48.tsx
import * as React337 from "react";
var componentNameString331 = "FeatureLightningInCircle48";
function FeatureLightningInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString331,
    ...props
  });
  return /* @__PURE__ */ React337.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React337.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React337.createElement("path", { fillRule: "evenodd", d: "M25.3 20.3v-10L14 27.6h8.8v10L34 20.3h-8.8z", clipRule: "evenodd" }), /* @__PURE__ */ React337.createElement("path", { fillRule: "evenodd", d: "M14 27.8h8.8v10L34 20.3h-8.8v-10L14 27.6z", clipRule: "evenodd" }), /* @__PURE__ */ React337.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningInCircle72.tsx
import * as React338 from "react";
var componentNameString332 = "FeatureLightningInCircle72";
function FeatureLightningInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString332,
    ...props
  });
  return /* @__PURE__ */ React338.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React338.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React338.createElement("path", { fillRule: "evenodd", d: "M37.9 30.4v-15L21 41.6h13.1v15L51 30.4H37.9z", clipRule: "evenodd" }), /* @__PURE__ */ React338.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21 41.6h13.1v15L51 30.4H37.9v-15L21 41.6zm11.9-9.2l-2.7 4.2h9v3l2.6-4.2h-9v-3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React338.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningInCircleCrossout24.tsx
import * as React339 from "react";
var componentNameString333 = "FeatureLightningInCircleCrossout24";
function FeatureLightningInCircleCrossout24({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString333,
    ...props
  });
  return /* @__PURE__ */ React339.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React339.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React339.createElement("mask", { id: "a" }, /* @__PURE__ */ React339.createElement("path", { fillRule: "evenodd", d: "M12.625 10.125V5.125L7 13.875H11.375V18.875L17 10.125H12.625Z", clipRule: "evenodd" })), /* @__PURE__ */ React339.createElement(
    "path",
    {
      d: "M12.625 10.125H10.625V12.125H12.625V10.125ZM12.625 5.125H14.625V-1.68463L10.9426 4.04348L12.625 5.125ZM7 13.875L5.31764 12.7935L3.33667 15.875H7V13.875ZM11.375 13.875H13.375V11.875H11.375V13.875ZM11.375 18.875H9.375V25.6846L13.0574 19.9565L11.375 18.875ZM17 10.125L18.6824 11.2065L20.6633 8.125H17V10.125ZM14.625 10.125V5.125H10.625V10.125H14.625ZM10.9426 4.04348L5.31764 12.7935L8.68236 14.9565L14.3074 6.20652L10.9426 4.04348ZM7 15.875H11.375V11.875H7V15.875ZM9.375 13.875V18.875H13.375V13.875H9.375ZM13.0574 19.9565L18.6824 11.2065L15.3176 9.04348L9.69264 17.7935L13.0574 19.9565ZM17 8.125H12.625V12.125H17V8.125Z",
      mask: "url(#a)"
    }
  ), /* @__PURE__ */ React339.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React339.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17.293 18.7072L5.29297 6.70718L6.70718 5.29297L18.7072 17.293L17.293 18.7072Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLightningInCircleCrossout48.tsx
import * as React340 from "react";
var componentNameString334 = "FeatureLightningInCircleCrossout48";
function FeatureLightningInCircleCrossout48({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString334,
    ...props
  });
  return /* @__PURE__ */ React340.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React340.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React340.createElement("path", { fillRule: "evenodd", d: "M35.8 38.2l-26-26 2.4-2.4 26 26-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React340.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40.5 24a16.5 16.5 0 10-33 0 16.5 16.5 0 0033 0zm3.5 0a20 20 0 10-40 0 20 20 0 0040 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React340.createElement("path", { fillRule: "evenodd", d: "M25.3 20V10L14 27.5h8.8v10L34 20h-8.8z", clipRule: "evenodd" }), /* @__PURE__ */ React340.createElement("path", { fillRule: "evenodd", d: "M14 27.5h8.8v10L34 20h-8.8V10L14 27.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureLightningInCircleCrossout72.tsx
import * as React341 from "react";
var componentNameString335 = "FeatureLightningInCircleCrossout72";
function FeatureLightningInCircleCrossout72({
  title,
  titleId,
  ...props
}) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString335,
    ...props
  });
  return /* @__PURE__ */ React341.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React341.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React341.createElement("path", { fillRule: "evenodd", d: "M37.9 30.4v-15L21 41.6h13.1v15L51 30.4H37.9z", clipRule: "evenodd" }), /* @__PURE__ */ React341.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21 41.6h13.1v15L51 30.4H37.9v-15L21 41.6zm11.9-9.2l-2.7 4.2h9v3l2.6-4.2h-9v-3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React341.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React341.createElement("path", { fillRule: "evenodd", d: "M52.2 55.8l-36-36 3.6-3.6 36 36-3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureLink24.tsx
import * as React342 from "react";
var componentNameString336 = "FeatureLink24";
function FeatureLink24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString336,
    ...props
  });
  return /* @__PURE__ */ React342.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React342.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React342.createElement("path", { d: "M2 12C2 9.23858 4.23858 7 7 7H11V9H7C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15H11V17H7C4.23858 17 2 14.7614 2 12Z" }), /* @__PURE__ */ React342.createElement("path", { d: "M22 12C22 9.23858 19.7614 7 17 7H13V9H17C18.6569 9 20 10.3431 20 12C20 13.6569 18.6569 15 17 15H13V17H17C19.7614 17 22 14.7614 22 12Z" }), /* @__PURE__ */ React342.createElement("path", { d: "M7 13H17V11H7V13Z" }));
}

// src/components/icons/FeatureLink48.tsx
import * as React343 from "react";
var componentNameString337 = "FeatureLink48";
function FeatureLink48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString337,
    ...props
  });
  return /* @__PURE__ */ React343.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React343.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React343.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.3 24c0-5.4 4.3-9.8 9.7-9.8h8v3.6h-8a6.2 6.2 0 100 12.4h8v3.6h-8A9.7 9.7 0 014.2 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React343.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M43.8 24c0-5.4-4.4-9.8-9.8-9.8h-8v3.6h8a6.2 6.2 0 110 12.4h-8v3.6h8c5.4 0 9.8-4.4 9.8-9.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React343.createElement("path", { fillRule: "evenodd", d: "M34 25.8H14v-3.6h20v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureLink72.tsx
import * as React344 from "react";
var componentNameString338 = "FeatureLink72";
function FeatureLink72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString338,
    ...props
  });
  return /* @__PURE__ */ React344.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React344.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React344.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6.5 36c0-8 6.5-14.5 14.5-14.5h12v5H21a9.5 9.5 0 000 19h12v5H21C13 50.5 6.5 44 6.5 36z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React344.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M65.5 36c0-8-6.5-14.5-14.5-14.5H39v5h12a9.5 9.5 0 010 19H39v5h12c8 0 14.5-6.5 14.5-14.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React344.createElement("path", { fillRule: "evenodd", d: "M51 38.5H21v-5h30v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureLinkAlt24.tsx
import * as React345 from "react";
var componentNameString339 = "FeatureLinkAlt24";
function FeatureLinkAlt24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString339,
    ...props
  });
  return /* @__PURE__ */ React345.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React345.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React345.createElement("path", { d: "M4.92894 4.92882C6.88157 2.9762 10.0474 2.9762 12 4.92882L14.8284 7.75725L13.4142 9.17146L10.5858 6.34303C9.41423 5.17146 7.51473 5.17146 6.34316 6.34303C5.17158 7.51461 5.17158 9.4141 6.34316 10.5857L9.17158 13.4141L7.75737 14.8283L4.92894 11.9999C2.97632 10.0473 2.97632 6.88144 4.92894 4.92882Z" }), /* @__PURE__ */ React345.createElement("path", { d: "M19.0711 19.071C21.0237 17.1184 21.0237 13.9525 19.0711 11.9999L16.2426 9.17148L14.8284 10.5857L17.6569 13.4141C18.8284 14.5857 18.8284 16.4852 17.6569 17.6568C16.4853 18.8283 14.5858 18.8283 13.4142 17.6568L10.5858 14.8283L9.17157 16.2425L12 19.071C13.9526 21.0236 17.1184 21.0236 19.0711 19.071Z" }), /* @__PURE__ */ React345.createElement("path", { d: "M7.75736 9.17151L14.8284 16.2426L16.2426 14.8284L9.17157 7.7573L7.75736 9.17151Z" }));
}

// src/components/icons/FeatureLinkAlt48.tsx
import * as React346 from "react";
var componentNameString340 = "FeatureLinkAlt48";
function FeatureLinkAlt48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString340,
    ...props
  });
  return /* @__PURE__ */ React346.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React346.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React346.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10 10a9.7 9.7 0 0113.8 0l5.7 5.7-2.5 2.5-5.7-5.7a6.3 6.3 0 00-8.8 8.9l5.7 5.6-2.5 2.5-5.7-5.7A9.7 9.7 0 0110 10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React346.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 38a9.8 9.8 0 000-13.8l-5.7-5.7-2.5 2.5 5.7 5.7a6.2 6.2 0 11-8.8 8.8L21 29.8l-2.5 2.5 5.7 5.7A9.8 9.8 0 0038 38z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React346.createElement("path", { fillRule: "evenodd", d: "M29.8 32.3L15.7 18.2l2.5-2.5 14.1 14.1-2.5 2.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureLinkAlt72.tsx
import * as React347 from "react";
var componentNameString341 = "FeatureLinkAlt72";
function FeatureLinkAlt72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString341,
    ...props
  });
  return /* @__PURE__ */ React347.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React347.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React347.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.1 15.1a14.5 14.5 0 0120.5 0l8.5 8.5-3.5 3.6-8.5-8.5A9.5 9.5 0 1018.7 32l8.5 8.5-3.6 3.5-8.5-8.5a14.5 14.5 0 010-20.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React347.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M56.9 56.9a14.5 14.5 0 000-20.5l-8.5-8.5-3.6 3.5 8.5 8.5A9.5 9.5 0 1140 53.3l-8.5-8.5-3.5 3.6 8.5 8.5a14.5 14.5 0 0020.5 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React347.createElement("path", { fillRule: "evenodd", d: "M44.8 48.4L23.6 27.2l3.6-3.6 21.2 21.2-3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureLock24.tsx
import * as React348 from "react";
var componentNameString342 = "FeatureLock24";
function FeatureLock24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString342,
    ...props
  });
  return /* @__PURE__ */ React348.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React348.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React348.createElement("path", { d: "M12 18C13.6569 18 15 16.6569 15 15C15 13.3431 13.6569 12 12 12C10.3431 12 9 13.3431 9 15C9 16.6569 10.3431 18 12 18Z" }), /* @__PURE__ */ React348.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7 6V8H6C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H17V6C17 3.23858 14.7614 1 12 1C9.23858 1 7 3.23858 7 6ZM12 3C10.3431 3 9 4.34315 9 6V8H15V6C15 4.34315 13.6569 3 12 3ZM6 10V20H18V10H6Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureLock48.tsx
import * as React349 from "react";
var componentNameString343 = "FeatureLock48";
function FeatureLock48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString343,
    ...props
  });
  return /* @__PURE__ */ React349.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React349.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React349.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24.5 5.8a5.8 5.8 0 00-5.8 5.7V19h-3.4v-7.5a9.3 9.3 0 0118.4 0V19h-3.5v-7.5c0-3.2-2.5-5.8-5.7-5.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React349.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 19.5H12c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h24c.3 0 .5-.2.5-.5V20c0-.3-.2-.5-.5-.5zM12 16a4 4 0 00-4 4v20a4 4 0 004 4h24a4 4 0 004-4V20a4 4 0 00-4-4H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React349.createElement("path", { d: "M30 30a6 6 0 11-12 0 6 6 0 0112 0z" }));
}

// src/components/icons/FeatureLock72.tsx
import * as React350 from "react";
var componentNameString344 = "FeatureLock72";
function FeatureLock72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString344,
    ...props
  });
  return /* @__PURE__ */ React350.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React350.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React350.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 8.5a9.5 9.5 0 00-9.5 9.5v9h-5v-9a14.5 14.5 0 0129 0v9h-5v-9c0-5.2-4.3-9.5-9.5-9.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React350.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54 29H18a1 1 0 00-1 1v30c0 .6.4 1 1 1h36c.6 0 1-.4 1-1V30c0-.6-.4-1-1-1zm-36-5a6 6 0 00-6 6v30a6 6 0 006 6h36a6 6 0 006-6V30a6 6 0 00-6-6H18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React350.createElement("path", { d: "M45 45a9 9 0 11-18 0 9 9 0 0118 0z" }));
}

// src/components/icons/FeatureLock.tsx
import * as React351 from "react";
var componentNameString345 = "FeatureLock";
function FeatureLock({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString345,
    ...props
  });
  return /* @__PURE__ */ React351.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React351.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React351.createElement("path", { d: "M4 48V22h40v26H4zm17-6h6V28h-6v14z" }), /* @__PURE__ */ React351.createElement("path", { d: "M42 18a18 18 0 00-36 0h6a12 12 0 0124 0h6z" }));
}

// src/components/icons/FeatureLowerfees.tsx
import * as React352 from "react";
var componentNameString346 = "FeatureLowerfees";
function FeatureLowerfees({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString346,
    ...props
  });
  return /* @__PURE__ */ React352.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React352.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React352.createElement(
    "polygon",
    {
      points: "37.029 12 28.343 20.686 28.343 0 20.343 0 20.343 20.686 11.656 12 6 17.657 24.343 36 42.686 17.657",
      className: "sc-Icon--secondary-color"
    }
  ), /* @__PURE__ */ React352.createElement("polygon", { points: "8.343 48 40.343 48 40.343 40 8.343 40", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureMail24.tsx
import * as React353 from "react";
var componentNameString347 = "FeatureMail24";
function FeatureMail24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString347,
    ...props
  });
  return /* @__PURE__ */ React353.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React353.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React353.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M2 5H22V19H2V5ZM4 17V9.5L12 14.5L20 9.5V17H4ZM20 7H4L12 12L20 7Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMail48.tsx
import * as React354 from "react";
var componentNameString348 = "FeatureMail48";
function FeatureMail48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString348,
    ...props
  });
  return /* @__PURE__ */ React354.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React354.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React354.createElement("path", { fillRule: "evenodd", d: "M40.5 13.5h-33v21h33v-21zM4 10v28h40V10H4z", clipRule: "evenodd" }), /* @__PURE__ */ React354.createElement("path", { fillRule: "evenodd", d: "M4 15.1l2-2.9 18 11.7 18-11.7 2 3L24 28 4 15z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMail72.tsx
import * as React355 from "react";
var componentNameString349 = "FeatureMail72";
function FeatureMail72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString349,
    ...props
  });
  return /* @__PURE__ */ React355.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React355.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React355.createElement("path", { fillRule: "evenodd", d: "M61 20H11v32h50V20zM6 15v42h60V15H6z", clipRule: "evenodd" }), /* @__PURE__ */ React355.createElement("path", { fillRule: "evenodd", d: "M6.1 22.6L9 18.4 36 36l27.1-17.6 2.8 4.2L36 42 6.1 22.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMailOpen24.tsx
import * as React356 from "react";
var componentNameString350 = "FeatureMailOpen24";
function FeatureMailOpen24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString350,
    ...props
  });
  return /* @__PURE__ */ React356.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React356.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React356.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M2.97101 7.4174L12 2L21.029 7.41739C21.6314 7.77884 22 8.42985 22 9.13238V21H2V9.13238C2 8.42985 2.3686 7.77884 2.97101 7.4174ZM20 11.5V19H4V11.5L12 16.5L20 11.5ZM19.8919 9.06754L12 4.33238L4.10807 9.06754L12 14L19.8919 9.06754Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMailOpen48.tsx
import * as React357 from "react";
var componentNameString351 = "FeatureMailOpen48";
function FeatureMailOpen48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString351,
    ...props
  });
  return /* @__PURE__ */ React357.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React357.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React357.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40.5 38.5V18.3c0-.2 0-.4-.2-.5L24 8.1 7.7 17.8l-.2.5v20.2h33zM24 4L6 14.8a4 4 0 00-2 3.5V42h40V18.3a4 4 0 00-2-3.5L24 4z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React357.createElement("path", { fillRule: "evenodd", d: "M4.4 19.5l1.9-3L24 28.2l17.7-11.7 2 3-19.7 13-19.6-13z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMailOpen72.tsx
import * as React358 from "react";
var componentNameString352 = "FeatureMailOpen72";
function FeatureMailOpen72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString352,
    ...props
  });
  return /* @__PURE__ */ React358.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React358.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React358.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M61 58V27.4a1 1 0 00-.5-.9L36 11.8 11.5 26.5a1 1 0 00-.5.9V58h50zM36 6L9 22.3a6 6 0 00-3 5.1V63h60V27.4a6 6 0 00-3-5.1L36 6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React358.createElement("path", { fillRule: "evenodd", d: "M6.6 29l2.8-4L36 42.4l26.6-17.6 2.8 4.2L36 48.5 6.6 29.1z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMajorPurchase24.tsx
import * as React359 from "react";
var componentNameString353 = "FeatureMajorPurchase24";
function FeatureMajorPurchase24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString353,
    ...props
  });
  return /* @__PURE__ */ React359.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React359.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React359.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5 11.1716L14 20.1716L20.1716 14L11.1716 5H5V11.1716ZM12 3L21.5858 12.5858C22.3668 13.3668 22.3668 14.6332 21.5858 15.4142L15.4142 21.5858C14.6332 22.3668 13.3668 22.3668 12.5858 21.5858L3 12V3H12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React359.createElement("circle", { cx: 10, cy: 10, r: 1 }));
}

// src/components/icons/FeatureMajorPurchase48.tsx
import * as React360 from "react";
var componentNameString354 = "FeatureMajorPurchase48";
function FeatureMajorPurchase48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString354,
    ...props
  });
  return /* @__PURE__ */ React360.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React360.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React360.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.5 22.6l18.1 18.1c.2.2.6.2.8 0l12.3-12.3c.2-.2.2-.6 0-.8L22.6 9.5H9.5v13zM24 6l19.2 19.2a4 4 0 010 5.6L30.8 43.2a4 4 0 01-5.6 0L6 24V6h18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React360.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17.3 15.8a1.6 1.6 0 100 3.1 1.6 1.6 0 000-3.1zm-5 1.5a5 5 0 1110.1 0 5 5 0 01-10.1 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React360.createElement("path", { fillRule: "evenodd", d: "M24 21.9l9 9 2.5-2.4-9-9-2.5 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React360.createElement("path", { fillRule: "evenodd", d: "M19.4 26.4l6.8 6.8 2.5-2.4-6.8-6.8-2.5 2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMajorPurchase72.tsx
import * as React361 from "react";
var componentNameString355 = "FeatureMajorPurchase72";
function FeatureMajorPurchase72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString355,
    ...props
  });
  return /* @__PURE__ */ React361.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React361.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React361.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14 34l27.3 27.2c.4.4 1 .4 1.4 0l18.5-18.5c.4-.4.4-1 0-1.4L34 14H14v20zM36 9l28.8 28.8a6 6 0 010 8.4L46.2 64.8a6 6 0 01-8.4 0L9 36V9h27z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React361.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M26 23.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM18.5 26a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React361.createElement("path", { fillRule: "evenodd", d: "M36 32.8l13.6 13.6 3.6-3.6-13.6-13.6-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React361.createElement("path", { fillRule: "evenodd", d: "M29.2 39.6l10.2 10.2 3.6-3.6L32.8 36l-3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMap24.tsx
import * as React362 from "react";
var componentNameString356 = "FeatureMap24";
function FeatureMap24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString356,
    ...props
  });
  return /* @__PURE__ */ React362.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React362.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React362.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M2 20V4L9 2L15 6L22 4V20L15 22L9 18L2 20ZM8 4.36575V16.2057L4 17.3485V5.5086L8 4.36575ZM14 18.9296V7.73703L10 5.07037V16.263L14 18.9296ZM16 19.6343V7.79432L20 6.65146V18.4914L16 19.6343Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMap48.tsx
import * as React363 from "react";
var componentNameString357 = "FeatureMap48";
function FeatureMap48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString357,
    ...props
  });
  return /* @__PURE__ */ React363.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React363.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React363.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4 40V8L18 4L30 12L44 8V40L30 44L18 36L4 40ZM16.25 8.14006V32.8599L7.5 35.3599V10.6401L16.25 8.14006ZM28.25 38.6269V15.0398L19.75 9.37314V32.9602L28.25 38.6269ZM31.75 39.8599V15.1401L40.5 12.6401V37.3599L31.75 39.8599Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMap72.tsx
import * as React364 from "react";
var componentNameString358 = "FeatureMap72";
function FeatureMap72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString358,
    ...props
  });
  return /* @__PURE__ */ React364.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React364.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React364.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6 60V12L27 6L45 18L66 12V60L45 66L27 54L6 60ZM24.5 11.9144V49.5142L11 53.3713V15.7715L24.5 11.9144ZM42.5 58.3241V22.3426L29.5 13.6759V49.6574L42.5 58.3241ZM47.5 60.0856V22.4858L61 18.6286V56.2285L47.5 60.0856Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMedal.tsx
import * as React365 from "react";
var componentNameString359 = "FeatureMedal";
function FeatureMedal({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString359,
    ...props
  });
  return /* @__PURE__ */ React365.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React365.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React365.createElement("path", { d: "M24 22a13 13 0 100 26 13 13 0 000-26" }), /* @__PURE__ */ React365.createElement("path", { d: "M34.4 22.7c-2.4-2-5.8-3.3-9.1-3.5L37.1 0H48L34.4 22.7zm-11.7-3.5c-3.3.2-6.8 1.5-9 3.5L0 0h10.9l11.8 19.2z" }));
}

// src/components/icons/FeatureMedical24.tsx
import * as React366 from "react";
var componentNameString360 = "FeatureMedical24";
function FeatureMedical24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString360,
    ...props
  });
  return /* @__PURE__ */ React366.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React366.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React366.createElement("mask", { id: "a" }, /* @__PURE__ */ React366.createElement("path", { fillRule: "evenodd", d: "M15 3H9V9L3 9V15H9V21H15V15H21V9L15 9V3Z", clipRule: "evenodd" })), /* @__PURE__ */ React366.createElement(
    "path",
    {
      d: "M9 3V1H7V3H9ZM15 3H17V1H15V3ZM9 9V11H11V9H9ZM3 9L3 7L1 7V9H3ZM3 15H1V17H3V15ZM9 15H11V13H9V15ZM9 21H7V23H9V21ZM15 21V23H17V21H15ZM15 15V13H13V15H15ZM21 15V17H23V15H21ZM21 9H23V7H21V9ZM15 9H13V11H15V9ZM9 5H15V1H9V5ZM11 9V3H7V9H11ZM3 11L9 11V7L3 7L3 11ZM5 15V9H1V15H5ZM9 13H3V17H9V13ZM11 21V15H7V21H11ZM15 19H9V23H15V19ZM13 15V21H17V15H13ZM21 13H15V17H21V13ZM19 9V15H23V9H19ZM15 11L21 11V7L15 7V11ZM13 3V9H17V3H13Z",
      mask: "url(#a)"
    }
  ));
}

// src/components/icons/FeatureMedical48.tsx
import * as React367 from "react";
var componentNameString361 = "FeatureMedical48";
function FeatureMedical48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString361,
    ...props
  });
  return /* @__PURE__ */ React367.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React367.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React367.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 18H6v12h12v12h12V30h12V18H30V6H18v12zm3.5-8.5v12h-12v5h12v12h5v-12h12v-5h-12v-12h-5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMedical72.tsx
import * as React368 from "react";
var componentNameString362 = "FeatureMedical72";
function FeatureMedical72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString362,
    ...props
  });
  return /* @__PURE__ */ React368.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React368.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React368.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M27 27H9v18h18v18h18V45h18V27H45V9H27v18zm5-13v18H14v8h18v18h8V40h18v-8H40V14h-8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMessage24.tsx
import * as React369 from "react";
var componentNameString363 = "FeatureMessage24";
function FeatureMessage24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString363,
    ...props
  });
  return /* @__PURE__ */ React369.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React369.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React369.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.8284 16L20 17.1716V6L4 6L4 16H18.8284ZM22 22L18 18H4C2.89543 18 2 17.1046 2 16L2 6C2 4.89543 2.89543 4 4 4L20 4C21.1046 4 22 4.89543 22 6V22Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React369.createElement("path", { fillRule: "evenodd", d: "M18 10H6V8H18V10Z", clipRule: "evenodd" }), /* @__PURE__ */ React369.createElement("path", { fillRule: "evenodd", d: "M14 14H6V12H14V14Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMessage48.tsx
import * as React370 from "react";
var componentNameString364 = "FeatureMessage48";
function FeatureMessage48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString364,
    ...props
  });
  return /* @__PURE__ */ React370.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React370.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React370.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M37.4 32.5l3.1 3V12c0-.3-.2-.5-.5-.5H8c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h29.4zM44 44l-8-8H8a4 4 0 01-4-4V12a4 4 0 014-4h32a4 4 0 014 4v32z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React370.createElement("path", { fillRule: "evenodd", d: "M36 19.8H12v-3.6h24v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React370.createElement("path", { fillRule: "evenodd", d: "M28 27.8H12v-3.6h16v3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMessage72.tsx
import * as React371 from "react";
var componentNameString365 = "FeatureMessage72";
function FeatureMessage72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString365,
    ...props
  });
  return /* @__PURE__ */ React371.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React371.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React371.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M56 49l5 5V18c0-.6-.4-1-1-1H12a1 1 0 00-1 1v30c0 .6.4 1 1 1h44zm10 17L54 54H12a6 6 0 01-6-6V18a6 6 0 016-6h48a6 6 0 016 6v48z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React371.createElement("path", { fillRule: "evenodd", d: "M54 29.5H18v-5h36v5z", clipRule: "evenodd" }), /* @__PURE__ */ React371.createElement("path", { fillRule: "evenodd", d: "M42 41.5H18v-5h24v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMinus24.tsx
import * as React372 from "react";
var componentNameString366 = "FeatureMinus24";
function FeatureMinus24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString366,
    ...props
  });
  return /* @__PURE__ */ React372.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React372.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React372.createElement("path", { fillRule: "evenodd", d: "M3 11L21 11L21 13L3 13L3 11Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMinus48.tsx
import * as React373 from "react";
var componentNameString367 = "FeatureMinus48";
function FeatureMinus48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString367,
    ...props
  });
  return /* @__PURE__ */ React373.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React373.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React373.createElement("path", { fillRule: "evenodd", d: "M6 22.3h36v3.4H6v-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMinus72.tsx
import * as React374 from "react";
var componentNameString368 = "FeatureMinus72";
function FeatureMinus72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString368,
    ...props
  });
  return /* @__PURE__ */ React374.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React374.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React374.createElement("path", { fillRule: "evenodd", d: "M9 33.5h54v5H9v-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureMinusInCircle24.tsx
import * as React375 from "react";
var componentNameString369 = "FeatureMinusInCircle24";
function FeatureMinusInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString369,
    ...props
  });
  return /* @__PURE__ */ React375.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React375.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React375.createElement("path", { d: "M18 11L6 11V13L18 13V11Z" }), /* @__PURE__ */ React375.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMinusInCircle48.tsx
import * as React376 from "react";
var componentNameString370 = "FeatureMinusInCircle48";
function FeatureMinusInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString370,
    ...props
  });
  return /* @__PURE__ */ React376.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React376.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React376.createElement("path", { fillRule: "evenodd", d: "M12 22.3h24v3.4H12v-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React376.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMinusInCircle72.tsx
import * as React377 from "react";
var componentNameString371 = "FeatureMinusInCircle72";
function FeatureMinusInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString371,
    ...props
  });
  return /* @__PURE__ */ React377.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React377.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React377.createElement("path", { fillRule: "evenodd", d: "M18 33.5h36v5H18v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React377.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureMobile.tsx
import * as React378 from "react";
var componentNameString372 = "FeatureMobile";
function FeatureMobile({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString372,
    ...props
  });
  return /* @__PURE__ */ React378.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React378.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React378.createElement("path", { d: "M11 48V0h34v48H11zm4-12h26V4H15v32z" }), /* @__PURE__ */ React378.createElement("path", { d: "M3 15V9h30v6H3zm0 13v-6h18v6H3z" }));
}

// src/components/icons/FeatureNestEgg24.tsx
import * as React379 from "react";
var componentNameString373 = "FeatureNestEgg24";
function FeatureNestEgg24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString373,
    ...props
  });
  return /* @__PURE__ */ React379.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React379.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React379.createElement("path", { d: "M11 5H13V7C14.6569 7 16 8.34315 16 10H14C14 9.44772 13.5523 9 13 9H11C10.4477 9 10 9.44771 10 10C10 10.5523 10.4477 11 11 11H13C14.6569 11 16 12.3431 16 14C16 15.6569 14.6569 17 13 17V19H11V17C9.34315 17 8 15.6569 8 14H10C10 14.5523 10.4477 15 11 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H11C9.34315 13 8 11.6569 8 10C8 8.34315 9.34315 7 11 7V5Z" }), /* @__PURE__ */ React379.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21 12.8462C21 18.9213 16.9706 23 12 23C7.02944 23 3 18.9213 3 12.8462C3 6.77102 7.5 1 12 1C16.5 1 21 6.77102 21 12.8462ZM19 12.8462C19 17.9867 15.7034 21 12 21C8.29661 21 5 17.9867 5 12.8462C5 10.2821 5.95878 7.74215 7.4 5.8614C8.87399 3.93787 10.6008 3 12 3C13.3992 3 15.126 3.93787 16.6 5.8614C18.0412 7.74215 19 10.2821 19 12.8462Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureNestEgg48.tsx
import * as React380 from "react";
var componentNameString374 = "FeatureNestEgg48";
function FeatureNestEgg48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString374,
    ...props
  });
  return /* @__PURE__ */ React380.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React380.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React380.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.3 19.5c0-3.5 2.7-6.3 6.2-6.3h5c3.5 0 6.3 2.8 6.3 6.3h-3.5c0-1.5-1.3-2.8-2.8-2.8h-5a2.7 2.7 0 100 5.6h5a6.2 6.2 0 110 12.4h-5a6.2 6.2 0 01-6.3-6.2h3.6c0 1.5 1.2 2.8 2.7 2.8h5a2.7 2.7 0 100-5.6h-5a6.2 6.2 0 01-6.3-6.2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React380.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 44.5c8.2 0 15.5-7 15.5-18.7 0-5.8-2.1-11.5-5.2-15.8-3.3-4.3-7-6.5-10.3-6.5-3.2 0-7 2.2-10.3 6.5-3.1 4.3-5.2 10-5.2 15.8 0 11.8 7.3 18.7 15.5 18.7zm0 3.5c10.5 0 19-8.9 19-22.2C43 12.6 33.5 0 24 0S5 12.6 5 25.8C5 39.1 13.5 48 24 48z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React380.createElement("path", { fillRule: "evenodd", d: "M22.3 14v-4h3.4v4h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React380.createElement("path", { fillRule: "evenodd", d: "M22.3 38v-4h3.4v4h-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureNestEgg72.tsx
import * as React381 from "react";
var componentNameString375 = "FeatureNestEgg72";
function FeatureNestEgg72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString375,
    ...props
  });
  return /* @__PURE__ */ React381.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React381.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React381.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M23.5 29.5c0-5 4-9 9-9h7c5 0 9 4 9 9h-5a4 4 0 00-4-4h-7a4 4 0 000 8h7a9 9 0 110 18h-7c-5 0-9-4-9-9h5a4 4 0 004 4h7a4 4 0 000-8h-7c-5 0-9-4-9-9z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React381.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 65c12.3 0 23-10 23-26.4 0-8.2-3-16.3-7.7-22.3S40.9 7 36 7s-10.6 3.2-15.3 9.3c-4.6 6-7.7 14.1-7.7 22.3C13 55 23.7 65 36 65zm0 5c15.5 0 28-12.6 28-31.4C64 19.8 50 2 36 2S8 19.8 8 38.6 20.5 70 36 70z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React381.createElement("path", { fillRule: "evenodd", d: "M33.5 21v-6.5h5V21h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React381.createElement("path", { fillRule: "evenodd", d: "M33.5 57.5V51h5v6.5h-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureOpen24.tsx
import * as React382 from "react";
var componentNameString376 = "FeatureOpen24";
function FeatureOpen24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString376,
    ...props
  });
  return /* @__PURE__ */ React382.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React382.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React382.createElement("path", { fillRule: "evenodd", d: "M21 3L21 9L19 9L19 5L15 5L15 3L21 3Z", clipRule: "evenodd" }), /* @__PURE__ */ React382.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.2928 11.293L19.2928 3.29297L20.707 4.70718L12.707 12.7072L11.2928 11.293Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React382.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V12H19V19H5L5 5H12V3Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureOpen48.tsx
import * as React383 from "react";
var componentNameString377 = "FeatureOpen48";
function FeatureOpen48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString377,
    ...props
  });
  return /* @__PURE__ */ React383.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React383.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React383.createElement("path", { fillRule: "evenodd", d: "M41.8 6.3V18h-3.5V9.7H30V6.3h11.8z", clipRule: "evenodd" }), /* @__PURE__ */ React383.createElement("path", { fillRule: "evenodd", d: "M22.8 22.8l16-16 2.4 2.4-16 16-2.4-2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React383.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6.3 12c0-3.2 2.5-5.8 5.7-5.8h12v3.5H12c-1.2 0-2.3 1-2.3 2.3v24c0 1.2 1 2.3 2.3 2.3h24c1.2 0 2.3-1 2.3-2.3V24h3.5v12c0 3.2-2.6 5.8-5.8 5.8H12A5.8 5.8 0 016.2 36V12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureOpen72.tsx
import * as React384 from "react";
var componentNameString378 = "FeatureOpen72";
function FeatureOpen72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString378,
    ...props
  });
  return /* @__PURE__ */ React384.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React384.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React384.createElement("path", { fillRule: "evenodd", d: "M62.5 9.5V27h-5V14.5H45v-5h17.5z", clipRule: "evenodd" }), /* @__PURE__ */ React384.createElement("path", { fillRule: "evenodd", d: "M34.2 34.2l24-24 3.6 3.6-24 24-3.6-3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React384.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.5 18c0-4.7 3.8-8.5 8.5-8.5h18v5H18c-2 0-3.5 1.6-3.5 3.5v36c0 2 1.6 3.5 3.5 3.5h36c2 0 3.5-1.6 3.5-3.5V36h5v18c0 4.7-3.8 8.5-8.5 8.5H18A8.5 8.5 0 019.5 54V18z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureOpposingArrows.tsx
import * as React385 from "react";
var componentNameString379 = "FeatureOpposingArrows";
function FeatureOpposingArrows({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString379,
    ...props
  });
  return /* @__PURE__ */ React385.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React385.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React385.createElement(
    "polygon",
    {
      points: "0 35 12.93 48 17.173 43.757 11.462 38 48 38 48 31.999 11.462 31.999 17.173 26.242 12.93 21.999",
      className: "sc-Icon--secondary-color"
    }
  ), /* @__PURE__ */ React385.createElement(
    "polygon",
    {
      points: "35.07 0 30.827 4.243 36.539 10 0 10 0 15.999 36.539 15.999 30.827 21.757 35.07 26 47.999 13",
      className: "sc-Icon--primary-color"
    }
  ));
}

// src/components/icons/FeaturePages.tsx
import * as React386 from "react";
var componentNameString380 = "FeaturePages";
function FeaturePages({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString380,
    ...props
  });
  return /* @__PURE__ */ React386.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React386.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React386.createElement("polygon", { points: "16 0 16 5.999 38.001 5.999 38.001 35 44 35 44 0", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React386.createElement("path", { d: "M4 48V10h30v38H4zm6-6h6V16h-6v26zm12 0h6V22h-6v20z" }));
}

// src/components/icons/FeaturePeople24.tsx
import * as React387 from "react";
var componentNameString381 = "FeaturePeople24";
function FeaturePeople24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString381,
    ...props
  });
  return /* @__PURE__ */ React387.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React387.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React387.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10 6C10 7.65685 8.65685 9 7 9C5.34315 9 4 7.65685 4 6C4 4.34315 5.34315 3 7 3C8.65685 3 10 4.34315 10 6ZM8 6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React387.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20 6C20 7.65685 18.6569 9 17 9C15.3431 9 14 7.65685 14 6C14 4.34315 15.3431 3 17 3C18.6569 3 20 4.34315 20 6ZM18 6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6C16 5.44772 16.4477 5 17 5C17.5523 5 18 5.44772 18 6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React387.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7 10C4.79086 10 3 11.7909 3 14V21H11V14C11 11.7909 9.20914 10 7 10ZM9 19V14C9 12.8954 8.10457 12 7 12C5.89543 12 5 12.8954 5 14V19H9Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React387.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13 14C13 11.7909 14.7909 10 17 10C19.2091 10 21 11.7909 21 14V21H13V14ZM19 14V19H15V14C15 12.8954 15.8954 12 17 12C18.1046 12 19 12.8954 19 14Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePeople48.tsx
import * as React388 from "react";
var componentNameString382 = "FeaturePeople48";
function FeaturePeople48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString382,
    ...props
  });
  return /* @__PURE__ */ React388.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React388.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React388.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 3.5a6 6 0 100-12 6 6 0 000 12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React388.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 3.5a6 6 0 100-12 6 6 0 000 12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React388.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.5 38.5V28a4.5 4.5 0 10-9 0v10.5h9zM14 20a8 8 0 00-8 8v14h16V28a8 8 0 00-8-8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React388.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.5 38.5V28a4.5 4.5 0 10-9 0v10.5h9zM34 20a8 8 0 00-8 8v14h16V28a8 8 0 00-8-8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePeople72.tsx
import * as React389 from "react";
var componentNameString383 = "FeaturePeople72";
function FeaturePeople72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString383,
    ...props
  });
  return /* @__PURE__ */ React389.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React389.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React389.createElement("path", { fillRule: "evenodd", d: "M21 22a4 4 0 100-8 4 4 0 000 8zm0 5a9 9 0 100-18 9 9 0 000 18z", clipRule: "evenodd" }), /* @__PURE__ */ React389.createElement("path", { fillRule: "evenodd", d: "M51 22a4 4 0 100-8 4 4 0 000 8zm0 5a9 9 0 100-18 9 9 0 000 18z", clipRule: "evenodd" }), /* @__PURE__ */ React389.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28 58V42a7 7 0 10-14 0v16h14zm-7-28A12 12 0 009 42v21h24V42a12 12 0 00-12-12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React389.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M58 58V42a7 7 0 10-14 0v16h14zm-7-28a12 12 0 00-12 12v21h24V42a12 12 0 00-12-12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePerson24.tsx
import * as React390 from "react";
var componentNameString384 = "FeaturePerson24";
function FeaturePerson24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString384,
    ...props
  });
  return /* @__PURE__ */ React390.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React390.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React390.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6ZM14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React390.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 12C16.2832 12 19.8675 14.992 20.777 19C20.9229 19.6432 21 20.3126 21 21H3C3 20.3126 3.07706 19.6432 3.22302 19C4.13247 14.992 7.71683 12 12 12ZM5.28988 19C6.15043 16.1085 8.82898 14 12 14C15.171 14 17.8496 16.1085 18.7101 19H5.28988Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePerson48.tsx
import * as React391 from "react";
var componentNameString385 = "FeaturePerson48";
function FeaturePerson48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString385,
    ...props
  });
  return /* @__PURE__ */ React391.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React391.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React391.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 17.8a5.2 5.2 0 100-10.3 5.2 5.2 0 000 10.3zm0 3.5A8.7 8.7 0 1024 4a8.7 8.7 0 000 17.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React391.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 27.5c-6.8 0-12.5 4.7-14 11h28c-1.5-6.3-7.2-11-14-11zm17.7 11A18 18 0 006 42h36a18 18 0 00-.3-3.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePerson72.tsx
import * as React392 from "react";
var componentNameString386 = "FeaturePerson72";
function FeaturePerson72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString386,
    ...props
  });
  return /* @__PURE__ */ React392.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React392.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React392.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 27a8 8 0 100-16 8 8 0 000 16zm0 5a13 13 0 100-26 13 13 0 000 26z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React392.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 41a22 22 0 00-21.4 17h42.8A22 22 0 0036 41zm26.5 17A27 27 0 009 63h54c0-1.7-.2-3.4-.5-5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePets24.tsx
import * as React393 from "react";
var componentNameString387 = "FeaturePets24";
function FeaturePets24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString387,
    ...props
  });
  return /* @__PURE__ */ React393.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React393.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React393.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8.5 9C9.88071 9 11 7.88071 11 6.5C11 5.11929 9.88071 4 8.5 4C7.11929 4 6 5.11929 6 6.5C6 7.88071 7.11929 9 8.5 9ZM8.5 7C8.77614 7 9 6.77614 9 6.5C9 6.22386 8.77614 6 8.5 6C8.22386 6 8 6.22386 8 6.5C8 6.77614 8.22386 7 8.5 7Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React393.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.5 14C5.88071 14 7 12.8807 7 11.5C7 10.1193 5.88071 9 4.5 9C3.11929 9 2 10.1193 2 11.5C2 12.8807 3.11929 14 4.5 14ZM4.5 12C4.77614 12 5 11.7761 5 11.5C5 11.2239 4.77614 11 4.5 11C4.22386 11 4 11.2239 4 11.5C4 11.7761 4.22386 12 4.5 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React393.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 6.5C18 7.88071 16.8807 9 15.5 9C14.1193 9 13 7.88071 13 6.5C13 5.11929 14.1193 4 15.5 4C16.8807 4 18 5.11929 18 6.5ZM16 6.5C16 6.77614 15.7761 7 15.5 7C15.2239 7 15 6.77614 15 6.5C15 6.22386 15.2239 6 15.5 6C15.7761 6 16 6.22386 16 6.5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React393.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.5 14C20.8807 14 22 12.8807 22 11.5C22 10.1193 20.8807 9 19.5 9C18.1193 9 17 10.1193 17 11.5C17 12.8807 18.1193 14 19.5 14ZM19.5 12C19.7761 12 20 11.7761 20 11.5C20 11.2239 19.7761 11 19.5 11C19.2239 11 19 11.2239 19 11.5C19 11.7761 19.2239 12 19.5 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React393.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.73622 11.1034C10.9321 9.72808 13.0679 9.72808 14.2638 11.1034L17.6796 15.0314C19.368 16.9731 17.9889 20 15.4158 20H8.58432C6.01121 20 4.63208 16.9731 6.3205 15.0314L9.73622 11.1034ZM12.7546 12.4157L16.1704 16.3438C16.7332 16.991 16.2735 18 15.4158 18H8.58432C7.72661 18 7.2669 16.991 7.82971 16.3438L11.2454 12.4157C11.6441 11.9573 12.356 11.9573 12.7546 12.4157Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePets48.tsx
import * as React394 from "react";
var componentNameString388 = "FeaturePets48";
function FeaturePets48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString388,
    ...props
  });
  return /* @__PURE__ */ React394.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React394.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React394.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17 18C19.7614 18 22 15.7614 22 13C22 10.2386 19.7614 8 17 8C14.2386 8 12 10.2386 12 13C12 15.7614 14.2386 18 17 18ZM17 14.5C17.8284 14.5 18.5 13.8284 18.5 13C18.5 12.1716 17.8284 11.5 17 11.5C16.1716 11.5 15.5 12.1716 15.5 13C15.5 13.8284 16.1716 14.5 17 14.5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React394.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9 28C11.7614 28 14 25.7614 14 23C14 20.2386 11.7614 18 9 18C6.23858 18 4 20.2386 4 23C4 25.7614 6.23858 28 9 28ZM9 24.5C9.82843 24.5 10.5 23.8284 10.5 23C10.5 22.1716 9.82843 21.5 9 21.5C8.17157 21.5 7.5 22.1716 7.5 23C7.5 23.8284 8.17157 24.5 9 24.5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React394.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 13C36 15.7614 33.7614 18 31 18C28.2386 18 26 15.7614 26 13C26 10.2386 28.2386 8 31 8C33.7614 8 36 10.2386 36 13ZM32.5 13C32.5 13.8284 31.8284 14.5 31 14.5C30.1716 14.5 29.5 13.8284 29.5 13C29.5 12.1716 30.1716 11.5 31 11.5C31.8284 11.5 32.5 12.1716 32.5 13Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React394.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M39 28C41.7614 28 44 25.7614 44 23C44 20.2386 41.7614 18 39 18C36.2386 18 34 20.2386 34 23C34 25.7614 36.2386 28 39 28ZM39 24.5C39.8284 24.5 40.5 23.8284 40.5 23C40.5 22.1716 39.8284 21.5 39 21.5C38.1716 21.5 37.5 22.1716 37.5 23C37.5 23.8284 38.1716 24.5 39 24.5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React394.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.4724 22.2067C21.8642 19.4562 26.1359 19.4562 28.5277 22.2067L35.3591 30.0629C38.736 33.9462 35.9777 39.9999 30.8315 39.9999H17.1686C12.0224 39.9999 9.26416 33.9462 12.641 30.0629L19.4724 22.2067ZM25.8866 24.5034L32.718 32.3595C34.125 33.9776 32.9758 36.4999 30.8315 36.4999H17.1686C15.0244 36.4999 13.8751 33.9776 15.2821 32.3595L22.1136 24.5034C23.1101 23.3573 24.89 23.3573 25.8866 24.5034Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePets72.tsx
import * as React395 from "react";
var componentNameString389 = "FeaturePets72";
function FeaturePets72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString389,
    ...props
  });
  return /* @__PURE__ */ React395.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React395.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React395.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M25.5 27C29.6421 27 33 23.6421 33 19.5C33 15.3579 29.6421 12 25.5 12C21.3579 12 18 15.3579 18 19.5C18 23.6421 21.3579 27 25.5 27ZM25.5 22C26.8807 22 28 20.8807 28 19.5C28 18.1193 26.8807 17 25.5 17C24.1193 17 23 18.1193 23 19.5C23 20.8807 24.1193 22 25.5 22Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React395.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.5 42C17.6421 42 21 38.6421 21 34.5C21 30.3579 17.6421 27 13.5 27C9.35786 27 6 30.3579 6 34.5C6 38.6421 9.35786 42 13.5 42ZM13.5 37C14.8807 37 16 35.8807 16 34.5C16 33.1193 14.8807 32 13.5 32C12.1193 32 11 33.1193 11 34.5C11 35.8807 12.1193 37 13.5 37Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React395.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54 19.5C54 23.6421 50.6421 27 46.5 27C42.3579 27 39 23.6421 39 19.5C39 15.3579 42.3579 12 46.5 12C50.6421 12 54 15.3579 54 19.5ZM49 19.5C49 20.8807 47.8807 22 46.5 22C45.1193 22 44 20.8807 44 19.5C44 18.1193 45.1193 17 46.5 17C47.8807 17 49 18.1193 49 19.5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React395.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M58.5 42C62.6421 42 66 38.6421 66 34.5C66 30.3579 62.6421 27 58.5 27C54.3579 27 51 30.3579 51 34.5C51 38.6421 54.3579 42 58.5 42ZM58.5 37C59.8807 37 61 35.8807 61 34.5C61 33.1193 59.8807 32 58.5 32C57.1193 32 56 33.1193 56 34.5C56 35.8807 57.1193 37 58.5 37Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React395.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28.5015 34.498C32.4824 29.9863 39.5174 29.9863 43.4983 34.498L51.3385 43.3837C57.0359 49.8406 52.4513 59.9999 43.8402 59.9999H28.1596C19.5485 59.9999 14.9639 49.8406 20.6613 43.3837L28.5015 34.498ZM39.7491 37.8062L47.5893 46.6918C50.438 49.9203 48.1457 54.9999 43.8402 54.9999H28.1596C23.8541 54.9999 21.5618 49.9203 24.4105 46.6918L32.2507 37.8061C34.2412 35.5503 37.7586 35.5503 39.7491 37.8062Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePhone24.tsx
import * as React396 from "react";
var componentNameString390 = "FeaturePhone24";
function FeaturePhone24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString390,
    ...props
  });
  return /* @__PURE__ */ React396.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React396.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React396.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5 3C5 1.89543 5.89543 1 7 1H17C18.1046 1 19 1.89543 19 3V21C19 22.1046 18.1046 23 17 23H7C5.89543 23 5 22.1046 5 21V3ZM7 3H17V4H7V3ZM7 6L7 18H17V6H7ZM17 20H7V21H17V20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePhone48.tsx
import * as React397 from "react";
var componentNameString391 = "FeaturePhone48";
function FeaturePhone48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString391,
    ...props
  });
  return /* @__PURE__ */ React397.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React397.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React397.createElement("path", { fillRule: "evenodd", d: "M36.7 11.8H11V8.2h25.7v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React397.createElement("path", { fillRule: "evenodd", d: "M36.7 39.8H11v-3.5h25.7v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React397.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34 5.5H14c-.3 0-.5.2-.5.5v36c0 .3.2.5.5.5h20c.3 0 .5-.2.5-.5V6c0-.3-.2-.5-.5-.5zM14 2a4 4 0 00-4 4v36a4 4 0 004 4h20a4 4 0 004-4V6a4 4 0 00-4-4H14z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePhone72.tsx
import * as React398 from "react";
var componentNameString392 = "FeaturePhone72";
function FeaturePhone72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString392,
    ...props
  });
  return /* @__PURE__ */ React398.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React398.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React398.createElement("path", { fillRule: "evenodd", d: "M55 17.5H16.5v-5H55v5z", clipRule: "evenodd" }), /* @__PURE__ */ React398.createElement("path", { fillRule: "evenodd", d: "M55 59.5H16.5v-5H55v5z", clipRule: "evenodd" }), /* @__PURE__ */ React398.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M51 8H21a1 1 0 00-1 1v54c0 .6.4 1 1 1h30c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1zM21 3a6 6 0 00-6 6v54a6 6 0 006 6h30a6 6 0 006-6V9a6 6 0 00-6-6H21z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePie24.tsx
import * as React399 from "react";
var componentNameString393 = "FeaturePie24";
function FeaturePie24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString393,
    ...props
  });
  return /* @__PURE__ */ React399.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React399.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React399.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM4 12C4 7.92038 7.05369 4.55399 11 4.06189V19.9381C7.05369 19.446 4 16.0796 4 12ZM19.9381 13H13V19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13ZM19.9381 11H13V4.06189C16.6187 4.51314 19.4869 7.38128 19.9381 11Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePie48.tsx
import * as React400 from "react";
var componentNameString394 = "FeaturePie48";
function FeaturePie48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString394,
    ...props
  });
  return /* @__PURE__ */ React400.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React400.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React400.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React400.createElement("path", { fillRule: "evenodd", d: "M22.3 42V6h3.4v36h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React400.createElement("path", { fillRule: "evenodd", d: "M24 22.3h18v3.4H24v-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePie72.tsx
import * as React401 from "react";
var componentNameString395 = "FeaturePie72";
function FeaturePie72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString395,
    ...props
  });
  return /* @__PURE__ */ React401.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React401.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React401.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React401.createElement("path", { fillRule: "evenodd", d: "M33.5 63V9h5v54h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React401.createElement("path", { fillRule: "evenodd", d: "M36 33.5h27v5H36v-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePieceOfPie24.tsx
import * as React402 from "react";
var componentNameString396 = "FeaturePieceOfPie24";
function FeaturePieceOfPie24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString396,
    ...props
  });
  return /* @__PURE__ */ React402.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React402.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React402.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3V5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React402.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.7101 8C20.0382 5.74222 18.2578 3.96183 16 3.28988V8H20.7101ZM22.777 8C22.0135 4.63525 19.3648 1.98652 16 1.22302C15.3568 1.07706 14.6874 1 14 1V10H23C23 9.31261 22.9229 8.64322 22.777 8Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePieceOfPie48.tsx
import * as React403 from "react";
var componentNameString397 = "FeaturePieceOfPie48";
function FeaturePieceOfPie48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString397,
    ...props
  });
  return /* @__PURE__ */ React403.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React403.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React403.createElement("path", { fillRule: "evenodd", d: "M24 9.8A14.2 14.2 0 1038.3 24h3.5A17.7 17.7 0 1124 6.2v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React403.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M42 16.5A14.5 14.5 0 0031.6 5.9v10.6h10.6zm3.7 0A18 18 0 0028 2v18h18a18 18 0 00-.3-3.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePieceOfPie72.tsx
import * as React404 from "react";
var componentNameString398 = "FeaturePieceOfPie72";
function FeaturePieceOfPie72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString398,
    ...props
  });
  return /* @__PURE__ */ React404.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React404.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React404.createElement("path", { fillRule: "evenodd", d: "M36 14.5A21.5 21.5 0 1057.5 36h5A26.5 26.5 0 1136 9.5v5z", clipRule: "evenodd" }), /* @__PURE__ */ React404.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M63.4 25A22 22 0 0047 8.6V25h16.4zm5.1 0A27 27 0 0042 3v27h27c0-1.7-.2-3.4-.5-5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePin24.tsx
import * as React405 from "react";
var componentNameString399 = "FeaturePin24";
function FeaturePin24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString399,
    ...props
  });
  return /* @__PURE__ */ React405.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React405.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 3, y: 3 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 3, y: 10 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 3, y: 17 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 10, y: 3 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 10, y: 10 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 10, y: 17 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 17, y: 3 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 17, y: 10 }), /* @__PURE__ */ React405.createElement("rect", { width: 4, height: 4, x: 17, y: 17 }));
}

// src/components/icons/FeaturePin48.tsx
import * as React406 from "react";
var componentNameString400 = "FeaturePin48";
function FeaturePin48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString400,
    ...props
  });
  return /* @__PURE__ */ React406.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React406.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React406.createElement("path", { d: "M6 6h8v8H6V6z" }), /* @__PURE__ */ React406.createElement("path", { d: "M6 20h8v8H6v-8z" }), /* @__PURE__ */ React406.createElement("path", { d: "M6 34h8v8H6v-8z" }), /* @__PURE__ */ React406.createElement("path", { d: "M20 6h8v8h-8V6z" }), /* @__PURE__ */ React406.createElement("path", { d: "M20 20h8v8h-8v-8z" }), /* @__PURE__ */ React406.createElement("path", { d: "M20 34h8v8h-8v-8z" }), /* @__PURE__ */ React406.createElement("path", { d: "M34 6h8v8h-8V6z" }), /* @__PURE__ */ React406.createElement("path", { d: "M34 20h8v8h-8v-8z" }), /* @__PURE__ */ React406.createElement("path", { d: "M34 34h8v8h-8v-8z" }));
}

// src/components/icons/FeaturePin72.tsx
import * as React407 from "react";
var componentNameString401 = "FeaturePin72";
function FeaturePin72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString401,
    ...props
  });
  return /* @__PURE__ */ React407.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React407.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React407.createElement("path", { d: "M9 9h12v12H9V9z" }), /* @__PURE__ */ React407.createElement("path", { d: "M9 30h12v12H9V30z" }), /* @__PURE__ */ React407.createElement("path", { d: "M9 51h12v12H9V51z" }), /* @__PURE__ */ React407.createElement("path", { d: "M30 9h12v12H30V9z" }), /* @__PURE__ */ React407.createElement("path", { d: "M30 30h12v12H30V30z" }), /* @__PURE__ */ React407.createElement("path", { d: "M30 51h12v12H30V51z" }), /* @__PURE__ */ React407.createElement("path", { d: "M51 9h12v12H51V9z" }), /* @__PURE__ */ React407.createElement("path", { d: "M51 30h12v12H51V30z" }), /* @__PURE__ */ React407.createElement("path", { d: "M51 51h12v12H51V51z" }));
}

// src/components/icons/FeaturePlus24.tsx
import * as React408 from "react";
var componentNameString402 = "FeaturePlus24";
function FeaturePlus24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString402,
    ...props
  });
  return /* @__PURE__ */ React408.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React408.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React408.createElement("path", { d: "M11 13V21H13V13H21V11L13 11V3H11V11L3 11V13H11Z" }));
}

// src/components/icons/FeaturePlus48.tsx
import * as React409 from "react";
var componentNameString403 = "FeaturePlus48";
function FeaturePlus48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString403,
    ...props
  });
  return /* @__PURE__ */ React409.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React409.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React409.createElement("path", { fillRule: "evenodd", d: "M22.3 42V6h3.4v36h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React409.createElement("path", { fillRule: "evenodd", d: "M6 22.3h36v3.4H6v-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePlus72.tsx
import * as React410 from "react";
var componentNameString404 = "FeaturePlus72";
function FeaturePlus72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString404,
    ...props
  });
  return /* @__PURE__ */ React410.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React410.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React410.createElement("path", { fillRule: "evenodd", d: "M33.5 63V9h5v54h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React410.createElement("path", { fillRule: "evenodd", d: "M9 33.5h54v5H9v-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePlusInCircle24.tsx
import * as React411 from "react";
var componentNameString405 = "FeaturePlusInCircle24";
function FeaturePlusInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString405,
    ...props
  });
  return /* @__PURE__ */ React411.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React411.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React411.createElement("path", { d: "M11 18V13H6V11H11V6H13V11H18V13H13V18H11Z" }), /* @__PURE__ */ React411.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePlusInCircle48.tsx
import * as React412 from "react";
var componentNameString406 = "FeaturePlusInCircle48";
function FeaturePlusInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString406,
    ...props
  });
  return /* @__PURE__ */ React412.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React412.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React412.createElement("path", { fillRule: "evenodd", d: "M22.3 36V12h3.4v24h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React412.createElement("path", { fillRule: "evenodd", d: "M12 22.3h24v3.4H12v-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React412.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePlusInCircle72.tsx
import * as React413 from "react";
var componentNameString407 = "FeaturePlusInCircle72";
function FeaturePlusInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString407,
    ...props
  });
  return /* @__PURE__ */ React413.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React413.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React413.createElement("path", { fillRule: "evenodd", d: "M33.5 54V18h5v36h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React413.createElement("path", { fillRule: "evenodd", d: "M18 33.5h36v5H18v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React413.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePower24.tsx
import * as React414 from "react";
var componentNameString408 = "FeaturePower24";
function FeaturePower24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString408,
    ...props
  });
  return /* @__PURE__ */ React414.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React414.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React414.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.05015 7.05025C4.31648 9.78392 4.31648 14.2161 7.05015 16.9497C9.78382 19.6834 14.216 19.6834 16.9496 16.9497C19.6833 14.2161 19.6833 9.78392 16.9496 7.05025L18.3639 5.63604C21.8786 9.15076 21.8786 14.8492 18.3639 18.364C14.8491 21.8787 9.15065 21.8787 5.63593 18.364C2.12122 14.8492 2.12121 9.15076 5.63593 5.63604L7.05015 7.05025Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React414.createElement("path", { fillRule: "evenodd", d: "M13 3V12H11V3H13Z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePower48.tsx
import * as React415 from "react";
var componentNameString409 = "FeaturePower48";
function FeaturePower48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString409,
    ...props
  });
  return /* @__PURE__ */ React415.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React415.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React415.createElement("path", { fillRule: "evenodd", d: "M14 14a14.3 14.3 0 1020 0l2.6-2.6a17.7 17.7 0 11-25.2 0L14 14z", clipRule: "evenodd" }), /* @__PURE__ */ React415.createElement("path", { fillRule: "evenodd", d: "M25.8 6v18h-3.6V6h3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePower72.tsx
import * as React416 from "react";
var componentNameString410 = "FeaturePower72";
function FeaturePower72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString410,
    ...props
  });
  return /* @__PURE__ */ React416.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React416.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React416.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.8 20.8a21.5 21.5 0 1030.4 0l3.5-3.5a26.5 26.5 0 11-37.4 0l3.5 3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React416.createElement("path", { fillRule: "evenodd", d: "M38.5 9v27h-5V9h5z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePreferences24.tsx
import * as React417 from "react";
var componentNameString411 = "FeaturePreferences24";
function FeaturePreferences24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString411,
    ...props
  });
  return /* @__PURE__ */ React417.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React417.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React417.createElement("path", { fillRule: "evenodd", d: "M22 13H18V11L22 11V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React417.createElement("path", { fillRule: "evenodd", d: "M14 13H2V11H14V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React417.createElement("path", { fillRule: "evenodd", d: "M22 19L10 19V17L22 17V19Z", clipRule: "evenodd" }), /* @__PURE__ */ React417.createElement("path", { fillRule: "evenodd", d: "M6 19H2V17H6V19Z", clipRule: "evenodd" }), /* @__PURE__ */ React417.createElement("path", { fillRule: "evenodd", d: "M22 7L10 7V5L22 5V7Z", clipRule: "evenodd" }), /* @__PURE__ */ React417.createElement("path", { fillRule: "evenodd", d: "M6 7H2V5H6V7Z", clipRule: "evenodd" }), /* @__PURE__ */ React417.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7ZM8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React417.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 19C8.55228 19 9 18.5523 9 18C9 17.4477 8.55228 17 8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19ZM8 21C9.65685 21 11 19.6569 11 18C11 16.3431 9.65685 15 8 15C6.34315 15 5 16.3431 5 18C5 19.6569 6.34315 21 8 21Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React417.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13ZM16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePreferences48.tsx
import * as React418 from "react";
var componentNameString412 = "FeaturePreferences48";
function FeaturePreferences48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString412,
    ...props
  });
  return /* @__PURE__ */ React418.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React418.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React418.createElement("path", { fillRule: "evenodd", d: "M44 25.8h-8v-3.6h8v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React418.createElement("path", { fillRule: "evenodd", d: "M28 25.8H4v-3.6h24v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React418.createElement("path", { fillRule: "evenodd", d: "M44 37.8H20v-3.5h24v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React418.createElement("path", { fillRule: "evenodd", d: "M12 37.8H4v-3.5h8v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React418.createElement("path", { fillRule: "evenodd", d: "M44 13.8H20v-3.6h24v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React418.createElement("path", { fillRule: "evenodd", d: "M12 13.8H4v-3.6h8v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React418.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 3.5a6 6 0 100-12 6 6 0 000 12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React418.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 38.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 3.5a6 6 0 100-12 6 6 0 000 12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React418.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32 26.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 3.5a6 6 0 100-12 6 6 0 000 12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePreferences72.tsx
import * as React419 from "react";
var componentNameString413 = "FeaturePreferences72";
function FeaturePreferences72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString413,
    ...props
  });
  return /* @__PURE__ */ React419.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React419.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M66 38.5H54v-5h12v5z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M42 38.5H6v-5h36v5z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M66 56.5H30v-5h36v5z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M18 56.5H6v-5h12v5z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M66 20.5H30v-5h36v5z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M18 20.5H6v-5h12v5z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M24 22a4 4 0 100-8 4 4 0 000 8zm0 5a9 9 0 100-18 9 9 0 000 18z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M24 58a4 4 0 100-8 4 4 0 000 8zm0 5a9 9 0 100-18 9 9 0 000 18z", clipRule: "evenodd" }), /* @__PURE__ */ React419.createElement("path", { fillRule: "evenodd", d: "M48 40a4 4 0 100-8 4 4 0 000 8zm0 5a9 9 0 100-18 9 9 0 000 18z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePresent24.tsx
import * as React420 from "react";
var componentNameString414 = "FeaturePresent24";
function FeaturePresent24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString414,
    ...props
  });
  return /* @__PURE__ */ React420.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React420.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React420.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.4142 5H19C20.1046 5 21 5.89543 21 7V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V7C3 5.89543 3.89543 5 5 5H9.58574L7.75737 3.17163L9.17158 1.75742L11 3.58583V1H13V3.58574L14.8284 1.75732L16.2426 3.17154L14.4142 5ZM11 7H5V12H11V7ZM13 12H19V7H13V12ZM13 14H19V19H13V14ZM11 14H5V19H11V14Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePresent48.tsx
import * as React421 from "react";
var componentNameString415 = "FeaturePresent48";
function FeaturePresent48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString415,
    ...props
  });
  return /* @__PURE__ */ React421.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React421.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React421.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 13.5H10c-.3 0-.5.2-.5.5v24c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5V14c0-.3-.2-.5-.5-.5zM10 10a4 4 0 00-4 4v24a4 4 0 004 4h28a4 4 0 004-4V14a4 4 0 00-4-4H10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React421.createElement("path", { fillRule: "evenodd", d: "M22.3 40V12h3.4v28h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React421.createElement("path", { fillRule: "evenodd", d: "M8 24.3h32v3.4H8v-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React421.createElement("path", { fillRule: "evenodd", d: "M22.3 22V2h3.4v20h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React421.createElement("path", { fillRule: "evenodd", d: "M22.8 13.2l-7.1-7 2.5-2.5 7 7-2.4 2.5z", clipRule: "evenodd" }), /* @__PURE__ */ React421.createElement("path", { fillRule: "evenodd", d: "M22.8 10.8l7-7.1 2.5 2.5-7 7-2.5-2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePresent72.tsx
import * as React422 from "react";
var componentNameString416 = "FeaturePresent72";
function FeaturePresent72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString416,
    ...props
  });
  return /* @__PURE__ */ React422.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React422.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React422.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57 20H15a1 1 0 00-1 1v36c0 .6.4 1 1 1h42c.6 0 1-.4 1-1V21c0-.6-.4-1-1-1zm-42-5a6 6 0 00-6 6v36a6 6 0 006 6h42a6 6 0 006-6V21a6 6 0 00-6-6H15z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React422.createElement("path", { fillRule: "evenodd", d: "M33.5 60V18h5v42h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React422.createElement("path", { fillRule: "evenodd", d: "M12 36.5h48v5H12v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React422.createElement("path", { fillRule: "evenodd", d: "M33.5 33V3h5v30h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React422.createElement("path", { fillRule: "evenodd", d: "M34.2 19.8L23.6 9.2l3.6-3.6 10.6 10.6-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React422.createElement("path", { fillRule: "evenodd", d: "M34.2 16.2L44.8 5.6l3.6 3.6-10.6 10.6-3.6-3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeaturePresentation24.tsx
import * as React423 from "react";
var componentNameString417 = "FeaturePresentation24";
function FeaturePresentation24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString417,
    ...props
  });
  return /* @__PURE__ */ React423.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React423.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React423.createElement("path", { fillRule: "evenodd", d: "M7 12L7 10L9 10L9 12L7 12Z", clipRule: "evenodd" }), /* @__PURE__ */ React423.createElement("path", { fillRule: "evenodd", d: "M8 20L16 20L16 22L8 22L8 20Z", clipRule: "evenodd" }), /* @__PURE__ */ React423.createElement("path", { fillRule: "evenodd", d: "M11 12L11 8L13 8L13 12L11 12Z", clipRule: "evenodd" }), /* @__PURE__ */ React423.createElement("path", { fillRule: "evenodd", d: "M11 21L11 18L13 18L13 21L11 21Z", clipRule: "evenodd" }), /* @__PURE__ */ React423.createElement("path", { fillRule: "evenodd", d: "M15 12L15 6L17 6L17 12L15 12Z", clipRule: "evenodd" }), /* @__PURE__ */ React423.createElement("path", { fillRule: "evenodd", d: "M23 4L1 4L1 2L23 2V4Z", clipRule: "evenodd" }), /* @__PURE__ */ React423.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5 4V14H19V4H5ZM21 2V14C21 15.1046 20.1046 16 19 16H5C3.89543 16 3 15.1046 3 14V2H21Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePresentation48.tsx
import * as React424 from "react";
var componentNameString418 = "FeaturePresentation48";
function FeaturePresentation48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString418,
    ...props
  });
  return /* @__PURE__ */ React424.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React424.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React424.createElement("path", { fillRule: "evenodd", d: "M14.3 24v-4h3.4v4h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React424.createElement("path", { fillRule: "evenodd", d: "M16 40.3h16v3.5H16v-3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React424.createElement("path", { fillRule: "evenodd", d: "M22.3 24v-8h3.4v8h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React424.createElement("path", { fillRule: "evenodd", d: "M22.3 42v-6h3.4v6h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React424.createElement("path", { fillRule: "evenodd", d: "M30.3 24V12h3.4v12h-3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React424.createElement("path", { fillRule: "evenodd", d: "M46 7H2V3.7h44V7z", clipRule: "evenodd" }), /* @__PURE__ */ React424.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.5 7.5V26c0 1.4 1.1 2.5 2.5 2.5h24c1.4 0 2.5-1.1 2.5-2.5V7.5h-29zM42 4v22a6 6 0 01-6 6H12a6 6 0 01-6-6V4h36z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeaturePresentation72.tsx
import * as React425 from "react";
var componentNameString419 = "FeaturePresentation72";
function FeaturePresentation72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString419,
    ...props
  });
  return /* @__PURE__ */ React425.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React425.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React425.createElement("path", { fillRule: "evenodd", d: "M21.5 36v-6h5v6h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React425.createElement("path", { fillRule: "evenodd", d: "M24 60.5h24v5H24v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React425.createElement("path", { fillRule: "evenodd", d: "M33.5 36V24h5v12h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React425.createElement("path", { fillRule: "evenodd", d: "M33.5 63v-9h5v9h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React425.createElement("path", { fillRule: "evenodd", d: "M45.5 36V18h5v18h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React425.createElement("path", { fillRule: "evenodd", d: "M69 10.5H3v-5h66v5z", clipRule: "evenodd" }), /* @__PURE__ */ React425.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14 11v31c0 .6.4 1 1 1h42c.6 0 1-.4 1-1V11H14zm49-5v36a6 6 0 01-6 6H15a6 6 0 01-6-6V6h54z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureQuestionMark24.tsx
import * as React426 from "react";
var componentNameString420 = "FeatureQuestionMark24";
function FeatureQuestionMark24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString420,
    ...props
  });
  return /* @__PURE__ */ React426.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React426.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React426.createElement("path", { d: "M7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9C17 11.7614 14.7614 14 12 14H11V18H13V15.9291C16.3923 15.4439 19 12.5265 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9H7Z" }), /* @__PURE__ */ React426.createElement("path", { d: "M13 22V20H11V22H13Z" }));
}

// src/components/icons/FeatureQuestionMark48.tsx
import * as React427 from "react";
var componentNameString421 = "FeatureQuestionMark48";
function FeatureQuestionMark48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString421,
    ...props
  });
  return /* @__PURE__ */ React427.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React427.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React427.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 7.8c-5 0-9 3.9-9 8.6h-3.4c0-6.8 5.6-12.1 12.4-12.1 6.8 0 12.4 5.3 12.4 12.1 0 6.2-4.7 11.2-10.7 12v6.3h-3.5V25H24c5 0 9-3.9 9-8.6 0-4.7-4-8.6-9-8.6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React427.createElement("path", { fillRule: "evenodd", d: "M22.3 42v-3.3h3.4V42h-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureQuestionMark72.tsx
import * as React428 from "react";
var componentNameString422 = "FeatureQuestionMark72";
function FeatureQuestionMark72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString422,
    ...props
  });
  return /* @__PURE__ */ React428.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React428.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React428.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.5c-7.5 0-13.5 6-13.5 13.1h-5c0-10 8.3-18.1 18.5-18.1s18.5 8 18.5 18.1c0 9.2-7 16.7-16 18V52h-5V37.7H36c7.5 0 13.5-6 13.5-13.1 0-7.2-6-13.1-13.5-13.1z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React428.createElement("path", { fillRule: "evenodd", d: "M33.5 63v-5h5v5h-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureQuestionMarkInCircle24.tsx
import * as React429 from "react";
var componentNameString423 = "FeatureQuestionMarkInCircle24";
function FeatureQuestionMarkInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString423,
    ...props
  });
  return /* @__PURE__ */ React429.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React429.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React429.createElement("path", { d: "M12 8C10.8954 8 10 8.89543 10 10H8C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14H11V12H12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z" }), /* @__PURE__ */ React429.createElement("path", { d: "M13 18V16H11V18H13Z" }), /* @__PURE__ */ React429.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureQuestionMarkInCircle48.tsx
import * as React430 from "react";
var componentNameString424 = "FeatureQuestionMarkInCircle48";
function FeatureQuestionMarkInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString424,
    ...props
  });
  return /* @__PURE__ */ React430.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React430.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React430.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React430.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M23.7 15.8a5 5 0 00-5 5.2h-3.4c0-4.8 3.6-8.8 8.4-8.8 4.7 0 8.4 4 8.4 8.8 0 4.8-3.7 8.8-8.4 8.8h-2.3v-3.6h2.3c2.6 0 4.9-2.2 4.9-5.2s-2.3-5.3-5-5.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React430.createElement("path", { fillRule: "evenodd", d: "M21.6 35.7v-3.4H25v3.4h-3.5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureQuestionMarkInCircle72.tsx
import * as React431 from "react";
var componentNameString425 = "FeatureQuestionMarkInCircle72";
function FeatureQuestionMarkInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString425,
    ...props
  });
  return /* @__PURE__ */ React431.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React431.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React431.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React431.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 22.5c-4 0-7.5 3.5-7.5 8h-5c0-7 5.5-13 12.5-13s12.5 6 12.5 13-5.5 13-12.5 13h-3.3v-5H36c4 0 7.5-3.5 7.5-8s-3.5-8-7.5-8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React431.createElement("path", { fillRule: "evenodd", d: "M32.5 52v-5h5v5h-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureQuote24.tsx
import * as React432 from "react";
var componentNameString426 = "FeatureQuote24";
function FeatureQuote24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString426,
    ...props
  });
  return /* @__PURE__ */ React432.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React432.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React432.createElement("path", { fillRule: "evenodd", d: "M8 8H6V10H8V8ZM4 6V12H10V6H4Z", clipRule: "evenodd" }), /* @__PURE__ */ React432.createElement("path", { fillRule: "evenodd", d: "M18 8H16V10H18V8ZM14 6V12H20V6H14Z", clipRule: "evenodd" }), /* @__PURE__ */ React432.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10 18C6.68629 18 4 15.3137 4 12H6C6 14.2091 7.79086 16 10 16V18Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React432.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20 18C16.6863 18 14 15.3137 14 12H16C16 14.2091 17.7909 16 20 16V18Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureQuote48.tsx
import * as React433 from "react";
var componentNameString427 = "FeatureQuote48";
function FeatureQuote48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString427,
    ...props
  });
  return /* @__PURE__ */ React433.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React433.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React433.createElement("path", { fillRule: "evenodd", d: "M16.5 15.5h-5v5h5v-5zM8 12v12h12V12H8z", clipRule: "evenodd" }), /* @__PURE__ */ React433.createElement("path", { fillRule: "evenodd", d: "M36.5 15.5h-5v5h5v-5zM28 12v12h12V12H28z", clipRule: "evenodd" }), /* @__PURE__ */ React433.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 27v-3h3.5v3c0 2.9 2.4 5.3 5.3 5.3h3v3.5h-3c-4.9 0-8.8-4-8.8-8.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React433.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28 27v-3h3.5v3c0 2.9 2.4 5.3 5.3 5.3h3v3.5h-3c-4.9 0-8.8-4-8.8-8.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureQuote72.tsx
import * as React434 from "react";
var componentNameString428 = "FeatureQuote72";
function FeatureQuote72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString428,
    ...props
  });
  return /* @__PURE__ */ React434.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React434.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React434.createElement("path", { fillRule: "evenodd", d: "M25 23h-8v8h8v-8zm-13-5v18h18V18H12z", clipRule: "evenodd" }), /* @__PURE__ */ React434.createElement("path", { fillRule: "evenodd", d: "M55 23h-8v8h8v-8zm-13-5v18h18V18H42z", clipRule: "evenodd" }), /* @__PURE__ */ React434.createElement("path", { fillRule: "evenodd", d: "M12 44v-8h6v8a4 4 0 004 4h8v6h-8a10 10 0 01-10-10z", clipRule: "evenodd" }), /* @__PURE__ */ React434.createElement("path", { fillRule: "evenodd", d: "M42 44v-8h6v8a4 4 0 004 4h8v6h-8a10 10 0 01-10-10z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureRattle.tsx
import * as React435 from "react";
var componentNameString429 = "FeatureRattle";
function FeatureRattle({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString429,
    ...props
  });
  return /* @__PURE__ */ React435.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React435.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React435.createElement("path", { d: "M34.4 38.3l-8-8a24 24 0 003.8-4l8 8a6.5 6.5 0 11-3.8 4zm7.9.4a2.5 2.5 0 10-3.6 3.6 2.5 2.5 0 003.6-3.6z" }), /* @__PURE__ */ React435.createElement("path", { d: "M23.4 2.8L2.8 23.4A14.7 14.7 0 0123.3 2.9zm3.2 3.3A14.7 14.7 0 016 26.6L26.6 6z" }));
}

// src/components/icons/FeatureRebalancing24.tsx
import * as React436 from "react";
var componentNameString430 = "FeatureRebalancing24";
function FeatureRebalancing24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString430,
    ...props
  });
  return /* @__PURE__ */ React436.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React436.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React436.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21.9182 12.3775L2.59967 17.5539L2.08203 15.6221L21.4005 10.4457L21.9182 12.3775Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React436.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17.9331 8.18832C18.4665 8.04538 18.7831 7.49704 18.6402 6.96358C18.4972 6.43011 17.9489 6.11353 17.4154 6.25647C16.8819 6.39941 16.5654 6.94775 16.7083 7.48121C16.8513 8.01468 17.3996 8.33126 17.9331 8.18832ZM18.4507 10.1202C20.0511 9.69135 21.0008 8.04634 20.572 6.44594C20.1432 4.84554 18.4982 3.89579 16.8978 4.32462C15.2974 4.75344 14.3476 6.39845 14.7765 7.99885C15.2053 9.59925 16.8503 10.549 18.4507 10.1202Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React436.createElement("path", { d: "M6.90551 10.0695C7.33433 11.6699 6.38459 13.3149 4.78419 13.7437C3.18379 14.1725 1.53878 13.2228 1.10995 11.6224C0.681128 10.022 1.63088 8.37698 3.23127 7.94815C4.83167 7.51933 6.47668 8.46907 6.90551 10.0695Z" }), /* @__PURE__ */ React436.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3.49009 8.91408C2.42316 9.19996 1.79 10.2966 2.07588 11.3636C2.36176 12.4305 3.45844 13.0637 4.52537 12.7778C5.5923 12.4919 6.22547 11.3952 5.93958 10.3283C5.6537 9.26136 4.55702 8.62819 3.49009 8.91408ZM4.78419 13.7437C6.38459 13.3149 7.33433 11.6699 6.90551 10.0695C6.47668 8.46907 4.83167 7.51933 3.23127 7.94815C1.63088 8.37698 0.681128 10.022 1.10995 11.6224C1.53878 13.2228 3.18379 14.1725 4.78419 13.7437Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React436.createElement("path", { fillRule: "evenodd", d: "M16 21L12 17L8 21H16Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureRebalancing48.tsx
import * as React437 from "react";
var componentNameString431 = "FeatureRebalancing48";
function FeatureRebalancing48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString431,
    ...props
  });
  return /* @__PURE__ */ React437.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React437.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React437.createElement("path", { fillRule: "evenodd", d: "M43.8 24.5L5 35l-.9-3.4L43 21l.9 3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React437.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 16.9a2.5 2.5 0 10-1.3-4.9 2.5 2.5 0 001.3 5zm.9 3.3a6 6 0 10-3.1-11.6 6 6 0 003.1 11.6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React437.createElement("path", { d: "M13.8 20.1a6 6 0 11-11.6 3.1 6 6 0 0111.6-3z" }), /* @__PURE__ */ React437.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8.3 22.7a1 1 0 10-.5-2 1 1 0 00.5 2zm1.3 4.8a6 6 0 10-3.1-11.6 6 6 0 003 11.6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React437.createElement("path", { fillRule: "evenodd", d: "M16 42h16l-8-8-8 8z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureRebalancing72.tsx
import * as React438 from "react";
var componentNameString432 = "FeatureRebalancing72";
function FeatureRebalancing72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString432,
    ...props
  });
  return /* @__PURE__ */ React438.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React438.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React438.createElement("path", { fillRule: "evenodd", d: "M65.6 36.7l-58 15.5-1.2-4.9 58-15.5 1.2 4.9z", clipRule: "evenodd" }), /* @__PURE__ */ React438.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54 25.5a4 4 0 10-2-7.7 4 4 0 002 7.7zm1.4 4.9A9 9 0 1050.7 13a9 9 0 004.7 17.4z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React438.createElement("path", { d: "M20.7 30.2A9 9 0 113.3 35a9 9 0 0117.4-4.7z" }), /* @__PURE__ */ React438.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13 36.4a4 4 0 10-2-7.7 4 4 0 002 7.7zm1.4 4.8a9 9 0 10-4.7-17.4 9 9 0 004.7 17.4z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React438.createElement("path", { fillRule: "evenodd", d: "M24 63h24L36 51 24 63z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureRedo24.tsx
import * as React439 from "react";
var componentNameString433 = "FeatureRedo24";
function FeatureRedo24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString433,
    ...props
  });
  return /* @__PURE__ */ React439.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React439.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React439.createElement("path", { d: "M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19V21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12V16.5859L22.2929 15.293L23.7071 16.7072L20 20.4143L16.2929 16.7072L17.7071 15.293L19 16.5859V12Z" }));
}

// src/components/icons/FeatureRedo48.tsx
import * as React440 from "react";
var componentNameString434 = "FeatureRedo48";
function FeatureRedo48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString434,
    ...props
  });
  return /* @__PURE__ */ React440.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React440.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React440.createElement("path", { fillRule: "evenodd", d: "M40 40.5l-7.2-7.3 2.4-2.4 4.8 4.7 4.8-4.7 2.4 2.4-7.2 7.3z", clipRule: "evenodd" }), /* @__PURE__ */ React440.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 9.8c7.9 0 14.3 6.3 14.3 14.2v12h3.5V24A17.7 17.7 0 1024 41.8v-3.5a14.2 14.2 0 110-28.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureRedo72.tsx
import * as React441 from "react";
var componentNameString435 = "FeatureRedo72";
function FeatureRedo72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString435,
    ...props
  });
  return /* @__PURE__ */ React441.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React441.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React441.createElement("path", { fillRule: "evenodd", d: "M60 60.5L49.2 49.8l3.6-3.6 7.2 7.3 7.2-7.3 3.6 3.6L60 60.5z", clipRule: "evenodd" }), /* @__PURE__ */ React441.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 14.5c11.9 0 21.5 9.6 21.5 21.5v18h5V36A26.5 26.5 0 1036 62.5v-5a21.5 21.5 0 010-43z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureResponse24.tsx
import * as React442 from "react";
var componentNameString436 = "FeatureResponse24";
function FeatureResponse24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString436,
    ...props
  });
  return /* @__PURE__ */ React442.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React442.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React442.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5.17157 14L4 15.1716L4 4L16 4L16 14L5.17157 14ZM2 20L6 16L16 16C17.1046 16 18 15.1046 18 14V4C18 2.89543 17.1046 2 16 2L4 2C2.89543 2 2 2.89543 2 4L2 20Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React442.createElement("path", { fillRule: "evenodd", d: "M6 8H14V6H6V8Z", clipRule: "evenodd" }), /* @__PURE__ */ React442.createElement("path", { fillRule: "evenodd", d: "M6 12H12V10H6V12Z", clipRule: "evenodd" }), /* @__PURE__ */ React442.createElement("path", { d: "M20 8C21.1046 8 22 8.89543 22 10V22L20 20H8C6.89543 20 6 19.1046 6 18H20L20 8Z" }));
}

// src/components/icons/FeatureResponse48.tsx
import * as React443 from "react";
var componentNameString437 = "FeatureResponse48";
function FeatureResponse48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString437,
    ...props
  });
  return /* @__PURE__ */ React443.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React443.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React443.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10.6 28.5l-3.1 3V8c0-.3.2-.5.5-.5h24c.3 0 .5.2.5.5v20c0 .3-.2.5-.5.5H10.6zM4 40l8-8h20a4 4 0 004-4V8a4 4 0 00-4-4H8a4 4 0 00-4 4v32z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React443.createElement("path", { fillRule: "evenodd", d: "M12 15.8h16v-3.6H12v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React443.createElement("path", { fillRule: "evenodd", d: "M12 23.8h12v-3.6H12v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React443.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40.8 16a4 4 0 013.2 4v24l-3.5-3.5-.5-.5H16a4 4 0 01-4-3.5h28.8V16.1z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureResponse72.tsx
import * as React444 from "react";
var componentNameString438 = "FeatureResponse72";
function FeatureResponse72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString438,
    ...props
  });
  return /* @__PURE__ */ React444.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React444.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React444.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 43l-5 5V12c0-.6.4-1 1-1h36c.6 0 1 .4 1 1v30c0 .6-.4 1-1 1H16zM6 60l12-12h30a6 6 0 006-6V12a6 6 0 00-6-6H12a6 6 0 00-6 6v48z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React444.createElement("path", { fillRule: "evenodd", d: "M18 23.5h24v-5H18v5z", clipRule: "evenodd" }), /* @__PURE__ */ React444.createElement("path", { fillRule: "evenodd", d: "M18 35.5h18v-5H18v5z", clipRule: "evenodd" }), /* @__PURE__ */ React444.createElement("path", { fillRule: "evenodd", d: "M61 24c2.8.6 5 3 5 6v36l-5-5-1-1H24a6 6 0 01-6-5h43V24z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureRibbon24.tsx
import * as React445 from "react";
var componentNameString439 = "FeatureRibbon24";
function FeatureRibbon24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString439,
    ...props
  });
  return /* @__PURE__ */ React445.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React445.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React445.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13ZM12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React445.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 13.7451V14V20.1716V23L10 21L10.5858 20.4142L12 19L13.4142 20.4142L14 21L16 23V20.1716V14V13.7451C15.396 14.1664 14.7224 14.4949 14 14.7099V18.1716L13.4142 17.5858L12 16.1716L10.5858 17.5858L10 18.1716V14.7099C9.27757 14.4949 8.60401 14.1664 8 13.7451Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureRibbon48.tsx
import * as React446 from "react";
var componentNameString440 = "FeatureRibbon48";
function FeatureRibbon48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString440,
    ...props
  });
  return /* @__PURE__ */ React446.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React446.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React446.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 26.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21zm0 3.5a14 14 0 100-28 14 14 0 000 28z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React446.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 19.8a3.8 3.8 0 100-7.6 3.8 3.8 0 000 7.6zm0 3.5a7.3 7.3 0 100-14.6 7.3 7.3 0 000 14.6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React446.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 27.5V46l3.5-3.5 2-2L24 38l2.5 2.5 2 2L32 46V27.5a14 14 0 01-3.5 1.8v8.3l-2-2L24 33l-2.5 2.4-2 2v-8.2a14 14 0 01-3.5-1.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureRibbon72.tsx
import * as React447 from "react";
var componentNameString441 = "FeatureRibbon72";
function FeatureRibbon72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString441,
    ...props
  });
  return /* @__PURE__ */ React447.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React447.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React447.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 40a16 16 0 100-32 16 16 0 000 32zm0 5a21 21 0 100-42 21 21 0 000 42z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React447.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 30a6 6 0 100-12 6 6 0 000 12zm0 5a11 11 0 100-22 11 11 0 000 22z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React447.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 41.2V69l5-5 3.5-3.5L36 57l3.5 3.5L43 64l5 5V41.2a21 21 0 01-5 2.6v13.1l-3.5-3.4-3.5-3.6-3.5 3.6-3.5 3.4V43.8a21 21 0 01-5-2.6z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureRight24.tsx
import * as React448 from "react";
var componentNameString442 = "FeatureRight24";
function FeatureRight24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString442,
    ...props
  });
  return /* @__PURE__ */ React448.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React448.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React448.createElement("path", { fillRule: "evenodd", d: "M18 13L4 13L4 11L18 11L18 13Z", clipRule: "evenodd" }), /* @__PURE__ */ React448.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.4141 12L13.707 18.7071L12.2927 17.2929L17.5856 12L12.2927 6.70711L13.707 5.29289L20.4141 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureRight48.tsx
import * as React449 from "react";
var componentNameString443 = "FeatureRight48";
function FeatureRight48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString443,
    ...props
  });
  return /* @__PURE__ */ React449.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React449.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React449.createElement("path", { fillRule: "evenodd", d: "M36 25.75L8 25.75L8 22.25L36 22.25L36 25.75Z", clipRule: "evenodd" }), /* @__PURE__ */ React449.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40.4746 24L27.2372 37.2374L24.7623 34.7626L35.5249 24L24.7623 13.2374L27.2372 10.7626L40.4746 24Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureRight72.tsx
import * as React450 from "react";
var componentNameString444 = "FeatureRight72";
function FeatureRight72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString444,
    ...props
  });
  return /* @__PURE__ */ React450.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React450.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React450.createElement("path", { fillRule: "evenodd", d: "M54 38.5L12 38.5L12 33.5L54 33.5L54 38.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React450.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M60.5356 36L40.7679 55.7678L37.2323 52.2322L53.4646 36L37.2323 19.7678L40.7679 16.2322L60.5356 36Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureRightArrowSmall24.tsx
import * as React451 from "react";
var componentNameString445 = "FeatureRightArrowSmall24";
function FeatureRightArrowSmall24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString445,
    ...props
  });
  return /* @__PURE__ */ React451.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React451.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React451.createElement("path", { d: "M12.7071 7.29285L17.4142 12L12.7071 16.7071L11.2929 15.2928L13.5858 13H7V11L13.5858 11L11.2929 8.70706L12.7071 7.29285Z" }));
}

// src/components/icons/FeatureSafe24.tsx
import * as React452 from "react";
var componentNameString446 = "FeatureSafe24";
function FeatureSafe24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString446,
    ...props
  });
  return /* @__PURE__ */ React452.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React452.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React452.createElement("path", { fillRule: "evenodd", d: "M19 20L19 4L5 4L5 20L19 20ZM21 2L3 2L3 22L21 22L21 2Z", clipRule: "evenodd" }), /* @__PURE__ */ React452.createElement("circle", { cx: 12, cy: 8, r: 1 }), /* @__PURE__ */ React452.createElement("path", { fillRule: "evenodd", d: "M11 16V12H13V16H11Z", clipRule: "evenodd" }), /* @__PURE__ */ React452.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.9641 18.8662L11.5 16.8662L12.5 15.1342L15.9641 17.1342L14.9641 18.8662Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React452.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.5 16.8662L9.03589 18.8662L8.03589 17.1342L11.5 15.1342L12.5 16.8662Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React452.createElement("path", { fillRule: "evenodd", d: "M20 9H17V7H20V9Z", clipRule: "evenodd" }), /* @__PURE__ */ React452.createElement("path", { fillRule: "evenodd", d: "M20 17H17V15H20V17Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSafe48.tsx
import * as React453 from "react";
var componentNameString447 = "FeatureSafe48";
function FeatureSafe48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString447,
    ...props
  });
  return /* @__PURE__ */ React453.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React453.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React453.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.5 40V8c0-.3-.2-.5-.5-.5H10c-.3 0-.5.2-.5.5v32c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5zM42 8a4 4 0 00-4-4H10a4 4 0 00-4 4v32a4 4 0 004 4h28a4 4 0 004-4V8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React453.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 14.4a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zM19 16a5 5 0 1110 0 5 5 0 01-10 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React453.createElement("path", { fillRule: "evenodd", d: "M22.3 32v-8h3.4v8h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React453.createElement("path", { fillRule: "evenodd", d: "M30 37.5l-6.9-4 1.8-3 6.9 4-1.7 3z", clipRule: "evenodd" }), /* @__PURE__ */ React453.createElement("path", { fillRule: "evenodd", d: "M24.9 33.5l-7 4-1.7-3 7-4 1.7 3z", clipRule: "evenodd" }), /* @__PURE__ */ React453.createElement("path", { fillRule: "evenodd", d: "M40 17.8h-6v-3.6h6v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React453.createElement("path", { fillRule: "evenodd", d: "M40 33.8h-6v-3.5h6v3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSafe72.tsx
import * as React454 from "react";
var componentNameString448 = "FeatureSafe72";
function FeatureSafe72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString448,
    ...props
  });
  return /* @__PURE__ */ React454.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React454.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React454.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M58 60V12c0-.6-.4-1-1-1H15a1 1 0 00-1 1v48c0 .6.4 1 1 1h42c.6 0 1-.4 1-1zm5-48a6 6 0 00-6-6H15a6 6 0 00-6 6v48a6 6 0 006 6h42a6 6 0 006-6V12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React454.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 21.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM28.5 24a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React454.createElement("path", { fillRule: "evenodd", d: "M33.5 48V36h5v12h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React454.createElement("path", { fillRule: "evenodd", d: "M45.1 56.2l-10.4-6 2.5-4.4 10.4 6-2.5 4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React454.createElement("path", { fillRule: "evenodd", d: "M37.3 50.2l-10.4 6-2.5-4.4 10.4-6 2.5 4.4z", clipRule: "evenodd" }), /* @__PURE__ */ React454.createElement("path", { fillRule: "evenodd", d: "M60 26.5h-9v-5h9v5z", clipRule: "evenodd" }), /* @__PURE__ */ React454.createElement("path", { fillRule: "evenodd", d: "M60 50.5h-9v-5h9v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSafetyNet48.tsx
import * as React455 from "react";
var componentNameString449 = "FeatureSafetyNet48";
function FeatureSafetyNet48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString449,
    ...props
  });
  return /* @__PURE__ */ React455.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React455.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React455.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28.6 17.3c1 .6 1.8 1.5 2.4 2.5l7-7-2.6-2.4-6.8 6.9zm2.3 11c-.7 1-1.5 2-2.5 2.6l7 7 2.5-2.5-7-7zm-11 2.7c-1-.7-2-1.5-2.6-2.5l-7 7 2.5 2.5 7-7zm-2.7-11.3l-6.9-7 2.5-2.4 6.9 6.9c-1 .6-1.9 1.5-2.5 2.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React455.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React455.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 29.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0 3.5a9 9 0 100-18 9 9 0 000 18z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSafetyNet72.tsx
import * as React456 from "react";
var componentNameString450 = "FeatureSafetyNet72";
function FeatureSafetyNet72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString450,
    ...props
  });
  return /* @__PURE__ */ React456.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React456.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React456.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm14-25a14 14 0 11-28 0 14 14 0 0128 0zm16 0a30 30 0 11-60 0 30 30 0 0160 0zm-21 0a9 9 0 11-18 0 9 9 0 0118 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React456.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M43.3 25.4a13 13 0 013.4 3.6l11-11-3.5-3.6-11 11zm3.3 17.9a13 13 0 01-3.6 3.5L54.2 58l3.6-3.5-11.2-11.2zM28.8 47a13 13 0 01-3.7-3.5L14 54.6l3.5 3.6L28.8 47zM17.5 14.2l11 11a13 13 0 00-3.5 3.5l-11-11 3.5-3.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSafetyNet24.tsx
import * as React457 from "react";
var componentNameString451 = "FeatureSafetyNet24";
function FeatureSafetyNet24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString451,
    ...props
  });
  return /* @__PURE__ */ React457.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React457.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React457.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React457.createElement("mask", { id: "a", width: 20, height: 20, x: 2, y: 2, maskUnits: "userSpaceOnUse" }, /* @__PURE__ */ React457.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
      clipRule: "evenodd"
    }
  )), /* @__PURE__ */ React457.createElement("g", { mask: "url(#a)" }, /* @__PURE__ */ React457.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.4853 4.92913L19.0711 3.51492L12 10.586L4.92893 3.51491L3.51472 4.92913L10.5858 12.0002L3.51472 19.0713L4.92893 20.4855L12 13.4144L19.0711 20.4855L20.4853 19.0713L13.4142 12.0002L20.4853 4.92913Z",
      clipRule: "evenodd"
    }
  )));
}

// src/components/icons/FeatureScale.tsx
import * as React458 from "react";
var componentNameString452 = "FeatureScale";
function FeatureScale({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString452,
    ...props
  });
  return /* @__PURE__ */ React458.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React458.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React458.createElement("polygon", { points: "13.537 38.611 34.322 38.611 23.929 20.611", className: "sc-Icon--secondary-color" }), /* @__PURE__ */ React458.createElement("polygon", { points: "47.345 9 0 12.31 .558 20.291 47.903 16.98", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureSearch24.tsx
import * as React459 from "react";
var componentNameString453 = "FeatureSearch24";
function FeatureSearch24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString453,
    ...props
  });
  return /* @__PURE__ */ React459.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React459.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React459.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.435 20.8493L12.435 13.8493L13.8492 12.4351L20.8492 19.4351L19.435 20.8493Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React459.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.5 14C11.9853 14 14 11.9853 14 9.5C14 7.01472 11.9853 5 9.5 5C7.01472 5 5 7.01472 5 9.5C5 11.9853 7.01472 14 9.5 14ZM9.5 16C13.0899 16 16 13.0899 16 9.5C16 5.91015 13.0899 3 9.5 3C5.91015 3 3 5.91015 3 9.5C3 13.0899 5.91015 16 9.5 16Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSearch48.tsx
import * as React460 from "react";
var componentNameString454 = "FeatureSearch48";
function FeatureSearch48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString454,
    ...props
  });
  return /* @__PURE__ */ React460.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React460.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React460.createElement("path", { fillRule: "evenodd", d: "M39 41.5l-14-14 2.5-2.5 14 14-2.5 2.5z", clipRule: "evenodd" }), /* @__PURE__ */ React460.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 28.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19zm0 3.5a13 13 0 100-26 13 13 0 000 26z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSearch72.tsx
import * as React461 from "react";
var componentNameString455 = "FeatureSearch72";
function FeatureSearch72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString455,
    ...props
  });
  return /* @__PURE__ */ React461.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React461.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React461.createElement("path", { fillRule: "evenodd", d: "M58.7 62.2l-21-21 3.5-3.5 21 21-3.5 3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React461.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28.5 43a14.5 14.5 0 100-29 14.5 14.5 0 000 29zm0 5a19.5 19.5 0 100-39 19.5 19.5 0 000 39z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSearch.tsx
import * as React462 from "react";
var componentNameString456 = "FeatureSearch";
function FeatureSearch({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString456,
    ...props
  });
  return /* @__PURE__ */ React462.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React462.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React462.createElement("path", { d: "M33.5 29.3c-1.2 1.6-2.6 3-4.2 4.2L43.8 48l4.2-4.2-14.5-14.5z" }), /* @__PURE__ */ React462.createElement("path", { d: "M16 0a16 16 0 110 32 16 16 0 010-32zm0 26a10 10 0 100-20 10 10 0 000 20z" }));
}

// src/components/icons/FeatureSecurityCheck24.tsx
import * as React463 from "react";
var componentNameString457 = "FeatureSecurityCheck24";
function FeatureSecurityCheck24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString457,
    ...props
  });
  return /* @__PURE__ */ React463.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React463.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React463.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 4.23607L6 7.23607V9.05573C6 13.4372 8.29592 17.4699 12 19.7173C15.7041 17.4699 18 13.4372 18 9.05573V7.23607L12 4.23607ZM20 6L12 2L4 6V9.05573C4 14.5374 7.09707 19.5485 12 22C16.9029 19.5485 20 14.5374 20 9.05573V6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React463.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.7072 9.70718L11.0001 15.4143L7.79297 12.2072L9.20718 10.793L11.0001 12.5859L15.293 8.29297L16.7072 9.70718Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSecurityCheck48.tsx
import * as React464 from "react";
var componentNameString458 = "FeatureSecurityCheck48";
function FeatureSecurityCheck48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString458,
    ...props
  });
  return /* @__PURE__ */ React464.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React464.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React464.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 8l-12.5 6.2v4c0 9 4.8 17.3 12.5 21.8a25.4 25.4 0 0012.5-21.9v-4L24 8zm16 4L24 4 8 12v6.1c0 11 6.2 21 16 25.9a29 29 0 0016-25.9V12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React464.createElement("path", { fillRule: "evenodd", d: "M30.8 16.8l2.4 2.4L22 30.5l-6.2-6.3 2.4-2.4 3.8 3.7 8.8-8.7z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSecurityCheck72.tsx
import * as React465 from "react";
var componentNameString459 = "FeatureSecurityCheck72";
function FeatureSecurityCheck72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString459,
    ...props
  });
  return /* @__PURE__ */ React465.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React465.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React465.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.6L17 21v6c0 13.8 7.3 26.4 19 33.2a38.4 38.4 0 0019-33.1V21l-19-9.5zM60 18L36 6 12 18v9.2c0 16.4 9.3 31.4 24 38.8a43.4 43.4 0 0024-38.8V18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React465.createElement("path", { fillRule: "evenodd", d: "M49.8 28.8L33 45.5l-9.3-9.2 3.6-3.6 5.7 5.8 13.2-13.3 3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSecurityReview24.tsx
import * as React466 from "react";
var componentNameString460 = "FeatureSecurityReview24";
function FeatureSecurityReview24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString460,
    ...props
  });
  return /* @__PURE__ */ React466.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React466.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React466.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.2929 17.7072L13.2929 14.7072L14.7072 13.293L17.7072 16.293L16.2929 17.7072Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React466.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React466.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 4.23607L6 7.23607V9.05573C6 13.4372 8.29592 17.4699 12 19.7173C15.7041 17.4699 18 13.4372 18 9.05573V7.23607L12 4.23607ZM20 6L12 2L4 6V9.05573C4 14.5374 7.09707 19.5485 12 22C16.9029 19.5485 20 14.5374 20 9.05573V6Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSecurityReview48.tsx
import * as React467 from "react";
var componentNameString461 = "FeatureSecurityReview48";
function FeatureSecurityReview48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString461,
    ...props
  });
  return /* @__PURE__ */ React467.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React467.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React467.createElement("path", { fillRule: "evenodd", d: "M32.8 35.2l-6-6 2.4-2.4 6 6-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React467.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React467.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 8l-12.5 6.2v4c0 9 4.8 17.3 12.5 21.8a25.4 25.4 0 0012.5-21.9v-4L24 8zm16 4L24 4 8 12v6.1c0 11 6.2 21 16 25.9a29 29 0 0016-25.9V12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSecurityReview72.tsx
import * as React468 from "react";
var componentNameString462 = "FeatureSecurityReview72";
function FeatureSecurityReview72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString462,
    ...props
  });
  return /* @__PURE__ */ React468.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React468.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React468.createElement("path", { fillRule: "evenodd", d: "M49.2 52.8l-9-9 3.6-3.6 9 9-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React468.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 43a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React468.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.6L17 21v8.2a35 35 0 0019 31.1 35 35 0 0019-31.1V21l-19-9.5zM60 18L36 6 12 18v11.3A40 40 0 0034.1 65l1.9.9 1.9-1A40 40 0 0060 29.4V18z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSecurityX24.tsx
import * as React469 from "react";
var componentNameString463 = "FeatureSecurityX24";
function FeatureSecurityX24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString463,
    ...props
  });
  return /* @__PURE__ */ React469.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React469.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React469.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 4.23607L6 7.23607V9.05573C6 13.4372 8.29592 17.4699 12 19.7173C15.7041 17.4699 18 13.4372 18 9.05573V7.23607L12 4.23607ZM20 6L12 2L4 6V9.05573C4 14.5374 7.09707 19.5485 12 22C16.9029 19.5485 20 14.5374 20 9.05573V6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React469.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.7072 9.70718L9.70718 15.7072L8.29297 14.293L14.293 8.29297L15.7072 9.70718Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React469.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.2928 15.7072L8.29282 9.70718L9.70703 8.29297L15.707 14.293L14.2928 15.7072Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSecurityX48.tsx
import * as React470 from "react";
var componentNameString464 = "FeatureSecurityX48";
function FeatureSecurityX48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString464,
    ...props
  });
  return /* @__PURE__ */ React470.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React470.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React470.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 8l-12.5 6.2v4c0 9 4.8 17.3 12.5 21.8a25.4 25.4 0 0012.5-21.9v-4L24 8zm16 4L24 4 8 12v6.1c0 11 6.2 21 16 25.9a29 29 0 0016-25.9V12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React470.createElement("path", { fillRule: "evenodd", d: "M31.2 19.2l-12 12-2.4-2.4 12-12 2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React470.createElement("path", { fillRule: "evenodd", d: "M28.8 31.2l-12-12 2.4-2.4 12 12-2.4 2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSecurityX72.tsx
import * as React471 from "react";
var componentNameString465 = "FeatureSecurityX72";
function FeatureSecurityX72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString465,
    ...props
  });
  return /* @__PURE__ */ React471.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React471.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React471.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.6L17 21v8.2a35 35 0 0019 31.1 35 35 0 0019-31.1V21l-19-9.5zM60 18L36 6 12 18v11.3A40 40 0 0034.1 65l1.9.9 1.9-1A40 40 0 0060 29.4V18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React471.createElement("path", { fillRule: "evenodd", d: "M46.8 28.8l-18 18-3.6-3.6 18-18 3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React471.createElement("path", { fillRule: "evenodd", d: "M43.2 46.8l-18-18 3.6-3.6 18 18-3.6 3.6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSetting24.tsx
import * as React472 from "react";
var componentNameString466 = "FeatureSetting24";
function FeatureSetting24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString466,
    ...props
  });
  return /* @__PURE__ */ React472.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React472.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React472.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15 4.58152V2H8.99998V4.58152C8.30514 4.86278 7.65881 5.23883 7.07703 5.69363L4.83972 4.40192L1.83972 9.59808L4.07644 10.8894C4.02603 11.2524 3.99998 11.6232 3.99998 12C3.99998 12.3768 4.02603 12.7476 4.07643 13.1105L1.83972 14.4019L4.83972 19.598L7.07699 18.3063C7.65878 18.7612 8.30512 19.1372 8.99997 19.4185V22H15V19.4185C15.6948 19.1372 16.3411 18.7612 16.9229 18.3064L19.1602 19.5981L22.1602 14.4019L19.9235 13.1106C19.9739 12.7476 20 12.3768 20 12C20 11.6231 19.9739 11.2524 19.9235 10.8894L22.1602 9.59803L19.1602 4.40187L16.9229 5.6936C16.3411 5.23881 15.6948 4.86277 15 4.58152ZM18.4282 7.13392L16.7543 8.10036L15.6911 7.26929C15.2541 6.92764 14.7694 6.64584 14.2495 6.43539L13 5.92958V4H11V5.92958L9.75041 6.43539C9.23049 6.64585 8.74584 6.92765 8.30879 7.26931L7.24566 8.1004L5.57177 7.13398L4.57177 8.86603L6.24267 9.83072L6.05743 11.1646C6.01964 11.4366 5.99998 11.7155 5.99998 12C5.99998 12.2845 6.01964 12.5633 6.05742 12.8354L6.24265 14.1692L4.57177 15.1339L5.57177 16.866L7.24563 15.8996L8.30876 16.7307C8.74582 17.0723 9.23048 17.3541 9.7504 17.5646L11 18.0704V20H13V18.0704L14.2495 17.5646C14.7695 17.3542 15.2541 17.0724 15.6912 16.7307L16.7543 15.8996L18.4282 16.866L19.4282 15.134L17.7573 14.1693L17.9425 12.8354C17.9803 12.5634 18 12.2845 18 12C18 11.7155 17.9803 11.4366 17.9425 11.1645L17.7573 9.83067L19.4282 8.86597L18.4282 7.13392ZM16 12C16 14.2091 14.2091 16 12 16C9.79084 16 7.99998 14.2091 7.99998 12C7.99998 9.79086 9.79084 8 12 8C14.2091 8 16 9.79086 16 12ZM12 14C13.1045 14 14 13.1046 14 12C14 10.8954 13.1045 10 12 10C10.8954 10 9.99998 10.8954 9.99998 12C9.99998 13.1046 10.8954 14 12 14Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSetting48.tsx
import * as React473 from "react";
var componentNameString467 = "FeatureSetting48";
function FeatureSetting48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString467,
    ...props
  });
  return /* @__PURE__ */ React473.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React473.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React473.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.4 26.6a5.3 5.3 0 109.1-5.3 5.3 5.3 0 00-9 5.3zm-3 1.7a8.8 8.8 0 1015.1-8.7 8.8 8.8 0 00-15.1 8.7z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React473.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.5 5.5h7v2.9c1.2.3 2.4.7 3.5 1.2V2H17v7.6c1.1-.5 2.3-1 3.5-1.2V5.5zm-5.4 5.2l-3.6-2-3-1.8-1.7 3L3.3 16l-1.8 3 3 1.8 3.5 2c.1-1.2.4-2.4.7-3.6l-2.4-1.4 3.5-6 2.4 1.3a16 16 0 012.9-2.4zM8 25.2l-3.6 2-3 1.7 1.8 3L6.8 38l1.7 3 3-1.7 3.6-2c-1-.7-2-1.5-2.9-2.4l-2.4 1.4-3.5-6 2.4-1.5a16 16 0 01-.7-3.6zm9 13.2V46h14v-7.6c-1.1.5-2.3 1-3.5 1.2v2.9h-7v-2.9c-1.2-.3-2.4-.7-3.5-1.2zm16-1.2l3.6 2.1 3 1.8 1.8-3 3.5-6.1 1.7-3-3-1.8L40 25a16 16 0 01-.7 3.7l2.5 1.4-3.5 6-2.5-1.4a16 16 0 01-2.8 2.4zM40 23l3.6-2 3-1.8-1.7-3-3.5-6.1-1.8-3-3 1.7-3.6 2c1 .8 2 1.6 2.8 2.5l2.5-1.5 3.5 6-2.5 1.5c.3 1.2.6 2.4.7 3.7z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React473.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20.5 8.4a16 16 0 00-8.3 4.7l3.2 1.9c1.4-1.4 3.2-2.4 5.1-3V8.4zM32.7 15a12.5 12.5 0 00-5.2-3V8.4a16 16 0 018.3 4.8L32.7 15zm3.5 12a12.5 12.5 0 000-6l3-1.8a16 16 0 010 9.6l-3-1.9zm-8.7 9a13 13 0 005.2-3l3 1.8a16 16 0 01-8.2 4.8V36zm-12.1-3c1.4 1.4 3.2 2.4 5.1 3v3.6a16 16 0 01-8.3-4.7l3.2-1.8zm-3.5-12a12.5 12.5 0 000 6l-3.2 1.8a16 16 0 010-9.6L12 21z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSetting72.tsx
import * as React474 from "react";
var componentNameString468 = "FeatureSetting72";
function FeatureSetting72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString468,
    ...props
  });
  return /* @__PURE__ */ React474.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React474.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React474.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 44a8 8 0 100-16 8 8 0 000 16zm0 5a13 13 0 100-26 13 13 0 000 26z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React474.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M42 7H30v6.8c-1.8.5-3.4 1.1-5 2V2h22v13.8c-1.6-.9-3.2-1.5-5-2V7zm6 9.4c1.5.9 3 2 4.2 3.3l5.9-3.4 6 10.4-5.9 3.4c.5 1.7.7 3.5.8 5.3l7.6-4.4 4.3-2.5-2.5-4.3-6-10.4-2.5-4.3-4.3 2.5-7.6 4.4zm11 20.2a23 23 0 01-.8 5.3l5.9 3.4-6 10.4-5.9-3.4a23.1 23.1 0 01-4.2 3.3l7.6 4.4 4.3 2.5 2.5-4.3 6-10.4 2.5-4.3-4.3-2.5-7.6-4.4zM47 56.2c-1.6.9-3.2 1.5-5 2V65H30v-6.8c-1.8-.5-3.4-1.1-5-2V70h22V56.2zm-23-.6c-1.6-1-3-2-4.2-3.3l-6 3.4-6-10.4 6-3.4a23 23 0 01-.8-5.4L5.3 41 1 43.5l2.5 4.3 6 10.4 2.5 4.3 4.3-2.5 7.7-4.4zM13 35.5c0-1.9.3-3.7.8-5.4l-6-3.4 6-10.4 6 3.4c1.2-1.2 2.6-2.4 4.2-3.3L16.3 12 12 9.5l-2.5 4.3-6 10.4L1 28.5 5.3 31l7.7 4.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React474.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M30 12.8a24 24 0 00-11.1 6.4l4.5 2.6c1.9-1.7 4.1-3 6.6-3.8v-5.2zM42 18v-5.2a24 24 0 0111.1 6.4l-4.5 2.6A19 19 0 0042 18zm12.6 21.9a19 19 0 000-7.7l4.5-2.7a24 24 0 010 13l-4.5-2.6zm-37.2-7.7a19 19 0 000 7.6l-4.5 2.6a24 24 0 010-12.8l4.5 2.6zm1.5 20.6l4.5-2.6c1.9 1.7 4.1 3 6.6 3.8v5.2a24 24 0 01-11.1-6.4zM42 59.2a24 24 0 0011.1-6.4l-4.5-2.6A19 19 0 0142 54v5.2z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureShapes24.tsx
import * as React475 from "react";
var componentNameString469 = "FeatureShapes24";
function FeatureShapes24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString469,
    ...props
  });
  return /* @__PURE__ */ React475.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React475.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React475.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 7L7 2L2 7L7 12L12 7ZM7 4.82843L4.82843 7L7 9.17157L9.17157 7L7 4.82843Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React475.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.8284 7C12.8284 9.20914 14.6192 11 16.8284 11C19.0375 11 20.8284 9.20914 20.8284 7C20.8284 4.79086 19.0375 3 16.8284 3C14.6192 3 12.8284 4.79086 12.8284 7ZM14.8284 7C14.8284 8.10457 15.7238 9 16.8284 9C17.9329 9 18.8284 8.10457 18.8284 7C18.8284 5.89543 17.9329 5 16.8284 5C15.7238 5 14.8284 5.89543 14.8284 7Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React475.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.0247 21L16.8285 12L11.6324 21H22.0247ZM18.5606 19L16.8285 16L15.0965 19H18.5606Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React475.createElement("path", { fillRule: "evenodd", d: "M11 13V21H3V13H11ZM5 15H9V19H5V15Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureShapes48.tsx
import * as React476 from "react";
var componentNameString470 = "FeatureShapes48";
function FeatureShapes48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString470,
    ...props
  });
  return /* @__PURE__ */ React476.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React476.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React476.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24.0413 14.0413L14.0413 4.04126L4.04126 14.0413L14.0413 24.0413L24.0413 14.0413ZM14.0413 8.99101L8.99101 14.0413L14.0413 19.0915L19.0915 14.0413L14.0413 8.99101Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React476.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M26 14C26 18.4183 29.5817 22 34 22C38.4183 22 42 18.4183 42 14C42 9.58172 38.4183 6 34 6C29.5817 6 26 9.58172 26 14ZM29.5 14C29.5 16.4853 31.5147 18.5 34 18.5C36.4853 18.5 38.5 16.4853 38.5 14C38.5 11.5147 36.4853 9.5 34 9.5C31.5147 9.5 29.5 11.5147 29.5 14Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React476.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M44.3923 42L34 24L23.6077 42H44.3923ZM38.3302 38.5L34 31L29.6699 38.5H38.3302Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React476.createElement("path", { fillRule: "evenodd", d: "M22 26V42H6V26H22ZM9.5 29.5H18.5V38.5H9.5V29.5Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureShapes72.tsx
import * as React477 from "react";
var componentNameString471 = "FeatureShapes72";
function FeatureShapes72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString471,
    ...props
  });
  return /* @__PURE__ */ React477.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React477.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React477.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36.3064 21.1532L21.1532 6L6 21.1532L21.1532 36.3064L36.3064 21.1532ZM21.1532 13.0711L13.0711 21.1532L21.1532 29.2354L29.2354 21.1532L21.1532 13.0711Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React477.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38.9999 21C38.9999 27.6274 44.3725 33 50.9999 33C57.6273 33 62.9999 27.6274 62.9999 21C62.9999 14.3726 57.6273 9 50.9999 9C44.3725 9 38.9999 14.3726 38.9999 21ZM43.9999 21C43.9999 24.866 47.1339 28 50.9999 28C54.8659 28 57.9999 24.866 57.9999 21C57.9999 17.134 54.8659 14 50.9999 14C47.1339 14 43.9999 17.134 43.9999 21Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React477.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M67.5214 64L51.4999 37L35.4784 64H67.5214ZM58.7404 59L51.4999 46.798L44.2594 59H58.7404Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React477.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32.9999 39V63H8.9999V39H32.9999ZM13.9999 44H27.9999V58H13.9999V44Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureShare24.tsx
import * as React478 from "react";
var componentNameString472 = "FeatureShare24";
function FeatureShare24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString472,
    ...props
  });
  return /* @__PURE__ */ React478.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React478.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React478.createElement("path", { d: "M12.0001 1.58582L16.7072 6.29292L15.293 7.70714L13 5.41417V15H11V5.41432L8.70718 7.70714L7.29297 6.29292L12.0001 1.58582Z" }), /* @__PURE__ */ React478.createElement("path", { d: "M7 8H5C3.89543 8 3 8.89543 3 10V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V10C21 8.89543 20.1046 8 19 8H17V10H19V20H5L5 10H7V8Z" }));
}

// src/components/icons/FeatureShare48.tsx
import * as React479 from "react";
var componentNameString473 = "FeatureShare48";
function FeatureShare48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString473,
    ...props
  });
  return /* @__PURE__ */ React479.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React479.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React479.createElement("path", { d: "M23.9999 3.52515L33.2373 12.7626L30.7625 15.2375L25.75 10.225V30H22.25V10.2248L17.2373 15.2375L14.7625 12.7626L23.9999 3.52515Z" }), /* @__PURE__ */ React479.createElement("path", { d: "M14 15.5H8C6.89543 15.5 6 16.3954 6 17.5V41.5C6 42.6046 6.89543 43.5 8 43.5H40C41.1046 43.5 42 42.6046 42 41.5V17.5C42 16.3954 41.1046 15.5 40 15.5H34V19H38.5V40H9.5V19H14V15.5Z" }));
}

// src/components/icons/FeatureShare72.tsx
import * as React480 from "react";
var componentNameString474 = "FeatureShare72";
function FeatureShare72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString474,
    ...props
  });
  return /* @__PURE__ */ React480.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React480.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React480.createElement("path", { d: "M36.0002 5.46436L49.768 19.2321L46.2324 22.7677L38.5 15.0352V45H33.5V15.0356L25.768 22.7677L22.2324 19.2321L36.0002 5.46436Z" }), /* @__PURE__ */ React480.createElement("path", { d: "M21 24H15C11.6863 24 9 26.6863 9 30V60C9 63.3137 11.6863 66 15 66H57C60.3137 66 63 63.3137 63 60V30C63 26.6863 60.3137 24 57 24H51V29H57C57.5523 29 58 29.4477 58 30V60C58 60.5523 57.5523 61 57 61H15C14.4477 61 14 60.5523 14 60V30C14 29.4477 14.4477 29 15 29H21V24Z" }));
}

// src/components/icons/FeatureShield24.tsx
import * as React481 from "react";
var componentNameString475 = "FeatureShield24";
function FeatureShield24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString475,
    ...props
  });
  return /* @__PURE__ */ React481.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React481.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React481.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20 6L12 2L4 6V9.05573C4 14.5374 7.09707 19.5485 12 22C16.9029 19.5485 20 14.5374 20 9.05573V6ZM6 7.23607L11 4.73607V11H6.15214C6.05171 10.363 6 9.71329 6 9.05573V7.23607ZM6.63975 13C7.43927 15.3974 8.9552 17.5127 11 19.0423V13H6.63975ZM13 13V19.0423C15.0448 17.5127 16.5607 15.3974 17.3602 13H13ZM17.8479 11C17.9483 10.363 18 9.71329 18 9.05573V7.23607L13 4.73607V11H17.8479Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureShield48.tsx
import * as React482 from "react";
var componentNameString476 = "FeatureShield48";
function FeatureShield48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString476,
    ...props
  });
  return /* @__PURE__ */ React482.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React482.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React482.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 8l-12.5 6.2v4c0 9 4.8 17.3 12.5 21.8a25.4 25.4 0 0012.5-21.9v-4L24 8zm16 4L24 4 8 12v6.1c0 11 6.2 21 16 25.9a29 29 0 0016-25.9V12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React482.createElement("path", { fillRule: "evenodd", d: "M22.3 41V7h3.4v34h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React482.createElement("path", { fillRule: "evenodd", d: "M10 22.3h28v3.4H10v-3.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureShield72.tsx
import * as React483 from "react";
var componentNameString477 = "FeatureShield72";
function FeatureShield72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString477,
    ...props
  });
  return /* @__PURE__ */ React483.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React483.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React483.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.6L17 21v8.2a35 35 0 0019 31.1 35 35 0 0019-31.1V21l-19-9.5zM60 18L36 6 12 18v11.3A40 40 0 0034.1 65l1.9.9 1.9-1A40 40 0 0060 29.4V18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React483.createElement("path", { fillRule: "evenodd", d: "M33.5 61.5v-51h5v51h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React483.createElement("path", { fillRule: "evenodd", d: "M15 33.5h42v5H15v-5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureShield.tsx
import * as React484 from "react";
var componentNameString478 = "FeatureShield";
function FeatureShield({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString478,
    ...props
  });
  return /* @__PURE__ */ React484.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React484.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React484.createElement("path", { d: "M23.3 34.9V19.4l12.3-4.7v-8L17.8 0 0 6.8V29c0 3.6 2.2 6.9 5.7 10.2 3.3 3 7.8 5.8 12.1 8.7 3.2-2.1 6.4-4.2 9.2-6.3-2.3-2.2-3.7-4.4-3.7-6.8" }), /* @__PURE__ */ React484.createElement("path", { d: "M35.6 14.7V29c0 3.6-2.1 6.9-5.7 10.2a45 45 0 01-3 2.4c.2 0 .2.1.3.2 2.3 2.1 5.4 4 8.4 6.1 3-2 6.1-4 8.4-6 2.5-2.3 4-4.6 4-7.1V19.4l-12.4-4.7z" }));
}

// src/components/icons/FeatureShopping24.tsx
import * as React485 from "react";
var componentNameString479 = "FeatureShopping24";
function FeatureShopping24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString479,
    ...props
  });
  return /* @__PURE__ */ React485.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React485.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React485.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6H18C19.1046 6 20 6.89543 20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V8C4 6.89543 4.89543 6 6 6L8 6ZM10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6L10 6ZM8 8V10H10V8H14V10H16V8H18V20H6V8H8Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureShopping48.tsx
import * as React486 from "react";
var componentNameString480 = "FeatureShopping48";
function FeatureShopping48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString480,
    ...props
  });
  return /* @__PURE__ */ React486.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React486.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React486.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.25 12V11C16.25 6.71979 19.7198 3.25 24 3.25C28.2802 3.25 31.75 6.71979 31.75 11V12H38C39.1046 12 40 12.8954 40 14V42C40 43.1046 39.1046 44 38 44H10C8.89543 44 8 43.1046 8 42V14C8 12.8954 8.89543 12 10 12H16.25ZM19.75 11C19.75 8.65279 21.6528 6.75 24 6.75C26.3472 6.75 28.25 8.65279 28.25 11V12H19.75V11ZM16.25 15.5V19H19.75V15.5H28.25V19H31.75V15.5H36.5V40.5H11.5V15.5H16.25Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureShopping72.tsx
import * as React487 from "react";
var componentNameString481 = "FeatureShopping72";
function FeatureShopping72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString481,
    ...props
  });
  return /* @__PURE__ */ React487.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React487.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React487.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24.5 18V17C24.5 10.6487 29.6487 5.5 36 5.5C42.3513 5.5 47.5 10.6487 47.5 17V18H54C57.3137 18 60 20.6863 60 24V60C60 63.3137 57.3137 66 54 66H18C14.6863 66 12 63.3137 12 60V24C12 20.6863 14.6863 18 18 18H24.5ZM29.5 17C29.5 13.4101 32.4101 10.5 36 10.5C39.5899 10.5 42.5 13.4101 42.5 17V18H29.5V17ZM24.5 23V29H29.5V23H42.5V29H47.5V23H54C54.5523 23 55 23.4477 55 24V60C55 60.5523 54.5523 61 54 61H18C17.4477 61 17 60.5523 17 60V24C17 23.4477 17.4477 23 18 23H24.5Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSignpost24.tsx
import * as React488 from "react";
var componentNameString482 = "FeatureSignpost24";
function FeatureSignpost24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString482,
    ...props
  });
  return /* @__PURE__ */ React488.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React488.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React488.createElement("rect", { width: 2, height: 8, x: 11, y: 14 }), /* @__PURE__ */ React488.createElement("path", { d: "M19 3H5.41421L4.41421 4L5.41421 5H19V3Z" }), /* @__PURE__ */ React488.createElement("path", { d: "M5 9H18.5858L19.5858 10L18.5858 11H5V9Z" }));
}

// src/components/icons/FeatureSignpost48.tsx
import * as React489 from "react";
var componentNameString483 = "FeatureSignpost48";
function FeatureSignpost48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString483,
    ...props
  });
  return /* @__PURE__ */ React489.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React489.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React489.createElement("path", { d: "M22 28h4v16h-4V28z" }), /* @__PURE__ */ React489.createElement("path", { d: "M40 4H10L6 8l4 4h30V4z" }), /* @__PURE__ */ React489.createElement("path", { fillRule: "evenodd", d: "M11.4 7.5h25.1v1h-25l-.6-.5.5-.5zM10 4h30v8H10L6 8l4-4z", clipRule: "evenodd" }), /* @__PURE__ */ React489.createElement("path", { d: "M8 16h30l4 4-4 4H8v-8z" }), /* @__PURE__ */ React489.createElement("path", { fillRule: "evenodd", d: "M36.6 19.5H11.5v1h25l.6-.5-.5-.5zM38 16H8v8h30l4-4-4-4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSignpost72.tsx
import * as React490 from "react";
var componentNameString484 = "FeatureSignpost72";
function FeatureSignpost72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString484,
    ...props
  });
  return /* @__PURE__ */ React490.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React490.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React490.createElement("path", { d: "M33 42h6v24h-6V42z" }), /* @__PURE__ */ React490.createElement("path", { d: "M60 6H15l-6 6 6 6h45V6z" }), /* @__PURE__ */ React490.createElement("path", { fillRule: "evenodd", d: "M17 11h38v2H17l-1-1 1-1zm-2-5h45v12H15l-6-6 6-6z", clipRule: "evenodd" }), /* @__PURE__ */ React490.createElement("path", { d: "M12 24h45l6 6-6 6H12V24z" }), /* @__PURE__ */ React490.createElement("path", { fillRule: "evenodd", d: "M55 29H17v2h38l1-1-1-1zm2-5H12v12h45l6-6-6-6z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureSignpost.tsx
import * as React491 from "react";
var componentNameString485 = "FeatureSignpost";
function FeatureSignpost({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString485,
    ...props
  });
  return /* @__PURE__ */ React491.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React491.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React491.createElement("path", { d: "M8 0h32v8H8L4 4l4-4zm11 48V24h8v24h-8z" }), /* @__PURE__ */ React491.createElement("polygon", { points: "8 12 8 20 40 20 44 16 40 12", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureSound24.tsx
import * as React492 from "react";
var componentNameString486 = "FeatureSound24";
function FeatureSound24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString486,
    ...props
  });
  return /* @__PURE__ */ React492.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React492.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React492.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5 10H4L4 14H5V10ZM4 8C2.89543 8 2 8.89543 2 10V14C2 15.1046 2.89543 16 4 16H7V8H4Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React492.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7 9.59297V14.407L13 17.647V6.35297L7 9.59297ZM5 8.4V15.6L15 21V3L5 8.4Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React492.createElement("mask", { id: "a", width: 5, height: 16, x: 17, y: 4, maskUnits: "userSpaceOnUse" }, /* @__PURE__ */ React492.createElement("path", { d: "M17 4H22V20H17V4Z" })), /* @__PURE__ */ React492.createElement("g", { mask: "url(#a)" }, /* @__PURE__ */ React492.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.1112 17.7777C17.3021 17.7777 19.8889 15.1909 19.8889 11.9999C19.8889 8.80897 17.3021 6.22217 14.1112 6.22217C10.9202 6.22217 8.33337 8.80897 8.33337 11.9999C8.33337 15.1909 10.9202 17.7777 14.1112 17.7777ZM14.1112 19.7777C18.4067 19.7777 21.8889 16.2955 21.8889 11.9999C21.8889 7.7044 18.4067 4.22217 14.1112 4.22217C9.8156 4.22217 6.33337 7.7044 6.33337 11.9999C6.33337 16.2955 9.8156 19.7777 14.1112 19.7777Z",
      clipRule: "evenodd"
    }
  )), /* @__PURE__ */ React492.createElement("mask", { id: "b", width: 2, height: 10, x: 17, y: 7, maskUnits: "userSpaceOnUse" }, /* @__PURE__ */ React492.createElement("path", { d: "M17 7H19V17H17V7Z" })), /* @__PURE__ */ React492.createElement("g", { mask: "url(#b)" }, /* @__PURE__ */ React492.createElement("path", { d: "M19 12C19 14.2091 17.2091 16 15 16C12.7909 16 11 14.2091 11 12C11 9.79086 12.7909 8 15 8C17.2091 8 19 9.79086 19 12Z" })));
}

// src/components/icons/FeatureSpending24.tsx
import * as React493 from "react";
var componentNameString487 = "FeatureSpending24";
function FeatureSpending24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString487,
    ...props
  });
  return /* @__PURE__ */ React493.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React493.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React493.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 5H5L5 19H19V15H20V9H19V5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React493.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20 9H16C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15H20V9ZM16 7C13.2386 7 11 9.23858 11 12C11 14.7614 13.2386 17 16 17H20C21.1046 17 22 16.1046 22 15V9C22 7.89543 21.1046 7 20 7H16Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React493.createElement("circle", { cx: 16, cy: 12, r: 1 }));
}

// src/components/icons/FeatureSpending48.tsx
import * as React494 from "react";
var componentNameString488 = "FeatureSpending48";
function FeatureSpending48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString488,
    ...props
  });
  return /* @__PURE__ */ React494.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React494.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React494.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M40.5 17.5H28a2.5 2.5 0 00-2.5 2.5v8c0 1.4 1.1 2.5 2.5 2.5h12.5v-13zM28 14a6 6 0 00-6 6v8a6 6 0 006 6h14a2 2 0 002-2V16a2 2 0 00-2-2H28z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React494.createElement("path", { d: "M34 24a2 2 0 11-4 0 2 2 0 014 0z" }), /* @__PURE__ */ React494.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.5 38.5v-29h29V14H42V8a2 2 0 00-2-2H8a2 2 0 00-2 2v32c0 1.1.9 2 2 2h32a2 2 0 002-2v-6h-3.5v4.5h-29z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureSpending72.tsx
import * as React495 from "react";
var componentNameString489 = "FeatureSpending72";
function FeatureSpending72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString489,
    ...props
  });
  return /* @__PURE__ */ React495.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React495.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React495.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M61 26H39a1 1 0 00-1 1v18c0 .6.4 1 1 1h22V26zm-22-5a6 6 0 00-6 6v18a6 6 0 006 6h25a2 2 0 002-2V23a2 2 0 00-2-2H39z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React495.createElement("path", { d: "M51 36a3 3 0 11-6 0 3 3 0 016 0z" }), /* @__PURE__ */ React495.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14 58V14h44v9h5V11a2 2 0 00-2-2H11a2 2 0 00-2 2v50c0 1.1.9 2 2 2h50a2 2 0 002-2V49h-5v9H14z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureStack.tsx
import * as React496 from "react";
var componentNameString490 = "FeatureStack";
function FeatureStack({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString490,
    ...props
  });
  return /* @__PURE__ */ React496.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React496.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React496.createElement("polygon", { points: "6 9 42 9 42 0 6 0", className: "sc-Icon--primary-color" }), /* @__PURE__ */ React496.createElement("path", { d: "M6 22v-9h36v9H6zm0 13v-9h36v9H6zm0 13v-9h36v9H6z" }));
}

// src/components/icons/FeatureStacks24.tsx
import * as React497 from "react";
var componentNameString491 = "FeatureStacks24";
function FeatureStacks24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString491,
    ...props
  });
  return /* @__PURE__ */ React497.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React497.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M11 21H3V19H11V21Z", clipRule: "evenodd" }), /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M11 17H3V15H11V17Z", clipRule: "evenodd" }), /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M11 13H3V11H11V13Z", clipRule: "evenodd" }), /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M11 9H3V7H11V9Z", clipRule: "evenodd" }), /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M11 5H3V3H11V5Z", clipRule: "evenodd" }), /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M21 21H13V19H21V21Z", clipRule: "evenodd" }), /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M21 17H13V15H21V17Z", clipRule: "evenodd" }), /* @__PURE__ */ React497.createElement("path", { fillRule: "evenodd", d: "M21 13H13V11H21V13Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureStacks48.tsx
import * as React498 from "react";
var componentNameString492 = "FeatureStacks48";
function FeatureStacks48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString492,
    ...props
  });
  return /* @__PURE__ */ React498.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React498.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M22 42.5H6v-5h16v5z", clipRule: "evenodd" }), /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M22 34.5H6v-5h16v5z", clipRule: "evenodd" }), /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M22 26.5H6v-5h16v5z", clipRule: "evenodd" }), /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M22 18.5H6v-5h16v5z", clipRule: "evenodd" }), /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M22 10.5H6v-5h16v5z", clipRule: "evenodd" }), /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M42 42.5H26v-5h16v5z", clipRule: "evenodd" }), /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M42 34.5H26v-5h16v5z", clipRule: "evenodd" }), /* @__PURE__ */ React498.createElement("path", { fillRule: "evenodd", d: "M42 26.5H26v-5h16v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureStacks72.tsx
import * as React499 from "react";
var componentNameString493 = "FeatureStacks72";
function FeatureStacks72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString493,
    ...props
  });
  return /* @__PURE__ */ React499.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React499.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M33 62.5H9v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M33 50.5H9v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M33 38.5H9v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M33 26.5H9v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M33 14.5H9v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M63 62.5H39v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M63 50.5H39v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React499.createElement("path", { fillRule: "evenodd", d: "M63 38.5H39v-5h24v5z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureStroller24.tsx
import * as React500 from "react";
var componentNameString494 = "FeatureStroller24";
function FeatureStroller24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString494,
    ...props
  });
  return /* @__PURE__ */ React500.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React500.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React500.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 12H5C5 12.695 5.10128 13.3663 5.28988 14C6.15043 16.8915 8.82898 19 12 19C15.171 19 17.8496 16.8915 18.7101 14C18.8987 13.3663 19 12.695 19 12ZM16.584 14H7.41604C8.1876 15.7659 9.94968 17 12 17C14.0503 17 15.8124 15.7659 16.584 14Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React500.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.7101 8C18.8987 8.63371 19 9.30503 19 10L12 10L12 3C12.695 3 13.3663 3.10128 14 3.28988C16.2578 3.96183 18.0382 5.74222 18.7101 8ZM14 5.41604L14 8L16.584 8C16.08 6.84656 15.1534 5.92 14 5.41604Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React500.createElement("path", { d: "M20 20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20C16 18.8954 16.8954 18 18 18C19.1046 18 20 18.8954 20 20Z" }), /* @__PURE__ */ React500.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 22C19.1046 22 20 21.1046 20 20C20 18.8954 19.1046 18 18 18C16.8954 18 16 18.8954 16 20C16 21.1046 16.8954 22 18 22Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React500.createElement("path", { d: "M8 20C8 21.1046 7.10457 22 6 22C4.89543 22 4 21.1046 4 20C4 18.8954 4.89543 18 6 18C7.10457 18 8 18.8954 8 20Z" }), /* @__PURE__ */ React500.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6 22C7.10457 22 8 21.1046 8 20C8 18.8954 7.10457 18 6 18C4.89543 18 4 18.8954 4 20C4 21.1046 4.89543 22 6 22Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React500.createElement("path", { fillRule: "evenodd", d: "M5 10H3V8H7V12H5V10Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureStroller48.tsx
import * as React501 from "react";
var componentNameString495 = "FeatureStroller48";
function FeatureStroller48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString495,
    ...props
  });
  return /* @__PURE__ */ React501.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React501.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React501.createElement("path", { fillRule: "evenodd", d: "M38 24H10a14 14 0 1028 0zm-4.1 3.5H14.1a10.5 10.5 0 0019.8 0z", clipRule: "evenodd" }), /* @__PURE__ */ React501.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M37.6 16.5c.2 1.1.4 2.3.4 3.5H24V6a14 14 0 0113.6 10.5zm-10.1-6.4v6.4h6.4c-1-3-3.4-5.3-6.4-6.4z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React501.createElement("path", { d: "M40 40a4 4 0 11-8 0 4 4 0 018 0z" }), /* @__PURE__ */ React501.createElement("path", { fillRule: "evenodd", d: "M36 42a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8z", clipRule: "evenodd" }), /* @__PURE__ */ React501.createElement("path", { d: "M16 40a4 4 0 11-8 0 4 4 0 018 0z" }), /* @__PURE__ */ React501.createElement("path", { fillRule: "evenodd", d: "M12 42a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8z", clipRule: "evenodd" }), /* @__PURE__ */ React501.createElement("path", { d: "M10 16h3.5v8H10v-8z" }), /* @__PURE__ */ React501.createElement("path", { d: "M13 16v3.5H6V16h7z" }));
}

// src/components/icons/FeatureStroller72.tsx
import * as React502 from "react";
var componentNameString496 = "FeatureStroller72";
function FeatureStroller72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString496,
    ...props
  });
  return /* @__PURE__ */ React502.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React502.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React502.createElement("path", { fillRule: "evenodd", d: "M57 36H15a21 21 0 1042 0zm-5.8 5H20.8a16 16 0 0030.4 0z", clipRule: "evenodd" }), /* @__PURE__ */ React502.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M56.4 25c.4 1.6.6 3.3.6 5H36V9a21 21 0 0120.4 16zM41 14.8V25h10.2A16 16 0 0041 14.8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React502.createElement("path", { d: "M60 60a6 6 0 11-12 0 6 6 0 0112 0z" }), /* @__PURE__ */ React502.createElement("path", { fillRule: "evenodd", d: "M54 64a4 4 0 100-8 4 4 0 000 8zm0 2a6 6 0 100-12 6 6 0 000 12z", clipRule: "evenodd" }), /* @__PURE__ */ React502.createElement("path", { d: "M24 60a6 6 0 11-12 0 6 6 0 0112 0z" }), /* @__PURE__ */ React502.createElement("path", { fillRule: "evenodd", d: "M18 64a4 4 0 100-8 4 4 0 000 8zm0 2a6 6 0 100-12 6 6 0 000 12z", clipRule: "evenodd" }), /* @__PURE__ */ React502.createElement("path", { d: "M15 29h5v7h-5v-7z" }), /* @__PURE__ */ React502.createElement("path", { d: "M20 25v5H9v-5h11z" }));
}

// src/components/icons/FeatureSun.tsx
import * as React503 from "react";
var componentNameString497 = "FeatureSun";
function FeatureSun({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString497,
    ...props
  });
  return /* @__PURE__ */ React503.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React503.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React503.createElement("path", { d: "M21 14.3V5h6v9.3a15 15 0 00-6 0zm11.2 2.1l6.5-6.4 4.2 4.3-6.4 6.4a15 15 0 00-4.3-4.3zm6.5 9.6H48v6h-9.3a15 15 0 000-6zM9.3 32H0v-6h9.3a15 15 0 000 6zm2.2-11.2L5 14.3 9.3 10l6.5 6.5a15 15 0 00-4.3 4.3zm2 11.2a11 11 0 1121 0h-21z" }), /* @__PURE__ */ React503.createElement("polygon", { points: "0 42 48 42 48 35 0 35", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureTags.tsx
import * as React504 from "react";
var componentNameString498 = "FeatureTags";
function FeatureTags({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString498,
    ...props
  });
  return /* @__PURE__ */ React504.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React504.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React504.createElement("path", { d: "M7.9 14.4a2.4 2.4 0 11-3.4-3.5 2.4 2.4 0 013.4 3.5zm5.3-7.6H.2l.1 12.8 22.2 22.2 12.8-12.9L13.2 6.8z" }), /* @__PURE__ */ React504.createElement(
    "polygon",
    {
      points: "25.655 7.095 18.37 7.095 40.214 28.944 31.015 38.146 35.001 42.13 47.841 29.286",
      className: "sc-Icon--secondary-color"
    }
  ));
}

// src/components/icons/FeatureTicket24.tsx
import * as React505 from "react";
var componentNameString499 = "FeatureTicket24";
function FeatureTicket24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString499,
    ...props
  });
  return /* @__PURE__ */ React505.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React505.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React505.createElement("path", { d: "M11 8V10H13V8H11Z" }), /* @__PURE__ */ React505.createElement("path", { d: "M11 11H13V13H11V11Z" }), /* @__PURE__ */ React505.createElement("path", { d: "M11 14V16H13V14H11Z" }), /* @__PURE__ */ React505.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 20V14C20.8954 14 20 13.1046 20 12C20 10.8954 20.8954 10 22 10V4H2V10C3.10457 10 4 10.8954 4 12C4 13.1046 3.10457 14 2 14V20H22ZM13 6H20V8.53513C18.8044 9.22675 18 10.5194 18 12C18 13.4806 18.8044 14.7733 20 15.4649V18H13V17H11V18H4V15.4649C5.1956 14.7733 6 13.4806 6 12C6 10.5194 5.1956 9.22675 4 8.53513V6H11V7H13V6Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTicket48.tsx
import * as React506 from "react";
var componentNameString500 = "FeatureTicket48";
function FeatureTicket48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString500,
    ...props
  });
  return /* @__PURE__ */ React506.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React506.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React506.createElement("path", { d: "M22.25 16V20H25.75V16H22.25Z" }), /* @__PURE__ */ React506.createElement("path", { d: "M22.25 22H25.75V26H22.25V22Z" }), /* @__PURE__ */ React506.createElement("path", { d: "M22.25 28V32H25.75V28H22.25Z" }), /* @__PURE__ */ React506.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M44 40V28C41.7909 28 40 26.2091 40 24C40 21.7909 41.7909 20 44 20V8H4V20C6.20914 20 8 21.7909 8 24C8 26.2091 6.20914 28 4 28V40H44ZM25.75 11.5H40.5V17.365C38.1211 18.6225 36.5 21.122 36.5 24C36.5 26.878 38.1211 29.3775 40.5 30.635V36.5H25.75V34H22.25V36.5H7.5V30.635C9.8789 29.3775 11.5 26.878 11.5 24C11.5 21.122 9.8789 18.6225 7.5 17.365V11.5H22.25V14H25.75V11.5Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTicket72.tsx
import * as React507 from "react";
var componentNameString501 = "FeatureTicket72";
function FeatureTicket72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString501,
    ...props
  });
  return /* @__PURE__ */ React507.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React507.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React507.createElement("path", { d: "M33.5 24V30H38.5V24H33.5Z" }), /* @__PURE__ */ React507.createElement("path", { d: "M33.5 33H38.5V39H33.5V33Z" }), /* @__PURE__ */ React507.createElement("path", { d: "M33.5 42V48H38.5V42H33.5Z" }), /* @__PURE__ */ React507.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M66 60V42C62.6863 42 60 39.3137 60 36C60 32.6863 62.6863 30 66 30V12H6V30C9.31371 30 12 32.6863 12 36C12 39.3137 9.31371 42 6 42V60H66ZM38.5 17H61V26.1994C57.4383 28.0201 55 31.7253 55 36C55 40.2747 57.4383 43.9799 61 45.8006V55H38.5V51H33.5V55H11V45.8006C14.5617 43.9799 17 40.2747 17 36C17 31.7253 14.5617 28.0201 11 26.1994V17H33.5V21H38.5V17Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTimer.tsx
import * as React508 from "react";
var componentNameString502 = "FeatureTimer";
function FeatureTimer({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString502,
    ...props
  });
  return /* @__PURE__ */ React508.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React508.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React508.createElement("polygon", { points: "5 4 18.715 24 24 16.293 29.285 24 43 4", className: "sc-Icon--primary-color" }), /* @__PURE__ */ React508.createElement("polygon", { points: "24 31.707 18.714 24 5 44 43 44 29.286 24", className: "sc-Icon--secondary-color" }));
}

// src/components/icons/FeatureToggle.tsx
import * as React509 from "react";
var componentNameString503 = "FeatureToggle";
function FeatureToggle({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString503,
    ...props
  });
  return /* @__PURE__ */ React509.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React509.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React509.createElement("path", { d: "M0 15V9h6v6H0zm42 24v-6h6v6h-6zM0 39v-6h30v6H0zm18-24V9h30v6H18z" }), /* @__PURE__ */ React509.createElement("path", { d: "M6 21V3h10v18H6zm24 24V27h10v18H30z" }));
}

// src/components/icons/FeatureTooltip24.tsx
import * as React510 from "react";
var componentNameString504 = "FeatureTooltip24";
function FeatureTooltip24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString504,
    ...props
  });
  return /* @__PURE__ */ React510.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React510.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React510.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18.4C15.5346 18.4 18.4 15.5346 18.4 12C18.4 8.46538 15.5346 5.6 12 5.6C8.46538 5.6 5.6 8.46538 5.6 12C5.6 15.5346 8.46538 18.4 12 18.4ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React510.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 8.80007C11.1164 8.80007 10.4 9.51642 10.4 10.4001H8.80005C8.80005 8.63276 10.2327 7.20007 12 7.20007C13.7674 7.20007 15.2 8.63276 15.2 10.4001C15.2 12.1674 13.7674 13.6001 12 13.6001H11.2V12.0001H12C12.8837 12.0001 13.6 11.2837 13.6 10.4001C13.6 9.51642 12.8837 8.80007 12 8.80007Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React510.createElement("path", { d: "M11.2 15.2001H12.8V16.8001H11.2V15.2001Z" }));
}

// src/components/icons/FeatureTooltipInfo24.tsx
import * as React511 from "react";
var componentNameString505 = "FeatureTooltipInfo24";
function FeatureTooltipInfo24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString505,
    ...props
  });
  return /* @__PURE__ */ React511.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React511.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React511.createElement("path", { d: "M12.8 9.6H11.2V8H12.8V9.6Z" }), /* @__PURE__ */ React511.createElement("path", { fillRule: "evenodd", d: "M11.2 16V11.2H12.8V16H11.2Z", clipRule: "evenodd" }), /* @__PURE__ */ React511.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18.4C15.5346 18.4 18.4 15.5346 18.4 12C18.4 8.46538 15.5346 5.6 12 5.6C8.46538 5.6 5.6 8.46538 5.6 12C5.6 15.5346 8.46538 18.4 12 18.4ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTransfer24.tsx
import * as React512 from "react";
var componentNameString506 = "FeatureTransfer24";
function FeatureTransfer24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString506,
    ...props
  });
  return /* @__PURE__ */ React512.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React512.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React512.createElement("path", { d: "M2.58582 7.00007L7.29292 2.29297L8.70714 3.70718L6.41417 6.00015H21V8.00015H6.41432L8.70714 10.293L7.29292 11.7072L2.58582 7.00007Z" }), /* @__PURE__ */ React512.createElement("path", { d: "M17.5859 16.0001L15.2929 13.7072L16.7071 12.293L21.4142 17.0001L16.7071 21.7072L15.2929 20.293L17.5857 18.0001H3.00003V16.0001H17.5859Z" }));
}

// src/components/icons/FeatureTransfer48.tsx
import * as React513 from "react";
var componentNameString507 = "FeatureTransfer48";
function FeatureTransfer48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString507,
    ...props
  });
  return /* @__PURE__ */ React513.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React513.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React513.createElement("path", { fillRule: "evenodd", d: "M10 12.3h32v3.4H10v-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React513.createElement("path", { fillRule: "evenodd", d: "M40 35.8H6v-3.5h34v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React513.createElement("path", { fillRule: "evenodd", d: "M5.5 14l9.3-9.2 2.4 2.4-6.7 6.8 6.7 6.8-2.4 2.4L5.5 14z", clipRule: "evenodd" }), /* @__PURE__ */ React513.createElement("path", { fillRule: "evenodd", d: "M42.5 34l-9.3-9.2-2.4 2.4 6.7 6.8-6.7 6.8 2.4 2.4 9.3-9.2z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureTransfer72.tsx
import * as React514 from "react";
var componentNameString508 = "FeatureTransfer72";
function FeatureTransfer72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString508,
    ...props
  });
  return /* @__PURE__ */ React514.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React514.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React514.createElement("path", { fillRule: "evenodd", d: "M15 18.5h48v5H15v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React514.createElement("path", { fillRule: "evenodd", d: "M60 53.5H9v-5h51v5z", clipRule: "evenodd" }), /* @__PURE__ */ React514.createElement("path", { fillRule: "evenodd", d: "M8.5 21L22.2 7.2l3.6 3.6L15.5 21l10.3 10.2-3.6 3.6L8.5 21z", clipRule: "evenodd" }), /* @__PURE__ */ React514.createElement("path", { fillRule: "evenodd", d: "M63.5 51L49.8 37.2l-3.6 3.6L56.5 51 46.2 61.2l3.6 3.6L63.5 51z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureTransferInCircle24.tsx
import * as React515 from "react";
var componentNameString509 = "FeatureTransferInCircle24";
function FeatureTransferInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString509,
    ...props
  });
  return /* @__PURE__ */ React515.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React515.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React515.createElement("path", { d: "M10 6L7 9L10 12V10H16V8H10V6Z" }), /* @__PURE__ */ React515.createElement("path", { d: "M14 12V14L8 14L8 16L14 16V18L17 15L14 12Z" }), /* @__PURE__ */ React515.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTransferInCircle48.tsx
import * as React516 from "react";
var componentNameString510 = "FeatureTransferInCircle48";
function FeatureTransferInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString510,
    ...props
  });
  return /* @__PURE__ */ React516.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React516.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React516.createElement("path", { fillRule: "evenodd", d: "M16 16.3h16v3.4H16v-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React516.createElement("path", { fillRule: "evenodd", d: "M32 31.8H16v-3.6h16v3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React516.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React516.createElement("path", { d: "M14 18l6-6v12l-6-6z" }), /* @__PURE__ */ React516.createElement("path", { d: "M34 30l-6 6V24l6 6z" }));
}

// src/components/icons/FeatureTransferInCircle72.tsx
import * as React517 from "react";
var componentNameString511 = "FeatureTransferInCircle72";
function FeatureTransferInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString511,
    ...props
  });
  return /* @__PURE__ */ React517.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React517.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React517.createElement("path", { fillRule: "evenodd", d: "M24 24.5h24v5H24v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React517.createElement("path", { fillRule: "evenodd", d: "M48 47.5H24v-5h24v5z", clipRule: "evenodd" }), /* @__PURE__ */ React517.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React517.createElement("path", { d: "M21 27l9-9v18l-9-9z" }), /* @__PURE__ */ React517.createElement("path", { d: "M51 45l-9 9V36l9 9z" }));
}

// src/components/icons/FeatureTrend24.tsx
import * as React518 from "react";
var componentNameString512 = "FeatureTrend24";
function FeatureTrend24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString512,
    ...props
  });
  return /* @__PURE__ */ React518.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React518.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React518.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.0001 6H16.0001V8H18.5859L13.0001 13.5858L9.00008 9.5858L2.29297 16.2929L3.70718 17.7071L9.00008 12.4142L13.0001 16.4142L20.0001 9.41424V12H22.0001V6Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTrend48.tsx
import * as React519 from "react";
var componentNameString513 = "FeatureTrend48";
function FeatureTrend48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString513,
    ...props
  });
  return /* @__PURE__ */ React519.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React519.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React519.createElement("path", { fillRule: "evenodd", d: "M32 12.3h11.8V24h-3.5v-8.3H32v-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React519.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M41.6 16.9L26 32.5l-8-8L7.2 35.2l-2.4-2.4L18 19.5l8 8 13.1-13 2.5 2.4z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTrend72.tsx
import * as React520 from "react";
var componentNameString514 = "FeatureTrend72";
function FeatureTrend72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString514,
    ...props
  });
  return /* @__PURE__ */ React520.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React520.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React520.createElement("path", { fillRule: "evenodd", d: "M48 18.5h17.5V36h-5V23.5H48v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React520.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M62.3 25.3L39 48.5l-12-12-16.2 16.3-3.6-3.6L27 29.5l12 12 19.7-19.8 3.6 3.6z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTrophy24.tsx
import * as React521 from "react";
var componentNameString515 = "FeatureTrophy24";
function FeatureTrophy24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString515,
    ...props
  });
  return /* @__PURE__ */ React521.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React521.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React521.createElement("path", { fillRule: "evenodd", d: "M11 22V15H13V22H11Z", clipRule: "evenodd" }), /* @__PURE__ */ React521.createElement("path", { fillRule: "evenodd", d: "M6 20H18V22H6V20Z", clipRule: "evenodd" }), /* @__PURE__ */ React521.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 4H8V10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10V4ZM6 2V10C6 13.3137 8.68629 16 12 16C15.3137 16 18 13.3137 18 10V2H6Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React521.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 12V4H2V6C2 8.61244 3.66962 10.8349 6 11.6586C6.62556 11.8797 7.29873 12 8 12ZM6 9.46487V6H4C4 7.48056 4.8044 8.77325 6 9.46487Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React521.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 12V4H21.8118C21.9157 4 22 4.08428 22 4.18824V6C22 8.61244 20.3304 10.8349 18 11.6586C17.3744 11.8797 16.7013 12 16 12ZM18 9.46487V6H20C20 7.48056 19.1956 8.77325 18 9.46487Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTrophy48.tsx
import * as React522 from "react";
var componentNameString516 = "FeatureTrophy48";
function FeatureTrophy48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString516,
    ...props
  });
  return /* @__PURE__ */ React522.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React522.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React522.createElement("path", { fillRule: "evenodd", d: "M22.3 43.7V30h3.4v13.7h-3.4z", clipRule: "evenodd" }), /* @__PURE__ */ React522.createElement("path", { fillRule: "evenodd", d: "M12 40.3h24v3.5H12v-3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React522.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32.5 7.5h-17V20a8.5 8.5 0 0017 0V7.5zM12 4v16a12 12 0 0024 0V4H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React522.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.3 24V8H4v4.7A11.3 11.3 0 0015.3 24zm-3.5-4.3v-8.2H7.5v1.2a8 8 0 004.3 7z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React522.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32.7 24V8h11c.1 0 .3.2.3.4v4.3A11.3 11.3 0 0132.7 24zm3.5-4.3v-8.2h4.3v1.2a8 8 0 01-4.3 7z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureTrophy72.tsx
import * as React523 from "react";
var componentNameString517 = "FeatureTrophy72";
function FeatureTrophy72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString517,
    ...props
  });
  return /* @__PURE__ */ React523.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React523.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React523.createElement("path", { fillRule: "evenodd", d: "M33.5 65.5V45h5v20.5h-5z", clipRule: "evenodd" }), /* @__PURE__ */ React523.createElement("path", { fillRule: "evenodd", d: "M18 60.5h36v5H18v-5z", clipRule: "evenodd" }), /* @__PURE__ */ React523.createElement("path", { fillRule: "evenodd", d: "M49 11H23v19a13 13 0 0026 0V11zM18 6v24a18 18 0 0036 0V6H18z", clipRule: "evenodd" }), /* @__PURE__ */ React523.createElement("path", { fillRule: "evenodd", d: "M23 36V12H6v7a17 17 0 0017 17zm-5-6V17h-7v2c0 4.8 2.9 9 7 11z", clipRule: "evenodd" }), /* @__PURE__ */ React523.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M49 36V12h16.4c.3 0 .6.3.6.6V19a17 17 0 01-17 17zm5-6V17h7v2c0 4.8-2.9 9-7 11z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUmbrella24.tsx
import * as React524 from "react";
var componentNameString518 = "FeatureUmbrella24";
function FeatureUmbrella24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString518,
    ...props
  });
  return /* @__PURE__ */ React524.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React524.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React524.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 4C8.27232 4 5.14012 6.54955 4.25203 10H19.748C18.8599 6.54955 15.7277 4 12 4ZM21.8 10C20.8734 5.43552 16.8379 2 12 2C7.16208 2 3.12658 5.43552 2.20004 10C2.06886 10.6462 2 11.3151 2 12H22C22 11.3151 21.9311 10.6462 21.8 10Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React524.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11 19V14H13V19C13 20.6569 11.6569 22 10 22C8.34315 22 7 20.6569 7 19V18H9V19C9 19.5523 9.44772 20 10 20C10.5523 20 11 19.5523 11 19Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUmbrella48.tsx
import * as React525 from "react";
var componentNameString519 = "FeatureUmbrella48";
function FeatureUmbrella48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString519,
    ...props
  });
  return /* @__PURE__ */ React525.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React525.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React525.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 7.5c-8 0-14.5 5.6-16.1 13H40c-1.6-7.4-8.2-13-16.1-13zm19.7 13A20 20 0 004 24h40c0-1.2-.1-2.4-.3-3.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React525.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.3 38V28h3.4v10a5.8 5.8 0 01-11.4 0v-2h3.4v2a2.3 2.3 0 004.6 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React525.createElement("path", { fillRule: "evenodd", d: "M15 21c0-9.7 5-14.9 8-16.8l2 3c-2.3 1.3-6.6 5.5-6.6 13.8H15z", clipRule: "evenodd" }), /* @__PURE__ */ React525.createElement("path", { fillRule: "evenodd", d: "M33 21c0-9.7-5-14.9-8-16.8l-2 3c2.3 1.3 6.6 5.5 6.6 13.8H33z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureUmbrella72.tsx
import * as React526 from "react";
var componentNameString520 = "FeatureUmbrella72";
function FeatureUmbrella72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString520,
    ...props
  });
  return /* @__PURE__ */ React526.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React526.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React526.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11a25 25 0 00-24.5 20h49A25 25 0 0036 11zm29.6 20A30 30 0 006 36h60c0-1.7-.1-3.4-.4-5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React526.createElement("path", { fillRule: "evenodd", d: "M33.5 57V42h5v15a8.5 8.5 0 01-17 0v-3h5v3a3.5 3.5 0 107 0z", clipRule: "evenodd" }), /* @__PURE__ */ React526.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.5 31.5c0-14.5 7.6-22.2 12.2-25.1l2.6 4.2c-3.4 2.1-9.8 8.4-9.8 20.9h-5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React526.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M49.5 31.5c0-14.5-7.6-22.2-12.2-25.1l-2.6 4.2c3.4 2.1 9.8 8.4 9.8 20.9h5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUmbrella.tsx
import * as React527 from "react";
var componentNameString521 = "FeatureUmbrella";
function FeatureUmbrella({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString521,
    ...props
  });
  return /* @__PURE__ */ React527.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React527.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React527.createElement("path", { d: "M28 41v2a1 1 0 11-2 0V24h-4v19a5 5 0 1010 0v-2h-4z" }), /* @__PURE__ */ React527.createElement("path", { d: "M45 21a21 21 0 10-42 0h42z" }));
}

// src/components/icons/FeatureUndo24.tsx
import * as React528 from "react";
var componentNameString522 = "FeatureUndo24";
function FeatureUndo24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString522,
    ...props
  });
  return /* @__PURE__ */ React528.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React528.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React528.createElement("path", { d: "M5.00006 12C5.00006 8.13401 8.13407 5 12.0001 5C15.8661 5 19.0001 8.13401 19.0001 12C19.0001 15.866 15.8661 19 12.0001 19V21C16.9706 21 21.0001 16.9706 21.0001 12C21.0001 7.02944 16.9706 3 12.0001 3C7.0295 3 3.00006 7.02944 3.00006 12V16.5859L1.70718 15.293L0.292969 16.7072L4.00008 20.4143L7.70718 16.7072L6.29297 15.293L5.00006 16.5859V12Z" }));
}

// src/components/icons/FeatureUndo48.tsx
import * as React529 from "react";
var componentNameString523 = "FeatureUndo48";
function FeatureUndo48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString523,
    ...props
  });
  return /* @__PURE__ */ React529.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React529.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React529.createElement("path", { fillRule: "evenodd", d: "M8 40.5l7.2-7.3-2.4-2.4L8 35.5l-4.8-4.7-2.4 2.4L8 40.5z", clipRule: "evenodd" }), /* @__PURE__ */ React529.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 9.8C16.1 9.8 9.7 16 9.7 24v12H6.3V24A17.7 17.7 0 1124 41.8v-3.5a14.2 14.2 0 100-28.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUndo72.tsx
import * as React530 from "react";
var componentNameString524 = "FeatureUndo72";
function FeatureUndo72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString524,
    ...props
  });
  return /* @__PURE__ */ React530.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React530.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React530.createElement("path", { fillRule: "evenodd", d: "M12 60.5l10.8-10.7-3.6-3.6-7.2 7.3-7.2-7.3-3.6 3.6L12 60.5z", clipRule: "evenodd" }), /* @__PURE__ */ React530.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 14.5A21.5 21.5 0 0014.5 36v18h-5V36A26.5 26.5 0 1136 62.5v-5a21.5 21.5 0 000-43z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUnlink24.tsx
import * as React531 from "react";
var componentNameString525 = "FeatureUnlink24";
function FeatureUnlink24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString525,
    ...props
  });
  return /* @__PURE__ */ React531.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React531.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React531.createElement("path", { d: "M7 7C4.23858 7 2 9.23858 2 12C2 14.7614 4.23858 17 7 17H11V15H7C5.34315 15 4 13.6569 4 12C4 10.3431 5.34315 9 7 9H11V7H7Z" }), /* @__PURE__ */ React531.createElement("path", { d: "M17 7C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H13V15H17C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9H13V7H17Z" }));
}

// src/components/icons/FeatureUnlink48.tsx
import * as React532 from "react";
var componentNameString526 = "FeatureUnlink48";
function FeatureUnlink48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString526,
    ...props
  });
  return /* @__PURE__ */ React532.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React532.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React532.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.3 24c0-5.4 4.3-9.8 9.7-9.8h8v3.6h-8a6.2 6.2 0 100 12.4h8v3.6h-8A9.7 9.7 0 014.2 24z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React532.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M43.8 24c0-5.4-4.4-9.8-9.8-9.8h-8v3.6h8a6.2 6.2 0 110 12.4h-8v3.6h8c5.4 0 9.8-4.4 9.8-9.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUnlink72.tsx
import * as React533 from "react";
var componentNameString527 = "FeatureUnlink72";
function FeatureUnlink72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString527,
    ...props
  });
  return /* @__PURE__ */ React533.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React533.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React533.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M6.5 36c0-8 6.5-14.5 14.5-14.5h12v5H21a9.5 9.5 0 000 19h12v5H21C13 50.5 6.5 44 6.5 36z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React533.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M65.5 36c0-8-6.5-14.5-14.5-14.5H39v5h12a9.5 9.5 0 010 19H39v5h12c8 0 14.5-6.5 14.5-14.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUnlinkAlt24.tsx
import * as React534 from "react";
var componentNameString528 = "FeatureUnlinkAlt24";
function FeatureUnlinkAlt24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString528,
    ...props
  });
  return /* @__PURE__ */ React534.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React534.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React534.createElement("path", { d: "M12 4.92882C10.0474 2.9762 6.88157 2.9762 4.92894 4.92882C2.97632 6.88144 2.97632 10.0473 4.92894 11.9999L7.75737 14.8283L9.17158 13.4141L6.34316 10.5857C5.17158 9.4141 5.17158 7.51461 6.34316 6.34303C7.51473 5.17146 9.41423 5.17146 10.5858 6.34303L13.4142 9.17146L14.8284 7.75725L12 4.92882Z" }), /* @__PURE__ */ React534.createElement("path", { d: "M19.0711 11.9999C21.0237 13.9525 21.0237 17.1184 19.0711 19.071C17.1184 21.0236 13.9526 21.0236 12 19.071L9.17157 16.2425L10.5858 14.8283L13.4142 17.6568C14.5858 18.8283 16.4853 18.8283 17.6569 17.6568C18.8284 16.4852 18.8284 14.5857 17.6569 13.4141L14.8284 10.5857L16.2426 9.17148L19.0711 11.9999Z" }));
}

// src/components/icons/FeatureUnlinkAlt48.tsx
import * as React535 from "react";
var componentNameString529 = "FeatureUnlinkAlt48";
function FeatureUnlinkAlt48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString529,
    ...props
  });
  return /* @__PURE__ */ React535.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React535.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React535.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10 10a9.7 9.7 0 0113.8 0l5.7 5.7-2.5 2.5-5.7-5.7a6.3 6.3 0 00-8.8 8.9l5.7 5.6-2.5 2.5-5.7-5.7A9.7 9.7 0 0110 10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React535.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 38a9.8 9.8 0 000-13.8l-5.7-5.7-2.5 2.5 5.7 5.7a6.2 6.2 0 11-8.8 8.8L21 29.8l-2.5 2.5 5.7 5.7A9.8 9.8 0 0038 38z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUnlinkAlt72.tsx
import * as React536 from "react";
var componentNameString530 = "FeatureUnlinkAlt72";
function FeatureUnlinkAlt72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString530,
    ...props
  });
  return /* @__PURE__ */ React536.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React536.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React536.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M15.1 15.1a14.5 14.5 0 0120.5 0l8.5 8.5-3.5 3.6-8.5-8.5A9.5 9.5 0 1018.7 32l8.5 8.5-3.6 3.5-8.5-8.5a14.5 14.5 0 010-20.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React536.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M56.9 56.9a14.5 14.5 0 000-20.5l-8.5-8.5-3.6 3.5 8.5 8.5A9.5 9.5 0 1140 53.3l-8.5-8.5-3.5 3.6 8.5 8.5a14.5 14.5 0 0020.5 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUnlock24.tsx
import * as React537 from "react";
var componentNameString531 = "FeatureUnlock24";
function FeatureUnlock24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString531,
    ...props
  });
  return /* @__PURE__ */ React537.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React537.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React537.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 15C16 17.2091 14.2091 19 12 19C9.79086 19 8 17.2091 8 15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15ZM14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React537.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3C10.3431 3 9 4.34315 9 6H7C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V8H18C19.1046 8 20 8.89543 20 10V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V10C4 8.89543 4.89543 8 6 8H15V6C15 4.34315 13.6569 3 12 3ZM6 10V20H18V10H6Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUnlock48.tsx
import * as React538 from "react";
var componentNameString532 = "FeatureUnlock48";
function FeatureUnlock48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString532,
    ...props
  });
  return /* @__PURE__ */ React538.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React538.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React538.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 5.8a6.2 6.2 0 00-6.3 6.2h-3.4a9.7 9.7 0 1119.4 0v6h-3.5v-6c0-3.5-2.7-6.3-6.2-6.3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React538.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 19.5H12c-.3 0-.5.2-.5.5v20c0 .3.2.5.5.5h24c.3 0 .5-.2.5-.5V20c0-.3-.2-.5-.5-.5zM12 16a4 4 0 00-4 4v20a4 4 0 004 4h24a4 4 0 004-4V20a4 4 0 00-4-4H12z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React538.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 34.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0 3.5a8 8 0 100-16 8 8 0 000 16z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUnlock72.tsx
import * as React539 from "react";
var componentNameString533 = "FeatureUnlock72";
function FeatureUnlock72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString533,
    ...props
  });
  return /* @__PURE__ */ React539.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React539.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React539.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 8.5a9.5 9.5 0 00-9.5 9.5h-5a14.5 14.5 0 0129 0v9h-5v-9c0-5.2-4.3-9.5-9.5-9.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React539.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M54 29H18a1 1 0 00-1 1v30c0 .6.4 1 1 1h36c.6 0 1-.4 1-1V30c0-.6-.4-1-1-1zm-36-5a6 6 0 00-6 6v30a6 6 0 006 6h36a6 6 0 006-6V30a6 6 0 00-6-6H18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React539.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 52a7 7 0 100-14 7 7 0 000 14zm0 5a12 12 0 100-24 12 12 0 000 24z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUp24.tsx
import * as React540 from "react";
var componentNameString534 = "FeatureUp24";
function FeatureUp24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString534,
    ...props
  });
  return /* @__PURE__ */ React540.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React540.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React540.createElement("path", { fillRule: "evenodd", d: "M13 6L13 20L11 20L11 6L13 6Z", clipRule: "evenodd" }), /* @__PURE__ */ React540.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3.58582L18.7071 10.2929L17.2929 11.7071L12 6.41425L6.70711 11.7071L5.29289 10.2929L12 3.58582Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUp48.tsx
import * as React541 from "react";
var componentNameString535 = "FeatureUp48";
function FeatureUp48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString535,
    ...props
  });
  return /* @__PURE__ */ React541.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React541.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React541.createElement("path", { fillRule: "evenodd", d: "M25.75 12L25.75 40L22.25 40L22.25 12L25.75 12Z", clipRule: "evenodd" }), /* @__PURE__ */ React541.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 7.52515L37.2374 20.7626L34.7626 23.2375L24 12.4749L13.2374 23.2375L10.7626 20.7626L24 7.52515Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUp72.tsx
import * as React542 from "react";
var componentNameString536 = "FeatureUp72";
function FeatureUp72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString536,
    ...props
  });
  return /* @__PURE__ */ React542.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React542.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React542.createElement("path", { fillRule: "evenodd", d: "M38.5 16L38.5 58L33.5 58L33.5 16L38.5 16Z", clipRule: "evenodd" }), /* @__PURE__ */ React542.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 11.4644L55.7678 31.2321L52.2322 34.7677L36 18.5354L19.7678 34.7677L16.2322 31.2321L36 11.4644Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUpArrowSmall24.tsx
import * as React543 from "react";
var componentNameString537 = "FeatureUpArrowSmall24";
function FeatureUpArrowSmall24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString537,
    ...props
  });
  return /* @__PURE__ */ React543.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React543.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React543.createElement("path", { d: "M16.7071 11.2929L12 6.58582L7.29285 11.2929L8.70706 12.7071L11 10.4142L11 17H13L13 10.4142L15.2928 12.7071L16.7071 11.2929Z" }));
}

// src/components/icons/FeatureUpload24.tsx
import * as React544 from "react";
var componentNameString538 = "FeatureUpload24";
function FeatureUpload24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString538,
    ...props
  });
  return /* @__PURE__ */ React544.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React544.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React544.createElement("path", { fillRule: "evenodd", d: "M20 4L4 4L4 2L20 2L20 4Z", clipRule: "evenodd" }), /* @__PURE__ */ React544.createElement("path", { fillRule: "evenodd", d: "M13 8L13 22L11 22L11 8L13 8Z", clipRule: "evenodd" }), /* @__PURE__ */ React544.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 5.5857L18.7071 12.2928L17.2929 13.707L12 8.41412L6.70711 13.707L5.29289 12.2928L12 5.5857Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUpload48.tsx
import * as React545 from "react";
var componentNameString539 = "FeatureUpload48";
function FeatureUpload48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString539,
    ...props
  });
  return /* @__PURE__ */ React545.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React545.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React545.createElement("path", { fillRule: "evenodd", d: "M40 7.75L8 7.75L8 4.25L40 4.25L40 7.75Z", clipRule: "evenodd" }), /* @__PURE__ */ React545.createElement("path", { fillRule: "evenodd", d: "M25.75 16L25.75 44L22.25 44L22.25 16L25.75 16Z", clipRule: "evenodd" }), /* @__PURE__ */ React545.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 11.5252L37.2374 24.7626L34.7626 27.2375L24 16.4749L13.2374 27.2375L10.7626 24.7626L24 11.5252Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUpload72.tsx
import * as React546 from "react";
var componentNameString540 = "FeatureUpload72";
function FeatureUpload72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString540,
    ...props
  });
  return /* @__PURE__ */ React546.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React546.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React546.createElement("path", { fillRule: "evenodd", d: "M60 11.5L12 11.5L12 6.5L60 6.5L60 11.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React546.createElement("path", { fillRule: "evenodd", d: "M38.5 24L38.5 66L33.5 66L33.5 24L38.5 24Z", clipRule: "evenodd" }), /* @__PURE__ */ React546.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 17.4644L55.7678 37.2321L52.2322 40.7677L36 24.5354L19.7678 40.7677L16.2322 37.2321L36 17.4644Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureUpload.tsx
import * as React547 from "react";
var componentNameString541 = "FeatureUpload";
function FeatureUpload({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString541,
    ...props
  });
  return /* @__PURE__ */ React547.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React547.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React547.createElement(
    "polygon",
    {
      points: "10.657 36 19.343 27.314 19.343 48 27.343 48 27.343 27.314 36.03 36 41.686 30.343 23.343 12 5 30.343",
      className: "sc-Icon--secondary-color"
    }
  ), /* @__PURE__ */ React547.createElement("polygon", { points: "7.343 8 39.343 8 39.343 0 7.343 0", className: "sc-Icon--primary-color" }));
}

// src/components/icons/FeatureUser.tsx
import * as React548 from "react";
var componentNameString542 = "FeatureUser";
function FeatureUser({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString542,
    ...props
  });
  return /* @__PURE__ */ React548.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React548.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React548.createElement("path", { d: "M46 48a22 22 0 00-44 0h6a16 16 0 1132 0h6z" }), /* @__PURE__ */ React548.createElement("path", { d: "M35 11a11 11 0 11-22 0 11 11 0 0122 0" }));
}

// src/components/icons/FeatureUsersTwo.tsx
import * as React549 from "react";
var componentNameString543 = "FeatureUsersTwo";
function FeatureUsersTwo({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString543,
    ...props
  });
  return /* @__PURE__ */ React549.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React549.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React549.createElement("path", { d: "M27.7 29a15 15 0 00-8.4 8H0a15 15 0 0127.7-8zM23 12a8 8 0 11-16 0 8 8 0 0116 0z" }), /* @__PURE__ */ React549.createElement("path", { d: "M48 43H18c0-2.1.5-4.2 1.3-6H30c0-3-.9-5.7-2.3-8A15 15 0 0148 43zm-7-25a8 8 0 11-16 0 8 8 0 0116 0z" }));
}

// src/components/icons/FeatureVennDiagram24.tsx
import * as React550 from "react";
var componentNameString544 = "FeatureVennDiagram24";
function FeatureVennDiagram24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString544,
    ...props
  });
  return /* @__PURE__ */ React550.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React550.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React550.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6C12.6863 6 10 8.68629 10 12C10 15.3137 12.6863 18 16 18ZM16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React550.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 18C11.3137 18 14 15.3137 14 12C14 8.68629 11.3137 6 8 6C4.68629 6 2 8.68629 2 12C2 15.3137 4.68629 18 8 18ZM8 20C12.4183 20 16 16.4183 16 12C16 7.58172 12.4183 4 8 4C3.58172 4 0 7.58172 0 12C0 16.4183 3.58172 20 8 20Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React550.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18.9298C14.3912 17.5466 16 14.9612 16 12.0001C16 9.03893 14.3912 6.45355 12 5.07031C9.60879 6.45355 8 9.03893 8 12.0001C8 14.9612 9.6088 17.5466 12 18.9298Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureVennDiagram48.tsx
import * as React551 from "react";
var componentNameString545 = "FeatureVennDiagram48";
function FeatureVennDiagram48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString545,
    ...props
  });
  return /* @__PURE__ */ React551.createElement("svg", { viewBox: "0 0 48 32", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React551.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React551.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32 28.5C38.9036 28.5 44.5 22.9036 44.5 16C44.5 9.09644 38.9036 3.5 32 3.5C25.0964 3.5 19.5 9.09644 19.5 16C19.5 22.9036 25.0964 28.5 32 28.5ZM32 32C40.8366 32 48 24.8366 48 16C48 7.16344 40.8366 0 32 0C23.1634 0 16 7.16344 16 16C16 24.8366 23.1634 32 32 32Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React551.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 28.5C22.9036 28.5 28.5 22.9036 28.5 16C28.5 9.09644 22.9036 3.5 16 3.5C9.09644 3.5 3.5 9.09644 3.5 16C3.5 22.9036 9.09644 28.5 16 28.5ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React551.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.8045 22.722L29.1378 13.0554L31.5289 15.6113L21.1955 25.278L18.8045 22.722Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React551.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.1151 16.7437L27.1151 6.07701L29.5516 8.58966L18.5516 19.2563L16.1151 16.7437Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureVennDiagram72.tsx
import * as React552 from "react";
var componentNameString546 = "FeatureVennDiagram72";
function FeatureVennDiagram72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString546,
    ...props
  });
  return /* @__PURE__ */ React552.createElement("svg", { viewBox: "0 0 72 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React552.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React552.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M48 43C58.4934 43 67 34.4934 67 24C67 13.5066 58.4934 5 48 5C37.5066 5 29 13.5066 29 24C29 34.4934 37.5066 43 48 43ZM48 48C61.2548 48 72 37.2548 72 24C72 10.7452 61.2548 0 48 0C34.7452 0 24 10.7452 24 24C24 37.2548 34.7452 48 48 48Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React552.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 43C34.4934 43 43 34.4934 43 24C43 13.5066 34.4934 5 24 5C13.5066 5 5 13.5066 5 24C5 34.4934 13.5066 43 24 43ZM24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React552.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28.2921 34.1743L43.7921 19.6743L47.2079 23.3257L31.7079 37.8257L28.2921 34.1743Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React552.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24.2596 25.2052L40.7596 9.20525L44.2404 12.7948L27.7404 28.7948L24.2596 25.2052Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureVennDiagram.tsx
import * as React553 from "react";
var componentNameString547 = "FeatureVennDiagram";
function FeatureVennDiagram({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString547,
    ...props
  });
  return /* @__PURE__ */ React553.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React553.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React553.createElement("path", { d: "M15 16.5v-1.4a16.5 16.5 0 1018 17.8l-1.5.1C22.4 33 15 25.6 15 16.5" }), /* @__PURE__ */ React553.createElement("path", { d: "M48 16.5a16.5 16.5 0 00-33-1.4l1.5-.1a16.5 16.5 0 0116.4 18c8.5-.9 15.1-8 15.1-16.6" }));
}

// src/components/icons/FeatureWebinar24.tsx
import * as React554 from "react";
var componentNameString548 = "FeatureWebinar24";
function FeatureWebinar24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString548,
    ...props
  });
  return /* @__PURE__ */ React554.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React554.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React554.createElement("path", { fillRule: "evenodd", d: "M23 20H1V18H23V20Z", clipRule: "evenodd" }), /* @__PURE__ */ React554.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 6H5L5 15H19V6ZM5 4C3.89543 4 3 4.89543 3 6V15C3 16.1046 3.89543 17 5 17H19C20.1046 17 21 16.1046 21 15V6C21 4.89543 20.1046 4 19 4H5Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React554.createElement("path", { d: "M13.6668 10.0002C13.6668 10.9206 12.9206 11.6668 12.0002 11.6668C11.0797 11.6668 10.3335 10.9206 10.3335 10.0002C10.3335 9.07969 11.0797 8.3335 12.0002 8.3335C12.9206 8.3335 13.6668 9.07969 13.6668 10.0002Z" }), /* @__PURE__ */ React554.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.0002 10.1517C12.0838 10.1517 12.1517 10.0838 12.1517 10.0002C12.1517 9.91648 12.0838 9.84865 12.0002 9.84865C11.9165 9.84865 11.8486 9.91648 11.8486 10.0002C11.8486 10.0838 11.9165 10.1517 12.0002 10.1517ZM12.0002 11.6668C12.9206 11.6668 13.6668 10.9206 13.6668 10.0002C13.6668 9.07969 12.9206 8.3335 12.0002 8.3335C11.0797 8.3335 10.3335 9.07969 10.3335 10.0002C10.3335 10.9206 11.0797 11.6668 12.0002 11.6668Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React554.createElement("path", { d: "M11.9998 12C10.1589 12 8.6665 13.4924 8.6665 15.3333H15.3332C15.3332 13.4924 13.8408 12 11.9998 12Z" }), /* @__PURE__ */ React554.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.9998 13.5152C11.6031 13.5152 11.2479 13.6288 10.9556 13.8182H13.0441C12.7518 13.6288 12.3965 13.5152 11.9998 13.5152ZM14.9697 13.8182C14.418 12.7389 13.2952 12 11.9998 12C10.7045 12 9.5817 12.7389 9.02996 13.8182C8.79758 14.2728 8.6665 14.7877 8.6665 15.3333H15.3332C15.3332 14.7877 15.2021 14.2728 14.9697 13.8182Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureWebinar48.tsx
import * as React555 from "react";
var componentNameString549 = "FeatureWebinar48";
function FeatureWebinar48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString549,
    ...props
  });
  return /* @__PURE__ */ React555.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React555.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React555.createElement("path", { fillRule: "evenodd", d: "M46 39.8H2v-3.5h44v3.5z", clipRule: "evenodd" }), /* @__PURE__ */ React555.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 11.5H10c-.3 0-.5.2-.5.5v18c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5V12c0-.3-.2-.5-.5-.5zM10 8a4 4 0 00-4 4v18a4 4 0 004 4h28a4 4 0 004-4V12a4 4 0 00-4-4H10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React555.createElement("path", { d: "M27.3 20a3.3 3.3 0 11-6.6 0 3.3 3.3 0 016.6 0z" }), /* @__PURE__ */ React555.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 20.3a.3.3 0 100-.6.3.3 0 000 .6zm0 3a3.3 3.3 0 100-6.6 3.3 3.3 0 000 6.6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React555.createElement("path", { d: "M24 24c-3.7 0-6.7 3-6.7 6.7h13.4c0-3.7-3-6.7-6.7-6.7z" }), /* @__PURE__ */ React555.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 27a4 4 0 00-2 .6h4a4 4 0 00-2-.6zm6 .6a6.7 6.7 0 00-12.7 3h13.4c0-1-.3-2-.8-3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureWebinar72.tsx
import * as React556 from "react";
var componentNameString550 = "FeatureWebinar72";
function FeatureWebinar72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString550,
    ...props
  });
  return /* @__PURE__ */ React556.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React556.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React556.createElement("path", { fillRule: "evenodd", d: "M69 59.5H3v-5h66v5z", clipRule: "evenodd" }), /* @__PURE__ */ React556.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57 17H15a1 1 0 00-1 1v27c0 .6.4 1 1 1h42c.6 0 1-.4 1-1V18c0-.6-.4-1-1-1zm-42-5a6 6 0 00-6 6v27a6 6 0 006 6h42a6 6 0 006-6V18a6 6 0 00-6-6H15z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React556.createElement("path", { d: "M41 30a5 5 0 11-10 0 5 5 0 0110 0z" }), /* @__PURE__ */ React556.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 30.5a.5.5 0 100-1 .5.5 0 000 1zm0 4.5a5 5 0 100-10 5 5 0 000 10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React556.createElement("path", { d: "M36 36a10 10 0 00-10 10h20a10 10 0 00-10-10z" }), /* @__PURE__ */ React556.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 40.5c-1.2 0-2.3.4-3.1 1H39c-.8-.6-2-1-3.1-1zm9 1A10 10 0 0026 46h20a10 10 0 00-1-4.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureWeddingBands24.tsx
import * as React557 from "react";
var componentNameString551 = "FeatureWeddingBands24";
function FeatureWeddingBands24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString551,
    ...props
  });
  return /* @__PURE__ */ React557.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React557.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React557.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6C12.6863 6 10 8.68629 10 12C10 15.3137 12.6863 18 16 18ZM16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React557.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8 18C11.3137 18 14 15.3137 14 12C14 8.68629 11.3137 6 8 6C4.68629 6 2 8.68629 2 12C2 15.3137 4.68629 18 8 18ZM8 20C12.4183 20 16 16.4183 16 12C16 7.58172 12.4183 4 8 4C3.58172 4 0 7.58172 0 12C0 16.4183 3.58172 20 8 20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureWeddingBands48.tsx
import * as React558 from "react";
var componentNameString552 = "FeatureWeddingBands48";
function FeatureWeddingBands48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString552,
    ...props
  });
  return /* @__PURE__ */ React558.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React558.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React558.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M32 36.5a12.5 12.5 0 100-25 12.5 12.5 0 000 25zm0 3.5a16 16 0 100-32 16 16 0 000 32z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React558.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16 36.5a12.5 12.5 0 100-25 12.5 12.5 0 000 25zm0 3.5a16 16 0 100-32 16 16 0 000 32z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureWeddingBands72.tsx
import * as React559 from "react";
var componentNameString553 = "FeatureWeddingBands72";
function FeatureWeddingBands72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString553,
    ...props
  });
  return /* @__PURE__ */ React559.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React559.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React559.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M48 55a19 19 0 100-38 19 19 0 000 38zm0 5a24 24 0 100-48 24 24 0 000 48z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React559.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 55a19 19 0 100-38 19 19 0 000 38zm0 5a24 24 0 100-48 24 24 0 000 48z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureWeddingCake24.tsx
import * as React560 from "react";
var componentNameString554 = "FeatureWeddingCake24";
function FeatureWeddingCake24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString554,
    ...props
  });
  return /* @__PURE__ */ React560.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React560.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React560.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.3334 3.83333C11.3334 4.29357 10.9603 4.66667 10.5001 4.66667C10.0398 4.66667 9.66675 4.29357 9.66675 3.83333C9.66675 3.3731 10.0398 3 10.5001 3C10.9603 3 11.3334 3.3731 11.3334 3.83333ZM10 9H14V10.6667L10 10.6667V9ZM8 9C8 8.12922 8.5565 7.38841 9.33325 7.11383V6.16667C9.33325 5.52234 9.85559 5 10.4999 5C11.1442 5 11.6666 5.52233 11.6666 6.16667V7H12.3333V6.16667C12.3333 5.52234 12.8556 5 13.4999 5C14.1442 5 14.6666 5.52233 14.6666 6.16667V7.11377C15.4434 7.38831 16 8.12916 16 9V10.6667C16 10.9005 15.9599 11.1249 15.8861 11.3335H17C18.1046 11.3335 19 12.2289 19 13.3335V15.0002C19 15.1137 18.9905 15.2251 18.9723 15.3335H19C20.1046 15.3335 21 16.2289 21 17.3335V19.0002C21 20.1047 20.1046 21.0002 19 21.0002H5C3.89543 21.0002 3 20.1047 3 19.0002V17.3335C3 16.2289 3.89543 15.3335 5 15.3335H5.02765C5.00947 15.2251 5 15.1137 5 15.0002V13.3335C5 12.2289 5.89543 11.3335 7 11.3335H8.11386C8.04012 11.1249 8 10.9005 8 10.6667V9ZM17 13.3335H7V15.0002L17 15.0002V13.3335ZM19 17.3335H5L5 19.0002L19 19.0002V17.3335ZM13.5001 4.66667C13.9603 4.66667 14.3334 4.29357 14.3334 3.83333C14.3334 3.3731 13.9603 3 13.5001 3C13.0398 3 12.6667 3.3731 12.6667 3.83333C12.6667 4.29357 13.0398 4.66667 13.5001 4.66667Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureWeddingCake48.tsx
import * as React561 from "react";
var componentNameString555 = "FeatureWeddingCake48";
function FeatureWeddingCake48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString555,
    ...props
  });
  return /* @__PURE__ */ React561.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React561.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React561.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M38 34.2H10c-.3 0-.5.2-.5.5V38c0 .3.2.5.5.5h28c.3 0 .5-.2.5-.5v-3.3c0-.3-.2-.5-.5-.5zm-28-3.5a4 4 0 00-4 4V38a4 4 0 004 4h28a4 4 0 004-4v-3.3a4 4 0 00-4-4H10z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React561.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34 26.2H14c-.3 0-.5.2-.5.5V30c0 .3.2.5.5.5h20c.3 0 .5-.2.5-.5v-3.3c0-.3-.2-.5-.5-.5zm-20-3.5a4 4 0 00-4 4V30a4 4 0 004 4h20a4 4 0 004-4v-3.3a4 4 0 00-4-4H14z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React561.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M28 17.5h-8c-.3 0-.5.2-.5.5v3.3c0 .3.2.5.5.5h8c.3 0 .5-.2.5-.5V18c0-.3-.2-.5-.5-.5zM20 14a4 4 0 00-4 4v3.3a4 4 0 004 4h8a4 4 0 004-4V18a4 4 0 00-4-4h-8z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React561.createElement("path", { d: "M22.7 7.7a1.7 1.7 0 11-3.4 0 1.7 1.7 0 013.4 0z" }), /* @__PURE__ */ React561.createElement("path", { d: "M28.7 7.7a1.7 1.7 0 11-3.4 0 1.7 1.7 0 013.4 0z" }), /* @__PURE__ */ React561.createElement("path", { d: "M18.7 12.3a2.3 2.3 0 014.6 0v3h-4.6v-3z" }), /* @__PURE__ */ React561.createElement("path", { d: "M24.7 12.3a2.3 2.3 0 014.6 0v3h-4.6v-3z" }));
}

// src/components/icons/FeatureWeddingCake72.tsx
import * as React562 from "react";
var componentNameString556 = "FeatureWeddingCake72";
function FeatureWeddingCake72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString556,
    ...props
  });
  return /* @__PURE__ */ React562.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React562.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React562.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M57 51H15a1 1 0 00-1 1v5c0 .6.4 1 1 1h42c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1zm-42-5a6 6 0 00-6 6v5a6 6 0 006 6h42a6 6 0 006-6v-5a6 6 0 00-6-6H15z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React562.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M51 39H21a1 1 0 00-1 1v5c0 .6.4 1 1 1h30c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1zm-30-5a6 6 0 00-6 6v5a6 6 0 006 6h30a6 6 0 006-6v-5a6 6 0 00-6-6H21z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React562.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M42 26H30a1 1 0 00-1 1v5c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1zm-12-5a6 6 0 00-6 6v5a6 6 0 006 6h12a6 6 0 006-6v-5a6 6 0 00-6-6H30z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React562.createElement("path", { d: "M34 11.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" }), /* @__PURE__ */ React562.createElement("path", { d: "M43 11.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" }), /* @__PURE__ */ React562.createElement("path", { d: "M28 18.5a3.5 3.5 0 117 0V23h-7v-4.5z" }), /* @__PURE__ */ React562.createElement("path", { d: "M37 18.5a3.5 3.5 0 117 0V23h-7v-4.5z" }));
}

// src/components/icons/FeatureWithdraw24.tsx
import * as React563 from "react";
var componentNameString557 = "FeatureWithdraw24";
function FeatureWithdraw24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString557,
    ...props
  });
  return /* @__PURE__ */ React563.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React563.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React563.createElement("path", { fillRule: "evenodd", d: "M4 13L18 13L18 11L4 11L4 13Z", clipRule: "evenodd" }), /* @__PURE__ */ React563.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M1.58594 12L8.29305 18.7071L9.70726 17.2929L4.41437 12L9.70726 6.70711L8.29304 5.29289L1.58594 12Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React563.createElement("path", { fillRule: "evenodd", d: "M22 20L22 4L20 4L20 20L22 20Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureWithdraw48.tsx
import * as React564 from "react";
var componentNameString558 = "FeatureWithdraw48";
function FeatureWithdraw48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString558,
    ...props
  });
  return /* @__PURE__ */ React564.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React564.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React564.createElement("path", { fillRule: "evenodd", d: "M8 25.75L36 25.75L36 22.25L8 22.25L8 25.75Z", clipRule: "evenodd" }), /* @__PURE__ */ React564.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3.5254 24L16.7628 37.2374L19.2377 34.7626L8.47514 24L19.2377 13.2374L16.7628 10.7626L3.5254 24Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React564.createElement("path", { fillRule: "evenodd", d: "M43.75 40L43.75 8L40.25 8L40.25 40L43.75 40Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureWithdraw72.tsx
import * as React565 from "react";
var componentNameString559 = "FeatureWithdraw72";
function FeatureWithdraw72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString559,
    ...props
  });
  return /* @__PURE__ */ React565.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React565.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React565.createElement("path", { fillRule: "evenodd", d: "M12 38.5L54 38.5L54 33.5L12 33.5L12 38.5Z", clipRule: "evenodd" }), /* @__PURE__ */ React565.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5.46437 36L25.2321 55.7678L28.7677 52.2322L12.5354 36L28.7677 19.7678L25.2321 16.2322L5.46437 36Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React565.createElement("path", { fillRule: "evenodd", d: "M65.5 60L65.5 12L60.5 12L60.5 60L65.5 60Z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureX24.tsx
import * as React566 from "react";
var componentNameString560 = "FeatureX24";
function FeatureX24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString560,
    ...props
  });
  return /* @__PURE__ */ React566.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React566.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React566.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M17.293 18.7072L5.29297 6.70718L6.70718 5.29297L18.7072 17.293L17.293 18.7072Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React566.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5.29297 17.293L17.293 5.29297L18.7072 6.70718L6.70718 18.7072L5.29297 17.293Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureX48.tsx
import * as React567 from "react";
var componentNameString561 = "FeatureX48";
function FeatureX48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString561,
    ...props
  });
  return /* @__PURE__ */ React567.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React567.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React567.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M34.7627 37.2373L10.7627 13.2373L13.2376 10.7625L37.2376 34.7625L34.7627 37.2373Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React567.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10.7627 34.7625L34.7627 10.7625L37.2376 13.2373L13.2376 37.2373L10.7627 34.7625Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureX72.tsx
import * as React568 from "react";
var componentNameString562 = "FeatureX72";
function FeatureX72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString562,
    ...props
  });
  return /* @__PURE__ */ React568.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React568.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React568.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M52.2324 55.7677L16.2324 19.7677L19.768 16.2322L55.768 52.2322L52.2324 55.7677Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React568.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.2324 52.2322L52.2324 16.2322L55.768 19.7677L19.768 55.7677L16.2324 52.2322Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureXInCircle24.tsx
import * as React569 from "react";
var componentNameString563 = "FeatureXInCircle24";
function FeatureXInCircle24({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString563,
    ...props
  });
  return /* @__PURE__ */ React569.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React569.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React569.createElement("path", { d: "M10.5858 12.0001L7.29291 8.70718L8.70712 7.29297L12 10.5858L15.2929 7.29297L16.7071 8.70718L13.4142 12.0001L16.7071 15.293L15.2929 16.7072L12 13.4143L8.70709 16.7072L7.29288 15.293L10.5858 12.0001Z" }), /* @__PURE__ */ React569.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/FeatureXInCircle48.tsx
import * as React570 from "react";
var componentNameString564 = "FeatureXInCircle48";
function FeatureXInCircle48({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString564,
    ...props
  });
  return /* @__PURE__ */ React570.createElement("svg", { viewBox: "0 0 48 48", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React570.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React570.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M24 40.5a16.5 16.5 0 100-33 16.5 16.5 0 000 33zm0 3.5a20 20 0 100-40 20 20 0 000 40z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React570.createElement("path", { fillRule: "evenodd", d: "M30.8 33.2l-16-16 2.4-2.4 16 16-2.4 2.4z", clipRule: "evenodd" }), /* @__PURE__ */ React570.createElement("path", { fillRule: "evenodd", d: "M14.8 30.8l16-16 2.4 2.4-16 16-2.4-2.4z", clipRule: "evenodd" }));
}

// src/components/icons/FeatureXInCircle72.tsx
import * as React571 from "react";
var componentNameString565 = "FeatureXInCircle72";
function FeatureXInCircle72({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString565,
    ...props
  });
  return /* @__PURE__ */ React571.createElement("svg", { viewBox: "0 0 72 72", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React571.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React571.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M36 61a25 25 0 100-50 25 25 0 000 50zm0 5a30 30 0 100-60 30 30 0 000 60z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React571.createElement("path", { fillRule: "evenodd", d: "M46.2 49.8l-24-24 3.6-3.6 24 24-3.6 3.6z", clipRule: "evenodd" }), /* @__PURE__ */ React571.createElement("path", { fillRule: "evenodd", d: "M22.2 46.2l24-24 3.6 3.6-24 24-3.6-3.6z", clipRule: "evenodd" }));
}

// src/components/icons/LogoB4A.tsx
import * as React572 from "react";
var componentNameString566 = "LogoB4A";
function LogoB4A({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString566,
    ...props
  });
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ React572.createElement("svg", { viewBox: "0 0 380 87", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React572.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M161.016 84.2541C159.672 82.4305 159 80.0243 159 77.0355C159 74.1212 159.714 71.7373 161.143 69.8839C161.789 68.9958 162.624 68.2803 163.58 67.7951C164.537 67.3099 165.588 67.0684 166.649 67.0903C167.736 67.0363 168.814 67.3162 169.754 67.8961C170.694 68.4761 171.454 69.3311 171.942 70.3576V59H175V86.5427H172.12V83.0071C170.991 85.6681 169.047 86.9986 166.288 86.9986C165.266 87.0207 164.253 86.7829 163.335 86.3053C162.417 85.8276 161.622 85.1242 161.016 84.2541V84.2541ZM170.697 82.3366C171.586 81.1298 172.031 79.5147 172.031 77.4914V76.5974C172.031 74.5116 171.592 72.8726 170.714 71.6807C170.298 71.1007 169.755 70.6352 169.132 70.324C168.509 70.0127 167.824 69.8648 167.135 69.8928C166.435 69.8637 165.738 70.0203 165.109 70.3482C164.481 70.6761 163.94 71.1649 163.536 71.7701C162.672 73.0246 162.24 74.7663 162.24 76.9953C162.24 79.2242 162.672 80.9659 163.536 82.2204C163.94 82.8256 164.481 83.3144 165.109 83.6423C165.738 83.9702 166.435 84.1267 167.135 84.0977C167.819 84.1259 168.5 83.9807 169.119 83.6743C169.739 83.3679 170.28 82.9092 170.697 82.3366V82.3366Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M179 68H182.25L186.206 80.1299C186.502 81.0278 186.75 81.9411 186.95 82.8659H187.054C187.252 81.9406 187.501 81.0272 187.798 80.1299L191.754 68H195L188.608 86H185.396L179 68Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement("path", { d: "M199 60H202V63.9765H199V60ZM199.186 67.4286H201.814V86H199.186V67.4286Z", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M208.564 85.5034C207.874 84.9947 207.292 84.3465 206.851 83.598C206.411 82.8495 206.121 82.0161 206 81.1484L209.167 80.5596C209.334 81.6653 209.902 82.6633 210.754 83.3506C211.71 84.0513 212.864 84.401 214.034 84.3439C215.036 84.4058 216.029 84.116 216.853 83.5214C217.171 83.284 217.429 82.9711 217.605 82.609C217.782 82.2469 217.872 81.8462 217.868 81.4405C217.892 81.1032 217.846 80.7646 217.731 80.448C217.616 80.1313 217.437 79.8443 217.204 79.6068C216.63 79.1391 215.94 78.8479 215.213 78.7663L211.6 78.0787C208.329 77.4405 206.696 75.6577 206.698 72.7303C206.682 71.9372 206.845 71.1511 207.174 70.4348C207.504 69.7184 207.99 69.0917 208.594 68.6045C209.861 67.5349 211.564 67 213.704 67C215.766 67 217.455 67.4585 218.77 68.3753C219.396 68.7874 219.922 69.3423 220.308 69.9974C220.694 70.6525 220.931 71.3906 221 72.1551L217.907 72.8832C217.714 71.9412 217.204 71.1014 216.467 70.5146C215.617 69.9618 214.638 69.6593 213.634 69.6395C212.631 69.6197 211.641 69.8834 210.772 70.4023C210.44 70.6478 210.174 70.9757 209.996 71.3557C209.819 71.7358 209.736 72.1559 209.757 72.5775C209.757 74.0307 210.704 74.9296 212.598 75.2742L216.172 75.9573C219.37 76.5955 220.968 78.3273 220.965 81.1528C220.991 81.9607 220.837 82.7639 220.514 83.4998C220.191 84.2358 219.709 84.8845 219.104 85.3955C217.859 86.4652 216.137 87 213.925 87C211.713 87 209.952 86.5236 208.564 85.5034Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M226.314 84.307C224.771 82.5117 224 80.076 224 77C224 73.924 224.771 71.4883 226.314 69.693C227.859 67.8977 229.921 67 232.5 67C235.079 67 237.141 67.8977 238.686 69.693C240.229 71.4883 241 73.924 241 77C241 80.076 240.229 82.5117 238.686 84.307C237.141 86.1023 235.079 87 232.5 87C229.921 87 227.859 86.1023 226.314 84.307ZM236.351 82.3411C237.261 81.1203 237.716 79.3399 237.716 77C237.716 74.6601 237.261 72.8797 236.351 71.6589C235.871 71.0838 235.279 70.6228 234.615 70.3069C233.951 69.991 233.23 69.8276 232.5 69.8276C231.77 69.8276 231.049 69.991 230.385 70.3069C229.721 70.6228 229.129 71.0838 228.649 71.6589C227.739 72.8797 227.284 74.6601 227.284 77C227.284 79.3399 227.739 81.1203 228.649 82.3411C229.129 82.9162 229.721 83.3772 230.385 83.6931C231.049 84.009 231.77 84.1724 232.5 84.1724C233.23 84.1724 233.951 84.009 234.615 83.6931C235.279 83.3772 235.871 82.9162 236.351 82.3411V82.3411Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M258.563 85.4691C257.874 84.961 257.291 84.3136 256.851 83.5659C256.41 82.8182 256.121 81.9858 256 81.119L259.17 80.5443C259.337 81.6476 259.903 82.644 260.753 83.3322C261.71 84.0313 262.865 84.3803 264.036 84.3243C265.038 84.3862 266.031 84.0968 266.854 83.5028C267.172 83.2657 267.43 82.9531 267.606 82.5914C267.783 82.2297 267.873 81.8295 267.869 81.4242C267.893 81.0874 267.847 80.7491 267.732 80.4328C267.617 80.1165 267.438 79.8299 267.206 79.5926C266.631 79.1254 265.941 78.8346 265.215 78.7531L261.603 78.0662C258.333 77.4287 256.7 75.648 256.702 72.7239C256.686 71.9316 256.849 71.1464 257.178 70.4309C257.507 69.7154 257.993 69.0894 258.598 68.6027C259.864 67.5343 261.565 67 263.702 67C265.766 67 267.456 67.4579 268.771 68.3738C269.396 68.7854 269.922 69.3396 270.308 69.994C270.695 70.6484 270.931 71.3856 271 72.1493L267.908 72.899C267.719 71.9577 267.21 71.118 266.473 70.5331C265.623 69.9809 264.644 69.6787 263.641 69.659C262.638 69.6392 261.648 69.9026 260.779 70.4209C260.448 70.6661 260.181 70.9936 260.004 71.3733C259.826 71.7529 259.744 72.1725 259.764 72.5937C259.764 74.0452 260.709 74.9431 262.6 75.2873L266.178 75.9697C269.358 76.6072 270.955 78.3371 270.97 81.1594C270.996 81.9664 270.841 82.7687 270.519 83.5038C270.196 84.2389 269.714 84.8869 269.109 85.3973C267.863 86.4657 266.129 87 263.905 87C261.682 87 259.901 86.4897 258.563 85.4691Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M76.4533 62.9448V71.2155H87.6862V74.1431H76.4533V86H73V60H89V62.9277L76.4533 62.9448Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M93.3176 84.307C91.7725 82.5117 91 80.076 91 77C91 73.924 91.7725 71.4883 93.3176 69.693C94.8626 67.8977 96.9241 67 99.5021 67C102.08 67 104.14 67.8977 105.682 69.693C107.228 71.4883 108 73.924 108 77C108 80.076 107.228 82.5117 105.682 84.307C104.14 86.1023 102.08 87 99.5021 87C96.9241 87 94.8626 86.1023 93.3176 84.307ZM103.348 82.3411C104.263 81.1203 104.72 79.3399 104.717 77C104.714 74.6601 104.258 72.8797 103.348 71.6589C102.869 71.0839 102.277 70.6229 101.614 70.3071C100.95 69.9912 100.229 69.8278 99.5 69.8278C98.7708 69.8278 98.0501 69.9912 97.3863 70.3071C96.7226 70.6229 96.1313 71.0839 95.6523 71.6589C94.7424 72.8797 94.2861 74.6601 94.2832 77C94.2804 79.3399 94.7367 81.1203 95.6523 82.3411C96.1313 82.9161 96.7226 83.377 97.3863 83.6929C98.0501 84.0087 98.7708 84.1722 99.5 84.1722C100.229 84.1722 100.95 84.0087 101.614 83.6929C102.277 83.377 102.869 82.9161 103.348 82.3411Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M116.529 68.3121C117.553 67.4497 118.893 66.9809 120.278 67.001C120.519 66.9962 120.761 67.0093 121 67.0403V70.0997C117.856 69.4485 114.862 71.9529 114.499 75.7072C114.442 76.3016 114.418 77.084 114.418 78.0499V86H111V67.4249H114.168V71.6601C114.624 70.3718 115.438 69.2172 116.529 68.3121V68.3121Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M249.968 68.3121C250.892 67.4502 252.101 66.9815 253.349 67.001C253.567 66.9962 253.784 67.0093 254 67.0403V70.0997C251.163 69.4485 248.471 71.9529 248.143 75.7072C248.092 76.3016 248.071 77.084 248.071 78.0499V86H245V67.4249H247.841V71.6601C248.252 70.3716 248.985 69.2169 249.968 68.3121V68.3121Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M154.203 86H158L146.774 60H143.226L132 85.9828H135.797L138.817 78.5302H151.178L154.203 86ZM140.01 75.6198L145.004 63.2936L149.999 75.6198H140.01Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M345.763 16.0013C343.8 15.9724 341.861 16.4429 340.115 17.3712C338.37 18.2996 336.872 19.6574 335.753 21.3252V16.8886H328V47H335.753V32.2659C335.753 26.6003 338.357 23.2196 342.717 23.2196C346.578 23.2196 349.307 25.8506 349.307 30.2473V47H357V28.5613C357 20.7129 352.418 16.0013 345.763 16.0013Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M269.112 46.9911H260.951V30.2433C260.951 26.1095 258.36 23.2176 254.647 23.2176C250.012 23.2176 247.248 26.5974 247.248 32.2613V46.9911H239V16.8884H247.248V21.3237C248.436 19.6562 250.028 18.2986 251.883 17.3704C253.738 16.4422 255.8 15.972 257.886 16.0013C262.616 16.0013 266.188 18.3654 267.922 22.3527C269.162 20.3908 270.904 18.7746 272.978 17.6616C275.052 16.5485 277.387 15.9765 279.755 16.0013C286.598 16.0013 291 20.9334 291 28.5667V47H282.821V30.2521C282.821 26.1183 280.23 23.2265 276.516 23.2265C271.882 23.2265 269.112 26.6062 269.112 32.2702V46.9911Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M101.119 26.7191L99.3575 26.0158L101.041 25.1577C102.509 24.2939 103.716 23.0713 104.541 21.6124C105.367 20.1536 105.783 18.5099 105.746 16.8463C105.746 11.9541 101.393 7 93.0784 7H73V47H93.1332C106.33 47 106.996 37.9411 106.996 36.1231C107.049 34.1745 106.523 32.2523 105.481 30.5852C104.439 28.918 102.925 27.5761 101.119 26.7191V26.7191ZM81.2961 13.5819H91.2304C93.9683 13.5819 96.8934 15.1743 96.8934 18.6687C96.8934 22.0835 94.0459 23.8705 91.2304 23.8705H81.2961V13.5819ZM92.5308 40.4225H81.2961V30.1295H92.5308C96.2088 30.1295 98.1346 32.7481 98.1346 35.3357C98.1528 38.2817 95.7799 40.4225 92.5308 40.4225Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M141 32.0089C140.824 22.5859 134.343 16 125.226 16C115.987 16 109.001 22.8749 109.001 32.0089C108.947 36.181 110.529 40.2123 113.418 43.2596C116.37 46.3191 120.606 48 125.212 48C129.818 48 134.055 46.3191 137.011 43.2596C138.601 41.6106 139.804 39.6371 140.536 37.4786H133.063C131.536 40.1467 128.651 41.7921 125.212 41.7921C121.255 41.7921 118.06 39.0128 117.177 34.7126L116.965 33.672H140.964L141 32.0089ZM117.438 28.1623C117.917 26.4874 118.94 25.0141 120.35 23.9694C121.761 22.9248 123.48 22.3668 125.244 22.3813C128.967 22.3813 131.752 24.547 132.725 28.1623H117.438Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M215 32.0089C214.825 22.5859 208.551 16 199.719 16C190.769 16 184.001 22.8749 184.001 32.0089C183.948 36.181 185.482 40.2123 188.28 43.2596C191.14 46.3191 195.266 48 199.706 48C204.146 48 208.272 46.3191 211.132 43.2596C212.673 41.6104 213.84 39.637 214.55 37.4786H207.312C205.827 40.1467 203.037 41.7921 199.706 41.7921C195.872 41.7921 192.773 39.0128 191.921 34.7126L191.716 33.672H214.965L215 32.0089ZM192.17 28.1623C192.634 26.487 193.627 25.0136 194.994 23.969C196.361 22.9244 198.027 22.3666 199.736 22.3813C203.343 22.3813 206.041 24.547 206.98 28.1623H192.17Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M324 32.0089C323.83 22.5859 317.551 16 308.719 16C299.769 16 293.001 22.8749 293.001 32.0089C292.948 36.181 294.482 40.2123 297.28 43.2596C300.144 46.3191 304.244 48 308.71 48C313.177 48 317.272 46.3191 320.136 43.2596C321.676 41.6096 322.843 39.6365 323.555 37.4786H316.346C314.866 40.1467 312.076 41.7921 308.745 41.7921C304.907 41.7921 301.812 39.0128 300.961 34.7126L300.751 33.672H324V32.0089ZM301.174 28.1623C301.638 26.4874 302.629 25.0141 303.996 23.9694C305.362 22.9248 307.028 22.3668 308.736 22.3813C312.343 22.3813 315.045 24.547 315.984 28.1623H301.174Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M237 16.0298C231.916 15.7149 227.594 17.9103 225.394 22.0881V16.899H217V47H225.394V33.9342C225.394 25.9511 231.123 21.8752 237 24.177V16.0298Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M183.037 41.4464C181.855 41.9648 180.578 42.2339 179.286 42.2368C175.726 42.2368 173.754 40.0743 173.754 36.1446V24.098H183.389V17.9436H173.75V5.00444L165.704 7.92618V17.9436H152.046V5L144 7.92174V37.2281C144 44.9277 148.005 48.995 155.571 48.995C158.215 49.0557 160.843 48.5594 163.283 47.5386L161.329 41.4598C160.148 41.9785 158.872 42.2476 157.582 42.2501C154.022 42.2501 152.05 40.0877 152.05 36.158V24.1157H165.717V37.2281C165.717 44.9277 169.722 48.995 177.288 48.995C179.933 49.0557 182.56 48.5594 185 47.5386L183.037 41.4464Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M378.075 40.6138C376.91 41.1203 375.651 41.3833 374.378 41.3862C370.871 41.3862 368.928 39.2729 368.928 35.4324V23.6596H378.421V17.6451H368.924V5L361 7.85533V36.4956C361 44.0202 364.946 47.9952 372.401 47.9952C375.007 48.0544 377.596 47.5694 380 46.5718L378.075 40.6138Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React572.createElement(
    "path",
    {
      d: "M32.0009 41.9136L57.4116 51C61.5755 45.7029 64 38.9591 64 31.4374C64 13.5181 50.2448 0 32.0009 0C13.7571 0 0.00196178 13.5138 0.00196178 31.4374C-0.0771958 38.4966 2.24117 45.3803 6.59041 51L32.0009 41.9136Z",
      fill: theme2.colors.bmtGold
    }
  ));
}

// src/components/icons/LogoB4B.tsx
import * as React573 from "react";
var componentNameString567 = "LogoB4B";
function LogoB4B({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString567,
    ...props
  });
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ React573.createElement("svg", { viewBox: "0 0 380 87", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React573.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M76.6727 63.0581V71.6468H88.6091V74.687H76.6727V87H73V60H90V63.0403L76.6727 63.0581Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M93.4539 84.307C91.818 82.5117 91 80.076 91 77C91 73.924 91.818 71.4883 93.4539 69.693C95.0899 67.8977 97.2711 67 99.9977 67C102.724 67 104.907 67.8977 106.546 69.693C108.182 71.4883 109 73.924 109 77C109 80.076 108.182 82.5117 106.546 84.307C104.91 86.1023 102.727 87 99.9977 87C97.2681 87 95.0868 86.1023 93.4539 84.307ZM104.074 82.3411C105.043 81.1203 105.527 79.3399 105.524 77C105.521 74.6601 105.037 72.8797 104.074 71.6589C103.567 71.0839 102.941 70.6229 102.238 70.3071C101.535 69.9912 100.772 69.8278 100 69.8278C99.2279 69.8278 98.4648 69.9912 97.762 70.3071C97.0593 70.6229 96.4332 71.0839 95.926 71.6589C94.9596 72.8797 94.4764 74.6601 94.4764 77C94.4764 79.3399 94.9611 81.1143 95.9306 82.3231C96.4377 82.8981 97.0638 83.3591 97.7665 83.675C98.4693 83.9908 99.2324 84.1543 100.005 84.1543C100.777 84.1543 101.54 83.9908 102.243 83.675C102.945 83.3591 103.571 82.8981 104.079 82.3231L104.074 82.3411Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M160 79.466V67.0046H163.143V79.0753C163.143 80.7163 163.469 81.9758 164.121 82.8445C164.454 83.2813 164.881 83.6279 165.366 83.8557C165.852 84.0835 166.381 84.1859 166.911 84.1546C167.603 84.172 168.29 84.0142 168.913 83.6944C169.536 83.3746 170.077 82.902 170.493 82.3159C171.405 81.0902 171.86 79.4875 171.857 77.5079V67H175V86.5356H172.044V82.8583C171.617 84.0688 170.842 85.1072 169.828 85.8277C168.803 86.5971 167.576 87.007 166.32 86.9999C162.11 87.006 160.003 84.4947 160 79.466Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M181.734 85.4899C180.999 84.9812 180.378 84.333 179.908 83.5845C179.438 82.836 179.129 82.0026 179 81.1349L182.381 80.5596C182.56 81.6641 183.163 82.6616 184.07 83.3506C185.091 84.0504 186.323 84.3999 187.571 84.3438C188.64 84.4057 189.699 84.116 190.578 83.5214C190.917 83.284 191.192 82.9711 191.38 82.609C191.568 82.2469 191.664 81.8462 191.66 81.4405C191.686 81.1032 191.636 80.7646 191.514 80.4479C191.392 80.1313 191.2 79.8443 190.953 79.6068C190.34 79.1391 189.604 78.8479 188.829 78.7663L184.976 78.0787C181.489 77.4405 179.746 75.6577 179.749 72.7303C179.732 71.9372 179.906 71.1511 180.257 70.4348C180.608 69.7184 181.126 69.0917 181.771 68.6045C183.121 67.5349 184.936 67 187.215 67C189.417 67 191.219 67.4585 192.622 68.3753C193.289 68.7874 193.85 69.3423 194.262 69.9974C194.674 70.6525 194.927 71.3906 195 72.155L191.697 72.8831C191.496 71.9408 190.952 71.1002 190.166 70.5146C189.26 69.9618 188.216 69.6593 187.146 69.6395C186.076 69.6197 185.02 69.8834 184.093 70.4023C183.739 70.6478 183.455 70.9756 183.266 71.3557C183.077 71.7358 182.989 72.1559 183.01 72.5775C183.01 74.0307 184.019 74.9296 186.036 75.2742L189.852 75.9573C193.244 76.5955 194.948 78.3273 194.963 81.1528C194.991 81.9607 194.826 82.7639 194.482 83.4998C194.138 84.2358 193.623 84.8845 192.979 85.3955C191.65 86.4652 189.799 87 187.428 87C185.056 87 183.158 86.4966 181.734 85.4899Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement("path", { d: "M198 60H202V64.1294H198V60ZM198.248 67.7143H201.752V87H198.248V67.7143Z", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M208 67.5448H210.899V71.3992C212.084 68.4664 214.1 67 216.947 67C220.985 67 223.003 69.6337 223 74.9011V87H219.918V75.098C219.918 71.6464 218.59 69.9221 215.933 69.9252C215.247 69.8972 214.566 70.0494 213.948 70.3685C213.33 70.6876 212.794 71.164 212.386 71.7562C211.517 72.977 211.082 74.6692 211.082 76.8329V86.9908H208V67.5448Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M250.392 85.4899C249.748 84.9827 249.203 84.335 248.792 83.5861C248.381 82.8373 248.111 82.0032 248 81.1349L250.959 80.5596C251.115 81.6641 251.643 82.6616 252.436 83.3506C253.33 84.0504 254.408 84.3999 255.5 84.3438C256.435 84.405 257.362 84.1154 258.131 83.5214C258.427 83.284 258.668 82.9711 258.832 82.609C258.997 82.2469 259.081 81.8462 259.078 81.4405C259.1 81.1032 259.057 80.7646 258.95 80.4479C258.843 80.1313 258.675 79.8443 258.459 79.6068C257.922 79.1391 257.279 78.8479 256.601 78.7663L253.229 78.0787C250.178 77.4405 248.652 75.6577 248.652 72.7303C248.636 71.9367 248.789 71.1501 249.097 70.4337C249.405 69.7172 249.859 69.0908 250.424 68.6045C251.606 67.5349 253.194 67 255.188 67C257.115 67 258.692 67.4585 259.92 68.3753C260.502 68.7882 260.993 69.3432 261.353 69.9982C261.714 70.6532 261.935 71.3908 262 72.155L259.11 72.8831C258.934 71.9408 258.458 71.1002 257.77 70.5146C256.977 69.9615 256.062 69.6587 255.125 69.6389C254.188 69.6191 253.264 69.883 252.452 70.4023C252.144 70.6489 251.897 70.9771 251.732 71.357C251.567 71.7368 251.491 72.1564 251.509 72.5775C251.509 74.0307 252.391 74.9296 254.156 75.2742L257.495 75.9573C260.463 76.5955 261.947 78.3273 261.947 81.1528C261.972 81.9607 261.828 82.7639 261.526 83.4998C261.225 84.2358 260.775 84.8845 260.211 85.3955C259.054 86.4652 257.443 87 255.378 87C253.314 87 251.652 86.4966 250.392 85.4899Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M267.729 85.4691C266.994 84.9615 266.373 84.3142 265.904 83.5663C265.435 82.8185 265.127 81.9858 265 81.119L268.381 80.5443C268.558 81.6484 269.162 82.6455 270.07 83.3322C271.091 84.0313 272.323 84.3803 273.571 84.3243C274.64 84.3855 275.699 84.0961 276.578 83.5028C276.916 83.2655 277.19 82.9528 277.378 82.5911C277.565 82.2293 277.661 81.8291 277.656 81.4242C277.681 81.0878 277.632 80.75 277.51 80.4339C277.389 80.1177 277.199 79.8308 276.953 79.5926C276.339 79.1271 275.604 78.8364 274.829 78.7531L270.976 78.0662C267.489 77.4287 265.745 75.648 265.745 72.7239C265.727 71.9311 265.902 71.1455 266.253 70.4298C266.605 69.7141 267.125 69.0884 267.771 68.6027C269.121 67.5343 270.936 67 273.215 67C275.417 67 277.219 67.4579 278.622 68.3738C279.288 68.7862 279.849 69.3406 280.261 69.9948C280.673 70.6491 280.926 71.3859 281 72.1493L277.707 72.899C277.505 71.9566 276.96 71.1165 276.171 70.5331C275.264 69.9809 274.22 69.6787 273.15 69.659C272.08 69.6392 271.025 69.9026 270.097 70.4209C269.745 70.6672 269.463 70.9951 269.274 71.3745C269.086 71.754 268.999 72.173 269.02 72.5937C269.02 74.0452 270.028 74.9431 272.045 75.2873L275.856 75.9697C279.264 76.6072 280.96 78.3371 280.944 81.1594C280.972 81.9664 280.808 82.7687 280.463 83.5038C280.119 84.2389 279.605 84.8869 278.96 85.3973C277.637 86.4657 275.796 87 273.437 87C271.078 87 269.175 86.4897 267.729 85.4691Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M155.537 75.1886C156.544 76.4372 157.06 77.9893 156.994 79.5702C157.024 81.4074 156.328 83.1865 155.047 84.5457C154.253 85.3656 153.259 85.9799 152.155 86.3323C150.739 86.8001 149.248 87.0253 147.751 86.9977H136V60.0028H146.927C148.467 59.9723 150.001 60.1912 151.466 60.6504C152.579 60.984 153.578 61.6012 154.357 62.437C155.566 63.7482 156.226 65.4473 156.208 67.2027C156.222 68.4982 155.8 69.7631 155.005 70.807C154.14 71.9099 152.914 72.6971 151.526 73.0402C153.095 73.2457 154.526 74.0124 155.537 75.1886ZM139.733 63.0578V71.7137H146.927C150.647 71.7137 152.508 70.2964 152.512 67.4617C152.512 64.5287 150.65 63.0608 146.927 63.0578H139.733ZM151.938 82.6073C152.389 82.1626 152.743 81.6341 152.977 81.0537C153.211 80.4733 153.32 79.8531 153.298 79.2307C153.324 78.6307 153.22 78.032 152.993 77.4729C152.766 76.9138 152.421 76.4066 151.98 75.9836C151.104 75.1558 149.76 74.7419 147.95 74.7419H139.733V83.9293H147.557C149.574 83.9353 151.034 83.4946 151.938 82.6073Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M117.496 68.3812C118.529 67.4684 119.882 66.9747 121.277 67.001C121.519 66.996 121.761 67.0098 122 67.0424V70.2629C118.848 69.5774 115.856 72.2136 115.492 76.1655C115.436 76.7912 115.412 77.6147 115.412 78.6315V87H112V67.4473H115.171V71.9053C115.617 70.5531 116.418 69.338 117.496 68.3812V68.3812Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M244 77.6152C244 70.8527 240.963 67 235.591 67C229.951 67 227 71.3197 227 77C227 83.255 230.406 87 235.591 87C239.9 87 243.032 84.0049 243.67 80.4755H240.568C240.19 82.4782 238.424 84.1756 235.591 84.1756C231.985 84.1756 230.337 81.2209 230.337 77.6152H244ZM235.587 69.8244C236.933 69.8142 238.23 70.3473 239.202 71.3107C240.174 72.2741 240.745 73.5918 240.794 74.9838H230.419C230.466 73.5984 231.032 72.2861 231.996 71.3235C232.96 70.361 234.247 69.8236 235.587 69.8244V69.8244Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M345.763 16.0013C343.8 15.9724 341.861 16.4429 340.115 17.3712C338.37 18.2996 336.872 19.6574 335.753 21.3252V16.8886H328V47H335.753V32.2659C335.753 26.6003 338.357 23.2196 342.717 23.2196C346.557 23.2196 349.307 25.8506 349.307 30.2473V47H357V28.5613C357 20.7129 352.418 16.0013 345.763 16.0013Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M269.112 46.9911H260.951V30.2433C260.951 26.1095 258.36 23.2176 254.647 23.2176C250.012 23.2176 247.248 26.5974 247.248 32.2613V46.9911H239V16.8884H247.248V21.3237C248.436 19.6562 250.028 18.2986 251.883 17.3704C253.738 16.4422 255.8 15.972 257.886 16.0013C262.616 16.0013 266.188 18.3654 267.922 22.3527C269.162 20.3908 270.904 18.7746 272.978 17.6616C275.052 16.5485 277.387 15.9765 279.755 16.0013C286.598 16.0013 291 20.9334 291 28.5667V47H282.821V30.2521C282.821 26.1183 280.23 23.2265 276.516 23.2265C271.881 23.2265 269.112 26.6062 269.112 32.2702V46.9911Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M101.119 26.7191L99.3575 26.0158L101.041 25.1577C102.509 24.2939 103.716 23.0713 104.541 21.6124C105.367 20.1536 105.783 18.5099 105.746 16.8463C105.746 11.9541 101.393 7 93.0784 7H73V47H93.1332C106.33 47 106.996 37.9411 106.996 36.1231C107.049 34.1745 106.523 32.2523 105.481 30.5852C104.439 28.918 102.925 27.5761 101.119 26.7191V26.7191ZM81.296 13.5819H91.2303C93.9683 13.5819 96.8933 15.1743 96.8933 18.6687C96.8933 22.0835 94.0458 23.8705 91.2303 23.8705H81.296V13.5819ZM92.5308 40.4225H81.296V30.1295H92.5308C96.2088 30.1295 98.1345 32.7481 98.1345 35.3357C98.1528 38.2817 95.7799 40.4225 92.5308 40.4225Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M141 32.0089C140.824 22.5859 134.343 16 125.226 16C115.987 16 109.001 22.8749 109.001 32.0089C108.947 36.181 110.529 40.2123 113.418 43.2596C116.37 46.3191 120.607 48 125.213 48C129.819 48 134.055 46.3191 137.011 43.2596C138.601 41.6106 139.804 39.6371 140.536 37.4786H133.1C131.572 40.1467 128.687 41.7921 125.249 41.7921C121.292 41.7921 118.096 39.0128 117.213 34.7126L117.001 33.672H141V32.0089ZM117.438 28.1623C117.917 26.4874 118.94 25.0141 120.35 23.9694C121.761 22.9248 123.48 22.3668 125.244 22.3813C128.967 22.3813 131.752 24.547 132.725 28.1623H117.438Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M215 32.0089C214.825 22.5859 208.551 16 199.719 16C190.769 16 184.001 22.8749 184.001 32.0089C183.948 36.181 185.482 40.2123 188.28 43.2596C191.14 46.3191 195.244 48 199.706 48C204.168 48 208.272 46.3191 211.132 43.2596C212.673 41.6104 213.84 39.637 214.55 37.4786H207.346C205.862 40.1467 203.072 41.7921 199.741 41.7921C195.907 41.7921 192.808 39.0128 191.956 34.7126L191.751 33.672H215V32.0089ZM192.17 28.1623C192.634 26.487 193.627 25.0136 194.994 23.969C196.361 22.9244 198.027 22.3666 199.736 22.3813C203.343 22.3813 206.041 24.547 206.98 28.1623H192.17Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M324 32.0089C323.83 22.5859 317.551 16 308.719 16C299.769 16 293.001 22.8749 293.001 32.0089C292.948 36.181 294.482 40.2123 297.28 43.2596C300.144 46.3191 304.266 48 308.71 48C313.155 48 317.272 46.3191 320.136 43.2596C321.676 41.6096 322.843 39.6365 323.555 37.4786H316.346C314.866 40.1467 312.076 41.7921 308.745 41.7921C304.907 41.7921 301.812 39.0128 300.961 34.7126L300.751 33.672H324V32.0089ZM301.175 28.1623C301.638 26.4874 302.629 25.0141 303.996 23.9694C305.362 22.9248 307.028 22.3668 308.736 22.3813C312.343 22.3813 315.045 24.547 315.984 28.1623H301.175Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M237 16.0298C231.916 15.7149 227.594 17.9103 225.394 22.0881V16.899H217V47H225.394V33.9342C225.394 25.9511 231.123 21.8752 237 24.177V16.0298Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M183.037 40.4464C181.855 40.9648 180.578 41.2339 179.286 41.2368C175.726 41.2368 173.754 39.0743 173.754 35.1446V23.098H183.389V16.9436H173.75V4.00444L165.704 6.92618V16.9436H152.046V4L144 6.92174V36.2281C144 43.9277 148.005 47.995 155.571 47.995C158.215 48.0557 160.843 47.5594 163.283 46.5386L161.329 40.4464C160.148 40.9652 158.872 41.2343 157.582 41.2368C154.022 41.2368 152.05 39.0743 152.05 35.1446V23.1024H165.717V36.2148C165.717 43.9143 169.722 47.9817 177.288 47.9817C179.932 48.0423 182.56 47.5461 185 46.5253L183.037 40.4464Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M378.075 40.442C376.91 40.9604 375.651 41.2294 374.378 41.2324C370.871 41.2324 368.928 39.0699 368.928 35.1402V23.0935H378.421V16.9392H368.924V4L361 6.92174V36.2281C361 43.9277 364.946 47.995 372.401 47.995C375.007 48.0557 377.596 47.5594 380 46.5386L378.075 40.442Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React573.createElement(
    "path",
    {
      d: "M32.0011 41.9136L57.4116 51C61.5755 45.7029 64 38.9591 64 31.4374C64 13.5181 50.2449 0 32.0011 0C13.7573 0 0.00215721 13.5138 0.00215721 31.4374C-0.0808318 38.4951 2.23277 45.3786 6.57723 51L32.0011 41.9136Z",
      fill: theme2.colors.bmtGold
    }
  ));
}

// src/components/icons/LogoBAW.tsx
import * as React574 from "react";
var componentNameString568 = "LogoSymbol";
function LogoBAW({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString568,
    ...props
  });
  return /* @__PURE__ */ React574.createElement("svg", { viewBox: "0 0 582 51", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React574.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M345.767 16.0009C343.801 15.9751 341.86 16.4492 340.114 17.3813C338.368 18.3135 336.871 19.6751 335.754 21.3461V16.9096H328V46.9999H335.754V32.2724C335.754 26.6127 338.356 23.2358 342.714 23.2358C346.555 23.2358 349.303 25.8644 349.303 30.2569V46.9999H357V28.5747C357.003 20.7141 352.41 16.0009 345.767 16.0009Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M269.123 46.9779H260.944V30.2366C260.944 26.1024 258.356 23.2162 254.644 23.2162C250.009 23.2162 247.244 26.5928 247.244 32.2518V46.9779H239V16.9001H247.244V21.3456C248.429 19.6746 250.02 18.3129 251.875 17.3808C253.73 16.4487 255.793 15.9748 257.881 16.001C262.609 16.001 266.177 18.3652 267.926 22.3517C269.167 20.3907 270.909 18.7753 272.982 17.6624C275.055 16.5496 277.389 15.9772 279.757 16.001C286.588 16.001 291 20.9338 291 28.5766V46.9999H282.823V30.2586C282.823 26.1244 280.236 23.2383 276.52 23.2383C271.888 23.2383 269.12 26.6148 269.12 32.2739L269.123 46.9779Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M101.135 26.7193L99.3739 26.0135L101.057 25.1539C101.255 25.0535 105.76 22.6443 105.76 16.8471C105.76 11.9534 101.41 7.00006 93.0944 7.00006H73V47.0001H93.1333C106.333 47.0001 107 37.9372 107 36.1209C107.003 29.1567 101.193 26.7475 101.135 26.7193ZM81.3123 13.5815H91.2462C93.9716 13.5815 96.9074 15.172 96.9074 18.6697C96.9074 22.0828 94.059 23.8709 91.2462 23.8709H81.3123V13.5815ZM92.5474 40.4186H81.3123V30.1292H92.5474C96.2277 30.1292 98.1504 32.7455 98.1504 35.3335C98.1504 38.2854 95.794 40.4249 92.5474 40.4249V40.4186Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M141 32.011C140.82 22.5868 134.337 15.9999 125.226 15.9999C115.977 15.9999 109.001 22.8803 109.001 32.0047C108.946 36.1806 110.531 40.2157 113.424 43.2657C116.381 46.324 120.621 47.9999 125.232 47.9999C129.844 47.9999 134.084 46.3177 137.041 43.2657C138.63 41.6079 139.832 39.6267 140.561 37.4616H133.089C131.559 40.1475 128.676 41.7761 125.232 41.7761C121.267 41.7761 118.067 38.9955 117.187 34.6937L116.973 33.6522H141V32.011ZM117.411 28.1637C117.887 26.4845 118.91 25.0064 120.323 23.9575C121.735 22.9086 123.458 22.3471 125.226 22.3595C128.954 22.3595 131.741 24.531 132.714 28.1637H117.411Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M215 32.011C214.826 22.5868 208.546 15.9999 199.721 15.9999C190.759 15.9999 184.001 22.8803 184.001 32.0047C183.95 36.1803 185.485 40.2149 188.285 43.2657C191.15 46.324 195.257 47.9999 199.727 47.9999C204.197 47.9999 208.301 46.3177 211.165 43.2657C212.705 41.6079 213.869 39.6267 214.575 37.4616H207.328C205.846 40.1475 203.05 41.7761 199.718 41.7761C195.877 41.7761 192.777 38.9955 191.925 34.6937L191.717 33.6522H214.991L215 32.011ZM192.148 28.1637C192.61 26.4842 193.601 25.0061 194.97 23.9572C196.338 22.9083 198.008 22.3469 199.721 22.3595C203.332 22.3595 206.032 24.531 206.974 28.1637H192.148Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M324 32.011C323.826 22.5868 317.545 15.9999 308.719 15.9999C299.756 15.9999 293.001 22.8803 293.001 32.0047C292.948 36.18 294.482 40.2145 297.282 43.2657C300.15 46.324 304.258 47.9999 308.725 47.9999C313.192 47.9999 317.3 46.3177 320.165 43.2657C321.704 41.6079 322.868 39.6267 323.575 37.4616H316.327C314.845 40.1475 312.051 41.7761 308.716 41.7761C304.874 41.7761 301.774 38.9955 300.922 34.6937L300.714 33.6522H324V32.011ZM301.148 28.1637C301.609 26.4842 302.6 25.0058 303.968 23.9568C305.337 22.9078 307.006 22.3465 308.719 22.3595C312.33 22.3595 315.031 24.531 315.973 28.1637H301.148Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M237 16.0296C231.913 15.7151 227.588 17.9163 225.399 22.0859V16.9069H217V46.9999H225.399V33.9345C225.399 25.9537 231.135 21.8815 237 24.1676V16.0296Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M183.048 40.456C181.866 40.9746 180.589 41.2439 179.297 41.247C175.729 41.247 173.762 39.0821 173.762 35.1495V23.0962H183.402V16.9482H173.756V4.00315L165.71 6.92427V16.9482H152.045V4L144 6.92115V36.2272C144 43.9287 148 48 155.565 48C158.518 48 161.05 47.5242 163.282 46.5442L161.331 40.4624C160.148 40.9809 158.871 41.2502 157.58 41.2533C154.012 41.2533 152.045 39.0884 152.045 35.1558V23.1056H165.717V36.2272C165.717 43.9287 169.717 48 177.286 48C180.235 48 182.767 47.5242 184.999 46.5442L183.048 40.456Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M378.078 40.4529C376.914 40.9714 375.656 41.2406 374.385 41.2438C370.866 41.2438 368.931 39.079 368.931 35.1463V23.093H378.426V16.9451H368.928V4L361 6.92112V36.2271C361 43.9286 364.942 48 372.4 48C375.309 48 377.804 47.5242 380 46.5442L378.078 40.4529Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M31.5978 41.9115L56.6929 51C60.8027 45.7025 63.1956 38.9575 63.1956 31.4345C63.1956 13.5149 49.6137 0 31.5978 0C13.582 0 0 13.5149 0 31.4345C0 38.9575 2.39609 45.6932 6.50589 51L31.5978 41.9115Z",
      fill: "#FFC729",
      className: "sun"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M403.357 47.5365C400.338 47.5365 397.928 46.7525 396.125 45.1846C394.321 43.6167 393.42 41.5196 393.42 38.8933C393.42 37.4038 393.773 36.0711 394.478 34.8951C395.184 33.68 396.203 32.7 397.536 31.9553C398.672 31.4065 400.005 30.9361 401.534 30.5441C403.063 30.1522 405.023 29.819 407.414 29.5446L412.882 28.8978V28.4274C412.882 25.7228 412.372 23.7825 411.353 22.6065C410.334 21.4306 408.688 20.8426 406.414 20.8426C404.415 20.8426 402.827 21.3522 401.652 22.3713C400.476 23.3905 399.829 24.8212 399.711 26.6635H394.361C394.557 23.6453 395.733 21.2346 397.888 19.4315C400.084 17.6284 402.906 16.7268 406.355 16.7268C410.393 16.7268 413.333 17.7068 415.175 19.6667C417.017 21.5874 417.938 24.684 417.938 28.9566V36.8942C417.938 41.3628 418.271 44.675 418.938 46.8309H413.705C413.47 45.1846 413.313 43.4011 413.235 41.4804C412.568 43.3619 411.353 44.8514 409.589 45.949C407.825 47.0073 405.748 47.5365 403.357 47.5365ZM404.474 43.4207C407.022 43.4207 409.06 42.5779 410.589 40.8924C412.157 39.1677 412.941 36.8746 412.941 34.0132V32.5432L404.944 33.7192C402.788 34.0328 401.201 34.6011 400.182 35.4243C399.202 36.2082 398.712 37.3254 398.712 38.7757C398.712 40.226 399.221 41.3628 400.24 42.1859C401.26 43.0091 402.671 43.4207 404.474 43.4207Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M421.027 17.4324H426.495V9.72998L431.493 7.61329V17.4324H438.842V21.5482H431.493V37.835C431.493 39.5205 431.826 40.7552 432.492 41.5392C433.198 42.2839 434.295 42.6563 435.785 42.6563C436.647 42.6563 437.667 42.5191 438.842 42.2447V46.8309C437.549 47.1837 436.099 47.3601 434.491 47.3601C431.512 47.3601 429.435 46.5565 428.259 44.9494C427.083 43.3423 426.495 41.0296 426.495 38.0114V21.5482H421.027V17.4324Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M450.561 5.08502H456.264L463.496 38.7169C463.653 39.5401 463.771 40.3044 463.849 41.01H464.026C464.065 40.5396 464.221 39.7753 464.496 38.7169L473.08 5.08502H478.725L487.309 38.7169C487.584 39.7753 487.74 40.5396 487.78 41.01H487.956C488.034 40.3044 488.152 39.5401 488.309 38.7169L495.541 5.08502H501.244L491.307 46.8309H484.487L476.373 14.2574C476.177 13.4734 476.059 12.8266 476.02 12.3171H475.785C475.746 12.8266 475.628 13.4734 475.432 14.2574L467.318 46.8309H460.498L450.561 5.08502Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M516.11 47.5365C513.366 47.5365 510.955 46.9289 508.878 45.7138C506.8 44.4594 505.193 42.6759 504.057 40.3632C502.959 38.0506 502.41 35.3067 502.41 32.1317C502.41 28.9566 502.959 26.2128 504.057 23.9001C505.193 21.5874 506.8 19.8235 508.878 18.6083C510.955 17.354 513.366 16.7268 516.11 16.7268C518.854 16.7268 521.265 17.354 523.342 18.6083C525.42 19.8235 527.007 21.5874 528.105 23.9001C529.241 26.2128 529.81 28.9566 529.81 32.1317C529.81 35.3067 529.241 38.0506 528.105 40.3632C527.007 42.6759 525.42 44.4594 523.342 45.7138C521.265 46.9289 518.854 47.5365 516.11 47.5365ZM516.11 43.1855C518.775 43.1855 520.833 42.2447 522.284 40.3632C523.773 38.4817 524.518 35.7379 524.518 32.1317C524.518 28.5254 523.773 25.7816 522.284 23.9001C520.833 22.0186 518.775 21.0778 516.11 21.0778C513.445 21.0778 511.367 22.0186 509.878 23.9001C508.427 25.7816 507.702 28.5254 507.702 32.1317C507.702 35.7379 508.427 38.4817 509.878 40.3632C511.367 42.2447 513.445 43.1855 516.11 43.1855Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M541.197 24.1353C541.941 21.9402 543.078 20.1567 544.607 18.7847C546.175 17.4128 548.017 16.7268 550.134 16.7268C550.604 16.7268 550.957 16.7464 551.192 16.7856V21.6658H550.957C548.174 21.6658 546.018 22.4301 544.489 23.9589C543.235 25.2132 542.431 26.6635 542.079 28.3098C541.726 29.9562 541.549 31.9357 541.549 34.2484V46.8309H536.552V17.4324H541.197V24.1353Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React574.createElement(
    "path",
    {
      d: "M575.574 46.8309L566.696 32.4256L561.345 37.835V46.8309H556.348V4.20306H561.345V31.8965L574.516 17.4324H581.042L570.282 28.7802L581.748 46.8309H575.574Z",
      fill: "#000B50"
    }
  ));
}

// src/components/icons/LogoCustomerService.tsx
import * as React575 from "react";
var componentNameString569 = "LogoCustomerService";
function LogoCustomerService({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString569,
    ...props
  });
  return /* @__PURE__ */ React575.createElement("svg", { viewBox: "0 0 636 136", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React575.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React575.createElement("path", { d: "M452 44c0 11.6 6 18 17.6 18 5 0 9-1 12.4-2.6l-3.5-11c-2.1 1-4 1.6-6 1.6-4.5 0-6.7-2.6-6.7-7.5V26.8h13.7V15.6h-13.7V0L452 4.6V44z" }), /* @__PURE__ */ React575.createElement("path", { d: "M360 34a10 10 0 019.8-7.5c4.5 0 8 2.7 9.3 7.5h-19zm33 5c-.3-14.1-9.8-24-23.2-24A23.4 23.4 0 00346 39c0 13 9.4 24 23.7 24 10.3 0 19.7-6.5 22.4-15.6h-13.3c-2 2.9-5 4.3-9 4.3-5 0-8.8-3.5-10-9.1H393V39z" }), /* @__PURE__ */ React575.createElement("path", { d: "M430.3 62H444V34c0-5.6-1.7-10.4-4.8-13.8a16 16 0 00-12.3-5.2c-5.5 0-10.6 2.2-14 6v-4.6H399V62h13.8V40.8c0-8.3 3.4-13 9.6-13 4.7 0 7.9 3.8 7.9 9.3V62z" }), /* @__PURE__ */ React575.createElement("path", { d: "M326.1 62H340V34.3c0-11.8-6.8-19.3-17-19.3a19 19 0 00-16 7.9c-3-5-8.2-7.9-14.6-7.9-5.6 0-10.1 1.9-13.4 5.8v-4.4h-14V62h14V39.6c0-7.4 3-11.7 8.7-11.7 5.1 0 7.8 3 7.8 8.6V62h14V39.6c0-7.4 3.3-11.7 9-11.7 4.7 0 7.6 3.8 7.6 8.8V62z" }), /* @__PURE__ */ React575.createElement("path", { d: "M228 61h13.7V46.6c0-12.7 5.6-17.8 14.6-17.8 2.3 0 3.7.3 3.7.3V15.3a12 12 0 00-3-.3c-6.7 0-11.7 3.3-15.3 9.7v-9H228V61z" }), /* @__PURE__ */ React575.createElement("path", { d: "M188 34a10 10 0 019.8-7.5c4.5 0 8 2.7 9.3 7.5h-19zm33 5c-.3-14.1-9.8-24-23.2-24A23.4 23.4 0 00174 39c0 13 9.4 24 23.7 24 10.3 0 19.7-6.5 22.4-15.6h-13.3c-2 2.9-5 4.3-9 4.3-5 0-8.8-3.5-10-9.1H221V39z" }), /* @__PURE__ */ React575.createElement("path", { d: "M122.8 26.8h19.3V44c0 11.5 6 17.9 17.5 17.9 5 0 9-1 12.4-2.6l-3.5-11c-2.1 1-4 1.6-6 1.6-4.4 0-6.6-2.6-6.6-7.5V26.8h13.6V15.6h-13.6V0L142 4.6v11h-19.3V0L109 4.6V44c0 11.5 6 17.9 17.5 17.9 5 0 9-1 12.4-2.6l-3.5-11c-2.1 1-4 1.6-6 1.6-4.4 0-6.6-2.6-6.6-7.5V26.8z" }), /* @__PURE__ */ React575.createElement("path", { d: "M70 34a10 10 0 019.8-7.5c4.5 0 8 2.7 9.3 7.5H70zm33 5c-.3-14.1-9.8-24-23.2-24A23.4 23.4 0 0056 39c0 13 9.4 24 23.7 24 10.3 0 19.7-6.5 22.4-15.6H88.8c-2 2.9-5 4.3-9 4.3-5 0-8.8-3.5-10-9.1H103V39z" }), /* @__PURE__ */ React575.createElement("path", { d: "M30.6 50H16V37.8h14.5c3.2 0 6.5 2.2 6.5 6.3 0 3.6-2.7 6-6.5 6zM16 14h12.6c4.6 0 6.7 3 6.7 6 0 4.3-3.5 6.3-6.7 6.3H16.1V13.9zm27 16.4s7.2-3.8 7.2-13C50.3 10.1 44 2 31.3 2H2v60h29.4C47.5 62 52 52 52 45.1c0-11-9-14.7-9-14.7z" }), /* @__PURE__ */ React575.createElement("path", { d: "M9.2 130.8c-3.1-2.1-5.4-5-7-8.6A31.8 31.8 0 010 109.9c0-4.8.8-9 2.4-12.5 1.6-3.6 4-6.4 7-8.4 3.2-2 7-3 11.5-3 5.3 0 9.6 1.4 12.6 4.3s4.9 6.8 5.5 11.8l-6.3.6a14 14 0 00-3.8-8.4c-2-2-4.9-3-8.4-3-4.4 0-7.9 1.6-10.3 5a22.4 22.4 0 00-3.7 13.5c0 3.6.5 6.9 1.6 9.7a14 14 0 004.8 6.7c2.1 1.6 4.7 2.4 7.8 2.4 3.2 0 5.9-1 8.1-3 2.2-2 3.6-4.7 4.3-8.1l5.9 1c-1 4.7-3 8.4-6 11.2a17 17 0 01-12.3 4.3c-4.6 0-8.4-1-11.5-3.2" }), /* @__PURE__ */ React575.createElement("path", { d: "M48.6 130.8a14.4 14.4 0 01-2.6-9.2V101h5.4v20c0 2.6.6 4.7 1.7 6.1a5.8 5.8 0 004.9 2.2c2.5 0 4.6-1 6.2-3 1.6-2 2.4-4.7 2.4-8V101H72v32.2h-5.1v-6c-.7 2-2 3.6-3.9 4.9a10 10 0 01-6 1.9c-3.9 0-6.7-1-8.4-3.2" }), /* @__PURE__ */ React575.createElement("path", { d: "M84.4 131.2a12 12 0 01-4.4-8l5.5-1a8.7 8.7 0 002.8 5.4 8.6 8.6 0 005.7 1.9 8 8 0 004.9-1.3c1.1-.9 1.7-2 1.7-3.6s-.4-2.8-1.2-3.6a6.7 6.7 0 00-3.9-1.5l-5.1-.6a11 11 0 01-7-3 8.8 8.8 0 01-2.3-6.3c0-3 1-5.3 3.2-7a14 14 0 018.9-2.6c3.6 0 6.5.9 8.8 2.7 2.3 1.8 3.7 4.2 4 7.2l-5.3 1.2c-.4-2-1.3-3.6-2.6-4.8a7.3 7.3 0 00-5-1.8c-2.2 0-3.8.4-5 1.2-1.2.9-1.7 2-1.7 3.6 0 2.9 1.9 4.5 5.7 5l5 .6c6 .6 8.8 3.7 8.8 9.2a9 9 0 01-3.2 7.3 13.8 13.8 0 01-9 2.6c-3.8 0-6.9-1-9.3-2.8" }), /* @__PURE__ */ React575.createElement("path", { d: "M110 99.6h5.8v-8.3l5.4-2.3v10.6h7.8v4.5h-7.8v17.6c0 1.8.3 3.1 1 4 .8.8 2 1.2 3.5 1.2 1 0 2-.1 3.3-.4v5c-1.4.3-3 .5-4.6.5-3.2 0-5.4-.9-6.7-2.6a12.7 12.7 0 01-1.9-7.5V104H110v-4.5z" }), /* @__PURE__ */ React575.createElement("path", { d: "M154.8 126c1.6-2 2.4-5 2.4-9s-.8-7-2.4-9a8.1 8.1 0 00-6.8-3.2 8 8 0 00-6.8 3.1c-1.6 2-2.4 5.1-2.4 9.1s.8 7 2.4 9a8 8 0 006.8 3.2c3 0 5.2-1 6.8-3.1M140 132c-2.3-1.4-4-3.4-5.3-6a20.8 20.8 0 01-1.8-9c0-3.5.6-6.5 1.8-9 1.3-2.6 3-4.6 5.3-6 2.3-1.3 4.9-2 7.9-2s5.6.7 8 2a14 14 0 015.2 6c1.2 2.5 1.8 5.5 1.8 9s-.6 6.5-1.8 9c-1.3 2.6-3 4.6-5.3 6a15 15 0 01-7.9 2c-3 0-5.6-.7-8-2" }), /* @__PURE__ */ React575.createElement("path", { d: "M177.1 100.9v5.6c1.8-4.3 5-6.5 9.2-6.5 2.3 0 4.2.6 5.7 1.7a9.5 9.5 0 013.5 4.8c2.1-4.3 5.4-6.5 9.7-6.5 3.1 0 5.5 1 7.2 3.1 1.7 2.1 2.6 5 2.6 8.8V133h-5.5v-20.6c0-5-2-7.6-6-7.6-2.3 0-4.1.8-5.4 2.4a10.7 10.7 0 00-1.9 6.8v19h-5.4v-20.9c0-2.3-.6-4.1-1.6-5.4a5.5 5.5 0 00-4.5-1.9c-2.2 0-4 .9-5.3 2.5a11 11 0 00-2 7V133H172v-32.1h5.1z" }), /* @__PURE__ */ React575.createElement("path", { d: "M245.3 113.4c0-3-.7-5.2-2.2-6.7-1.4-1.6-3.5-2.4-6.3-2.4s-5 1-6.7 2.6a10.7 10.7 0 00-2.5 7.2h17.7v-.7zm5.7 5.2h-23.4c0 3.2 1 5.7 2.7 7.6 1.8 2 4.2 3 7.1 3a9 9 0 005.4-1.7c1.5-1 2.6-2.5 3.4-4.5l4.6 2a13.6 13.6 0 01-13.8 9c-4.7 0-8.4-1.4-11-4.3-2.7-2.9-4-7-4-12.3a19 19 0 014-12.8c2.6-3 6.3-4.6 11-4.6 4.4 0 7.9 1.3 10.3 3.8 2.5 2.5 3.7 6.1 3.7 11v3.8z" }), /* @__PURE__ */ React575.createElement("path", { d: "M266.8 102.3a8.7 8.7 0 017.2-2.2v5.3h-.3c-3 0-5.4.9-7 2.5a9.5 9.5 0 00-2.7 4.8 40 40 0 00-.5 6.5V133H258v-32.2h5v7.3a14 14 0 013.8-5.8" }), /* @__PURE__ */ React575.createElement("path", { d: "M299.3 130a15.2 15.2 0 01-5.3-10.7l6.2-1c.4 3.2 1.7 5.7 3.7 7.7s4.9 3 8.6 3c2.9 0 5.3-.7 7.2-2 2-1.3 3-3.2 3-5.9 0-2.5-.7-4.4-2.1-5.6a15 15 0 00-6.6-2.7l-6.6-1.3c-7.7-1.6-11.5-5.8-11.5-12.7a12 12 0 017.5-11.2c2.4-1 5.2-1.6 8.4-1.6 4.8 0 8.7 1.1 11.7 3.3a13 13 0 015.2 9.7l-6 1.3c-.9-6.3-4.5-9.5-11-9.5a11 11 0 00-6.9 2 6.5 6.5 0 00-2.6 5.5c0 2.2.6 3.9 1.8 5.1 1.2 1.3 3.1 2.2 5.7 2.7l6.7 1.5c4 .8 7 2.2 9.3 4.1 2.2 2 3.3 5 3.3 8.8a13 13 0 01-1.8 6.8c-1.3 2-3.1 3.6-5.6 4.9a21 21 0 01-9.3 1.8c-5.5 0-9.9-1.3-13-4" }), /* @__PURE__ */ React575.createElement("path", { d: "M357.3 113.4c0-3-.7-5.2-2.2-6.7-1.5-1.6-3.5-2.4-6.3-2.4s-5 1-6.7 2.6a10.6 10.6 0 00-2.5 7.2h17.7v-.7zm5.7 5.2h-23.4c0 3.2 1 5.7 2.7 7.6 1.8 2 4.2 3 7.1 3a9 9 0 005.4-1.7c1.5-1 2.6-2.5 3.4-4.5l4.6 2c-1.1 3-2.9 5.2-5.2 6.7a15.3 15.3 0 01-8.6 2.3c-4.7 0-8.4-1.4-11-4.3-2.7-2.9-4-7-4-12.3a19 19 0 014-12.8c2.6-3 6.3-4.6 11-4.6 4.4 0 7.9 1.3 10.3 3.8 2.5 2.5 3.7 6.1 3.7 11v3.8z" }), /* @__PURE__ */ React575.createElement("path", { d: "M379.8 102.3a8.8 8.8 0 017.2-2.2v5.3h-.3c-3 0-5.4.9-7 2.5a9.4 9.4 0 00-2.7 4.8 40 40 0 00-.5 6.5V133H371v-32.2h5v7.3a14 14 0 013.8-5.8" }), /* @__PURE__ */ React575.createElement("path", { d: "M391 101h5.9l7.2 21.6c.5 1.6 1 3.3 1.3 4.8h.2c.3-1.5.8-3.2 1.3-4.8l7.2-21.6h5.9l-11.6 32h-5.8L391 101z" }), /* @__PURE__ */ React575.createElement("path", { d: "M425.4 134h5.2v-32.9h-5.2V134zm-.4-39h6v-7h-6v7z" }), /* @__PURE__ */ React575.createElement("path", { d: "M446.3 132a14.3 14.3 0 01-5.4-6 20.1 20.1 0 01-1.9-9 18 18 0 014-12.5c2.8-3 6.6-4.5 11.3-4.5 3.9 0 7 1 9.4 3.1 2.4 2 3.9 5 4.3 8.7l-5.8.7a9 9 0 00-2.5-5.7 7.7 7.7 0 00-5.5-2 8 8 0 00-6.8 3.2 14.5 14.5 0 00-2.4 9c0 3.8.8 6.8 2.4 9 1.7 2.1 4 3.2 7 3.2 2.2 0 4-.7 5.4-2a10 10 0 002.7-5.7l5.4.8a14 14 0 01-4.5 8.7c-2.3 2-5.4 3-9.1 3-3 0-5.7-.7-8-2" }), /* @__PURE__ */ React575.createElement("path", { d: "M496.3 113.4c0-3-.7-5.2-2.2-6.7-1.4-1.6-3.5-2.4-6.3-2.4s-5 1-6.7 2.6a10.7 10.7 0 00-2.5 7.2h17.7v-.7zm5.7 5.2h-23.4c0 3.2 1 5.7 2.7 7.6 1.8 2 4.2 3 7.1 3a9 9 0 005.4-1.7c1.5-1 2.6-2.5 3.4-4.5l4.6 2a13.6 13.6 0 01-13.8 9c-4.7 0-8.4-1.4-11-4.3-2.7-2.9-4-7-4-12.3a19 19 0 014-12.8c2.6-3 6.3-4.6 11-4.6 4.4 0 7.9 1.3 10.3 3.8 2.5 2.5 3.7 6.1 3.7 11v3.8z" }), /* @__PURE__ */ React575.createElement("polygon", { points: "555 87 555 92.183 540.984 92.183 540.984 133 535.013 133 535.013 92.183 521 92.183 521 87" }), /* @__PURE__ */ React575.createElement("path", { d: "M576.8 126c1.6-2 2.4-5 2.4-9s-.8-7-2.4-9a8.1 8.1 0 00-6.8-3.2c-3 0-5.2 1-6.8 3.1-1.6 2-2.4 5.1-2.4 9.1s.8 7 2.4 9a7.9 7.9 0 006.8 3.2c3 0 5.2-1 6.8-3.1M562 132c-2.3-1.4-4-3.4-5.3-6a20.9 20.9 0 01-1.8-9c0-3.5.6-6.5 1.8-9 1.3-2.6 3-4.6 5.3-6 2.3-1.3 4.9-2 7.9-2s5.6.7 8 2a14 14 0 015.2 6c1.2 2.5 1.8 5.5 1.8 9s-.6 6.5-1.8 9c-1.3 2.6-3 4.6-5.3 6a15 15 0 01-7.9 2c-3 0-5.6-.7-8-2" }), /* @__PURE__ */ React575.createElement("path", { d: "M611.8 126c1.6-2 2.4-5 2.4-9s-.8-7-2.4-9a8.1 8.1 0 00-6.8-3.2 8 8 0 00-6.8 3.1c-1.6 2-2.4 5.1-2.4 9.1s.8 7 2.4 9a8 8 0 006.8 3.2c3 0 5.2-1 6.8-3.1M597 132c-2.3-1.4-4-3.4-5.3-6a20.8 20.8 0 01-1.8-9c0-3.5.6-6.5 1.8-9 1.3-2.6 3-4.6 5.3-6 2.3-1.3 4.9-2 7.9-2s5.6.7 8 2a14 14 0 015.2 6c1.2 2.5 1.8 5.5 1.8 9s-.6 6.5-1.8 9c-1.3 2.6-3 4.6-5.3 6a15 15 0 01-7.9 2c-3 0-5.6-.7-8-2" }), /* @__PURE__ */ React575.createElement("polygon", { points: "629 133 635 133 635 86 629 86" }));
}

// src/components/icons/LogoRetail.tsx
import * as React576 from "react";
var componentNameString570 = "LogoRetail";
function LogoRetail({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString570,
    ...props
  });
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ React576.createElement("svg", { viewBox: "0 0 380 51", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React576.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M345.767 16.001C343.802 15.9752 341.861 16.4493 340.114 17.3814C338.368 18.3135 336.871 19.6751 335.754 21.3462V16.9097H328V47H335.754V32.2724C335.754 26.6128 338.356 23.2359 342.715 23.2359C346.555 23.2359 349.303 25.8645 349.303 30.2569V47H357V28.5748C357.003 20.7142 352.411 16.001 345.767 16.001Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M269.124 46.978H260.944V30.2367C260.944 26.1024 258.357 23.2163 254.644 23.2163C250.009 23.2163 247.244 26.5928 247.244 32.2519V46.978H239V16.9002H247.244V21.3457C248.43 19.6746 250.02 18.313 251.876 17.3809C253.731 16.4488 255.793 15.9749 257.881 16.001C262.61 16.001 266.177 18.3652 267.927 22.3517C269.168 20.3908 270.909 18.7753 272.982 17.6625C275.056 16.5496 277.39 15.9773 279.758 16.001C286.589 16.001 291 20.9338 291 28.5767V47H282.824V30.2587C282.824 26.1244 280.236 23.2383 276.52 23.2383C271.889 23.2383 269.12 26.6149 269.12 32.2739L269.124 46.978Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M101.135 26.7192L99.374 26.0134L101.057 25.1539C101.255 25.0535 105.76 22.6443 105.76 16.8471C105.76 11.9533 101.41 7 93.0944 7H73V47H93.1333C106.333 47 107 37.9372 107 36.1208C107.003 29.1567 101.193 26.7475 101.135 26.7192ZM81.3123 13.5814H91.2462C93.9716 13.5814 96.9074 15.1719 96.9074 18.6697C96.9074 22.0827 94.059 23.8708 91.2462 23.8708H81.3123V13.5814ZM92.5474 40.4186H81.3123V30.1292H92.5474C96.2277 30.1292 98.1504 32.7454 98.1504 35.3334C98.1504 38.2854 95.794 40.4248 92.5474 40.4248V40.4186Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M141 32.011C140.821 22.5868 134.337 16 125.226 16C115.978 16 109.001 22.8803 109.001 32.0047C108.947 36.1807 110.531 40.2158 113.424 43.2658C116.381 46.3241 120.621 48 125.233 48C129.844 48 134.084 46.3178 137.041 43.2658C138.631 41.6079 139.832 39.6268 140.562 37.4617H133.089C131.559 40.1475 128.676 41.7761 125.233 41.7761C121.268 41.7761 118.067 38.9956 117.187 34.6937L116.973 33.6522H141V32.011ZM117.411 28.1637C117.888 26.4845 118.911 25.0065 120.323 23.9576C121.735 22.9086 123.458 22.3471 125.226 22.3596C128.955 22.3596 131.742 24.531 132.715 28.1637H117.411Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M215 32.011C214.826 22.5868 208.546 16 199.721 16C190.759 16 184.001 22.8803 184.001 32.0047C183.95 36.1804 185.485 40.2149 188.285 43.2658C191.15 46.3241 195.257 48 199.727 48C204.197 48 208.301 46.3178 211.165 43.2658C212.705 41.6079 213.869 39.6268 214.575 37.4617H207.328C205.846 40.1475 203.05 41.7761 199.718 41.7761C195.877 41.7761 192.777 38.9956 191.925 34.6937L191.717 33.6522H214.991L215 32.011ZM192.148 28.1637C192.61 26.4843 193.601 25.0061 194.97 23.9572C196.338 22.9084 198.008 22.347 199.721 22.3596C203.332 22.3596 206.032 24.531 206.974 28.1637H192.148Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M324 32.011C323.826 22.5868 317.545 16 308.719 16C299.757 16 293.001 22.8803 293.001 32.0047C292.949 36.18 294.483 40.2146 297.283 43.2658C300.15 46.3241 304.258 48 308.725 48C313.193 48 317.301 46.3178 320.165 43.2658C321.705 41.6079 322.869 39.6268 323.575 37.4617H316.327C314.845 40.1475 312.052 41.7761 308.716 41.7761C304.875 41.7761 301.775 38.9956 300.922 34.6937L300.715 33.6522H324V32.011ZM301.149 28.1637C301.609 26.4843 302.6 25.0059 303.969 23.9569C305.337 22.9079 307.006 22.3466 308.719 22.3596C312.331 22.3596 315.031 24.531 315.974 28.1637H301.149Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M237 16.0296C231.913 15.7152 227.588 17.9163 225.4 22.086V16.9069H217V47H225.4V33.9345C225.4 25.9537 231.135 21.8816 237 24.1676V16.0296Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M183.049 40.456C181.866 40.9746 180.589 41.2439 179.298 41.247C175.73 41.247 173.762 39.0821 173.762 35.1495V23.0962H183.402V16.9482H173.756V4.00315L165.711 6.92427V16.9482H152.045V4L144 6.92115V36.2272C144 43.9287 148.001 48 155.566 48C158.518 48 161.05 47.5242 163.283 46.5442L161.331 40.4624C160.149 40.9809 158.872 41.2502 157.58 41.2533C154.012 41.2533 152.045 39.0884 152.045 35.1558V23.1056H165.717V36.2272C165.717 43.9287 169.718 48 177.286 48C180.235 48 182.768 47.5242 185 46.5442L183.049 40.456Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M378.077 40.4529C376.913 40.9714 375.656 41.2406 374.384 41.2438C370.866 41.2438 368.93 39.079 368.93 35.1463V23.093H378.426V16.9451H368.927V4L361 6.92112V36.2271C361 43.9286 364.942 48 372.399 48C375.308 48 377.804 47.5242 380 46.5442L378.077 40.4529Z",
      fill: theme2.colors.bmtNavy
    }
  ), /* @__PURE__ */ React576.createElement(
    "path",
    {
      d: "M32 41.9115L57.4145 51C61.5766 45.7025 64 38.9575 64 31.4345C64 13.5149 50.2451 0 32 0C13.7549 0 0 13.5149 0 31.4345C0 38.9575 2.42659 45.6932 6.5887 51L32 41.9115Z",
      fill: theme2.colors.bmtGold
    }
  ));
}

// src/components/icons/LogoSecurities.tsx
import * as React577 from "react";
var componentNameString571 = "LogoSecurities";
function LogoSecurities({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString571,
    ...props
  });
  return /* @__PURE__ */ React577.createElement("svg", { viewBox: "0 0 482 136", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React577.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React577.createElement("path", { d: "M451.7 44.7c0 11.6 6.1 18 17.7 18 5 0 9-1 12.5-2.7l-3.5-11a13 13 0 01-6.1 1.6c-4.4 0-6.6-2.6-6.6-7.4V27.3h13.7V16.1h-13.8V.4L451.7 5v39.7z" }), /* @__PURE__ */ React577.createElement("path", { d: "M360 33.6a10 10 0 019.8-7.4c4.5 0 8 2.6 9.3 7.4H360zm33.1 5c-.2-14-9.8-24-23.3-24-13.7 0-24 10.4-24 24 0 13 9.5 24 23.9 24 10.4 0 19.8-6.5 22.6-15.5h-13.5c-2 2.8-5 4.2-9.1 4.2-5 0-8.9-3.4-10-9h33.4v-3.6z" }), /* @__PURE__ */ React577.createElement("path", { d: "M430.6 61.3h13.8V33.5c0-5.6-1.7-10.3-4.8-13.7a16.2 16.2 0 00-12.4-5.1 19 19 0 00-14.1 6V16h-14v45.3h14v-21c0-8.3 3.4-12.8 9.5-12.8 4.8 0 8 3.6 8 9v24.8z" }), /* @__PURE__ */ React577.createElement("path", { d: "M326.2 61.3H340V34c0-11.8-6.8-19.2-16.9-19.2-6.7 0-12.2 2.7-16 7.8-3-5-8.1-7.8-14.5-7.8-5.6 0-10 1.9-13.3 5.7V16h-14v45.3h14V39.1c0-7.4 3-11.6 8.6-11.6 5.2 0 7.8 3 7.8 8.5v25.3h14V39.1c0-7.4 3.2-11.6 9-11.6 4.5 0 7.5 3.7 7.5 8.8v25z" }), /* @__PURE__ */ React577.createElement("path", { d: "M227.6 61.3h13.9V47c0-12.6 5.7-17.7 14.8-17.7 2.3 0 3.8.3 3.8.3V15.8c-1-.3-1.9-.4-3.2-.4-6.7 0-11.7 3.3-15.4 9.7v-9h-14v45.2z" }), /* @__PURE__ */ React577.createElement("path", { d: "M188.4 33.6a10 10 0 019.8-7.4c4.6 0 8.1 2.6 9.3 7.4h-19.1zm33.2 5c-.3-14-10-24-23.4-24-13.7 0-24 10.4-24 24 0 13 9.5 24 24 24 10.3 0 19.8-6.5 22.5-15.5h-13.5c-2 2.8-5 4.2-9 4.2-5 0-9-3.4-10-9h33.4v-3.6z" }), /* @__PURE__ */ React577.createElement("path", { d: "M123.3 27.3h19.4v17.4c0 11.6 6 18 17.7 18 5 0 9-1 12.5-2.7l-3.6-11a13 13 0 01-6 1.6c-4.5 0-6.7-2.6-6.7-7.4V27.3h13.7V16.1h-13.7V.4L142.7 5v11h-19.4V.6L109.4 5v39.7c0 11.6 6 18 17.7 18 5 0 9-1 12.5-2.7L136 49a13 13 0 01-6 1.6c-4.5 0-6.7-2.6-6.7-7.4V27.3z" }), /* @__PURE__ */ React577.createElement("path", { d: "M70.5 33.6a10 10 0 019.8-7.4c4.5 0 8.1 2.6 9.3 7.4H70.5zm33.1 5c-.2-14-9.8-24-23.3-24-13.7 0-24 10.4-24 24 0 13 9.5 24 23.9 24 10.4 0 19.8-6.5 22.6-15.5H89.3c-2 2.8-5 4.2-9.1 4.2-5 0-8.9-3.4-10-9h33.4v-3.6z" }), /* @__PURE__ */ React577.createElement("path", { d: "M30.3 49.5H16V37.3h14.3c3.3 0 6.6 2.1 6.6 6.2 0 3.5-2.7 6-6.6 6zM16 13.6h12.5c4.6 0 6.6 3 6.6 6 0 4.3-3.4 6.3-6.6 6.3H16V13.6zM42.7 30S50 26.2 50 17c0-7.2-6.3-15.3-18.8-15.3H2v59.7h29.2c16 0 20.4-10 20.4-16.8 0-10.9-8.9-14.6-8.9-14.6z" }), /* @__PURE__ */ React577.createElement("path", { d: "M0 120.1l6.4-.9c.8 5.8 4.4 10.9 12.7 10.9 5 0 10.4-2.2 10.4-8.1 0-5.6-3.4-7.4-9-8.5l-6.7-1.4C7 110.7 2 107.2 2 99.1 2 91.4 8.3 86 18.3 86c9.4 0 16.5 4.2 17.4 13.4l-6.3 1.3c-.8-6.3-4.3-9.7-11.2-9.7-5.8 0-9.7 2.8-9.7 7.6 0 4.5 2.4 7 7.6 8l7 1.5c7.2 1.5 12.9 4.8 12.9 13.3 0 7.3-5.4 13.8-17.1 13.8-12 0-18.1-6.5-18.9-15" }), /* @__PURE__ */ React577.createElement("path", { d: "M64.6 113.8c0-6.1-3.1-9.3-8.5-9.3-5.9 0-9.2 3.8-9.3 10h17.8v-.7zm5.7 5.2H46.8c0 6.5 4 10.8 9.8 10.8 4.3 0 7.4-2.3 8.8-6.3l4.7 2c-2.3 6-7.2 9.2-13.8 9.2-9.5 0-15.1-6-15.1-17s5.5-17.6 15-17.6c9 0 14 5 14 15v4z" }), /* @__PURE__ */ React577.createElement("path", { d: "M76.3 117.4c0-10.8 5.8-17.3 15.2-17.3 7.8 0 12.8 4.4 13.7 12l-5.8.7c-.6-5-3.5-7.8-8-7.8-5.7 0-9.1 4.6-9.1 12.3 0 8 3.4 12.5 9.3 12.5 4.5 0 7.3-2.7 8.1-7.8l5.4.8c-1.2 7.6-6.2 12-13.6 12-9.2 0-15.2-6.8-15.2-17.4" }), /* @__PURE__ */ React577.createElement("path", { d: "M112.4 122.3v-21.1h5.7v20.4c0 5.6 2.4 8.6 6.7 8.6 5.3 0 8.9-4.5 8.9-11.2v-17.8h5.6v33H134v-6.1a11 11 0 01-10.2 7c-8.4 0-11.4-5-11.4-12.8" }), /* @__PURE__ */ React577.createElement("path", { d: "M166.9 100.4h1.2v5.6h-.3c-3.4 0-5.7 1-7.3 2.5-3.1 3.2-3.3 7.6-3.3 11.6v14.2h-5.6v-33.1h5.2v7.5c1.6-4.6 5-8.3 10-8.3" }), /* @__PURE__ */ React577.createElement("path", { d: "M174 134.3h5.7v-33h-5.6v33zm-.3-39.2h6.4v-7h-6.4v7z" }), /* @__PURE__ */ React577.createElement("path", { d: "M186.7 101h6.2v-8.6l5.6-2.4v11h8.3v4.7h-8.3V124c0 3.8 1.5 5.5 4.9 5.5 1.4 0 2.3-.2 3.4-.5v5.1a17 17 0 01-5 .6c-7 0-8.9-4.3-8.9-10.5v-18.5h-6.2v-4.6z" }), /* @__PURE__ */ React577.createElement("path", { d: "M215.3 134.3h5.6v-33h-5.6v33zm-.4-39.2h6.4v-7h-6.4v7z" }), /* @__PURE__ */ React577.createElement("path", { d: "M252.3 113.8c0-6.1-3-9.3-8.5-9.3-5.8 0-9.1 3.8-9.3 10h17.8v-.7zm5.7 5.2h-23.5c.1 6.5 4 10.8 9.9 10.8a9 9 0 008.8-6.3l4.6 2c-2.3 6-7.1 9.2-13.8 9.2-9.5 0-15-6-15-17s5.5-17.6 15-17.6c8.9 0 14 5 14 15v4z" }), /* @__PURE__ */ React577.createElement("path", { d: "M264 123.7l5.7-1c.9 4.9 4 7.4 9 7.4 4.3 0 6.8-1.9 6.8-5 0-3.3-1.7-4.7-5.3-5.1l-5.4-.6c-6.5-.7-9.6-4.5-9.6-9.6 0-6 4.7-9.7 12.5-9.7 7.6 0 12.7 4 13.4 10l-5.5 1.3c-.8-4-3.5-6.8-8-6.8-4.4 0-7 1.8-7 5 0 2.8 2 4.6 6 5l5.3.6c6.6.7 9.1 4.2 9.1 9.4 0 6.3-4.6 10.1-12.7 10.1-7.8 0-13-3.9-14.2-11" }));
}

// src/components/icons/LogoSymbol.tsx
import * as React578 from "react";
var componentNameString572 = "LogoSymbol";
function LogoSymbol({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString572,
    ...props
  });
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ React578.createElement("svg", { viewBox: "0 0 83 68", fill: "none", "aria-labelledby": titleId, xmlns: "http://www.w3.org/2000/svg", ...props }, title ? /* @__PURE__ */ React578.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React578.createElement(
    "path",
    {
      d: "M41.5 55.8821L74.4594 68C79.8571 60.9367 83 51.9434 83 41.9126C83 18.0198 65.1617 0 41.5 0C17.8383 0 0 18.0198 0 41.9126C0 51.9434 3.14698 60.9243 8.54472 68L41.5 55.8821Z",
      fill: theme2.colors.bmtGold
    }
  ));
}

// src/components/icons/UiArrowCircleV2.tsx
import * as React579 from "react";
var componentNameString573 = "UiArrowCircleV2";
function UiArrowCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString573,
    ...props
  });
  return /* @__PURE__ */ React579.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React579.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React579.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 6a6 6 0 016 6v4.2l-1.7-1.7-1 1 3.4 3.6 3.6-3.6-1-1-1.8 1.7V12c0-4.1-3.4-7.5-7.5-7.5V6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React579.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18a6 6 0 01-6-6V7.8l1.7 1.7 1-1-3.4-3.6-3.6 3.6 1 1 1.8-1.7V12c0 4.1 3.4 7.5 7.5 7.5V18z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiArrowTrending.tsx
import * as React580 from "react";
var componentNameString574 = "UiArrowTrending";
function UiArrowTrending({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString574,
    ...props
  });
  return /* @__PURE__ */ React580.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React580.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React580.createElement("g", { clipPath: "url(#ui--arrow-trending_svg__ui--arrow-trending_svg__clip0)" }, /* @__PURE__ */ React580.createElement("path", { d: "M17 2.4L10 5l2 1.6L9.7 10 4.5 6 0 11.6l1.8 1.5 3-3.9 5.2 4 4-5 2 1.6 1-7.4z" })), /* @__PURE__ */ React580.createElement("defs", null, /* @__PURE__ */ React580.createElement("clipPath", { id: "ui--arrow-trending_svg__ui--arrow-trending_svg__clip0" }, /* @__PURE__ */ React580.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiBackV2.tsx
import * as React581 from "react";
var componentNameString575 = "UiBackV2";
function UiBackV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString575,
    ...props
  });
  return /* @__PURE__ */ React581.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React581.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React581.createElement("path", { fillRule: "evenodd", d: "M4.8 12.7l5.5 5.5-1 1L1.8 12l7.3-7.3 1 1-5.4 5.5h17.7v1.5H4.8z", clipRule: "evenodd" }));
}

// src/components/icons/UiBalanceV2.tsx
import * as React582 from "react";
var componentNameString576 = "UiBalanceV2";
function UiBalanceV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString576,
    ...props
  });
  return /* @__PURE__ */ React582.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React582.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React582.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M9.8 6.8a2.3 2.3 0 114.5 0 2.3 2.3 0 01-4.6 0zM12 3a3.7 3.7 0 100 7.5A3.7 3.7 0 0012 3zm10.5 9v1.5h-21V12h21zM12 15l3.6 6H8.4l3.6-6zm-1 4.5h2L12 18l-1 1.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiBankV2.tsx
import * as React583 from "react";
var componentNameString577 = "UiBankV2";
function UiBankV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString577,
    ...props
  });
  return /* @__PURE__ */ React583.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React583.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React583.createElement("path", { fillRule: "evenodd", d: "M12 3l9.3 4.6-.6 1.3L12 4.6 3.3 8.9l-.6-1.3L12 2.9z", clipRule: "evenodd" }), /* @__PURE__ */ React583.createElement("path", { fillRule: "evenodd", d: "M4.5 18V9.7H6V18H4.5z", clipRule: "evenodd" }), /* @__PURE__ */ React583.createElement("path", { fillRule: "evenodd", d: "M9 18V9.7h1.5V18H9z", clipRule: "evenodd" }), /* @__PURE__ */ React583.createElement("path", { fillRule: "evenodd", d: "M13.5 18V9.7H15V18h-1.5z", clipRule: "evenodd" }), /* @__PURE__ */ React583.createElement("path", { fillRule: "evenodd", d: "M18 18V9.7h1.5V18H18z", clipRule: "evenodd" }), /* @__PURE__ */ React583.createElement("path", { fillRule: "evenodd", d: "M3 19.5h18V21H3v-1.5z", clipRule: "evenodd" }));
}

// src/components/icons/UiBank.tsx
import * as React584 from "react";
var componentNameString578 = "UiBank";
function UiBank({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString578,
    ...props
  });
  return /* @__PURE__ */ React584.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React584.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React584.createElement("path", { d: "M5 16V6h2v10H5zm-4 0V6h2v10H1zm8 0V6h2v10H9zm4 0V6h2v10h-2zM8 0l8 3v1H0V3l8-3z" }));
}

// src/components/icons/UiBoatV2.tsx
import * as React585 from "react";
var componentNameString579 = "UiBoatV2";
function UiBoatV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString579,
    ...props
  });
  return /* @__PURE__ */ React585.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React585.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React585.createElement("path", { fillRule: "evenodd", d: "M12.8 3.2L2.8 15h9.8V3.2zm-1.6 4.1v6.2h-5l5.2-6.2z", clipRule: "evenodd" }), /* @__PURE__ */ React585.createElement("path", { fillRule: "evenodd", d: "M2.4 16.5h19.2L18.7 21H5.3l-3-4.5zM5 18l1 1.5h11.8l1-1.5H5z", clipRule: "evenodd" }));
}

// src/components/icons/UiBoat.tsx
import * as React586 from "react";
var componentNameString580 = "UiBoat";
function UiBoat({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString580,
    ...props
  });
  return /* @__PURE__ */ React586.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React586.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React586.createElement("path", { d: "M11 9.9h3v2H9v-8h2v6zm-11 4h16l-2 2H2l-2-2zM7.3 1L9 2 4.5 9.9H7v2H1l1.2-2 5-8.9h.1z" }));
}

// src/components/icons/UiBullet2V2.tsx
import * as React587 from "react";
var componentNameString581 = "UiBullet2V2";
function UiBullet2V2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString581,
    ...props
  });
  return /* @__PURE__ */ React587.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React587.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React587.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 9a3 3 0 100 6 3 3 0 000-6zm-4.5 3a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiBulletV2.tsx
import * as React588 from "react";
var componentNameString582 = "UiBulletV2";
function UiBulletV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString582,
    ...props
  });
  return /* @__PURE__ */ React588.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React588.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React588.createElement("path", { d: "M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" }));
}

// src/components/icons/UiBullet.tsx
import * as React589 from "react";
var componentNameString583 = "UiBullet";
function UiBullet({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString583,
    ...props
  });
  return /* @__PURE__ */ React589.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React589.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React589.createElement("path", { d: "M8 12a4 4 0 100-8 4 4 0 000 8z" }));
}

// src/components/icons/UiCalendarV2.tsx
import * as React590 from "react";
var componentNameString584 = "UiCalendarV2";
function UiCalendarV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString584,
    ...props
  });
  return /* @__PURE__ */ React590.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React590.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React590.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.5 7.5V6h-3v3h15V6h-3v1.5H15V6H9v1.5H7.5zm-3 12v-9h15v9h-15zM15 4.5H9V3H7.5v1.5H3V21h18V4.5h-4.5V3H15v1.5zm-4.5 12v-3h-3v3h3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiCalendar.tsx
import * as React591 from "react";
var componentNameString585 = "UiCalendar";
function UiCalendar({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString585,
    ...props
  });
  return /* @__PURE__ */ React591.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React591.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React591.createElement("path", { d: "M0 16V0h16v16H0zM12 3h-2V2H6v1H4V2H2v12h12V2h-2v1zm1 4h-2v3h2v1h-2v2h-1v-2H6v2H5v-2H3v-1h2V7H3V6h2V4h1v2h4V4h1v2h2v1zm-7 3h4V7H6v3z" }));
}

// src/components/icons/UiCameraV2.tsx
import * as React592 from "react";
var componentNameString586 = "UiCameraV2";
function UiCameraV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString586,
    ...props
  });
  return /* @__PURE__ */ React592.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React592.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React592.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.2 4.5H7.8L7 6H1.5v13.5h21V6H17l-.8-1.5zM8 7.5L8.7 6h6.6l.7 1.5h5v3h-5.1a4.5 4.5 0 00-7.8 0H3v-3h5zm8.4 4.5l.1.8a4.5 4.5 0 11-9-.8H3v6h18v-6h-4.6zm-1.4.8a3 3 0 11-6 0 3 3 0 016 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiCancelV2.tsx
import * as React593 from "react";
var componentNameString587 = "UiCancelV2";
function UiCancelV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString587,
    ...props
  });
  return /* @__PURE__ */ React593.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React593.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React593.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 12a9 9 0 0114.8-6.9L5.1 17.8A9 9 0 013 12zm3.2 6.9A9 9 0 0018.9 6.2L6.2 18.9zM12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiCardV2.tsx
import * as React594 from "react";
var componentNameString588 = "UiCardV2";
function UiCardV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString588,
    ...props
  });
  return /* @__PURE__ */ React594.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React594.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React594.createElement("path", { fillRule: "evenodd", d: "M6 3v18h12V3H6zm3 1.5H7.5v15H9v-15zm1.5 15h6v-15h-6v15z", clipRule: "evenodd" }));
}

// src/components/icons/UiCard.tsx
import * as React595 from "react";
var componentNameString589 = "UiCard";
function UiCard({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString589,
    ...props
  });
  return /* @__PURE__ */ React595.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React595.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React595.createElement("rect", { width: 14, height: 10, x: 1, y: 3 }), /* @__PURE__ */ React595.createElement("rect", { width: 13, height: 1, x: 1.5, y: 6.5 }));
}

// src/components/icons/UiCaretDownV2.tsx
import * as React596 from "react";
var componentNameString590 = "UiCaretDownV2";
function UiCaretDownV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString590,
    ...props
  });
  return /* @__PURE__ */ React596.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React596.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React596.createElement("path", { fillRule: "evenodd", d: "M12 14.3l6.2-6.2 1 1-7.2 7.3-7.3-7.2 1-1.1 6.3 6.2z", clipRule: "evenodd" }));
}

// src/components/icons/UiCaretDown.tsx
import * as React597 from "react";
var componentNameString591 = "UiCaretDown";
function UiCaretDown({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString591,
    ...props
  });
  return /* @__PURE__ */ React597.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React597.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React597.createElement("path", { d: "M14.6 3.8L8 10.4 1.4 3.8 0 5.2l8 8 8-8-1.4-1.4z" }));
}

// src/components/icons/UiCaretLeftV2.tsx
import * as React598 from "react";
var componentNameString592 = "UiCaretLeftV2";
function UiCaretLeftV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString592,
    ...props
  });
  return /* @__PURE__ */ React598.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React598.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React598.createElement("path", { fillRule: "evenodd", d: "M9.7 12l6.2 6.2-1 1L7.5 12l7.2-7.3 1.1 1L9.7 12z", clipRule: "evenodd" }));
}

// src/components/icons/UiCaretLeft.tsx
import * as React599 from "react";
var componentNameString593 = "UiCaretLeft";
function UiCaretLeft({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString593,
    ...props
  });
  return /* @__PURE__ */ React599.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React599.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React599.createElement("path", { d: "M12.4 14.6L5.8 8l6.6-6.6L11 0 3 8l8 8 1.4-1.4z" }));
}

// src/components/icons/UiCaretPlay.tsx
import * as React600 from "react";
var componentNameString594 = "UiCaretPlay";
function UiCaretPlay({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString594,
    ...props
  });
  return /* @__PURE__ */ React600.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React600.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React600.createElement("path", { d: "M15 8L5 16V0l10 8z" }));
}

// src/components/icons/UiCaretRightV2.tsx
import * as React601 from "react";
var componentNameString595 = "UiCaretRightV2";
function UiCaretRightV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString595,
    ...props
  });
  return /* @__PURE__ */ React601.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React601.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React601.createElement("path", { fillRule: "evenodd", d: "M14.3 12l-6.2 6.2 1 1 7.3-7.2-7.2-7.3-1.1 1 6.2 6.3z", clipRule: "evenodd" }));
}

// src/components/icons/UiCaretRight.tsx
import * as React602 from "react";
var componentNameString596 = "UiCaretRight";
function UiCaretRight({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString596,
    ...props
  });
  return /* @__PURE__ */ React602.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React602.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React602.createElement("path", { d: "M3.8 14.6L10.4 8 3.8 1.4 5.2 0l8 8-8 8-1.4-1.4z" }));
}

// src/components/icons/UiCaretUpV2.tsx
import * as React603 from "react";
var componentNameString597 = "UiCaretUpV2";
function UiCaretUpV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString597,
    ...props
  });
  return /* @__PURE__ */ React603.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React603.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React603.createElement("path", { fillRule: "evenodd", d: "M12 9.7l6.2 6.2 1-1L12 7.5l-7.3 7.2 1 1.1L12 9.7z", clipRule: "evenodd" }));
}

// src/components/icons/UiCaretUp.tsx
import * as React604 from "react";
var componentNameString598 = "UiCaretUp";
function UiCaretUp({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString598,
    ...props
  });
  return /* @__PURE__ */ React604.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React604.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React604.createElement("path", { d: "M14.6 12.4L8 5.8l-6.6 6.5L0 11l8-8 8 8-1.4 1.5z" }));
}

// src/components/icons/UiCashV2.tsx
import * as React605 from "react";
var componentNameString599 = "UiCashV2";
function UiCashV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString599,
    ...props
  });
  return /* @__PURE__ */ React605.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React605.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React605.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M1.5 18h21V6h-21v12zM21 7.5v9H3v-9h18zm-9 2.3a2.3 2.3 0 100 4.5 2.3 2.3 0 000-4.6zM8.2 12c0-.5.2-1 .4-1.5H6v3h2.6L8.3 12zm-3.7 3h5.2a3.7 3.7 0 004.6 0h5.2V9h-5.2a3.7 3.7 0 00-4.6 0H4.5v6zM18 13.5h-2.6a3.7 3.7 0 000-3H18v3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiChatV2.tsx
import * as React606 from "react";
var componentNameString600 = "UiChatV2";
function UiChatV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString600,
    ...props
  });
  return /* @__PURE__ */ React606.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React606.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React606.createElement("path", { fillRule: "evenodd", d: "M3 3h18v18.1l-5.5-4.6H3V3zm1.5 1.5V15H16l3.5 2.9V4.5h-15z", clipRule: "evenodd" }), /* @__PURE__ */ React606.createElement("rect", { width: 1.5, height: 1.5, x: 11.3, y: 9 }), /* @__PURE__ */ React606.createElement("rect", { width: 1.5, height: 1.5, x: 15, y: 9 }), /* @__PURE__ */ React606.createElement("rect", { width: 1.5, height: 1.5, x: 7.5, y: 9 }));
}

// src/components/icons/UiChat.tsx
import * as React607 from "react";
var componentNameString601 = "UiChat";
function UiChat({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString601,
    ...props
  });
  return /* @__PURE__ */ React607.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React607.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React607.createElement("path", { d: "M0 1h16v15l-4-4H0V1zm2 9h12V3H2v7z" }));
}

// src/components/icons/UiCheckArrowCircleV2.tsx
import * as React608 from "react";
var componentNameString602 = "UiCheckArrowCircleV2";
function UiCheckArrowCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString602,
    ...props
  });
  return /* @__PURE__ */ React608.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React608.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React608.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 6a6 6 0 016 6v4.2l-1.7-1.7-1 1 3.4 3.6 3.6-3.6-1-1-1.8 1.7V12c0-4.1-3.4-7.5-7.5-7.5V6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React608.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18a6 6 0 01-6-6V7.8l1.7 1.7 1-1-3.4-3.6-3.6 3.6 1 1 1.8-1.7V12c0 4.1 3.4 7.5 7.5 7.5V18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React608.createElement("path", { fillRule: "evenodd", d: "M15.5 10.3L11 14.8l-2.5-2.5 1-1 1.5 1.4 3.5-3.5 1 1z", clipRule: "evenodd" }));
}

// src/components/icons/UiCheckBackV2.tsx
import * as React609 from "react";
var componentNameString603 = "UiCheckBackV2";
function UiCheckBackV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString603,
    ...props
  });
  return /* @__PURE__ */ React609.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React609.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React609.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.5 18h-21V6h21v12zM21 16.5v-9h-6v9h-1.5v-9H3v9h18zm-3.4-5.9l-1.5-1 .8-1.2 1.5 1a2 2 0 010 3.2c-.3.2-.3.6 0 .8l1.5 1-.8 1.2-1.5-1a2 2 0 010-3.2c.3-.2.3-.6 0-.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiCheckFrontV2.tsx
import * as React610 from "react";
var componentNameString604 = "UiCheckFrontV2";
function UiCheckFrontV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString604,
    ...props
  });
  return /* @__PURE__ */ React610.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React610.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React610.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M1.5 18h21V6h-21v12zM21 7.5v9H3v-9h18zm-16.5 3H12V9H4.5v1.5zm7.5 3H4.5V12H12v1.5zm2.1 2l1-1.6c.2-.3.6-.3.8 0a2 2 0 003.2 0l1-1.5-1.2-.8-1 1.5c-.2.3-.6.3-.8 0a2 2 0 00-3.2 0l-1 1.5 1.2.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiCheck.tsx
import * as React611 from "react";
var componentNameString605 = "UiCheck";
function UiCheck({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString605,
    ...props
  });
  return /* @__PURE__ */ React611.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React611.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React611.createElement("path", { d: "M14.6 1.7l-9.1 9-4-4.2L0 8l5.4 5.6L16 3.1l-1.4-1.4z" }));
}

// src/components/icons/UiCheckmarkCircleV2.tsx
import * as React612 from "react";
var componentNameString606 = "UiCheckmarkCircleV2";
function UiCheckmarkCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString606,
    ...props
  });
  return /* @__PURE__ */ React612.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React612.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React612.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1.5 12a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React612.createElement("path", { fillRule: "evenodd", d: "M17 9.5l-6.5 6.6L7 12.5l1-1 2.5 2.4L16 8.5l1 1z", clipRule: "evenodd" }));
}

// src/components/icons/UiCheckmarkV2.tsx
import * as React613 from "react";
var componentNameString607 = "UiCheckmarkV2";
function UiCheckmarkV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString607,
    ...props
  });
  return /* @__PURE__ */ React613.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React613.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React613.createElement("path", { fillRule: "evenodd", d: "M19.3 8l-9.6 9.6-5-5 1-1.1 4 4L18.3 7l1 1z", clipRule: "evenodd" }));
}

// src/components/icons/UiCircleArrowsCheck.tsx
import * as React614 from "react";
var componentNameString608 = "UiCircleArrowsCheck";
function UiCircleArrowsCheck({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString608,
    ...props
  });
  return /* @__PURE__ */ React614.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React614.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React614.createElement("g", { clipPath: "url(#ui--circle-arrows-check_svg__ui--circle-arrows-check_svg__clip0)" }, /* @__PURE__ */ React614.createElement("path", { d: "M0 8a8 8 0 013.4-6.6L2.6 0H8L5.2 4.7l-1-1.8C2.8 3.9 2 6 2 8a6 6 0 005 5.9l-1.1 1.8A8 8 0 010 8zm16 0a8 8 0 01-3.4 6.6l.8 1.4H8l2.8-4.7 1 1.8C13.2 12.1 14 10 14 8a6 6 0 00-5-5.9L10.2.3A8 8 0 0116 8zM4 8.2l1.4-1.4 1.8 1.7L10.7 5l1.4 1.4-5 5L4 8.2z" })), /* @__PURE__ */ React614.createElement("defs", null, /* @__PURE__ */ React614.createElement("clipPath", { id: "ui--circle-arrows-check_svg__ui--circle-arrows-check_svg__clip0" }, /* @__PURE__ */ React614.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiCircleArrowsMinus.tsx
import * as React615 from "react";
var componentNameString609 = "UiCircleArrowsMinus";
function UiCircleArrowsMinus({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString609,
    ...props
  });
  return /* @__PURE__ */ React615.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React615.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React615.createElement("g", { clipPath: "url(#ui--circle-arrows-minus_svg__ui--circle-arrows-minus_svg__clip0)" }, /* @__PURE__ */ React615.createElement("path", { d: "M0 8a8 8 0 005.9 7.7l1-1.8A6 6 0 012 8c0-2 .8-4 2.2-5.1l1 1.8L8 0H2.6l.8 1.4A8 8 0 000 8zm16 0A8 8 0 0010.1.3L9.1 2A6 6 0 0114 7.9c0 2-.8 4-2.2 5.1l-1-1.8L8 16h5.4l-.8-1.4A8 8 0 0016 8zm-5 1V7H5v2h6z" })), /* @__PURE__ */ React615.createElement("defs", null, /* @__PURE__ */ React615.createElement("clipPath", { id: "ui--circle-arrows-minus_svg__ui--circle-arrows-minus_svg__clip0" }, /* @__PURE__ */ React615.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiCircleArrowsPlus.tsx
import * as React616 from "react";
var componentNameString610 = "UiCircleArrowsPlus";
function UiCircleArrowsPlus({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString610,
    ...props
  });
  return /* @__PURE__ */ React616.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React616.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React616.createElement("g", { clipPath: "url(#ui--circle-arrows-plus_svg__ui--circle-arrows-plus_svg__clip0)" }, /* @__PURE__ */ React616.createElement("path", { d: "M0 8a8 8 0 005.9 7.7l1-1.8A6 6 0 012 8c0-2 .8-4 2.2-5.1l1 1.8L8 0H2.6l.8 1.4A8 8 0 000 8zm16 0A8 8 0 0010.1.3L9.1 2A6 6 0 0114 7.9c0 2-.8 4-2.2 5.1l-1-1.8L8 16h5.4l-.8-1.4A8 8 0 0016 8zM9 5H7v2H5v2h2v2h2V9h2V7H9V5z" })), /* @__PURE__ */ React616.createElement("defs", null, /* @__PURE__ */ React616.createElement("clipPath", { id: "ui--circle-arrows-plus_svg__ui--circle-arrows-plus_svg__clip0" }, /* @__PURE__ */ React616.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiCircleArrows.tsx
import * as React617 from "react";
var componentNameString611 = "UiCircleArrows";
function UiCircleArrows({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString611,
    ...props
  });
  return /* @__PURE__ */ React617.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React617.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React617.createElement("g", { clipPath: "url(#ui--circle-arrows_svg__ui--circle-arrows_svg__clip0)" }, /* @__PURE__ */ React617.createElement("path", { d: "M0 8a8 8 0 005.9 7.7l1-1.8A6 6 0 012 8c0-2 .8-4 2.2-5.1l1 1.8L8 0H2.6l.8 1.4A8 8 0 000 8zm16 0A8 8 0 0010.1.3L9.1 2A6 6 0 0114 7.9c0 2-.8 4-2.2 5.1l-1-1.8L8 16h5.4l-.8-1.4A8 8 0 0016 8z" })), /* @__PURE__ */ React617.createElement("defs", null, /* @__PURE__ */ React617.createElement("clipPath", { id: "ui--circle-arrows_svg__ui--circle-arrows_svg__clip0" }, /* @__PURE__ */ React617.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiCircleCheck.tsx
import * as React618 from "react";
var componentNameString612 = "UiCircleCheck";
function UiCircleCheck({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString612,
    ...props
  });
  return /* @__PURE__ */ React618.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React618.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React618.createElement("g", { clipPath: "url(#ui--circle-check_svg__ui--circle-check_svg__clip0)" }, /* @__PURE__ */ React618.createElement("path", { d: "M8 15A7 7 0 118 1a7 7 0 010 14zM0 8a8 8 0 1016 0A8 8 0 000 8zm11.5-4l-5 5-2-2.2L3 8.2l2.1 2.2 1.4 1.4L13 5.4 11.5 4z" })), /* @__PURE__ */ React618.createElement("defs", null, /* @__PURE__ */ React618.createElement("clipPath", { id: "ui--circle-check_svg__ui--circle-check_svg__clip0" }, /* @__PURE__ */ React618.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiCircleDollar.tsx
import * as React619 from "react";
var componentNameString613 = "UiCircleDollar";
function UiCircleDollar({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString613,
    ...props
  });
  return /* @__PURE__ */ React619.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React619.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React619.createElement("path", { d: "M8 0a8 8 0 110 16A8 8 0 018 0zm2.1 10.2c.3-.8.2-1.3-.1-1.7a3 3 0 00-1.3-.9L8 7.4a2 2 0 01-.6-.4C7 6.5 7 6 7.6 5.8c.6-.3 1.3-.1 2 .5l.5-1c-.3-.4-.8-.6-1.6-.7v-1h-1v1c-1 .2-1.5.8-1.6 1.5-.1.8.1 1.4.7 1.9l1.6.7c.6.2.9.5.8 1 0 .4-.4.6-1 .6-.5 0-1-.2-1.6-.7l-.7.8.7.7 1.2.3v1h1v-1c.8-.2 1.3-.6 1.5-1.2z" }));
}

// src/components/icons/UiCircleExclamation.tsx
import * as React620 from "react";
var componentNameString614 = "UiCircleExclamation";
function UiCircleExclamation({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString614,
    ...props
  });
  return /* @__PURE__ */ React620.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React620.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React620.createElement("g", { clipPath: "url(#ui--circle-exclamation_svg__ui--circle-exclamation_svg__clip0)" }, /* @__PURE__ */ React620.createElement("path", { d: "M8 15A7 7 0 118 1a7 7 0 010 14zM0 8a8 8 0 1016 0A8 8 0 000 8zm7 2h2V3H7v7zm0 3h2v-2H7v2z" })), /* @__PURE__ */ React620.createElement("defs", null, /* @__PURE__ */ React620.createElement("clipPath", { id: "ui--circle-exclamation_svg__ui--circle-exclamation_svg__clip0" }, /* @__PURE__ */ React620.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiCircleOpen.tsx
import * as React621 from "react";
var componentNameString615 = "UiCircleOpen";
function UiCircleOpen({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString615,
    ...props
  });
  return /* @__PURE__ */ React621.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React621.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React621.createElement("path", { d: "M8 16A8 8 0 118 0a8 8 0 010 16zm0-4a4 4 0 100-8 4 4 0 000 8z" }));
}

// src/components/icons/UiCircleQuestion.tsx
import * as React622 from "react";
var componentNameString616 = "UiCircleQuestion";
function UiCircleQuestion({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString616,
    ...props
  });
  return /* @__PURE__ */ React622.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React622.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React622.createElement("g", { clipPath: "url(#ui--circle-question_svg__ui--circle-question_svg__clip0)" }, /* @__PURE__ */ React622.createElement("path", { d: "M7 13h2v-2H7v2zm0-3.4l.2-.9c.1-.3.4-.5.7-.8l.7-.6.7-.8.2-1c0-.4-.1-.8-.4-1C8.8 4.2 8.4 4 8 4c-.5 0-1 .2-1.2.5-.3.3-.5.8-.5 1.3l.1.7-1.7-.1v-.8c0-.9.3-1.6.8-2.1.6-.6 1.4-.8 2.5-.8 1 0 1.8.2 2.4.7.6.5.9 1.2.9 2a3.3 3.3 0 01-1.4 2.5l-.6.6-.5.6-.1.7v.4H7v-.6zM8 15A7 7 0 118 1a7 7 0 010 14zM8 0a8 8 0 100 16A8 8 0 008 0" })), /* @__PURE__ */ React622.createElement("defs", null, /* @__PURE__ */ React622.createElement("clipPath", { id: "ui--circle-question_svg__ui--circle-question_svg__clip0" }, /* @__PURE__ */ React622.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiCopyV2.tsx
import * as React623 from "react";
var componentNameString617 = "UiCopyV2";
function UiCopyV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString617,
    ...props
  });
  return /* @__PURE__ */ React623.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React623.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React623.createElement("path", { d: "M5.3 17.3V4.4h11.2V3H3.7v14.3h1.5z" }), /* @__PURE__ */ React623.createElement("path", { fillRule: "evenodd", d: "M16.8 6h-10v15h13.4V9.3L16.9 6zM8.2 19.5v-12h8l2.6 2.5v9.5H8.2z", clipRule: "evenodd" }));
}

// src/components/icons/UiDirectDepositV2.tsx
import * as React624 from "react";
var componentNameString618 = "UiDirectDepositV2";
function UiDirectDepositV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString618,
    ...props
  });
  return /* @__PURE__ */ React624.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React624.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React624.createElement("path", { d: "M19.5 12h-5.6v1.5H21V3H3v10.5h7.1V12H4.5V4.5h15V12z" }), /* @__PURE__ */ React624.createElement("path", { d: "M12 7.5H6V6h6v1.5z" }), /* @__PURE__ */ React624.createElement("path", { d: "M6 10.5h6V9H6v1.5z" }), /* @__PURE__ */ React624.createElement("path", { d: "M11.3 18.4L8.8 16l-1 1 4.2 4.3 4.3-4.3-1-1-2.6 2.4V12h-1.4v6.4z" }));
}

// src/components/icons/UiDirectDeposit.tsx
import * as React625 from "react";
var componentNameString619 = "UiDirectDeposit";
function UiDirectDeposit({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString619,
    ...props
  });
  return /* @__PURE__ */ React625.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React625.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React625.createElement("path", { d: "M19.5 12h-5.6v1.5H21V3H3v10.5h7.1V12H4.5V4.5h15V12z" }), /* @__PURE__ */ React625.createElement("path", { d: "M12 7.5H6V6h6v1.5z" }), /* @__PURE__ */ React625.createElement("path", { d: "M6 10.5h6V9H6v1.5z" }), /* @__PURE__ */ React625.createElement("path", { d: "M11.3 18.4L8.8 16l-1 1 4.2 4.3 4.3-4.3-1-1-2.6 2.4V12h-1.4v6.4z" }));
}

// src/components/icons/UiDocumentCompleteV2.tsx
import * as React626 from "react";
var componentNameString620 = "UiDocumentCompleteV2";
function UiDocumentCompleteV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString620,
    ...props
  });
  return /* @__PURE__ */ React626.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React626.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React626.createElement("path", { fillRule: "evenodd", d: "M17 9.5l-6.5 6.6L7 12.5l1-1 2.5 2.4L16 8.5l1 1z", clipRule: "evenodd" }), /* @__PURE__ */ React626.createElement("path", { fillRule: "evenodd", d: "M3 1.5h13.4L21 6.1v16.4H3v-21zM4.5 3v18h15V6.7L15.8 3H4.5z", clipRule: "evenodd" }));
}

// src/components/icons/UiDocumentV2.tsx
import * as React627 from "react";
var componentNameString621 = "UiDocumentV2";
function UiDocumentV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString621,
    ...props
  });
  return /* @__PURE__ */ React627.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React627.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React627.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.5 8.3h-9V6.7h9v1.5zm0 4.4h-9v-1.4h9v1.4zm0 4.6h-9v-1.6h9v1.6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React627.createElement("path", { fillRule: "evenodd", d: "M3 1.5h13.4L21 6.1v16.4H3v-21zM4.5 3v18h15V6.7L15.8 3H4.5z", clipRule: "evenodd" }));
}

// src/components/icons/UiDocumentsV2.tsx
import * as React628 from "react";
var componentNameString622 = "UiDocumentsV2";
function UiDocumentsV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString622,
    ...props
  });
  return /* @__PURE__ */ React628.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React628.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React628.createElement("path", { fillRule: "evenodd", d: "M16.5 8.3h-6V6.7h6v1.5zm0 3h-6V9.7h6v1.6zm0 3h-6v-1.6h6v1.6z", clipRule: "evenodd" }), /* @__PURE__ */ React628.createElement("path", { fillRule: "evenodd", d: "M6.8 3h10l3.4 3.3V18H6.8V3zm1.5 1.5v12h10.4V7l-2.5-2.5h-8z", clipRule: "evenodd" }), /* @__PURE__ */ React628.createElement("path", { fillRule: "evenodd", d: "M5.3 19.5V6.7H3.8V21h12.7v-1.5H5.2z", clipRule: "evenodd" }));
}

// src/components/icons/UiDocuments.tsx
import * as React629 from "react";
var componentNameString623 = "UiDocuments";
function UiDocuments({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString623,
    ...props
  });
  return /* @__PURE__ */ React629.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React629.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React629.createElement("path", { d: "M0 16V4h11v12H0zm2-2h7V6H2v8zm1-1v-3h2v3H3zm3 0V8h2v5H6zm7-11H4V0h11v13h-2V2z" }));
}

// src/components/icons/UiDollarSignCircleV2.tsx
import * as React630 from "react";
var componentNameString624 = "UiDollarSignCircleV2";
function UiDollarSignCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString624,
    ...props
  });
  return /* @__PURE__ */ React630.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React630.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React630.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 12a9 9 0 1118 0 9 9 0 01-18 0zm9-10.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zM11.2 6v1.5a2.2 2.2 0 00-1.2 4l3.2 2.2a.7.7 0 01-.4 1.3h-1.6a.8.8 0 01-.7-.8v-.8H9v.8c0 1.3 1 2.3 2.3 2.3V18h1.4v-1.5a2.2 2.2 0 001.3-4l-3.2-2.2a.7.7 0 01.4-1.3h1.6c.4 0 .7.3.7.8v.7H15v-.8c0-1.2-1-2.2-2.3-2.2V6h-1.4z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiDollarSignV2.tsx
import * as React631 from "react";
var componentNameString625 = "UiDollarSignV2";
function UiDollarSignV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString625,
    ...props
  });
  return /* @__PURE__ */ React631.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React631.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React631.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.3 18.8V21h1.4v-2.3h.7a3 3 0 001.7-5.6l-2.3-1.5V6.8h.5c1 0 1.7.7 1.7 1.6v1.2h1.5V8.4c0-1.7-1.4-3.2-3.2-3.2h-.6V3h-1.4v2.3h-.7a3 3 0 00-1.7 5.6l2.3 1.5v4.8h-.5c-1 0-1.7-.7-1.7-1.6v-1.3H7.5v1.3c0 1.7 1.4 3.2 3.2 3.2h.6zm1.4-1.6h.7a1.6 1.6 0 00.9-2.9l-1.6-1v4zm-1.4-6.6V6.8h-.7a1.6 1.6 0 00-.9 2.9l1.6 1z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiDonutV2.tsx
import * as React632 from "react";
var componentNameString626 = "UiDonutV2";
function UiDonutV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString626,
    ...props
  });
  return /* @__PURE__ */ React632.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React632.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React632.createElement("path", { d: "M12 19.5a7 7 0 004.7-1.7l1.1 1A9 9 0 1111.2 3v1.5a7.5 7.5 0 00.8 15z" }), /* @__PURE__ */ React632.createElement("path", { d: "M18.9 17.8l-1-1a9.4 9.4 0 001.6-4H21a9 9 0 01-2.1 5z" }), /* @__PURE__ */ React632.createElement("path", { d: "M21 11.3A9 9 0 0012.7 3v1.5c3.6.4 6.4 3.2 6.8 6.8H21z" }));
}

// src/components/icons/UiDonut.tsx
import * as React633 from "react";
var componentNameString627 = "UiDonut";
function UiDonut({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString627,
    ...props
  });
  return /* @__PURE__ */ React633.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React633.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React633.createElement("g", { clipPath: "url(#ui--donut_svg__ui--donut_svg__clip0)" }, /* @__PURE__ */ React633.createElement("path", { d: "M8 14a6 6 0 003.5-1.2l1.4 1.4A8 8 0 117 0v2a6 6 0 001 12zm6-7a6 6 0 00-5-5V0a8 8 0 017 7h-2zm0 2h2a8 8 0 01-1.7 3.8L13 11.4a6 6 0 001-2.5V9z" })), /* @__PURE__ */ React633.createElement("defs", null, /* @__PURE__ */ React633.createElement("clipPath", { id: "ui--donut_svg__ui--donut_svg__clip0" }, /* @__PURE__ */ React633.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiDownloadV2.tsx
import * as React634 from "react";
var componentNameString628 = "UiDownloadV2";
function UiDownloadV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString628,
    ...props
  });
  return /* @__PURE__ */ React634.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React634.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React634.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.8 3v12.4l5.4-5.4 1 1-7.2 7.3L4.7 11l1-1 5.5 5.4V3h1.6zM21 19.5H3V21h18v-1.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiDownloadWithdrawV2.tsx
import * as React635 from "react";
var componentNameString629 = "UiDownloadWithdrawV2";
function UiDownloadWithdrawV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString629,
    ...props
  });
  return /* @__PURE__ */ React635.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React635.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React635.createElement("path", { d: "M12.8 3v12.4l5.4-5.4 1 1-7.2 7.3L4.7 11l1-1 5.5 5.4V3h1.6zM21 19.5H3V21h18v-1.5z", clipRule: "evenodd" }));
}

// src/components/icons/UiEditV2.tsx
import * as React636 from "react";
var componentNameString630 = "UiEditV2";
function UiEditV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString630,
    ...props
  });
  return /* @__PURE__ */ React636.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React636.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React636.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 21h2.7L3 18.3V21zm1-4l3 3L18.1 8.9l-3-3L4 17zm2 0l9.2-9 .9.9L6.9 18 6 17zM21 6l-1.7 1.7-3-3L18 3l3 3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiEdit.tsx
import * as React637 from "react";
var componentNameString631 = "UiEdit";
function UiEdit({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString631,
    ...props
  });
  return /* @__PURE__ */ React637.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React637.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React637.createElement(
    "path",
    {
      d: "M3 21h2.7L3 18.3V21zm1-4l3 3L18.1 8.9l-3-3L4 17zm2 0l9.2-9 .9.9L6.9 18 6 17zM21 6l-1.7 1.7-3-3L18 3l3 3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiEggV2.tsx
import * as React638 from "react";
var componentNameString632 = "UiEggV2";
function UiEggV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString632,
    ...props
  });
  return /* @__PURE__ */ React638.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React638.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React638.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5.3 12.8c0-2.6.8-5 2.2-6.9C8.8 4.1 10.5 3 12 3s3.2 1 4.5 3a12 12 0 012.3 6.8c0 5-3.2 8.2-6.8 8.2-3.6 0-6.8-3.2-6.8-8.3zM12 1.4C9.8 1.5 7.7 3 6.2 5a14 14 0 00-2.5 7.8c0 5.6 3.6 9.7 8.3 9.7 4.7 0 8.3-4 8.3-9.8 0-2.8-1-5.6-2.5-7.7-1.5-2-3.6-3.5-5.8-3.5zm.8 6c1.2 0 2.2 1 2.2 2.3v.7h-1.5v-.8c0-.4-.3-.7-.8-.7h-1.5a.7.7 0 00-.4 1.3l3.2 2.1a2.2 2.2 0 01-1.2 4.1V18h-1.6v-1.5c-1.2 0-2.2-1-2.2-2.3v-.8h1.5v.8c0 .5.3.8.8.8h1.5a.7.7 0 00.4-1.3L10 11.6a2.2 2.2 0 011.2-4.1V6h1.6v1.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiEgg.tsx
import * as React639 from "react";
var componentNameString633 = "UiEgg";
function UiEgg({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString633,
    ...props
  });
  return /* @__PURE__ */ React639.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React639.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React639.createElement("path", { d: "M15.2 9.4c0 3.9-3 6.6-7 6.6S1 13.3 1 9.4C1 4.9 4.7 0 8.1 0c3.4 0 7.1 5 7.1 9.4zm-5 .9c.2-.8.1-1.4-.2-1.8-.3-.4-.8-.6-1.3-.8L8 7.4a2 2 0 01-.5-.4c-.5-.4-.5-.8.1-1 .6-.3 1.3-.2 2 .4l.5-.9c-.3-.4-.8-.7-1.6-.7v-1h-1v1c-1 .2-1.5.7-1.6 1.5-.1.7.1 1.4.7 1.8.2.2.7.4 1.6.7.6.3.9.6.8 1 0 .4-.4.7-1 .7-.5 0-1-.3-1.6-.8l-.7.9.7.6 1.2.4v1h1v-1c.8-.2 1.3-.6 1.5-1.2l.1-.1z" }));
}

// src/components/icons/UiEllipse.tsx
import * as React640 from "react";
var componentNameString634 = "UiEllipse";
function UiEllipse({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString634,
    ...props
  });
  return /* @__PURE__ */ React640.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React640.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React640.createElement("path", { d: "M2 10V7h3v3H2zm5 0V7h3v3H7zm5 0V7h3v3h-3z" }));
}

// src/components/icons/UiEllipsesV2.tsx
import * as React641 from "react";
var componentNameString635 = "UiEllipsesV2";
function UiEllipsesV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString635,
    ...props
  });
  return /* @__PURE__ */ React641.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React641.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React641.createElement("path", { fillRule: "evenodd", d: "M7.5 10.5h-3v3h3v-3zm3 0h3v3h-3v-3zm6 0h3v3h-3v-3z", clipRule: "evenodd" }));
}

// src/components/icons/UiError.tsx
import * as React642 from "react";
var componentNameString636 = "UiError";
function UiError({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString636,
    ...props
  });
  return /* @__PURE__ */ React642.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React642.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React642.createElement("path", { d: "M8 15a7 7 0 01-4.2-1.4l9.8-9.8A7 7 0 018 15zM1 8a7 7 0 0111.2-5.6l-9.8 9.8A7 7 0 011 8zm13.3-4.9A8 8 0 00.8 11.5a8 8 0 002.3 2.8A8 8 0 0014.3 3.1" }));
}

// src/components/icons/UiExclamationCircleV2.tsx
import * as React643 from "react";
var componentNameString637 = "UiExclamationCircleV2";
function UiExclamationCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString637,
    ...props
  });
  return /* @__PURE__ */ React643.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React643.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React643.createElement("path", { fillRule: "evenodd", d: "M11.3 15V6h1.4v9h-1.4z", clipRule: "evenodd" }), /* @__PURE__ */ React643.createElement("path", { d: "M11.3 16.5h1.4V18h-1.4v-1.5z" }), /* @__PURE__ */ React643.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1.5 12a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiExclamationV2.tsx
import * as React644 from "react";
var componentNameString638 = "UiExclamationV2";
function UiExclamationV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString638,
    ...props
  });
  return /* @__PURE__ */ React644.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React644.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React644.createElement("path", { fillRule: "evenodd", d: "M11.3 16.5v-12h1.4v12h-1.4z", clipRule: "evenodd" }), /* @__PURE__ */ React644.createElement("path", { d: "M11.3 18h1.4v1.5h-1.4V18z" }));
}

// src/components/icons/UiExclamation.tsx
import * as React645 from "react";
var componentNameString639 = "UiExclamation";
function UiExclamation({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString639,
    ...props
  });
  return /* @__PURE__ */ React645.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React645.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React645.createElement("path", { d: "M7 16h2v-2H7v2zm0-3.7h2V0H7v12.3z" }));
}

// src/components/icons/UiExitXCircleV2.tsx
import * as React646 from "react";
var componentNameString640 = "UiExitXCircleV2";
function UiExitXCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString640,
    ...props
  });
  return /* @__PURE__ */ React646.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React646.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React646.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 12a9 9 0 1118 0 9 9 0 01-18 0zm9-10.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zM16 17l-4-4-4 4-1-1 4-4-4-4 1-1 4 4 4-4 1 1-4 4 4 4-1 1z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiExitXV2.tsx
import * as React647 from "react";
var componentNameString641 = "UiExitXV2";
function UiExitXV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString641,
    ...props
  });
  return /* @__PURE__ */ React647.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React647.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React647.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11 12l-6.3 6.2 1 1 6.3-6.1 6.2 6.2 1-1-6.1-6.3 6.2-6.2-1-1-6.3 6.1-6.2-6.2-1 1 6.1 6.3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiExit.tsx
import * as React648 from "react";
var componentNameString642 = "UiExit";
function UiExit({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString642,
    ...props
  });
  return /* @__PURE__ */ React648.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React648.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React648.createElement("path", { d: "M8 0L6.6 1.4 12.2 7H4v2h8.2l-5.6 5.6L8 16l8-8-8-8zM0 13h2V3H0v10z" }));
}

// src/components/icons/UiFileCsv.tsx
import * as React649 from "react";
var componentNameString643 = "UiFileCsv";
function UiFileCsv({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString643,
    ...props
  });
  return /* @__PURE__ */ React649.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React649.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React649.createElement("path", { d: "M7.8.6L9.2 2H4v12h8V2l2 2v12H2V0h8l2 2H9.2L7.8.6zM9.2 2H12v2.8L9.2 2zM6 7V5h4v2H6zm0 4V9h4v2H6z" }));
}

// src/components/icons/UiFilePdf.tsx
import * as React650 from "react";
var componentNameString644 = "UiFilePdf";
function UiFilePdf({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString644,
    ...props
  });
  return /* @__PURE__ */ React650.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React650.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React650.createElement("path", { d: "M7.8.6L9.2 2H4v12h8V2l2 2v12H2V0h8l2 2H9.2L7.8.6zM9.2 2H12v2.8L9.2 2zM9 3v2h2v2H7V3h2z" }));
}

// src/components/icons/UiFilterV2.tsx
import * as React651 from "react";
var componentNameString645 = "UiFilterV2";
function UiFilterV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString645,
    ...props
  });
  return /* @__PURE__ */ React651.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React651.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React651.createElement("path", { fillRule: "evenodd", d: "M19.5 8.3h-15V6.7h15v1.5z", clipRule: "evenodd" }), /* @__PURE__ */ React651.createElement("path", { fillRule: "evenodd", d: "M17.3 12.8H6.7v-1.6h10.6v1.6z", clipRule: "evenodd" }), /* @__PURE__ */ React651.createElement("path", { fillRule: "evenodd", d: "M15 17.3H9v-1.6h6v1.6z", clipRule: "evenodd" }));
}

// src/components/icons/UiFilter.tsx
import * as React652 from "react";
var componentNameString646 = "UiFilter";
function UiFilter({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString646,
    ...props
  });
  return /* @__PURE__ */ React652.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React652.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React652.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M10.5 3a1 1 0 112 0 1 1 0 01-2 0zm-1 .5H0v-1h9.6a2 2 0 013.8 0H16v1h-2.6a2 2 0 01-3.8 0zm1 8.5a1 1 0 112 0 1 1 0 01-2 0zm-1 .5H0v-1h9.6a2 2 0 013.8 0H16v1h-2.6a2 2 0 01-3.8 0zm-5-6a1 1 0 100 2 1 1 0 000-2zM0 8h2.6a2 2 0 003.8 0H16V7H6.4a2 2 0 00-3.8 0H0v1z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiFolderCompleteV2.tsx
import * as React653 from "react";
var componentNameString647 = "UiFolderCompleteV2";
function UiFolderCompleteV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString647,
    ...props
  });
  return /* @__PURE__ */ React653.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React653.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React653.createElement("path", { fillRule: "evenodd", d: "M1.5 3h9.1v1.5H3v15h18V6H10.6V4.5h11.9V21h-21V3z", clipRule: "evenodd" }), /* @__PURE__ */ React653.createElement("path", { fillRule: "evenodd", d: "M17 10.3l-6.5 6.5L7 13.3l1-1 2.5 2.4L16 9.2l1 1z", clipRule: "evenodd" }));
}

// src/components/icons/UiFolderV2.tsx
import * as React654 from "react";
var componentNameString648 = "UiFolderV2";
function UiFolderV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString648,
    ...props
  });
  return /* @__PURE__ */ React654.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React654.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React654.createElement("path", { fillRule: "evenodd", d: "M1.5 3h9.1v1.5H3v15h18V6H10.6V4.5h11.9V21h-21V3z", clipRule: "evenodd" }));
}

// src/components/icons/UiForwardV2.tsx
import * as React655 from "react";
var componentNameString649 = "UiForwardV2";
function UiForwardV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString649,
    ...props
  });
  return /* @__PURE__ */ React655.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React655.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React655.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.2 12.7l-5.5 5.5 1 1 7.4-7.2-7.3-7.3-1 1 5.4 5.5H1.5v1.5h17.7z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiFpo.tsx
import * as React656 from "react";
var componentNameString650 = "UiFpo";
function UiFpo({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString650,
    ...props
  });
  return /* @__PURE__ */ React656.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React656.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React656.createElement("g", { clipPath: "url(#ui--fpo_svg__ui--fpo_svg__clip0)" }, /* @__PURE__ */ React656.createElement("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 6.2c1 0 1.5.5 1.5 1.3C9.5 8.4 9 9 8 9h-.8v1.4H6v-4h2v-.2zm-.3 1.9c.4 0 .6-.2.6-.5 0-.4-.2-.6-.6-.6h-.5v1.1h.5zm4.1 2.3c-1.2 0-2-.9-2-2.2 0-1.3.8-2 2-2 1.3 0 2.1.7 2.1 2s-.8 2.2-2 2.2h-.1zm0-1c-.5 0-.8-.4-.8-1.2 0-.7.3-1.2.8-1.2.6 0 .9.5.9 1.2 0 .8-.3 1.3-.9 1.3v-.1zM5.6 7.2H3.9v.7h1.6v1H3.9v1.5H2.7v-4h2.9v.8z" })), /* @__PURE__ */ React656.createElement("defs", null, /* @__PURE__ */ React656.createElement("clipPath", { id: "ui--fpo_svg__ui--fpo_svg__clip0" }, /* @__PURE__ */ React656.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiFullscreenV2.tsx
import * as React657 from "react";
var componentNameString651 = "UiFullscreenV2";
function UiFullscreenV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString651,
    ...props
  });
  return /* @__PURE__ */ React657.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React657.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React657.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5.6 4.5h2.7V3H3v5.3h1.5V5.5l4.7 4.7 1-1-4.6-4.8zm12.8 0h-2.6V3H21v5.3h-1.5V5.5l-4.7 4.7-1-1 4.6-4.8zm-12.8 15h2.7V21H3v-5.3h1.5v2.7l4.7-4.7 1 1-4.6 4.8zm12.8 0h-2.6V21H21v-5.3h-1.5v2.7l-4.7-4.7-1 1 4.6 4.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiGear.tsx
import * as React658 from "react";
var componentNameString652 = "UiGear";
function UiGear({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString652,
    ...props
  });
  return /* @__PURE__ */ React658.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React658.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React658.createElement("path", { d: "M4 8a4 4 0 118 0 4 4 0 01-8 0zm12 1V7h-2a6 6 0 00-1.1-2.5L14.4 3l-1.5-1.4-1.4 1.5a6 6 0 00-2.5-1V0H7v2a6 6 0 00-2.5 1.1L3 1.6 1.6 3l1.5 1.5a6 6 0 00-1 2.5H0v2h2a6 6 0 001.1 2.5l-1.5 1.4L3 14.4l1.5-1.5a6 6 0 002.5 1V16h2v-2a6 6 0 002.5-1.1l1.4 1.5 1.5-1.5-1.5-1.4a6 6 0 001-2.5H16z" }));
}

// src/components/icons/UiGearsV2.tsx
import * as React659 from "react";
var componentNameString653 = "UiGearsV2";
function UiGearsV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString653,
    ...props
  });
  return /* @__PURE__ */ React659.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React659.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React659.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8.3 4.6c-.7 0-1.4.3-2 .7l-1-1-1 1 1 1c-.4.6-.6 1.3-.7 2H3v1.4h1.6c0 .7.3 1.4.7 2l-1 1 1 1 1-1c.6.4 1.3.6 2 .7V15h1.4v-1.6c.7 0 1.4-.3 2-.7l1 1 1-1-1-1c.4-.6.6-1.3.7-2H15V8.3h-1.6c0-.7-.3-1.4-.7-2l1-1-1-1-1 1c-.6-.4-1.3-.6-2-.7V3H8.3v1.6zM9 6a3 3 0 100 6 3 3 0 000-6zm7.5 7.3l-.2-1-1.5.4.3 1a3 3 0 00-1.5 1.4l-1-.2-.3 1.4 1 .3a3.5 3.5 0 00.4 2l-.6.7 1 1 .7-.7c.6.4 1.3.6 2 .6l.3.9 1.4-.4-.2-1c.6-.2 1.1-.8 1.4-1.4l1 .3.3-1.5-.9-.2a3.5 3.5 0 00-.5-2l.6-.7-1-1-.7.6c-.6-.4-1.3-.6-2-.5zm2 3a2 2 0 10-3.7 1 2 2 0 003.7-1z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiGift.tsx
import * as React660 from "react";
var componentNameString654 = "UiGift";
function UiGift({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString654,
    ...props
  });
  return /* @__PURE__ */ React660.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React660.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React660.createElement("path", { d: "M0 16h16V8H0v8zm2-2v-4h12v4H2zM12 0l1.4 1.4L10.8 4H16v2H0V4h5.2L2.6 1.4 4 0l4 4 4-4z" }));
}

// src/components/icons/UiGraphBar.tsx
import * as React661 from "react";
var componentNameString655 = "UiGraphBar";
function UiGraphBar({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString655,
    ...props
  });
  return /* @__PURE__ */ React661.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React661.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React661.createElement("path", { d: "M13 16V0h2v16h-2zm-4 0V4h2v12H9zm-4 0V8h2v8H5zm-4 0v-4h2v4H1z" }));
}

// src/components/icons/UiGraphPie.tsx
import * as React662 from "react";
var componentNameString656 = "UiGraphPie";
function UiGraphPie({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString656,
    ...props
  });
  return /* @__PURE__ */ React662.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React662.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React662.createElement("g", { clipPath: "url(#ui--graph-pie_svg__ui--graph-pie_svg__clip0)" }, /* @__PURE__ */ React662.createElement("path", { d: "M7 14a5 5 0 01-1-9.9V10h5.9A5 5 0 017 14zm6-5H7V2a7 7 0 107 7h-1zM9 0v7h7a7 7 0 00-7-7zm1 6V2.1A5 5 0 0113.9 6H10z" })), /* @__PURE__ */ React662.createElement("defs", null, /* @__PURE__ */ React662.createElement("clipPath", { id: "ui--graph-pie_svg__ui--graph-pie_svg__clip0" }, /* @__PURE__ */ React662.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiGraphSteps.tsx
import * as React663 from "react";
var componentNameString657 = "UiGraphSteps";
function UiGraphSteps({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString657,
    ...props
  });
  return /* @__PURE__ */ React663.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React663.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React663.createElement("path", { d: "M10 0v5H5v5H0v6h16V0h-6zM2 12h5V7h5V2h2v12H2v-2z" }));
}

// src/components/icons/UiHamburger.tsx
import * as React664 from "react";
var componentNameString658 = "UiHamburger";
function UiHamburger({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString658,
    ...props
  });
  return /* @__PURE__ */ React664.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React664.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React664.createElement("path", { d: "M0 9V7h16v2H0zm0-4V3h16v2H0zm0 8v-2h16v2H0z" }));
}

// src/components/icons/UiHomeV2.tsx
import * as React665 from "react";
var componentNameString659 = "UiHomeV2";
function UiHomeV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString659,
    ...props
  });
  return /* @__PURE__ */ React665.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React665.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React665.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 2.8l9 6.6V21h-7.5v-7.5h-3V21H3V9.4l9-6.6zm-7.5 7.3v9.4H9V12h6v7.5h4.5v-9.4L12 4.7 4.5 10z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiHouse.tsx
import * as React666 from "react";
var componentNameString660 = "UiHouse";
function UiHouse({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString660,
    ...props
  });
  return /* @__PURE__ */ React666.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React666.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React666.createElement("path", { d: "M8 0L0 6v10h7v-6h2v6h7V6L8 0zM2 7l6-4.5L14 7v7h-3V8H5v6H2V7z" }));
}

// src/components/icons/UiImage.tsx
import * as React667 from "react";
var componentNameString661 = "UiImage";
function UiImage({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString661,
    ...props
  });
  return /* @__PURE__ */ React667.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React667.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React667.createElement("path", { fillRule: "evenodd", d: "M0 0h16v16H0V0zm1.3 1.3v13.4h13.4V1.3H1.3z", clipRule: "evenodd" }), /* @__PURE__ */ React667.createElement("path", { d: "M6.7 5.3a1.3 1.3 0 11-2.7 0 1.3 1.3 0 012.7 0z" }), /* @__PURE__ */ React667.createElement("path", { d: "M13.3 13.3l-4-6-2.6 4-1.4-2-2.6 4h10.6z" }));
}

// src/components/icons/UiInfoCircleV2.tsx
import * as React668 from "react";
var componentNameString662 = "UiInfoCircleV2";
function UiInfoCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString662,
    ...props
  });
  return /* @__PURE__ */ React668.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React668.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React668.createElement("path", { fillRule: "evenodd", d: "M11.3 18V9h1.4v9h-1.4z", clipRule: "evenodd" }), /* @__PURE__ */ React668.createElement("path", { d: "M11.3 6h1.4v1.5h-1.4V6z" }), /* @__PURE__ */ React668.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1.5 12a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiInfoV2.tsx
import * as React669 from "react";
var componentNameString663 = "UiInfoV2";
function UiInfoV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString663,
    ...props
  });
  return /* @__PURE__ */ React669.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React669.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React669.createElement("path", { fillRule: "evenodd", d: "M21 8.3H6V6.7h15v1.5zm0 4.4H6v-1.4h15v1.4zm0 4.6H6v-1.6h15v1.6z", clipRule: "evenodd" }), /* @__PURE__ */ React669.createElement("path", { d: "M3 6.8h1.5v1.5H3V6.7z" }), /* @__PURE__ */ React669.createElement("path", { d: "M3 11.3h1.5v1.4H3v-1.4z" }), /* @__PURE__ */ React669.createElement("path", { d: "M3 15.8h1.5v1.4H3v-1.4z" }));
}

// src/components/icons/UiInfo.tsx
import * as React670 from "react";
var componentNameString664 = "UiInfo";
function UiInfo({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString664,
    ...props
  });
  return /* @__PURE__ */ React670.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React670.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React670.createElement("path", { d: "M4 9V7h12v2H4zm0-5V2h12v2H4zm0 10v-2h12v2H4zM0 9V7h2v2H0zm0-5V2h2v2H0zm0 10v-2h2v2H0z" }));
}

// src/components/icons/UiLaptopV2.tsx
import * as React671 from "react";
var componentNameString665 = "UiLaptopV2";
function UiLaptopV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString665,
    ...props
  });
  return /* @__PURE__ */ React671.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React671.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React671.createElement("path", { fillRule: "evenodd", d: "M21 4.5H3v12h18v-12zM4.5 15V6h15v9h-15zm-3 4.5h21V18h-21v1.5z", clipRule: "evenodd" }));
}

// src/components/icons/UiLaptop.tsx
import * as React672 from "react";
var componentNameString666 = "UiLaptop";
function UiLaptop({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString666,
    ...props
  });
  return /* @__PURE__ */ React672.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React672.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React672.createElement("path", { d: "M0 15v-2h16v2H0zm2-4V2h12v9H2zm2-2h8V4H4v5z" }));
}

// src/components/icons/UiLeftAndroidV2.tsx
import * as React673 from "react";
var componentNameString667 = "UiLeftAndroidV2";
function UiLeftAndroidV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString667,
    ...props
  });
  return /* @__PURE__ */ React673.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React673.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React673.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.5 10.7h-16l7.3-7.4L12 1.5 1.5 12 12 22.5l1.8-1.8-7.3-7.4h16v-2.6z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiLeftAndroid.tsx
import * as React674 from "react";
var componentNameString668 = "UiLeftAndroid";
function UiLeftAndroid({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString668,
    ...props
  });
  return /* @__PURE__ */ React674.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React674.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React674.createElement("path", { fillRule: "evenodd", d: "M16 7H3.8l5.6-5.6L8 0 0 8l8 8 1.4-1.4L3.8 9H16V7z", clipRule: "evenodd" }));
}

// src/components/icons/UiLetter.tsx
import * as React675 from "react";
var componentNameString669 = "UiLetter";
function UiLetter({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString669,
    ...props
  });
  return /* @__PURE__ */ React675.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React675.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React675.createElement("path", { d: "M0 13h16V3H0v10zm2-7V5h12v1L8 9 2 6zm12 1v4H2V7l6 3 6-3z" }));
}

// src/components/icons/UiLightningBolt.tsx
import * as React676 from "react";
var componentNameString670 = "UiLightningBolt";
function UiLightningBolt({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString670,
    ...props
  });
  return /* @__PURE__ */ React676.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React676.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React676.createElement("path", { d: "M4 9.9l1.4 1.4 4.3-4.2-1.5-1.4L4 9.9zM9.7 0L4 5.7 5.4 7l5.7-5.7L9.7 0zM4 14.1l1.4 1.5 2.8-2.9-1.4-1.4L4 14.1z" }));
}

// src/components/icons/UiLightningCircleCrossedV2.tsx
import * as React677 from "react";
var componentNameString671 = "UiLightningCircleCrossedV2";
function UiLightningCircleCrossedV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString671,
    ...props
  });
  return /* @__PURE__ */ React677.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React677.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React677.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 22.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21zm6.9-4.7A9 9 0 006.2 5.1l4 4L12 6v4.5h4.5l-1.9 3 4.3 4.3zm-1 1A9 9 0 015.1 6.2l4.2 4.3-1.9 3.1H12V18l1.9-3 4 3.9z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiLightningCircleV2.tsx
import * as React678 from "react";
var componentNameString672 = "UiLightningCircleV2";
function UiLightningCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString672,
    ...props
  });
  return /* @__PURE__ */ React678.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React678.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React678.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0zm1.5 0a10.5 10.5 0 11-21 0 10.5 10.5 0 0121 0zm-15 1.5L12 6v4.5h4.5L12 18v-4.5H7.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiLightningFillV2.tsx
import * as React679 from "react";
var componentNameString673 = "UiLightningFillV2";
function UiLightningFillV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString673,
    ...props
  });
  return /* @__PURE__ */ React679.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React679.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React679.createElement("path", { d: "M12.8 9.8V2L4.6 14.3h6.7V22l8.1-12.2h-6.6z" }));
}

// src/components/icons/UiLightningOutlineV2.tsx
import * as React680 from "react";
var componentNameString674 = "UiLightningOutlineV2";
function UiLightningOutlineV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString674,
    ...props
  });
  return /* @__PURE__ */ React680.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React680.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React680.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.8 2v7.8h6.6L11.3 22v-7.8H4.5L12.7 2zM7.3 12.8h5.3V17l3.9-5.8h-5.4V7l-3.8 5.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiLinkV2.tsx
import * as React681 from "react";
var componentNameString675 = "UiLinkV2";
function UiLinkV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString675,
    ...props
  });
  return /* @__PURE__ */ React681.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React681.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React681.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13 19.4a4.5 4.5 0 106.4-6.3l-3.2-3.2-1 1 3.2 3.2a3 3 0 01-4.3 4.3L11 15.2l-1 1 3.2 3.2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React681.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.6 11a4.5 4.5 0 116.3-6.4l3.2 3.2-1 1-3.2-3.2A3 3 0 105.6 10l3.2 3-1 1-3.2-3z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React681.createElement("path", { fillRule: "evenodd", d: "M8.3 9.3l6.4 6.4 1-1-6.4-6.4-1 1z", clipRule: "evenodd" }));
}

// src/components/icons/UiLockV2.tsx
import * as React682 from "react";
var componentNameString676 = "UiLockV2";
function UiLockV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString676,
    ...props
  });
  return /* @__PURE__ */ React682.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React682.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React682.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 17.3a2.3 2.3 0 100-4.6 2.3 2.3 0 000 4.6zm0 1.4a3.7 3.7 0 100-7.4 3.7 3.7 0 000 7.4z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React682.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 1.5c-2 0-3.8 1.7-3.8 3.8v3.2a7.5 7.5 0 107.6 0V5.2c0-2-1.7-3.7-3.8-3.7zm2.3 6.3V5.3a2.3 2.3 0 00-4.6 0v2.5a7.5 7.5 0 014.6 0zM18 15a6 6 0 11-12 0 6 6 0 0112 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiLock.tsx
import * as React683 from "react";
var componentNameString677 = "UiLock";
function UiLock({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString677,
    ...props
  });
  return /* @__PURE__ */ React683.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React683.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React683.createElement("path", { d: "M1 16V7h14v9H1zm2-2h10V9H3v5zm4-1v-3h2v3H7zm6-8h-2a3 3 0 00-6 0H3a5 5 0 1110 0z" }));
}

// src/components/icons/UiMenuCircleV2.tsx
import * as React684 from "react";
var componentNameString678 = "UiMenuCircleV2";
function UiMenuCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString678,
    ...props
  });
  return /* @__PURE__ */ React684.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React684.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React684.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 21a9 9 0 100-18 9 9 0 000 18zm0 1.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React684.createElement("path", { fillRule: "evenodd", d: "M16.5 9h-9V7.5h9V9zm0 3.8h-9v-1.6h9v1.6zm0 3.7h-9V15h9v1.5z", clipRule: "evenodd" }));
}

// src/components/icons/UiMenuV2.tsx
import * as React685 from "react";
var componentNameString679 = "UiMenuV2";
function UiMenuV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString679,
    ...props
  });
  return /* @__PURE__ */ React685.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React685.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React685.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.5 8.3h-15V6.7h15v1.5zm0 4.4h-15v-1.4h15v1.4zm0 4.6h-15v-1.6h15v1.6z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiMessageV2.tsx
import * as React686 from "react";
var componentNameString680 = "UiMessageV2";
function UiMessageV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString680,
    ...props
  });
  return /* @__PURE__ */ React686.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React686.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React686.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18 7.5H6l6 4.3 6-4.3zm-13.5.7v8.3h15V8.2L12 13.7 4.5 8.2zM3 18V6h18v12H3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiMinusArrowCircleV2.tsx
import * as React687 from "react";
var componentNameString681 = "UiMinusArrowCircleV2";
function UiMinusArrowCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString681,
    ...props
  });
  return /* @__PURE__ */ React687.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React687.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React687.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 6a6 6 0 016 6v4.2l-1.7-1.7-1 1 3.4 3.6 3.6-3.6-1-1-1.8 1.7V12c0-4.1-3.4-7.5-7.5-7.5V6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React687.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18a6 6 0 01-6-6V7.8l1.7 1.7 1-1-3.4-3.6-3.6 3.6 1 1 1.8-1.7V12c0 4.1 3.4 7.5 7.5 7.5V18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React687.createElement("path", { fillRule: "evenodd", d: "M15 12.8H9v-1.6h6v1.6z", clipRule: "evenodd" }));
}

// src/components/icons/UiMinusCircleV2.tsx
import * as React688 from "react";
var componentNameString682 = "UiMinusCircleV2";
function UiMinusCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString682,
    ...props
  });
  return /* @__PURE__ */ React688.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React688.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React688.createElement("path", { fillRule: "evenodd", d: "M16.5 12.8h-9v-1.6h9v1.6z", clipRule: "evenodd" }), /* @__PURE__ */ React688.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1.5 12a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiMinusCircle.tsx
import * as React689 from "react";
var componentNameString683 = "UiMinusCircle";
function UiMinusCircle({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString683,
    ...props
  });
  return /* @__PURE__ */ React689.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React689.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React689.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M11.4 8.6H4.6V7.4h6.8v1.2zM8 15A7 7 0 118 1a7 7 0 010 14M0 8a8 8 0 1016 0A8 8 0 000 8z"
    }
  ));
}

// src/components/icons/UiMinusV2.tsx
import * as React690 from "react";
var componentNameString684 = "UiMinusV2";
function UiMinusV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString684,
    ...props
  });
  return /* @__PURE__ */ React690.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React690.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React690.createElement("path", { fillRule: "evenodd", d: "M4.5 11.3h15v1.4h-15v-1.4z", clipRule: "evenodd" }));
}

// src/components/icons/UiMinus.tsx
import * as React691 from "react";
var componentNameString685 = "UiMinus";
function UiMinus({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString685,
    ...props
  });
  return /* @__PURE__ */ React691.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React691.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React691.createElement("path", { d: "M16 7H0v2h16V7z" }));
}

// src/components/icons/UiMobileV2.tsx
import * as React692 from "react";
var componentNameString686 = "UiMobileV2";
function UiMobileV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString686,
    ...props
  });
  return /* @__PURE__ */ React692.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React692.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React692.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5.3 22.5v-21h13.4v21H5.3zM6.8 21h10.4v-1.5H6.8V21zm0-3V6h10.4v12H6.8zm0-13.5h10.4V3H6.8v1.5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiMobile.tsx
import * as React693 from "react";
var componentNameString687 = "UiMobile";
function UiMobile({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString687,
    ...props
  });
  return /* @__PURE__ */ React693.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React693.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React693.createElement("path", { d: "M2 16V0h12v16H2zm2-4h8V2H4v10zm4 3.3a1.3 1.3 0 100-2.6 1.3 1.3 0 000 2.6z" }));
}

// src/components/icons/UiOpenV2.tsx
import * as React694 from "react";
var componentNameString688 = "UiOpenV2";
function UiOpenV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString688,
    ...props
  });
  return /* @__PURE__ */ React694.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React694.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React694.createElement("path", { fillRule: "evenodd", d: "M3 3h7.5v1.5h-6v15h15v-6H21V21H3V3z", clipRule: "evenodd" }), /* @__PURE__ */ React694.createElement("path", { fillRule: "evenodd", d: "M13.5 3H21v7.5h-1.5v-5L8 17l-1-1L18.4 4.5h-4.9V3z", clipRule: "evenodd" }));
}

// src/components/icons/UiOpenedMessageV2.tsx
import * as React695 from "react";
var componentNameString689 = "UiOpenedMessageV2";
function UiOpenedMessageV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString689,
    ...props
  });
  return /* @__PURE__ */ React695.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React695.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React695.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19 9.8l-7-5-7 5 7 5 7-5zM4.4 11.2v8.3h15v-8.3L12 16.7l-7.5-5.5zM21 9.4L12 3 3 9.4V21h18V9.4z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiOpposingArrowsCircleV2.tsx
import * as React696 from "react";
var componentNameString690 = "UiOpposingArrowsCircleV2";
function UiOpposingArrowsCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString690,
    ...props
  });
  return /* @__PURE__ */ React696.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React696.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React696.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.5 9.9h6.4l-1.2 1.4 1.1 1L16.5 9l-2.7-3-1.1 1 1.2 1.4H7.5v1.5zm3.8 2.9L10.1 14h6.4v1.5h-6.4l1.2 1.4-1.1 1-2.7-3.1 2.7-3.1 1.1 1zm.7 8.4a9.2 9.2 0 110-18.4 9.2 9.2 0 010 18.4zM1.5 12a10.5 10.5 0 1021 0 10.5 10.5 0 00-21 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiOpposingArrowsCircle.tsx
import * as React697 from "react";
var componentNameString691 = "UiOpposingArrowsCircle";
function UiOpposingArrowsCircle({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString691,
    ...props
  });
  return /* @__PURE__ */ React697.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React697.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React697.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.6 6.4h4.8l-.9 1 .9.8 2-2.4-2-2.4-.9.8 1 1h-5v1.2zm2.9 2.2l-1 1h5v1.2h-5l1 1-.9.8-2-2.4 2-2.4.9.8zM8 15A7 7 0 118 1a7 7 0 010 14M0 8a8 8 0 1016 0A8 8 0 000 8z"
    }
  ));
}

// src/components/icons/UiOpposingArrows.tsx
import * as React698 from "react";
var componentNameString692 = "UiOpposingArrows";
function UiOpposingArrows({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString692,
    ...props
  });
  return /* @__PURE__ */ React698.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React698.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React698.createElement("path", { d: "M11.7 0l-1.4 1.4 1.9 2H0v2h12.2l-2 1.9 1.5 1.4L16 4.3 11.7 0zM0 11.7L4.3 16l1.4-1.4-1.9-2H16v-2H3.8l2-1.9-1.5-1.4L0 11.7z" }));
}

// src/components/icons/UiPerformanceV2.tsx
import * as React699 from "react";
var componentNameString693 = "UiPerformanceV2";
function UiPerformanceV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString693,
    ...props
  });
  return /* @__PURE__ */ React699.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React699.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React699.createElement("path", { fillRule: "evenodd", d: "M4.5 21v-6H6v6H4.5z", clipRule: "evenodd" }), /* @__PURE__ */ React699.createElement("path", { fillRule: "evenodd", d: "M9 21v-9h1.5v9H9z", clipRule: "evenodd" }), /* @__PURE__ */ React699.createElement("path", { fillRule: "evenodd", d: "M13.5 21V7.5H15V21h-1.5z", clipRule: "evenodd" }), /* @__PURE__ */ React699.createElement("path", { fillRule: "evenodd", d: "M18 21V3h1.5v18H18z", clipRule: "evenodd" }));
}

// src/components/icons/UiPersonV2.tsx
import * as React700 from "react";
var componentNameString694 = "UiPersonV2";
function UiPersonV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString694,
    ...props
  });
  return /* @__PURE__ */ React700.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React700.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React700.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 10.5a3 3 0 100-6 3 3 0 000 6zm0 1.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React700.createElement("path", { fillRule: "evenodd", d: "M12 15a6 6 0 00-6 6H4.5a7.5 7.5 0 0115 0H18a6 6 0 00-6-6z", clipRule: "evenodd" }));
}

// src/components/icons/UiPerson.tsx
import * as React701 from "react";
var componentNameString695 = "UiPerson";
function UiPerson({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString695,
    ...props
  });
  return /* @__PURE__ */ React701.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React701.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React701.createElement("path", { d: "M8 7.5A3.8 3.8 0 118 0a3.8 3.8 0 010 7.5zM1 16a7.3 7.3 0 1114.5 0H1z" }));
}

// src/components/icons/UiPhoto2V2.tsx
import * as React702 from "react";
var componentNameString696 = "UiPhoto2V2";
function UiPhoto2V2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString696,
    ...props
  });
  return /* @__PURE__ */ React702.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React702.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React702.createElement("path", { fillRule: "evenodd", d: "M3 3h18v18H3V3zm1.5 1.5v15h15v-15h-15z", clipRule: "evenodd" }), /* @__PURE__ */ React702.createElement("path", { d: "M10.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }), /* @__PURE__ */ React702.createElement("path", { d: "M18 18l-4.5-6.8-3 4.6L9 13.4 6 18h12z" }));
}

// src/components/icons/UiPhotoV2.tsx
import * as React703 from "react";
var componentNameString697 = "UiPhotoV2";
function UiPhotoV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString697,
    ...props
  });
  return /* @__PURE__ */ React703.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React703.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React703.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M1.5 4.5h21v15h-21v-15zM3 6v12h18V6H3zm4.5 3a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11.9 7.5l-5.9-8.9-3 4.5L9 10l-4.4 6.6h14.8zm-8.9-1.6l3-4.5 3.1 4.6H7.4L9 12.6l1.5 2.3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiPieChartV2.tsx
import * as React704 from "react";
var componentNameString698 = "UiPieChartV2";
function UiPieChartV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString698,
    ...props
  });
  return /* @__PURE__ */ React704.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React704.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React704.createElement("path", { fillRule: "evenodd", d: "M18 12.8A6 6 0 1111.2 6V4.5a7.5 7.5 0 108.3 8.3H18z", clipRule: "evenodd" }), /* @__PURE__ */ React704.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12.8 11.3V3a9 9 0 018.2 8.3h-8.3zm6.4-1.6a7.5 7.5 0 00-5-4.9v5h5z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiPinV2.tsx
import * as React705 from "react";
var componentNameString699 = "UiPinV2";
function UiPinV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString699,
    ...props
  });
  return /* @__PURE__ */ React705.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React705.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React705.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.5 4.5h-3v3h3v-3zm3 0h3v3h-3v-3zm6 0h3v3h-3v-3zm-6 6h3v3h-3v-3zm9 0h-3v3h3v-3zm-15 0h3v3h-3v-3zm9 6h-3v3h3v-3zm3 0h3v3h-3v-3zm-9 0h-3v3h3v-3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiPin.tsx
import * as React706 from "react";
var componentNameString700 = "UiPin";
function UiPin({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString700,
    ...props
  });
  return /* @__PURE__ */ React706.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React706.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React706.createElement("circle", { cx: 2, cy: 2, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 8, cy: 2, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 14, cy: 2, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 2, cy: 8, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 8, cy: 8, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 14, cy: 8, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 2, cy: 14, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 8, cy: 14, r: 2 }), /* @__PURE__ */ React706.createElement("circle", { cx: 14, cy: 14, r: 2 }));
}

// src/components/icons/UiPlusArrowCircleV2.tsx
import * as React707 from "react";
var componentNameString701 = "UiPlusArrowCircleV2";
function UiPlusArrowCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString701,
    ...props
  });
  return /* @__PURE__ */ React707.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React707.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React707.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 6a6 6 0 016 6v4.2l-1.7-1.7-1 1 3.4 3.6 3.6-3.6-1-1-1.8 1.7V12c0-4.1-3.4-7.5-7.5-7.5V6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React707.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 18a6 6 0 01-6-6V7.8l1.7 1.7 1-1-3.4-3.6-3.6 3.6 1 1 1.8-1.7V12c0 4.1 3.4 7.5 7.5 7.5V18z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React707.createElement("path", { fillRule: "evenodd", d: "M11.3 12.8V15h1.4v-2.3H15v-1.4h-2.3V9h-1.4v2.3H9v1.4h2.3z", clipRule: "evenodd" }));
}

// src/components/icons/UiPlusCircleV2.tsx
import * as React708 from "react";
var componentNameString702 = "UiPlusCircleV2";
function UiPlusCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString702,
    ...props
  });
  return /* @__PURE__ */ React708.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React708.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React708.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 12a9 9 0 1118 0 9 9 0 01-18 0zm9-10.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zm-.8 15v-3.8H7.5v-1.4h3.8V7.5h1.4v3.8h3.8v1.4h-3.8v3.8h-1.4z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiPlusCircle.tsx
import * as React709 from "react";
var componentNameString703 = "UiPlusCircle";
function UiPlusCircle({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString703,
    ...props
  });
  return /* @__PURE__ */ React709.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React709.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React709.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.4 8.6v2.8h1.2V8.6h2.8V7.4H8.6V4.6H7.4v2.8H4.6v1.2h2.8zM8 15A7 7 0 118 1a7 7 0 010 14M0 8a8 8 0 1016 0A8 8 0 000 8z"
    }
  ));
}

// src/components/icons/UiPlusV2.tsx
import * as React710 from "react";
var componentNameString704 = "UiPlusV2";
function UiPlusV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString704,
    ...props
  });
  return /* @__PURE__ */ React710.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React710.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React710.createElement("path", { fillRule: "evenodd", d: "M11.3 12.8v6.7h1.4v-6.8h6.8v-1.4h-6.8V4.5h-1.4v6.8H4.5v1.4h6.8z", clipRule: "evenodd" }));
}

// src/components/icons/UiPlus.tsx
import * as React711 from "react";
var componentNameString705 = "UiPlus";
function UiPlus({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString705,
    ...props
  });
  return /* @__PURE__ */ React711.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React711.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React711.createElement("path", { d: "M7 0v7H0v2h7v7h2V9h7V7H9V0H7z" }));
}

// src/components/icons/UiPortfolioCheck.tsx
import * as React712 from "react";
var componentNameString706 = "UiPortfolioCheck";
function UiPortfolioCheck({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString706,
    ...props
  });
  return /* @__PURE__ */ React712.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React712.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React712.createElement("path", { d: "M4 3h12v11H0V1h4v2zm4.5 7.6l4.4-4.4-1.5-1.5L7 9.1l-2-2-1.6 1.4L7 12.1l1.5-1.5z" }));
}

// src/components/icons/UiPortfolio.tsx
import * as React713 from "react";
var componentNameString707 = "UiPortfolio";
function UiPortfolio({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString707,
    ...props
  });
  return /* @__PURE__ */ React713.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React713.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React713.createElement("path", { d: "M0 1v14h16V3H6V1H0zm2 2h2v2h10v8H2V3z" }));
}

// src/components/icons/UiPowerV2.tsx
import * as React714 from "react";
var componentNameString708 = "UiPowerV2";
function UiPowerV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString708,
    ...props
  });
  return /* @__PURE__ */ React714.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React714.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React714.createElement("path", { fillRule: "evenodd", d: "M7.8 7.8a6 6 0 108.4 0l1.1-1.1a7.5 7.5 0 11-10.6 0l1 1z", clipRule: "evenodd" }), /* @__PURE__ */ React714.createElement("path", { fillRule: "evenodd", d: "M11.3 12V4.5h1.4V12h-1.4z", clipRule: "evenodd" }));
}

// src/components/icons/UiPower.tsx
import * as React715 from "react";
var componentNameString709 = "UiPower";
function UiPower({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString709,
    ...props
  });
  return /* @__PURE__ */ React715.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React715.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React715.createElement("g", { clipPath: "url(#ui--power_svg__ui--power_svg__clip0)" }, /* @__PURE__ */ React715.createElement("path", { d: "M13.7 2.3l-1.5 1.5A6 6 0 018 14 6 6 0 013.8 3.8L2.3 2.3A8 8 0 008 16a8 8 0 005.7-13.7zM7 8h2V0H7v8z" })), /* @__PURE__ */ React715.createElement("defs", null, /* @__PURE__ */ React715.createElement("clipPath", { id: "ui--power_svg__ui--power_svg__clip0" }, /* @__PURE__ */ React715.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiPreferencesV2.tsx
import * as React716 from "react";
var componentNameString710 = "UiPreferencesV2";
function UiPreferencesV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString710,
    ...props
  });
  return /* @__PURE__ */ React716.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React716.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React716.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8.3 6.8a.8.8 0 111.5 0 .8.8 0 01-1.6 0zM6.8 6H3v1.5h3.9a2.3 2.3 0 004.2 0H21V6h-9.9A2.3 2.3 0 007 6z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React716.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M8.3 17.3a.8.8 0 111.5 0 .8.8 0 01-1.6 0zm-1.4-.8H3V18h3.9a2.3 2.3 0 004.2 0H21v-1.5h-9.9a2.3 2.3 0 00-4.2 0z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React716.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.3 12a.8.8 0 111.5 0 .8.8 0 01-1.6 0zm-1.4.8H3v-1.6h9.9a2.3 2.3 0 014.2 0H21v1.6h-3.9a2.3 2.3 0 01-4.2 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiPresentationBoard.tsx
import * as React717 from "react";
var componentNameString711 = "UiPresentationBoard";
function UiPresentationBoard({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString711,
    ...props
  });
  return /* @__PURE__ */ React717.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React717.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React717.createElement("path", { d: "M7 14v-3h2v3h2v2H5v-2h2zm7-12v8H2V2H0V0h16v2h-2zM7 4v4h2V4H7zM4 6v2h2V6H4zm6-1v3h2V5h-2z" }));
}

// src/components/icons/UiPresentationV2.tsx
import * as React718 from "react";
var componentNameString712 = "UiPresentationV2";
function UiPresentationV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString712,
    ...props
  });
  return /* @__PURE__ */ React718.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React718.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React718.createElement("path", { fillRule: "evenodd", d: "M20.3 6H3.6V4.5h16.6V6z", clipRule: "evenodd" }), /* @__PURE__ */ React718.createElement("path", { fillRule: "evenodd", d: "M6.8 13.5v-6H5.3V15h13.4V7.5h-1.4v6H6.7z", clipRule: "evenodd" }), /* @__PURE__ */ React718.createElement("path", { fillRule: "evenodd", d: "M11.3 12V9h1.4v3h-1.4z", clipRule: "evenodd" }), /* @__PURE__ */ React718.createElement("path", { fillRule: "evenodd", d: "M8.3 12v-1.5h1.4V12H8.3z", clipRule: "evenodd" }), /* @__PURE__ */ React718.createElement("path", { fillRule: "evenodd", d: "M14.3 12V7.5h1.4V12h-1.4z", clipRule: "evenodd" }), /* @__PURE__ */ React718.createElement("path", { fillRule: "evenodd", d: "M11.3 16.5v3H7.5V21h9v-1.5h-3.8v-3h-1.4z", clipRule: "evenodd" }));
}

// src/components/icons/UiQuestionMarkCircleV2.tsx
import * as React719 from "react";
var componentNameString713 = "UiQuestionMarkCircleV2";
function UiQuestionMarkCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString713,
    ...props
  });
  return /* @__PURE__ */ React719.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React719.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React719.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 21a9 9 0 100-18 9 9 0 000 18zm0 1.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React719.createElement("path", { d: "M11.3 16.5h1.4V18h-1.4v-1.5z" }), /* @__PURE__ */ React719.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 7.5a3 3 0 00-3 3H7.5A4.5 4.5 0 1112 15h-.8v-1.5h.8a3 3 0 100-6z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiQuestionMarkV2.tsx
import * as React720 from "react";
var componentNameString714 = "UiQuestionMarkV2";
function UiQuestionMarkV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString714,
    ...props
  });
  return /* @__PURE__ */ React720.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React720.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React720.createElement("path", { d: "M11.3 18h1.4v1.5h-1.4V18z" }), /* @__PURE__ */ React720.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 6c-2 0-3.8 1.7-3.8 3.8H6.8a5.2 5.2 0 116 5.1v1.6h-1.6v-3h.8A3.7 3.7 0 1012 6z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiQuestion.tsx
import * as React721 from "react";
var componentNameString715 = "UiQuestion";
function UiQuestion({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString715,
    ...props
  });
  return /* @__PURE__ */ React721.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React721.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React721.createElement("path", { d: "M6.8 11.2c0-.5 0-1 .2-1.4.2-.5.5-1 1-1.4l1.1-1L10.2 6c.3-.4.5-1 .5-1.6 0-.8-.3-1.5-.8-2-.5-.4-1.2-.7-2-.7-.9 0-1.6.3-2.1.9C5.2 3 5 3.9 5 4.9V6l-2-.2V4.6c0-1.4.4-2.5 1.3-3.3C5 .4 6.3 0 7.9 0c1.5 0 2.7.4 3.6 1.2.8.7 1.2 1.8 1.2 3.2 0 1.3-.6 2.6-2 3.8l-1.1 1-.7 1c-.2.4-.2.8-.2 1.3v.6H6.8v-.9zM7 16h2v-2H7v2z" }));
}

// src/components/icons/UiQuoteV2.tsx
import * as React722 from "react";
var componentNameString716 = "UiQuoteV2";
function UiQuoteV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString716,
    ...props
  });
  return /* @__PURE__ */ React722.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React722.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React722.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M7.5 6C6.7 6 6 6.7 6 7.5v.8h1.5v3h-3V7.5a3 3 0 013-3V6zM12 8.3h-1.5v-.8c0-.8.7-1.5 1.5-1.5V4.5a3 3 0 00-3 3v3.8h3v-3zm3 4.4h-3v3h1.5v.8c0 .8-.7 1.5-1.5 1.5v1.5a3 3 0 003-3v-3.8zm1.5 0h3v3.8a3 3 0 01-3 3V18c.8 0 1.5-.7 1.5-1.5v-.8h-1.5v-3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiQuote.tsx
import * as React723 from "react";
var componentNameString717 = "UiQuote";
function UiQuote({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString717,
    ...props
  });
  return /* @__PURE__ */ React723.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React723.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React723.createElement("g", { clipPath: "url(#ui--quote_svg__ui--quote_svg__clip0)" }, /* @__PURE__ */ React723.createElement("path", { d: "M6.6 4.2c-1 .4-1.6 1-2 1.5a5 5 0 00-.4 2.5v.2H7V16H0V8.9a9 9 0 011.2-5C2 2.6 3.2 1.6 5 1l1.6 3.2zm9 0c-1 .4-1.6 1-2 1.5a5 5 0 00-.4 2.5v.2H16V16H9V8.9a9 9 0 011.2-5c.8-1.3 2-2.3 3.8-2.9l1.6 3.2z" })), /* @__PURE__ */ React723.createElement("defs", null, /* @__PURE__ */ React723.createElement("clipPath", { id: "ui--quote_svg__ui--quote_svg__clip0" }, /* @__PURE__ */ React723.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiRedoV2.tsx
import * as React724 from "react";
var componentNameString718 = "UiRedoV2";
function UiRedoV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString718,
    ...props
  });
  return /* @__PURE__ */ React724.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React724.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React724.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 6a6 6 0 016 6v4.2l-1.7-1.7-1 1 3.4 3.6 3.6-3.6-1-1-1.8 1.7V12a7.5 7.5 0 10-7.5 7.5V18a6 6 0 010-12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiReviewDocsV2.tsx
import * as React725 from "react";
var componentNameString719 = "UiReviewDocsV2";
function UiReviewDocsV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString719,
    ...props
  });
  return /* @__PURE__ */ React725.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React725.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React725.createElement("path", { d: "M11.4 5.3H2.2v14.2H15v-6.4h-1.4v5H3.7V6.7h7.7V5.2z" }), /* @__PURE__ */ React725.createElement("path", { d: "M5.8 10.2h5.6V8.8H5.8v1.4z" }), /* @__PURE__ */ React725.createElement("path", { d: "M5.8 13h5.6v-1.3H5.8V13z" }), /* @__PURE__ */ React725.createElement("path", { d: "M5.8 16h5.6v-1.5H5.8V16z" }), /* @__PURE__ */ React725.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.6 10.8a3.6 3.6 0 00-3-5.6c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c.7 0 1.4-.2 2-.6l3.2 3.2 1-1-3.2-3.2zm-5-2a2 2 0 012-2.1c1.2 0 2.1 1 2.1 2.1a2 2 0 01-2 2.1c-1.2 0-2.2-1-2.2-2z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiRewardsV2.tsx
import * as React726 from "react";
var componentNameString720 = "UiRewardsV2";
function UiRewardsV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString720,
    ...props
  });
  return /* @__PURE__ */ React726.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React726.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React726.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.5 19.5h-6.8v-6.8h6.8v6.8zm0-8.3h-6.8v-3h6.8v3zm-8.3 0v-3H4.5v3h6.8zm-6.7 1.6v6.7h6.8v-6.8H4.5zM3 6.8h7.2l-2-2 1.1-1 2 1.9V3h1.4v2.7l2-2 1 1.1-1.9 2H21V21H3V6.7z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiSearchV2.tsx
import * as React727 from "react";
var componentNameString721 = "UiSearchV2";
function UiSearchV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString721,
    ...props
  });
  return /* @__PURE__ */ React727.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React727.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React727.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M14.3 9.4a4.9 4.9 0 11-9.8 0 4.9 4.9 0 019.8 0zm-1 5c-1 .8-2.4 1.3-4 1.3a6.4 6.4 0 115-2.4l6.5 6.4-1 1-6.5-6.3z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiSearch.tsx
import * as React728 from "react";
var componentNameString722 = "UiSearch";
function UiSearch({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString722,
    ...props
  });
  return /* @__PURE__ */ React728.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React728.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React728.createElement("g", { clipPath: "url(#ui--search_svg__ui--search_svg__clip0)" }, /* @__PURE__ */ React728.createElement("path", { d: "M2 5.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm8 3.2c.7-.9 1-2 1-3.2a5.5 5.5 0 10-2.3 4.6l5.8 5.9 1.4-1.4-5.8-5.9H10z" })), /* @__PURE__ */ React728.createElement("defs", null, /* @__PURE__ */ React728.createElement("clipPath", { id: "ui--search_svg__ui--search_svg__clip0" }, /* @__PURE__ */ React728.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiSettingsCircleV2.tsx
import * as React729 from "react";
var componentNameString723 = "UiSettingsCircleV2";
function UiSettingsCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString723,
    ...props
  });
  return /* @__PURE__ */ React729.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React729.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React729.createElement("g", { clipPath: "url(#ui--settings-circle-v2_svg__ui--settings-circle-v2_svg__clip0)" }, /* @__PURE__ */ React729.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0zm1.5 0a10.5 10.5 0 11-21 0 10.5 10.5 0 0121 0zM9 12a3 3 0 116 0 3 3 0 01-6 0zm3.8-6v1.6c.6 0 1.3.3 1.8.7l1.1-1 1 1-1 1c.4.6.6 1.3.7 2H18v1.4h-1.6c0 .7-.3 1.4-.7 2l1 1-1 1-1-1c-.6.4-1.3.6-2 .7V18h-1.4v-1.6c-.7 0-1.4-.3-2-.7l-1 1-1-1 1-1c-.4-.6-.6-1.3-.7-2H6v-1.4h1.6c0-.7.3-1.4.7-2l-1-1 1-1 1 1c.6-.4 1.3-.6 2-.7V6h1.4z",
      clipRule: "evenodd"
    }
  )), /* @__PURE__ */ React729.createElement("defs", null, /* @__PURE__ */ React729.createElement("clipPath", { id: "ui--settings-circle-v2_svg__ui--settings-circle-v2_svg__clip0" }, /* @__PURE__ */ React729.createElement("rect", { width: 24, height: 24 }))));
}

// src/components/icons/UiSettingsV2.tsx
import * as React730 from "react";
var componentNameString724 = "UiSettingsV2";
function UiSettingsV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString724,
    ...props
  });
  return /* @__PURE__ */ React730.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React730.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React730.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M21 12.8h-2.3a6.7 6.7 0 01-1.4 3.4l1.6 1.6-1 1-1.7-1.5a6 6 0 01-3.4 1.4V21h-1.6v-2.3a6.7 6.7 0 01-3.4-1.4l-1.6 1.6-1-1 1.5-1.7a6 6 0 01-1.4-3.4H3v-1.6h2.3a6 6 0 011.4-3.4L5.1 6.2l1-1 1.7 1.5a6 6 0 013.5-1.4V3h1.4v2.3a6 6 0 013.5 1.4l1.6-1.6 1 1-1.5 1.7a6 6 0 011.4 3.5H21v1.4zm-9-6a5.2 5.2 0 100 10.4 5.2 5.2 0 000-10.4z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiShieldV2.tsx
import * as React731 from "react";
var componentNameString725 = "UiShieldV2";
function UiShieldV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString725,
    ...props
  });
  return /* @__PURE__ */ React731.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React731.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React731.createElement("g", { clipPath: "url(#ui--shield-v2_svg__ui--shield-v2_svg__clip0)" }, /* @__PURE__ */ React731.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M20 3H4V8.34958C4 13.6749 7.06998 18.3116 11.6086 20.7866L12 21L12.3914 20.7866C16.93 18.3116 20 13.6749 20 8.34958V3ZM5.6 8.34958V4.5553H11.2L11.2 18.6997C7.79926 16.3684 5.6 12.596 5.6 8.34958ZM12.8 18.6997C16.2007 16.3684 18.4 12.596 18.4 8.34958V4.5553H12.8L12.8 18.6997Z",
      clipRule: "evenodd"
    }
  )), /* @__PURE__ */ React731.createElement("defs", null, /* @__PURE__ */ React731.createElement("clipPath", { id: "ui--shield-v2_svg__ui--shield-v2_svg__clip0" }, /* @__PURE__ */ React731.createElement("rect", { width: 24, height: 24 }))));
}

// src/components/icons/UiSocialFacebook.tsx
import * as React732 from "react";
var componentNameString726 = "UiSocialFacebook";
function UiSocialFacebook({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString726,
    ...props
  });
  return /* @__PURE__ */ React732.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React732.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React732.createElement("path", { d: "M9.5 3H12V0H9.5C7.5 0 6 1.6 6 3.5V5H4v3h2v8h3V8h2.5l.5-3H9V3.5c0-.3.2-.5.5-.5z" }));
}

// src/components/icons/UiSocialGoogle.tsx
import * as React733 from "react";
var componentNameString727 = "UiSocialGoogle";
function UiSocialGoogle({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString727,
    ...props
  });
  return /* @__PURE__ */ React733.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React733.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React733.createElement("path", { d: "M5.8 0v5.6H0V10h5.8v6h4.4v-6H16V5.6h-5.8V0H5.8z" }));
}

// src/components/icons/UiSocialLinkedin.tsx
import * as React734 from "react";
var componentNameString728 = "UiSocialLinkedin";
function UiSocialLinkedin({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString728,
    ...props
  });
  return /* @__PURE__ */ React734.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React734.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React734.createElement("path", { d: "M.2 15.2h3.4V4.9H.2v10.3zM1.9 0C.8 0 0 .8 0 1.8s.7 1.8 1.9 1.8 2-.8 2-1.8S3 0 1.9 0zM16 9.3v5.9h-3.4V9.7c0-1.4-.5-2.3-1.8-2.3-1 0-1.5.6-1.7 1.2l-.1.9v5.7H5.5V4.9H9v1.5c.4-.7 1.2-1.7 3-1.7 2.3 0 4 1.5 4 4.6z" }));
}

// src/components/icons/UiSocialTwitter.tsx
import * as React735 from "react";
var componentNameString729 = "UiSocialTwitter";
function UiSocialTwitter({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString729,
    ...props
  });
  return /* @__PURE__ */ React735.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React735.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React735.createElement("g", { clipPath: "url(#ui--social-twitter_svg__ui--social-twitter_svg__clip0)" }, /* @__PURE__ */ React735.createElement("path", { d: "M16 2.7c-.6.3-1.2.5-1.9.5.7-.4 1.2-1 1.5-1.8a6 6 0 01-2.1.8 3.3 3.3 0 00-5.6 3A9.3 9.3 0 011 1.8a3.3 3.3 0 001 4.4c-.5 0-1-.2-1.5-.4 0 1.6 1.2 3 2.7 3.2H1.7a3.3 3.3 0 003 2.4c-1.3 1-3 1.5-4.7 1.3a9.3 9.3 0 0014.4-8.3c.6-.4 1.2-1 1.6-1.7" })), /* @__PURE__ */ React735.createElement("defs", null, /* @__PURE__ */ React735.createElement("clipPath", { id: "ui--social-twitter_svg__ui--social-twitter_svg__clip0" }, /* @__PURE__ */ React735.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiStepsV2.tsx
import * as React736 from "react";
var componentNameString730 = "UiStepsV2";
function UiStepsV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString730,
    ...props
  });
  return /* @__PURE__ */ React736.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React736.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React736.createElement("path", { fillRule: "evenodd", d: "M3.8 15.8h4.5v1.4h-3V21H3.8v-5.3z", clipRule: "evenodd" }), /* @__PURE__ */ React736.createElement("path", { fillRule: "evenodd", d: "M9.8 11.3h4.4v1.4h-3V21H9.8v-9.8z", clipRule: "evenodd" }), /* @__PURE__ */ React736.createElement("path", { fillRule: "evenodd", d: "M15.8 6.8h4.4v1.5h-3V21h-1.4V6.7z", clipRule: "evenodd" }));
}

// src/components/icons/UiTagV2.tsx
import * as React737 from "react";
var componentNameString731 = "UiTagV2";
function UiTagV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString731,
    ...props
  });
  return /* @__PURE__ */ React737.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React737.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React737.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 3h8l10.3 10.3-8 8L3 11V3zm1.5 1.5v6l8.8 8.7 5.9-6-8.8-8.7H4.5z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React737.createElement("path", { d: "M9 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }));
}

// src/components/icons/UiTag.tsx
import * as React738 from "react";
var componentNameString732 = "UiTag";
function UiTag({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString732,
    ...props
  });
  return /* @__PURE__ */ React738.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React738.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React738.createElement("path", { d: "M0 0h6l10 10.2-5.8 5.8L0 5.8V0zm2 3.5A1 1 0 103.5 2 1 1 0 002 3.5z" }));
}

// src/components/icons/UiTipsCircleV2.tsx
import * as React739 from "react";
var componentNameString733 = "UiTipsCircleV2";
function UiTipsCircleV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString733,
    ...props
  });
  return /* @__PURE__ */ React739.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React739.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React739.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 21a9 9 0 100-18 9 9 0 000 18zm0 1.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React739.createElement("path", { d: "M10.5 16.5h3V18h-3v-1.5z" }), /* @__PURE__ */ React739.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 13.5a3 3 0 100-6 3 3 0 000 6zm0 1.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiTipsV2.tsx
import * as React740 from "react";
var componentNameString734 = "UiTipsV2";
function UiTipsV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString734,
    ...props
  });
  return /* @__PURE__ */ React740.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React740.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React740.createElement("path", { d: "M9 21h6v1.5H9V21z" }), /* @__PURE__ */ React740.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 3a6 6 0 00-2 11.5l.5.2V18h3v-3.4l.5-.1A6 6 0 0012 3zM4.4 9A7.4 7.4 0 1115 15.6v3.8H9v-3.8A7.4 7.4 0 014.5 9z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiTransferV2.tsx
import * as React741 from "react";
var componentNameString735 = "UiTransferV2";
function UiTransferV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString735,
    ...props
  });
  return /* @__PURE__ */ React741.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React741.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React741.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M18.2 7.3l-2-2.1 1-1L21.1 8l-3.9 3.9-1-1.1 2-2H3V7.3h15.2zm-12.4 8l2-2.1-1-1L2.9 16l3.9 3.9 1-1.1-2-2H21v-1.6H5.8z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiTrendingV2.tsx
import * as React742 from "react";
var componentNameString736 = "UiTrendingV2";
function UiTrendingV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString736,
    ...props
  });
  return /* @__PURE__ */ React742.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React742.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React742.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M16.5 6.4h6v6H21V8.9l-6.8 6.8-4.4-4.5-7 7-1-1.1 8-8 4.4 4.5L20 7.9h-3.4V6.4z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiUndoV2.tsx
import * as React743 from "react";
var componentNameString737 = "UiUndoV2";
function UiUndoV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString737,
    ...props
  });
  return /* @__PURE__ */ React743.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React743.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React743.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 6a6 6 0 00-6 6v4.2l1.7-1.7 1 1-3.4 3.6-3.6-3.6 1-1 1.8 1.7V12a7.5 7.5 0 117.5 7.5V18a6 6 0 000-12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiUnlinkV2.tsx
import * as React744 from "react";
var componentNameString738 = "UiUnlinkV2";
function UiUnlinkV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString738,
    ...props
  });
  return /* @__PURE__ */ React744.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React744.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React744.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M13.2 19.5a4.5 4.5 0 006.3-6.3L16.3 10l-1 1 3.2 3.2a3 3 0 01-4.3 4.3L11 15.3l-1 1 3.2 3.2z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React744.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M4.4 10.7a4.5 4.5 0 116.3-6.3L14 7.6l-1 1-3.2-3.2a3 3 0 00-4.3 4.3l3.2 3.2-1 1-3.2-3.2z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiUnlockV2.tsx
import * as React745 from "react";
var componentNameString739 = "UiUnlockV2";
function UiUnlockV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString739,
    ...props
  });
  return /* @__PURE__ */ React745.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React745.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React745.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 17.3a2.3 2.3 0 100-4.6 2.3 2.3 0 000 4.6zm0 1.4a3.7 3.7 0 100-7.4 3.7 3.7 0 000 7.4z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React745.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M5.3 1.5a3.8 3.8 0 00-3.8 3.8V9H3V5.2a2.3 2.3 0 014.5 0V9A7.5 7.5 0 109 8.1V5.3c0-2.1-1.7-3.8-3.8-3.8zM18 15a6 6 0 11-12 0 6 6 0 0112 0z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiUploadDepositV2.tsx
import * as React746 from "react";
var componentNameString740 = "UiUploadDepositV2";
function UiUploadDepositV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString740,
    ...props
  });
  return /* @__PURE__ */ React746.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React746.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React746.createElement("path", { d: "M3 4.5h18V3H3v1.5zM18.2 14l-5.4-5.4V21h-1.6V8.6L5.8 14l-1-1L12 5.7l7.3 7.3-1 1z", clipRule: "evenodd" }));
}

// src/components/icons/UiUploadV2.tsx
import * as React747 from "react";
var componentNameString741 = "UiUploadV2";
function UiUploadV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString741,
    ...props
  });
  return /* @__PURE__ */ React747.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React747.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React747.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3 4.5h18V3H3v1.5zM18.2 14l-5.4-5.4V21h-1.6V8.6L5.8 14l-1-1L12 5.7l7.3 7.3-1 1z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiUpload.tsx
import * as React748 from "react";
var componentNameString742 = "UiUpload";
function UiUpload({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString742,
    ...props
  });
  return /* @__PURE__ */ React748.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React748.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React748.createElement("path", { d: "M3 2h10V0H3v2z" }), /* @__PURE__ */ React748.createElement("path", { d: "M0 12l1.4 1.4L7 7.8V16h2V7.8l5.6 5.6L16 12 8 4l-8 8z" }));
}

// src/components/icons/UiUser.tsx
import * as React749 from "react";
var componentNameString743 = "UiUser";
function UiUser({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString743,
    ...props
  });
  return /* @__PURE__ */ React749.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React749.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React749.createElement("path", { d: "M8 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }), /* @__PURE__ */ React749.createElement("path", { d: "M15 16a7 7 0 10-14 0h2a5 5 0 1110 0h2z" }));
}

// src/components/icons/UiWindowV2.tsx
import * as React750 from "react";
var componentNameString744 = "UiWindowV2";
function UiWindowV2({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString744,
    ...props
  });
  return /* @__PURE__ */ React750.createElement("svg", { viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React750.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React750.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M22.5 4.5h-21v15h21v-15zM3 7.5V6h18v1.5H3zM3 9v9h18V9H3zm4 3h1.3v-1.5H4.5v3.8H6V13l2.5 2.4 1-1L7.1 12z",
      clipRule: "evenodd"
    }
  ));
}

// src/components/icons/UiWrench.tsx
import * as React751 from "react";
var componentNameString745 = "UiWrench";
function UiWrench({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString745,
    ...props
  });
  return /* @__PURE__ */ React751.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React751.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React751.createElement("g", { clipPath: "url(#ui--wrench_svg__ui--wrench_svg__clip0)" }, /* @__PURE__ */ React751.createElement("path", { d: "M13.2 0L9.3 1l-1 4 .7.7-9 9L1.4 16l9-9 .7.7 3.9-1 1-3.9-.7-.7L14 3.3l-.5 2-2 .5-1.4-1.4.5-2 2-.5L13.8.7l-.7-.7z" })), /* @__PURE__ */ React751.createElement("defs", null, /* @__PURE__ */ React751.createElement("clipPath", { id: "ui--wrench_svg__ui--wrench_svg__clip0" }, /* @__PURE__ */ React751.createElement("rect", { width: 16, height: 16 }))));
}

// src/components/icons/UiX.tsx
import * as React752 from "react";
var componentNameString746 = "UiX";
function UiX({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString746,
    ...props
  });
  return /* @__PURE__ */ React752.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React752.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React752.createElement("path", { d: "M14.6 0L8 6.6 1.4 0 0 1.4 6.6 8 0 14.6 1.4 16 8 9.4l6.6 6.6 1.4-1.4L9.4 8 16 1.4 14.6 0z" }));
}

// src/components/icons/VendorFpo.tsx
import * as React753 from "react";
var componentNameString747 = "VendorFpo";
function VendorFpo({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString747,
    ...props
  });
  return /* @__PURE__ */ React753.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React753.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React753.createElement("path", { d: "M8 0a8 8 0 100 16zm0 6.2c1 0 1.5.5 1.5 1.3C9.5 8.4 9 9 8 9h-.8v1.4H6v-4h2zm-.3 1.9c.4 0 .6-.2.6-.5 0-.4-.2-.6-.6-.6h-.5v1.1h.5zm4.1 2.3c-1.2 0-2-.9-2-2.2 0-1.3.8-2 2-2 1.3 0 2.1.7 2.1 2s-.8 2.2-2 2.2zm0-1c-.5 0-.8-.4-.8-1.2 0-.7.3-1.2.8-1.2.6 0 .9.5.9 1.2 0 .8-.3 1.3-.9 1.3zM5.6 7.2H3.9v.7h1.6v1H3.9v1.5H2.7v-4h2.9V7z" }));
}

// src/components/icons/VendorSocialFacebook.tsx
import * as React754 from "react";
var componentNameString748 = "VendorSocialFacebook";
function VendorSocialFacebook({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString748,
    ...props
  });
  return /* @__PURE__ */ React754.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React754.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React754.createElement("path", { d: "M9.5 3H12V0H9.5C7.5 0 6 1.6 6 3.5V5H4v3h2v8h3V8h2.5l.5-3H9V3.5c0-.3.2-.5.5-.5" }));
}

// src/components/icons/VendorSocialGoogle.tsx
import * as React755 from "react";
var componentNameString749 = "VendorSocialGoogle";
function VendorSocialGoogle({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString749,
    ...props
  });
  return /* @__PURE__ */ React755.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React755.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React755.createElement("polygon", { points: "5.76 0 5.76 5.616 0 5.616 0 10.048 5.76 10.048 5.76 16 10.24 16 10.24 10.048 16 10.048 16 5.616 10.24 5.616 10.24 0" }));
}

// src/components/icons/VendorSocialLinkedin.tsx
import * as React756 from "react";
var componentNameString750 = "VendorSocialLinkedin";
function VendorSocialLinkedin({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString750,
    ...props
  });
  return /* @__PURE__ */ React756.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React756.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React756.createElement("path", { d: "M.2 15.2h3.4V4.9H.2v10.3zM1.9 0C.8 0 0 .8 0 1.8s.7 1.8 1.9 1.8 2-.8 2-1.8S3 0 1.9 0zM16 9.3v5.9h-3.4V9.7c0-1.4-.5-2.3-1.8-2.3-1 0-1.5.6-1.7 1.2l-.1.9v5.7H5.5V4.9H9v1.5c.4-.7 1.2-1.7 3-1.7 2.3 0 4 1.5 4 4.6z" }));
}

// src/components/icons/VendorSocialTwitter.tsx
import * as React757 from "react";
var componentNameString751 = "VendorSocialTwitter";
function VendorSocialTwitter({ title, titleId, ...props }) {
  [titleId, props] = useIconProps({
    title,
    titleId,
    componentNameString: componentNameString751,
    ...props
  });
  return /* @__PURE__ */ React757.createElement("svg", { viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React757.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React757.createElement("path", { d: "M16 2.7c-.6.3-1.2.5-1.9.5.7-.4 1.2-1 1.5-1.8a6 6 0 01-2.1.8 3.3 3.3 0 00-5.6 3A9.3 9.3 0 011 1.8a3.3 3.3 0 001 4.4c-.5 0-1-.2-1.5-.4 0 1.6 1.2 3 2.7 3.2a3.3 3.3 0 01-1.5 0 3.3 3.3 0 003 2.4A6.6 6.6 0 010 12.7a9.3 9.3 0 0014.4-8.3c.6-.4 1.2-1 1.6-1.7" }));
}

// src/components/Slot.tsx
import React758 from "react";
var Slot = ({ children }) => /* @__PURE__ */ React758.createElement(React758.Fragment, null, children);
function getSlots(names, children, defaultName) {
  return names.map((name) => {
    let slot = null;
    React758.Children.forEach(children, (child) => {
      if (!React758.isValidElement(child)) {
        return;
      }
      if (child.type === Slot && child.props.name === name) {
        slot = React758.cloneElement(child);
      }
      if (child.type === Slot && child.props.name === void 0 && name === defaultName) {
        slot = React758.cloneElement(child, { name: defaultName });
      }
    });
    return slot;
  });
}

// src/components/SvgIcon.tsx
import React759 from "react";
var allColors = {
  ...theme.secondaryColors,
  ...theme.colors
};
var getColor = (color2) => allColors[color2];
var ArrowTrending = ({
  color: color2 = "bmtGrey90",
  size: size2 = "16"
}) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, /* @__PURE__ */ React759.createElement(
  "polygon",
  {
    points: "17 2.363 10.07 5.138 12.085 6.722 9.579 9.91 4.5 5.918 0 11.642 1.839 13.087 4.893 9.202 9.973 13.195 13.925 8.168 15.94 9.752",
    fill: getColor(color2)
  }
));
var Bank = ({ color: color2 = "bmtGrey90", size: size2 = "24" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement("title", null, "bank"), /* @__PURE__ */ React759.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.91147L21.3354 7.57917L20.6646 8.92082L12 4.58852L3.3354 8.92082L2.66458 7.57917L12 2.91147Z",
    fill: getColor(color2)
  }
), /* @__PURE__ */ React759.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 18V9.75H6V18H4.5Z", fill: getColor(color2) }), /* @__PURE__ */ React759.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 18V9.75H10.5V18H9Z", fill: getColor(color2) }), /* @__PURE__ */ React759.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5 18V9.75H15V18H13.5Z", fill: getColor(color2) }), /* @__PURE__ */ React759.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 18V9.75H19.5V18H18Z", fill: getColor(color2) }), /* @__PURE__ */ React759.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 19.5L21 19.5L21 21L3 21L3 19.5Z", fill: getColor(color2) }));
var Calendar = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M0 16V0h16v16H0zM12 3h-2V2H6v1H4V2H2v12h12V2h-2v1zm1 4h-2v3h2v1h-2v2h-1v-2H6v2H5v-2H3v-1h2V7H3V6h2V4h1v2h4V4h1v2h2v1zm-7 3h4V7H6v3z",
    fill: color2 && getColor(color2)
  }
));
var Card = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement("title", null, "card"), /* @__PURE__ */ React759.createElement("rect", { x: "1", y: "3", width: "14", height: "10", stroke: color2 && getColor(color2), strokeWidth: "2" }), /* @__PURE__ */ React759.createElement("rect", { x: "1.5", y: "6.5", width: "13", height: "1", fill: "white", stroke: color2 && getColor(color2) }));
var Check = ({ color: color2 }) => /* @__PURE__ */ React759.createElement(
  "svg",
  {
    width: "22",
    height: "12",
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: color2 && getColor(color2)
  },
  /* @__PURE__ */ React759.createElement("title", null, "check icon"),
  /* @__PURE__ */ React759.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.500001 12L21.5 12L21.5 0L0.5 1.78814e-06L0.500001 12ZM20 1.5V10.5L2 10.5L2 1.5L20 1.5ZM3.5 4.5H11V3H3.5V4.5ZM11 7.5H3.5V6H11V7.5ZM13.124 9.41602L14.124 7.91602C14.3029 7.64774 14.6971 7.64774 14.876 7.91602C15.6486 9.07489 17.3515 9.07489 18.124 7.91602L19.124 6.41602L17.876 5.58397L16.876 7.08397C16.6971 7.35224 16.3029 7.35224 16.124 7.08397C15.3515 5.92509 13.6486 5.92509 12.876 7.08397L11.876 8.58397L13.124 9.41602Z",
      fill: "currentColor"
    }
  )
);
var CheckMark = ({ color: color2, title = "check mark" }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "13", viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement("title", null, title), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M14.592 0.352539L5.476 9.38137L1.436 5.18585L0 6.58839L5.443 12.2408L15.994 1.78933L14.592 0.352539Z",
    fill: color2 && getColor(color2)
  }
));
var CircleArrows = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement("g", { clipPath: "url(#clip0)" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M-5.74961e-05 8C0.00420604 9.75252 0.583829 11.4552 1.64974 12.8463C2.71565 14.2374 4.20887 15.24 5.89994 15.7L6.89994 13.9C5.52292 13.6432 4.27916 12.9127 3.38421 11.8351C2.48926 10.7575 1.99955 9.40076 1.99994 8C1.99994 6 2.79994 4 4.19994 2.9L5.19994 4.7L7.99994 0H2.59994L3.39994 1.4C2.34204 2.14345 1.4801 3.13225 0.887959 4.28171C0.295816 5.43116 -0.00888903 6.70702 -5.74961e-05 8ZM15.9999 8C15.9957 6.24748 15.4161 4.54485 14.3501 3.15374C13.2842 1.76264 11.791 0.760033 10.0999 0.3L9.09994 2C10.477 2.25681 11.7207 2.98731 12.6157 4.0649C13.5106 5.14249 14.0003 6.49924 13.9999 7.9C13.9999 9.9 13.1999 11.9 11.7999 13L10.7999 11.2L7.99994 16H13.3999L12.5999 14.6C13.6578 13.8565 14.5198 12.8677 15.1119 11.7183C15.7041 10.5688 16.0088 9.29298 15.9999 8Z",
    fill: color2 && getColor(color2)
  }
)), /* @__PURE__ */ React759.createElement("defs", null, /* @__PURE__ */ React759.createElement("clipPath", { id: "clip0" }, /* @__PURE__ */ React759.createElement("rect", { width: "16", height: "16", fill: "white" }))));
var FeatureCheckMark = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", role: "img", width: "80", height: "80", fill: "none" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8zm11.5-4l-5 5-2-2.2L3 8.2l2.1 2.2 1.4 1.4L13 5.4 11.5 4z",
    fill: color2 && getColor(color2)
  }
));
var ChecklistMarkToDo = ({ color: color2, size: size2 = "24" }) => /* @__PURE__ */ React759.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size2, height: size2, viewBox: "0 0 24 24", fill: "none" }, /* @__PURE__ */ React759.createElement("circle", { cx: "12", cy: "12", r: "11.5", stroke: "#C2C6CC" }), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M16.12 8.07495L10.4225 13.6756L7.8975 11.0731L7 11.9431L10.4019 15.4493L16.9963 8.9662L16.12 8.07495Z",
    fill: color2 && getColor(color2)
  }
));
var ChecklistMarkCompleted = ({ color: color2, size: size2 = "24" }) => /* @__PURE__ */ React759.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size2, height: size2, viewBox: "0 0 24 24", fill: "none" }, /* @__PURE__ */ React759.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#00CC9A" }), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M16.12 8.07495L10.4225 13.6756L7.8975 11.0731L7 11.9431L10.4019 15.4493L16.9963 8.9662L16.12 8.07495Z",
    fill: color2 && getColor(color2)
  }
));
var Mobile = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M2 16V0h12v16H2zm2-4h8V2H4v10zm4 3.3a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6z",
    fill: color2 && getColor(color2)
  }
));
var Numpad = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement("circle", { cx: "2", cy: "2", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "8", cy: "2", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "14", cy: "2", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "2", cy: "8", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "8", cy: "8", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "14", cy: "8", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "2", cy: "14", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "8", cy: "14", r: "2", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement("circle", { cx: "14", cy: "14", r: "2", fill: color2 && getColor(color2) }));
var Open = ({ color: color2, size: size2 = "12" }) => /* @__PURE__ */ React759.createElement(
  "svg",
  {
    width: size2,
    height: size2,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: color2 && getColor(color2)
  },
  /* @__PURE__ */ React759.createElement("title", null, "open new tab"),
  /* @__PURE__ */ React759.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0H7.5V1.5H1.5V16.5H16.5V10.5H18V18H0V0Z", fill: "currentColor" }),
  /* @__PURE__ */ React759.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5001 0L18.0001 6.30319e-06L18.0001 7.5H16.5001L16.5001 2.56067L5.03039 14.0303L3.96973 12.9697L15.4394 1.5L10.5001 1.5L10.5001 0Z",
      fill: "currentColor"
    }
  )
);
var Target = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M7.99976 14C9.26371 13.9787 10.4886 13.5587 11.4998 12.8L12.8998 14.2C11.9312 14.9733 10.7962 15.511 9.58436 15.7707C8.37248 16.0304 7.11684 16.0049 5.91648 15.6964C4.71611 15.3878 3.60386 14.8045 2.66744 13.9926C1.73102 13.1807 0.996058 12.1623 0.520514 11.0178C0.0449704 9.87326 -0.158145 8.63389 -0.072811 7.39744C0.0125228 6.16099 0.383972 4.96128 1.01224 3.89293C1.6405 2.82458 2.5084 1.91682 3.54748 1.24124C4.58656 0.565656 5.76839 0.140739 6.99976 0V2C5.40846 2.13261 3.93502 2.89193 2.90357 4.11091C1.87212 5.3299 1.36716 6.9087 1.49976 8.5C1.63237 10.0913 2.39169 11.5647 3.61068 12.5962C4.82966 13.6276 6.40846 14.1326 7.99976 14V14ZM13.9998 7C13.8032 5.74448 13.2132 4.58378 12.3146 3.68519C11.416 2.78659 10.2553 2.19651 8.99976 2V0C10.7829 0.211907 12.4428 1.01753 13.7125 2.28724C14.9822 3.55695 15.7879 5.21691 15.9998 7H13.9998ZM13.9998 9H15.9998C15.7784 10.3945 15.1918 11.7055 14.2998 12.8L12.9998 11.4C13.5182 10.6532 13.8601 9.79833 13.9998 8.9V9Z",
    fill: color2 && getColor(color2)
  }
));
var LeftCaret = ({ color: color2 = "bmtGrey90", size: size2 = "12" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, /* @__PURE__ */ React759.createElement("polygon", { points: "12.407 14.586 5.824 8.003 12.401 1.413 10.984 0 2.997 8.003 10.993 16", fill: getColor(color2) }));
var RightCaret = ({ color: color2 = "bmtGrey90", size: size2 = "12" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, /* @__PURE__ */ React759.createElement("polygon", { points: "3.781 14.586 10.364 8.003 3.787 1.413 5.204 0 13.191 8.003 5.195 16", fill: getColor(color2) }));
var DownCaret = ({ color: color2 = "bmtGrey90", size: size2 = "16" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, viewBox: "0 0 16 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M14.586 0.800995L8.003 7.38399L1.413 0.806995L0 2.22399L8.003 10.211L16 2.21499L14.586 0.800995Z",
    fill: getColor(color2)
  }
));
var Clock = () => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M8.99987 14C7.40857 14 5.88245 13.3679 4.75723 12.2426C3.63201 11.1174 2.99987 9.5913 2.99987 8C2.99987 6.4087 3.63201 4.88258 4.75723 3.75736C5.88245 2.63214 7.40857 2 8.99987 2V0C7.68568 0.00323062 6.39254 0.330167 5.23473 0.95191C4.07692 1.57365 3.09011 2.47105 2.36152 3.56479C1.63294 4.65852 1.18502 5.9149 1.05737 7.22287C0.929709 8.53085 1.12624 9.85013 1.6296 11.0641C2.13295 12.2781 2.92762 13.3493 3.94336 14.1832C4.9591 15.0171 6.16463 15.5879 7.45339 15.8452C8.74215 16.1025 10.0744 16.0383 11.3325 15.6583C12.5906 15.2784 13.7356 14.5943 14.6665 13.6667L13.2332 12.2333C12.1118 13.3597 10.5893 13.9951 8.99987 14",
    fill: "#C2C6CC"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M9 2V8L13.2333 12.2333C14.0687 11.3943 14.6372 10.3269 14.8672 9.16542C15.0971 8.00398 14.9784 6.80046 14.5258 5.70639C14.0732 4.61232 13.307 3.67661 12.3237 3.01708C11.3404 2.35754 10.184 2.00366 9 2V2Z",
    fill: "#1D6AE5"
  }
));
var GraphPie = ({
  size: size2 = "18",
  color: color2 = "bmtBlue",
  secondaryColor = "bmtGrey20"
}) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, /* @__PURE__ */ React759.createElement("path", { d: "M42 27A21 21 0 1 1 21 6v21h21z", fill: getColor(secondaryColor) }), /* @__PURE__ */ React759.createElement("path", { d: "M48 21A21 21 0 0 0 27 0v21h21z", fill: getColor(color2) }));
var OpposingArrows = () => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M0 11.6667L4.31 16L5.72433 14.5857L3.82067 12.6667H16V10.6663H3.82067L5.72433 8.74734L4.31 7.33301L0 11.6667Z",
    fill: "#C2C6CC"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M11.69 0L10.2757 1.41433L12.1797 3.33333H0V5.333H12.1797L10.2757 7.25233L11.69 8.66667L15.9997 4.33333L11.69 0Z",
    fill: "#1D6AE5"
  }
));
var Upload = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement("g", { clipPath: "url(#clip0)" }, /* @__PURE__ */ React759.createElement("path", { d: "M13 14L3 14L3 16L13 16L13 14Z", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M16 4L14.586 2.586L9 8.172L9 -6.11959e-07L7 -7.86805e-07L7 8.172L1.414 2.586L6.99382e-07 4L8 12L16 4Z",
    fill: color2 && getColor(color2)
  }
)), /* @__PURE__ */ React759.createElement("defs", null, /* @__PURE__ */ React759.createElement("clipPath", { id: "clip0" }, /* @__PURE__ */ React759.createElement("rect", { width: "16", height: "16", fill: "white", transform: "translate(16 16) rotate(-180)" }))));
var CircleExclamation = ({ color: color2, size: size2 = "24" }) => /* @__PURE__ */ React759.createElement(UiExclamationCircleV2, { color: color2, size: size2 });
var CircleInfo = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "16", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M7 0.875C5.37555 0.875 3.81763 1.52031 2.66897 2.66897C1.52031 3.81763 0.875 5.37555 0.875 7C0.875 8.62445 1.52031 10.1824 2.66897 11.331C3.81763 12.4797 5.37555 13.125 7 13.125C8.62445 13.125 10.1824 12.4797 11.331 11.331C12.4797 10.1824 13.125 8.62445 13.125 7C13.125 5.37555 12.4797 3.81763 11.331 2.66897C10.1824 1.52031 8.62445 0.875 7 0.875ZM0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737497 5.14348 0 7 0C8.85652 0 10.637 0.737497 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7H0ZM6.125 5.25H7.875V11.375H6.125V5.25ZM6.125 2.625H7.875V4.375H6.125V2.625Z",
    fill: color2 && getColor(color2)
  }
));
var CircleQuestion = ({ color: color2, size: size2 = "16" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    fill: color2 && getColor(color2)
  }
), /* @__PURE__ */ React759.createElement("path", { d: "M7.5 11H8.5V12H7.5V11Z", fill: color2 && getColor(color2) }), /* @__PURE__ */ React759.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5C6.89543 5 6 5.89543 6 7H5C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7C11 8.65685 9.65685 10 8 10H7.5V9H8C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5Z",
    fill: color2 && getColor(color2)
  }
));
var Close = ({ color: color2, size: size2 = "16", title = "close" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": title }, /* @__PURE__ */ React759.createElement("title", null, title), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M14.587 0.00100708L8 6.58801L1.413 0.00100708L0 1.41401L6.587 8.00101L0 14.588L1.413 16L8 9.41401L14.587 16L16 14.588L9.413 8.00101L16 1.41401L14.587 0.00100708Z",
    fill: color2 && getColor(color2)
  }
));
var VerticalCard = ({ size: size2 = "48" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M44 24.0067C44 35.05 35.05 44.0134 23.9933 44.0134C12.95 44 4 35.05 4 24.0067C4 12.95 12.95 4 24.0067 4C35.05 4 44 12.95 44 24.0067Z",
    fill: "#ADE7FF"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M32.9105 15H15.077C14.4759 15 14 15.4996 14 16.1016V40.9514C16.9054 42.8728 20.3745 44 24.0939 44C27.7383 44 31.1196 42.9112 34 41.0667V16.1016C33.9875 15.4996 33.4991 15 32.9105 15ZM26.5986 22.6855H23.4427V19.496H26.5986V22.6855Z",
    fill: "#1D6AE5"
  }
), /* @__PURE__ */ React759.createElement("path", { d: "M27 19H23V23H27V19Z", fill: "#9EA2A8" }));
var Lock = ({ color: color2 }) => /* @__PURE__ */ React759.createElement("svg", { width: "14", height: "14", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M1 16V7H15V16H1ZM3 14H13V9H3V14ZM7 13V10H9V13H7ZM13 5H11C11 4.20435 10.6839 3.44129 10.1213 2.87868C9.55871 2.31607 8.79565 2 8 2C7.20435 2 6.44129 2.31607 5.87868 2.87868C5.31607 3.44129 5 4.20435 5 5H3C3 3.67392 3.52678 2.40215 4.46447 1.46447C5.40215 0.526784 6.67392 0 8 0C9.32608 0 10.5979 0.526784 11.5355 1.46447C12.4732 2.40215 13 3.67392 13 5Z",
    fill: color2 && getColor(color2)
  }
));
var MoneyEgg = ({ size: size2 = "16", color: color2 = "bmtGrey90" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M5.3 12.8c0-2.6.8-5 2.2-6.9C8.8 4.1 10.5 3 12 3s3.2 1 4.5 3a12 12 0 0 1 2.3 6.8c0 5-3.2 8.2-6.8 8.2-3.6 0-6.8-3.2-6.8-8.3zM12 1.4C9.8 1.5 7.7 3 6.2 5a14 14 0 0 0-2.5 7.8c0 5.6 3.6 9.7 8.3 9.7 4.7 0 8.3-4 8.3-9.8 0-2.8-1-5.6-2.5-7.7-1.5-2-3.6-3.5-5.8-3.5zm.8 6c1.2 0 2.2 1 2.2 2.3v.7h-1.5v-.8c0-.4-.3-.7-.8-.7h-1.5a.7.7 0 0 0-.4 1.3l3.2 2.1a2.2 2.2 0 0 1-1.2 4.1V18h-1.6v-1.5c-1.2 0-2.2-1-2.2-2.3v-.8h1.5v.8c0 .5.3.8.8.8h1.5a.7.7 0 0 0 .4-1.3L10 11.6a2.2 2.2 0 0 1 1.2-4.1V6h1.6v1.5z",
    clipRule: "evenodd",
    fill: getColor(color2)
  }
));
var Search = ({ size: size2 = "16", color: color2 = "bmtGrey90" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 9.375C14.25 12.0674 12.0674 14.25 9.375 14.25C6.68261 14.25 4.5 12.0674 4.5 9.375C4.5 6.68261 6.68261 4.5 9.375 4.5C12.0674 4.5 14.25 6.68261 14.25 9.375ZM13.3214 14.382C12.2359 15.2387 10.8652 15.75 9.375 15.75C5.85418 15.75 3 12.8958 3 9.375C3 5.85418 5.85418 3 9.375 3C12.8958 3 15.75 5.85418 15.75 9.375C15.75 10.8652 15.2387 12.2359 14.382 13.3214L20.7803 19.7197L19.7197 20.7803L13.3214 14.382Z",
    fill: getColor(color2)
  }
));
var Tags = ({ size: size2 = "32" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M5.26615 9.59987C5.11294 9.7487 4.93191 9.8659 4.73341 9.94477C4.53491 10.0236 4.32282 10.0626 4.10924 10.0595C3.89567 10.0565 3.68479 10.0113 3.48866 9.92673C3.29253 9.84214 3.11498 9.71975 2.96615 9.56654C2.81731 9.41333 2.70012 9.2323 2.62125 9.0338C2.54237 8.8353 2.50337 8.62321 2.50647 8.40963C2.50956 8.19606 2.55469 7.98518 2.63929 7.78905C2.72388 7.59292 2.84627 7.41537 2.99948 7.26654C3.3089 6.96596 3.72505 6.80061 4.15638 6.80686C4.58772 6.81311 4.9989 6.99045 5.29948 7.29987C5.60006 7.60929 5.76541 8.02544 5.75916 8.45677C5.75291 8.88811 5.57557 9.29929 5.26615 9.59987ZM8.79948 4.5332H0.132812L0.199479 13.0665L14.9995 27.8665L23.5328 19.2665L8.79948 4.5332Z",
    fill: "#1D6AE5"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M17.1028 4.72998H12.2461L26.8088 19.296L20.6761 25.4306L23.3334 28.0866L31.8934 19.524L17.1028 4.72998Z",
    fill: "#C2C6CC"
  }
));
var DollarBill = ({ size: size2 = "48" }) => /* @__PURE__ */ React759.createElement("svg", { width: size2, height: size2, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React759.createElement("path", { d: "M23.9934 4C17.7895 4 12.2365 6.82962 8.56995 11.28C12.2365 6.82962 17.7895 4 23.9934 4Z", fill: "#00CC99" }), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M8.56983 36.72C7.75947 35.737 7.02882 34.6609 6.41772 33.5317C7.02882 34.6609 7.74619 35.737 8.56983 36.72Z",
    fill: "#00CC99"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M6.41772 14.4683C7.02882 13.3391 7.75947 12.263 8.56983 11.28C7.74619 12.263 7.02882 13.3391 6.41772 14.4683Z",
    fill: "#00CC99"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M41.5822 14.4683C40.9711 13.3391 40.2405 12.263 39.4301 11.28C35.7635 6.82962 30.2106 4 23.9934 4C17.7894 4 12.2365 6.82962 8.56991 11.28C7.75955 12.263 7.02889 13.3391 6.4178 14.4683C4.87679 17.2979 4 20.5526 4 23.9934C4 27.4341 4.87679 30.6888 6.4178 33.5317C7.02889 34.6609 7.75955 35.737 8.56991 36.72C10.0578 38.5267 11.8778 40.0412 13.897 41.2368V14.6011H34.0897V41.2501C36.1222 40.0545 37.9422 38.5267 39.4301 36.72C40.2405 35.737 40.9711 34.6609 41.5822 33.5317C43.1232 30.7021 44 27.4474 44 23.9934C44 20.5394 43.1232 17.2979 41.5822 14.4683Z",
    fill: "#B5FFCB"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M31.4061 18.4138H16.6071V42.5785C18.892 43.4952 21.3762 44 23.9933 44C26.6104 44 29.1079 43.4819 31.4061 42.5653V18.4138ZM28.2444 40.825H19.7821V35.9894C18.4935 34.8203 17.6698 33.1199 17.6698 31.2202C17.6698 29.3205 18.4935 27.6333 19.7821 26.4643V21.6287H28.2444V26.4643C29.533 27.6333 30.3566 29.3338 30.3566 31.2202C30.3566 33.1199 29.533 34.807 28.2444 35.9894V40.825Z",
    fill: "#00CC99"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M24.0066 26.9426C21.6685 26.9426 19.7821 28.8555 19.7821 31.2069C19.7821 33.5583 21.6818 35.4713 24.0066 35.4713C26.3314 35.4713 28.2311 33.5583 28.2311 31.2069C28.2444 28.8555 26.3447 26.9426 24.0066 26.9426Z",
    fill: "#00CC9A"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M13.8971 41.2368C11.8645 40.0412 10.0578 38.5267 8.56995 36.72C12.2365 41.1704 17.7895 44 24.0067 44C21.3896 44 18.9054 43.4819 16.6204 42.5785C15.6639 42.1933 14.7606 41.7549 13.8971 41.2368Z",
    fill: "#00CC99"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M28.2445 26.451V21.6154H19.7822V26.451C18.4936 27.6201 17.6699 29.3205 17.6699 31.2069C17.6699 33.1066 18.4936 34.7937 19.7822 35.9761V40.8117H28.2445V35.9761C29.5331 34.807 30.3567 33.1066 30.3567 31.2069C30.3567 29.3205 29.5331 27.6201 28.2445 26.451ZM24.0067 35.4845C21.6686 35.4845 19.7822 33.5716 19.7822 31.2202C19.7822 28.8688 21.6819 26.9558 24.0067 26.9558C26.3315 26.9558 28.2312 28.8688 28.2312 31.2202C28.2445 33.5716 26.3448 35.4845 24.0067 35.4845Z",
    fill: "#208982"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M31.4061 42.5653C32.3361 42.1933 33.2261 41.7549 34.0763 41.2501C33.2261 41.7549 32.3361 42.1933 31.4061 42.5653Z",
    fill: "#208982"
  }
), /* @__PURE__ */ React759.createElement(
  "path",
  {
    d: "M16.607 18.4138H31.4061V42.5653C32.336 42.1933 33.2261 41.7549 34.0763 41.2501V14.6011H13.897V41.2368C14.7605 41.7416 15.6638 42.1933 16.607 42.5653V18.4138Z",
    fill: "#208982"
  }
));
var UiOpposingArrows2 = ({ color: color2 = "bmtGrey90" }) => /* @__PURE__ */ React759.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1894 7.25002L16.1364 5.19701L17.1971 4.13635L21.0608 8.00002L17.1971 11.8637L16.1364 10.803L18.1894 8.75002H3.00011V7.25002H18.1894ZM5.81077 15.25L7.86378 13.197L6.80312 12.1364L2.93945 16L6.80312 19.8637L7.86378 18.803L5.81077 16.75H21.0001V15.25H5.81077Z",
    fill: getColor(color2)
  }
));
var UiDownload = ({ color: color2 = "bmtGrey90" }) => /* @__PURE__ */ React759.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, /* @__PURE__ */ React759.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 3L12.75 15.4393L18.2197 9.96968L19.2803 11.0303L12 18.3107L4.71967 11.0303L5.78033 9.96968L11.25 15.4394L11.25 3H12.75ZM21 19.5L3 19.5V21L21 21V19.5Z",
    fill: getColor(color2)
  }
));
var icons = Object.freeze({
  arrowTrending: ArrowTrending,
  bank: Bank,
  calendar: Calendar,
  card: Card,
  check: Check,
  checklistMarkToDo: ChecklistMarkToDo,
  checklistMarkCompleted: ChecklistMarkCompleted,
  checkMark: CheckMark,
  circleArrows: CircleArrows,
  circleQuestion: CircleQuestion,
  circleExclamation: CircleExclamation,
  circleInfo: CircleInfo,
  clock: Clock,
  close: Close,
  dollarBill: DollarBill,
  downCaret: DownCaret,
  featureCheckMark: FeatureCheckMark,
  graphPie: GraphPie,
  leftCaret: LeftCaret,
  lock: Lock,
  mobile: Mobile,
  moneyEgg: MoneyEgg,
  numpad: Numpad,
  open: Open,
  opposingArrows: OpposingArrows,
  rightCaret: RightCaret,
  search: Search,
  tags: Tags,
  target: Target,
  uiBank: Bank,
  uiDownload: UiDownload,
  uiOpposingArrows: UiOpposingArrows2,
  upload: Upload,
  verticalCard: VerticalCard
});
var SvgIcon = ({ name, color: color2 = "bmtBlue", size: size2, title }) => {
  return React759.createElement(icons[name], { color: color2, size: size2, title });
};

// src/components/Text.tsx
import React760, { forwardRef as forwardRef4 } from "react";
import styled4 from "@emotion/styled";
var VARIANT_STYLES = {
  copy: { fontSize: 2, lineHeight: 2, as: "p" }
};
var TextBase = styled4(Base)`
  color: ${get("colors.bmtGrey90")};
  ${TYPOGRAPHY}
  ${COMMON}
`;
var Text = styled4(({ as = "span", variant, ...rest }) => /* @__PURE__ */ React760.createElement(TextBase, { ...variant && VARIANT_STYLES[variant], ...rest, as }))``;
var ReffableTextBase = styled4(
  ReffableBase
)`
  ${TYPOGRAPHY}
  ${COMMON}
`;
ReffableTextBase.defaultProps = {
  as: "span"
};
var ReffableText = forwardRef4(({ children, ...rest }, ref) => /* @__PURE__ */ React760.createElement(ReffableTextBase, { ...rest, ref }, children));
Text.displayName = "Text";

// src/components/ActionCard.tsx
var StyledBox2 = styled5(Box)`
  &:hover {
    cursor: pointer;
    border: 1px solid ${get("colors.bmtBlue")};
    text-decoration: 'underline';
  }
`;
var ActionCard = ({
  onSelect,
  iconName,
  iconColor = "bmtGrey90",
  icon,
  children,
  ...rest
}) => {
  const [content, cta] = getSlots(["content", "cta"], children, "content");
  const onKeyDown = (event) => {
    if (["Enter", " "].includes(event.key)) {
      onSelect();
    }
  };
  if (!icon && iconName) {
    icon = /* @__PURE__ */ React761.createElement(SvgIcon, { name: iconName, color: iconColor });
  }
  return /* @__PURE__ */ React761.createElement(
    StyledBox2,
    {
      onClick: onSelect,
      onKeyDown,
      width: "100%",
      borderStyle: "solid",
      borderWidth: [0, "1px"],
      borderBottom: "1px solid",
      borderColor: "bmtGrey20",
      borderRadius: ["0px", "4px"],
      role: "link",
      tabIndex: 0,
      ...rest
    },
    /* @__PURE__ */ React761.createElement(Flex, { justifyContent: "space-between", alignItems: "center", py: [5, 8], px: [0, 8] }, /* @__PURE__ */ React761.createElement(Flex, { alignItems: "center" }, icon && /* @__PURE__ */ React761.createElement(Flex, { alignItems: "center", mr: "3" }, icon), content || (isString(children) ? /* @__PURE__ */ React761.createElement(Text, null, children) : children)), /* @__PURE__ */ React761.createElement(Box, null, cta || /* @__PURE__ */ React761.createElement(FeatureCaretRight24, { color: "bmtGrey40" })))
  );
};
ActionCard.displayName = "ActionCard";
ActionCard.Slot = Slot;
ActionCard.Slot.displayName = "ActionCard.Slot";

// src/components/BackLink.tsx
import React762 from "react";
import styled7 from "@emotion/styled";

// src/components/Button.tsx
import { jsx } from "@emotion/core";
import styled6 from "@emotion/styled";
var VARIANT_STYLES2 = {
  primary: (theme2) => ({
    bg: theme2.colors.bmtBlue,
    color: theme2.colors.bmtWhite,
    fontSize: theme2.fontSizes[2],
    lineHeight: theme2.lineHeights[1],
    fontWeight: theme2.fontWeights.medium,
    borderRadius: "3px",
    border: 0,
    css: {
      "&:hover": {
        backgroundColor: theme2.secondaryColors.blueAccent
      },
      "&:disabled": {
        backgroundColor: "rgba(29, 106, 229, 0.4)",
        opacity: 1,
        cursor: "not-allowed"
      },
      "&:focus": {
        outline: `2px solid ${theme2.colors.bmtBlue}`,
        outlineOffset: "1px",
        textDecoration: "underline"
      }
    }
  }),
  primaryGrey: (theme2) => ({
    bg: theme2.colors.bmtGrey60,
    color: theme2.colors.bmtWhite,
    fontSize: theme2.fontSizes[2],
    lineHeight: theme2.lineHeights[1],
    fontWeight: theme2.fontWeights.medium,
    borderRadius: "3px",
    border: 0,
    css: {
      "&:hover": {
        backgroundColor: theme2.secondaryColors.grey60Accent
      },
      "&:disabled": {
        backgroundColor: "rgba(48, 54, 61, 0.4)",
        opacity: 1,
        cursor: "not-allowed"
      },
      "&:focus": {
        outline: `2px solid ${theme2.colors.bmtBlue}`,
        outlineOffset: "1px",
        textDecoration: "underline"
      }
    }
  }),
  secondary: (theme2) => ({
    bg: theme2.colors.transparent,
    color: theme2.colors.bmtGrey90,
    backgroundColor: theme2.colors.bmtWhite,
    borderRadius: "3px",
    fontSize: theme2.fontSizes[2],
    lineHeight: theme2.lineHeights[1],
    fontWeight: theme2.fontWeights.medium,
    border: 0,
    boxShadow: `inset 0 0 0 1px ${theme2.colors.bmtGrey40}`,
    css: {
      "&:hover": {
        backgroundColor: theme2.secondaryColors.whiteAccent
      },
      "&:disabled": {
        color: "rgb(28, 30, 33, 0.4)",
        borderColor: "rgba(194, 198, 204, 0.4)",
        backgroundColor: theme2.colors.bmtWhite,
        opacity: 1,
        cursor: "not-allowed"
      },
      "&:focus": {
        outline: `2px solid ${theme2.colors.bmtBlue}`,
        outlineOffset: "1px",
        textDecoration: "underline"
      }
    }
  }),
  tertiary: (theme2) => ({
    bg: theme2.colors.transparent,
    color: theme2.colors.bmtBlue,
    border: 0,
    fontWeight: "normal",
    lineHeight: theme2.lineHeights[1],
    padding: 0,
    margin: 0,
    minWidth: 0,
    css: {
      "&:hover": {
        backgroundColor: theme2.colors.transparent,
        textDecoration: "underline"
      },
      "&:focus": {
        outline: `2px solid ${theme2.colors.bmtBlue}`,
        outlineOffset: "1px",
        textDecoration: "underline"
      }
    }
  })
};
var SIZE_STYLES = {
  small: (theme2) => ({
    py: theme2.space[2],
    px: theme2.space[8],
    minWidth: "120px"
  }),
  default: (theme2) => ({
    py: theme2.space[5],
    px: theme2.space[8],
    minWidth: "120px"
  })
};
var ButtonBase = styled6(Base)`
  cursor: pointer;
  display: inline-block;
  text-align: center;
  font-family: 'GT America';
  ${TYPOGRAPHY}
  ${COMMON}
  ${LAYOUT}
  ${BORDER}
`;
var Button = styled6(
  ({ variant = "primary", size: size2 = "default", ...rest }) => {
    const { theme: theme2 } = useTheme();
    return /* @__PURE__ */ jsx(
      ButtonBase,
      {
        as: "button",
        ...variant && VARIANT_STYLES2[variant](theme2),
        ...size2 && variant !== "tertiary" && SIZE_STYLES[size2](theme2),
        ...rest
      }
    );
  }
)``;
Button.displayName = "Button";

// src/components/BackLink.tsx
var Icon = styled7.svg`
  width: 100%;
  height: 100%;
  display: block;
  color: currentColor;

  * {
    color: inherit;
    fill: currentColor;
  }
`;
var BackLink = ({
  title = "Back",
  altText = "Navigate back",
  onClick
}) => /* @__PURE__ */ React762.createElement(Button, { m: "0", p: "0", variant: "tertiary", onClick, tabIndex: 0, title }, /* @__PURE__ */ React762.createElement(Box, { as: "span", color: "bmtBlack", display: "inline-block", size: useTheme().theme.space[6] }, /* @__PURE__ */ React762.createElement(Icon, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", "aria-label": altText, role: "img" }, /* @__PURE__ */ React762.createElement("title", null, altText), /* @__PURE__ */ React762.createElement("polygon", { points: "12.407 14.586 5.824 8.003 12.401 1.413 10.984 0 2.997 8.003 10.993 16" }))));

// src/components/BettermentForAdvisorsLogo.tsx
import React763 from "react";
var BettermentForAdvisorsLogo = ({
  title = "Betterment for Advisors",
  width: width3,
  height: height2
}) => {
  const { theme: theme2 } = useTheme();
  if (!width3 && !height2) {
    width3 = "100";
    height2 = width3;
  }
  return /* @__PURE__ */ React763.createElement(
    "svg",
    {
      width: width3,
      height: height2,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 380 87",
      "aria-label": "Betterment for advisors",
      role: "img",
      color: "currentColor",
      fill: "none"
    },
    /* @__PURE__ */ React763.createElement("title", null, title),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M161.016 84.2541C159.672 82.4305 159 80.0243 159 77.0355C159 74.1212 159.714 71.7373 161.143 69.8839C161.789 68.9958 162.624 68.2803 163.58 67.7951C164.537 67.3099 165.588 67.0684 166.649 67.0903C167.736 67.0363 168.814 67.3162 169.754 67.8961C170.694 68.4761 171.454 69.3311 171.942 70.3576V59H175V86.5427H172.12V83.0071C170.991 85.6681 169.047 86.9986 166.288 86.9986C165.266 87.0207 164.253 86.7829 163.335 86.3053C162.417 85.8276 161.622 85.1242 161.016 84.2541V84.2541ZM170.697 82.3366C171.586 81.1298 172.031 79.5147 172.031 77.4914V76.5974C172.031 74.5116 171.592 72.8726 170.714 71.6807C170.298 71.1007 169.755 70.6352 169.132 70.324C168.509 70.0127 167.824 69.8648 167.135 69.8928C166.435 69.8637 165.738 70.0203 165.109 70.3482C164.481 70.6761 163.94 71.1649 163.536 71.7701C162.672 73.0246 162.24 74.7663 162.24 76.9953C162.24 79.2242 162.672 80.9659 163.536 82.2204C163.94 82.8256 164.481 83.3144 165.109 83.6423C165.738 83.9702 166.435 84.1267 167.135 84.0977C167.819 84.1259 168.5 83.9807 169.119 83.6743C169.739 83.3679 170.28 82.9092 170.697 82.3366V82.3366Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M179 68H182.25L186.206 80.1299C186.502 81.0278 186.75 81.9411 186.95 82.8659H187.054C187.252 81.9406 187.501 81.0272 187.798 80.1299L191.754 68H195L188.608 86H185.396L179 68Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement("path", { d: "M199 60H202V63.9765H199V60ZM199.186 67.4286H201.814V86H199.186V67.4286Z", fill: theme2.colors.bmtNavy }),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M208.564 85.5034C207.874 84.9947 207.292 84.3465 206.851 83.598C206.411 82.8495 206.121 82.0161 206 81.1484L209.167 80.5596C209.334 81.6653 209.902 82.6633 210.754 83.3506C211.71 84.0513 212.864 84.401 214.034 84.3439C215.036 84.4058 216.029 84.116 216.853 83.5214C217.171 83.284 217.429 82.9711 217.605 82.609C217.782 82.2469 217.872 81.8462 217.868 81.4405C217.892 81.1032 217.846 80.7646 217.731 80.448C217.616 80.1313 217.437 79.8443 217.204 79.6068C216.63 79.1391 215.94 78.8479 215.213 78.7663L211.6 78.0787C208.329 77.4405 206.696 75.6577 206.698 72.7303C206.682 71.9372 206.845 71.1511 207.174 70.4348C207.504 69.7184 207.99 69.0917 208.594 68.6045C209.861 67.5349 211.564 67 213.704 67C215.766 67 217.455 67.4585 218.77 68.3753C219.396 68.7874 219.922 69.3423 220.308 69.9974C220.694 70.6525 220.931 71.3906 221 72.1551L217.907 72.8832C217.714 71.9412 217.204 71.1014 216.467 70.5146C215.617 69.9618 214.638 69.6593 213.634 69.6395C212.631 69.6197 211.641 69.8834 210.772 70.4023C210.44 70.6478 210.174 70.9757 209.996 71.3557C209.819 71.7358 209.736 72.1559 209.757 72.5775C209.757 74.0307 210.704 74.9296 212.598 75.2742L216.172 75.9573C219.37 76.5955 220.968 78.3273 220.965 81.1528C220.991 81.9607 220.837 82.7639 220.514 83.4998C220.191 84.2358 219.709 84.8845 219.104 85.3955C217.859 86.4652 216.137 87 213.925 87C211.713 87 209.952 86.5236 208.564 85.5034Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M226.314 84.307C224.771 82.5117 224 80.076 224 77C224 73.924 224.771 71.4883 226.314 69.693C227.859 67.8977 229.921 67 232.5 67C235.079 67 237.141 67.8977 238.686 69.693C240.229 71.4883 241 73.924 241 77C241 80.076 240.229 82.5117 238.686 84.307C237.141 86.1023 235.079 87 232.5 87C229.921 87 227.859 86.1023 226.314 84.307ZM236.351 82.3411C237.261 81.1203 237.716 79.3399 237.716 77C237.716 74.6601 237.261 72.8797 236.351 71.6589C235.871 71.0838 235.279 70.6228 234.615 70.3069C233.951 69.991 233.23 69.8276 232.5 69.8276C231.77 69.8276 231.049 69.991 230.385 70.3069C229.721 70.6228 229.129 71.0838 228.649 71.6589C227.739 72.8797 227.284 74.6601 227.284 77C227.284 79.3399 227.739 81.1203 228.649 82.3411C229.129 82.9162 229.721 83.3772 230.385 83.6931C231.049 84.009 231.77 84.1724 232.5 84.1724C233.23 84.1724 233.951 84.009 234.615 83.6931C235.279 83.3772 235.871 82.9162 236.351 82.3411V82.3411Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M258.563 85.4691C257.874 84.961 257.291 84.3136 256.851 83.5659C256.41 82.8182 256.121 81.9858 256 81.119L259.17 80.5443C259.337 81.6476 259.903 82.644 260.753 83.3322C261.71 84.0313 262.865 84.3803 264.036 84.3243C265.038 84.3862 266.031 84.0968 266.854 83.5028C267.172 83.2657 267.43 82.9531 267.606 82.5914C267.783 82.2297 267.873 81.8295 267.869 81.4242C267.893 81.0874 267.847 80.7491 267.732 80.4328C267.617 80.1165 267.438 79.8299 267.206 79.5926C266.631 79.1254 265.941 78.8346 265.215 78.7531L261.603 78.0662C258.333 77.4287 256.7 75.648 256.702 72.7239C256.686 71.9316 256.849 71.1464 257.178 70.4309C257.507 69.7154 257.993 69.0894 258.598 68.6027C259.864 67.5343 261.565 67 263.702 67C265.766 67 267.456 67.4579 268.771 68.3738C269.396 68.7854 269.922 69.3396 270.308 69.994C270.695 70.6484 270.931 71.3856 271 72.1493L267.908 72.899C267.719 71.9577 267.21 71.118 266.473 70.5331C265.623 69.9809 264.644 69.6787 263.641 69.659C262.638 69.6392 261.648 69.9026 260.779 70.4209C260.448 70.6661 260.181 70.9936 260.004 71.3733C259.826 71.7529 259.744 72.1725 259.764 72.5937C259.764 74.0452 260.709 74.9431 262.6 75.2873L266.178 75.9697C269.358 76.6072 270.955 78.3371 270.97 81.1594C270.996 81.9664 270.841 82.7687 270.519 83.5038C270.196 84.2389 269.714 84.8869 269.109 85.3973C267.863 86.4657 266.129 87 263.905 87C261.682 87 259.901 86.4897 258.563 85.4691Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M76.4533 62.9448V71.2155H87.6862V74.1431H76.4533V86H73V60H89V62.9277L76.4533 62.9448Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M93.3176 84.307C91.7725 82.5117 91 80.076 91 77C91 73.924 91.7725 71.4883 93.3176 69.693C94.8626 67.8977 96.9241 67 99.5021 67C102.08 67 104.14 67.8977 105.682 69.693C107.228 71.4883 108 73.924 108 77C108 80.076 107.228 82.5117 105.682 84.307C104.14 86.1023 102.08 87 99.5021 87C96.9241 87 94.8626 86.1023 93.3176 84.307ZM103.348 82.3411C104.263 81.1203 104.72 79.3399 104.717 77C104.714 74.6601 104.258 72.8797 103.348 71.6589C102.869 71.0839 102.277 70.6229 101.614 70.3071C100.95 69.9912 100.229 69.8278 99.5 69.8278C98.7708 69.8278 98.0501 69.9912 97.3863 70.3071C96.7226 70.6229 96.1313 71.0839 95.6523 71.6589C94.7424 72.8797 94.2861 74.6601 94.2832 77C94.2804 79.3399 94.7367 81.1203 95.6523 82.3411C96.1313 82.9161 96.7226 83.377 97.3863 83.6929C98.0501 84.0087 98.7708 84.1722 99.5 84.1722C100.229 84.1722 100.95 84.0087 101.614 83.6929C102.277 83.377 102.869 82.9161 103.348 82.3411Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M116.529 68.3121C117.553 67.4497 118.893 66.9809 120.278 67.001C120.519 66.9962 120.761 67.0093 121 67.0403V70.0997C117.856 69.4485 114.862 71.9529 114.499 75.7072C114.442 76.3016 114.418 77.084 114.418 78.0499V86H111V67.4249H114.168V71.6601C114.624 70.3718 115.438 69.2172 116.529 68.3121V68.3121Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M249.968 68.3121C250.892 67.4502 252.101 66.9815 253.349 67.001C253.567 66.9962 253.784 67.0093 254 67.0403V70.0997C251.163 69.4485 248.471 71.9529 248.143 75.7072C248.092 76.3016 248.071 77.084 248.071 78.0499V86H245V67.4249H247.841V71.6601C248.252 70.3716 248.985 69.2169 249.968 68.3121V68.3121Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M154.203 86H158L146.774 60H143.226L132 85.9828H135.797L138.817 78.5302H151.178L154.203 86ZM140.01 75.6198L145.004 63.2936L149.999 75.6198H140.01Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M345.763 16.0013C343.8 15.9724 341.861 16.4429 340.115 17.3712C338.37 18.2996 336.872 19.6574 335.753 21.3252V16.8886H328V47H335.753V32.2659C335.753 26.6003 338.357 23.2196 342.717 23.2196C346.578 23.2196 349.307 25.8506 349.307 30.2473V47H357V28.5613C357 20.7129 352.418 16.0013 345.763 16.0013Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M269.112 46.9911H260.951V30.2433C260.951 26.1095 258.36 23.2176 254.647 23.2176C250.012 23.2176 247.248 26.5974 247.248 32.2613V46.9911H239V16.8884H247.248V21.3237C248.436 19.6562 250.028 18.2986 251.883 17.3704C253.738 16.4422 255.8 15.972 257.886 16.0013C262.616 16.0013 266.188 18.3654 267.922 22.3527C269.162 20.3908 270.904 18.7746 272.978 17.6616C275.052 16.5485 277.387 15.9765 279.755 16.0013C286.598 16.0013 291 20.9334 291 28.5667V47H282.821V30.2521C282.821 26.1183 280.23 23.2265 276.516 23.2265C271.882 23.2265 269.112 26.6062 269.112 32.2702V46.9911Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M101.119 26.7191L99.3575 26.0158L101.041 25.1577C102.509 24.2939 103.716 23.0713 104.541 21.6124C105.367 20.1536 105.783 18.5099 105.746 16.8463C105.746 11.9541 101.393 7 93.0784 7H73V47H93.1332C106.33 47 106.996 37.9411 106.996 36.1231C107.049 34.1745 106.523 32.2523 105.481 30.5852C104.439 28.918 102.925 27.5761 101.119 26.7191V26.7191ZM81.2961 13.5819H91.2304C93.9683 13.5819 96.8934 15.1743 96.8934 18.6687C96.8934 22.0835 94.0459 23.8705 91.2304 23.8705H81.2961V13.5819ZM92.5308 40.4225H81.2961V30.1295H92.5308C96.2088 30.1295 98.1346 32.7481 98.1346 35.3357C98.1528 38.2817 95.7799 40.4225 92.5308 40.4225Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M141 32.0089C140.824 22.5859 134.343 16 125.226 16C115.987 16 109.001 22.8749 109.001 32.0089C108.947 36.181 110.529 40.2123 113.418 43.2596C116.37 46.3191 120.606 48 125.212 48C129.818 48 134.055 46.3191 137.011 43.2596C138.601 41.6106 139.804 39.6371 140.536 37.4786H133.063C131.536 40.1467 128.651 41.7921 125.212 41.7921C121.255 41.7921 118.06 39.0128 117.177 34.7126L116.965 33.672H140.964L141 32.0089ZM117.438 28.1623C117.917 26.4874 118.94 25.0141 120.35 23.9694C121.761 22.9248 123.48 22.3668 125.244 22.3813C128.967 22.3813 131.752 24.547 132.725 28.1623H117.438Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M215 32.0089C214.825 22.5859 208.551 16 199.719 16C190.769 16 184.001 22.8749 184.001 32.0089C183.948 36.181 185.482 40.2123 188.28 43.2596C191.14 46.3191 195.266 48 199.706 48C204.146 48 208.272 46.3191 211.132 43.2596C212.673 41.6104 213.84 39.637 214.55 37.4786H207.312C205.827 40.1467 203.037 41.7921 199.706 41.7921C195.872 41.7921 192.773 39.0128 191.921 34.7126L191.716 33.672H214.965L215 32.0089ZM192.17 28.1623C192.634 26.487 193.627 25.0136 194.994 23.969C196.361 22.9244 198.027 22.3666 199.736 22.3813C203.343 22.3813 206.041 24.547 206.98 28.1623H192.17Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M324 32.0089C323.83 22.5859 317.551 16 308.719 16C299.769 16 293.001 22.8749 293.001 32.0089C292.948 36.181 294.482 40.2123 297.28 43.2596C300.144 46.3191 304.244 48 308.71 48C313.177 48 317.272 46.3191 320.136 43.2596C321.676 41.6096 322.843 39.6365 323.555 37.4786H316.346C314.866 40.1467 312.076 41.7921 308.745 41.7921C304.907 41.7921 301.812 39.0128 300.961 34.7126L300.751 33.672H324V32.0089ZM301.174 28.1623C301.638 26.4874 302.629 25.0141 303.996 23.9694C305.362 22.9248 307.028 22.3668 308.736 22.3813C312.343 22.3813 315.045 24.547 315.984 28.1623H301.174Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M237 16.0298C231.916 15.7149 227.594 17.9103 225.394 22.0881V16.899H217V47H225.394V33.9342C225.394 25.9511 231.123 21.8752 237 24.177V16.0298Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M183.037 41.4464C181.855 41.9648 180.578 42.2339 179.286 42.2368C175.726 42.2368 173.754 40.0743 173.754 36.1446V24.098H183.389V17.9436H173.75V5.00444L165.704 7.92618V17.9436H152.046V5L144 7.92174V37.2281C144 44.9277 148.005 48.995 155.571 48.995C158.215 49.0557 160.843 48.5594 163.283 47.5386L161.329 41.4598C160.148 41.9785 158.872 42.2476 157.582 42.2501C154.022 42.2501 152.05 40.0877 152.05 36.158V24.1157H165.717V37.2281C165.717 44.9277 169.722 48.995 177.288 48.995C179.933 49.0557 182.56 48.5594 185 47.5386L183.037 41.4464Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M378.075 40.6138C376.91 41.1203 375.651 41.3833 374.378 41.3862C370.871 41.3862 368.928 39.2729 368.928 35.4324V23.6596H378.421V17.6451H368.924V5L361 7.85533V36.4956C361 44.0202 364.946 47.9952 372.401 47.9952C375.007 48.0544 377.596 47.5694 380 46.5718L378.075 40.6138Z",
        fill: theme2.colors.bmtNavy
      }
    ),
    /* @__PURE__ */ React763.createElement(
      "path",
      {
        d: "M32.0009 41.9136L57.4116 51C61.5755 45.7029 64 38.9591 64 31.4374C64 13.5181 50.2448 0 32.0009 0C13.7571 0 0.00196178 13.5138 0.00196178 31.4374C-0.0771958 38.4966 2.24117 45.3803 6.59041 51L32.0009 41.9136Z",
        fill: theme2.colors.bmtGold
      }
    )
  );
};

// src/components/BettermentLogo.tsx
import React764 from "react";
var BettermentLogo = ({
  title = "Betterment",
  width: width3,
  height: height2,
  darkBackground
}) => {
  const { theme: theme2 } = useTheme();
  const fillColor = darkBackground ? theme2.colors.bmtWhite : theme2.colors.bmtNavy;
  if (!width3 && !height2) {
    width3 = "100";
    height2 = width3;
  }
  return /* @__PURE__ */ React764.createElement(
    "svg",
    {
      width: width3,
      height: height2,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 380 51",
      fill: "none",
      "aria-label": "Betterment",
      role: "img",
      color: "currentColor"
    },
    /* @__PURE__ */ React764.createElement("title", null, title),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M345.767 16.001C343.802 15.9752 341.861 16.4493 340.114 17.3814C338.368 18.3135 336.871 19.6751 335.754 21.3462V16.9097H328V47H335.754V32.2724C335.754 26.6128 338.356 23.2359 342.715 23.2359C346.555 23.2359 349.303 25.8645 349.303 30.2569V47H357V28.5748C357.003 20.7142 352.411 16.001 345.767 16.001Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M269.124 46.978H260.944V30.2367C260.944 26.1024 258.357 23.2163 254.644 23.2163C250.009 23.2163 247.244 26.5928 247.244 32.2519V46.978H239V16.9002H247.244V21.3457C248.43 19.6746 250.02 18.313 251.876 17.3809C253.731 16.4488 255.793 15.9749 257.881 16.001C262.61 16.001 266.177 18.3652 267.927 22.3517C269.168 20.3908 270.909 18.7753 272.982 17.6625C275.056 16.5496 277.39 15.9773 279.758 16.001C286.589 16.001 291 20.9338 291 28.5767V47H282.824V30.2587C282.824 26.1244 280.236 23.2383 276.52 23.2383C271.889 23.2383 269.12 26.6149 269.12 32.2739L269.124 46.978Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M101.135 26.7192L99.374 26.0134L101.057 25.1539C101.255 25.0535 105.76 22.6443 105.76 16.8471C105.76 11.9533 101.41 7 93.0944 7H73V47H93.1333C106.333 47 107 37.9372 107 36.1208C107.003 29.1567 101.193 26.7475 101.135 26.7192ZM81.3123 13.5814H91.2462C93.9716 13.5814 96.9074 15.1719 96.9074 18.6697C96.9074 22.0827 94.059 23.8708 91.2462 23.8708H81.3123V13.5814ZM92.5474 40.4186H81.3123V30.1292H92.5474C96.2277 30.1292 98.1504 32.7454 98.1504 35.3334C98.1504 38.2854 95.794 40.4248 92.5474 40.4248V40.4186Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M141 32.011C140.821 22.5868 134.337 16 125.226 16C115.978 16 109.001 22.8803 109.001 32.0047C108.947 36.1807 110.531 40.2158 113.424 43.2658C116.381 46.3241 120.621 48 125.233 48C129.844 48 134.084 46.3178 137.041 43.2658C138.631 41.6079 139.832 39.6268 140.562 37.4617H133.089C131.559 40.1475 128.676 41.7761 125.233 41.7761C121.268 41.7761 118.067 38.9956 117.187 34.6937L116.973 33.6522H141V32.011ZM117.411 28.1637C117.888 26.4845 118.911 25.0065 120.323 23.9576C121.735 22.9086 123.458 22.3471 125.226 22.3596C128.955 22.3596 131.742 24.531 132.715 28.1637H117.411Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M215 32.011C214.826 22.5868 208.546 16 199.721 16C190.759 16 184.001 22.8803 184.001 32.0047C183.95 36.1804 185.485 40.2149 188.285 43.2658C191.15 46.3241 195.257 48 199.727 48C204.197 48 208.301 46.3178 211.165 43.2658C212.705 41.6079 213.869 39.6268 214.575 37.4617H207.328C205.846 40.1475 203.05 41.7761 199.718 41.7761C195.877 41.7761 192.777 38.9956 191.925 34.6937L191.717 33.6522H214.991L215 32.011ZM192.148 28.1637C192.61 26.4843 193.601 25.0061 194.97 23.9572C196.338 22.9084 198.008 22.347 199.721 22.3596C203.332 22.3596 206.032 24.531 206.974 28.1637H192.148Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M324 32.011C323.826 22.5868 317.545 16 308.719 16C299.757 16 293.001 22.8803 293.001 32.0047C292.949 36.18 294.483 40.2146 297.283 43.2658C300.15 46.3241 304.258 48 308.725 48C313.193 48 317.301 46.3178 320.165 43.2658C321.705 41.6079 322.869 39.6268 323.575 37.4617H316.327C314.845 40.1475 312.052 41.7761 308.716 41.7761C304.875 41.7761 301.775 38.9956 300.922 34.6937L300.715 33.6522H324V32.011ZM301.149 28.1637C301.609 26.4843 302.6 25.0059 303.969 23.9569C305.337 22.9079 307.006 22.3466 308.719 22.3596C312.331 22.3596 315.031 24.531 315.974 28.1637H301.149Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M237 16.0296C231.913 15.7152 227.588 17.9163 225.4 22.086V16.9069H217V47H225.4V33.9345C225.4 25.9537 231.135 21.8816 237 24.1676V16.0296Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M183.049 40.456C181.866 40.9746 180.589 41.2439 179.298 41.247C175.73 41.247 173.762 39.0821 173.762 35.1495V23.0962H183.402V16.9482H173.756V4.00315L165.711 6.92427V16.9482H152.045V4L144 6.92115V36.2272C144 43.9287 148.001 48 155.566 48C158.518 48 161.05 47.5242 163.283 46.5442L161.331 40.4624C160.149 40.9809 158.872 41.2502 157.58 41.2533C154.012 41.2533 152.045 39.0884 152.045 35.1558V23.1056H165.717V36.2272C165.717 43.9287 169.718 48 177.286 48C180.235 48 182.768 47.5242 185 46.5442L183.049 40.456Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M378.077 40.4529C376.913 40.9714 375.656 41.2406 374.384 41.2438C370.866 41.2438 368.93 39.079 368.93 35.1463V23.093H378.426V16.9451H368.927V4L361 6.92112V36.2271C361 43.9286 364.942 48 372.399 48C375.308 48 377.804 47.5242 380 46.5442L378.077 40.4529Z",
        fill: fillColor
      }
    ),
    /* @__PURE__ */ React764.createElement(
      "path",
      {
        d: "M32 41.9115L57.4145 51C61.5766 45.7025 64 38.9575 64 31.4345C64 13.5149 50.2451 0 32 0C13.7549 0 0 13.5149 0 31.4345C0 38.9575 2.42659 45.6932 6.5887 51L32 41.9115Z",
        fill: theme2.colors.bmtGold
      }
    )
  );
};

// src/components/BettermentAtWorkLogo.tsx
import React765 from "react";
var BettermentAtWorkLogo = ({
  title = "Betterment at Work",
  width: width3,
  height: height2
}) => {
  if (!width3 && !height2) {
    width3 = "182.42";
    height2 = "16";
  }
  return /* @__PURE__ */ React765.createElement("svg", { width: width3, height: height2, viewBox: "0 0 582 51", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React765.createElement("title", null, title), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M345.767 16.0009C343.801 15.9751 341.86 16.4492 340.114 17.3813C338.368 18.3135 336.871 19.6751 335.754 21.3461V16.9096H328V46.9999H335.754V32.2724C335.754 26.6127 338.356 23.2358 342.714 23.2358C346.555 23.2358 349.303 25.8644 349.303 30.2569V46.9999H357V28.5747C357.003 20.7141 352.41 16.0009 345.767 16.0009Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M269.123 46.9779H260.944V30.2366C260.944 26.1024 258.356 23.2162 254.644 23.2162C250.009 23.2162 247.244 26.5928 247.244 32.2518V46.9779H239V16.9001H247.244V21.3456C248.429 19.6746 250.02 18.3129 251.875 17.3808C253.73 16.4487 255.793 15.9748 257.881 16.001C262.609 16.001 266.177 18.3652 267.926 22.3517C269.167 20.3907 270.909 18.7753 272.982 17.6624C275.055 16.5496 277.389 15.9772 279.757 16.001C286.588 16.001 291 20.9338 291 28.5766V46.9999H282.823V30.2586C282.823 26.1244 280.236 23.2383 276.52 23.2383C271.888 23.2383 269.12 26.6148 269.12 32.2739L269.123 46.9779Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M101.135 26.7193L99.3739 26.0135L101.057 25.1539C101.255 25.0535 105.76 22.6443 105.76 16.8471C105.76 11.9534 101.41 7.00006 93.0944 7.00006H73V47.0001H93.1333C106.333 47.0001 107 37.9372 107 36.1209C107.003 29.1567 101.193 26.7475 101.135 26.7193ZM81.3123 13.5815H91.2462C93.9716 13.5815 96.9074 15.172 96.9074 18.6697C96.9074 22.0828 94.059 23.8709 91.2462 23.8709H81.3123V13.5815ZM92.5474 40.4186H81.3123V30.1292H92.5474C96.2277 30.1292 98.1504 32.7455 98.1504 35.3335C98.1504 38.2854 95.794 40.4249 92.5474 40.4249V40.4186Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M141 32.011C140.82 22.5868 134.337 15.9999 125.226 15.9999C115.977 15.9999 109.001 22.8803 109.001 32.0047C108.946 36.1806 110.531 40.2157 113.424 43.2657C116.381 46.324 120.621 47.9999 125.232 47.9999C129.844 47.9999 134.084 46.3177 137.041 43.2657C138.63 41.6079 139.832 39.6267 140.561 37.4616H133.089C131.559 40.1475 128.676 41.7761 125.232 41.7761C121.267 41.7761 118.067 38.9955 117.187 34.6937L116.973 33.6522H141V32.011ZM117.411 28.1637C117.887 26.4845 118.91 25.0064 120.323 23.9575C121.735 22.9086 123.458 22.3471 125.226 22.3595C128.954 22.3595 131.741 24.531 132.714 28.1637H117.411Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M215 32.011C214.826 22.5868 208.546 15.9999 199.721 15.9999C190.759 15.9999 184.001 22.8803 184.001 32.0047C183.95 36.1803 185.485 40.2149 188.285 43.2657C191.15 46.324 195.257 47.9999 199.727 47.9999C204.197 47.9999 208.301 46.3177 211.165 43.2657C212.705 41.6079 213.869 39.6267 214.575 37.4616H207.328C205.846 40.1475 203.05 41.7761 199.718 41.7761C195.877 41.7761 192.777 38.9955 191.925 34.6937L191.717 33.6522H214.991L215 32.011ZM192.148 28.1637C192.61 26.4842 193.601 25.0061 194.97 23.9572C196.338 22.9083 198.008 22.3469 199.721 22.3595C203.332 22.3595 206.032 24.531 206.974 28.1637H192.148Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M324 32.011C323.826 22.5868 317.545 15.9999 308.719 15.9999C299.756 15.9999 293.001 22.8803 293.001 32.0047C292.948 36.18 294.482 40.2145 297.282 43.2657C300.15 46.324 304.258 47.9999 308.725 47.9999C313.192 47.9999 317.3 46.3177 320.165 43.2657C321.704 41.6079 322.868 39.6267 323.575 37.4616H316.327C314.845 40.1475 312.051 41.7761 308.716 41.7761C304.874 41.7761 301.774 38.9955 300.922 34.6937L300.714 33.6522H324V32.011ZM301.148 28.1637C301.609 26.4842 302.6 25.0058 303.968 23.9568C305.337 22.9078 307.006 22.3465 308.719 22.3595C312.33 22.3595 315.031 24.531 315.973 28.1637H301.148Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M237 16.0296C231.913 15.7151 227.588 17.9163 225.399 22.0859V16.9069H217V46.9999H225.399V33.9345C225.399 25.9537 231.135 21.8815 237 24.1676V16.0296Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M183.048 40.456C181.866 40.9746 180.589 41.2439 179.297 41.247C175.729 41.247 173.762 39.0821 173.762 35.1495V23.0962H183.402V16.9482H173.756V4.00315L165.71 6.92427V16.9482H152.045V4L144 6.92115V36.2272C144 43.9287 148 48 155.565 48C158.518 48 161.05 47.5242 163.282 46.5442L161.331 40.4624C160.148 40.9809 158.871 41.2502 157.58 41.2533C154.012 41.2533 152.045 39.0884 152.045 35.1558V23.1056H165.717V36.2272C165.717 43.9287 169.717 48 177.286 48C180.235 48 182.767 47.5242 184.999 46.5442L183.048 40.456Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M378.078 40.4529C376.914 40.9714 375.656 41.2406 374.385 41.2438C370.866 41.2438 368.931 39.079 368.931 35.1463V23.093H378.426V16.9451H368.928V4L361 6.92112V36.2271C361 43.9286 364.942 48 372.4 48C375.309 48 377.804 47.5242 380 46.5442L378.078 40.4529Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M31.5978 41.9115L56.6929 51C60.8027 45.7025 63.1956 38.9575 63.1956 31.4345C63.1956 13.5149 49.6137 0 31.5978 0C13.582 0 0 13.5149 0 31.4345C0 38.9575 2.39609 45.6932 6.50589 51L31.5978 41.9115Z",
      fill: "#FFC729",
      className: "sun"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M403.357 47.5365C400.338 47.5365 397.928 46.7525 396.125 45.1846C394.321 43.6167 393.42 41.5196 393.42 38.8933C393.42 37.4038 393.773 36.0711 394.478 34.8951C395.184 33.68 396.203 32.7 397.536 31.9553C398.672 31.4065 400.005 30.9361 401.534 30.5441C403.063 30.1522 405.023 29.819 407.414 29.5446L412.882 28.8978V28.4274C412.882 25.7228 412.372 23.7825 411.353 22.6065C410.334 21.4306 408.688 20.8426 406.414 20.8426C404.415 20.8426 402.827 21.3522 401.652 22.3713C400.476 23.3905 399.829 24.8212 399.711 26.6635H394.361C394.557 23.6453 395.733 21.2346 397.888 19.4315C400.084 17.6284 402.906 16.7268 406.355 16.7268C410.393 16.7268 413.333 17.7068 415.175 19.6667C417.017 21.5874 417.938 24.684 417.938 28.9566V36.8942C417.938 41.3628 418.271 44.675 418.938 46.8309H413.705C413.47 45.1846 413.313 43.4011 413.235 41.4804C412.568 43.3619 411.353 44.8514 409.589 45.949C407.825 47.0073 405.748 47.5365 403.357 47.5365ZM404.474 43.4207C407.022 43.4207 409.06 42.5779 410.589 40.8924C412.157 39.1677 412.941 36.8746 412.941 34.0132V32.5432L404.944 33.7192C402.788 34.0328 401.201 34.6011 400.182 35.4243C399.202 36.2082 398.712 37.3254 398.712 38.7757C398.712 40.226 399.221 41.3628 400.24 42.1859C401.26 43.0091 402.671 43.4207 404.474 43.4207Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M421.027 17.4324H426.495V9.72998L431.493 7.61329V17.4324H438.842V21.5482H431.493V37.835C431.493 39.5205 431.826 40.7552 432.492 41.5392C433.198 42.2839 434.295 42.6563 435.785 42.6563C436.647 42.6563 437.667 42.5191 438.842 42.2447V46.8309C437.549 47.1837 436.099 47.3601 434.491 47.3601C431.512 47.3601 429.435 46.5565 428.259 44.9494C427.083 43.3423 426.495 41.0296 426.495 38.0114V21.5482H421.027V17.4324Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M450.561 5.08502H456.264L463.496 38.7169C463.653 39.5401 463.771 40.3044 463.849 41.01H464.026C464.065 40.5396 464.221 39.7753 464.496 38.7169L473.08 5.08502H478.725L487.309 38.7169C487.584 39.7753 487.74 40.5396 487.78 41.01H487.956C488.034 40.3044 488.152 39.5401 488.309 38.7169L495.541 5.08502H501.244L491.307 46.8309H484.487L476.373 14.2574C476.177 13.4734 476.059 12.8266 476.02 12.3171H475.785C475.746 12.8266 475.628 13.4734 475.432 14.2574L467.318 46.8309H460.498L450.561 5.08502Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M516.11 47.5365C513.366 47.5365 510.955 46.9289 508.878 45.7138C506.8 44.4594 505.193 42.6759 504.057 40.3632C502.959 38.0506 502.41 35.3067 502.41 32.1317C502.41 28.9566 502.959 26.2128 504.057 23.9001C505.193 21.5874 506.8 19.8235 508.878 18.6083C510.955 17.354 513.366 16.7268 516.11 16.7268C518.854 16.7268 521.265 17.354 523.342 18.6083C525.42 19.8235 527.007 21.5874 528.105 23.9001C529.241 26.2128 529.81 28.9566 529.81 32.1317C529.81 35.3067 529.241 38.0506 528.105 40.3632C527.007 42.6759 525.42 44.4594 523.342 45.7138C521.265 46.9289 518.854 47.5365 516.11 47.5365ZM516.11 43.1855C518.775 43.1855 520.833 42.2447 522.284 40.3632C523.773 38.4817 524.518 35.7379 524.518 32.1317C524.518 28.5254 523.773 25.7816 522.284 23.9001C520.833 22.0186 518.775 21.0778 516.11 21.0778C513.445 21.0778 511.367 22.0186 509.878 23.9001C508.427 25.7816 507.702 28.5254 507.702 32.1317C507.702 35.7379 508.427 38.4817 509.878 40.3632C511.367 42.2447 513.445 43.1855 516.11 43.1855Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M541.197 24.1353C541.941 21.9402 543.078 20.1567 544.607 18.7847C546.175 17.4128 548.017 16.7268 550.134 16.7268C550.604 16.7268 550.957 16.7464 551.192 16.7856V21.6658H550.957C548.174 21.6658 546.018 22.4301 544.489 23.9589C543.235 25.2132 542.431 26.6635 542.079 28.3098C541.726 29.9562 541.549 31.9357 541.549 34.2484V46.8309H536.552V17.4324H541.197V24.1353Z",
      fill: "#000B50"
    }
  ), /* @__PURE__ */ React765.createElement(
    "path",
    {
      d: "M575.574 46.8309L566.696 32.4256L561.345 37.835V46.8309H556.348V4.20306H561.345V31.8965L574.516 17.4324H581.042L570.282 28.7802L581.748 46.8309H575.574Z",
      fill: "#000B50"
    }
  ));
};

// src/components/WorkflowHeader.tsx
import React766 from "react";
import styled8 from "@emotion/styled";
import VisuallyHidden from "@reach/visually-hidden";
var Grid = styled8(Box)`
  grid-template-columns: repeat(3, 1fr);
  display: grid;
`;
var Title = styled8.p`
  color: ${get("colors.bmtGrey60")};
  display: table-cell;
  font-size: ${get("fontSizes.1")};
  margin: 0;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
`;
var WorkflowHeader = ({
  backButtonHandler,
  backButtonTitle = "Navigate to previous page",
  closeHandler,
  logo: Logo,
  logoHandler,
  logoTitle = "Navigate to application home",
  title
}) => {
  const { theme: theme2 } = useTheme();
  const HEIGHT = theme2.space[11];
  return /* @__PURE__ */ React766.createElement(Grid, { height: HEIGHT, minHeight: HEIGHT, position: "relative" }, /* @__PURE__ */ React766.createElement(Flex, { alignItems: "center" }, backButtonHandler && /* @__PURE__ */ React766.createElement(Button, { variant: "tertiary", height: theme2.space[7], onClick: backButtonHandler, title: backButtonTitle }, /* @__PURE__ */ React766.createElement(FeatureLeft24, null)), Logo && logoHandler && /* @__PURE__ */ React766.createElement(Button, { ml: backButtonHandler ? 10 : 0, variant: "tertiary", onClick: logoHandler, title: logoTitle }, /* @__PURE__ */ React766.createElement(Logo, null))), /* @__PURE__ */ React766.createElement(Box, { display: "table", height: "100%" }, /* @__PURE__ */ React766.createElement(Title, null, title)), closeHandler && /* @__PURE__ */ React766.createElement(Flex, { justifyContent: "flex-end", alignItems: "center" }, /* @__PURE__ */ React766.createElement(Box, null, /* @__PURE__ */ React766.createElement(Button, { variant: "tertiary", height: theme2.space[7], onClick: closeHandler }, /* @__PURE__ */ React766.createElement(VisuallyHidden, null, "Close"), /* @__PURE__ */ React766.createElement(FeatureX24, { "aria-hidden": "true" })))));
};

// src/components/Card.tsx
import React768 from "react";
import styled10 from "@emotion/styled";
import { display as display3 } from "styled-system";

// src/components/Heading.tsx
import React767 from "react";
import styled9 from "@emotion/styled";
var VARIANT_STYLES3 = {
  primary: { fontSize: [4, 4, 5, 6], lineHeight: [3, 3, 4, 5], mb: 6 },
  secondary: { fontSize: [3, 3, 4, 4], lineHeight: [2, 2, 3, 3], mb: 6 },
  tertiary: { fontSize: [2, 2, 3, 3], lineHeight: [1, 1, 2, 2], mb: 6 }
};
var HeadingBase = styled9(Base)`
  ${TYPOGRAPHY}
  ${COMMON}
`;
var Heading = ({ variant, ...rest }) => /* @__PURE__ */ React767.createElement(HeadingBase, { ...rest, ...variant && VARIANT_STYLES3[variant] });
Heading.defaultProps = {
  color: "bmtGrey60",
  fontSize: [6],
  as: "h1"
};

// src/components/Card.tsx
var TOP_BORDER_WIDTH = "0.4rem";
var VARIANT_STYLES4 = {
  default: { borderTopColor: "colors.transparent" },
  success: { borderTopColor: "colors.bmtTeal" },
  error: { borderTopColor: "colors.bmtOrange" }
};
var CardContainer = styled10(Box)`
  background-color: ${get("colors.bmtWhite")};
  border: ${({ theme: theme2 }) => `solid 1px ${get("colors.bmtGrey20")(theme2)}`};
  border-radius: ${(props) => props.isRounded ? "4px" : "0"};
  position: relative;
  ${FLEX_CONTAINER}
  ${BORDER}
  ${COMMON}
  ${display3}
`;
var CardContainerWithTopBorder = styled10(CardContainer)`
  &:before {
    border: ${({ theme: theme2, variant }) => `solid ${TOP_BORDER_WIDTH} ${get(VARIANT_STYLES4[variant || "default"].borderTopColor)(theme2)}`};
    border-radius: ${(props) => props.isRounded ? "4px" : 0};
    content: '';
    display: block;
    left: -1px;
    position: absolute;
    top: -1px;
    width: calc(100% + 2px);
  }
`;
var Card2 = ({ children, isRounded = false, variant = "default" }) => {
  const [header, body, footer] = getSlots(["header", "body", "footer"], children, "body");
  if (variant === "default") {
    return /* @__PURE__ */ React768.createElement(CardContainer, { isRounded, variant }, header && /* @__PURE__ */ React768.createElement(Box, { my: 0, mx: [0, 8], borderBottom: "1px solid", borderColor: "bmtGrey20" }, /* @__PURE__ */ React768.createElement(Heading, { m: "0", px: [8, 0], py: 8, fontWeight: "medium", fontSize: "3" }, header)), /* @__PURE__ */ React768.createElement(Box, { p: 8 }, body), footer && /* @__PURE__ */ React768.createElement(Box, { mx: [0, 8], px: [8, 0], py: 8, borderTop: "1px solid", borderColor: "bmtGrey20" }, footer));
  }
  return /* @__PURE__ */ React768.createElement(CardContainerWithTopBorder, { isRounded, variant }, header && /* @__PURE__ */ React768.createElement(Box, { my: 0, mx: [0, 8], borderBottom: "1px solid", borderColor: "bmtGrey20" }, /* @__PURE__ */ React768.createElement(Heading, { m: "0", px: [8, 0], py: 8, fontWeight: "medium", fontSize: "3" }, header)), /* @__PURE__ */ React768.createElement(Box, { p: 8 }, body), footer && /* @__PURE__ */ React768.createElement(Box, { mx: [0, 8], px: [8, 0], py: 8, borderTop: "1px solid", borderColor: "bmtGrey20" }, footer));
};
Card2.Slot = Slot;

// src/components/CenteredWorkflowLayout.tsx
import React773, { createContext as createContext2, useContext as useContext2, useMemo } from "react";
import styled17 from "@emotion/styled";

// src/components/ContentLayoutC.tsx
import styled11 from "@emotion/styled";
import { display as display4 } from "styled-system";
var Slot1 = styled11(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var Slot2 = styled11(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var ContentLayoutC = styled11(Base)`
  ${FLEX_CONTAINER}
  ${COMMON}
  ${display4}
`;
ContentLayoutC.Slot1 = Slot1;
ContentLayoutC.Slot2 = Slot2;

// src/components/ProgressBar.tsx
import React769 from "react";
import styled12 from "@emotion/styled";
var Bar = styled12(Box)`
  transition: width 0.3s ease-out;
  will-change: width;
`;
var ProgressBarBase = ({
  indicatorColor = "bmtBlue",
  percent,
  rounded = true,
  bg = "bmtGrey20",
  ...rest
}) => /* @__PURE__ */ React769.createElement(Box, { ...rest, bg, borderRadius: rounded ? BORDER_RADIUS : 0 }, /* @__PURE__ */ React769.createElement(
  Bar,
  {
    bg: indicatorColor,
    borderRadius: rounded ? BORDER_RADIUS : 0,
    height: 6,
    width: percent / 100,
    role: "progressbar",
    "aria-valuenow": percent,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }
));
var ProgressBar = styled12(ProgressBarBase)`
  ${COMMON}
`;

// src/components/SectionLayout.tsx
import React770 from "react";
import styled13 from "@emotion/styled";
var ContentWrapper = styled13(Base)`
  ${COMMON}
  width: 100%;
  margin: 0 auto;
  max-width: ${CONTENT_MAX_WIDTH};
`;
var SectionLayoutBase = styled13(Base)`
  ${COMMON}
  ${BORDER}
  ${FLEX_ITEM}
  ${POSITION}
  border-color: ${({ borderColor: borderColor4 }) => borderColor4 || theme.colors[BORDER_COLOR]};
  display: flex;
  min-height: 1px;
  position: relative;
  justify-content: flex-start;
`;
var SectionLayout = ({ as = "section", px = [8, 8, 9], ...props }) => /* @__PURE__ */ React770.createElement(SectionLayoutBase, { as, px, ...props });
SectionLayout.ContentWrapper = ContentWrapper;

// src/components/SiteLayout.tsx
import styled14 from "@emotion/styled";

// src/styles/browser-hacks.ts
var ieOnly = (content) => `@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  ${content}
}`;

// src/components/SiteLayout.tsx
var MAIN_MIN_HEIGHT = "60vh";
var CONSTRAINED_MAX_WIDTH = "1650px";
var CONSTRAINED_SHADOW = "0 0 15px rgba(0, 0, 0, 0.1)";
var Header = styled14(Base)`
  ${COMMON}
  flex: none;
`;
var Main = styled14(Base)`
  ${COMMON}
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  min-height: ${MAIN_MIN_HEIGHT};
`;
var Footer = styled14(Base)`
  ${COMMON}
  flex: none;
`;
var SiteLayout = styled14(Base)`
  ${COMMON}
  display: flex;
  min-height: 100vh;
  height: 100%;
  flex-direction: column;
  min-width: ${CONTENT_MIN_WIDTH};
  margin: ${(props) => props.variant === "constrained" ? "0 auto" : null};
  max-width: ${(props) => props.variant === "constrained" ? CONSTRAINED_MAX_WIDTH : null};
  box-shadow: ${(props) => props.variant === "constrained" ? CONSTRAINED_SHADOW : null};

  ${ieOnly(`
    height: 100vh;
  `)}
`;
SiteLayout.defaultProps = {
  variant: "default"
};
Header.defaultProps = {
  as: "header"
};
Main.defaultProps = {
  as: "main"
};
Footer.defaultProps = {
  as: "footer"
};
SiteLayout.Header = Header;
SiteLayout.Main = Main;
SiteLayout.Footer = Footer;

// src/components/TakeoverHeader.tsx
import React772 from "react";
import styled16 from "@emotion/styled";

// src/components/CloseButton.tsx
import React771 from "react";
import styled15 from "@emotion/styled";
import VisuallyHidden2 from "@reach/visually-hidden";
var Container = styled15(Box)`
  position: absolute;
  right: ${get("space.6")};
  top: ${get("space.6")};
  height: ${get("space.8")};
  width: ${get("space.8")};
`;
var IconContainer = styled15.div`
  height: ${get("space.8")};
  width: ${get("space.8")};
`;
var BaseCloseButton = styled15.button`
  appearance: none !important;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;

  &:hover {
    background-color: transparent;
  }
`;
var CloseButton = ({ closeHandler, ...props }) => {
  return /* @__PURE__ */ React771.createElement(Container, { ...props }, /* @__PURE__ */ React771.createElement(BaseCloseButton, { onClick: closeHandler }, /* @__PURE__ */ React771.createElement(VisuallyHidden2, null, "Close"), /* @__PURE__ */ React771.createElement(IconContainer, { "aria-hidden": "true" }, /* @__PURE__ */ React771.createElement(FeatureX24, { title: "close", color: "bmtGrey90" }))));
};

// src/components/TakeoverHeader.tsx
var Title2 = styled16.div`
  font-size: ${get("fontSizes.0")};
  line-height: ${get("lineHeights.0")};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${get("colors.bmtGrey50")};
`;
var TakeoverHeader = ({ title, logo, closeHandler }) => {
  const { theme: theme2 } = useTheme();
  const HEIGHT = theme2.space[11];
  return /* @__PURE__ */ React772.createElement(Flex, { height: HEIGHT, minHeight: HEIGHT, position: "relative", alignItems: "center" }, /* @__PURE__ */ React772.createElement(Flex, { alignItems: "center" }, logo), /* @__PURE__ */ React772.createElement(Box, { ml: [3, 6], pl: [3, 6], pr: "8", borderLeft: "1px solid", borderColor: "bmtGrey20", overflow: "hidden" }, /* @__PURE__ */ React772.createElement(Title2, null, title)), closeHandler && /* @__PURE__ */ React772.createElement(CloseButton, { closeHandler, zIndex: 201 }));
};

// src/components/CenteredWorkflowLayout.tsx
var LayoutContext = createContext2({ centered: false });
var VARIANTS = {
  "four-column": { width: [1, 1, 1, 8 / 12] },
  "five-column": { width: [1, 1, 1, 9 / 12] },
  "six-column": { width: [1, 1, 1, 10 / 12] }
};
var StickyHeader = styled17(SiteLayout.Header)`
  position: sticky;
  top: 0;
  z-index: ${get("zIndexes.overlay")};
  ${({ disableBorder, theme: theme2 }) => disableBorder ? null : `border-bottom: solid 1px ${get("colors.bmtGrey20")({ theme: theme2 })}`};
`;
var CenteredWorkflowLayout = ({
  children,
  logo = /* @__PURE__ */ React773.createElement(BettermentLogo, null),
  title = "",
  progressPercent,
  handleBackButton,
  closeHandler,
  variant = "four-column",
  centered = false,
  heading,
  headingIcon = void 0
}) => {
  const [content, header, footer] = getSlots(["content", "header", "footer"], children, "content");
  const hasHeadingWithIcon = heading && headingIcon;
  const hasHeadingWithoutIcon = heading && !headingIcon;
  const { theme: theme2 } = useTheme();
  const layoutContextValue = useMemo(() => ({ centered }), [centered]);
  return /* @__PURE__ */ React773.createElement(SiteLayout, null, /* @__PURE__ */ React773.createElement(StickyHeader, { disableBorder: !!progressPercent }, /* @__PURE__ */ React773.createElement(SectionLayout, { py: "0", bg: "bmtWhite" }, /* @__PURE__ */ React773.createElement(SectionLayout.ContentWrapper, null, header || /* @__PURE__ */ React773.createElement(React773.Fragment, null, /* @__PURE__ */ React773.createElement(TakeoverHeader, { title, logo, closeHandler }), progressPercent !== void 0 && /* @__PURE__ */ React773.createElement(ProgressBar, { percent: progressPercent, rounded: false, indicatorColor: "bmtGrey60" }))))), /* @__PURE__ */ React773.createElement(SiteLayout.Main, null, /* @__PURE__ */ React773.createElement(Flex.Item, { bg: "bmtWhite", flex: 1 }, /* @__PURE__ */ React773.createElement(SectionLayout, { bg: "bmtWhite", py: "9" }, /* @__PURE__ */ React773.createElement(SectionLayout.ContentWrapper, null, /* @__PURE__ */ React773.createElement(ContentLayoutC, { mx: CONTENT_GRID_CONTAINER_MX, display: ["block", "block", "flex"], mb: [8, 8, 9] }, /* @__PURE__ */ React773.createElement(
    ContentLayoutC.Slot1,
    {
      display: ["block", "block", "flex"],
      px: [0, theme2.space[8]],
      mb: 0,
      width: [1, 1, 8 / 12],
      ml: [0, 0, `${1 / 12 * 100}%`],
      order: 2
    },
    /* @__PURE__ */ React773.createElement(LayoutContext.Provider, { value: layoutContextValue }, /* @__PURE__ */ React773.createElement(Box, { ...VARIANTS[variant], mx: "auto" }, hasHeadingWithIcon && /* @__PURE__ */ React773.createElement(React773.Fragment, null, /* @__PURE__ */ React773.createElement(Box, { mb: "8" }, headingIcon), /* @__PURE__ */ React773.createElement(Heading, { variant: "primary", textAlign: centered ? "center" : "left" }, heading)), hasHeadingWithoutIcon && /* @__PURE__ */ React773.createElement(Heading, { variant: "primary", textAlign: centered ? "center" : "left" }, heading), content))
  ), /* @__PURE__ */ React773.createElement(
    ContentLayoutC.Slot2,
    {
      px: [0, theme2.space[8]],
      mb: [8, 8, 0],
      width: [0, 0, 1 / 12],
      display: ["none", "none", "block"],
      order: 1
    },
    handleBackButton && /* @__PURE__ */ React773.createElement(BackLink, { onClick: handleBackButton })
  )))))), footer && /* @__PURE__ */ React773.createElement(SiteLayout.Footer, { bg: "bmtWhite", "data-testid": "CenteredWorkflowLayout-footer" }, /* @__PURE__ */ React773.createElement(SectionLayout, { py: "9" }, /* @__PURE__ */ React773.createElement(SectionLayout.ContentWrapper, null, footer))));
};
CenteredWorkflowLayout.Slot = Slot;
var ActionContainer = styled17(Flex)`
  & button {
    margin-right: ${get("space.6")};
    min-width: 150px;

    @media screen and (max-width: ${get("breakpoints.0")}) {
      margin-bottom: ${get("space.6")};
      margin-right: 0;
    }
  }
`;
var Actions = ({ children, ...spaceProps }) => {
  const { centered } = useContext2(LayoutContext);
  return /* @__PURE__ */ React773.createElement(
    ActionContainer,
    {
      mt: "9",
      flexDirection: ["column", "row"],
      justifyContent: centered ? "center" : "flex-start",
      ...spaceProps
    },
    children
  );
};
CenteredWorkflowLayout.Actions = Actions;

// src/components/CheckboxInput.tsx
import React774 from "react";
import styled18 from "@emotion/styled";
import { useField } from "formik";
var CheckboxItem = styled18(Text)`
  font-weight: 400;
  margin-left: ${get("space.8")};
`;
var checkboxCheck = () => `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><title>ui--check</title><polygon fill='%23ffffff' points='13.627 1.6 5.461 9.683 2.355 6.519 0 8.817 5.482 14.41 16 4.009' /></svg>")`;
var borderColor2 = ({ theme: theme2 }) => {
  if (theme2) {
    return theme2.colors.bmtGrey60;
  }
  return void 0;
};
var CheckboxInputBase = styled18(Base)`
  height: ${get("space.6")};
  width: ${get("space.6")};
  position: absolute;
  opacity: 1;
  margin-top: 1px;
  appearance: none;
  border: 1px solid ${borderColor2};
  border-radius: 0.5rem;
  background-color: ${get("colors.bmtWhite")};
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;

  &:after {
    color: ${get("colors.bmtWhite")};
    border-radius: 1rem;
    content: ${checkboxCheck};
    display: block;
    width: 1rem;
  }

  &:checked {
    border-color: ${get("colors.bmtBlue")};
    background: ${get("colors.bmtBlue")};

    &:after {
      opacity: 1;
    }
  }

  &:disabled {
    border-color: ${get("colors.bmtGrey10")};
    cursor: not-allowed;

    &:checked {
      background: ${borderColor2};
      border-color: ${borderColor2};
    }
  }

  &:focus {
    box-shadow: 0 0 1px 2px ${get("colors.bmtBlue")};
  }

  ${COMMON}
  ${LAYOUT}
  ${POSITION}
`;
var CheckboxInput = ({
  checked,
  className = "",
  ...rest
}) => /* @__PURE__ */ React774.createElement(
  CheckboxInputBase,
  {
    as: "input",
    "aria-checked": checked,
    checked,
    ...rest,
    role: "checkbox",
    type: "checkbox",
    className: `checkboxInputBase ${className}`
  }
);
CheckboxInput.Item = CheckboxItem;
var FormikCheckboxInput = ({ name, ...rest }) => {
  const [field] = useField({ name });
  return /* @__PURE__ */ React774.createElement(
    CheckboxInput,
    {
      ...field,
      ...rest,
      checked: Array.isArray(field.value) ? field.value.includes(rest.value) : !!field.value,
      onChange: (event) => {
        if (rest.onChange) {
          rest.onChange(event);
        }
        field.onChange(event);
      }
    }
  );
};
FormikCheckboxInput.Item = CheckboxItem;

// src/components/ContentGrid.tsx
import styled19 from "@emotion/styled";
import { display as display5 } from "styled-system";
var Item2 = styled19(Base)`
  ${LAYOUT}
  ${FLEX_ITEM}
  ${COMMON}
`;
var ContentGrid = styled19(Base)`
  ${FLEX_CONTAINER}
  ${COMMON}
  ${display5}
`;
ContentGrid.defaultProps = {
  display: "flex",
  mx: CONTENT_GRID_CONTAINER_MX
};
Item2.defaultProps = {
  px: CONTENT_GRID_ITEM_PX
};
ContentGrid.Item = Item2;

// src/components/ContentLayoutA.tsx
import styled20 from "@emotion/styled";
import { display as display6 } from "styled-system";
var Slot12 = styled20(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var Slot22 = styled20(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var Slot3 = styled20(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var ContentLayoutA = styled20(Base)`
  ${FLEX_CONTAINER}
  ${COMMON}
  ${display6}
`;
ContentLayoutA.defaultProps = {
  mx: CONTENT_GRID_CONTAINER_MX,
  display: ["block", "block", "flex"],
  mb: [8, 8, 9]
};
Slot12.defaultProps = {
  px: CONTENT_GRID_ITEM_PX,
  mb: [8, 8, 0],
  width: [1, 1, 4 / 12],
  order: 2
};
Slot22.defaultProps = {
  px: CONTENT_GRID_ITEM_PX,
  mb: 0,
  width: [1, 1, 5 / 12],
  ml: [0, 0, `${1 / 12 * 100}%`],
  order: 3
};
Slot3.defaultProps = {
  px: CONTENT_GRID_ITEM_PX,
  mb: [8, 8, 0],
  width: [0, 0, 1 / 12],
  order: 1,
  display: ["none", "none", "block"]
};
ContentLayoutA.Slot1 = Slot12;
ContentLayoutA.Slot2 = Slot22;
ContentLayoutA.Slot3 = Slot3;

// src/components/ContentLayoutB.tsx
import styled21 from "@emotion/styled";
import { display as display7 } from "styled-system";
var Slot13 = styled21(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var ContentLayoutB = styled21(Base)`
  ${FLEX_CONTAINER}
  ${COMMON}
  ${display7}
`;
ContentLayoutB.defaultProps = {
  mx: CONTENT_GRID_CONTAINER_MX,
  display: ["block", "block", "flex"],
  mb: [8, 8, 9]
};
Slot13.defaultProps = {
  px: CONTENT_GRID_ITEM_PX,
  width: [1, 1, 5 / 12],
  ml: [0, 0, `${1 / 2 * 100}%`]
};
ContentLayoutB.Slot1 = Slot13;

// src/components/ContentLayoutE.tsx
import styled22 from "@emotion/styled";
import { display as display8 } from "styled-system";
var Slot14 = styled22(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var Slot23 = styled22(Base)`
  ${FLEX_ITEM}
  ${COMMON}
  ${LAYOUT}
`;
var ContentLayoutE = styled22(Base)`
  ${FLEX_CONTAINER}
  ${COMMON}
  ${display8}
`;
ContentLayoutE.defaultProps = {
  mx: CONTENT_GRID_CONTAINER_MX,
  display: ["block", "block", "flex"],
  mb: [8, 8, 9]
};
Slot14.defaultProps = {
  px: CONTENT_GRID_ITEM_PX,
  mb: [8, 8, 0],
  width: [1, 1, 4 / 12, 3 / 12],
  order: 1
};
Slot23.defaultProps = {
  px: CONTENT_GRID_ITEM_PX,
  mb: 0,
  width: [1, 1, 8 / 12, 9 / 12],
  order: 2
};
ContentLayoutE.Slot1 = Slot14;
ContentLayoutE.Slot2 = Slot23;

// src/components/DateInput.tsx
import React777 from "react";
import { useField as useField3 } from "formik";
import { createAutoCorrectedDatePipe as _createAutoCorrectedDatePipe } from "text-mask-addons";

// src/components/TextInput.tsx
import React775, { forwardRef as forwardRef5 } from "react";
import styled23 from "@emotion/styled";
import { useField as useField2 } from "formik";
var SIZE_STYLES2 = {
  small: {
    fontSize: 1,
    py: 1,
    px: 3
  }
};
var StyledTextInput = styled23(ReffableBase)`
  ${TYPOGRAPHY}
  ${COMMON}
  ${LAYOUT}
  ${BORDER}
  border: 1px solid ${(props) => props.invalid ? get("colors.bmtOrange90")(props) : get("colors.bmtGrey30")(props)};
  background-color: ${(props) => props.disabled ? get("colors.bmtGrey10")(props) : get("colors.bmtWhite")(props)};
  color: ${(props) => props.disabled ? get("colors.bmtGrey40")(props) : get("colors.bmtGrey60")(props)};
  display: block;
  width: 100%;
  max-width: ${(props) => props.fullWidth ? "100%" : INPUT_MAX_WIDTH};

  &:active,
  &:focus {
    border: 2px solid
      ${(props) => props.invalid ? get("colors.bmtOrange90")(props) : get("colors.bmtBlue")(props)};
  }
`;
StyledTextInput.defaultProps = {
  as: "input",
  fontSize: 2,
  fontWeight: 400,
  lineHeight: 2,
  borderRadius: 0,
  py: 4,
  px: 6
};
var FormikTextInput = ({
  name,
  validate,
  type,
  size: size2,
  ...rest
}) => {
  const [field, { error }] = useField2({ name, validate, type });
  const sizeVariant = size2 && SIZE_STYLES2[size2];
  return /* @__PURE__ */ React775.createElement(StyledTextInput, { ...field, type, invalid: !!error, ...rest, ...sizeVariant });
};
var TextInput = forwardRef5(({ size: size2, ...rest }, ref) => {
  return /* @__PURE__ */ React775.createElement(StyledTextInput, { ...rest, ...size2 && SIZE_STYLES2[size2], ref });
});

// src/components/TextMask/index.tsx
import React776 from "react";
import { createTextMaskInputElement } from "text-mask-core";

// src/components/TextMask/utilities.ts
function isNil(value) {
  return typeof value === "undefined" || value === null;
}

// src/components/TextMask/index.tsx
import { conformToMask } from "text-mask-core";
var MaskedInput = class extends React776.PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "inputElement", null);
    __publicField(this, "textMaskInputElement", {
      update() {
      }
    });
    this.setRef = this.setRef.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  setRef(inputElement) {
    this.inputElement = inputElement;
  }
  initTextMask() {
    const {
      props,
      props: { value }
    } = this;
    this.textMaskInputElement = createTextMaskInputElement({
      inputElement: this.inputElement,
      ...props
    });
    this.textMaskInputElement.update(value);
  }
  componentDidMount() {
    this.initTextMask();
  }
  componentDidUpdate(prevProps) {
    const { value, pipe, mask, guide, placeholderChar, showMask } = this.props;
    const settings = { guide, placeholderChar, showMask };
    const isPipeChanged = typeof pipe === "function" && typeof prevProps.pipe === "function" ? pipe.toString() !== prevProps.pipe.toString() : isNil(pipe) && !isNil(prevProps.pipe) || !isNil(pipe) && isNil(prevProps.pipe);
    const isMaskChanged = mask.toString() !== prevProps.mask.toString();
    const isSettingChanged = Object.keys(settings).some((prop) => settings[prop] !== prevProps[prop]) || isMaskChanged || isPipeChanged;
    const isValueChanged = value !== this.inputElement?.value;
    if (isValueChanged || isSettingChanged) {
      this.initTextMask();
    }
  }
  render() {
    const { render, value, ...props } = this.props;
    delete props.guide;
    delete props.pipe;
    delete props.placeholderChar;
    delete props.keepCharPositions;
    delete props.onBlur;
    delete props.onChange;
    delete props.showMask;
    return render(this.setRef, {
      onBlur: this.onBlur,
      onChange: this.onChange,
      defaultValue: value?.toString(),
      ...props
    });
  }
  onChange(event) {
    this.textMaskInputElement.update();
    const { onChange } = this.props;
    if (typeof onChange === "function") {
      onChange(event);
    }
  }
  onBlur(event) {
    const { onBlur } = this.props;
    if (typeof onBlur === "function") {
      onBlur(event);
    }
  }
};
__publicField(MaskedInput, "defaultProps", {
  render: (ref, { mask: _omitMask, ...props }) => /* @__PURE__ */ React776.createElement("input", { ref, ...props })
});

// src/components/DateInput.tsx
var createAutoCorrectedDatePipe = _createAutoCorrectedDatePipe;
var formatMasks = {
  "mm/dd/yyyy": [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
  "mm/yyyy": [/\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]
};
var DateInput = ({
  onBlur,
  onChange,
  format = "mm/dd/yyyy",
  ...rest
}) => {
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(format, {
    minYear: 1900
  });
  return /* @__PURE__ */ React777.createElement(
    MaskedInput,
    {
      mask: formatMasks[format],
      placeholder: format.toUpperCase(),
      pipe: autoCorrectedDatePipe,
      keepCharPositions: true,
      onChange,
      onBlur,
      render: (ref, props) => /* @__PURE__ */ React777.createElement(TextInput, { ref, ...props, ...rest })
    }
  );
};
var FormikDateInput = ({
  name,
  validate,
  format = "mm/dd/yyyy",
  ...rest
}) => {
  const [field, { error }] = useField3({ name, validate });
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(format, {
    minYear: 1900
  });
  return /* @__PURE__ */ React777.createElement(
    MaskedInput,
    {
      ...field,
      mask: formatMasks[format],
      placeholder: format.toUpperCase(),
      pipe: autoCorrectedDatePipe,
      keepCharPositions: true,
      render: (ref, props) => /* @__PURE__ */ React777.createElement(TextInput, { ref, ...props, invalid: !!error, ...rest })
    }
  );
};

// src/components/Dropdown.tsx
import React778, { forwardRef as forwardRef6 } from "react";
import styled25 from "@emotion/styled";
import { useSelect } from "downshift";
import { useField as useField4 } from "formik";

// src/components/Label.tsx
import styled24 from "@emotion/styled";
var Label = styled24(Base)`
  ${TYPOGRAPHY}
  ${COMMON}
  ${LAYOUT}
`;
Label.defaultProps = {
  as: "label",
  display: "block",
  color: "bmtGrey90",
  fontSize: 2,
  fontWeight: 500,
  lineHeight: 2,
  mb: 3
};

// src/components/Dropdown.tsx
var mapValueToItem = (items) => {
  const values = items.map((item) => ({
    value: item
  }));
  return values;
};
var getDisplayValue = (item) => item.text || item.value.toString();
var itemToString = (item) => item ? getDisplayValue(item) : "";
var getTextColor = (selectedItem, disabled) => {
  if (selectedItem) {
    if (disabled) {
      return "bmtGrey40";
    }
    return "bmtGrey60";
  }
  return "bmtGrey50";
};
var StyledDropdownButton = styled25(ReffableFlex)`
  appearance: none !important;

  &:hover {
    background-color: ${get("colors.bmtWhite")};

    &:disabled {
      background-color: ${get("colors.bmtGrey10")};
    }
  }

  &:active,
  &:focus {
    outline: 2px solid ${get("colors.bmtBlue")};

    svg {
      color: ${get("colors.bmtBlue")};
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 1 !important;
  }
`;
var DropdownButton = forwardRef6(({ children, ...rest }, ref) => /* @__PURE__ */ React778.createElement(StyledDropdownButton, { ...rest, ref }, children));
var List = styled25(ReffableBox)`
  list-style: none;
  overflow: scroll;
  max-height: ${(props) => props.visibleItems * 50 + 25}px;
`;
var ListItem = styled25.li`
  ${COMMON}
  cursor: pointer;

  &[disabled] {
    background-color: ${get("colors.bmtGrey10")};
    color: ${get("colors.bmtGrey40")};
    cursor: not-allowed;
  }
`;
var CaretIcon = ({ className }) => /* @__PURE__ */ React778.createElement("svg", { width: "16", height: "16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className }, /* @__PURE__ */ React778.createElement("title", null, "Open"), /* @__PURE__ */ React778.createElement("polygon", { fill: "currentColor", points: "14.586 3.801 8.003 10.384 1.413 3.807 0 5.224 8.003 13.211 16 5.215" }));
var DropdownCaret = styled25(CaretIcon)`
  color: ${({ disabled, invalid }) => disabled && get("colors.bmtGrey30") || invalid && get("colors.bmtOrange90") || get("colors.bmtGrey90")};
`;
var DropdownBase = ({
  disabled,
  labelText,
  invalid,
  fullWidth,
  visibleItems = 3,
  items,
  value,
  onChange,
  placeholder,
  ...rest
}) => {
  const initialSelectedItem = items.find((item) => item.value === value);
  const controlledSelectedItem = value && initialSelectedItem ? initialSelectedItem : "";
  const { getLabelProps, getToggleButtonProps, getItemProps, getMenuProps, isOpen, highlightedIndex, selectedItem } = useSelect({
    initialSelectedItem,
    items,
    itemToString,
    selectedItem: controlledSelectedItem,
    onSelectedItemChange: ({ selectedItem: newSelectedItem }) => {
      if (onChange) onChange(newSelectedItem || null);
    }
  });
  const labelProps = getLabelProps();
  const buttonLabelledBy = labelText ? labelProps.id : void 0;
  const menuLabelledBy = isOpen ? labelProps.id : void 0;
  const { theme: theme2 } = useTheme();
  const invalidBorder = "bmtOrange90";
  const standardBorder = "bmtGrey60";
  return /* @__PURE__ */ React778.createElement(Box, { position: isOpen ? "relative" : "static", zIndex: isOpen ? theme2.zIndexes.overlay : theme2.zIndexes.default }, labelText && /* @__PURE__ */ React778.createElement(Label, { ...labelProps }, labelText), /* @__PURE__ */ React778.createElement(
    DropdownButton,
    {
      as: "button",
      type: "button",
      alignItems: "center",
      bg: disabled ? "bmtGrey10" : "bmtWhite",
      border: "1px solid",
      borderColor: invalid ? invalidBorder : standardBorder,
      px: "6",
      py: "4",
      m: "0",
      maxWidth: fullWidth ? "100%" : INPUT_MAX_WIDTH,
      width: "100%",
      justifyContent: "space-between",
      ...rest,
      ...getToggleButtonProps({
        disabled,
        "aria-labelledby": buttonLabelledBy
      })
    },
    /* @__PURE__ */ React778.createElement(Flex.Item, { textAlign: "left" }, /* @__PURE__ */ React778.createElement(Text, { fontSize: "2", lineHeight: "2", fontWeight: "normal", color: getTextColor(selectedItem, disabled) }, selectedItem ? getDisplayValue(selectedItem) : placeholder)),
    /* @__PURE__ */ React778.createElement(DropdownCaret, { invalid, disabled })
  ), /* @__PURE__ */ React778.createElement(Box, { position: "relative" }, /* @__PURE__ */ React778.createElement(
    List,
    {
      as: "ul",
      m: "0",
      p: "0",
      width: "100%",
      border: isOpen ? "1px solid" : "none",
      borderColor: "bmtGrey60",
      position: "absolute",
      maxWidth: fullWidth ? "100%" : INPUT_MAX_WIDTH,
      visibleItems,
      hidden: !isOpen,
      ...getMenuProps({
        "aria-labelledby": menuLabelledBy
      })
    },
    isOpen && items.map((item, index) => /* @__PURE__ */ React778.createElement(
      ListItem,
      {
        px: "6",
        py: "4",
        bg: highlightedIndex === index ? "bmtGrey20" : "bmtWhite",
        color: highlightedIndex === index ? "bmtBlue" : "bmtGrey60",
        key: item.value,
        ...getItemProps({
          index,
          item,
          disabled: item.disabled
        })
      },
      getDisplayValue(item)
    ))
  )));
};
var Dropdown = styled25(DropdownBase)`
  ${COMMON}
`;
Dropdown.defaultProps = {
  placeholder: ""
};
var FormikDropdown = ({
  name,
  validate,
  ...rest
}) => {
  const [field, { error }] = useField4({ name, validate });
  return /* @__PURE__ */ React778.createElement(
    Dropdown,
    {
      ...field,
      ...rest,
      invalid: !!error,
      onChange: (item) => {
        if (rest.onChange) {
          rest.onChange(item);
        }
        field.onChange({ currentTarget: { ...item, name } });
      }
    }
  );
};

// src/components/DropdownMenu.tsx
import React779 from "react";
import styled26 from "@emotion/styled";
import {
  Menu as _Menu,
  MenuButton as _MenuButton,
  MenuItem as _MenuItem,
  MenuList as _MenuList
} from "@reach/menu-button";
import "@reach/menu-button/styles.css";
var Menu = styled26(_Menu)`
  ${COMMON}
  ${BORDER}
  ${LAYOUT}
`;
var MenuListBase = styled26(_MenuList)`
  z-index: ${get("zIndexes.below")};
  background: ${get("colors.bmtWhite")};
  overflow-y: auto;
  max-height: 24rem;
  border: 1px solid ${get("colors.bmtGrey30")};
  padding: 1.6rem;
  padding-bottom: 0.8rem;
  margin: 0;

  ${COMMON}
  ${BORDER}
  ${LAYOUT}
`;
var MenuList = (props) => /* @__PURE__ */ React779.createElement(MenuListBase, { ...props });
var MenuItemBase = styled26(_MenuItem)`
  margin-bottom: 0.8rem;
  padding: 0;

  &[data-selected] {
    color: ${(props) => props.disabled ? get("colors.bmtGrey30")(props) : get("colors.bmtBlue")(props)} !important;
    background: ${get("colors.bmtWhite")};
  }

  ${(props) => {
  return props.disabled ? `
      color: ${get("colors.bmtGrey30")};
      cursor: not-allowed;
    ` : "";
}}

  ${COMMON}
  ${BORDER}
  ${LAYOUT}
`;
var MenuItem = ({
  disabled = false,
  onSelect: onSelectBase,
  ...rest
}) => {
  const onSelect = (event) => {
    if (disabled && event) {
      event.preventDefault();
    } else if (onSelectBase) {
      onSelectBase();
    }
  };
  return /* @__PURE__ */ React779.createElement(MenuItemBase, { disabled, tabIndex: disabled ? -1 : 0, onSelect, ...rest });
};
var MenuButtonBase = styled26(_MenuButton)`
  cursor: pointer;
  display: inline-block;
  text-align: center;

  ${TYPOGRAPHY}
  ${COMMON}
  ${LAYOUT}
  ${BORDER}
`;
var MenuButton = (props) => /* @__PURE__ */ React779.createElement(Button, { ...props, as: MenuButtonBase });
MenuButton.defaultProps = {
  type: "button",
  variant: "primary",
  size: "default"
};

// src/components/ErrorFallback.tsx
import React780 from "react";
var reload = () => window.location.reload();
var ErrorFallback = ({ message, handleReload = reload }) => /* @__PURE__ */ React780.createElement(Flex, { height: "100%", bg: "bmtWhite", alignItems: "center", justifyContent: "center", flexDirection: "row" }, /* @__PURE__ */ React780.createElement(Flex.Item, { mr: "3", pt: "8" }, /* @__PURE__ */ React780.createElement(Text, { textAlign: "center", as: "p" }, /* @__PURE__ */ React780.createElement(FeatureExclamationInCircle48, { color: "bmtGrey90" })), /* @__PURE__ */ React780.createElement(Text, { lineHeight: "2", textAlign: "center", as: "p", mb: "3" }, message), /* @__PURE__ */ React780.createElement(Text, { lineHeight: "2", textAlign: "center", as: "p" }, /* @__PURE__ */ React780.createElement(Button, { variant: "tertiary", fontWeight: "normal", m: "0", pt: "0", onClick: handleReload }, "Reload"))));

// src/components/ErrorText.tsx
import styled27 from "@emotion/styled";
var ErrorText = styled27(Text)`
  color: ${get("colors.bmtOrange90")};
  font-size: ${get("fontSizes.1")};
`;

// src/components/Faq.tsx
import React781 from "react";
import styled28 from "@emotion/styled";
var CaretBase = ({ className }) => /* @__PURE__ */ React781.createElement("svg", { className, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-hidden": true, role: "img" }, /* @__PURE__ */ React781.createElement("path", { d: "M14.3 12l-6.2 6.2 1 1 7.3-7.2-7.2-7.3-1.1 1 6.2 6.3z", clipRule: "evenodd", stroke: "currentColor" }));
var Caret = styled28(CaretBase)`
  color: ${get("colors.bmtGrey60")};
  height: 16px;
  position: absolute;
  top: 10px;
  width: 16px;
`;
var Details = styled28.details`
  &[open] + svg {
    transform: rotate(90deg);
  }
`;
var Question = styled28(Text)`
  cursor: pointer;
  list-style: none;
  margin-left: ${get("space.8")};
  padding: ${get("space.3")} 0;

  &::-webkit-details-marker {
    display: none;
  }
`;
Question.defaultProps = {
  as: "summary",
  color: "bmtGrey60"
};
var Answer = styled28(Box)`
  margin-left: ${get("space.8")};
  padding-bottom: ${get("space.3")};
`;
Answer.defaultProps = {
  color: "bmtGrey50"
};
var Faq = ({ children, ...props }) => /* @__PURE__ */ React781.createElement(Box, { ...props, position: "relative" }, /* @__PURE__ */ React781.createElement(Details, null, children), /* @__PURE__ */ React781.createElement(Caret, null));
Faq.Question = Question;
Faq.Answer = Answer;

// src/components/Field.tsx
import React783 from "react";
import { useField as useField5 } from "formik";

// src/components/InputGroup.tsx
import styled29 from "@emotion/styled";
var InputGroup = styled29(Box)`
  max-width: ${(props) => props.fullWidth ? "100%" : INPUT_MAX_WIDTH};
`;
InputGroup.defaultProps = {
  mb: VERTICAL_RHYTHM
};

// src/components/MaskedInput.tsx
import React782 from "react";
import { pick } from "lodash";
import { createNumberMask as _createNumberMask } from "text-mask-addons";
var createNumberMask = _createNumberMask;
var createNotatedNumberMask = _createNumberMask;
var constructPropsForVariant = (variant) => {
  switch (variant) {
    case "taxId":
      return [
        {
          placeholderChar: "x",
          mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
        },
        {
          placeholder: "xxx-xx-xxxx"
        }
      ];
    case "phone":
      return [
        {
          mask: ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
        },
        {
          placeholder: "(123)-456-7890"
        }
      ];
    case "money":
      return [
        {
          mask: createNumberMask({
            allowDecimal: true
          })
        },
        {
          placeholder: "$10"
        }
      ];
    case "percent":
      return [
        {
          mask: createNotatedNumberMask({
            prefix: "",
            suffix: "%",
            allowDecimal: true
          })
        },
        {
          placeholder: "0%"
        }
      ];
    default:
      throw new TypeError("invalid template provided");
  }
};
var defaultMaskedInputProps = (props) => pick(props, ["mask", "guide", "placeholderChar", "keepCharPositions", "pipe", "showMask"]);
var MaskedInput2 = ({
  onBlur,
  onChange,
  variant,
  ...rest
}) => {
  const [{ mask, ...maskedInputProps }, textInputProps] = variant ? constructPropsForVariant(variant) : [defaultMaskedInputProps(rest)];
  return /* @__PURE__ */ React782.createElement(
    MaskedInput,
    {
      ...maskedInputProps,
      mask,
      onChange,
      onBlur,
      render: (ref, props) => /* @__PURE__ */ React782.createElement(TextInput, { ref, ...props, ...textInputProps, ...rest })
    }
  );
};

// src/components/Field.tsx
var getInput = (type) => {
  switch (type) {
    case "string":
      return TextInput;
    case "date":
      return DateInput;
    case "taxId":
      return MaskedInput2;
    case "phone":
      return MaskedInput2;
    case "money":
      return MaskedInput2;
    case "percent":
      return MaskedInput2;
  }
};
function inputPropsForType(type, baseProps) {
  switch (type) {
    case "taxId":
    case "phone":
    case "money":
    case "percent":
      return {
        ...baseProps,
        variant: type
      };
    default:
      return baseProps;
  }
}
var Field = ({
  errorMessage,
  fullWidth,
  name,
  label,
  variant = "withLabel",
  as,
  ...rest
}) => {
  const InputComponent = getInput(as || "string");
  const baseProps = {
    name,
    id: name,
    "aria-describedby": `error-${name}`,
    invalid: !!errorMessage,
    ...variant === "withLabel" && { "aria-labelledby": `label-${name}` },
    ...variant === "withoutLabel" && { "aria-label": label }
  };
  const inputProps = inputPropsForType(as, baseProps);
  return /* @__PURE__ */ React783.createElement(InputGroup, { fullWidth }, variant === "withLabel" && /* @__PURE__ */ React783.createElement(Label, { htmlFor: name, id: inputProps["aria-labelledby"] }, label), /* @__PURE__ */ React783.createElement(InputComponent, { fullWidth, ...rest, ...inputProps }), /* @__PURE__ */ React783.createElement(ErrorText, { id: inputProps["aria-describedby"] }, errorMessage));
};
var FormikField = ({
  name,
  validate,
  label,
  as,
  ...rest
}) => {
  const [field, { error }] = useField5({ name, validate });
  return /* @__PURE__ */ React783.createElement(
    Field,
    {
      ...field,
      ...rest,
      as,
      label,
      errorMessage: error,
      onChange: (event) => {
        if (rest.onChange) {
          rest.onChange(event);
        }
        field.onChange(event);
      }
    }
  );
};

// src/components/Flash.tsx
import React784 from "react";
import styled30 from "@emotion/styled";
var Message = styled30(Flex.Item)`
  line-height: 2.4rem;
`;
var FLASH_ICON_VARIANT = {
  success: {
    component: FeatureCheckmarkInCircle24,
    color: "bmtTeal90"
  },
  warning: {
    component: FeatureExclamationInCircle24,
    color: "bmtGrey90"
  },
  error: {
    component: FeatureExclamationInCircle24,
    color: "bmtOrange90"
  },
  info: {
    component: FeatureInfoInCircle24,
    color: "bmtGrey90"
  }
};
var FLASH_COLOR_VARIANT = {
  success: (theme2) => ({
    bg: "bmtTeal10",
    borderColor: `${theme2.secondaryColors.green30}26`
  }),
  warning: (theme2) => ({
    bg: "bmtGold10",
    borderColor: `${theme2.secondaryColors.gold30}33`
  }),
  error: (theme2) => ({
    bg: "bmtOrange10",
    borderColor: `${theme2.colors.bmtOrange90}14`
  }),
  info: (theme2) => ({
    bg: "bmtBlue10",
    borderColor: `${theme2.secondaryColors.blue30}26`
  })
};
var Flash = ({
  children,
  variant,
  icon = true,
  border = true,
  onDismiss,
  ...spacingProps
}) => {
  if (!variant) throw new Error("Variant must be provided");
  const { theme: theme2 } = useTheme();
  let IconComponent = FLASH_ICON_VARIANT[variant].component;
  if (typeof icon === "function") {
    IconComponent = icon;
  } else if (typeof icon === "string") {
    IconComponent = UiCheckmarkV2;
  }
  return /* @__PURE__ */ React784.createElement(
    Flex,
    {
      border: border ? "1px solid" : "none",
      ...FLASH_COLOR_VARIANT[variant](theme2),
      alignItems: "flex-start",
      p: "6",
      mt: "5",
      ...spacingProps
    },
    icon && /* @__PURE__ */ React784.createElement(Flex, { mr: "3" }, IconComponent === UiCheckmarkV2 ? /* @__PURE__ */ React784.createElement(IconComponent, { size: "1.6rem", color: FLASH_ICON_VARIANT[variant].color }) : /* @__PURE__ */ React784.createElement(IconComponent, { color: FLASH_ICON_VARIANT[variant].color })),
    /* @__PURE__ */ React784.createElement(Message, { mr: onDismiss ? 4 : 0, flex: "1 1 auto", minHeight: icon ? "2.0rem" : void 0 }, children),
    onDismiss && /* @__PURE__ */ React784.createElement(Flex.Item, { flex: "0 0 auto" }, /* @__PURE__ */ React784.createElement(Button, { display: "flex", variant: "tertiary", onClick: onDismiss, p: "0", m: "0" }, /* @__PURE__ */ React784.createElement(FeatureX24, { title: "close", color: "bmtGrey90" })))
  );
};

// src/components/GoalIcon.tsx
import React785 from "react";
var AdviceIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", ry: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3637 26.7274C12.64 26.7274 8 22.0874 8 16.3637C8 10.64 12.64 6 18.3637 6C24.0604 6 28.6835 10.5963 28.727 16.2827H28.7274C28.7274 16.2966 28.7273 16.3105 28.7273 16.3243C28.7273 16.3374 28.7273 16.3506 28.7273 16.3637C28.7273 17.1069 28.6491 17.8318 28.5004 18.5307C27.281 24.5292 21.4467 28.6753 18.3637 30L18.3637 26.7274Z",
    fill: theme2.colors.bmtVizNavy
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5828 20.7254C24.5247 19.5916 25.091 18.1347 25.091 16.5455C25.091 12.9305 22.1605 10 18.5455 10C14.9305 10 12 12.9305 12 16.5455C12 18.1347 12.5663 19.5916 13.5082 20.7254L18.5455 18.8364L23.5828 20.7254ZM18.5619 23.091H18.5291C18.5346 23.091 18.54 23.091 18.5455 23.091C18.551 23.091 18.5564 23.091 18.5619 23.091Z",
    fill: theme2.colors.bmtGold
  }
));
var AdviceIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", ry: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3637 26.7274C12.64 26.7274 8 22.0874 8 16.3637C8 10.64 12.64 6 18.3637 6C24.0604 6 28.6835 10.5963 28.727 16.2827H28.7274C28.7274 16.2966 28.7273 16.3105 28.7273 16.3243C28.7273 16.3374 28.7273 16.3506 28.7273 16.3637C28.7273 17.1069 28.6491 17.8318 28.5004 18.5307C27.281 24.5292 21.4467 28.6753 18.3637 30L18.3637 26.7274Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5828 20.7254C24.5247 19.5916 25.091 18.1347 25.091 16.5455C25.091 12.9305 22.1605 10 18.5455 10C14.9305 10 12 12.9305 12 16.5455C12 18.1347 12.5663 19.5916 13.5082 20.7254L18.5455 18.8364L23.5828 20.7254ZM18.5619 23.091H18.5291C18.5346 23.091 18.54 23.091 18.5455 23.091C18.551 23.091 18.5564 23.091 18.5619 23.091Z",
    fill: theme2.colors.bmtGold
  }
));
var AppleIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M16.7303 12.7064L17.2206 13.0129C17.6975 13.3109 18.3025 13.3109 18.7794 13.0129L19.2697 12.7064C20.9318 11.6677 23.0482 11.6988 24.6789 12.7859C26.6203 14.0802 27.4048 16.5476 26.5672 18.7254L24.2107 24.8522C23.5113 26.6707 21.6034 27.7207 19.6929 27.3386L19.5689 27.3138C18.5332 27.1066 17.4668 27.1066 16.4311 27.3138L16.3071 27.3386C14.3966 27.7207 12.4887 26.6707 11.7893 24.8522L9.43284 18.7254C8.59524 16.5476 9.37967 14.0802 11.3211 12.7859C12.9518 11.6988 15.0682 11.6677 16.7303 12.7064Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M18 14V10V8", stroke: theme2.colors.bmtTeal90, strokeWidth: "2" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7C24 9.76142 21.7614 12 19 12C19 9.23858 21.2386 7 24 7Z",
    fill: theme2.colors.bmtTeal90
  }
));
var AppleIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M16.7303 12.7064L17.2206 13.0129C17.6975 13.3109 18.3025 13.3109 18.7794 13.0129L19.2697 12.7064C20.9318 11.6677 23.0482 11.6988 24.6789 12.7859C26.6203 14.0802 27.4048 16.5476 26.5672 18.7254L24.2107 24.8522C23.5113 26.6707 21.6034 27.7207 19.6929 27.3386L19.5689 27.3138C18.5332 27.1066 17.4668 27.1066 16.4311 27.3138L16.3071 27.3386C14.3966 27.7207 12.4887 26.6707 11.7893 24.8522L9.43284 18.7254C8.59524 16.5476 9.37967 14.0802 11.3211 12.7859C12.9518 11.6988 15.0682 11.6677 16.7303 12.7064Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M18 14V10V8", stroke: theme2.colors.bmtTeal90, strokeWidth: "2" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7C24 9.76142 21.7614 12 19 12C19 9.23858 21.2386 7 24 7Z",
    fill: theme2.colors.bmtTeal90
  }
));
var BabyIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3286 25.7361C13.881 27.2454 15.7714 28 18 28C20.2286 28 22.119 27.2454 23.6714 25.7361C25.2238 24.2269 26 22.3889 26 20.2222C26 18.7963 25.7571 17.3611 25.2714 15.9167C25.1112 15.4401 24.9354 14.9781 24.744 14.5308L21.3202 17.3839L21.0001 17.6506L20.6801 17.3839L17.9999 15.1508L15.3202 17.3839L15.0001 17.6506L14.68 17.3839L11.256 14.5307C11.0647 14.978 10.8888 15.44 10.7286 15.9167C10.2429 17.3611 10 18.7963 10 20.2222C10 22.3889 10.7762 24.2269 12.3286 25.7361ZM11.6913 13.5917L15.0001 16.3489L17.6798 14.1159L17.9999 13.8492L18.3199 14.1159L21.0001 16.3489L24.3088 13.5918C24.0279 13.0313 23.7203 12.4961 23.3857 11.9861C22.6143 10.8102 21.7571 9.85185 20.8143 9.11111C19.8714 8.37037 18.9333 8 18 8C17.0857 8 16.1524 8.37037 15.2 9.11111C14.2476 9.85185 13.3857 10.8102 12.6143 11.9861C12.2798 12.496 11.9721 13.0312 11.6913 13.5917Z",
    fill: theme2.colors.bmtGold
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M24.5 14L21 17L18 14.5L15 17L11.5 14", stroke: "#071B39" }));
var BabyIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3286 25.7361C13.881 27.2454 15.7714 28 18 28C20.2286 28 22.119 27.2454 23.6714 25.7361C25.2238 24.2269 26 22.3889 26 20.2222C26 18.7963 25.7571 17.3611 25.2714 15.9167C25.1112 15.4401 24.9354 14.9781 24.744 14.5308L21.3202 17.3839L21.0001 17.6506L20.6801 17.3839L17.9999 15.1508L15.3202 17.3839L15.0001 17.6506L14.68 17.3839L11.256 14.5307C11.0647 14.978 10.8888 15.44 10.7286 15.9167C10.2429 17.3611 10 18.7963 10 20.2222C10 22.3889 10.7762 24.2269 12.3286 25.7361ZM11.6913 13.5917L15.0001 16.3489L17.6798 14.1159L17.9999 13.8492L18.3199 14.1159L21.0001 16.3489L24.3088 13.5918C24.0279 13.0313 23.7203 12.4961 23.3857 11.9861C22.6143 10.8102 21.7571 9.85185 20.8143 9.11111C19.8714 8.37037 18.9333 8 18 8C17.0857 8 16.1524 8.37037 15.2 9.11111C14.2476 9.85185 13.3857 10.8102 12.6143 11.9861C12.2798 12.496 11.9721 13.0312 11.6913 13.5917Z",
    fill: theme2.colors.bmtGold
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M24.5 14L21 17L18 14.5L15 17L11.5 14", stroke: "#071B39" }));
var BandaidIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M22 14L14 14L14 10C14 8.89543 14.8954 8 16 8L20 8C21.1046 8 22 8.89543 22 10L22 14Z",
    fill: theme2.colors.bmtTeal90
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M22 22L14 22L14 26C14 27.1046 14.8954 28 16 28L20 28C21.1046 28 22 27.1046 22 26L22 22Z",
    fill: theme2.colors.bmtTeal90
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 16C28 14.8954 27.1046 14 26 14L10 14C8.89543 14 8 14.8954 8 16L8 20C8 21.1046 8.89543 22 10 22L26 22C27.1046 22 28 21.1046 28 20L28 16ZM19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20ZM20 17C19.4477 17 19 16.5523 19 16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17ZM16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17ZM16 21C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "16", cy: "16", r: "1", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React785.createElement("circle", { cx: "16", cy: "20", r: "1", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React785.createElement("circle", { cx: "20", cy: "16", r: "1", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React785.createElement("circle", { cx: "20", cy: "20", r: "1", fill: theme2.colors.bmtNavy }));
var BandaidIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M22 14L14 14L14 10C14 8.89543 14.8954 8 16 8L20 8C21.1046 8 22 8.89543 22 10L22 14Z",
    fill: theme2.colors.bmtTeal90
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M22 22L14 22L14 26C14 27.1046 14.8954 28 16 28L20 28C21.1046 28 22 27.1046 22 26L22 22Z",
    fill: theme2.colors.bmtTeal90
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 16C28 14.8954 27.1046 14 26 14L10 14C8.89543 14 8 14.8954 8 16L8 20C8 21.1046 8.89543 22 10 22L26 22C27.1046 22 28 21.1046 28 20L28 16ZM19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20ZM20 17C19.4477 17 19 16.5523 19 16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17ZM16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17ZM16 21C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "16", cy: "16", r: "1", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React785.createElement("circle", { cx: "16", cy: "20", r: "1", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React785.createElement("circle", { cx: "20", cy: "16", r: "1", fill: theme2.colors.bmtNavy }), /* @__PURE__ */ React785.createElement("circle", { cx: "20", cy: "20", r: "1", fill: theme2.colors.bmtNavy }));
var BondIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("g", { clipPath: "url(#clip0_1214_7794)" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("g", { clipPath: "url(#clip1_1214_7794)" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("rect", { x: "7", y: "11", width: "22", height: "13", fill: theme2.colors.bmtBlue10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9H29V25H7V9ZM25 11H11C11 11 11 11 11 11C11 12.1046 10.1045 13 9 13V21C10.1045 21.0001 10.9999 21.8955 11 23H25C25 21.8954 25.8954 21 27 21C27 21 26.9999 21 27 21L27 13C27 13 27 13 27 13C25.8954 13 25 12.1046 25 11C25 11 25 11 25 11Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "14", cy: "17", r: "3", fill: theme2.colors.bmtBlue }), /* @__PURE__ */ React785.createElement("path", { d: "M25 15H19", stroke: theme2.colors.bmtBlue, strokeWidth: "2" }), /* @__PURE__ */ React785.createElement("path", { d: "M25 19H19", stroke: theme2.colors.bmtBlue, strokeWidth: "2" }))), /* @__PURE__ */ React785.createElement("defs", null, /* @__PURE__ */ React785.createElement("clipPath", { id: "clip0_1214_7794" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: "white" })), /* @__PURE__ */ React785.createElement("clipPath", { id: "clip1_1214_7794" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: "white" }))));
var BondIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("g", { clipPath: "url(#clip0_1214_7805)" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("g", { clipPath: "url(#clip0_1214_7805)" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("rect", { x: "7", y: "11", width: "22", height: "13", fill: theme2.colors.bmtBlue10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9H29V25H7V9ZM25 11H11C11 11 11 11 11 11C11 12.1046 10.1045 13 9 13V21C10.1045 21.0001 10.9999 21.8955 11 23H25C25 21.8954 25.8954 21 27 21C27 21 26.9999 21 27 21L27 13C27 13 27 13 27 13C25.8954 13 25 12.1046 25 11C25 11 25 11 25 11Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "14", cy: "17", r: "3", fill: theme2.colors.bmtBlue }), /* @__PURE__ */ React785.createElement("path", { d: "M25 15H19", stroke: theme2.colors.bmtBlue, strokeWidth: "2" }), /* @__PURE__ */ React785.createElement("path", { d: "M25 19H19", stroke: theme2.colors.bmtBlue, strokeWidth: "2" }))), /* @__PURE__ */ React785.createElement("defs", null, /* @__PURE__ */ React785.createElement("clipPath", { id: "clip0_1214_7805" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: "white" })), /* @__PURE__ */ React785.createElement("clipPath", { id: "clip1_1214_7805" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: "white" }))));
var BusinessIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 27V9H26V27H24V19H20V27H10ZM12 19H18V25H12V19Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("rect", { x: "20", y: "19", width: "4", height: "8", fill: "#071B39" }), /* @__PURE__ */ React785.createElement("rect", { x: "12", y: "19", width: "6", height: "6", fill: "#071B39" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M26 11H10L8.21115 14.5777C8.07229 14.8554 8 15.1616 8 15.4721V17H28V15.4721C28 15.1616 27.9277 14.8554 27.7889 14.5777L26 11Z",
    fill: theme2.colors.bmtTeal90
  }
));
var BusinessIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 27V9H26V27H24V19H20V27H10ZM12 19H18V25H12V19Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M26 11H10L8.21115 14.5777C8.07229 14.8554 8 15.1616 8 15.4721V17H28V15.4721C28 15.1616 27.9277 14.8554 27.7889 14.5777L26 11Z",
    fill: theme2.colors.bmtTeal90
  }
));
var CapIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("path", { d: "M27 23V16.1L18 21L7 15L18 9L29 15V23H27Z", fill: "#1C1B1F" }), /* @__PURE__ */ React785.createElement("path", { d: "M11 23.2002L18 27.0002L25 23.2002V18.2002L18 22.0002L11 18.2002V23.2002Z", fill: "#071B39" }), /* @__PURE__ */ React785.createElement("path", { d: "M11 23.2001L18 27.0001L25 23.2001V15.1998L18 18.9998L11 15.1998V23.2001Z", fill: "#071B39" }), /* @__PURE__ */ React785.createElement("rect", { x: "27", y: "15", width: "2", height: "8", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M18 21L7 15L18 9L29 15L18 21Z", fill: "#1856BA" }));
var CapIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("path", { d: "M27 23V16.1L18 21L7 15L18 9L29 15V23H27Z", fill: "#1C1B1F" }), /* @__PURE__ */ React785.createElement("path", { d: "M11 23.2002L18 27.0002L25 23.2002V18.2002L18 22.0002L11 18.2002V23.2002Z", fill: "#1856BA" }), /* @__PURE__ */ React785.createElement("path", { d: "M11 23.2001L18 27.0001L25 23.2001V15.1998L18 18.9998L11 15.1998V23.2001Z", fill: "#1856BA" }), /* @__PURE__ */ React785.createElement("rect", { x: "27", y: "15", width: "2", height: "8", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M18 21L7 15L18 9L29 15L18 21Z", fill: "#2D79ED" }));
var CarIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3188 12H22.6812L23.9669 15H12.0331L13.3188 12ZM27 22V17L24.5195 11.2122C24.2043 10.4768 23.4813 10 22.6812 10H13.3188C12.5187 10 11.7957 10.4768 11.4805 11.2122L9 17V22V24H11H25H27V22Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "12.5", cy: "18.5", r: "1.5", fill: "white" }), /* @__PURE__ */ React785.createElement("circle", { cx: "23.5", cy: "18.5", r: "1.5", fill: "white" }), /* @__PURE__ */ React785.createElement("path", { d: "M9 24H12V27H9V24Z", fill: "#071B39" }), /* @__PURE__ */ React785.createElement("path", { d: "M24 24H27V27H24V24Z", fill: "#071B39" }));
var CarIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3188 12H22.6812L23.9669 15H12.0331L13.3188 12ZM27 22V17L24.5195 11.2122C24.2043 10.4768 23.4813 10 22.6812 10H13.3188C12.5187 10 11.7957 10.4768 11.4805 11.2122L9 17V22V24H11H25H27V22Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "12.5", cy: "18.5", r: "1.5", fill: theme2.colors.bmtBlue10 }), /* @__PURE__ */ React785.createElement("circle", { cx: "23.5", cy: "18.5", r: "1.5", fill: theme2.colors.bmtBlue10 }), /* @__PURE__ */ React785.createElement("path", { d: "M9 24H12V27H9V24Z", fill: "#12438F" }), /* @__PURE__ */ React785.createElement("path", { d: "M24 24H27V27H24V24Z", fill: "#12438F" }));
var CardIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("rect", { x: "11", y: "8", width: "14", height: "20", rx: "2", fill: theme2.colors.bmtBlue }), /* @__PURE__ */ React785.createElement("rect", { x: "18", y: "12", width: "3", height: "4", fill: theme2.colors.bmtBlue10 }));
var CardIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("rect", { x: "11", y: "8", width: "14", height: "20", rx: "2", fill: theme2.colors.bmtBlue }), /* @__PURE__ */ React785.createElement("rect", { x: "18", y: "12", width: "3", height: "4", fill: theme2.colors.bmtBlue10 }));
var CharityIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5892 14.7509C15.4242 14.3461 16 13.4903 16 12.5C16 11.1193 14.8807 10 13.5 10C12.1193 10 11 11.1193 11 12.5C11 13.2125 11.298 13.8553 11.7762 14.3107C10.2769 14.0053 8.79459 13.5885 7.34174 13.0602L6.65826 14.9398C8.0649 15.4513 9.4975 15.8646 10.9461 16.1797L8 26H11L13 19L14 26H17L15.1633 16.8165C16.1071 16.8974 17.0536 16.9379 18 16.9379V14.9379C16.8613 14.9379 15.7227 14.8756 14.5892 14.7509Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2238 14.3107C24.702 13.8553 25 13.2125 25 12.5C25 11.1193 23.8807 10 22.5 10C21.1193 10 20 11.1193 20 12.5C20 13.4903 20.5758 14.3461 21.4108 14.7509C20.2773 14.8756 19.1387 14.9379 18 14.9379V16.9379C18.9464 16.9379 19.8929 16.8974 20.8367 16.8165L19 26H22L23 19L25 26H28L25.0539 16.1797C26.5025 15.8646 27.9351 15.4513 29.3417 14.9398L28.6582 13.0602C27.2054 13.5885 25.7231 14.0053 24.2238 14.3107Z",
    fill: theme2.colors.bmtGold
  }
));
var CharityIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5892 14.7509C15.4242 14.3461 16 13.4903 16 12.5C16 11.1193 14.8807 10 13.5 10C12.1193 10 11 11.1193 11 12.5C11 13.2125 11.298 13.8553 11.7762 14.3107C10.2769 14.0053 8.79459 13.5885 7.34174 13.0602L6.65826 14.9398C8.0649 15.4513 9.4975 15.8646 10.9461 16.1797L8 26H11L13 19L14 26H17L15.1633 16.8165C16.1071 16.8974 17.0536 16.9379 18 16.9379V14.9379C16.8613 14.9379 15.7227 14.8756 14.5892 14.7509Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2238 14.3107C24.702 13.8553 25 13.2125 25 12.5C25 11.1193 23.8807 10 22.5 10C21.1193 10 20 11.1193 20 12.5C20 13.4903 20.5758 14.3461 21.4108 14.7509C20.2773 14.8756 19.1387 14.9379 18 14.9379V16.9379C18.9464 16.9379 19.8929 16.8974 20.8367 16.8165L19 26H22L23 19L25 26H28L25.0539 16.1797C26.5025 15.8646 27.9351 15.4513 29.3417 14.9398L28.6582 13.0602C27.2054 13.5885 25.7231 14.0053 24.2238 14.3107Z",
    fill: theme2.colors.bmtGold
  }
));
var CoinIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("circle", { cx: "18", cy: "18", r: "9", fill: "#FCFCD0", stroke: theme2.colors.bmtGold, strokeWidth: "2" }), /* @__PURE__ */ React785.createElement("circle", { cx: "18", cy: "18", r: "5", fill: theme2.colors.bmtGold }));
var CoinIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("circle", { cx: "18", cy: "18", r: "9", fill: theme2.colors.bmtGold, stroke: "#FCFCD0", strokeWidth: "2" }), /* @__PURE__ */ React785.createElement("circle", { cx: "18", cy: "18", r: "5", fill: "#FCFCD0" }));
var DollarIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("rect", { x: "7", y: "11", width: "22", height: "14", fill: theme2.colors.bmtTeal }), /* @__PURE__ */ React785.createElement("circle", { cx: "18", cy: "18", r: "3", fill: theme2.colors.bmtTeal90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 13H11C11 13 11 13 11 13.0001C11 14.1046 10.1045 15 9 15.0001V21.0001C10.1045 21.0001 10.9999 21.8955 11 23H25C25 21.8955 25.8954 21.0001 27 21.0001C27 21.0001 27 21.0001 27 21.0001V15.0001C27 15.0001 27 15.0001 27 15.0001C25.8954 15.0001 25 14.1046 25 13.0001C25 13 25 13 25 13ZM7 11H9H27H29V13V23V25H27H9H7V23V13V11Z",
    fill: theme2.colors.bmtTeal90
  }
));
var DollarIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("rect", { x: "7", y: "11", width: "22", height: "14", fill: theme2.colors.bmtTeal }), /* @__PURE__ */ React785.createElement("circle", { cx: "18", cy: "18", r: "3", fill: theme2.colors.bmtTeal90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 13H11C11 13 11 13 11 13.0001C11 14.1046 10.1045 15 9 15.0001V21.0001C10.1045 21.0001 10.9999 21.8955 11 23H25C25 21.8955 25.8954 21.0001 27 21.0001C27 21.0001 27 21.0001 27 21.0001V15.0001C27 15.0001 27 15.0001 27 15.0001C25.8954 15.0001 25 14.1046 25 13.0001C25 13 25 13 25 13ZM7 11H9H27H29V13V23V25H27H9H7V23V13V11Z",
    fill: theme2.colors.bmtTeal90
  }
));
var HomeIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("path", { d: "M10 27V17H8V15L18 8L28 15V17H26V27H20V19H16V27H10Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M8 17H10L18 11L26 17H28V15L18 8L8 15V17Z", fill: theme2.colors.bmtOrange }), /* @__PURE__ */ React785.createElement("rect", { x: "16", y: "19", width: "4", height: "8", fill: "#071B39" }));
var HomeIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("path", { d: "M10 27V17H8V15L18 8L28 15V17H26V27H20V19H16V27H10Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M8 17H10L18 11L26 17H28V15L18 8L8 15V17Z", fill: theme2.colors.bmtOrange }));
var LiferingIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22ZM18 28C23.5228 28 28 23.5228 28 18C28 12.4772 23.5228 8 18 8C12.4772 8 8 12.4772 8 18C8 23.5228 12.4772 28 18 28Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1355 19.0362C14.5036 20.4127 15.5876 21.4965 16.964 21.8646L12.4853 26.3433C11.3633 25.6002 10.3999 24.6369 9.65683 23.5149L14.1355 19.0362ZM16.9638 14.1355C15.5874 14.5037 14.5035 15.5876 14.1354 16.964L9.65674 12.4853C10.3998 11.3633 11.3632 10.4 12.4852 9.65687L16.9638 14.1355ZM26.3432 23.5149C25.6 24.6368 24.6367 25.6002 23.5147 26.3433L19.036 21.8646C20.4124 21.4965 21.4964 20.4126 21.8645 19.0362L26.3432 23.5149ZM23.5148 9.6569C24.6368 10.4 25.6002 11.3634 26.3432 12.4854L21.8645 16.9641C21.4965 15.5876 20.4126 14.5037 19.0362 14.1356L23.5148 9.6569Z",
    fill: "#071B39"
  }
));
var LiferingIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22ZM18 28C23.5228 28 28 23.5228 28 18C28 12.4772 23.5228 8 18 8C12.4772 8 8 12.4772 8 18C8 23.5228 12.4772 28 18 28Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1355 19.0362C14.5036 20.4127 15.5876 21.4965 16.964 21.8646L12.4853 26.3433C11.3633 25.6002 10.3999 24.6369 9.65683 23.5149L14.1355 19.0362ZM16.9638 14.1355C15.5874 14.5037 14.5035 15.5876 14.1354 16.964L9.65674 12.4853C10.3998 11.3633 11.3632 10.4 12.4852 9.65687L16.9638 14.1355ZM26.3432 23.5149C25.6 24.6368 24.6367 25.6002 23.5147 26.3433L19.036 21.8646C20.4124 21.4965 21.4964 20.4126 21.8645 19.0362L26.3432 23.5149ZM23.5148 9.6569C24.6368 10.4 25.6002 11.3634 26.3432 12.4854L21.8645 16.9641C21.4965 15.5876 20.4126 14.5037 19.0362 14.1356L23.5148 9.6569Z",
    fill: theme2.colors.bmtBlue10
  }
));
var ParasolIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("path", { d: "M10 26L25 11", stroke: "#071B39", strokeWidth: "2" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M25.0711 10.9289C21.1658 7.02369 14.8342 7.02369 10.9289 10.9289L25.0711 25.0711C28.9763 21.1658 28.9763 14.8342 25.0711 10.9289Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M25.0711 10.9289C23.1184 8.97631 18.3697 10.5592 14.4645 14.4645L21.5355 21.5355C25.4408 17.6303 27.0237 12.8816 25.0711 10.9289Z",
    fill: theme2.colors.bmtGold
  }
));
var ParasolIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("path", { d: "M10 26L25 11", stroke: "#FCFCD0", strokeWidth: "2" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M25.0711 10.9289C21.1658 7.02369 14.8342 7.02369 10.9289 10.9289L25.0711 25.0711C28.9763 21.1658 28.9763 14.8342 25.0711 10.9289Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M25.0711 10.9289C23.1184 8.97631 18.3697 10.5592 14.4645 14.4645L21.5355 21.5355C25.4408 17.6303 27.0237 12.8816 25.0711 10.9289Z",
    fill: theme2.colors.bmtGold
  }
));
var PlaneIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M14.5 28V26.5L16.5 25V19.5L8 22V20L16.5 15V9.5C16.5 9.08333 16.6458 8.72917 16.9375 8.4375C17.2292 8.14583 17.5833 8 18 8C18.4167 8 18.7708 8.14583 19.0625 8.4375C19.3542 8.72917 19.5 9.08333 19.5 9.5V15L28 20V22L19.5 19.5V25L21.5 26.5V28L18 27L14.5 28Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M28 20L19.5 15V19.5L28 22V20Z", fill: theme2.colors.bmtTeal90 }), /* @__PURE__ */ React785.createElement("path", { d: "M8 22L16.5 19.5V15L8 20V22Z", fill: theme2.colors.bmtTeal90 }));
var PlaneIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M14.5 28V26.5L16.5 25V19.5L8 22V20L16.5 15V9.5C16.5 9.08333 16.6458 8.72917 16.9375 8.4375C17.2292 8.14583 17.5833 8 18 8C18.4167 8 18.7708 8.14583 19.0625 8.4375C19.3542 8.72917 19.5 9.08333 19.5 9.5V15L28 20V22L19.5 19.5V25L21.5 26.5V28L18 27L14.5 28Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M28 20L19.5 15V19.5L28 22V20Z", fill: theme2.colors.bmtTeal90 }), /* @__PURE__ */ React785.createElement("path", { d: "M8 22L16.5 19.5V15L8 20V22Z", fill: theme2.colors.bmtTeal90 }));
var PlantIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C12 17.3137 14.6863 20 18 20C18 16.6863 15.3137 14 12 14Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15.748C22.4505 14.8599 25 11.7277 25 8C20.5817 8 17 11.5817 17 16V22H19L19 15.748Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M26 28H10L15.1716 22.8284C16.7337 21.2663 19.2663 21.2663 20.8284 22.8284L26 28Z", fill: "#071B39" }));
var PlantIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14C12 17.3137 14.6863 20 18 20C18 16.6863 15.3137 14 12 14Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15.748C22.4505 14.8599 25 11.7277 25 8C20.5817 8 17 11.5817 17 16V22H19L19 15.748Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M26 28H10L15.1716 22.8284C16.7337 21.2663 19.2663 21.2663 20.8284 22.8284L26 28Z",
    fill: theme2.colors.bmtTeal90
  }
));
var PresentIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M8 14C8 12.8954 8.89543 12 10 12H26C27.1046 12 28 12.8954 28 14V25C28 26.1046 27.1046 27 26 27H10C8.89543 27 8 26.1046 8 25L8 14Z",
    fill: theme2.colors.bmtGold
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10ZM12 11C12 9.34315 13.3431 8 15 8C15.08 8 15.1594 8.00314 15.2378 8.00929C16.0878 8.07582 16.8754 8.4967 17.4033 9.17541L18 9.94261L18.5967 9.17541C19.1246 8.49673 19.9121 8.07586 20.762 8.0093C20.8405 8.00314 20.9199 8 21 8C22.6569 8 24 9.34315 24 11C24 12.6056 22.7386 13.9166 21.1528 13.9962L23.7894 17.3861L22.2106 18.6139L19 14.486V27H17V14.486L13.7894 18.6139L12.2106 17.3861L14.8472 13.9962C13.2614 13.9166 12 12.6056 12 11ZM21 10C20.4477 10 20 10.4477 20 11C20 11.5523 20.4477 12 21 12C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10Z",
    fill: "#071B39"
  }
));
var PresentIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M8 14C8 12.8954 8.89543 12 10 12H26C27.1046 12 28 12.8954 28 14V25C28 26.1046 27.1046 27 26 27H10C8.89543 27 8 26.1046 8 25L8 14Z",
    fill: theme2.colors.bmtGold
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C14.4477 10 14 10.4477 14 11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10ZM12 11C12 9.34315 13.3431 8 15 8C15.08 8 15.1594 8.00314 15.2378 8.00929C16.0878 8.07582 16.8754 8.4967 17.4033 9.17541L18 9.94261L18.5967 9.17541C19.1246 8.49673 19.9121 8.07586 20.762 8.0093C20.8405 8.00314 20.9199 8 21 8C22.6569 8 24 9.34315 24 11C24 12.6056 22.7386 13.9166 21.1528 13.9962L23.7894 17.3861L22.2106 18.6139L19 14.486V27H17V14.486L13.7894 18.6139L12.2106 17.3861L14.8472 13.9962C13.2614 13.9166 12 12.6056 12 11ZM21 10C20.4477 10 20 10.4477 20 11C20 11.5523 20.4477 12 21 12C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10Z",
    fill: "#FCFCD0"
  }
));
var SignPostIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", ry: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("path", { d: "M20.4747 4.08789H15.6621V33.5909H20.4747V4.08789Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M28.2447 16.1601L31.3994 13.052L28.2447 9.94629H7.8756V16.1601H28.2447Z", fill: theme2.colors.bmtVizNavy }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M10.6442 18.8994L8.35254 21.1196L10.6442 23.3379L25.4406 23.3379L25.4406 18.8994L10.6442 18.8994Z",
    fill: theme2.colors.bmtTeal
  }
));
var SignPostIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", ry: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("path", { d: "M20.4747 4.08789H15.6621V33.5909H20.4747V4.08789Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M28.2447 16.1601L31.3994 13.052L28.2447 9.94629H7.8756V16.1601H28.2447Z", fill: theme2.colors.bmtBlue }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M10.6442 18.8994L8.35254 21.1196L10.6442 23.3379L25.4406 23.3379L25.4406 18.8994L10.6442 18.8994Z",
    fill: theme2.colors.bmtTeal
  }
));
var TalkingIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", ry: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "mask",
  {
    id: "mask0_4758_67096",
    style: { maskType: "alpha" },
    maskUnits: "userSpaceOnUse",
    x: "3",
    y: "3",
    width: "24",
    height: "32"
  },
  /* @__PURE__ */ React785.createElement("rect", { x: "3.75", y: "3.38184", width: "23.25", height: "30.8889", fill: theme2.colors.bmtGrey10 })
), /* @__PURE__ */ React785.createElement("g", { mask: "url(#mask0_4758_67096)" }, /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M8.78742 10.2968L8.72531 10.4432C7.92507 12.3295 8.37838 14.5143 9.863 15.9265C10.8592 16.874 11.4231 18.1887 11.4231 19.5635V23.4372C11.4231 23.8492 11.6155 24.2376 11.9433 24.4871L18.0055 29.1016L17.3227 25.0052C17.254 24.593 17.2195 24.1758 17.2195 23.7579V20.9066C17.2195 20.5423 17.5149 20.2469 17.8792 20.2469H19.7961C20.4991 20.2469 21.0787 19.6957 21.1139 18.9935L21.2196 16.8866C21.2259 16.7608 21.3033 16.6496 21.419 16.5999L21.9274 16.3818C22.3604 16.196 22.4647 15.6293 22.1262 15.3016L21.1985 14.4031C20.9812 14.1928 20.8721 13.8947 20.9022 13.5938L21.0129 12.4864C21.0381 12.2344 21.0167 11.98 20.9496 11.7358C20.1972 8.99469 17.7054 7.09473 14.8629 7.09473H13.6242C11.5154 7.09473 9.61099 8.35552 8.78742 10.2968Z",
    fill: theme2.colors.bmtVizOrange
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M18.3148 25.042L18.0155 24.7434C15.664 22.3972 11.838 22.4608 9.56562 24.8837C8.55906 25.9569 7.84862 27.2733 7.50391 28.7037L7.00637 30.7683C6.42927 33.1631 6.12203 35.615 6.09037 38.0781L5.67693 70.2521L33.4509 65.6289L28.5696 46.582L26.9734 41.4185C26.5566 40.0701 26.0225 38.7608 25.3773 37.5055L20.5326 28.0796C19.956 26.9578 19.2077 25.9329 18.3148 25.042Z",
    fill: theme2.colors.bmtVizNavy
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M18.141 12.852L18.272 12.8345C19.9966 12.6046 21.2598 11.0952 21.1823 9.35708C21.1069 7.66427 19.7818 6.29304 18.0925 6.15968L16.4681 6.03143C14.5661 5.88128 12.6538 6.13084 10.8541 6.76407L10.7684 6.79422C9.1897 7.3497 7.93693 8.57414 7.34547 10.1398L7.11093 10.7606C6.77679 11.6451 6.54117 12.5637 6.40835 13.4999L4.896 24.1591H14.3695V16.8071L13.7091 16.2483C13.3148 15.9147 13.0723 15.4357 13.0368 14.9205L12.9833 14.1447C12.936 13.4593 13.4792 12.8773 14.1662 12.8773C14.8211 12.8773 15.352 13.4082 15.352 14.0631V14.2247C15.352 14.3487 15.4525 14.4493 15.5765 14.4493H16.1539C16.2656 14.4493 16.3688 14.3896 16.4244 14.2927L16.6952 13.8217C17.0002 13.2913 17.5345 12.9329 18.141 12.852Z",
    fill: theme2.secondaryColors.coral50
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "0.928485", cy: "0.928485", r: "0.928485", transform: "matrix(-1 0 0 1 14.8364 15.8525)", fill: "#FEE27D" })), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8069 10C34.0619 10 34.2686 10.2067 34.2686 10.4617V16.1749C34.2686 16.4298 34.0619 16.6365 33.8069 16.6365H27.8693L26.3978 18.1781C26.254 18.3287 26 18.227 26 18.0187V16.2014H26.0009C26.0004 16.1926 26.0001 16.1837 26.0001 16.1749V10.4617C26.0001 10.2067 26.2068 10 26.4618 10H33.8069Z",
    fill: theme2.colors.bmtTeal
  }
));
var TalkingIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", ry: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "mask",
  {
    id: "mask0_4758_67096",
    style: { maskType: "alpha" },
    maskUnits: "userSpaceOnUse",
    x: "3",
    y: "3",
    width: "20",
    height: "32"
  },
  /* @__PURE__ */ React785.createElement("rect", { x: "3.75", y: "3.38184", width: "23.25", height: "30.8889", fill: theme2.colors.bmtGrey90 })
), /* @__PURE__ */ React785.createElement("g", { mask: "url(#mask0_4758_67096)" }, /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M8.78742 10.2968L8.72531 10.4432C7.92507 12.3295 8.37838 14.5143 9.863 15.9265C10.8592 16.874 11.4231 18.1887 11.4231 19.5635V23.4372C11.4231 23.8492 11.6155 24.2376 11.9433 24.4871L18.0055 29.1016L17.3227 25.0052C17.254 24.593 17.2195 24.1758 17.2195 23.7579V20.9066C17.2195 20.5423 17.5149 20.2469 17.8792 20.2469H19.7961C20.4991 20.2469 21.0787 19.6957 21.1139 18.9935L21.2196 16.8866C21.2259 16.7608 21.3033 16.6496 21.419 16.5999L21.9274 16.3818C22.3604 16.196 22.4647 15.6293 22.1262 15.3016L21.1985 14.4031C20.9812 14.1928 20.8721 13.8947 20.9022 13.5938L21.0129 12.4864C21.0381 12.2344 21.0167 11.98 20.9496 11.7358C20.1972 8.99469 17.7054 7.09473 14.8629 7.09473H13.6242C11.5154 7.09473 9.61099 8.35552 8.78742 10.2968Z",
    fill: theme2.colors.bmtVizOrange
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M18.3148 25.042L18.0155 24.7434C15.664 22.3972 11.838 22.4608 9.56562 24.8837C8.55906 25.9569 7.84862 27.2733 7.50391 28.7037L7.00637 30.7683C6.42927 33.1631 6.12203 35.615 6.09037 38.0781L5.67693 70.2521L33.4509 65.6289L28.5696 46.582L26.9734 41.4185C26.5566 40.0701 26.0225 38.7608 25.3773 37.5055L20.5326 28.0796C19.956 26.9578 19.2077 25.9329 18.3148 25.042Z",
    fill: theme2.colors.bmtBlue
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M18.141 12.852L18.272 12.8345C19.9966 12.6046 21.2598 11.0952 21.1823 9.35708C21.1069 7.66427 19.7818 6.29304 18.0925 6.15968L16.4681 6.03143C14.5661 5.88128 12.6538 6.13084 10.8541 6.76407L10.7684 6.79422C9.1897 7.3497 7.93693 8.57414 7.34547 10.1398L7.11093 10.7606C6.77679 11.6451 6.54117 12.5637 6.40835 13.4999L4.896 24.1591H14.3695V16.8071L13.7091 16.2483C13.3148 15.9147 13.0723 15.4357 13.0368 14.9205L12.9833 14.1447C12.936 13.4593 13.4792 12.8773 14.1662 12.8773C14.8211 12.8773 15.352 13.4082 15.352 14.0631V14.2247C15.352 14.3487 15.4525 14.4493 15.5765 14.4493H16.1539C16.2656 14.4493 16.3688 14.3896 16.4244 14.2927L16.6952 13.8217C17.0002 13.2913 17.5345 12.9329 18.141 12.852Z",
    fill: theme2.secondaryColors.coral50
  }
), /* @__PURE__ */ React785.createElement("circle", { cx: "0.928485", cy: "0.928485", r: "0.928485", transform: "matrix(-1 0 0 1 14.8364 15.8525)", fill: "#FEE27D" })), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8069 10C34.0619 10 34.2686 10.2067 34.2686 10.4617V16.1749C34.2686 16.4298 34.0619 16.6365 33.8069 16.6365H27.8693L26.3978 18.1781C26.254 18.3287 26 18.227 26 18.0187V16.2014H26.0009C26.0004 16.1926 26.0001 16.1837 26.0001 16.1749V10.4617C26.0001 10.2067 26.2068 10 26.4618 10H33.8069Z",
    fill: theme2.colors.bmtTeal
  }
));
var TreeIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement("path", { d: "M20 28H16L17 18H19L20 28Z", fill: "#071B39" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1332 9.13568C19.1141 7.62144 16.8859 7.62144 15.8668 9.13568C15.2897 9.99335 14.2549 10.4219 13.2404 10.2236C11.4491 9.87343 9.87343 11.4491 10.2236 13.2404C10.4219 14.2549 9.99335 15.2897 9.13569 15.8668C8.37856 16.3763 8 17.1882 8 18H28C28 17.1882 27.6214 16.3763 26.8643 15.8668C26.0066 15.2897 25.5781 14.2549 25.7764 13.2404C26.1266 11.4491 24.5509 9.87343 22.7596 10.2236C21.7451 10.4219 20.7103 9.99335 20.1332 9.13568Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M18 21L22 18H23L18 24V21Z", fill: "#071B39" }), /* @__PURE__ */ React785.createElement("path", { d: "M18 21L14 18H13L18 24V21Z", fill: "#071B39" }));
var TreeIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement("path", { d: "M20 28H16L17 18H19L20 28Z", fill: "#DAFCF5" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1332 9.13568C19.1141 7.62144 16.8859 7.62144 15.8668 9.13568C15.2897 9.99335 14.2549 10.4219 13.2404 10.2236C11.4491 9.87343 9.87343 11.4491 10.2236 13.2404C10.4219 14.2549 9.99335 15.2897 9.13569 15.8668C8.37856 16.3763 8 17.1882 8 18H28C28 17.1882 27.6214 16.3763 26.8643 15.8668C26.0066 15.2897 25.5781 14.2549 25.7764 13.2404C26.1266 11.4491 24.5509 9.87343 22.7596 10.2236C21.7451 10.4219 20.7103 9.99335 20.1332 9.13568Z",
    fill: theme2.colors.bmtTeal
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M18 21L22 18H23L18 24V21Z", fill: "#DAFCF5" }), /* @__PURE__ */ React785.createElement("path", { d: "M18 21L14 18H13L18 24V21Z", fill: "#DAFCF5" }));
var WateringCanIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M18 28C18 26.7667 18.2375 25.6042 18.7125 24.5125C19.1875 23.4208 19.8333 22.4667 20.65 21.65C21.4667 20.8333 22.4208 20.1875 23.5125 19.7125C24.6042 19.2375 25.7667 19 27 19C27 20.2333 26.7625 21.3958 26.2875 22.4875C25.8125 23.5792 25.1667 24.5333 24.35 25.35C23.5333 26.1667 22.5792 26.8125 21.4875 27.2875C20.3958 27.7625 19.2333 28 18 28C16.7667 28 15.6042 27.7625 14.5125 27.2875C13.4208 26.8125 12.4667 26.1667 11.65 25.35C10.8333 24.5333 10.1875 23.5792 9.7125 22.4875C9.2375 21.3958 9 20.2333 9 19C10.2333 19 11.3958 19.2375 12.4875 19.7125C13.5792 20.1875 14.5333 20.8333 15.35 21.65C16.1667 22.4667 16.8125 23.4208 17.2875 24.5125C17.7625 25.6042 18 26.7667 18 28Z",
    fill: theme2.colors.bmtTeal90
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13C18.2113 13 18.4143 12.9817 18.6091 12.945C18.6748 13.132 18.7604 13.317 18.866 13.4999C18.9717 13.6829 19.0891 13.8496 19.2183 14C19.0891 14.1504 18.9717 14.3171 18.866 14.5001C18.7604 14.683 18.6748 14.868 18.6091 15.055C18.4143 15.0183 18.2113 15 18 15C17.7887 15 17.5857 15.0183 17.3909 15.055C17.3252 14.8679 17.2396 14.6829 17.134 14.4999C17.0283 14.317 16.9109 14.1504 16.7818 14C16.9109 13.8496 17.0283 13.683 17.1339 13.5001C17.2396 13.3171 17.3252 13.1321 17.3909 12.945C17.5857 12.9817 17.7887 13 18 13ZM12.2822 14C11.9717 13.6596 11.753 13.2529 11.6262 12.7797C11.4139 11.9874 11.5178 11.2275 11.9378 10.5001C12.3578 9.77261 12.9639 9.30273 13.7562 9.09043C14.2294 8.96364 14.691 8.94962 15.1411 9.04836C15.2806 8.6092 15.5236 8.21641 15.87 7.87C16.45 7.29 17.16 7 18 7C18.84 7 19.55 7.29 20.13 7.87C20.4764 8.21638 20.7193 8.60912 20.8588 9.04823C21.3089 8.94948 21.7705 8.9635 22.2437 9.0903C23.036 9.30259 23.6422 9.77247 24.0622 10.4999C24.4822 11.2274 24.586 11.9873 24.3737 12.7796C24.2469 13.2528 24.0282 13.6596 23.7177 14C24.0282 14.3404 24.2469 14.7472 24.3737 15.2204C24.586 16.0127 24.4822 16.7726 24.0622 17.5001C23.6422 18.2275 23.036 18.6974 22.2437 18.9097C21.7705 19.0365 21.3089 19.0505 20.8588 18.9518C20.7193 19.3909 20.4764 19.7836 20.13 20.13C19.55 20.71 18.84 21 18 21C17.16 21 16.45 20.71 15.87 20.13C15.5236 19.7836 15.2806 19.3908 15.1411 18.9516C14.691 19.0504 14.2294 19.0364 13.7562 18.9096C12.9639 18.6973 12.3578 18.2274 11.9378 17.4999C11.5178 16.7725 11.4139 16.0126 11.6262 15.2203C11.753 14.7471 11.9717 14.3404 12.2822 14Z",
    fill: theme2.colors.bmtGold
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M20.13 16.13C19.55 16.71 18.84 17 18 17C17.16 17 16.45 16.71 15.87 16.13C15.29 15.55 15 14.84 15 14C15 13.16 15.29 12.45 15.87 11.87C16.45 11.29 17.16 11 18 11C18.84 11 19.55 11.29 20.13 11.87C20.71 12.45 21 13.16 21 14C21 14.84 20.71 15.55 20.13 16.13Z",
    fill: "#071B39"
  }
));
var WateringCanIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M18 28C18 26.7667 18.2375 25.6042 18.7125 24.5125C19.1875 23.4208 19.8333 22.4667 20.65 21.65C21.4667 20.8333 22.4208 20.1875 23.5125 19.7125C24.6042 19.2375 25.7667 19 27 19C27 20.2333 26.7625 21.3958 26.2875 22.4875C25.8125 23.5792 25.1667 24.5333 24.35 25.35C23.5333 26.1667 22.5792 26.8125 21.4875 27.2875C20.3958 27.7625 19.2333 28 18 28C16.7667 28 15.6042 27.7625 14.5125 27.2875C13.4208 26.8125 12.4667 26.1667 11.65 25.35C10.8333 24.5333 10.1875 23.5792 9.7125 22.4875C9.2375 21.3958 9 20.2333 9 19C10.2333 19 11.3958 19.2375 12.4875 19.7125C13.5792 20.1875 14.5333 20.8333 15.35 21.65C16.1667 22.4667 16.8125 23.4208 17.2875 24.5125C17.7625 25.6042 18 26.7667 18 28Z",
    fill: theme2.colors.bmtTeal90
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13C18.2113 13 18.4143 12.9817 18.6091 12.945C18.6748 13.132 18.7604 13.317 18.866 13.4999C18.9717 13.6829 19.0891 13.8496 19.2183 14C19.0891 14.1504 18.9717 14.3171 18.866 14.5001C18.7604 14.683 18.6748 14.868 18.6091 15.055C18.4143 15.0183 18.2113 15 18 15C17.7887 15 17.5857 15.0183 17.3909 15.055C17.3252 14.8679 17.2396 14.6829 17.134 14.4999C17.0283 14.317 16.9109 14.1504 16.7818 14C16.9109 13.8496 17.0283 13.683 17.1339 13.5001C17.2396 13.3171 17.3252 13.1321 17.3909 12.945C17.5857 12.9817 17.7887 13 18 13ZM12.2822 14C11.9717 13.6596 11.753 13.2529 11.6262 12.7797C11.4139 11.9874 11.5178 11.2275 11.9378 10.5001C12.3578 9.77261 12.9639 9.30273 13.7562 9.09043C14.2294 8.96364 14.691 8.94962 15.1411 9.04836C15.2806 8.6092 15.5236 8.21641 15.87 7.87C16.45 7.29 17.16 7 18 7C18.84 7 19.55 7.29 20.13 7.87C20.4764 8.21638 20.7193 8.60912 20.8588 9.04823C21.3089 8.94948 21.7705 8.9635 22.2437 9.0903C23.036 9.30259 23.6422 9.77247 24.0622 10.4999C24.4822 11.2274 24.586 11.9873 24.3737 12.7796C24.2469 13.2528 24.0282 13.6596 23.7177 14C24.0282 14.3404 24.2469 14.7472 24.3737 15.2204C24.586 16.0127 24.4822 16.7726 24.0622 17.5001C23.6422 18.2275 23.036 18.6974 22.2437 18.9097C21.7705 19.0365 21.3089 19.0505 20.8588 18.9518C20.7193 19.3909 20.4764 19.7836 20.13 20.13C19.55 20.71 18.84 21 18 21C17.16 21 16.45 20.71 15.87 20.13C15.5236 19.7836 15.2806 19.3908 15.1411 18.9516C14.691 19.0504 14.2294 19.0364 13.7562 18.9096C12.9639 18.6973 12.3578 18.2274 11.9378 17.4999C11.5178 16.7725 11.4139 16.0126 11.6262 15.2203C11.753 14.7471 11.9717 14.3404 12.2822 14Z",
    fill: theme2.colors.bmtGold
  }
), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M20.13 16.13C19.55 16.71 18.84 17 18 17C17.16 17 16.45 16.71 15.87 16.13C15.29 15.55 15 14.84 15 14C15 13.16 15.29 12.45 15.87 11.87C16.45 11.29 17.16 11 18 11C18.84 11 19.55 11.29 20.13 11.87C20.71 12.45 21 13.16 21 14C21 14.84 20.71 15.55 20.13 16.13Z",
    fill: "#071B39"
  }
));
var WeddingIconLight = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey10 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M20.6109 9.3312L17.997 12L15.3831 9.3312C15.1377 9.07915 15 8.73829 15 8.38301C15 8.02774 15.1377 7.68689 15.3831 7.43485L15.4262 7.39092C15.6732 7.14053 16.0073 7 16.3555 7C16.7037 7 17.0378 7.14053 17.2848 7.39092L18.0024 8.1231L18.72 7.39092C18.967 7.14053 19.3011 7 19.6493 7C19.9975 7 20.3316 7.14053 20.5786 7.39092L20.6199 7.43485C20.865 7.68763 21.0017 8.02934 21 8.38491C20.9983 8.74048 20.8584 9.08084 20.6109 9.3312Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M12 14C12 12.8954 12.8954 12 14 12H22C23.1046 12 24 12.8954 24 14V17H12V14Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M10 19C10 17.8954 10.8954 17 12 17H24C25.1046 17 26 17.8954 26 19V22H10V19Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M9 23H27", stroke: "#071B39", strokeWidth: "2" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M9 24V22H27V24H20C19.4477 24 19 24.4477 19 25C19 25.5523 19.4477 26 20 26H21V28H15V26H16C16.5523 26 17 25.5523 17 25C17 24.4477 16.5523 24 16 24H9Z",
    fill: "#071B39"
  }
));
var WeddingIconDark = ({ theme: theme2 }) => /* @__PURE__ */ React785.createElement("svg", { viewBox: "0 0 36 36", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React785.createElement("rect", { width: "36", height: "36", rx: "4", fill: theme2.colors.bmtGrey90 }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M20.6109 9.3312L17.997 12L15.3831 9.3312C15.1377 9.07915 15 8.73829 15 8.38301C15 8.02774 15.1377 7.68689 15.3831 7.43485L15.4262 7.39092C15.6732 7.14053 16.0073 7 16.3555 7C16.7037 7 17.0378 7.14053 17.2848 7.39092L18.0024 8.1231L18.72 7.39092C18.967 7.14053 19.3011 7 19.6493 7C19.9975 7 20.3316 7.14053 20.5786 7.39092L20.6199 7.43485C20.865 7.68763 21.0017 8.02934 21 8.38491C20.9983 8.74048 20.8584 9.08084 20.6109 9.3312Z",
    fill: theme2.colors.bmtOrange
  }
), /* @__PURE__ */ React785.createElement("path", { d: "M12 14C12 12.8954 12.8954 12 14 12H22C23.1046 12 24 12.8954 24 14V17H12V14Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M10 19C10 17.8954 10.8954 17 12 17H24C25.1046 17 26 17.8954 26 19V22H10V19Z", fill: theme2.colors.bmtGold }), /* @__PURE__ */ React785.createElement("path", { d: "M9 23H27", stroke: "#FCFCD0", strokeWidth: "2" }), /* @__PURE__ */ React785.createElement(
  "path",
  {
    d: "M9 24V22H27V24H20C19.4477 24 19 24.4477 19 25C19 25.5523 19.4477 26 20 26H21V28H15V26H16C16.5523 26 17 25.5523 17 25C17 24.4477 16.5523 24 16 24H9Z",
    fill: "#FCFCD0"
  }
));
var GoalIconMap = {
  advice: { light: AdviceIconLight, dark: AdviceIconDark },
  apple: { light: AppleIconLight, dark: AppleIconDark },
  baby: { light: BabyIconLight, dark: BabyIconDark },
  bandaid: { light: BandaidIconLight, dark: BandaidIconDark },
  bond: { light: BondIconLight, dark: BondIconDark },
  business: { light: BusinessIconLight, dark: BusinessIconDark },
  cap: { light: CapIconLight, dark: CapIconDark },
  car: { light: CarIconLight, dark: CarIconDark },
  card: { light: CardIconLight, dark: CardIconDark },
  charity: { light: CharityIconLight, dark: CharityIconDark },
  coin: { light: CoinIconLight, dark: CoinIconDark },
  dollar: { light: DollarIconLight, dark: DollarIconDark },
  home: { light: HomeIconLight, dark: HomeIconDark },
  lifering: { light: LiferingIconLight, dark: LiferingIconDark },
  parasol: { light: ParasolIconLight, dark: ParasolIconDark },
  plane: { light: PlaneIconLight, dark: PlaneIconDark },
  plant: { light: PlantIconLight, dark: PlantIconDark },
  present: { light: PresentIconLight, dark: PresentIconDark },
  sign_post: { light: SignPostIconLight, dark: SignPostIconDark },
  talking: { light: TalkingIconLight, dark: TalkingIconDark },
  tree: { light: TreeIconLight, dark: TreeIconDark },
  watering_can: { light: WateringCanIconLight, dark: WateringCanIconDark },
  wedding: { light: WeddingIconLight, dark: WeddingIconDark }
};
var GoalIcon = ({
  className,
  size: size2,
  name,
  mode,
  ...boxProps
}) => {
  mode ??= "light";
  const { theme: theme2 } = useTheme();
  const themeSize = size2 ? theme2.space[size2] : "3.6rem";
  const Icon2 = GoalIconMap[name][mode];
  return /* @__PURE__ */ React785.createElement(
    Box,
    {
      ...boxProps,
      as: "span",
      className,
      width: themeSize,
      minWidth: themeSize,
      maxWidth: themeSize,
      height: themeSize
    },
    /* @__PURE__ */ React785.createElement(Icon2, { theme: theme2 })
  );
};

// src/components/GlobalErrorFallback.tsx
import React786 from "react";
var GlobalErrorFallback = () => /* @__PURE__ */ React786.createElement(ErrorFallback, { message: "Looks like something went wrong." });

// src/components/HR.tsx
import React787 from "react";
var VARIANT_STYLES5 = {
  "list-row": {
    mx: [0, 4]
  },
  "workflow-card": {
    display: ["block", "none"]
  }
};
var HR = ({ variant, ...boxProps }) => {
  return /* @__PURE__ */ React787.createElement(
    Box,
    {
      as: "hr",
      border: "none",
      borderTop: "1px solid",
      borderColor: "bmtGrey20",
      m: "0",
      ...typeof variant !== "undefined" && VARIANT_STYLES5[variant],
      ...boxProps
    }
  );
};

// src/components/InlineTextLoader.tsx
import React788 from "react";
import { keyframes } from "@emotion/core";
import styled31 from "@emotion/styled";
var ANIMATION_LENGTH_SECONDS = 2;
var ITEM_DELAYS_SECONDS = [0.1, ANIMATION_LENGTH_SECONDS / 6, ANIMATION_LENGTH_SECONDS / 3];
var pulse = keyframes`
  0% {
    opacity: 0.2;
  }
  40% {
    opacity: 0.9;
  }
  100% {
    opacity: 0.2;
  }
`;
var PulsingItem = styled31.span`
  animation: ${pulse} ${ANIMATION_LENGTH_SECONDS}s linear infinite;
  animation-fill-mode: both;
  padding: 0 0.1rem;
  animation-delay: ${(props) => props.animationDelaySeconds}s;
`;
var PulsingCircles = () => /* @__PURE__ */ React788.createElement(React788.Fragment, null, ITEM_DELAYS_SECONDS.map((delay, index) => /* @__PURE__ */ React788.createElement(PulsingItem, { animationDelaySeconds: delay, key: index }, "\u2022")));
var InlineTextLoader = () => /* @__PURE__ */ React788.createElement(Text, { color: "inherit", px: "0.2rem", role: "status", "aria-busy": "true", "aria-live": "polite", "aria-label": "loading" }, /* @__PURE__ */ React788.createElement(PulsingCircles, null));

// src/components/ListRow.tsx
import React789, { useRef } from "react";
import styled32 from "@emotion/styled";
import { useButton } from "@react-aria/button";
var mapVerticalAlignToFlexAlign = {
  top: "flex-start",
  center: "center"
};
var Default = ({
  title,
  subtitle,
  icon,
  textAlign: textAlign2 = "left",
  verticalAlign: verticalAlign2,
  variant
}) => {
  if (!title && variant === "leading") return null;
  const shouldShowLeadingIcon = icon && variant === "leading";
  const shouldShowTrailingIcon = icon && variant === "trailing";
  return /* @__PURE__ */ React789.createElement(Flex, { alignItems: mapVerticalAlignToFlexAlign[verticalAlign2], as: "span" }, shouldShowLeadingIcon && /* @__PURE__ */ React789.createElement(Flex, { mr: "4", as: "span" }, icon), /* @__PURE__ */ React789.createElement(Flex, { flexDirection: "column", as: "span" }, /* @__PURE__ */ React789.createElement(Text, { lineHeight: "2", textAlign: textAlign2 }, title), subtitle && /* @__PURE__ */ React789.createElement(Text, { fontSize: "1", color: "bmtGrey50", textAlign: textAlign2 }, subtitle)), shouldShowTrailingIcon && /* @__PURE__ */ React789.createElement(Flex, { ml: "4", as: "span" }, icon));
};
var ListRow = ({
  children,
  verticalAlign: verticalAlign2 = "center",
  leadingIcon,
  leadingSubtitle,
  leadingTitle,
  trailingIcon,
  trailingSubtitle,
  trailingTitle,
  textAlignment = "default",
  variant = "standard",
  spacingX = "wide"
}) => {
  let [leading, trailing] = getSlots(["leading", "trailing"], children);
  leading = leading || /* @__PURE__ */ React789.createElement(
    Default,
    {
      verticalAlign: verticalAlign2,
      title: leadingTitle,
      subtitle: leadingSubtitle,
      icon: leadingIcon,
      variant: "leading"
    }
  );
  trailing = trailing || /* @__PURE__ */ React789.createElement(
    Default,
    {
      verticalAlign: verticalAlign2,
      title: trailingTitle,
      subtitle: trailingSubtitle,
      icon: trailingIcon,
      textAlign: textAlignment === "flush" ? "right" : "left",
      variant: "trailing"
    }
  );
  return /* @__PURE__ */ React789.createElement(Flex, { px: spacingX === "wide" ? [0, 6] : 0, py: variant === "standard" ? 6 : 8, justifyContent: "space-between" }, /* @__PURE__ */ React789.createElement(Flex, { mr: "auto", flexDirection: "column", justifyContent: mapVerticalAlignToFlexAlign[verticalAlign2] }, leading), /* @__PURE__ */ React789.createElement(Flex, { flexDirection: "column", justifyContent: [mapVerticalAlignToFlexAlign[verticalAlign2]] }, trailing));
};
ListRow.Slot = Slot;
var StyledListRowContainer = styled32.div`
  :hover {
    cursor: pointer;
  }
  :focus {
    outline: 2px solid ${get("colors.bmtBlue")};
    outlineoffset: 1px;
  }
  &[data-whatintent='mouse']:focus {
    outline: none;
  }
`;
var ListRowButton = (props) => {
  const ref = useRef(null);
  const { buttonProps } = useButton({ ...props, elementType: "div" }, ref);
  return /* @__PURE__ */ React789.createElement(StyledListRowContainer, { ...buttonProps, ref }, /* @__PURE__ */ React789.createElement(ListRow, { ...props }));
};
ListRowButton.Slot = Slot;

// src/components/Loader.tsx
import React791 from "react";
import styled34 from "@emotion/styled";

// src/components/LoadingCircle.tsx
import React790 from "react";
import { keyframes as keyframes2 } from "@emotion/core";
import styled33 from "@emotion/styled";
var rotator = keyframes2`
  100% {
    transform: rotate(360deg);
  }
`;
var dash = keyframes2`
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89,200
    stroke-dashoffset: -124;
  }
`;
var Image = styled33.svg`
  animation: ${rotator} 1s linear infinite;
  display: inline-block;
  stroke: ${get("colors.bmtGrey60")};
`;
var Path = styled33.circle`
  stroke-width: 6;
  stroke: ${get("colors.bmtGrey20")};
  fill: none;
`;
var Spinner = styled33.circle`
  stroke-dasharray: 1, 300;
  stroke-dashoffset: 0;
  stroke-width: 6;
  fill: none;
  animation: ${dash} 2s ease-out infinite;
`;
var LoadingCircle = ({ size: size2 = 10 }) => {
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ React790.createElement(Image, { width: theme2.space[size2], height: theme2.space[size2], viewBox: "0 0 64 64" }, /* @__PURE__ */ React790.createElement("title", null, "Loading"), /* @__PURE__ */ React790.createElement(Path, { cx: "32", cy: "32", r: "28" }), /* @__PURE__ */ React790.createElement(Spinner, { cx: "32", cy: "32", r: "28" }));
};

// src/components/Loader.tsx
var Background = styled34.div`
  background: radial-gradient(${get("colors.bmtWhite")}e6, ${get("colors.bmtWhite")}80);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 300;
  display: flex;
  justify-content: center;
`;
var Loader = ({
  isLoading,
  className,
  children,
  ...props
}) => /* @__PURE__ */ React791.createElement(Box, { position: "relative", width: "100%" }, isLoading && /* @__PURE__ */ React791.createElement(Background, { className: className && `${className}` }, /* @__PURE__ */ React791.createElement(Flex, { justifyContent: "center", alignItems: "center", ...props }, /* @__PURE__ */ React791.createElement(LoadingCircle, null))), children);

// src/components/Modal.tsx
import "@reach/dialog/styles.css";
import React792 from "react";
import styled35 from "@emotion/styled";
import { DialogContent, DialogOverlay } from "@reach/dialog";
import { space as space3, width as width2 } from "styled-system";
var VARIANT_STYLES6 = {
  new: {
    background: "rgba(28, 30, 33, 0.8)",
    borderRadius: "8px"
  },
  legacy: {}
};
var ModalOverlay = styled35(DialogOverlay, { shouldForwardProp })`
  display: flex;
  z-index: ${get("zIndexes.modal")};
  ${space3}
  ${FLEX_CONTAINER}
  background: ${(props) => VARIANT_STYLES6[props.variant || "legacy"].background};
`;
var ModalContent = styled35(DialogContent, { shouldForwardProp })`
  && {
    ${space3}
    ${width2}
    position: relative;
    max-width: ${CONTENT_MAX_WIDTH};
    border-radius: ${(props) => VARIANT_STYLES6[props.variant || "legacy"].borderRadius};
  }
`;
var ActionContainer2 = styled35(Flex)`
  & button {
    margin-bottom: 0;
    margin-right: ${get("space.6")};
    min-width: 150px;

    @media screen and (max-width: ${get("breakpoints.0")}) {
      &:not(:last-child) {
        margin-bottom: ${get("space.6")};
      }
      margin-right: 0;
    }
  }
`;
var Modal = ({
  closeHandler,
  children,
  className,
  contentWidth,
  label,
  variant = "legacy",
  ...containerProps
}) => {
  const [heading, content, actions] = getSlots(["heading", "content", "actions"], children, "content");
  const defaultPadding = heading && content ? 9 : 0;
  return /* @__PURE__ */ React792.createElement(
    ModalOverlay,
    {
      onDismiss: closeHandler,
      className,
      alignItems: ["flex-end", "center"],
      justifyContent: "center",
      py: [0, "10vh"],
      variant,
      ...containerProps
    },
    /* @__PURE__ */ React792.createElement(
      ModalContent,
      {
        width: contentWidth ?? ["100%", "auto"],
        "aria-label": label,
        p: defaultPadding,
        variant,
        m: "auto"
      },
      /* @__PURE__ */ React792.createElement(CloseButton, { closeHandler }),
      heading && /* @__PURE__ */ React792.createElement(Heading, { variant: "secondary" }, heading),
      content || children,
      actions && /* @__PURE__ */ React792.createElement(ActionContainer2, { mt: "9", flexDirection: ["column", "row"] }, actions)
    )
  );
};
Modal.Slot = Slot;

// src/components/MultiSelect/MultiSelect.tsx
import React794 from "react";
import styled37 from "@emotion/styled";
import { useField as useField6 } from "formik";

// src/components/MultiSelect/hooks.ts
import {
  useMultipleSelection,
  useSelect as useSelect2
} from "downshift";
var getItemDisplayValue = (item) => item.text || item.value.toString();
var itemToString2 = (item) => item ? getItemDisplayValue(item) : "";
var optionToString = (option) => {
  if (!option) return "";
  switch (option.type) {
    case "item":
      return getItemDisplayValue(option.item);
    case "clearItemsOption":
      return "Clear items";
    default:
      return "";
  }
};
var useSelectCustomReducer = (state, actionsAndChanges) => {
  const { type, changes } = actionsAndChanges;
  switch (type) {
    case useSelect2.stateChangeTypes.ItemClick:
    case useSelect2.stateChangeTypes.ToggleButtonKeyDownEnter:
    case useSelect2.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
      return {
        ...changes,
        isOpen: state.isOpen,
        highlightedIndex: state.highlightedIndex
      };
    default:
      return changes;
  }
};
var CLEAR_ITEMS_OPTION = { type: "clearItemsOption" };
var useMultiSelect = ({
  items,
  values,
  onChange,
  labelText,
  disabled,
  onOpen,
  onClose
}) => {
  const initialSelectedItems = values ? items.filter((item) => values.includes(item.value)) : [];
  const useMultipleSelectionProps = {
    initialSelectedItems,
    itemToString: itemToString2,
    onSelectedItemsChange: (changes) => onChange && onChange(changes.selectedItems || [])
  };
  if (values) {
    const controlledSelectedItems = values.length && initialSelectedItems.length ? initialSelectedItems : [];
    useMultipleSelectionProps.selectedItems = controlledSelectedItems;
  }
  const { getDropdownProps, selectedItems, addSelectedItem, removeSelectedItem, reset } = useMultipleSelection(useMultipleSelectionProps);
  const options = [CLEAR_ITEMS_OPTION, ...items.map((i) => ({ item: i, type: "item" }))];
  const { getLabelProps, getToggleButtonProps, getItemProps, getMenuProps, isOpen, highlightedIndex, selectItem } = useSelect2({
    items: options,
    itemToString: optionToString,
    onSelectedItemChange: ({ selectedItem }) => {
      if (!selectedItem) return;
      switch (selectedItem.type) {
        case "item":
          if (selectedItems.map((i) => i.value).includes(selectedItem.item.value)) {
            removeSelectedItem(selectedItem.item);
          } else {
            addSelectedItem(selectedItem.item);
            selectItem("");
          }
          break;
        case "clearItemsOption":
          reset();
      }
    },
    stateReducer: useSelectCustomReducer,
    onIsOpenChange: (changes) => {
      if (changes.isOpen && onOpen) onOpen();
      if (!changes.isOpen && onClose) onClose();
    }
  });
  const labelProps = getLabelProps();
  const buttonLabelledBy = labelText ? labelProps.id : void 0;
  const menuLabelledBy = isOpen ? labelProps.id : void 0;
  const toggleButtonProps = getToggleButtonProps({
    ...getDropdownProps({ preventKeyAction: isOpen }),
    disabled,
    "aria-labelledby": buttonLabelledBy
  });
  const menuProps = getMenuProps({
    "aria-labelledby": menuLabelledBy,
    "aria-multiselectable": true,
    "aria-activedescendant": highlightedIndex > -1 ? getItemProps({
      index: highlightedIndex,
      item: options[highlightedIndex]
    }).id : void 0
  });
  return {
    getItemProps,
    highlightedIndex,
    options,
    selectedItems,
    isOpen,
    labelProps,
    toggleButtonProps,
    menuProps
  };
};

// src/components/MultiSelect/styled.tsx
import React793, { forwardRef as forwardRef7 } from "react";
import styled36 from "@emotion/styled";
var StyledDropdownButton2 = styled36(ReffableFlex)`
  appearance: none !important;

  &:hover {
    background-color: ${get("colors.bmtWhite")};

    &:disabled {
      background-color: ${get("colors.bmtGrey10")};
    }
  }

  &:active,
  &:focus {
    outline: 2px solid ${get("colors.bmtBlue")};

    svg {
      color: ${get("colors.bmtBlue")};
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 1 !important;
  }
`;
var DropdownButton2 = forwardRef7(({ children, ...rest }, ref) => /* @__PURE__ */ React793.createElement(StyledDropdownButton2, { ...rest, ref }, children));
var CLEAR_ITEMS_HEIGHT = 57;
var SELECTABLE_ITEM_HEIGHT = 40;
var HEIGHT_TO_PREVIEW_NEXT_ITEM = 32;
var List2 = styled36(ReffableBox)`
  list-style: none;
  overflow: scroll;
  position: absolute;
  max-height: ${(props) => CLEAR_ITEMS_HEIGHT + props.visibleItems * SELECTABLE_ITEM_HEIGHT + HEIGHT_TO_PREVIEW_NEXT_ITEM}px;
`;
var ListItem2 = styled36.li`
  ${COMMON}
  cursor: pointer;

  &[disabled] {
    background-color: ${get("colors.bmtGrey10")};
    color: ${get("colors.bmtGrey40")};
    cursor: not-allowed;
  }
`;
var CaretIcon2 = ({ className }) => /* @__PURE__ */ React793.createElement("svg", { width: "16", height: "16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className }, /* @__PURE__ */ React793.createElement("title", null, "Open"), /* @__PURE__ */ React793.createElement("polygon", { fill: "currentColor", points: "14.586 3.801 8.003 10.384 1.413 3.807 0 5.224 8.003 13.211 16 5.215" }));
var DropdownCaret2 = styled36(CaretIcon2)`
  color: ${({ disabled, invalid }) => disabled && get("colors.bmtGrey30") || invalid && get("colors.bmtOrange90") || get("colors.bmtGrey90")};
`;

// src/components/MultiSelect/MultiSelect.tsx
var defaultGetSelectDisplayValue = (items, labelText) => items.length === 1 ? getItemDisplayValue(items[0]) : `${items.length} ${labelText || "Items"}`;
var DropdownOptionText = styled37(Text)`
  white-space: nowrap;
`;
var DropdownOption = ({
  option,
  highlighted,
  labelId,
  selected,
  fieldName,
  otherProps
}) => {
  if (option.type === "item") {
    const { id } = otherProps;
    return /* @__PURE__ */ React794.createElement(
      ListItem2,
      {
        ...otherProps,
        px: "6",
        py: "3",
        bg: highlighted ? "bmtGrey20" : "transparent",
        color: highlighted ? "bmtBlue" : "bmtGrey60",
        "aria-selected": selected
      },
      /* @__PURE__ */ React794.createElement(Flex, { alignItems: "center" }, /* @__PURE__ */ React794.createElement(Box, { width: "1.6rem", height: "1.6rem", mt: "1px" }, /* @__PURE__ */ React794.createElement(
        CheckboxInput,
        {
          "aria-labelledby": `${labelId} ${id}--checkbox--label`,
          id: `${id}--checkbox`,
          name: fieldName,
          value: option.item.value,
          checked: selected,
          readOnly: true,
          tabIndex: -1,
          position: "static",
          m: "0"
        }
      )), /* @__PURE__ */ React794.createElement(DropdownOptionText, { id: `${id}--checkbox--label`, fontSize: "2", lineHeight: "2", ml: "6" }, getItemDisplayValue(option.item)))
    );
  }
  return /* @__PURE__ */ React794.createElement(
    ListItem2,
    {
      ...otherProps,
      px: "6",
      mb: "3",
      bg: highlighted ? "bmtGrey20" : "transparent",
      color: highlighted ? "bmtBlue" : "bmtGrey60",
      "aria-selected": false
    },
    /* @__PURE__ */ React794.createElement(Box, { py: "6", borderBottom: "1px solid", borderColor: "bmtGrey20" }, /* @__PURE__ */ React794.createElement(Button, { variant: "tertiary", fontSize: "2", lineHeight: "2" }, "Clear all"))
  );
};
var DropdownBase2 = ({
  disabled,
  labelText,
  invalid,
  fullWidth,
  visibleItems = 3,
  items,
  values,
  onChange,
  placeholder = "",
  name,
  getSelectDisplayValue,
  onOpen,
  onClose,
  ...rest
}) => {
  const { getItemProps, selectedItems, options, isOpen, highlightedIndex, labelProps, toggleButtonProps, menuProps } = useMultiSelect({ items, values, labelText, onChange, disabled, onOpen, onClose });
  const { theme: theme2 } = useTheme();
  const dropdownOptionProps = options.map((option, index) => {
    if (option.type === "item") {
      return {
        option,
        highlighted: index === highlightedIndex,
        selected: selectedItems.map((i) => i.value).includes(option.item.value),
        labelId: labelProps.id || "",
        fieldName: name,
        key: option.item.value,
        otherProps: getItemProps({
          index,
          item: option,
          disabled: option.item.disabled
        })
      };
    }
    return {
      option,
      highlighted: index === highlightedIndex,
      selected: false,
      labelId: labelProps.id || "",
      fieldName: name,
      key: "clearItemsOption",
      otherProps: getItemProps({
        index,
        item: option,
        disabled: false
      })
    };
  });
  const selectDisplayValue = getSelectDisplayValue ? getSelectDisplayValue(selectedItems) : defaultGetSelectDisplayValue(selectedItems, labelText);
  return /* @__PURE__ */ React794.createElement(
    Box,
    {
      position: isOpen ? "relative" : "static",
      zIndex: isOpen ? theme2.zIndexes.overlay : theme2.zIndexes.default,
      maxWidth: fullWidth ? "100%" : INPUT_MAX_WIDTH
    },
    labelText && /* @__PURE__ */ React794.createElement(Label, { ...labelProps }, labelText),
    /* @__PURE__ */ React794.createElement(
      DropdownButton2,
      {
        type: "button",
        alignItems: "center",
        bg: disabled ? "bmtGrey10" : "bmtWhite",
        border: "1px solid",
        borderColor: invalid ? "bmtOrange90" : "bmtGrey30",
        borderRadius: "3px",
        px: "6",
        py: "4",
        m: "0",
        width: "100%",
        justifyContent: "space-between",
        ...rest,
        ...toggleButtonProps,
        as: "button"
      },
      /* @__PURE__ */ React794.createElement(Flex.Item, { textAlign: "left" }, /* @__PURE__ */ React794.createElement(Text, { fontSize: "2", lineHeight: "2", fontWeight: "normal", color: disabled ? "bmtGrey40" : "bmtGrey90" }, selectedItems.length ? selectDisplayValue : placeholder)),
      /* @__PURE__ */ React794.createElement(DropdownCaret2, { invalid, disabled })
    ),
    /* @__PURE__ */ React794.createElement(
      List2,
      {
        as: "ul",
        m: "0",
        mt: isOpen ? 3 : 0,
        p: "0",
        visibleItems,
        minWidth: "100%",
        height: isOpen ? "auto" : 0,
        border: isOpen ? "1px solid" : "none",
        borderColor: "bmtGrey20",
        borderRadius: "3px",
        hidden: !isOpen,
        bg: "bmtWhite",
        ...menuProps
      },
      isOpen && dropdownOptionProps.map((optionProps) => /* @__PURE__ */ React794.createElement(DropdownOption, { ...optionProps }))
    )
  );
};
var MultiSelect = styled37(DropdownBase2)`
  ${COMMON}
`;
var FormikMultiSelect = ({
  name,
  validate,
  ...rest
}) => {
  const [, { value, error, touched }, { setValue, setTouched }] = useField6({ name, validate });
  return /* @__PURE__ */ React794.createElement(
    MultiSelect,
    {
      ...rest,
      name,
      values: value,
      invalid: touched && !!error,
      onChange: (items) => {
        if (rest.onChange) {
          rest.onChange(items);
        }
        void setValue(items.map((item) => item.value));
      },
      onClose: () => {
        if (rest.onClose) {
          rest.onClose();
        }
        void setTouched(true);
      }
    }
  );
};

// src/components/PasswordInput/PasswordInput.tsx
import React795, { useEffect, useMemo as useMemo2 } from "react";

// src/components/PasswordInput/dumb-zxcvbn.ts
var dumbZxcvbn = (password) => {
  const score = password.length < 8 ? 0 : 2;
  return {
    score,
    feedback: {
      suggestions: []
    }
  };
};

// src/components/PasswordInput/password-strength.ts
import { last } from "lodash";
var LABELS = {
  0: "Weak",
  1: "Weak",
  2: "Weak",
  3: "Weak",
  4: "Strong"
};
var COLORS = {
  0: "bmtOrange90",
  1: "bmtOrange90",
  2: "bmtOrange90",
  3: "bmtOrange90",
  4: theme.secondaryColors.green40
};
var getSuggestion = (password, result) => {
  if (password.length < 8) {
    return "Password should be a minimum of 8 characters";
  }
  let suggestion = last(result.feedback.suggestions) || "";
  if (suggestion === "Add another word or two. Uncommon words are better." || result.score === 3) {
    suggestion = "Consider a longer mix of upper/lowercase letters, numbers, and symbols";
  }
  return suggestion;
};
var getStrengthAssessment = (password, result) => {
  return {
    score: result.score,
    label: LABELS[result.score],
    color: COLORS[result.score],
    suggestion: getSuggestion(password, result)
  };
};

// src/components/PasswordInput/PasswordInput.tsx
var PasswordInput = ({
  strengthEstimator = dumbZxcvbn,
  onEstimation,
  ...props
}) => {
  if (strengthEstimator === dumbZxcvbn) {
    console.warn("You should use a stronger password checker, like https://github.com/dropbox/zxcvbn");
  }
  const { value = "" } = props;
  const result = useMemo2(() => strengthEstimator(value), [strengthEstimator, value]);
  const assessment = useMemo2(() => getStrengthAssessment(value, result), [value, result]);
  useEffect(() => {
    if (onEstimation) {
      onEstimation(assessment);
    }
  }, [onEstimation, assessment]);
  return /* @__PURE__ */ React795.createElement(React795.Fragment, null, /* @__PURE__ */ React795.createElement(TextInput, { ...props, type: "password" }), /* @__PURE__ */ React795.createElement(Text, { as: "p", color: "bmtGrey50", fontSize: "1" }, value ? /* @__PURE__ */ React795.createElement(Text, { color: assessment.color }, assessment.score === 4 ? `${assessment.label} Password` : assessment.suggestion || `${assessment.label} Password`) : assessment.suggestion));
};

// src/components/Picture.tsx
import React796, { forwardRef as forwardRef8 } from "react";
var Picture = forwardRef8(
  ({ src, type = "image/webp", width: width3, fallback, alt, isLazy, ...props }, ref) => {
    const loading = isLazy ? "lazy" : "eager";
    return /* @__PURE__ */ React796.createElement(ReffableBox, { as: "picture", ref }, /* @__PURE__ */ React796.createElement(Box, { as: "source", media: width3, srcSet: src, type }), /* @__PURE__ */ React796.createElement(
      Box,
      {
        as: "img",
        src: fallback,
        ...props,
        alt,
        width: width3,
        loading
      }
    ));
  }
);

// src/components/RadioInput.tsx
import React797 from "react";
import styled38 from "@emotion/styled";
import { useField as useField7 } from "formik";
var RadioItem = styled38(Text)`
  font-weight: 400;
  margin-bottom: 2px;
`;
var borderColor3 = ({ theme: theme2 }) => {
  if (theme2) {
    return theme2.colors.bmtGrey60;
  }
  return void 0;
};
var RadioInputBase = styled38(Base)`
  && {
    align-items: center;
    appearance: none;
    background: ${get("colors.bmtWhite")};
    border: 1px solid ${borderColor3};
    border-radius: 1rem;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: 18px;
    justify-content: center;
    margin: 0;
    opacity: 1;
    outline: none;
    pointer-events: auto;
    position: relative;
    width: 18px;

    &:after {
      background: ${get("colors.bmtWhite")};
      border-radius: 1rem;
      content: '';
      display: block;
      height: 6px;
      width: 6px;
    }

    &:checked {
      border-color: ${get("colors.bmtBlue")};
      background: ${get("colors.bmtBlue")};

      &:after {
        opacity: 1;
      }
    }

    &:disabled {
      border-color: ${get("colors.bmtGrey10")};
      cursor: not-allowed;

      &:checked {
        background: ${get("colors.bmtGrey30")};
        border-color: ${get("colors.bmtGrey30")};
      }
    }

    &:focus {
      box-shadow: 0 0 1px 2px ${get("colors.bmtBlue")};
    }

    ${COMMON}
    ${LAYOUT}
  }
`;
var RadioInput = ({
  checked,
  as = "input",
  ...rest
}) => /* @__PURE__ */ React797.createElement(RadioInputBase, { as, mr: "4", "aria-checked": checked, checked, ...rest, role: "radio", type: "radio" });
RadioInput.Item = RadioItem;
var FormikRadioInput = ({ name, ...rest }) => {
  const [field] = useField7({ name });
  return /* @__PURE__ */ React797.createElement(
    RadioInput,
    {
      ...field,
      ...rest,
      checked: field.value === rest.value,
      onChange: (event) => {
        if (rest.onChange) {
          rest.onChange(event);
        }
        field.onChange(event);
      }
    }
  );
};
FormikRadioInput.Item = RadioItem;

// src/components/SentryReportingErrorBoundary.tsx
import React798 from "react";
import * as Sentry from "@sentry/browser";
var SentryReportingErrorBoundary = class extends React798.Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  }
  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return /* @__PURE__ */ React798.createElement(GlobalErrorFallback, null);
    }
    return children;
  }
};

// src/components/StackedProgressBar.tsx
import React799 from "react";
import styled39 from "@emotion/styled";
var StackedBar = styled39(Flex)`
  background-color: ${({ bg, theme: theme2 }) => theme2.colors[bg] || theme2.colors.bmtGrey20};
  transition: width 0.3s ease-out;
  will-change: width;
  overflow: hidden;
  gap: 2px;
`;
var StackedProgressBar = ({ percents = [], ...rest }) => {
  if (percents.length === 0) {
    return /* @__PURE__ */ React799.createElement(ProgressBar, { percent: 0, ...rest });
  }
  return /* @__PURE__ */ React799.createElement(StackedBar, { borderRadius: BORDER_RADIUS, ...rest }, percents.map((percent, index) => /* @__PURE__ */ React799.createElement(
    Box,
    {
      key: index,
      bg: percent.indicatorColor,
      height: 16,
      width: percent.percent / 100,
      role: "progressbar",
      "aria-valuenow": percent.percent,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }
  )));
};

// src/components/TabularNumber.tsx
import styled40 from "@emotion/styled";
var TabularNumber = styled40(Text)`
  font-variant-numeric: tabular-nums;
`;

// src/components/Tag.tsx
import "react";
import styled41 from "@emotion/styled";
var handleFontSize = (size2) => {
  if (!size2 || size2 === "small") return get("fontSizes.0")("small");
  return get("fontSizes.1")("large");
};
var Tag = styled41(Text)`
  background-color: ${({ bg, theme: theme2 }) => theme2.colors[bg] || theme2.colors.bmtBlue10};
  border-radius: ${(props) => props.rounded ? "100px" : "3px"};
  color: ${get("colors.bmtGrey90")};
  display: inline-block;
  font-size: ${({ size: size2 }) => handleFontSize(size2)};
  padding: ${get("space.1")} ${get("space.3")};
  text-transform: ${(props) => props.uppercase ? "uppercase" : ""};
  white-space: nowrap;
`;
Tag.displayName = "Tag";

// src/components/ToggleSwitch.tsx
import React801 from "react";
import styled42 from "@emotion/styled";
import { useField as useField8 } from "formik";
var Switch = styled42.label`
  position: relative;
  display: inline-flex;
  align-items: center;
`;
var Input = styled42.input`
  opacity: 0;
  width: 0;
  height: 0;

  :focus + div .slider {
    outline: 2px solid ${get("colors.bmtBlue")};
    outline-offset: 1px;
  }

  :checked + div > .slider {
    background-color: ${(props) => props.color};
  }

  :checked + div .slider:before {
    transform: translateX(${({ sliderSize }) => sliderSize === "medium" ? "26px" : "16px"});
    box-shadow: 0 0 1px ${(props) => props.color};
  }
`;
var Slider = styled42.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 100px;
  background-color: ${({ theme: theme2 }) => theme2.colors.bmtGrey60};
  transition: 0.3s;

  :before {
    border-radius: 50%;
    position: absolute;
    content: '';
    height: ${({ size: size2 }) => size2 === "medium" ? "26px" : "20px"};
    width: ${({ size: size2 }) => size2 === "medium" ? "26px" : "20px"};
    left: ${({ size: size2 }) => size2 === "medium" ? "4px" : "2px"};
    bottom: ${({ size: size2 }) => size2 === "medium" ? "4px" : "2px"};
    background-color: ${get("colors.bmtWhite")};
    transition: 0.3s;
  }
`;
var ToggleSwitch = ({
  name,
  labelText,
  color: color2 = "bmtBlue",
  size: size2 = "medium",
  ...rest
}) => {
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ React801.createElement(Switch, { htmlFor: name, id: `${name}-toggle-label` }, /* @__PURE__ */ React801.createElement(
    Input,
    {
      type: "checkbox",
      id: name,
      color: theme2.colors[color2],
      "aria-labelledby": `${name}-toggle-label`,
      sliderSize: size2,
      ...rest
    }
  ), /* @__PURE__ */ React801.createElement(
    Box,
    {
      position: "relative",
      display: "inline-block",
      height: size2 === "medium" ? "34px" : "24px",
      width: size2 === "medium" ? "60px" : "40px",
      mr: labelText ? "4" : "0"
    },
    /* @__PURE__ */ React801.createElement(Slider, { className: "slider", size: size2 })
  ), labelText);
};
var FormikToggle = ({ name, ...rest }) => {
  const [field] = useField8({ name });
  return /* @__PURE__ */ React801.createElement(ToggleSwitch, { ...field, ...rest, value: field.value.toString(), checked: field.value });
};

// src/components/Tooltip.tsx
import React802 from "react";
import styled43 from "@emotion/styled";
import "@reach/tooltip/styles.css";
import ReachTooltip from "@reach/tooltip";
var centerTooltip = (triggerRect, tooltipRect) => {
  if (!triggerRect) return {};
  if (!tooltipRect) return {};
  const triggerCenter = triggerRect.left + triggerRect.width / 2;
  const left2 = triggerCenter - tooltipRect.width / 2;
  const maxLeft = window.innerWidth - tooltipRect.width - 2;
  const x = Math.min(Math.max(2, left2), maxLeft) + window.scrollX;
  const y = triggerRect.bottom + 8 + window.scrollY;
  return { left: x, top: y };
};
var StyledTooltip = styled43(ReachTooltip)`
  background-color: ${get("colors.bmtGrey60")};
  border-radius: 0.2rem;
  border-color: ${get("colors.bmtGrey60")};
  color: ${get("colors.bmtWhite")};
  font-size: ${get("fontSizes.1")};
  line-height: ${get("lineHeights.1")};
  max-width: ${TOOLTIP_MAX_WIDTH};
  padding: ${get("space.6")};
  white-space: normal;
  z-index: 300;
`;
var Trigger = styled43.button`
  background-color: transparent;
  border: none;
  cursor: default;
  padding: 0;
  margin: 0;
  min-width: 0;
  display: flex;

  &:hover {
    background-color: transparent;
  }
`;
var Tooltip = ({ label, children, ...rest }) => {
  const triggerRef = React802.useRef(null);
  const handleTouchEnd = (event) => {
    if (triggerRef.current) {
      event.preventDefault();
      event.stopPropagation();
      triggerRef.current.click();
      triggerRef.current.focus();
    }
  };
  return /* @__PURE__ */ React802.createElement(StyledTooltip, { label, position: centerTooltip }, /* @__PURE__ */ React802.createElement(ReffableBox, { as: "span", ...rest, onTouchEnd: handleTouchEnd }, /* @__PURE__ */ React802.createElement(Trigger, { "aria-label": label, type: "button", ref: triggerRef }, children)));
};

// src/components/Typist/Typist.tsx
import React805, { Component as Component2 } from "react";

// src/components/Typist/Controls.tsx
import React803 from "react";
var ACTION_CHARS = ["\u{1F519}", "\u23F0"];
var Backspace = () => /* @__PURE__ */ React803.createElement("noscript", null);
Backspace.defaultProps = {
  count: 1,
  delay: 0
};
var Delay = () => /* @__PURE__ */ React803.createElement("noscript", null);

// src/components/Typist/Cursor.tsx
import { Component } from "react";
import { css, jsx as jsx2, keyframes as keyframes3 } from "@emotion/core";
var blink = keyframes3`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
var blinkStyle = css`
  display: inline-block;
  opacity: 1;
  animation: ${blink} 1s linear infinite;
`;
var baseStyle = css`
  display: inline-block;
`;
var Cursor = class extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "isReRenderingCursor", false);
    this.state = {
      shouldRender: props.show
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isDone, hideWhenDone, hideWhenDoneDelay } = this.props;
    const shouldHide = !isDone && nextProps.isDone && hideWhenDone;
    if (shouldHide) {
      setTimeout(() => this.setState({ shouldRender: false }), hideWhenDoneDelay);
    }
  }
  componentDidUpdate() {
    const { show, isDone } = this.props;
    if (!show) {
      return;
    }
    if (isDone) {
      return;
    }
    if (this.isReRenderingCursor) {
      return;
    }
    this.reRenderCursor();
  }
  reRenderCursor() {
    this.isReRenderingCursor = true;
    this.setState({ shouldRender: false }, () => {
      this.setState({ shouldRender: true }, () => {
        this.isReRenderingCursor = false;
      });
    });
  }
  render() {
    const { blink: shouldBlink, element } = this.props;
    const { shouldRender } = this.state;
    if (shouldRender) {
      return /* @__PURE__ */ jsx2("span", { css: shouldBlink ? blinkStyle : baseStyle }, element);
    }
    return null;
  }
};
__publicField(Cursor, "defaultProps", {
  blink: true,
  show: true,
  element: "|",
  hideWhenDone: false,
  hideWhenDoneDelay: 1e3,
  isDone: false
});

// src/components/Typist/utils.tsx
import React804 from "react";
function isElementType(element, component) {
  if (!React804.isValidElement(element)) {
    return false;
  }
  const elementType = element && element.type;
  if (!elementType) {
    return false;
  }
  return elementType === component;
}
function exclude(obj, keys) {
  const res = {};
  Object.keys(obj).forEach((key) => {
    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  });
  return res;
}
function cloneElement(element, children) {
  const tag = element.type;
  const props = exclude(element.props, ["children"]);
  const getMilliseconds = (/* @__PURE__ */ new Date()).getUTCMilliseconds();
  const randomStamp = getMilliseconds + Math.random() + Math.random();
  props.key = `Typist-element-${tag.toString()}-${randomStamp}`;
  return React804.createElement(tag, props, ...children);
}
function cloneElementWithSpecifiedTextAtIndex(element, textLines, textIdx, traverseChildren) {
  if (textIdx >= textLines.length) {
    return [null, textIdx];
  }
  let idx = textIdx;
  const recurse = (el) => {
    const [child, advIdx] = cloneElementWithSpecifiedTextAtIndex(el, textLines, idx, traverseChildren);
    idx = advIdx;
    return child;
  };
  if (React804.isValidElement(element) && traverseChildren(element)) {
    const el = element;
    const clonedChildren = React804.Children.map(el.props.children, recurse) || [];
    return [cloneElement(el, clonedChildren), idx];
  }
  if (Array.isArray(element)) {
    const children = element.map(recurse);
    return [children, idx];
  }
  return [textLines[idx], idx + 1];
}
var isBackspaceElement = (node) => isElementType(node, Backspace);
var isDelayElement = (node) => isElementType(node, Delay);
var isControlElement = (node) => isBackspaceElement(node) || isDelayElement(node);
var cloneElementWithSpecifiedText = (element, textLines) => {
  if (element) {
    return cloneElementWithSpecifiedTextAtIndex(element, textLines, 0, (node) => !isControlElement(node))[0];
  }
  return null;
};
function extractTextFromElement(element) {
  const stack = element ? [element] : [];
  const lines = [];
  while (stack.length > 0) {
    const current = stack.pop();
    if (React804.isValidElement(current)) {
      const el = current;
      if (isControlElement(current)) {
        lines.unshift(current);
      } else {
        React804.Children.forEach(el.props.children, (child) => {
          stack.push(child);
        });
      }
    } else if (Array.isArray(current)) {
      stack.push(...current);
    } else if (current) {
      lines.unshift(current.toString());
    }
  }
  return lines;
}
function sleep(val) {
  return new Promise((resolve) => {
    if (val != null) {
      setTimeout(resolve, val);
    } else {
      resolve();
    }
  });
}
function gaussianRnd(mean, std) {
  const times = 12;
  let sum = 0;
  for (let idx = 0; idx < times; idx += 1) {
    sum += Math.random();
  }
  sum -= times / 2;
  return Math.round(sum * std) + mean;
}
function eachPromise(arr, iterator, ...extraArgs) {
  return Array.from(arr).reduce(
    (prev, current, idx) => prev.then(() => iterator(current, idx, ...extraArgs)),
    // eslint-disable-line @typescript-eslint/no-unsafe-argument
    Promise.resolve()
  );
}

// src/components/Typist/Typist.tsx
var Typist = class extends Component2 {
  constructor(props) {
    super(props);
    __publicField(this, "onTypingDone", () => {
      if (!this.mounted) {
        return;
      }
      const { onTypingDone } = this.props;
      this.setState({ isDone: true });
      if (onTypingDone) onTypingDone();
    });
    __publicField(this, "mounted", false);
    __publicField(this, "linesToType", []);
    __publicField(this, "introducedDelay");
    __publicField(this, "delayGenerator", () => {
      const { avgTypingDelay: mean, stdTypingDelay: std } = this.props;
      return gaussianRnd(mean, std);
    });
    __publicField(this, "typeLine", (line, lineIdx) => {
      if (!this.mounted) {
        return Promise.resolve();
      }
      let decoratedLine;
      if (isBackspaceElement(line)) {
        const backspaceEl = line;
        if (backspaceEl.props.delay && backspaceEl.props.delay > 0) {
          this.introducedDelay = backspaceEl.props.delay;
        }
        decoratedLine = String("\u{1F519}").repeat(backspaceEl.props.count || 1);
      } else if (isDelayElement(line)) {
        const delayEl = line;
        this.introducedDelay = delayEl.props.ms;
        decoratedLine = "\u23F0";
      } else {
        decoratedLine = line;
      }
      const { textLines } = this.state;
      return new Promise((resolve, reject) => {
        this.setState({ textLines: textLines.concat([""]) }, () => {
          eachPromise(decoratedLine, this.typeCharacter, lineIdx).then(resolve).catch(reject);
        });
      });
    });
    __publicField(this, "typeCharacter", (character, _charIdx, lineIdx) => {
      if (!this.mounted) {
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        const { textLines: currentTextLines } = this.state;
        const textLines = currentTextLines.slice();
        void sleep(this.introducedDelay).then(() => {
          this.introducedDelay = void 0;
          const isBackspace = character === "\u{1F519}";
          const isDelay = character === "\u23F0";
          if (isDelay) {
            resolve();
            return;
          }
          if (isBackspace && lineIdx > 0) {
            let prevLineIdx = lineIdx - 1;
            let prevLine = textLines[prevLineIdx];
            if (prevLine) {
              for (let idx = prevLineIdx; idx >= 0; idx -= 1) {
                if (prevLine.length > 0 && !ACTION_CHARS.includes(prevLine[0])) {
                  break;
                }
                prevLineIdx = idx;
                prevLine = textLines[prevLineIdx];
              }
              textLines[prevLineIdx] = prevLine.substr(0, prevLine.length - 1);
            }
          } else {
            textLines[lineIdx] += character;
          }
          this.setState({ textLines }, () => {
            setTimeout(resolve, this.delayGenerator());
          });
        });
      });
    });
    if (props.children) {
      this.linesToType = extractTextFromElement(props.children);
    }
    this.state = {
      textLines: [],
      isDone: false
    };
  }
  componentDidMount() {
    this.mounted = true;
    const { children, startDelay } = this.props;
    if (children) {
      if (startDelay > 0 && typeof window !== "undefined") {
        setTimeout(this.typeAllLines.bind(this), startDelay);
      } else {
        void this.typeAllLines();
      }
    } else {
      this.onTypingDone();
    }
  }
  shouldComponentUpdate(_nextProps, nextState) {
    const { textLines, isDone } = this.state;
    if (nextState.textLines.length !== textLines.length) {
      return true;
    }
    for (let idx = 0; idx < nextState.textLines.length; idx += 1) {
      const line = textLines[idx];
      const nextLine = nextState.textLines[idx];
      if (line !== nextLine) {
        return true;
      }
    }
    return isDone !== nextState.isDone;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  typeAllLines() {
    return eachPromise(this.linesToType, this.typeLine).then(() => this.onTypingDone());
  }
  render() {
    const { className, cursor, children } = this.props;
    const { isDone, textLines } = this.state;
    const innerTree = cloneElementWithSpecifiedText(children, textLines);
    return /* @__PURE__ */ React805.createElement("div", { className: `Typist ${className || ""}` }, innerTree, /* @__PURE__ */ React805.createElement(Cursor, { isDone, ...cursor }));
  }
};
__publicField(Typist, "defaultProps", {
  className: "",
  avgTypingDelay: 70,
  stdTypingDelay: 25,
  startDelay: 0,
  cursor: {},
  onTypingDone: () => {
  }
});
__publicField(Typist, "Backspace", Backspace);
__publicField(Typist, "Delay", Delay);

// src/components/WorkflowCard.tsx
import React806 from "react";
var WorkflowCard = ({
  children,
  variant = "standard",
  ...boxProps
}) => {
  const padding = variant === "standard" ? 8 : 4;
  return /* @__PURE__ */ React806.createElement(
    Box,
    {
      bg: "bmtWhite",
      borderRadius: "4px",
      border: ["none", "1px solid"],
      borderColor: [null, "bmtGrey20"],
      p: [0, padding],
      ...boxProps
    },
    children
  );
};

// src/components/WorkflowLayout.tsx
import React807 from "react";
var WorkflowLayout = ({
  children,
  title,
  logo = /* @__PURE__ */ React807.createElement(BettermentLogo, null),
  footer,
  progressPercent,
  handleBackButton,
  closeHandler
}) => {
  const { theme: theme2 } = useTheme();
  let [slot1, slot2] = React807.Children.toArray(children);
  if (!slot2 && slot1.type === React807.Fragment) {
    [slot1, slot2] = React807.Children.toArray(slot1.props.children);
  }
  return /* @__PURE__ */ React807.createElement(SiteLayout, null, /* @__PURE__ */ React807.createElement(SiteLayout.Header, null, /* @__PURE__ */ React807.createElement(SectionLayout, { py: "0", bg: "bmtWhite" }, /* @__PURE__ */ React807.createElement(SectionLayout.ContentWrapper, null, /* @__PURE__ */ React807.createElement(React807.Fragment, null, /* @__PURE__ */ React807.createElement(TakeoverHeader, { title, logo, closeHandler }), progressPercent !== void 0 && /* @__PURE__ */ React807.createElement(ProgressBar, { percent: progressPercent, rounded: false, indicatorColor: "bmtGrey60" }))))), /* @__PURE__ */ React807.createElement(SiteLayout.Main, null, /* @__PURE__ */ React807.createElement(Flex.Item, { bg: "bmtWhite", flex: 1 }, /* @__PURE__ */ React807.createElement(SectionLayout, { bg: "bmtWhite", py: "9" }, /* @__PURE__ */ React807.createElement(SectionLayout.ContentWrapper, null, /* @__PURE__ */ React807.createElement(ContentLayoutA, null, /* @__PURE__ */ React807.createElement(ContentLayoutA.Slot3, null, handleBackButton && /* @__PURE__ */ React807.createElement(BackLink, { onClick: handleBackButton })), /* @__PURE__ */ React807.createElement(ContentLayoutA.Slot1, { px: [0, theme2.space[8]] }, slot1), /* @__PURE__ */ React807.createElement(ContentLayoutA.Slot2, { px: [0, theme2.space[8]] }, slot2)))))), /* @__PURE__ */ React807.createElement(SiteLayout.Footer, null, /* @__PURE__ */ React807.createElement(SectionLayout, { bg: "bmtWhite", py: "9" }, /* @__PURE__ */ React807.createElement(SectionLayout.ContentWrapper, null, footer))));
};
WorkflowLayout.Slot = function({ children }) {
  return /* @__PURE__ */ React807.createElement(React807.Fragment, null, children);
};

// src/styles/BaseStyles.tsx
import React808 from "react";
import { Global, css as css2 } from "@emotion/core";

// src/fonts/gt-america/GT-America-Compressed-Bold.woff
var GT_America_Compressed_Bold_default = "./GT-America-Compressed-Bold-NXRSIMTV.woff";

// src/fonts/gt-america/GT-America-Extended-Regular-Italic.woff
var GT_America_Extended_Regular_Italic_default = "./GT-America-Extended-Regular-Italic-S6NGYUPW.woff";

// src/fonts/gt-america/GT-America-Extended-Regular.woff
var GT_America_Extended_Regular_default = "./GT-America-Extended-Regular-PPXJQWEJ.woff";

// src/fonts/gt-america/GT-America-Standard-Bold-Italic.woff
var GT_America_Standard_Bold_Italic_default = "./GT-America-Standard-Bold-Italic-NTXDSIPO.woff";

// src/fonts/gt-america/GT-America-Standard-Bold.woff
var GT_America_Standard_Bold_default = "./GT-America-Standard-Bold-BPTWOPUN.woff";

// src/fonts/gt-america/GT-America-Standard-Light-Italic.woff
var GT_America_Standard_Light_Italic_default = "./GT-America-Standard-Light-Italic-CT4B2RAN.woff";

// src/fonts/gt-america/GT-America-Standard-Light.woff
var GT_America_Standard_Light_default = "./GT-America-Standard-Light-LHBY7MZZ.woff";

// src/fonts/gt-america/GT-America-Standard-Medium-Italic.woff
var GT_America_Standard_Medium_Italic_default = "./GT-America-Standard-Medium-Italic-O7ATDRU4.woff";

// src/fonts/gt-america/GT-America-Standard-Medium.woff
var GT_America_Standard_Medium_default = "./GT-America-Standard-Medium-GUX3PML4.woff";

// src/fonts/gt-america/GT-America-Standard-Regular-Italic.woff
var GT_America_Standard_Regular_Italic_default = "./GT-America-Standard-Regular-Italic-HFF5P3BO.woff";

// src/fonts/gt-america/GT-America-Standard-Regular.woff
var GT_America_Standard_Regular_default = "./GT-America-Standard-Regular-VPB6PVM2.woff";

// src/styles/BaseStyles.tsx
var BaseStyles = () => {
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ React808.createElement(
    Global,
    {
      styles: css2`
        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: normal;
          font-weight: 300;
          src:
            local('GT America'),
            url('${GT_America_Standard_Light_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: italic;
          font-weight: 300;
          src:
            local('GT America'),
            url('${GT_America_Standard_Light_Italic_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: normal;
          font-weight: 500;
          src:
            local('GT America'),
            url('${GT_America_Standard_Regular_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: italic;
          font-weight: 500;
          src:
            local('GT America'),
            url('${GT_America_Standard_Regular_Italic_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: normal;
          font-weight: 600;
          src:
            local('GT America'),
            url('${GT_America_Standard_Medium_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: italic;
          font-weight: 600;
          src:
            local('GT America'),
            url('${GT_America_Standard_Medium_Italic_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: normal;
          font-weight: 700;
          src:
            local('GT America'),
            url('${GT_America_Standard_Bold_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America';
          font-style: italic;
          font-weight: 700;
          src:
            local('GT America'),
            url('${GT_America_Standard_Bold_Italic_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America Compressed';
          font-style: normal;
          font-weight: 700;
          src:
            local('GT America Compressed'),
            url('${GT_America_Compressed_Bold_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America Extended';
          font-style: normal;
          font-weight: 500;
          src:
            local('GT America Extended'),
            url('${GT_America_Extended_Regular_default}') format('woff');
        }

        @font-face {
          font-display: swap;
          font-family: 'GT America Extended';
          font-style: italic;
          font-weight: 500;
          src:
            local('GT America Extended'),
            url('${GT_America_Extended_Regular_Italic_default}') format('woff');
        }

        html {
          font-size: 10px;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          box-sizing: border-box;
        }

        * {
          &,
          &:before,
          &:after {
            box-sizing: inherit;
          }
        }

        body {
          background-color: ${theme2.colors.bmtGrey10};
          margin: 0;
          font-family: ${theme2.fonts.sans};
          font-size: ${theme2.fontSizes[2]};
          font-variant-numeric: tabular-nums;
        }

        html {
          line-height: 1.15;
          -ms-text-size-adjust: 100%;
          -webkit-text-size-adjust: 100%;
        }
        article,
        aside,
        footer,
        header,
        nav,
        section {
          display: block;
        }
        h1 {
          font-size: 2em;
          margin: 0.67em 0;
        }
        figcaption,
        figure,
        main {
          display: block;
        }
        figure {
          margin: 1em 40px;
        }
        hr {
          box-sizing: content-box;
          height: 0;
          overflow: visible;
        }
        pre {
          font-family: monospace, monospace;
          font-size: 1em;
        }
        a {
          background-color: transparent;
          -webkit-text-decoration-skip: objects;
        }
        abbr[title] {
          border-bottom: none;
          text-decoration: underline;
          text-decoration: underline dotted;
        }
        b,
        strong {
          font-weight: ${theme2.fontWeights.medium};
        }
        b,
        strong {
          font-weight: ${theme2.fontWeights.medium};
        }
        code,
        kbd,
        samp {
          font-family: monospace, monospace;
          font-size: 1em;
        }
        dfn {
          font-style: italic;
        }
        mark {
          background-color: #ff0;
          color: #000;
        }
        small {
          font-size: 80%;
        }
        sub,
        sup {
          font-size: 75%;
          line-height: 0;
          position: relative;
          vertical-align: baseline;
        }
        sub {
          bottom: -0.25em;
        }
        sup {
          top: -0.5em;
        }
        audio,
        video {
          display: inline-block;
        }
        audio:not([controls]) {
          display: none;
          height: 0;
        }
        img {
          border-style: none;
        }
        svg:not(:root) {
          overflow: hidden;
        }
        button,
        input,
        optgroup,
        select,
        textarea {
          margin: 0;
        }
        button,
        input {
          font-variant-numeric: tabular-nums;
          overflow: visible;
        }
        button,
        select {
          text-transform: none;
        }
        [type='reset'],
        [type='submit'],
        button,
        html [type='button'] {
          -webkit-appearance: button;
        }
        [type='button']::-moz-focus-inner,
        [type='reset']::-moz-focus-inner,
        [type='submit']::-moz-focus-inner,
        button::-moz-focus-inner {
          border-style: none;
          padding: 0;
        }
        [type='button']:-moz-focusring,
        [type='reset']:-moz-focusring,
        [type='submit']:-moz-focusring,
        [type='text'] {
          font-variant-numeric: tabular-nums;
        }
        button:-moz-focusring {
          outline: 1px dotted ButtonText;
        }
        legend {
          box-sizing: border-box;
          color: inherit;
          display: table;
          max-width: 100%;
          padding: 0;
          white-space: normal;
        }
        progress {
          display: inline-block;
          vertical-align: baseline;
        }
        textarea {
          overflow: auto;
        }
        [type='checkbox'],
        [type='radio'] {
          box-sizing: border-box;
          padding: 0;
        }
        [type='number']::-webkit-inner-spin-button,
        [type='number']::-webkit-outer-spin-button {
          height: auto;
        }
        [type='search'] {
          -webkit-appearance: textfield;
          outline-offset: -2px;
        }
        [type='search']::-webkit-search-cancel-button,
        [type='search']::-webkit-search-decoration {
          -webkit-appearance: none;
        }
        ::-webkit-file-upload-button {
          -webkit-appearance: button;
          font: inherit;
        }
        details,
        menu {
          display: block;
        }
        summary {
          display: list-item;
        }
        canvas {
          display: inline-block;
        }
        template {
          display: none;
        }
        [hidden] {
          display: none;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p {
          margin-top: 0;
        }

        // REPRO: style-closet-react samba-react CSS collision
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          font-weight: ${theme2.fontWeights.medium};
        }
      `
    }
  );
};
export {
  ActionCard,
  BORDER,
  BORDER_COLOR,
  BORDER_RADIUS,
  BackLink,
  Base,
  BaseStyles,
  BettermentAtWorkLogo,
  BettermentForAdvisorsLogo,
  BettermentLogo,
  Box,
  Button,
  COMMON,
  CONTENT_GRID_CONTAINER_MX,
  CONTENT_GRID_ITEM_PX,
  CONTENT_MAX_WIDTH,
  CONTENT_MIN_WIDTH,
  Card2 as Card,
  CenteredWorkflowLayout,
  CheckboxInput,
  CloseButton,
  ContentGrid,
  ContentLayoutA,
  ContentLayoutB,
  ContentLayoutC,
  ContentLayoutE,
  ContentWrapper,
  DateInput,
  Dropdown,
  ErrorFallback,
  ErrorText,
  FLEX_CONTAINER,
  FLEX_ITEM,
  Faq,
  FeatureAgingParentsSunset24,
  FeatureAgingParentsSunset48,
  FeatureAgingParentsSunset72,
  FeatureArrowCircle24,
  FeatureArrowCircle48,
  FeatureArrowCircle72,
  FeatureArrowCircleCheckmark24,
  FeatureArrowCircleCheckmark48,
  FeatureArrowCircleCheckmark72,
  FeatureArrowCircleMinus24,
  FeatureArrowCircleMinus48,
  FeatureArrowCircleMinus72,
  FeatureArrowCirclePlus24,
  FeatureArrowCirclePlus48,
  FeatureArrowCirclePlus72,
  FeatureArrowDown,
  FeatureAtmCard24,
  FeatureAtmCard48,
  FeatureAtmCard72,
  FeatureAtmCash24,
  FeatureAtmCash48,
  FeatureAtmCash72,
  FeatureAward,
  FeatureBag,
  FeatureBalance24,
  FeatureBalance48,
  FeatureBalance72,
  FeatureBank,
  FeatureBank24,
  FeatureBank48,
  FeatureBank72,
  FeatureBar24,
  FeatureBar48,
  FeatureBar72,
  FeatureBeachUmbrella24,
  FeatureBeachUmbrella48,
  FeatureBeachUmbrella72,
  FeatureBills24,
  FeatureBills48,
  FeatureBills72,
  FeatureBoat24,
  FeatureBoat48,
  FeatureBoat72,
  FeatureBook,
  FeatureBriefcase24,
  FeatureBriefcase48,
  FeatureBriefcase72,
  FeatureBriefcaseAlt24,
  FeatureBriefcaseAlt48,
  FeatureBriefcaseAlt72,
  FeatureBrowser,
  FeatureBrowser24,
  FeatureBrowser48,
  FeatureBrowser72,
  FeatureBuildWealth,
  FeatureBuilding24,
  FeatureBuilding48,
  FeatureBuilding72,
  FeatureBuildings24,
  FeatureBuildings48,
  FeatureBuildings72,
  FeatureBullet24,
  FeatureBullet48,
  FeatureBullet72,
  FeatureBulletOutline24,
  FeatureBulletOutline48,
  FeatureBulletOutline72,
  FeatureCalculator24,
  FeatureCalculator48,
  FeatureCalculator72,
  FeatureCalendar,
  FeatureCalendar24,
  FeatureCalendar48,
  FeatureCalendar72,
  FeatureCamera24,
  FeatureCamera48,
  FeatureCamera72,
  FeatureCancel24,
  FeatureCancel48,
  FeatureCancel72,
  FeatureCar24,
  FeatureCar48,
  FeatureCar72,
  FeatureCarAlt24,
  FeatureCarAlt48,
  FeatureCarAlt72,
  FeatureCard24,
  FeatureCard48,
  FeatureCard72,
  FeatureCaretDown24,
  FeatureCaretDown48,
  FeatureCaretDown72,
  FeatureCaretLeft24,
  FeatureCaretLeft48,
  FeatureCaretLeft72,
  FeatureCaretRight24,
  FeatureCaretRight48,
  FeatureCaretRight72,
  FeatureCaretUp24,
  FeatureCaretUp48,
  FeatureCaretUp72,
  FeatureCash24,
  FeatureCash48,
  FeatureCash72,
  FeatureCharity24,
  FeatureCharity48,
  FeatureCharity72,
  FeatureCharityHand24,
  FeatureCharityHand48,
  FeatureCharityHand72,
  FeatureChat,
  FeatureChat24,
  FeatureChat48,
  FeatureChat72,
  FeatureChatTwo,
  FeatureCheckBack24,
  FeatureCheckBack48,
  FeatureCheckBack72,
  FeatureCheckFront24,
  FeatureCheckFront48,
  FeatureCheckFront72,
  FeatureCheckFrontWithSignature24,
  FeatureCheckFrontWithSignature48,
  FeatureCheckFrontWithSignature72,
  FeatureCheckmark,
  FeatureCheckmark24,
  FeatureCheckmark48,
  FeatureCheckmark72,
  FeatureCheckmarkFilledCircle48,
  FeatureCheckmarkFilledCircle72,
  FeatureCheckmarkInCircle24,
  FeatureCheckmarkInCircle48,
  FeatureCheckmarkInCircle72,
  FeatureCheckmarkInFilledCircle24,
  FeatureChildren24,
  FeatureChildren48,
  FeatureChildren72,
  FeatureCircle24,
  FeatureCircle48,
  FeatureCircle72,
  FeatureCircleArrows,
  FeatureCircleArrowsPlus,
  FeatureClock,
  FeatureCompass24,
  FeatureCompass48,
  FeatureCompass72,
  FeatureCopy24,
  FeatureCopy48,
  FeatureCopy72,
  FeatureDeposit24,
  FeatureDeposit48,
  FeatureDeposit72,
  FeatureDepositCheck24,
  FeatureDepositCheck48,
  FeatureDepositCheck72,
  FeatureDining24,
  FeatureDining48,
  FeatureDining72,
  FeatureDirectDeposit24,
  FeatureDirectDeposit48,
  FeatureDirectDeposit72,
  FeatureDocument24,
  FeatureDocument48,
  FeatureDocument72,
  FeatureDocumentComplete24,
  FeatureDocumentComplete48,
  FeatureDocumentComplete72,
  FeatureDocumentFilled24,
  FeatureDocumentFilled48,
  FeatureDocumentFilled72,
  FeatureDocumentPlus24,
  FeatureDocumentPlus48,
  FeatureDocumentPlus72,
  FeatureDocumentReview24,
  FeatureDocumentReview48,
  FeatureDocumentReview72,
  FeatureDocuments24,
  FeatureDocuments48,
  FeatureDocuments72,
  FeatureDollar,
  FeatureDollar24,
  FeatureDollar48,
  FeatureDollar72,
  FeatureDollarInCircle24,
  FeatureDollarInCircle48,
  FeatureDollarInCircle72,
  FeatureDonut,
  FeatureDonut24,
  FeatureDonut48,
  FeatureDonut72,
  FeatureDown24,
  FeatureDown48,
  FeatureDown72,
  FeatureDownArrowSmall24,
  FeatureDownload24,
  FeatureDownload48,
  FeatureDownload72,
  FeatureEdit24,
  FeatureEdit48,
  FeatureEdit72,
  FeatureEducation24,
  FeatureEducation48,
  FeatureEducation72,
  FeatureEllipses24,
  FeatureEllipses48,
  FeatureEllipses72,
  FeatureEnvelope,
  FeatureExclamationInCircle24,
  FeatureExclamationInCircle48,
  FeatureExclamationInCircle72,
  FeatureExclamationPoint24,
  FeatureExclamationPoint48,
  FeatureExclamationPoint72,
  FeatureExit,
  FeatureExit24,
  FeatureExit48,
  FeatureExit72,
  FeatureEye24,
  FeatureEye48,
  FeatureEye72,
  FeatureEyeCrossout24,
  FeatureEyeCrossout48,
  FeatureEyeCrossout72,
  FeatureFilter24,
  FeatureFilter48,
  FeatureFilter72,
  FeatureFitness24,
  FeatureFitness48,
  FeatureFitness72,
  FeatureFolder24,
  FeatureFolder48,
  FeatureFolder72,
  FeatureFolderComplete24,
  FeatureFolderComplete48,
  FeatureFolderComplete72,
  FeatureFpo,
  FeatureFpo24,
  FeatureFpo48,
  FeatureFpo72,
  FeatureFullscreen24,
  FeatureFullscreen48,
  FeatureFullscreen72,
  FeatureGearInCircle24,
  FeatureGearInCircle48,
  FeatureGearInCircle72,
  FeatureGears,
  FeatureGears24,
  FeatureGears48,
  FeatureGears72,
  FeatureGiftbox,
  FeatureGlitter24,
  FeatureGlitter48,
  FeatureGlitter72,
  FeatureGlobe,
  FeatureGlobe24,
  FeatureGlobe48,
  FeatureGlobe72,
  FeatureGraphBar,
  FeatureGraphDots,
  FeatureGraphLineAngles,
  FeatureGraphLineCurves,
  FeatureGraphPie,
  FeatureGuidance24,
  FeatureHamburger24,
  FeatureHamburger48,
  FeatureHamburger72,
  FeatureHearts,
  FeatureHouse,
  FeatureHouse24,
  FeatureHouse48,
  FeatureHouse72,
  FeatureHsa24,
  FeatureHsa48,
  FeatureHsa72,
  FeatureImage24,
  FeatureImage48,
  FeatureImage72,
  FeatureInfo,
  FeatureInfo24,
  FeatureInfo48,
  FeatureInfo72,
  FeatureInfoBox24,
  FeatureInfoBox48,
  FeatureInfoBox72,
  FeatureInfoInCircle24,
  FeatureInfoInCircle48,
  FeatureInfoInCircle72,
  FeatureInheritance24,
  FeatureInheritance48,
  FeatureInheritance72,
  FeatureInheritanceTree24,
  FeatureInheritanceTree48,
  FeatureInheritanceTree72,
  FeatureInheritanceTreeAlt24,
  FeatureInheritanceTreeAlt48,
  FeatureInheritanceTreeAlt72,
  FeatureInvesting24,
  FeatureInvesting48,
  FeatureInvesting72,
  FeatureJointCash24,
  FeatureJointCash48,
  FeatureJointCash72,
  FeatureJointChecking24,
  FeatureJointChecking48,
  FeatureJointChecking72,
  FeatureLaptop,
  FeatureLaptop24,
  FeatureLaptop48,
  FeatureLaptop72,
  FeatureLaptopCloud,
  FeatureLaptopDownload,
  FeatureLaptopSecurity,
  FeatureLeft24,
  FeatureLeft48,
  FeatureLeft72,
  FeatureLeftArrowSmall24,
  FeatureLifePreserver,
  FeatureLightbulb,
  FeatureLightbulb24,
  FeatureLightbulb48,
  FeatureLightbulb72,
  FeatureLightbulbInCircle24,
  FeatureLightbulbInCircle48,
  FeatureLightbulbInCircle72,
  FeatureLightning24,
  FeatureLightning48,
  FeatureLightning72,
  FeatureLightningCrossout24,
  FeatureLightningCrossout48,
  FeatureLightningCrossout72,
  FeatureLightningInCircle24,
  FeatureLightningInCircle48,
  FeatureLightningInCircle72,
  FeatureLightningInCircleCrossout24,
  FeatureLightningInCircleCrossout48,
  FeatureLightningInCircleCrossout72,
  FeatureLink24,
  FeatureLink48,
  FeatureLink72,
  FeatureLinkAlt24,
  FeatureLinkAlt48,
  FeatureLinkAlt72,
  FeatureLock,
  FeatureLock24,
  FeatureLock48,
  FeatureLock72,
  FeatureLowerfees,
  FeatureMail24,
  FeatureMail48,
  FeatureMail72,
  FeatureMailOpen24,
  FeatureMailOpen48,
  FeatureMailOpen72,
  FeatureMajorPurchase24,
  FeatureMajorPurchase48,
  FeatureMajorPurchase72,
  FeatureMap24,
  FeatureMap48,
  FeatureMap72,
  FeatureMedal,
  FeatureMedical24,
  FeatureMedical48,
  FeatureMedical72,
  FeatureMessage24,
  FeatureMessage48,
  FeatureMessage72,
  FeatureMinus24,
  FeatureMinus48,
  FeatureMinus72,
  FeatureMinusInCircle24,
  FeatureMinusInCircle48,
  FeatureMinusInCircle72,
  FeatureMobile,
  FeatureNestEgg24,
  FeatureNestEgg48,
  FeatureNestEgg72,
  FeatureOpen24,
  FeatureOpen48,
  FeatureOpen72,
  FeatureOpposingArrows,
  FeaturePages,
  FeaturePeople24,
  FeaturePeople48,
  FeaturePeople72,
  FeaturePerson24,
  FeaturePerson48,
  FeaturePerson72,
  FeaturePets24,
  FeaturePets48,
  FeaturePets72,
  FeaturePhone24,
  FeaturePhone48,
  FeaturePhone72,
  FeaturePie24,
  FeaturePie48,
  FeaturePie72,
  FeaturePieceOfPie24,
  FeaturePieceOfPie48,
  FeaturePieceOfPie72,
  FeaturePin24,
  FeaturePin48,
  FeaturePin72,
  FeaturePlus24,
  FeaturePlus48,
  FeaturePlus72,
  FeaturePlusInCircle24,
  FeaturePlusInCircle48,
  FeaturePlusInCircle72,
  FeaturePower24,
  FeaturePower48,
  FeaturePower72,
  FeaturePreferences24,
  FeaturePreferences48,
  FeaturePreferences72,
  FeaturePresent24,
  FeaturePresent48,
  FeaturePresent72,
  FeaturePresentation24,
  FeaturePresentation48,
  FeaturePresentation72,
  FeatureQuestionMark24,
  FeatureQuestionMark48,
  FeatureQuestionMark72,
  FeatureQuestionMarkInCircle24,
  FeatureQuestionMarkInCircle48,
  FeatureQuestionMarkInCircle72,
  FeatureQuote24,
  FeatureQuote48,
  FeatureQuote72,
  FeatureRattle,
  FeatureRebalancing24,
  FeatureRebalancing48,
  FeatureRebalancing72,
  FeatureRedo24,
  FeatureRedo48,
  FeatureRedo72,
  FeatureResponse24,
  FeatureResponse48,
  FeatureResponse72,
  FeatureRibbon24,
  FeatureRibbon48,
  FeatureRibbon72,
  FeatureRight24,
  FeatureRight48,
  FeatureRight72,
  FeatureRightArrowSmall24,
  FeatureSafe24,
  FeatureSafe48,
  FeatureSafe72,
  FeatureSafetyNet24,
  FeatureSafetyNet48,
  FeatureSafetyNet72,
  FeatureScale,
  FeatureSearch,
  FeatureSearch24,
  FeatureSearch48,
  FeatureSearch72,
  FeatureSecurityCheck24,
  FeatureSecurityCheck48,
  FeatureSecurityCheck72,
  FeatureSecurityReview24,
  FeatureSecurityReview48,
  FeatureSecurityReview72,
  FeatureSecurityX24,
  FeatureSecurityX48,
  FeatureSecurityX72,
  FeatureSetting24,
  FeatureSetting48,
  FeatureSetting72,
  FeatureShapes24,
  FeatureShapes48,
  FeatureShapes72,
  FeatureShare24,
  FeatureShare48,
  FeatureShare72,
  FeatureShield,
  FeatureShield24,
  FeatureShield48,
  FeatureShield72,
  FeatureShopping24,
  FeatureShopping48,
  FeatureShopping72,
  FeatureSignpost,
  FeatureSignpost24,
  FeatureSignpost48,
  FeatureSignpost72,
  FeatureSound24,
  FeatureSpending24,
  FeatureSpending48,
  FeatureSpending72,
  FeatureStack,
  FeatureStacks24,
  FeatureStacks48,
  FeatureStacks72,
  FeatureStroller24,
  FeatureStroller48,
  FeatureStroller72,
  FeatureSun,
  FeatureTags,
  FeatureTicket24,
  FeatureTicket48,
  FeatureTicket72,
  FeatureTimer,
  FeatureToggle,
  FeatureTooltip24,
  FeatureTooltipInfo24,
  FeatureTransfer24,
  FeatureTransfer48,
  FeatureTransfer72,
  FeatureTransferInCircle24,
  FeatureTransferInCircle48,
  FeatureTransferInCircle72,
  FeatureTrend24,
  FeatureTrend48,
  FeatureTrend72,
  FeatureTrophy24,
  FeatureTrophy48,
  FeatureTrophy72,
  FeatureUmbrella,
  FeatureUmbrella24,
  FeatureUmbrella48,
  FeatureUmbrella72,
  FeatureUndo24,
  FeatureUndo48,
  FeatureUndo72,
  FeatureUnlink24,
  FeatureUnlink48,
  FeatureUnlink72,
  FeatureUnlinkAlt24,
  FeatureUnlinkAlt48,
  FeatureUnlinkAlt72,
  FeatureUnlock24,
  FeatureUnlock48,
  FeatureUnlock72,
  FeatureUp24,
  FeatureUp48,
  FeatureUp72,
  FeatureUpArrowSmall24,
  FeatureUpload,
  FeatureUpload24,
  FeatureUpload48,
  FeatureUpload72,
  FeatureUser,
  FeatureUsersTwo,
  FeatureVennDiagram,
  FeatureVennDiagram24,
  FeatureVennDiagram48,
  FeatureVennDiagram72,
  FeatureWebinar24,
  FeatureWebinar48,
  FeatureWebinar72,
  FeatureWeddingBands24,
  FeatureWeddingBands48,
  FeatureWeddingBands72,
  FeatureWeddingCake24,
  FeatureWeddingCake48,
  FeatureWeddingCake72,
  FeatureWithdraw24,
  FeatureWithdraw48,
  FeatureWithdraw72,
  FeatureX24,
  FeatureX48,
  FeatureX72,
  FeatureXInCircle24,
  FeatureXInCircle48,
  FeatureXInCircle72,
  Field,
  Flash,
  Flex,
  FormikCheckboxInput,
  FormikDateInput,
  FormikDropdown,
  FormikField,
  FormikMultiSelect,
  FormikRadioInput,
  FormikTextInput,
  FormikToggle,
  GlobalErrorFallback,
  GoalIcon,
  HR,
  Heading,
  INPUT_MAX_WIDTH,
  InlineTextLoader,
  InputGroup,
  LAYOUT,
  Label,
  ListRow,
  ListRowButton,
  Loader,
  LoadingCircle,
  LogoB4A,
  LogoB4B,
  LogoBAW,
  LogoCustomerService,
  LogoRetail,
  LogoSecurities,
  LogoSymbol,
  MaskedInput2 as MaskedInput,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalContent,
  ModalOverlay,
  MultiSelect,
  POSITION,
  PasswordInput,
  Picture,
  ProgressBar,
  RadioInput,
  ReffableBase,
  ReffableBox,
  ReffableFlex,
  ReffableText,
  SIZE_STYLES,
  SectionLayout,
  SentryReportingErrorBoundary,
  SiteLayout,
  Slot,
  StackedProgressBar,
  StyleClosetThemeProvider,
  StyledTextInput,
  SvgIcon,
  TOOLTIP_MAX_WIDTH,
  TYPOGRAPHY,
  TabularNumber,
  Tag,
  TakeoverHeader,
  Text,
  TextInput,
  ToggleSwitch,
  Tooltip,
  Typist,
  UiArrowCircleV2,
  UiArrowTrending,
  UiBackV2,
  UiBalanceV2,
  UiBank,
  UiBankV2,
  UiBoat,
  UiBoatV2,
  UiBullet,
  UiBullet2V2,
  UiBulletV2,
  UiCalendar,
  UiCalendarV2,
  UiCameraV2,
  UiCancelV2,
  UiCard,
  UiCardV2,
  UiCaretDown,
  UiCaretDownV2,
  UiCaretLeft,
  UiCaretLeftV2,
  UiCaretPlay,
  UiCaretRight,
  UiCaretRightV2,
  UiCaretUp,
  UiCaretUpV2,
  UiCashV2,
  UiChat,
  UiChatV2,
  UiCheck,
  UiCheckArrowCircleV2,
  UiCheckBackV2,
  UiCheckFrontV2,
  UiCheckmarkCircleV2,
  UiCheckmarkV2,
  UiCircleArrows,
  UiCircleArrowsCheck,
  UiCircleArrowsMinus,
  UiCircleArrowsPlus,
  UiCircleCheck,
  UiCircleDollar,
  UiCircleExclamation,
  UiCircleOpen,
  UiCircleQuestion,
  UiCopyV2,
  UiDirectDeposit,
  UiDirectDepositV2,
  UiDocumentCompleteV2,
  UiDocumentV2,
  UiDocuments,
  UiDocumentsV2,
  UiDollarSignCircleV2,
  UiDollarSignV2,
  UiDonut,
  UiDonutV2,
  UiDownloadV2,
  UiDownloadWithdrawV2,
  UiEdit,
  UiEditV2,
  UiEgg,
  UiEggV2,
  UiEllipse,
  UiEllipsesV2,
  UiError,
  UiExclamation,
  UiExclamationCircleV2,
  UiExclamationV2,
  UiExit,
  UiExitXCircleV2,
  UiExitXV2,
  UiFileCsv,
  UiFilePdf,
  UiFilter,
  UiFilterV2,
  UiFolderCompleteV2,
  UiFolderV2,
  UiForwardV2,
  UiFpo,
  UiFullscreenV2,
  UiGear,
  UiGearsV2,
  UiGift,
  UiGraphBar,
  UiGraphPie,
  UiGraphSteps,
  UiHamburger,
  UiHomeV2,
  UiHouse,
  UiImage,
  UiInfo,
  UiInfoCircleV2,
  UiInfoV2,
  UiLaptop,
  UiLaptopV2,
  UiLeftAndroid,
  UiLeftAndroidV2,
  UiLetter,
  UiLightningBolt,
  UiLightningCircleCrossedV2,
  UiLightningCircleV2,
  UiLightningFillV2,
  UiLightningOutlineV2,
  UiLinkV2,
  UiLock,
  UiLockV2,
  UiMenuCircleV2,
  UiMenuV2,
  UiMessageV2,
  UiMinus,
  UiMinusArrowCircleV2,
  UiMinusCircle,
  UiMinusCircleV2,
  UiMinusV2,
  UiMobile,
  UiMobileV2,
  UiOpenV2,
  UiOpenedMessageV2,
  UiOpposingArrows,
  UiOpposingArrowsCircle,
  UiOpposingArrowsCircleV2,
  UiPerformanceV2,
  UiPerson,
  UiPersonV2,
  UiPhoto2V2,
  UiPhotoV2,
  UiPieChartV2,
  UiPin,
  UiPinV2,
  UiPlus,
  UiPlusArrowCircleV2,
  UiPlusCircle,
  UiPlusCircleV2,
  UiPlusV2,
  UiPortfolio,
  UiPortfolioCheck,
  UiPower,
  UiPowerV2,
  UiPreferencesV2,
  UiPresentationBoard,
  UiPresentationV2,
  UiQuestion,
  UiQuestionMarkCircleV2,
  UiQuestionMarkV2,
  UiQuote,
  UiQuoteV2,
  UiRedoV2,
  UiReviewDocsV2,
  UiRewardsV2,
  UiSearch,
  UiSearchV2,
  UiSettingsCircleV2,
  UiSettingsV2,
  UiShieldV2,
  UiSocialFacebook,
  UiSocialGoogle,
  UiSocialLinkedin,
  UiSocialTwitter,
  UiStepsV2,
  UiTag,
  UiTagV2,
  UiTipsCircleV2,
  UiTipsV2,
  UiTransferV2,
  UiTrendingV2,
  UiUndoV2,
  UiUnlinkV2,
  UiUnlockV2,
  UiUpload,
  UiUploadDepositV2,
  UiUploadV2,
  UiUser,
  UiWindowV2,
  UiWrench,
  UiX,
  VARIANT_STYLES2 as VARIANT_STYLES,
  VERTICAL_RHYTHM,
  VendorFpo,
  VendorSocialFacebook,
  VendorSocialGoogle,
  VendorSocialLinkedin,
  VendorSocialTwitter,
  WorkflowCard,
  WorkflowHeader,
  WorkflowLayout,
  colors,
  get,
  getSlots,
  icons,
  mapValueToItem,
  secondaryColors,
  theme,
  useTheme
};
//# sourceMappingURL=index.js.map